import React__default, { createContext, useContext, useState, useCallback, useEffect, useLayoutEffect, createElement, Fragment, cloneElement, Component, useRef, forwardRef, useMemo } from 'react';
import { inject, observer, Provider } from 'mobx-react';
import { elementScrollIntoViewPolyfill } from 'seamless-scroll-polyfill';
import styled, { keyframes, css, createGlobalStyle } from 'styled-components';
import { Button as Button$1, Typography as Typography$1, Avatar as Avatar$1, notification as notification$1, Alert as Alert$1, Space, Carousel as Carousel$1, Checkbox as Checkbox$1, Collapse as Collapse$1, Divider as Divider$1, Image as Image$1, Input as Input$4, InputNumber as InputNumber$1, Menu as Menu$1, Dropdown, Modal as Modal$1, Popover as Popover$1, Radio as Radio$1, Select as Select$1, Slider as Slider$1, Switch as Switch$1, Tabs as Tabs$2, Form, Upload, Row, Col } from 'antd';
export { Col, Drawer, Dropdown, Form, Row, Spin, Table, Upload } from 'antd';
import axios from 'axios';
import qs from 'qs';
import ReactDOM from 'react-dom';
import Icon$1 from '@ant-design/icons';
import { StyleProvider } from '@ant-design/cssinjs';
export { default as ImgCrop } from 'antd-img-crop';
import { CardNumberElement, CardCvcElement, CardExpiryElement, useStripe, useElements, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { types, getParent, getSnapshot, flow, getEnv, isStateTreeNode } from 'mobx-state-tree';
import debounce$3 from 'lodash.debounce';
import nextId from 'react-id-generator';
import WebFont from 'webfontloader';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _taggedTemplateLiteralLoose(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _templateObject;
var moveSlideshow = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    from {\n        transform: translateX(0%);\n    }\n    to {\n        transform: translateX(-100%);\n    }\n"])));

var _templateObject$1;
var FromToOpacity = keyframes(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));

var _templateObject$2, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var SlideFromRight = keyframes(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n    transform: translateX(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n"])));
var SlideFromBottom = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n"])));
var PortalTopAnimation = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n    transform: translate3d(-50%, -110%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(-50%, -100%, 0);\n  }\n"])));
var PortalRightAnimation = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n    transform: translate3d(10%, -50%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, -50%, 0);\n  }\n"])));
var PortalBottomAnimation = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n    transform: translate3d(-50%, 10%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(-50%, 0, 0);\n  }\n"])));
var PortalLeftAnimation = keyframes(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n    transform: translate3d(-110%, -50%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(-100%, -50%, 0);\n  }\n"])));

var defaultTheme = {
  colors: {
    primary: '#F25858',
    tartRed: '#FFEBEB',
    secondary: '#2DC8C8',
    primaryText: '#04080F',
    darkBackground: '#1C3144',
    secondaryText: '#77838F',
    disabledState: '#A4ADB4',
    lines: '#D2D6DA',
    background: '#F4F4F4',
    primaryBackground: '#FED8D8',
    canvas: '#FFFFFF',
    error: '#EF2E2E',
    alert: '#FFC53A',
    success: '#1CA355',
    info: '#33B6DF',
    disabledPrimaryText: '#EAECEE',
    robinBlue: '#26A6A6'
  },
  RGB: {
    general: '119, 131, 143',
    error: '239, 46, 46',
    success: '28, 163, 85',
    alert: '255, 197, 58',
    overlay: '0, 0, 0'
  },
  fontsSrc: {
    sans: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap',
    serif: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Serif:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap'
  },
  fonts: {
    headline1: 'normal 500 32px/40px "IBM Plex Serif", Serif',
    headline2: 'normal 500 24px/36px "IBM Plex Serif", Serif',
    headline3: 'normal 500 16px/24px "IBM Plex Serif", Serif',
    em0: 'normal 500 48px/64px "IBM Plex Serif", Serif',
    body1: 'normal normal 20px/28px "IBM Plex Sans", Sans',
    body2: 'normal normal 14px/24px "IBM Plex Sans", Sans',
    descriptor1: 'normal normal 16px/24px "IBM Plex Sans", Sans',
    descriptor2: 'normal 500 12px/16px "IBM Plex Sans", Sans',
    badgeLarge: 'normal 500 20px/24px "IBM Plex Sans", Sans',
    badgeMedium: 'normal 500 16px/24px "IBM Plex Sans", Sans',
    badgeSmall: 'normal 500 14px/16px "IBM Plex Sans", Sans',
    caps: 'Capitalized normal 14px/20px "IBM Plex Sans", Sans, SemiBold'
  },
  shadows: {
    primary: '0px 20px 40px rgba(0, 0, 0, 0.09)'
  },
  transition: {
    "default": 'all 0.2s ease-in',
    slider: 'all 0.5s ease'
  }
};

var KliThemeContext = /*#__PURE__*/createContext(defaultTheme);

var KliThemeProvider = function KliThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(KliThemeContext.Provider, {
    value: _extends({}, defaultTheme, theme)
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children));
};

var _templateObject$3, _templateObject2$1;
var IconWrap = styled.span(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    height: 1em;\n    font-size: ", ";\n    color: ", ";\n    transition: ", ";\n\n    &:focus {\n        outline: none;\n    }\n\n    &:focus::after {\n        border-color: ", ";\n    }\n\n    &::after {\n        content: '';\n        position: absolute;\n\n        height: ", ";\n        width: ", ";\n        top: 50%;\n        left: 50%;\n        transform: translate3d(-50%, -50%, 0);\n\n        border-radius: 50%;\n        z-index: 2;\n        background-color: transparent;\n        border: 4px solid transparent;\n        opacity: ", ";\n        transition: ", ";\n    }\n\n    ", "\n    svg {\n        position: relative;\n        z-index: 2;\n    }\n"])), function (_ref) {
  var size = _ref.size;
  return size || 'inherit';
}, function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color;
  return theme.colors[color] || color || 'inherit';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition["default"];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.lines;
}, function (_ref5) {
  var roundedSize = _ref5.roundedSize;
  return roundedSize;
}, function (_ref6) {
  var roundedSize = _ref6.roundedSize;
  return roundedSize;
}, function (_ref7) {
  var roundedOpacity = _ref7.roundedOpacity;
  return roundedOpacity;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.transition["default"];
}, function (props) {
  return props.clicable ? css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n                  cursor: pointer;\n\n                  &::before {\n                      height: ", ";\n                      width: ", ";\n                      top: 50%;\n                      left: 50%;\n                      transform: translate3d(-50%, -50%, 0);\n\n                      content: '';\n                      position: absolute;\n                      border-radius: 50%;\n                      z-index: 1;\n                      background-color: ", ";\n                      opacity: ", ";\n                      transition: ", ";\n                  }\n\n                  &:hover::before {\n                      background-color: ", ";\n                  }\n              "])), function (_ref9) {
    var roundedSize = _ref9.roundedSize;
    return roundedSize;
  }, function (_ref0) {
    var roundedSize = _ref0.roundedSize;
    return roundedSize;
  }, function (_ref1) {
    var roundedColor = _ref1.roundedColor,
      theme = _ref1.theme;
    return roundedColor ? theme.colors[roundedColor] || roundedColor : 'transparent';
  }, function (_ref10) {
    var roundedOpacity = _ref10.roundedOpacity;
    return roundedOpacity;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.transition["default"];
  }, function (_ref12) {
    var theme = _ref12.theme,
      hoverRoundedColor = _ref12.hoverRoundedColor;
    return theme.colors[hoverRoundedColor] || hoverRoundedColor || theme.colors.lines;
  }) : '';
});

var _excluded = ["size", "color", "roundedColor", "hoverRoundedColor", "roundedSize", "roundedOpacity", "children", "onClick"];
var KliIcon = function KliIcon(_ref) {
  var size = _ref.size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '' : _ref$color,
    roundedColor = _ref.roundedColor,
    hoverRoundedColor = _ref.hoverRoundedColor,
    _ref$roundedSize = _ref.roundedSize,
    roundedSize = _ref$roundedSize === void 0 ? '200%' : _ref$roundedSize,
    _ref$roundedOpacity = _ref.roundedOpacity,
    roundedOpacity = _ref$roundedOpacity === void 0 ? 0.7 : _ref$roundedOpacity,
    children = _ref.children,
    onClick = _ref.onClick,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(IconWrap, _extends({
    theme: themeContext,
    clicable: !!roundedColor || !!hoverRoundedColor || !!onClick,
    roundedSize: roundedSize,
    roundedColor: roundedColor,
    roundedOpacity: roundedOpacity,
    hoverRoundedColor: hoverRoundedColor,
    size: size,
    color: color,
    onClick: onClick,
    className: "kli-icon"
  }, rest), children);
};

var _templateObject$4, _templateObject2$2, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7, _templateObject8;
var KliButtonStyled = styled.button(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    box-sizing: border-box;\n    justify-content: space-evenly;\n    align-items: center;\n    outline: transparent;\n    padding: 14px 20px;\n    font: ", ";\n\n    transition: ", ";\n    will-change: outline, color, bacground-color;\n\n    & > svg {\n        width: 24px;\n        height: 24px;\n    }\n\n    & > *:not(:last-child) {\n        margin-right: 10px;\n    }\n\n    // Default states;\n    :focus:not(:hover) {\n        border-color: ", ";\n        outline: 4px solid ", ";\n    }\n\n    :disabled {\n        cursor: not-allowed;\n        opacity: 0.5;\n    }\n\n    ", "\n\n    // Sizes;\n  ", "\n\n  ", " // Primary styles\n\n  ", " // Secondary styles\n\n  ", " // Without Background styles\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.badgeMedium;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition["default"];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.lines;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.lines;
}, function (props) {
  return props.withoutPadding ? css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n                  padding: 0;\n              "]))) : '';
}, function (props) {
  return props.small ? css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n                padding: 10px 16px;\n                font: ", ";\n\n                svg {\n                    width: 16px;\n                    height: 16px;\n                }\n            "])), function (_ref5) {
    var theme = _ref5.theme;
    return theme.fonts.badgeSmall;
  }) : '';
}, function (props) {
  return props.large ? css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n                padding: 18px 24px;\n                font: ", ";\n            "])), function (_ref6) {
    var theme = _ref6.theme;
    return theme.fonts.badgeLarge;
  }) : '';
}, function (props) {
  return props.primary ? css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n                border: 2px solid ", ";\n                color: ", ";\n                background-color: ", ";\n\n                :hover:not(:disabled):not(:active) {\n                    color: ", ";\n                    background-color: ", ";\n                    cursor: pointer;\n                }\n\n                :active {\n                    color: ", ";\n                    background-color: ", ";\n                }\n            "])), function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.primaryText;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.primaryText;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.canvas;
  }, function (_ref0) {
    var theme = _ref0.theme;
    return theme.colors.canvas;
  }, function (_ref1) {
    var theme = _ref1.theme;
    return theme.colors.primaryText;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.primaryText;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.background;
  }) : '';
}, function (props) {
  return props.secondary ? css(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n                border: 2px solid ", ";\n                color: ", ";\n                background-color: ", ";\n\n                :hover:not(:disabled):not(:active) {\n                    color: ", ";\n                    background-color: ", ";\n                    cursor: pointer;\n                }\n\n                :active {\n                    color: ", ";\n                    background-color: ", ";\n                    cursor: pointer;\n                }\n            "])), function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.background;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.primaryText;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.colors.background;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.primaryText;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return theme.colors.lines;
  }, function (_ref17) {
    var theme = _ref17.theme;
    return theme.colors.primaryText;
  }, function (_ref18) {
    var theme = _ref18.theme;
    return theme.colors.lines;
  }) : '';
}, function (props) {
  return props.linked ? css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n                border: none;\n                color: ", ";\n                background-color: transparent;\n\n                :hover:not(:disabled):not(:active) {\n                    color: ", ";\n                    cursor: pointer;\n                }\n\n                :active:not(:disabled) {\n                    color: ", ";\n                    cursor: pointer;\n                }\n            "])), function (_ref19) {
    var theme = _ref19.theme;
    return theme.colors.primaryText;
  }, function (_ref20) {
    var theme = _ref20.theme;
    return theme.colors.primary;
  }, function (_ref21) {
    var theme = _ref21.theme;
    return theme.colors.primary;
  }) : '';
}, function (props) {
  return props.unstyled ? css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n                border: none;\n                color: ", ";\n                background-color: transparent;\n                cursor: pointer;\n                outline: none;\n\n                :active:not(:disabled) {\n                    color: ", ";\n                }\n\n                :hover:not(:disabled) {\n                    color: ", ";\n                }\n            "])), function (_ref22) {
    var theme = _ref22.theme;
    return theme.colors.primaryText;
  }, function (_ref23) {
    var theme = _ref23.theme;
    return theme.colors.primary;
  }, function (_ref24) {
    var theme = _ref24.theme;
    return theme.colors.primary;
  }) : '';
});

var _excluded$1 = ["type", "children"];
var KliButton = function KliButton(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(KliButtonStyled, _extends({
    theme: themeContext,
    type: type
  }, rest), children);
};

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$2;
var KliButtonCircleStyled = styled.button(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    box-sizing: border-box;\n    justify-content: space-evenly;\n    align-items: center;\n    outline: transparent;\n    height: 40px;\n    width: 40px;\n    font: ", ";\n    border-radius: 50%;\n    transition: ", ";\n    will-change: outline, color, bacground-color;\n\n    // Default states;\n    :disabled {\n        cursor: not-allowed;\n        opacity: 0.5;\n    }\n\n    :focus:not(:hover) {\n        box-shadow: 0 0 0 6px ", ";\n    }\n\n    // Sizes;\n    ", " // Primary styles;\n  ", " // Secondary styles\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.badgeMedium;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition["default"];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.lines;
}, function (props) {
  return props.large ? css(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n                  height: 56px;\n                  width: 56px;\n                  font: ", ";\n              "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.fonts.badgeLarge;
  }) : '';
}, function (props) {
  return props.primary ? css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n      border: 2px solid ", ";\n      color: ", ";\n      background-color: ", ";\n\n      :hover:not(:disabled):not(:active) {\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: ", ";\n        cursor: pointer;\n      }\n\n      :active {\n        color: ", ";\n        background-color: ", ";\n    "])), function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.primaryText;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.canvas;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.primaryText;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.canvas;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.primary;
  }, function (_ref0) {
    var theme = _ref0.theme;
    return theme.colors.primary;
  }, function (_ref1) {
    var theme = _ref1.theme;
    return theme.shadows.primary;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.canvas;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.primaryText;
  }) : '';
}, function (props) {
  return props.secondary ? css(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n                border: 2px solid ", ";\n                color: ", ";\n                background-color: transparent;\n\n                :hover:not(:disabled):not(:active) {\n                    color: ", ";\n                    border-color: ", ";\n                    cursor: pointer;\n                }\n\n                :active {\n                    color: ", ";\n                    background-color: transparent;\n                    cursor: pointer;\n                }\n            "])), function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.primaryText;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.primaryText;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.colors.primary;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.primary;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return theme.colors.primaryText;
  }) : '';
});

var _excluded$2 = ["type", "children"];
var KliCircleButton = function KliCircleButton(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(KliButtonCircleStyled, _extends({
    theme: themeContext,
    type: type
  }, rest), children);
};

var useFitContent = function useFitContent(_ref) {
  var wrapperRef = _ref.wrapperRef,
    contentRef = _ref.contentRef;
  var _useState = useState(false),
    simple = _useState[0],
    setSimple = _useState[1];
  var _useState2 = useState(0),
    simpleBreakpoint = _useState2[0],
    setSimpleBreakpoint = _useState2[1];
  var onResize = useCallback(function () {
    if (wrapperRef !== null && wrapperRef !== void 0 && wrapperRef.current && contentRef !== null && contentRef !== void 0 && contentRef.current) {
      var shouldSimple = wrapperRef.current.offsetWidth < contentRef.current.offsetWidth;
      var moreSpaceThanBreakpoint = wrapperRef.current.offsetWidth > simpleBreakpoint;
      if (shouldSimple) {
        setSimpleBreakpoint(wrapperRef.current.offsetWidth + 20);
        setSimple(true);
      }
      if (!shouldSimple && moreSpaceThanBreakpoint && simpleBreakpoint) {
        setSimple(false);
        setSimpleBreakpoint(0);
      }
    }
  }, [contentRef, wrapperRef, simpleBreakpoint]);
  useEffect(function () {
    onResize();
  }, []);
  useLayoutEffect(function () {
    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  return simple;
};

var phoneMask = function phoneMask(value) {
  if (value === void 0) {
    value = '';
  }
  var phone = value.replace(/\D/g, '').substr(0, 10);
  var match = phone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
  if (match) {
    return "(" + match[1] + (match[2] ? ') ' : '') + match[2] + (match[3] ? '-' : '') + match[3];
  }
  return phone;
};

var roundToLocaleString = function roundToLocaleString(value, maxDigits) {
  if (maxDigits === void 0) {
    maxDigits = 2;
  }
  var toLocaleStringOptions = {
    minimumFractionDigits: maxDigits,
    maximumFractionDigits: maxDigits
  };
  return Number(value || 0).toLocaleString('en-US', toLocaleStringOptions).replace(/,$/, '.');
};

var _path;
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function SvgActionsMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M3 12h18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1;
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
function SvgActionsPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    d: "M12 3v18M3 12h18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2;
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3.apply(null, arguments);
}
function SvgAirbnb(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    width: ".958em",
    height: "1em",
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.997 16.764l.12.293c.315.889.412 1.73.218 2.57a5.1 5.1 0 01-3.142 3.989 4.905 4.905 0 01-2.586.336 6.412 6.412 0 01-2.417-.817c-.967-.552-1.934-1.345-2.997-2.498-1.064 1.153-2.006 1.946-2.997 2.498A6.412 6.412 0 015.15 24a4.99 4.99 0 01-1.958-.384A5.111 5.111 0 01.05 19.628c-.12-.865-.024-1.706.29-2.595.121-.312.242-.6.363-.865.088-.197.176-.39.262-.576.103-.224.202-.44.294-.65l.024-.047A281.363 281.363 0 016.625 4.036l.072-.144c.194-.36.387-.745.58-1.13.242-.432.508-.888.87-1.32C8.945.528 10.033 0 11.241 0c1.184 0 2.296.529 3.07 1.49.356.398.59.817.813 1.22.02.033.038.067.057.1.193.385.387.77.58 1.13l.073.144a250.273 250.273 0 015.341 10.859l.024.024c.092.21.191.425.294.649.086.187.174.379.262.576.08.176.161.374.242.572zM8.776 13.838c.29 1.297 1.136 2.835 2.441 4.468 1.305-1.657 2.151-3.195 2.441-4.468.121-.529.145-1.033.073-1.466a2.323 2.323 0 00-.387-1.009c-.435-.672-1.233-1.057-2.127-1.057-.894 0-1.668.409-2.127 1.057a2.322 2.322 0 00-.387 1.01c-.072.432-.048.912.073 1.465zm9.885 8.408a3.573 3.573 0 002.2-2.81c.096-.625.024-1.226-.17-1.85-.05-.167-.123-.334-.204-.517-.036-.08-.073-.164-.11-.252a13.805 13.805 0 01-.277-.6c-.091-.205-.182-.41-.279-.601v-.024A317.826 317.826 0 0014.529 4.78l-.072-.144a46.47 46.47 0 01-.29-.553c-.097-.186-.194-.372-.29-.552a5.274 5.274 0 00-.677-1.058 2.533 2.533 0 00-1.934-.888c-.749 0-1.426.312-1.933.888a5.273 5.273 0 00-.677 1.058c-.097.18-.193.366-.29.552-.097.186-.193.372-.29.553l-.073.144a261.954 261.954 0 00-5.317 10.787l-.024.048c-.194.408-.387.816-.556 1.2-.037.089-.074.172-.11.253-.08.183-.154.35-.204.517a3.955 3.955 0 00-.218 1.873 3.574 3.574 0 002.2 2.811 3.888 3.888 0 001.836.24 4.774 4.774 0 001.837-.624c.87-.48 1.765-1.225 2.756-2.33-1.571-1.946-2.562-3.748-2.925-5.334a4.959 4.959 0 01-.12-2.042c.096-.6.314-1.153.652-1.633.75-1.058 2.006-1.706 3.408-1.706 1.402 0 2.659.624 3.408 1.706.338.48.556 1.033.653 1.633a5.986 5.986 0 01-.121 2.042c-.363 1.586-1.33 3.364-2.925 5.31 1.015 1.105 1.885 1.85 2.756 2.33.628.36 1.232.552 1.836.625a3.68 3.68 0 001.837-.24z",
    fill: "currentColor"
  })));
}

var _path$3;
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4.apply(null, arguments);
}
function SvgAirlinePlane(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M4.864 6.136l2.314-2.314 8.1 1.8 2.255-2.256c.04-.039.078-.075.121-.11.442-.36 3.102-2.442 4.18-1.363 1.08 1.08-1.003 3.739-1.362 4.18a1.587 1.587 0 01-.11.122L18.105 8.45l1.8 8.1-2.314 2.314-3.677-6.435-4.808 4.314.578 2.957-1.993 1.992L5.828 17.9l-3.792-1.864 1.992-1.993 2.957.578L11.3 9.813 4.864 6.136z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4;
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$5.apply(null, arguments);
}
function SvgAlignCenter(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    width: "1.2em",
    height: "1em",
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    d: "M1 1h22M4 7h16M1 13h22M4 19h16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$5;
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$6.apply(null, arguments);
}
function SvgAlignJustify(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    width: "1.2em",
    height: "1em",
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    d: "M1 1h22M1 7h22M1 13h22M1 19h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$6;
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$7.apply(null, arguments);
}
function SvgAlignLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    width: "1.2em",
    height: "1em",
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/createElement("path", {
    d: "M1 1h22M1 7h16M1 13h22M1 19h16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$7;
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$8.apply(null, arguments);
}
function SvgAlignRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    width: "1.2em",
    height: "1em",
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/createElement("path", {
    d: "M1 1h22M7 7h16M1 13h22M7 19h16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$8;
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$9.apply(null, arguments);
}
function SvgAmazon(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/createElement("path", {
    d: "M20.772 19.768a.55.55 0 01.349-.04c.098.026.147.105.147.234 0 .13-.067.28-.201.449a5.565 5.565 0 01-.59.582c-.276.246-.702.55-1.278.911-.576.362-1.206.692-1.889.991-.683.3-1.522.558-2.518.777-.995.219-2.02.328-3.073.328-1.063 0-2.125-.138-3.188-.415-1.062-.277-1.995-.619-2.799-1.025a18.14 18.14 0 01-2.31-1.393c-.737-.522-1.328-.99-1.775-1.406A12.703 12.703 0 01.522 18.59a.573.573 0 01-.134-.22c-.017-.068-.013-.121.014-.161a.273.273 0 01.261-.12c.058.003.11.024.154.06 1.714 1.044 3.054 1.785 4.018 2.223 3.473 1.571 7.04 1.973 10.7 1.205 1.697-.357 3.443-.96 5.237-1.808zm2.773-1.54c.098.142.109.453.033.93a6.186 6.186 0 01-.382 1.373c-.303.741-.683 1.295-1.138 1.661-.152.125-.268.165-.348.12-.08-.044-.08-.151 0-.32.187-.403.386-.945.596-1.628.21-.683.239-1.123.087-1.32a.479.479 0 00-.208-.153 1.208 1.208 0 00-.361-.08 28.39 28.39 0 00-.395-.034 4.051 4.051 0 00-.47 0 7.975 7.975 0 00-.421.027 41.257 41.257 0 01-.717.067 1.826 1.826 0 01-.174.02 3.075 3.075 0 00-.26.026.899.899 0 01-.095.007h-.134l-.04-.007-.026-.02-.02-.04c-.054-.143.156-.321.629-.536a4.708 4.708 0 011.38-.401c.41-.063.892-.067 1.446-.014.553.054.893.161 1.018.322zm-5.277-5.933c0 .276.06.562.18.857.121.294.264.553.43.777.164.223.332.428.502.616.17.187.316.33.441.428l.174.147-3.04 3a44.89 44.89 0 01-1.834-1.794l-.255-.268a2.664 2.664 0 01-.335-.442c-.339.527-.774.984-1.306 1.373-.53.388-1.1.672-1.707.85a7.765 7.765 0 01-1.875.308 4.727 4.727 0 01-1.842-.28 5.578 5.578 0 01-1.573-.878c-.465-.37-.835-.875-1.112-1.514-.277-.638-.415-1.363-.415-2.176 0-.75.125-1.437.375-2.062.25-.625.571-1.146.964-1.56a6.365 6.365 0 011.427-1.112 9.1 9.1 0 011.64-.764 13.693 13.693 0 011.741-.462 15.546 15.546 0 011.6-.247c.443-.04.887-.07 1.333-.088v-1.7c0-.58-.094-1.014-.281-1.3-.304-.473-.844-.71-1.62-.71-.054 0-.128.005-.222.014-.093.009-.274.063-.542.16-.268.099-.518.23-.75.396-.232.165-.482.43-.75.797a4.563 4.563 0 00-.643 1.285l-3.937-.361c0-.536.098-1.067.294-1.594a5.208 5.208 0 01.898-1.513 6.434 6.434 0 011.446-1.273C8.237.84 8.913.547 9.704.328A9.53 9.53 0 0112.253 0c.893 0 1.701.112 2.425.335.723.223 1.3.498 1.734.823.433.326.795.697 1.085 1.112.29.415.49.8.602 1.152.112.353.168.68.168.984v7.889zm-9 .28c0 .769.312 1.363.937 1.782.59.393 1.21.491 1.862.295.75-.223 1.259-.772 1.527-1.647.125-.402.187-.853.187-1.353v-2.17a9.594 9.594 0 00-1.486.16c-.465.09-.94.24-1.427.45-.486.21-.875.526-1.165.95-.29.425-.435.936-.435 1.534z",
    fill: "currentColor"
  })));
}

var _path$9;
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$a.apply(null, arguments);
}
function SvgAmex(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.709 9.041L0 15.211h3.243l.402-.984h.918l.402.984h3.57v-.75l.318.75h1.846l.318-.766v.766h7.423l.902-.958.846.958L24 15.22l-2.717-3.076L24 9.041h-3.753l-.879.94-.819-.94h-8.075l-.693 1.593-.71-1.593H5.835v.725l-.36-.725H2.71zm.627.876h1.58l1.797 4.184V9.917h1.732l1.387 3 1.28-3h1.722v4.428h-1.048l-.009-3.47-1.528 3.47H9.31l-1.537-3.47v3.47H5.618l-.41-.993H3l-.408.992H1.437l1.899-4.427zm14.72 0h-4.263v4.425h4.197l1.352-1.466 1.304 1.466h1.363l-1.981-2.2 1.98-2.225h-1.303l-1.346 1.45-1.303-1.45zm-13.951.75l-.728 1.768h1.455l-.727-1.769zm10.74.975v-.809h2.66l1.161 1.293-1.212 1.3h-2.608v-.883h2.325v-.9h-2.325z",
    fill: "currentColor"
  })));
}

var _path$a, _path2;
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$b.apply(null, arguments);
}
function SvgAndroid(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    width: ".96em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/createElement("path", {
    d: "M3.79 8c-.42 0-.776.157-1.069.472a1.607 1.607 0 00-.439 1.134v6.772c0 .452.146.835.439 1.15.293.315.649.472 1.068.472.42 0 .773-.157 1.061-.472.288-.315.432-.698.432-1.15V9.606c0-.44-.146-.819-.439-1.134A1.389 1.389 0 003.789 8zM6.282 17.635c0 .444.14.82.418 1.128.28.308.619.463 1.02.463h.967L8.7 22.51c0 .415.131.767.393 1.056.26.29.575.434.94.434.375 0 .694-.145.955-.434.261-.29.392-.641.392-1.056v-3.284h1.804v3.284c0 .415.13.767.392 1.056.262.29.58.434.954.434.375 0 .693-.145.955-.434.261-.29.392-.641.392-1.056v-3.284h.98c.392 0 .728-.154 1.007-.463.278-.308.418-.684.418-1.128V8h-12v9.635zM20.775 8a1.4 1.4 0 00-1.054.465 1.6 1.6 0 00-.439 1.141v6.772c0 .452.146.835.439 1.15.293.315.644.472 1.054.472.42 0 .775-.157 1.068-.472.293-.315.439-.698.439-1.15V9.606a1.6 1.6 0 00-.439-1.141A1.416 1.416 0 0020.775 8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.154.295l-.92 1.756a5.781 5.781 0 012.218 2.06c.553.88.83 1.843.83 2.889h-12c0-1.046.277-2.009.83-2.89a5.756 5.756 0 012.232-2.059L8.423.295C8.362.18 8.383.09 8.487.027c.113-.054.2-.027.26.08l.934 1.77a6.2 6.2 0 012.608-.563c.916 0 1.785.188 2.607.564l.934-1.77c.06-.108.147-.135.26-.081.103.063.125.152.064.268zM10.782 4.5a1 1 0 11-2 0 1 1 0 012 0zm5 0a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "currentColor"
  })));
}

var _g, _defs;
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$c.apply(null, arguments);
}
function SvgApple(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Apple_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    d: "M21.792 18.704c-.363.838-.793 1.61-1.29 2.32-.679.967-1.234 1.637-1.662 2.008-.664.61-1.375.924-2.137.941-.546 0-1.206-.155-1.973-.47-.77-.315-1.478-.47-2.124-.47-.679 0-1.407.155-2.185.47-.78.315-1.407.48-1.888.495-.73.031-1.458-.29-2.184-.966-.464-.404-1.044-1.097-1.739-2.08-.745-1.048-1.358-2.265-1.838-3.651C2.258 15.803 2 14.353 2 12.949c0-1.609.348-2.996 1.044-4.158A6.122 6.122 0 015.23 6.58a5.88 5.88 0 012.955-.834c.58 0 1.34.179 2.285.532.943.353 1.548.533 1.813.533.199 0 .871-.21 2.01-.628 1.078-.388 1.988-.549 2.733-.485 2.02.163 3.536.959 4.545 2.393-1.806 1.094-2.699 2.626-2.681 4.592.016 1.532.572 2.806 1.663 3.818.495.47 1.048.832 1.663 1.09-.134.387-.274.757-.424 1.113zM17.161.48c0 1.2-.439 2.32-1.313 3.358-1.054 1.233-2.33 1.946-3.714 1.833a3.742 3.742 0 01-.027-.455c0-1.152.501-2.385 1.392-3.393.445-.51 1.01-.935 1.696-1.274.685-.333 1.332-.518 1.94-.55.019.16.026.321.026.48z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Apple_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var _g$1, _defs$1;
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$d.apply(null, arguments);
}
function SvgAppleMusic(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#AppleMusic_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    d: "M24.162 6.124v-.097c0-.743-.087-1.465-.252-2.156l.013.063A4.942 4.942 0 0021.76.903l-.02-.012a4.956 4.956 0 00-1.847-.723l-.03-.004a10.14 10.14 0 00-1.553-.15h-.011c-.04 0-.083-.01-.124-.013H6.15c-.152.01-.3.017-.455.026a6.96 6.96 0 00-2.242.415l.049-.015A5.034 5.034 0 00.649 3.175l-.012.033c-.17.409-.297.885-.36 1.38l-.003.028c-.051.343-.087.751-.1 1.165v.016c0 .032-.007.062-.01.093v12.224c.01.14.017.283.027.424.02.861.202 1.673.516 2.416l-.016-.043a5.01 5.01 0 003.199 2.792l.035.009c.377.111.817.192 1.27.227l.023.001c.555.053 1.11.06 1.667.06h11.028c.554 0 1.099-.037 1.633-.107l-.063.007a5.319 5.319 0 002.32-.823l-.02.013a5.078 5.078 0 001.867-2.176l.013-.032c.166-.383.295-.829.366-1.293l.004-.031a11.897 11.897 0 00.129-2.05V6.124zm-6.424 3.99v5.795c0 .407-.09.794-.251 1.14l.007-.017a2.13 2.13 0 01-1.373 1.137l-.015.003a4.483 4.483 0 01-1.06.173h-.01a1.871 1.871 0 01-.911-3.554l.01-.005c.294-.14.636-.252.992-.32l.027-.004c.378-.082.758-.153 1.134-.24a.621.621 0 00.51-.513v-.003a.863.863 0 00.02-.189v-.005-5.443a.739.739 0 00-.027-.19v.005a.29.29 0 00-.282-.235l-.018.001c-.177.013-.34.036-.498.07l.024-.004c-.76.15-1.52.302-2.28.456l-3.7.748c-.016 0-.032.01-.048.013a.452.452 0 00-.392.447c0 .015 0 .03.002.045v-.002 8.026c0 .408-.078.797-.223 1.152l.007-.021a2.138 2.138 0 01-1.436 1.235l-.015.003a4.307 4.307 0 01-1.067.172h-.008a1.84 1.84 0 01-1.919-1.533l-.001-.011a1.867 1.867 0 011.141-2.071l.013-.004a5.678 5.678 0 011.072-.305l.036-.005c.287-.06.575-.116.86-.177a.7.7 0 00.6-.693v-.022.001-.15-8.883-.007c0-.129.015-.254.044-.374l-.002.011a.696.696 0 01.542-.517l.004-.001c.255-.066.515-.112.774-.165.733-.15 1.466-.3 2.2-.444l2.27-.46c.67-.134 1.34-.27 2.01-.4.18-.042.407-.079.637-.104l.027-.002a.493.493 0 01.554.481c.008.067.012.144.012.222V10.11l.007.004z",
    fill: "currentColor"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "AppleMusic_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    transform: "translate(.162)",
    d: "M0 0h25v24H0z"
  })))));
}

var _path$b;
function _extends$e() {
  return _extends$e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$e.apply(null, arguments);
}
function SvgArrowCaretBack(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/createElement("path", {
    d: "M7.994 12.918a1.25 1.25 0 010-1.836l4.408-4.072c.8-.74 2.098-.172 2.098.918v8.144c0 1.09-1.298 1.658-2.098.918l-4.408-4.072z",
    fill: "currentColor"
  })));
}

var _path$c;
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$f.apply(null, arguments);
}
function SvgArrowCaretDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/createElement("path", {
    d: "M12.918 16.006a1.25 1.25 0 01-1.836 0L7.01 11.598c-.74-.8-.172-2.098.918-2.098h8.144c1.09 0 1.658 1.298.918 2.098l-4.072 4.408z",
    fill: "currentColor"
  })));
}

var _path$d;
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$g.apply(null, arguments);
}
function SvgArrowCaretForward(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/createElement("path", {
    d: "M16.006 11.082a1.25 1.25 0 010 1.836l-4.408 4.072c-.8.74-2.098.172-2.098-.918V7.928c0-1.09 1.298-1.658 2.098-.918l4.408 4.072z",
    fill: "currentColor"
  })));
}

var _path$e;
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$h.apply(null, arguments);
}
function SvgArrowCaretUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/createElement("path", {
    d: "M11.082 7.994a1.25 1.25 0 011.836 0l4.072 4.408c.74.8.172 2.098-.918 2.098H7.928c-1.09 0-1.658-1.298-.918-2.098l4.072-4.408z",
    fill: "currentColor"
  })));
}

var _path$f;
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$i.apply(null, arguments);
}
function SvgArrowChevronBack(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/createElement("path", {
    d: "M14.963 5L8 11.963l6.963 6.963",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$g;
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$j.apply(null, arguments);
}
function SvgArrowChevronDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/createElement("path", {
    d: "M18.926 10l-6.963 6.963L5 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$h;
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$k.apply(null, arguments);
}
function SvgArrowChevronForward(props) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/createElement("path", {
    d: "M10 5l6.963 6.963L10 18.926",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$i;
function _extends$l() {
  return _extends$l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$l.apply(null, arguments);
}
function SvgArrowChevronUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/createElement("path", {
    d: "M18.926 14.963L11.963 8 5 14.963",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$j, _path2$1;
function _extends$m() {
  return _extends$m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$m.apply(null, arguments);
}
function SvgArrowDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/createElement("path", {
    d: "M5 14.283L12 21l7-6.717",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M12.032 19.733V4"
  })));
}

var _path$k, _path2$2;
function _extends$n() {
  return _extends$n = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$n.apply(null, arguments);
}
function SvgArrowGoingDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/createElement("path", {
    d: "M18.564 8.665l-.2 9.699-9.7.2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M17.445 17.491L6.321 6.366"
  })));
}

var _path$l, _path2$3;
function _extends$o() {
  return _extends$o = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$o.apply(null, arguments);
}
function SvgArrowGoingUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/createElement("path", {
    d: "M8.664 5.436l9.7.2.2 9.7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M17.491 6.554L6.366 17.679"
  })));
}

var _path$m, _path2$4;
function _extends$p() {
  return _extends$p = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$p.apply(null, arguments);
}
function SvgArrowGoingUpAlt(props) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/createElement("path", {
    d: "M13.432 5.324h9v9.364",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/createElement("path", {
    d: "M22.25 5.506L13.326 14.5l-4.5-4.783L1.042 17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$n, _path2$5;
function _extends$q() {
  return _extends$q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$q.apply(null, arguments);
}
function SvgArrowReply(props) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$n || (_path$n = /*#__PURE__*/createElement("path", {
    d: "M8.717 16L2 9l6.717-7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/createElement("path", {
    d: "M2 9h7c7.18 0 13 5.82 13 13v0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$o;
function _extends$r() {
  return _extends$r = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$r.apply(null, arguments);
}
function SvgArrowSelect(props) {
  return /*#__PURE__*/createElement("svg", _extends$r({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/createElement("path", {
    d: "M8 17l4 4 4-4M8 7l4-4 4 4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$p, _path2$6;
function _extends$s() {
  return _extends$s = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$s.apply(null, arguments);
}
function SvgArrowUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$s({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/createElement("path", {
    d: "M5 9.717L12 3l7 6.717",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M12.032 4.267V20"
  })));
}

var _path$q, _circle, _path2$7, _path3;
function _extends$t() {
  return _extends$t = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$t.apply(null, arguments);
}
function SvgAtSign(props) {
  return /*#__PURE__*/createElement("svg", _extends$t({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/createElement("path", {
    d: "M16 8v5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/createElement("path", {
    d: "M22 12a3 3 0 11-6 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12a9 9 0 0118 0c0 .335.253.622.587.64l.678.035c.395.02.735-.28.735-.675 0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11c2.248 0 4.339-.674 6.08-1.832.819-.544.395-1.682-.585-1.733a1.234 1.234 0 00-.719.195A9 9 0 013 12z",
    fill: "currentColor"
  })));
}

var _path$r;
function _extends$u() {
  return _extends$u = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$u.apply(null, arguments);
}
function SvgAttach(props) {
  return /*#__PURE__*/createElement("svg", _extends$u({
    width: ".96em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/createElement("path", {
    d: "M21.981 11.667l-9.9 9.9s-4.596 4.596-8.838.353c-4.243-4.242.353-8.839.353-8.839L13.85 2.829s2.829-2.828 5.657 0c2.828 2.829 0 5.657 0 5.657l-9.9 9.9s-1.414 1.414-2.828 0 0-2.829 0-2.829l9.193-9.192",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$s;
function _extends$v() {
  return _extends$v = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$v.apply(null, arguments);
}
function SvgAutoLayout(props) {
  return /*#__PURE__*/createElement("svg", _extends$v({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M2 3h20v6H2zM2 15h20v6H2z"
  })));
}

var _path$t, _path2$8;
function _extends$w() {
  return _extends$w = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$w.apply(null, arguments);
}
function SvgAutomotiveIconRed(props) {
  return /*#__PURE__*/createElement("svg", _extends$w({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/createElement("path", {
    d: "M19 14.5h-3M5 14.5h2.5",
    stroke: "#F25858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/createElement("path", {
    d: "M15.868 3H8.132a2 2 0 00-1.715.971L4.558 7.07c-.346.577-.97.93-1.643.93h-.679C1.553 8 1 8.553 1 9.236v.075c0 .422.239.808.616.997.681.34.828 1.248.29 1.786l-.446.446A1.57 1.57 0 001 13.65v2.643c0 .453.18.887.5 1.207.32.32.5.754.5 1.207V19a2 2 0 002 2h1.5A1.5 1.5 0 007 19.5 1.5 1.5 0 018.5 18h7a1.5 1.5 0 011.5 1.5 1.5 1.5 0 001.5 1.5H20a2 2 0 002-2v-.293c0-.453.18-.887.5-1.207.32-.32.5-.754.5-1.207V13.65a1.57 1.57 0 00-.46-1.11l-.446-.446a1.115 1.115 0 01.29-1.786c.377-.189.616-.575.616-.997v-.075C23 8.553 22.447 8 21.764 8h-.68a1.916 1.916 0 01-1.642-.93l-1.86-3.099A2 2 0 0015.869 3z",
    stroke: "#F25858",
    strokeWidth: 2
  })));
}

var _g$2;
function _extends$x() {
  return _extends$x = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$x.apply(null, arguments);
}
function SvgAvatar(props) {
  return /*#__PURE__*/createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g$2 || (_g$2 = /*#__PURE__*/createElement("g", {
    fill: "none",
    strokeWidth: 30,
    stroke: "#000"
  }, /*#__PURE__*/createElement("path", {
    d: "M37.668 20c0 9.758-7.91 17.668-17.668 17.668S2.332 29.758 2.332 20 10.242 2.332 20 2.332 37.668 10.242 37.668 20zm0 0",
    strokeWidth: 2.0000999999999998
  }), /*#__PURE__*/createElement("path", {
    d: "M27.668 15.332a7.669 7.669 0 01-15.336 0A7.665 7.665 0 0120 7.668a7.665 7.665 0 017.668 7.664zm0 0M7.121 32.094a13.666 13.666 0 0125.758 0",
    strokeWidth: 2.0000999999999998
  }))));
}

var _circle$1, _path$u;
function _extends$y() {
  return _extends$y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$y.apply(null, arguments);
}
function SvgAvatarNew(props) {
  return /*#__PURE__*/createElement("svg", _extends$y({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F4F4F4"
  })), _path$u || (_path$u = /*#__PURE__*/createElement("path", {
    d: "M26.95 24.38c-1.572-.813-4.165-1.88-6.95-1.88s-5.378 1.067-6.95 1.88c-1.016.525-1.627 1.555-1.762 2.69L11 29.5h18l-.288-2.43c-.135-1.135-.746-2.165-1.761-2.69zM20 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: "#A4ADB4"
  })));
}

var _path$v, _path2$9;
function _extends$z() {
  return _extends$z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$z.apply(null, arguments);
}
function SvgBackArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$z({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/createElement("path", {
    d: "M9.717 5L3 12l6.717 7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M4.267 12.032H20"
  })));
}

var _path$w, _path2$a;
function _extends$A() {
  return _extends$A = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$A.apply(null, arguments);
}
function SvgBackspace(props) {
  return /*#__PURE__*/createElement("svg", _extends$A({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$w || (_path$w = /*#__PURE__*/createElement("path", {
    d: "M6.488 4.264A3 3 0 018.935 3H21a3 3 0 013 3v12a3 3 0 01-3 3H8.935a3 3 0 01-2.447-1.264L1.41 12.579a1 1 0 010-1.158l5.078-7.157z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$a || (_path2$a = /*#__PURE__*/createElement("path", {
    d: "M11 9l6 6M11 15l6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$x, _path2$b;
function _extends$B() {
  return _extends$B = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$B.apply(null, arguments);
}
function SvgBackUndo(props) {
  return /*#__PURE__*/createElement("svg", _extends$B({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$x || (_path$x = /*#__PURE__*/createElement("path", {
    d: "M9.45 14.453l-7.701.054V7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$b || (_path2$b = /*#__PURE__*/createElement("path", {
    d: "M1.749 14.508l3.463-3.65c4.792-5.05 13.208-3.396 15.733 3.09v0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$y;
function _extends$C() {
  return _extends$C = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$C.apply(null, arguments);
}
function SvgBackward(props) {
  return /*#__PURE__*/createElement("svg", _extends$C({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$y || (_path$y = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.238 7.572a.5.5 0 00-.78-.414l-6.064 4.093a.5.5 0 000 .829l6.064 4.092a.5.5 0 00.78-.414V7.572zM18.339 5.5c1.66-1.12 3.899.07 3.899 2.072v8.186c0 2.003-2.238 3.193-3.899 2.072l-6.064-4.093a2.552 2.552 0 01-.283-.22v2.241c0 2.003-2.239 3.193-3.899 2.072L2.03 13.737a2.5 2.5 0 010-4.144L8.093 5.5c1.66-1.12 3.899.07 3.899 2.072v2.242c.087-.079.181-.153.283-.221L18.339 5.5zM9.992 7.572a.5.5 0 00-.78-.414L3.148 11.25a.5.5 0 000 .829l6.064 4.092a.5.5 0 00.78-.414V7.572z",
    fill: "currentColor"
  })));
}

var _path$z, _path2$c;
function _extends$D() {
  return _extends$D = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$D.apply(null, arguments);
}
function SvgBag(props) {
  return /*#__PURE__*/createElement("svg", _extends$D({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/createElement("path", {
    d: "M2.464 4.444A2 2 0 002 5.724V20a3 3 0 003 3h14a3 3 0 003-3V5.724a2 2 0 00-.464-1.28l-2.27-2.724A2 2 0 0017.73 1H6.27a2 2 0 00-1.536.72l-2.27 2.724zM2 5.5h20",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$c || (_path2$c = /*#__PURE__*/createElement("path", {
    d: "M16 10a4 4 0 01-8 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$A, _circle$2, _path2$d;
function _extends$E() {
  return _extends$E = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$E.apply(null, arguments);
}
function SvgBagAndSuccess(props) {
  return /*#__PURE__*/createElement("svg", _extends$E({
    width: 108,
    height: 109,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$A || (_path$A = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.896 17.703c-.25.3-.429.648-.528 1.02h70.93c-.098-.372-.278-.72-.527-1.02L67.337 5.182a2.667 2.667 0 00-2.049-.96h-44.91c-.79 0-1.541.352-2.048.96L7.896 17.702zm-.618 60.742V21.722h71.11v56.723a4 4 0 01-4 4h-63.11a4 4 0 01-4-4zM31.61 36.222a3 3 0 00-6 0c0 9.512 7.71 17.222 17.222 17.222s17.223-7.71 17.223-17.222a3 3 0 10-6 0c0 6.198-5.025 11.222-11.223 11.222-6.197 0-11.222-5.024-11.222-11.222z",
    fill: "#1CA355"
  })), _circle$2 || (_circle$2 = /*#__PURE__*/createElement("circle", {
    cx: 80.167,
    cy: 80.667,
    r: 24.444,
    fill: "#fff",
    stroke: "#1CA355",
    strokeWidth: 6
  })), _path2$d || (_path2$d = /*#__PURE__*/createElement("path", {
    d: "M73.5 80.555l4.714 4.714 9.428-9.428",
    stroke: "#1CA355",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$B, _path2$e, _path3$1, _path4, _rect;
function _extends$F() {
  return _extends$F = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$F.apply(null, arguments);
}
function SvgBathroomShowerTub(props) {
  return /*#__PURE__*/createElement("svg", _extends$F({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$B || (_path$B = /*#__PURE__*/createElement("path", {
    d: "M13 13H1v4a4 4 0 004 4h14a4 4 0 004-4v-4h-3.889",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$e || (_path2$e = /*#__PURE__*/createElement("path", {
    d: "M19 22v1M5 22v1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/createElement("path", {
    d: "M1.033 13V5S1 1 4.5 1 8 3 8 3",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/createElement("path", {
    d: "M7.11 6.492a2.5 2.5 0 011.21-3.323v0a2.5 2.5 0 013.322 1.21l.634 1.36L7.745 7.85l-.634-1.36z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/createElement("rect", {
    x: 13,
    y: 11,
    width: 6,
    height: 6,
    rx: 1.5,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var _circle$3, _path$C, _circle2, _path2$f;
function _extends$G() {
  return _extends$G = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$G.apply(null, arguments);
}
function SvgBike(props) {
  return /*#__PURE__*/createElement("svg", _extends$G({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$3 || (_circle$3 = /*#__PURE__*/createElement("circle", {
    cx: 19,
    cy: 15,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path$C || (_path$C = /*#__PURE__*/createElement("path", {
    d: "M19 15s.396-2.123.5-3.5c.118-1.558.097-2.44 0-4-.097-1.571.5-5 .5-5l-5.5 1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/createElement("circle", {
    cx: 5,
    cy: 15,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$f || (_path2$f = /*#__PURE__*/createElement("path", {
    d: "M9 4H4M6.5 4.5L5 15s3-4 6.5-6 8-2 8-2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$D, _path2$g, _path3$2;
function _extends$H() {
  return _extends$H = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$H.apply(null, arguments);
}
function SvgBioFingerprint(props) {
  return /*#__PURE__*/createElement("svg", _extends$H({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$D || (_path$D = /*#__PURE__*/createElement("path", {
    d: "M17.753 20.884s2.162-4.425 2.721-6.304c.157-.528.442-1.548.769-2.742 1.124-4.105-1.107-8.377-5.106-9.832v0A8.213 8.213 0 005.592 6.964l-.116.326M2.408 14.03s.633-.873.963-1.477c.272-.497.614-1.315.614-1.315",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$g || (_path2$g = /*#__PURE__*/createElement("path", {
    d: "M12.228 22.199s.473-.6.877-1.228c.335-.519.702-1.403.702-1.403m-9.647-.877s1.855-2.02 3.158-5.087c.58-1.363 1.148-3.08 1.623-4.655.71-2.36 3.247-3.714 5.562-2.871v0a4.14 4.14 0 012.47 5.319l-1.595 4.332",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/createElement("path", {
    d: "M13.083 10.54s-1.123 2.758-2.185 5.283c-1.135 2.697-3.668 5.5-3.668 5.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$E;
function _extends$I() {
  return _extends$I = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$I.apply(null, arguments);
}
function SvgBitcoin(props) {
  return /*#__PURE__*/createElement("svg", _extends$I({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$E || (_path$E = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-9.117-4.459c1.67.574 2.89 1.432 2.65 3.03-.173 1.169-.824 1.735-1.689 1.933 1.187.615 1.59 1.783 1.215 3.194-.713 2.032-2.409 2.203-4.664 1.779l-.548 2.184-1.322-.329.54-2.155a56.26 56.26 0 01-1.053-.272l-.543 2.165-1.32-.328.547-2.189-2.663-.67.657-1.507s.974.257.96.238c.375.093.542-.15.607-.312l1.484-5.928c.017-.28-.08-.632-.616-.766.02-.014-.96-.238-.96-.238l.351-1.406 2.667.658.542-2.164 1.322.328-.532 2.121c.356.08.713.163 1.06.249l.527-2.108 1.322.329-.541 2.164zm-3.163 3.61c.9.239 2.86.758 3.201-.604.349-1.393-1.555-1.814-2.487-2.02a11.365 11.365 0 01-.275-.063l-.658 2.63.219.057zm-1.02 4.235c1.078.284 3.437.906 3.813-.595.384-1.535-1.903-2.046-3.02-2.296-.124-.027-.234-.052-.324-.074l-.726 2.899c.073.018.16.04.257.066z",
    fill: "currentColor"
  })));
}

var _path$F;
function _extends$J() {
  return _extends$J = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$J.apply(null, arguments);
}
function SvgBold(props) {
  return /*#__PURE__*/createElement("svg", _extends$J({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F || (_path$F = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5H7v14h6c2.21 0 4-1.814 4-4.023 0-.948-.337-1.874-.95-2.597l-.323-.38.323-.38c.613-.723.95-1.649.95-2.597C17 6.814 15.21 5 13 5zm-3 2.5h2.5a1.5 1.5 0 010 3H10v-3zm0 6h2.5a1.5 1.5 0 010 3H10v-3z",
    fill: "currentColor"
  })));
}

var _path$G, _path2$h, _path3$3;
function _extends$K() {
  return _extends$K = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$K.apply(null, arguments);
}
function SvgBottleIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$K({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G || (_path$G = /*#__PURE__*/createElement("path", {
    d: "M7 7a2 2 0 012-2h6a2 2 0 012 2v1.123a2 2 0 01-.358 1.142l-.848 1.218a2 2 0 000 2.284l.848 1.218A2 2 0 0117 15.127V21a2 2 0 01-2 2H9a2 2 0 01-2-2v-5.873a2 2 0 01.358-1.142l.847-1.218a2 2 0 000-2.284l-.847-1.218A2 2 0 017 8.123V7z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$h || (_path2$h = /*#__PURE__*/createElement("path", {
    d: "M12 1v1M7 18h10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/createElement("path", {
    d: "M9 4.571A2.571 2.571 0 0111.571 2h.858A2.571 2.571 0 0115 4.571v0a.429.429 0 01-.429.429H9.43A.429.429 0 019 4.571v0z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$H, _path2$i;
function _extends$L() {
  return _extends$L = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$L.apply(null, arguments);
}
function SvgBox(props) {
  return /*#__PURE__*/createElement("svg", _extends$L({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$H || (_path$H = /*#__PURE__*/createElement("path", {
    d: "M2 4a1 1 0 011-1h18a1 1 0 011 1v4H2V4zM3 8h18v12a1 1 0 01-1 1H4a1 1 0 01-1-1V8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$i || (_path2$i = /*#__PURE__*/createElement("path", {
    d: "M10 12a1 1 0 100 2v-2zm4 2a1 1 0 100-2v2zm-4 0h4v-2h-4v2z",
    fill: "currentColor"
  })));
}

var _rect$1, _path$I, _path2$j;
function _extends$M() {
  return _extends$M = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$M.apply(null, arguments);
}
function SvgBriefcasePortfolio(props) {
  return /*#__PURE__*/createElement("svg", _extends$M({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 6,
    width: 22,
    height: 16,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$I || (_path$I = /*#__PURE__*/createElement("path", {
    d: "M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2M1 14s4.889 3 11 3 11-3 11-3",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$j || (_path2$j = /*#__PURE__*/createElement("path", {
    d: "M11 12h2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$J, _path2$k, _path3$4, _path4$1, _path5;
function _extends$N() {
  return _extends$N = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$N.apply(null, arguments);
}
function SvgBuildingBusinessOffice(props) {
  return /*#__PURE__*/createElement("svg", _extends$N({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$J || (_path$J = /*#__PURE__*/createElement("path", {
    d: "M1 4l11.58-2.482A2 2 0 0115 3.474V23H1V4z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$k || (_path2$k = /*#__PURE__*/createElement("path", {
    d: "M6 19h4v4H6v-4z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$4 || (_path3$4 = /*#__PURE__*/createElement("path", {
    d: "M19 14h4M19 10h4M19 18h4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M15 5h8v18h-8zM19 0v5"
  })), _path5 || (_path5 = /*#__PURE__*/createElement("path", {
    d: "M4 15h3M9 15h3M9 7h3M4 7h3M4 11h3M9 11h3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var _rect$2, _path$K, _path2$l;
function _extends$O() {
  return _extends$O = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$O.apply(null, arguments);
}
function SvgBuildingGov(props) {
  return /*#__PURE__*/createElement("svg", _extends$O({
    width: "1.83em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/createElement("rect", {
    x: 2,
    y: 18,
    width: 22,
    height: 5,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path$K || (_path$K = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M5 9h5v9H5zM16 9h5v9h-5z"
  })), _path2$l || (_path2$l = /*#__PURE__*/createElement("path", {
    d: "M2.766 9C1.74 9 1.379 7.64 2.269 7.132l10.235-5.848a1 1 0 01.992 0l10.235 5.848C24.62 7.64 24.26 9 23.234 9H2.766z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var _path$L, _circle$4, _circle2$1, _circle3, _path2$m;
function _extends$P() {
  return _extends$P = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$P.apply(null, arguments);
}
function SvgBullets(props) {
  return /*#__PURE__*/createElement("svg", _extends$P({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$L || (_path$L = /*#__PURE__*/createElement("path", {
    d: "M10.996 5h12M10.996 12h12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$4 || (_circle$4 = /*#__PURE__*/createElement("circle", {
    cx: 3.996,
    cy: 12,
    r: 2,
    fill: "currentColor"
  })), _circle2$1 || (_circle2$1 = /*#__PURE__*/createElement("circle", {
    cx: 3.996,
    cy: 5,
    r: 2,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/createElement("circle", {
    cx: 3.996,
    cy: 19,
    r: 2,
    fill: "currentColor"
  })), _path2$m || (_path2$m = /*#__PURE__*/createElement("path", {
    d: "M10.996 19h12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$M, _path2$n;
function _extends$Q() {
  return _extends$Q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$Q.apply(null, arguments);
}
function SvgBulletsNumbered(props) {
  return /*#__PURE__*/createElement("svg", _extends$Q({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$M || (_path$M = /*#__PURE__*/createElement("path", {
    d: "M10.996 5h12M10.996 12h12M10.996 19h12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$n || (_path2$n = /*#__PURE__*/createElement("path", {
    d: "M2.996 3h1.5v4M2.996 17h2.5v2m-2.5 2h2.5v-2m-1.5 0h1.5M2.996 10h2.5l-2 3.5h2.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$3, _defs$2;
function _extends$R() {
  return _extends$R = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$R.apply(null, arguments);
}
function SvgBullhorn(props) {
  return /*#__PURE__*/createElement("svg", _extends$R({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Bullhorn_svg__clip0)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/createElement("path", {
    d: "M2 10c0-2.148 1.846-3.833 3.993-3.778C7.712 6.266 9.636 6.24 11 6c3.287-.576 7-3 7-3v14s-3.713-2.424-7-3c-1.364-.239-3.288-.266-5.007-.222C3.846 13.833 2 12.148 2 10v0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M13 15v6.566c0 1-1.306 1.38-1.844.537L6 14M18 13a3 3 0 100-6"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Bullhorn_svg__clip0"
  }, /*#__PURE__*/createElement("rect", {
    width: "1em",
    height: "1em",
    fill: "#fff"
  })))));
}

var _path$N;
function _extends$S() {
  return _extends$S = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$S.apply(null, arguments);
}
function SvgBumble(props) {
  return /*#__PURE__*/createElement("svg", _extends$S({
    width: "1.136em",
    height: "1em",
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$N || (_path$N = /*#__PURE__*/createElement("path", {
    d: "M24.104 11.192l-5.34 9.222a1.31 1.31 0 01-1.14.655H6.95c-.49 0-.91-.262-1.14-.66L.46 11.192a1.312 1.312 0 010-1.315L5.799.655A1.329 1.329 0 016.94 0H17.63c.49 0 .911.267 1.14.66l5.334 9.216c.236.407.236.91 0 1.316zM10.65 16.406h3.274a1.315 1.315 0 100-2.63H10.65a1.315 1.315 0 100 2.63zm4.572-11.71h-5.87a1.318 1.318 0 100 2.635h5.87a1.318 1.318 0 000-2.635zm2.386 4.538H6.961a1.318 1.318 0 000 2.634h10.647a1.318 1.318 0 100-2.634z",
    fill: "currentColor"
  })));
}

var _path$O, _path2$o;
function _extends$T() {
  return _extends$T = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$T.apply(null, arguments);
}
function SvgBush(props) {
  return /*#__PURE__*/createElement("svg", _extends$T({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$O || (_path$O = /*#__PURE__*/createElement("path", {
    d: "M8.097 7.84v1h1v-1h-1zM4.56 11.31l.301.953.769-.243-.074-.803-.996.092zM3.665 20l-.461.887.217.113h.244v-1zm17.844 0v1h.378l.284-.25-.662-.75zm-.176-6.548l-.943-.332-.235.669.552.443.626-.78zm-4.778-6.245l-.983.181.143.779.79.04.05-1zm-7.458.633c0-1.474 1.359-2.84 3.258-2.84V3C9.55 3 7.097 5.072 7.097 7.84h2zm-3.549 3.2c0-1.12 1.042-2.2 2.549-2.2v-2c-2.412 0-4.549 1.786-4.549 4.2h2zm.009.177a1.926 1.926 0 01-.009-.177h-2c0 .122.006.242.017.361l1.992-.184zM2 15.84c0-1.59 1.136-3.031 2.862-3.577l-.603-1.907C1.84 11.12 0 13.242 0 15.84h2zm2.127 3.273C2.817 18.431 2 17.193 2 15.84H0c0 2.203 1.328 4.07 3.204 5.047l.923-1.774zM3.665 21H21.51v-2H3.665v2zM22 16.8c0 .938-.425 1.807-1.153 2.45l1.324 1.5C23.283 19.766 24 18.37 24 16.8h-2zm-1.293-2.568C21.521 14.884 22 15.805 22 16.8h2c0-1.668-.81-3.14-2.041-4.128l-1.252 1.56zM20.581 12c0 .39-.067.766-.191 1.12l1.886.663A5.366 5.366 0 0022.581 12h-2zm-4.075-3.794c2.364.118 4.075 1.857 4.075 3.794h2c0-3.185-2.738-5.63-5.976-5.791l-.1 1.997zM12.355 5c1.696 0 2.981 1.105 3.217 2.388l1.967-.361C17.106 4.67 14.884 3 12.355 3v2z",
    fill: "currentColor"
  })), _path2$o || (_path2$o = /*#__PURE__*/createElement("path", {
    d: "M9 15.129c0-1.13 1.194-2 2.667-2 1.004 0 1.879.416 2.334 1.031",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _rect$3, _path$P;
function _extends$U() {
  return _extends$U = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$U.apply(null, arguments);
}
function SvgCalandar(props) {
  return /*#__PURE__*/createElement("svg", _extends$U({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$3 || (_rect$3 = /*#__PURE__*/createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 19,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$P || (_path$P = /*#__PURE__*/createElement("path", {
    d: "M7 1v2M17 1v2M2 8h20M7.5 13h2M14.5 13h2M7.5 17h2M14.5 17h2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$Q;
function _extends$V() {
  return _extends$V = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$V.apply(null, arguments);
}
function SvgCall(props) {
  return /*#__PURE__*/createElement("svg", _extends$V({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/createElement("path", {
    d: "M17.278 1.974l3.468.385c.93.103 1.646.84 1.549 1.77-.244 2.326-1.394 6.912-6.323 11.841-4.93 4.93-9.516 6.08-11.842 6.324-.93.098-1.668-.619-1.771-1.549l-.385-3.467a2 2 0 01.995-1.958l2.484-1.419a2 2 0 012.407.322l.637.638c.473.473 1.154.673 1.758.386.716-.339 1.752-.968 2.888-2.104 1.136-1.137 1.765-2.171 2.104-2.888.287-.604.087-1.285-.386-1.758l-.637-.637a2 2 0 01-.323-2.407l1.42-2.484a2 2 0 011.957-.995z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$R, _circle$5;
function _extends$W() {
  return _extends$W = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$W.apply(null, arguments);
}
function SvgCamera(props) {
  return /*#__PURE__*/createElement("svg", _extends$W({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$R || (_path$R = /*#__PURE__*/createElement("path", {
    d: "M2 9.257A3.257 3.257 0 015.257 6v0a3.257 3.257 0 002.71-1.45L8 4.5A3.369 3.369 0 0110.803 3h2.394c1.127 0 2.178.563 2.803 1.5l.033.05A3.257 3.257 0 0018.743 6v0A3.257 3.257 0 0122 9.257V17a4 4 0 01-4 4H6a4 4 0 01-4-4V9.257z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$5 || (_circle$5 = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 13,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$S;
function _extends$X() {
  return _extends$X = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$X.apply(null, arguments);
}
function SvgCandle(props) {
  return /*#__PURE__*/createElement("svg", _extends$X({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$S || (_path$S = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M14.588 3.06a.73.73 0 01.041.065c.5.87.49 1.919-.024 2.807a3.047 3.047 0 01-1.772 1.388v1.488l2.476.697c.337.094.57.402.57.751v8.564h4.633a.782.782 0 01.715 1.095l-1.588 3.618a.78.78 0 01-.715.467H5.076a.78.78 0 01-.715-.467l-1.588-3.619a.782.782 0 01.715-1.094H8.12V8.512a.782.782 0 01.993-.751l2.157.607V7.363a3 3 0 01-1.867-1.391c-.524-.89-.537-1.944-.033-2.82a.817.817 0 01.04-.063L11.361.33a.781.781 0 01.636-.33H12a.78.78 0 01.635.327l1.953 2.733zM9.683 18.82h4.634v-7.972L9.683 9.543v9.277zm2.304-12.937c.524 0 1.005-.281 1.267-.734.23-.395.242-.837.038-1.216l-1.289-1.804-1.294 1.829c-.293.54-.07 1.032.04 1.22.261.443.729.715 1.238.705zM5.586 22.438h12.827l.903-2.056H4.683l.903 2.056z"
  })));
}

var _rect$4, _path$T;
function _extends$Y() {
  return _extends$Y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$Y.apply(null, arguments);
}
function SvgCard(props) {
  return /*#__PURE__*/createElement("svg", _extends$Y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$4 || (_rect$4 = /*#__PURE__*/createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 15,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$T || (_path$T = /*#__PURE__*/createElement("path", {
    d: "M1 10h22",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$5, _path$U;
function _extends$Z() {
  return _extends$Z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$Z.apply(null, arguments);
}
function SvgCardCollection(props) {
  return /*#__PURE__*/createElement("svg", _extends$Z({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$5 || (_rect$5 = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 12,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$U || (_path$U = /*#__PURE__*/createElement("path", {
    d: "M19 10V7.5a2 2 0 00-2-2H7a2 2 0 00-2 2V10M16 5.5V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v1.5",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$V, _path2$p;
function _extends$_() {
  return _extends$_ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$_.apply(null, arguments);
}
function SvgCarFront(props) {
  return /*#__PURE__*/createElement("svg", _extends$_({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$V || (_path$V = /*#__PURE__*/createElement("path", {
    d: "M19 14.5h-3M5 14.5h2.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$p || (_path2$p = /*#__PURE__*/createElement("path", {
    d: "M15.868 3H8.132a2 2 0 00-1.715.971L4.558 7.07c-.346.577-.97.93-1.643.93h-.679C1.553 8 1 8.553 1 9.236v.075c0 .422.239.808.616.997.681.34.828 1.248.29 1.786l-.446.446A1.57 1.57 0 001 13.65v2.643c0 .453.18.887.5 1.207.32.32.5.754.5 1.207V19a2 2 0 002 2h1.5A1.5 1.5 0 007 19.5 1.5 1.5 0 018.5 18h7a1.5 1.5 0 011.5 1.5 1.5 1.5 0 001.5 1.5H20a2 2 0 002-2v-.293c0-.453.18-.887.5-1.207.32-.32.5-.754.5-1.207V13.65a1.57 1.57 0 00-.46-1.11l-.446-.446a1.115 1.115 0 01.29-1.786c.377-.189.616-.575.616-.997v-.075C23 8.553 22.447 8 21.764 8h-.68a1.916 1.916 0 01-1.642-.93l-1.86-3.099A2 2 0 0015.869 3z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$W, _path2$q, _path3$5, _path4$2, _path5$1, _path6;
function _extends$$() {
  return _extends$$ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$$.apply(null, arguments);
}
function SvgCarGarage(props) {
  return /*#__PURE__*/createElement("svg", _extends$$({
    width: ".96em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$W || (_path$W = /*#__PURE__*/createElement("path", {
    d: "M1 8l11-6 11 6v16H1V8z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$q || (_path2$q = /*#__PURE__*/createElement("path", {
    d: "M1 8l11-6 11 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/createElement("path", {
    d: "M1 8h22M1 12h22",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4$2 || (_path4$2 = /*#__PURE__*/createElement("path", {
    d: "M8.688 12a2 2 0 00-1.916 1.425l-.164.95c-.07.407-.272.777-.63.981C5.506 15.626 5 15.933 5 17v2a1 1 0 001 1h12a1 1 0 001-1v-2c0-1.067-.506-1.375-.978-1.644-.358-.204-.56-.574-.63-.98l-.164-.95A2 2 0 0015.312 12H8.688z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/createElement("path", {
    d: "M6 20h3v3a1 1 0 01-1 1H7a1 1 0 01-1-1v-3zM15 20h3v3a1 1 0 01-1 1h-1a1 1 0 01-1-1v-3z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/createElement("path", {
    d: "M8 17h1M15 17h1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$X, _circle$6, _circle2$2;
function _extends$10() {
  return _extends$10 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$10.apply(null, arguments);
}
function SvgCart(props) {
  return /*#__PURE__*/createElement("svg", _extends$10({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$X || (_path$X = /*#__PURE__*/createElement("path", {
    d: "M1 2h2.396a2 2 0 011.952 1.566L6 6.5m0 0l1.104 6.073a6 6 0 005.904 4.927h2.703a6 6 0 005.85-4.67l1.023-4.498A1.5 1.5 0 0021.12 6.5H6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle$6 || (_circle$6 = /*#__PURE__*/createElement("circle", {
    cx: 8.5,
    cy: 21,
    r: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2$2 || (_circle2$2 = /*#__PURE__*/createElement("circle", {
    cx: 20.5,
    cy: 21,
    r: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$Y;
function _extends$11() {
  return _extends$11 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$11.apply(null, arguments);
}
function SvgCashapp(props) {
  return /*#__PURE__*/createElement("svg", _extends$11({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/createElement("path", {
    d: "M23.594 3.469A5.087 5.087 0 0020.542.422C19.235 0 18.041 0 15.624 0H8.36c-2.4 0-3.611 0-4.897.4A5.09 5.09 0 00.41 3.458C0 4.761 0 5.961 0 8.363v7.274c0 2.412 0 3.602.4 4.905a5.087 5.087 0 003.051 3.047C4.753 24 5.953 24 8.353 24h7.277c2.41 0 3.61 0 4.902-.4a5.098 5.098 0 003.056-3.058C24 19.239 24 18.039 24 15.637V8.384c.005-2.412.005-3.613-.405-4.915zm-6.167 4.638l-.933.928a.498.498 0 01-.667.006 5.014 5.014 0 00-3.222-1.18c-.97 0-1.942.32-1.942 1.212 0 .896 1.04 1.2 2.24 1.649 2.102.704 3.841 1.585 3.841 3.645 0 2.241-1.739 3.784-4.576 3.954l-.262 1.207a.49.49 0 01-.475.39H9.64l-.09-.006a.503.503 0 01-.38-.592l.283-1.27a6.57 6.57 0 01-2.885-1.57v-.01a.48.48 0 010-.678l.997-.972a.494.494 0 01.672 0 4.863 4.863 0 003.393 1.324c1.301 0 2.17-.55 2.17-1.425s-.88-1.1-2.538-1.718c-1.76-.63-3.43-1.521-3.43-3.603 0-2.417 2.005-3.602 4.39-3.709l.25-1.233a.486.486 0 01.48-.384h1.772l.101.01c.256.06.432.31.373.572l-.266 1.371c.896.3 1.75.769 2.475 1.388l.021.021a.474.474 0 010 .673z",
    fill: "currentColor"
  })));
}

var _path$Z, _rect$6, _circle$7;
function _extends$12() {
  return _extends$12 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$12.apply(null, arguments);
}
function SvgCashMoney(props) {
  return /*#__PURE__*/createElement("svg", _extends$12({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/createElement("path", {
    d: "M17 9V7a2 2 0 00-2-2H3a2 2 0 00-2 2v6a2 2 0 002 2h3.857",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect$6 || (_rect$6 = /*#__PURE__*/createElement("rect", {
    x: 7,
    y: 9,
    width: 16,
    height: 10,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle$7 || (_circle$7 = /*#__PURE__*/createElement("circle", {
    cx: 15,
    cy: 14,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$_, _path2$r;
function _extends$13() {
  return _extends$13 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$13.apply(null, arguments);
}
function SvgCast(props) {
  return /*#__PURE__*/createElement("svg", _extends$13({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$_ || (_path$_ = /*#__PURE__*/createElement("path", {
    d: "M1.292 7V6a3 3 0 013-3h16a3 3 0 013 3v12a3 3 0 01-3 3h-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$r || (_path2$r = /*#__PURE__*/createElement("path", {
    d: "M1.105 11.657a9 9 0 019 9M1.105 16.173a4.22 4.22 0 014.22 4.22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$$;
function _extends$14() {
  return _extends$14 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$14.apply(null, arguments);
}
function SvgChartBar(props) {
  return /*#__PURE__*/createElement("svg", _extends$14({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$$ || (_path$$ = /*#__PURE__*/createElement("path", {
    d: "M3 14v8M9 12v10M15 8v14M21 2v20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$10;
function _extends$15() {
  return _extends$15 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$15.apply(null, arguments);
}
function SvgChartPie(props) {
  return /*#__PURE__*/createElement("svg", _extends$15({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$10 || (_path$10 = /*#__PURE__*/createElement("path", {
    d: "M20.272 15.816A9.999 9.999 0 116.805 2.992M15.827 1.831a9.999 9.999 0 00-2.333-.649C12.675 1.058 12 1.742 12 2.57v7a1.5 1.5 0 001.5 1.5h7c.828 0 1.512-.675 1.388-1.495a10 10 0 00-6.061-7.744z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$11;
function _extends$16() {
  return _extends$16 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$16.apply(null, arguments);
}
function SvgCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$16({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/createElement("path", {
    d: "M4 12.314l5.657 5.657L20.97 6.657",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _rect$7, _rect2, _path$12;
function _extends$17() {
  return _extends$17 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$17.apply(null, arguments);
}
function SvgChip(props) {
  return /*#__PURE__*/createElement("svg", _extends$17({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$7 || (_rect$7 = /*#__PURE__*/createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6,
    rx: 0.5,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path$12 || (_path$12 = /*#__PURE__*/createElement("path", {
    d: "M15 1v3M23 9h-3M23 15h-3M4 9H1M4 15H1M9 1v3M15 20v3M9 20v3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$4, _defs$3;
function _extends$18() {
  return _extends$18 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$18.apply(null, arguments);
}
function SvgChrome(props) {
  return /*#__PURE__*/createElement("svg", _extends$18({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Chrome_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.435 23.994a11.991 11.991 0 0010.791-6.006A11.988 11.988 0 0024.302 8.5H17.07a5.513 5.513 0 01.523 6.248v.001a5.55 5.55 0 01-.287.446 1 1 0 01-.108.294l-4.763 8.505zm-2.144-.265l3.537-6.316a5.5 5.5 0 01-5.764-2.656l-.026-.042-.007-.013-.007-.013a5.56 5.56 0 01-.256-.517L2.72 5.52a11.99 11.99 0 00-.362 12.335l.08.133a11.994 11.994 0 004.41 4.411 11.99 11.99 0 003.442 1.33zM4.043 3.816a11.985 11.985 0 012.914-2.285A11.994 11.994 0 0112.832 0h.027a11.881 11.881 0 015.97 1.599A11.966 11.966 0 0123.493 6.5H12.79a5.5 5.5 0 00-2.657.703 5.478 5.478 0 00-2.454 2.847L4.043 3.816zM11.08 15.04a3.5 3.5 0 01-1.284-1.283.999.999 0 00-.107-.26l-.125-.214a3.5 3.5 0 013.26-4.782H12.838c.61 0 1.21.16 1.737.466a3.51 3.51 0 011.285 4.786 3.5 3.5 0 01-4.78 1.287z",
    fill: "currentColor"
  }))), _defs$3 || (_defs$3 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Chrome_svg__clip0"
  }, /*#__PURE__*/createElement("rect", {
    width: "2em",
    height: "2em",
    fill: "#fff",
    transform: "translate(.825)"
  })))));
}

var _circle$8, _path$13;
function _extends$19() {
  return _extends$19 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$19.apply(null, arguments);
}
function SvgCircleActionsAlertInfo(props) {
  return /*#__PURE__*/createElement("svg", _extends$19({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$8 || (_circle$8 = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$13 || (_path$13 = /*#__PURE__*/createElement("path", {
    d: "M12 7v5M12 16v.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$9, _path$14;
function _extends$1a() {
  return _extends$1a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1a.apply(null, arguments);
}
function SvgCircleActionsAlertQuestion(props) {
  return /*#__PURE__*/createElement("svg", _extends$1a({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$9 || (_circle$9 = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$14 || (_path$14 = /*#__PURE__*/createElement("path", {
    d: "M12 14v-.77c0-.994.763-1.813 1.613-2.326C14.434 10.41 15.22 9.53 15 8c-.429-3-4.5-1.5-4.5-1.5M12 17v.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$a, _path$15;
function _extends$1b() {
  return _extends$1b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1b.apply(null, arguments);
}
function SvgCircleActionsClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$1b({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$a || (_circle$a = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$15 || (_path$15 = /*#__PURE__*/createElement("path", {
    d: "M9 9l6 6M9 15l6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$b;
function _extends$1c() {
  return _extends$1c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1c.apply(null, arguments);
}
function SvgCircleActionsPlaceholder(props) {
  return /*#__PURE__*/createElement("svg", _extends$1c({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$b || (_circle$b = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _circle$c, _path$16;
function _extends$1d() {
  return _extends$1d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1d.apply(null, arguments);
}
function SvgCircleActionsSuccess(props) {
  return /*#__PURE__*/createElement("svg", _extends$1d({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$c || (_circle$c = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$16 || (_path$16 = /*#__PURE__*/createElement("path", {
    d: "M9 11.95l2.121 2.121 4.243-4.243",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$17;
function _extends$1e() {
  return _extends$1e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1e.apply(null, arguments);
}
function SvgCloseX(props) {
  return /*#__PURE__*/createElement("svg", _extends$1e({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/createElement("path", {
    d: "M6 6l12.774 12.774M6 18.774L18.774 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$18, _path2$s, _path3$6, _path4$3;
function _extends$1f() {
  return _extends$1f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1f.apply(null, arguments);
}
function SvgColorPalette(props) {
  return /*#__PURE__*/createElement("svg", _extends$1f({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$18 || (_path$18 = /*#__PURE__*/createElement("path", {
    d: "M11 7l2.586-2.586a2 2 0 012.828 0l3.521 3.521a2 2 0 01-.014 2.843L10 20.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$s || (_path2$s = /*#__PURE__*/createElement("path", {
    d: "M2 4a2 2 0 012-2h5a2 2 0 012 2v13.5A4.5 4.5 0 016.5 22v0A4.5 4.5 0 012 17.5V4z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$6 || (_path3$6 = /*#__PURE__*/createElement("path", {
    d: "M18 13h2a2 2 0 012 2v5a2 2 0 01-2 2H6.5",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4$3 || (_path4$3 = /*#__PURE__*/createElement("path", {
    d: "M7 17.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    stroke: "currentColor"
  })));
}

var _path$19;
function _extends$1g() {
  return _extends$1g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1g.apply(null, arguments);
}
function SvgComment(props) {
  return /*#__PURE__*/createElement("svg", _extends$1g({
    width: "1.083em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$19 || (_path$19 = /*#__PURE__*/createElement("path", {
    d: "M7.001 2a6 6 0 00-6 6v4c0 .24.014.477.042.71A1 1 0 001 13v8.826a1 1 0 001.65.759l4.788-4.104A2 2 0 018.74 18H19a6 6 0 006-6V8a6 6 0 00-6-6h-12z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1a;
function _extends$1h() {
  return _extends$1h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1h.apply(null, arguments);
}
function SvgComment1(props) {
  return /*#__PURE__*/createElement("svg", _extends$1h({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1a || (_path$1a = /*#__PURE__*/createElement("path", {
    d: "M9.77 4.684H4.23m3.693 2.763H4.231M1 2.842v9.697c0 .374.424.592.73.374l2.5-1.782h6.924c1.02 0 1.846-.825 1.846-1.842V2.842A1.844 1.844 0 0011.154 1H2.846C1.826 1 1 1.825 1 2.842z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$1b;
function _extends$1i() {
  return _extends$1i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1i.apply(null, arguments);
}
function SvgCommentRound(props) {
  return /*#__PURE__*/createElement("svg", _extends$1i({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1b || (_path$1b = /*#__PURE__*/createElement("path", {
    d: "M12.5 22C18.299 22 23 17.299 23 11.5S18.299 1 12.5 1 2 5.701 2 11.5c0 1.959.536 3.792 1.47 5.361L2 22l5.265-1.396A10.452 10.452 0 0012.5 22z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var _path$1c;
function _extends$1j() {
  return _extends$1j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1j.apply(null, arguments);
}
function SvgCommentWithLines(props) {
  return /*#__PURE__*/createElement("svg", _extends$1j({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1c || (_path$1c = /*#__PURE__*/createElement("path", {
    d: "M1 4.07H0h1zm20 0h-1 1zm0 10.745h1-1zM17.923 1v1-1zM4.077 1V0v1zm2.308 16.885v-1h-.32l-.26.186.58.814zm-4.169 2.97l-.58-.814.58.815zm15.707-2.97v-1 1zM15.615 8.14a1 1 0 100-2v2zm-9.23-2a1 1 0 000 2v-2zm6.154 6.605a1 1 0 000-2v2zm-6.154-2a1 1 0 100 2v-2zM0 4.07v16.161h2V4.07H0zm20 0v10.745h2V4.07h-2zM17.923 0H4.077v2h13.846V0zM5.804 17.07l-4.168 2.971 1.16 1.629 4.169-2.97-1.16-1.63zm12.12-.185H6.383v2h11.54v-2zM22 4.07C22 1.82 20.173 0 17.923 0v2C19.073 2 20 2.929 20 4.07h2zm-20 0C2 2.929 2.928 2 4.077 2V0A4.073 4.073 0 000 4.07h2zM0 20.231c0 1.441 1.629 2.271 2.797 1.439l-1.161-1.629a.23.23 0 01.364.19H0zm20-5.416c0 1.141-.928 2.07-2.077 2.07v2c2.25 0 4.077-1.82 4.077-4.07h-2zM15.615 6.14h-9.23v2h9.23v-2zm-3.076 4.605H6.385v2h6.154v-2z",
    fill: "currentColor"
  })));
}

var _circle$d, _path$1d;
function _extends$1k() {
  return _extends$1k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1k.apply(null, arguments);
}
function SvgCompass(props) {
  return /*#__PURE__*/createElement("svg", _extends$1k({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$d || (_circle$d = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1d || (_path$1d = /*#__PURE__*/createElement("path", {
    d: "M9.828 9.828l6.122-2.121-2.121 6.121-6.122 2.122 2.121-6.122z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1e;
function _extends$1l() {
  return _extends$1l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1l.apply(null, arguments);
}
function SvgComponent(props) {
  return /*#__PURE__*/createElement("svg", _extends$1l({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1e || (_path$1e = /*#__PURE__*/createElement("path", {
    d: "M3.002 4L12 1l8.998 3S21 7 21 13s-9 10-9 10-9-4-9-10 .002-9 .002-9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1f, _path2$t;
function _extends$1m() {
  return _extends$1m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1m.apply(null, arguments);
}
function SvgComponent1(props) {
  return /*#__PURE__*/createElement("svg", _extends$1m({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1f || (_path$1f = /*#__PURE__*/createElement("path", {
    d: "M12 1l10 6.444L12 13 2 7.444 12 1zM2 17l10 6 10-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$t || (_path2$t = /*#__PURE__*/createElement("path", {
    d: "M2 17.5v-10M22 17.5v-10M12 22v-9",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1g, _path2$u;
function _extends$1n() {
  return _extends$1n = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1n.apply(null, arguments);
}
function SvgComponent5(props) {
  return /*#__PURE__*/createElement("svg", _extends$1n({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1g || (_path$1g = /*#__PURE__*/createElement("path", {
    d: "M15.139 1s.861 1 0 2c-.862 1 0 2 0 2M10.139 1s.861 1 0 2c-.862 1 0 2 0 2M5.139 1s.861 1 0 2c-.862 1 0 2 0 2M16.794 11c2.391 0 4.185 0 4.783 1.143.802 1.533.598 4-1.794 5.143A27.217 27.217 0 0115 19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$u || (_path2$u = /*#__PURE__*/createElement("path", {
    d: "M3.934 10c-1.028 0-1.89.78-1.922 1.809-.026.87-.017 1.899.11 2.704.429 2.722 2.615 5.52 4.498 7.487h5.76c1.883-1.967 4.07-4.765 4.498-7.487.127-.805.137-1.833.11-2.704C16.957 10.78 16.094 10 15.066 10H3.934z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1h;
function _extends$1o() {
  return _extends$1o = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1o.apply(null, arguments);
}
function SvgComponent2(props) {
  return /*#__PURE__*/createElement("svg", _extends$1o({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1h || (_path$1h = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M1.849 12.05L11.899 2l10.05 10.05-10.05 10.05z"
  })));
}

var _path$1i, _circle$e, _circle2$3;
function _extends$1p() {
  return _extends$1p = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1p.apply(null, arguments);
}
function SvgConfigure(props) {
  return /*#__PURE__*/createElement("svg", _extends$1p({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1i || (_path$1i = /*#__PURE__*/createElement("path", {
    d: "M3 17h10M10 7h10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle$e || (_circle$e = /*#__PURE__*/createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2$3 || (_circle2$3 = /*#__PURE__*/createElement("circle", {
    cx: 6,
    cy: 7,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$8, _path$1j;
function _extends$1q() {
  return _extends$1q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1q.apply(null, arguments);
}
function SvgCopy(props) {
  return /*#__PURE__*/createElement("svg", _extends$1q({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$8 || (_rect$8 = /*#__PURE__*/createElement("rect", {
    x: 11,
    y: 10,
    width: 12,
    height: 13,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1j || (_path$1j = /*#__PURE__*/createElement("path", {
    d: "M13 4.714V4a3 3 0 00-3-3H4a3 3 0 00-3 3v7a3 3 0 003 3h2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1k;
function _extends$1r() {
  return _extends$1r = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1r.apply(null, arguments);
}
function SvgCursor(props) {
  return /*#__PURE__*/createElement("svg", _extends$1r({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1k || (_path$1k = /*#__PURE__*/createElement("path", {
    d: "M18.369 11.26L5.537 6.538 10.26 19.37l2.884-2.884 2.926 2.926 2.341-2.34-2.926-2.926 2.884-2.884z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1l;
function _extends$1s() {
  return _extends$1s = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1s.apply(null, arguments);
}
function SvgCursorPointer(props) {
  return /*#__PURE__*/createElement("svg", _extends$1s({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1l || (_path$1l = /*#__PURE__*/createElement("path", {
    d: "M18.5 9.5s.223-1 1.535-1C21.348 8.5 21.5 10 21.5 10v6s-.131 3-1.465 5c-1.333 2-5 2-5 2h-3.23s-1.596-.144-2.5-.5c-1.27-.5-2.27-2-2.27-2l-4.5-7.5s-1.368-1.909.27-3c1.637-1.091 3 .5 3 .5l2.23 3.5V2.5s.2-1.5 1.7-1.5S11.5 2.5 11.5 2.5v10.22V8.5s.326-1 1.736-1C14.645 7.5 15 9 15 9m3.5.5v3.22m0-3.22S18.035 8 16.735 8C15.435 8 15 9 15 9m0 0v3.72",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$f, _path$1m, _circle2$4;
function _extends$1t() {
  return _extends$1t = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1t.apply(null, arguments);
}
function SvgCut(props) {
  return /*#__PURE__*/createElement("svg", _extends$1t({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$f || (_circle$f = /*#__PURE__*/createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1m || (_path$1m = /*#__PURE__*/createElement("path", {
    d: "M8.151 8.304L21 21M8.151 15.65l3.382-3.34M14.846 9.036l6.086-6.014",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2$4 || (_circle2$4 = /*#__PURE__*/createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _ellipse, _path$1n, _path2$v;
function _extends$1u() {
  return _extends$1u = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1u.apply(null, arguments);
}
function SvgDatabase(props) {
  return /*#__PURE__*/createElement("svg", _extends$1u({
    width: ".909em",
    height: "1em",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/createElement("ellipse", {
    cx: 10,
    cy: 4,
    rx: 9,
    ry: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1n || (_path$1n = /*#__PURE__*/createElement("path", {
    d: "M19 11c0 1.657-4.03 3-9 3s-9-1.343-9-3M19 18c0 1.657-4.03 3-9 3s-9-1.343-9-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$v || (_path2$v = /*#__PURE__*/createElement("path", {
    d: "M1 4v14M19 4v14",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1o, _path2$w;
function _extends$1v() {
  return _extends$1v = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1v.apply(null, arguments);
}
function SvgDelete(props) {
  return /*#__PURE__*/createElement("svg", _extends$1v({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1o || (_path$1o = /*#__PURE__*/createElement("path", {
    d: "M3 5h18l-.663 13.25A5 5 0 0115.344 23H8.656a5 5 0 01-4.994-4.75L3 5zM7 5V4a3 3 0 013-3h4a3 3 0 013 3v1",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$w || (_path2$w = /*#__PURE__*/createElement("path", {
    d: "M1 5h22M15 11v5M9 11v5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$1p, _path2$x, _path3$7;
function _extends$1w() {
  return _extends$1w = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1w.apply(null, arguments);
}
function SvgDeviceDesktop(props) {
  return /*#__PURE__*/createElement("svg", _extends$1w({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1p || (_path$1p = /*#__PURE__*/createElement("path", {
    d: "M1 4.5c0-.276.218-.5.494-.5h21.01c.276 0 .496.224.496.5v11c0 .276-.22.5-.497.5H1.493A.495.495 0 011 15.5v-11z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$x || (_path2$x = /*#__PURE__*/createElement("path", {
    d: "M12 16v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/createElement("path", {
    d: "M15.619 21.924a1 1 0 10.762-1.848l-.762 1.848zm-8-1.848a1 1 0 10.762 1.848l-.762-1.848zM16 21c.381-.924.381-.925.38-.925h-.002l-.007-.004-.024-.01a19.769 19.769 0 00-.402-.154c-.265-.099-.635-.23-1.058-.362C14.072 19.291 12.95 19 12 19v2c.626 0 1.502.209 2.293.455a18.8 18.8 0 011.233.432l.072.03.017.006.004.002L16 21zm-4-2c-.949 0-2.072.291-2.888.545a20.821 20.821 0 00-1.483.526l-.007.003-.002.001L8 21l.381.925.004-.002.017-.007.072-.029a18.81 18.81 0 011.233-.433C10.497 21.21 11.374 21 12 21v-2z",
    fill: "currentColor"
  })));
}

var _path$1q, _path2$y;
function _extends$1x() {
  return _extends$1x = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1x.apply(null, arguments);
}
function SvgDeviceLaptop(props) {
  return /*#__PURE__*/createElement("svg", _extends$1x({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1q || (_path$1q = /*#__PURE__*/createElement("path", {
    d: "M1 6a2 2 0 012-2h18a2 2 0 012 2v10.444A3.556 3.556 0 0119.444 20H4.556A3.556 3.556 0 011 16.444v0V6z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$y || (_path2$y = /*#__PURE__*/createElement("path", {
    d: "M1 15h6.171c.845 0 1.648.364 2.204 1v0c.556.636 1.36 1 2.204 1h1.171a2.5 2.5 0 002-1v0a2.5 2.5 0 012-1H23",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$9, _path$1r;
function _extends$1y() {
  return _extends$1y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1y.apply(null, arguments);
}
function SvgDeviceMouse(props) {
  return /*#__PURE__*/createElement("svg", _extends$1y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$9 || (_rect$9 = /*#__PURE__*/createElement("rect", {
    x: 6,
    y: 2,
    width: 12,
    height: 20,
    rx: 6,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1r || (_path$1r = /*#__PURE__*/createElement("path", {
    d: "M12 9V8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _rect$a, _path$1s;
function _extends$1z() {
  return _extends$1z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1z.apply(null, arguments);
}
function SvgDevicePhone(props) {
  return /*#__PURE__*/createElement("svg", _extends$1z({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$a || (_rect$a = /*#__PURE__*/createElement("rect", {
    x: 5,
    y: 1,
    width: 14,
    height: 22,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1s || (_path$1s = /*#__PURE__*/createElement("path", {
    d: "M11 19h2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _rect$b, _path$1t;
function _extends$1A() {
  return _extends$1A = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1A.apply(null, arguments);
}
function SvgDeviceTablet(props) {
  return /*#__PURE__*/createElement("svg", _extends$1A({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$b || (_rect$b = /*#__PURE__*/createElement("rect", {
    x: 2,
    y: 1,
    width: ".909em",
    height: "1em",
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1t || (_path$1t = /*#__PURE__*/createElement("path", {
    d: "M11 19h2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _rect$c, _path$1u, _path2$z;
function _extends$1B() {
  return _extends$1B = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1B.apply(null, arguments);
}
function SvgDeviceWatch(props) {
  return /*#__PURE__*/createElement("svg", _extends$1B({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$c || (_rect$c = /*#__PURE__*/createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path$1u || (_path$1u = /*#__PURE__*/createElement("path", {
    d: "M7.095 2.837A2.5 2.5 0 019.505 1h4.99a2.5 2.5 0 012.41 1.837L17.5 5h-11l.595-2.163zM6.5 19h11l-.595 2.163A2.5 2.5 0 0114.495 23h-4.99a2.5 2.5 0 01-2.41-1.837L6.5 19z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2$z || (_path2$z = /*#__PURE__*/createElement("path", {
    d: "M12 9v3.5l2 1.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1v;
function _extends$1C() {
  return _extends$1C = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1C.apply(null, arguments);
}
function SvgDiamond(props) {
  return /*#__PURE__*/createElement("svg", _extends$1C({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1v || (_path$1v = /*#__PURE__*/createElement("path", {
    d: "M1.002 9L5 2h14l3.998 7L12 22 1.002 9zM1 9h22M8 9l1-7M16 9l-1-7M12 22L8 9M12 22l4-13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$g, _path$1w;
function _extends$1D() {
  return _extends$1D = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1D.apply(null, arguments);
}
function SvgDisabled(props) {
  return /*#__PURE__*/createElement("svg", _extends$1D({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$g || (_circle$g = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1w || (_path$1w = /*#__PURE__*/createElement("path", {
    d: "M19.768 4.647l-15 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1x, _path2$A;
function _extends$1E() {
  return _extends$1E = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1E.apply(null, arguments);
}
function SvgDiscover(props) {
  return /*#__PURE__*/createElement("svg", _extends$1E({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1x || (_path$1x = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.32 9.799c.884 0 1.37.409 1.37 1.181.045.59-.353 1.09-.883 1.181L24 13.844h-.928l-1.017-1.636h-.088v1.636h-.752V9.799h1.105zm-.353 1.863h.22c.487 0 .708-.228.708-.637 0-.363-.22-.59-.707-.59h-.221v1.226zm-3.36 2.18h2.122v-.681h-1.37v-1.09h1.326v-.682h-1.326v-.909h1.37V9.8h-2.121v4.044zm-2.21-1.317l-1.016-2.726h-.795l1.635 4.134h.398L18.254 9.8h-.795l-1.061 2.726zm-8.972-.682c0 1.136.884 2.09 1.99 2.09.353 0 .662-.09.972-.227v-.909c-.221.273-.53.455-.884.455A1.262 1.262 0 018.22 11.98v-.091A1.346 1.346 0 019.46 10.48c.353 0 .707.182.928.455v-.909c-.265-.182-.619-.227-.928-.227-1.15-.091-2.034.863-2.034 2.044zm-1.37-.5c-.442-.181-.574-.272-.574-.5.044-.272.265-.499.53-.454.221 0 .442.137.619.319l.398-.546c-.31-.272-.708-.454-1.105-.454-.62-.045-1.15.454-1.194 1.09v.046c0 .545.221.863.928 1.09.177.046.354.137.53.228a.48.48 0 01.222.408c0 .318-.265.591-.53.591h-.045a.873.873 0 01-.795-.545l-.487.5c.266.5.796.772 1.326.772.708.046 1.282-.5 1.326-1.227v-.136c-.044-.545-.265-.818-1.149-1.181zm-2.563 2.5h.751V9.799h-.751v4.044zM0 9.799h1.326c1.06.045 1.9.954 1.856 2.044 0 .591-.265 1.136-.707 1.545-.398.318-.884.5-1.37.455H0V9.799zm.972 3.362c.354.045.752-.091 1.017-.318.265-.273.398-.636.398-1.045a1.43 1.43 0 00-.398-1 1.374 1.374 0 00-1.017-.318h-.22v2.68h.22z",
    fill: "currentColor"
  })), _path2$A || (_path2$A = /*#__PURE__*/createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.979 10C11.902 10 11 10.86 11 11.978c0 1.075.86 1.978 1.979 2.02 1.118.043 1.978-.86 2.021-1.977-.043-1.118-.903-2.021-2.021-2.021z",
    fill: "currentColor"
  })));
}

var _path$1y;
function _extends$1F() {
  return _extends$1F = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1F.apply(null, arguments);
}
function SvgDollar(props) {
  return /*#__PURE__*/createElement("svg", _extends$1F({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1y || (_path$1y = /*#__PURE__*/createElement("path", {
    d: "M17.25 7.096s-.656-3.18-5.25-3.18-5.813 1.928-5.907 3.256C6 8.5 6 11.5 12 11.5s6 3.5 6 4-.093 4.32-6 4.32-5.907-3.182-5.907-3.182M12 1v22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1z;
function _extends$1G() {
  return _extends$1G = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1G.apply(null, arguments);
}
function SvgDoordash(props) {
  return /*#__PURE__*/createElement("svg", _extends$1G({
    width: "1.785em",
    height: "1em",
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1z || (_path$1z = /*#__PURE__*/createElement("path", {
    d: "M17.956 0a6.102 6.102 0 015.398 3.185v-.002c2.73 5.12-.965 10.276-5.853 10.276h-3.757c-.465 0-.912-.182-1.242-.51L8.776 9.253a.575.575 0 01.091-.892.588.588 0 01.325-.098h8.306a1.542 1.542 0 001.538-1.549 1.544 1.544 0 00-1.57-1.518H5.418c-.466 0-.913-.183-1.242-.51L.453.991A.575.575 0 01.542.099.588.588 0 01.866 0h17.09z",
    fill: "currentColor"
  })));
}

var _path$1A, _path2$B;
function _extends$1H() {
  return _extends$1H = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1H.apply(null, arguments);
}
function SvgDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$1H({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1A || (_path$1A = /*#__PURE__*/createElement("path", {
    d: "M2.5 12C2 10.5 2 9 2 7.956 2 4.478 5.114 1 8.956 1a6.954 6.954 0 016.026 3.478h.93C18.795 4.478 21.5 6.5 21.5 9c0 1 0 2-.5 3M7.417 18.331L11.5 22.25l4.083-3.919",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$B || (_path2$B = /*#__PURE__*/createElement("path", {
    d: "M11.5 21.22V10.124",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$1B;
function _extends$1I() {
  return _extends$1I = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1I.apply(null, arguments);
}
function SvgDribbble(props) {
  return /*#__PURE__*/createElement("svg", _extends$1I({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1B || (_path$1B = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.375 0 0 5.375 0 12s5.375 12 12 12c6.612 0 12-5.375 12-12S18.612 0 12 0zm7.926 5.531a10.202 10.202 0 012.317 6.378c-.338-.065-3.722-.755-7.132-.325-.079-.17-.144-.352-.222-.534a30.53 30.53 0 00-.676-1.484c3.774-1.536 5.492-3.748 5.713-4.035zM12 1.771c2.603 0 4.985.975 6.794 2.576-.182.26-1.731 2.33-5.375 3.696-1.68-3.084-3.54-5.61-3.827-6A10.424 10.424 0 0112 1.77zm-4.36.962c.273.365 2.095 2.903 3.8 5.922-4.79 1.276-9.02 1.25-9.475 1.25.664-3.176 2.812-5.818 5.675-7.172zm-5.896 9.28v-.312c.443.013 5.414.078 10.53-1.458.299.573.572 1.158.832 1.744-.13.039-.273.078-.403.117-5.284 1.705-8.096 6.364-8.33 6.755a10.226 10.226 0 01-2.629-6.846zM12 22.256c-2.369 0-4.555-.807-6.286-2.16.182-.378 2.264-4.387 8.043-6.404.026-.013.04-.013.065-.026 1.445 3.735 2.03 6.872 2.187 7.77-1.237.534-2.59.82-4.009.82zm5.714-1.757c-.104-.625-.651-3.618-1.992-7.302 3.215-.507 6.026.326 6.378.443-.443 2.85-2.083 5.31-4.386 6.859z",
    fill: "currentColor"
  })));
}

var _rect$d, _circle$h, _path$1C;
function _extends$1J() {
  return _extends$1J = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1J.apply(null, arguments);
}
function SvgDryer(props) {
  return /*#__PURE__*/createElement("svg", _extends$1J({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$d || (_rect$d = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle$h || (_circle$h = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 13,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1C || (_path$1C = /*#__PURE__*/createElement("path", {
    d: "M4.5 4.5h1M11.551 10.325s-.223 1.27 1.533 1.298c1.756.027 1.533 1.298 1.533 1.298M9.383 13.079s-.223 1.271 1.533 1.298c1.757.027 1.533 1.298 1.533 1.298",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1D, _path2$C;
function _extends$1K() {
  return _extends$1K = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1K.apply(null, arguments);
}
function SvgEdit(props) {
  return /*#__PURE__*/createElement("svg", _extends$1K({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1D || (_path$1D = /*#__PURE__*/createElement("path", {
    d: "M3.551 15.662L17.552 1.66a3.42 3.42 0 01.966-.155c.667-.01 1.547.175 2.402 1.03.855.854 1.039 1.735 1.03 2.4a3.42 3.42 0 01-.155.967L7.794 19.904l-4.821.579.578-4.821z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$C || (_path2$C = /*#__PURE__*/createElement("path", {
    d: "M14.267 3.532l5.388 5.387",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _circle$i, _path$1E;
function _extends$1L() {
  return _extends$1L = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1L.apply(null, arguments);
}
function SvgEmojiHappySmile(props) {
  return /*#__PURE__*/createElement("svg", _extends$1L({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$i || (_circle$i = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1E || (_path$1E = /*#__PURE__*/createElement("path", {
    d: "M8 15s1.714 1.5 4 1.5 4-1.5 4-1.5M8 9h.25M16 9h.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$j, _path$1F;
function _extends$1M() {
  return _extends$1M = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1M.apply(null, arguments);
}
function SvgEmojiSadFrown(props) {
  return /*#__PURE__*/createElement("svg", _extends$1M({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$j || (_circle$j = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1F || (_path$1F = /*#__PURE__*/createElement("path", {
    d: "M8 16.5S9.714 15 12 15s4 1.5 4 1.5M8 9h.25M16 9h.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1G;
function _extends$1N() {
  return _extends$1N = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1N.apply(null, arguments);
}
function SvgExchangeTransfer(props) {
  return /*#__PURE__*/createElement("svg", _extends$1N({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1G || (_path$1G = /*#__PURE__*/createElement("path", {
    d: "M3 8h18l-6-6M21 16H3l6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1H, _path2$D, _path3$8;
function _extends$1O() {
  return _extends$1O = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1O.apply(null, arguments);
}
function SvgExport(props) {
  return /*#__PURE__*/createElement("svg", _extends$1O({
    width: ".96em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1H || (_path$1H = /*#__PURE__*/createElement("path", {
    d: "M16.89 6.555L11.73 1.36 6.57 6.555",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$D || (_path2$D = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M11.729 2.26v11"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/createElement("path", {
    d: "M3 13v5a5 5 0 005 5h7a5 5 0 005-5v-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1I;
function _extends$1P() {
  return _extends$1P = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1P.apply(null, arguments);
}
function SvgFacebook(props) {
  return /*#__PURE__*/createElement("svg", _extends$1P({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1I || (_path$1I = /*#__PURE__*/createElement("path", {
    d: "M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H15.83c-1.491 0-1.956.93-1.956 1.887v2.263h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z",
    fill: "currentColor"
  })));
}

var _circle$k, _path$1J, _path2$E, _path3$9;
function _extends$1Q() {
  return _extends$1Q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1Q.apply(null, arguments);
}
function SvgFastGage(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Q({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$k || (_circle$k = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$1J || (_path$1J = /*#__PURE__*/createElement("path", {
    d: "M11.342 15.638L13.394 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$E || (_path2$E = /*#__PURE__*/createElement("path", {
    d: "M12 1v2M23 12h-2M3 12H1M5 4l1.414 1.414M19.414 4L18 5.414",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$9 || (_path3$9 = /*#__PURE__*/createElement("path", {
    d: "M3.5 19S6 16 12 16s8.5 3 8.5 3",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1K;
function _extends$1R() {
  return _extends$1R = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1R.apply(null, arguments);
}
function SvgFeather(props) {
  return /*#__PURE__*/createElement("svg", _extends$1R({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1K || (_path$1K = /*#__PURE__*/createElement("path", {
    d: "M4.647 11.353l8.235-8.235a5.823 5.823 0 018.236 0v0a5.823 5.823 0 010 8.235l-8.236 8.235L5.235 19l-.588-7.647zM9.941 14.294h8.236M1.118 23.118L15.235 9",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$e, _rect2$1, _rect3, _rect4, _rect5, _rect6;
function _extends$1S() {
  return _extends$1S = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1S.apply(null, arguments);
}
function SvgFeedList(props) {
  return /*#__PURE__*/createElement("svg", _extends$1S({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$e || (_rect$e = /*#__PURE__*/createElement("rect", {
    x: 2.997,
    y: 2,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2$1 || (_rect2$1 = /*#__PURE__*/createElement("rect", {
    x: 2.997,
    y: 10,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/createElement("rect", {
    x: 10.997,
    y: 10,
    width: 12,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/createElement("rect", {
    x: 10.997,
    y: 2,
    width: 12,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/createElement("rect", {
    x: 10.997,
    y: 18,
    width: 12,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/createElement("rect", {
    x: 2.997,
    y: 18,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1L;
function _extends$1T() {
  return _extends$1T = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1T.apply(null, arguments);
}
function SvgFigma(props) {
  return /*#__PURE__*/createElement("svg", _extends$1T({
    width: ".92em",
    height: "1em",
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1L || (_path$1L = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16.25a5.071 5.071 0 00-3.31 8.91A5.059 5.059 0 003.09 13a5.06 5.06 0 001.76 3.84 5.071 5.071 0 003.31 8.91 5.071 5.071 0 005.07-5.07v-3.333a5.071 5.071 0 005.92-8.187A5.071 5.071 0 0015.84.25H8.16zM5.55 5.32c0-1.44 1.17-2.61 2.61-2.61h2.61v5.22H8.15a2.611 2.611 0 01-2.6-2.61zm7.68 2.61V2.71h2.61c1.44 0 2.61 1.17 2.61 2.61a2.611 2.611 0 01-2.602 2.61H13.23zM5.55 13a2.611 2.611 0 012.602-2.61h2.618v5.22H8.16c-1.44 0-2.61-1.17-2.61-2.61zm10.29-2.61h.01a2.611 2.611 0 012.6 2.61c0 1.44-1.17 2.61-2.61 2.61a2.611 2.611 0 01-2.61-2.574v-.072a2.611 2.611 0 012.598-2.574h.012zM5.55 20.68c0-1.44 1.17-2.61 2.61-2.61h2.61v2.61c0 1.44-1.17 2.61-2.61 2.61s-2.61-1.17-2.61-2.61z",
    fill: "currentColor"
  })));
}

var _path$1M, _path2$F;
function _extends$1U() {
  return _extends$1U = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1U.apply(null, arguments);
}
function SvgFile(props) {
  return /*#__PURE__*/createElement("svg", _extends$1U({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1M || (_path$1M = /*#__PURE__*/createElement("path", {
    d: "M4 4a2 2 0 012-2h3.421a3 3 0 013 3v2.5a2.5 2.5 0 002.5 2.5H17a3 3 0 013 3v7a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$F || (_path2$F = /*#__PURE__*/createElement("path", {
    d: "M4 4a2 2 0 012-2h3.234a8 8 0 016.12 2.847l2.765 3.285A8 8 0 0120 13.285V20a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$1N, _path2$G;
function _extends$1V() {
  return _extends$1V = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1V.apply(null, arguments);
}
function SvgFileStructure(props) {
  return /*#__PURE__*/createElement("svg", _extends$1V({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1N || (_path$1N = /*#__PURE__*/createElement("path", {
    d: "M13 3a1 1 0 011-1h1.688a1 1 0 01.772.364l2.312 2.809a1 1 0 01.228.635V9a1 1 0 01-1 1h-4a1 1 0 01-1-1V3zM13 16a1 1 0 011-1h1.688a1 1 0 01.772.364l2.312 2.809a1 1 0 01.228.635V22a1 1 0 01-1 1h-4a1 1 0 01-1-1v-6z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$G || (_path2$G = /*#__PURE__*/createElement("path", {
    d: "M4 1v4.5m4.5 13H4v-13m0 0h4.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1O;
function _extends$1W() {
  return _extends$1W = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1W.apply(null, arguments);
}
function SvgFilledAleritInfo(props) {
  return /*#__PURE__*/createElement("svg", _extends$1W({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1O || (_path$1O = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-17a1 1 0 011 1v5a1 1 0 11-2 0V7a1 1 0 011-1zm0 9a1 1 0 011 1v.5a1 1 0 11-2 0V16a1 1 0 011-1z",
    fill: "currentColor"
  })));
}

var _path$1P;
function _extends$1X() {
  return _extends$1X = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1X.apply(null, arguments);
}
function SvgFilledAlertQuestion(props) {
  return /*#__PURE__*/createElement("svg", _extends$1X({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1P || (_path$1P = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm.482-17c-.867 0-1.655.319-2.178.59a6.717 6.717 0 00-.897.56l-.017.014-.006.005-.002.001-.001.001.619.785-.62-.784a1 1 0 001.237 1.57l.004-.002.026-.02a4.715 4.715 0 01.577-.355c.4-.206.852-.365 1.257-.365.896 0 1.408.49 1.493 1.06.076.515-.026.857-.171 1.101-.157.263-.407.484-.719.665-.94.546-2.099 1.591-2.099 3.09v.258a1 1 0 102 0v-.259c0-.402.355-.925 1.104-1.36.504-.292 1.05-.729 1.432-1.37.393-.66.572-1.47.431-2.419C15.69 6.996 14.13 6 12.482 6zm.503 11.522a1 1 0 00-2 0V18a1 1 0 102 0v-.478z",
    fill: "currentColor"
  })));
}

var _path$1Q;
function _extends$1Y() {
  return _extends$1Y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1Y.apply(null, arguments);
}
function SvgFilledBackspace(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.488 4.264A3 3 0 017.935 3H20a3 3 0 013 3v12a3 3 0 01-3 3H7.935a3 3 0 01-2.447-1.264L.82 13.157a2 2 0 010-2.314l4.667-6.579zm3.805 4.029a1 1 0 011.414 0L13 10.586l2.293-2.293a1 1 0 111.414 1.414L14.414 12l2.293 2.293a1 1 0 01-1.414 1.414L13 13.414l-2.293 2.293a1 1 0 01-1.414-1.414L11.586 12 9.293 9.707a1 1 0 010-1.414z",
    fill: "currentColor"
  })));
}

var _path$1R;
function _extends$1Z() {
  return _extends$1Z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1Z.apply(null, arguments);
}
function SvgFilledBag(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Z({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1R || (_path$1R = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.464 4.444l-.046.056h19.164a1.866 1.866 0 00-.046-.056l-2.27-2.724A2 2 0 0017.73 1H6.27a2 2 0 00-1.536.72l-2.27 2.724zM2 20V6.5h20V20a3 3 0 01-3 3H5a3 3 0 01-3-3zm7-10a1 1 0 10-2 0 5 5 0 0010 0 1 1 0 10-2 0 3 3 0 11-6 0z",
    fill: "currentColor"
  })));
}

var _path$1S;
function _extends$1_() {
  return _extends$1_ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1_.apply(null, arguments);
}
function SvgFilledCart(props) {
  return /*#__PURE__*/createElement("svg", _extends$1_({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1S || (_path$1S = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1a1 1 0 000 2h2.396a1 1 0 01.976.783l.648 2.915 1.1 6.054a7 7 0 006.888 5.748h2.703a7 7 0 006.826-5.449l1.022-4.497A2.5 2.5 0 0021.12 5.5H6.802l-.478-2.15A3 3 0 003.396 1H1zM8.5 20a2 2 0 100 4 2 2 0 000-4zm12 0a2 2 0 100 4 2 2 0 000-4z",
    fill: "currentColor"
  })));
}

var _path$1T;
function _extends$1$() {
  return _extends$1$ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1$.apply(null, arguments);
}
function SvgFilledClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$1$({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1T || (_path$1T = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm-3.707-7.293a1 1 0 010-1.414L10.586 12 8.293 9.707a1 1 0 011.414-1.414L12 10.586l2.293-2.293a1 1 0 111.414 1.414L13.414 12l2.293 2.293a1 1 0 01-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 01-1.414 0z",
    fill: "currentColor"
  })));
}

var _path$1U;
function _extends$20() {
  return _extends$20 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$20.apply(null, arguments);
}
function SvgFilledEdit(props) {
  return /*#__PURE__*/createElement("svg", _extends$20({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1U || (_path$1U = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.799 1.323C17.644-.832 15.171.294 15.171.294L13.146 2.32l5.657 5.657 2.024-2.025s1.127-2.473-1.028-4.628zm-2.41 8.067l-5.657-5.657-10.96 10.96L0 21.123l6.428-.772 10.96-10.96z",
    fill: "currentColor"
  })));
}

var _path$1V;
function _extends$21() {
  return _extends$21 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$21.apply(null, arguments);
}
function SvgFilledFolder(props) {
  return /*#__PURE__*/createElement("svg", _extends$21({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1V || (_path$1V = /*#__PURE__*/createElement("path", {
    d: "M1 7a3 3 0 013-3h4.39a3 3 0 011.953.722l1.814 1.556A3 3 0 0014.11 7H20a3 3 0 013 3v8a3 3 0 01-3 3H4a3 3 0 01-3-3V7z",
    fill: "currentColor"
  })));
}

var _path$1W;
function _extends$22() {
  return _extends$22 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$22.apply(null, arguments);
}
function SvgFilledHeart(props) {
  return /*#__PURE__*/createElement("svg", _extends$22({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1W || (_path$1W = /*#__PURE__*/createElement("path", {
    d: "M2.31 3.143a5.042 5.042 0 000 7.131l7.637 7.637.053-.052.053.052 7.637-7.637a5.042 5.042 0 10-7.13-7.13l-.265.264a.417.417 0 01-.59 0l-.264-.265a5.042 5.042 0 00-7.131 0z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$1X;
function _extends$23() {
  return _extends$23 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$23.apply(null, arguments);
}
function SvgFilledHome(props) {
  return /*#__PURE__*/createElement("svg", _extends$23({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1X || (_path$1X = /*#__PURE__*/createElement("path", {
    d: "M2 9.88a3 3 0 011.221-2.416L12 1l8.779 6.464A3 3 0 0122 9.88V20.5a2.5 2.5 0 01-2.5 2.5H16a1 1 0 01-1-1v-6a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v6a1 1 0 01-1 1H4.5A2.5 2.5 0 012 20.5V9.88z",
    fill: "currentColor"
  })));
}

var _path$1Y;
function _extends$24() {
  return _extends$24 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$24.apply(null, arguments);
}
function SvgFilledLocation(props) {
  return /*#__PURE__*/createElement("svg", _extends$24({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.169 23.073C15.808 20.903 22 15.346 22 11c0-5.523-4.477-10-10-10S2 5.477 2 11c0 4.346 6.192 9.902 8.831 12.073a1.828 1.828 0 002.338 0zM12 14a3 3 0 100-6 3 3 0 000 6z",
    fill: "currentColor"
  })));
}

var _path$1Z;
function _extends$25() {
  return _extends$25 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$25.apply(null, arguments);
}
function SvgFilledProfile(props) {
  return /*#__PURE__*/createElement("svg", _extends$25({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/createElement("path", {
    d: "M18.95 18.38c-1.572-.813-4.165-1.88-6.95-1.88s-5.378 1.067-6.95 1.88c-1.016.525-1.627 1.555-1.762 2.69L3 23.5h18l-.288-2.43c-.135-1.135-.746-2.165-1.761-2.69zM12 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: "currentColor"
  })));
}

var _path$1_;
function _extends$26() {
  return _extends$26 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$26.apply(null, arguments);
}
function SvgFilledSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$26({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11c2.315 0 4.463-.715 6.235-1.936l2.35 2.35a2 2 0 102.83-2.828l-2.351-2.351A10.949 10.949 0 0022 11c0-6.075-4.925-11-11-11zM4 11a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: "currentColor"
  })));
}

var _path$1$;
function _extends$27() {
  return _extends$27 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$27.apply(null, arguments);
}
function SvgFilledSettings(props) {
  return /*#__PURE__*/createElement("svg", _extends$27({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.716 1.863c-.777-1.296-2.655-1.296-3.431 0l-.706 1.178a2 2 0 01-2.202.912l-1.332-.334c-1.465-.367-2.793.96-2.426 2.426l.334 1.332A2 2 0 013.04 9.58l-1.178.706c-1.296.776-1.296 2.654 0 3.43l1.178.707a2 2 0 01.912 2.201l-.334 1.332c-.367 1.466.96 2.794 2.426 2.426l1.332-.334a2 2 0 012.202.912l.705 1.178c.777 1.296 2.655 1.296 3.432 0l.705-1.178a2 2 0 012.202-.912l1.332.334c1.466.367 2.793-.96 2.426-2.426l-.334-1.332a2 2 0 01.912-2.202l1.178-.705c1.296-.777 1.296-2.655 0-3.431l-1.178-.706a2 2 0 01-.912-2.202l.334-1.332c.367-1.465-.96-2.793-2.426-2.426l-1.332.334a2 2 0 01-2.202-.912l-.705-1.178zM12 16a4 4 0 100-8 4 4 0 000 8z",
    fill: "currentColor"
  })));
}

var _path$20;
function _extends$28() {
  return _extends$28 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$28.apply(null, arguments);
}
function SvgFilledStar(props) {
  return /*#__PURE__*/createElement("svg", _extends$28({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$20 || (_path$20 = /*#__PURE__*/createElement("path", {
    d: "M11.308 2.658a.75.75 0 011.384 0l2.202 5.274a.75.75 0 00.591.454l5.803.785a.75.75 0 01.373 1.325l-4.48 3.656a.75.75 0 00-.257.75l1.433 6.19c.155.67-.599 1.178-1.162.783l-4.764-3.344a.75.75 0 00-.862 0l-4.764 3.344c-.563.395-1.317-.113-1.162-.783l1.432-6.19a.75.75 0 00-.256-.75l-4.48-3.656a.75.75 0 01.373-1.325l5.803-.785a.75.75 0 00.591-.454l2.202-5.274z",
    fill: "currentColor"
  })));
}

var _path$21;
function _extends$29() {
  return _extends$29 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$29.apply(null, arguments);
}
function SvgFilledSuccess(props) {
  return /*#__PURE__*/createElement("svg", _extends$29({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$21 || (_path$21 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zM9.707 11.243a1 1 0 00-1.414 1.414l2.121 2.121.707.707.707-.707 4.243-4.242a1 1 0 00-1.414-1.415l-3.536 3.536-1.414-1.414z",
    fill: "currentColor"
  })));
}

var _path$22;
function _extends$2a() {
  return _extends$2a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2a.apply(null, arguments);
}
function SvgFilledThumbsUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$2a({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$22 || (_path$22 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11a3 3 0 00-3 3v6a3 3 0 003 3h1V11H3zm3-1.178V23h10.737a3 3 0 002.885-2.176l2.285-8A3 3 0 0019.023 9h-4.4a1.5 1.5 0 01-1.49-1.675l.371-3.16A2.835 2.835 0 0010.688 1c-.569 0-1.082.34-1.305.863l-3.365 7.92a2.018 2.018 0 01-.018.04z",
    fill: "currentColor"
  })));
}

var _path$23;
function _extends$2b() {
  return _extends$2b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2b.apply(null, arguments);
}
function SvgFilledThumbsUp1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2b({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$23 || (_path$23 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13a3 3 0 01-3-3V4a3 3 0 013-3h1v12H3zm3 1.178V1h10.737a3 3 0 012.885 2.176l2.285 8A3 3 0 0119.023 15h-4.4a1.5 1.5 0 00-1.49 1.675l.371 3.16A2.835 2.835 0 0110.688 23c-.569 0-1.082-.34-1.305-.863l-3.365-7.92a1.94 1.94 0 00-.018-.04z",
    fill: "currentColor"
  })));
}

var _circle$l, _circle2$5, _path$24, _path2$H;
function _extends$2c() {
  return _extends$2c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2c.apply(null, arguments);
}
function SvgFilledTwoPeople(props) {
  return /*#__PURE__*/createElement("svg", _extends$2c({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$l || (_circle$l = /*#__PURE__*/createElement("circle", {
    cx: 7,
    cy: 6,
    r: 4,
    fill: "currentColor"
  })), _circle2$5 || (_circle2$5 = /*#__PURE__*/createElement("circle", {
    cx: 17,
    cy: 8,
    r: 4,
    fill: "currentColor"
  })), _path$24 || (_path$24 = /*#__PURE__*/createElement("path", {
    d: "M0 18a6 6 0 016-6h2a6 6 0 016 6v3H0v-3z",
    fill: "currentColor"
  })), _path2$H || (_path2$H = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15c1 1 1 2.238 1 3v3h9v-1a6 6 0 00-6-6h-1.332c-1.526 0-2.168.5-2.668 1z",
    fill: "currentColor"
  })));
}

var _g$5, _defs$4;
function _extends$2d() {
  return _extends$2d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2d.apply(null, arguments);
}
function SvgFirefoxBrowser(props) {
  return /*#__PURE__*/createElement("svg", _extends$2d({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#FirefoxBrowser_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M23.62 8.051c-.503-1.216-1.524-2.529-2.323-2.944.57 1.11.965 2.3 1.173 3.53v.012l.002.012a10.578 10.578 0 01-.36 7.85c-1.328 2.861-4.54 5.793-9.57 5.65-5.433-.154-10.218-4.204-11.112-9.508-.163-.837 0-1.26.082-1.94a8.703 8.703 0 00-.187 1.605v.06A11.661 11.661 0 004.38 20.24a11.544 11.544 0 0015.603 1.335 11.641 11.641 0 004.335-7.23c.02-.15.036-.299.053-.45a12.01 12.01 0 00-.751-5.844z"
  }), /*#__PURE__*/createElement("path", {
    d: "M23.62 8.051c-.503-1.216-1.524-2.529-2.323-2.944.57 1.11.965 2.3 1.173 3.53v.012l.002.012a10.578 10.578 0 01-.36 7.85c-1.328 2.861-4.54 5.793-9.57 5.65-5.433-.154-10.218-4.204-11.112-9.508-.163-.837 0-1.26.082-1.94a8.703 8.703 0 00-.187 1.605v.06A11.661 11.661 0 004.38 20.24a11.544 11.544 0 0015.603 1.335 11.641 11.641 0 004.335-7.23c.02-.15.036-.299.053-.45a12.01 12.01 0 00-.751-5.844z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.992 9.419c.026.017.049.035.072.053a6.329 6.329 0 00-1.075-1.41c-3.6-3.615-.943-7.84-.495-8.054l.004-.006c-2.909 1.71-3.896 4.877-3.987 6.461.136-.01.27-.02.407-.02a5.824 5.824 0 012.937.8 5.858 5.858 0 012.137 2.176zM8.785 7.31c.093.06.17.112.239.16a5.416 5.416 0 01-.033-2.844A8.582 8.582 0 006.204 6.79c.056-.001 1.736-.031 2.58.52z"
  }), /*#__PURE__*/createElement("path", {
    d: "M1.431 12.653c.894 5.304 5.68 9.354 11.113 9.509 5.029.143 8.242-2.79 9.569-5.65a10.578 10.578 0 00.36-7.85V8.65c0-.008-.002-.014 0-.01l.002.019c.411 2.694-.953 5.304-3.086 7.069l-.006.015c-4.156 3.4-8.133 2.051-8.938 1.5a6.305 6.305 0 01-.168-.084c-2.423-1.163-3.424-3.38-3.21-5.282a2.963 2.963 0 01-1.627-.458 2.982 2.982 0 01-1.116-1.275 4.354 4.354 0 014.258-.172 5.743 5.743 0 004.348.172c-.005-.095-2.02-.9-2.806-1.678-.42-.415-.62-.616-.796-.766a3.463 3.463 0 00-.299-.227 16.242 16.242 0 00-.239-.16c-.844-.551-2.524-.521-2.58-.52h-.005c-.459-.584-.427-2.51-.4-2.913a2.067 2.067 0 00-.387.206c-.405.29-.784.616-1.132.974-.398.402-.761.838-1.087 1.301a9.844 9.844 0 00-1.554 3.525c-.005.023-.417 1.83-.214 2.767z"
  }), /*#__PURE__*/createElement("path", {
    d: "M16.989 8.063a6.33 6.33 0 011.076 1.41c.064.049.123.097.174.143 2.625 2.431 1.25 5.868 1.147 6.112 2.133-1.765 3.496-4.375 3.086-7.07-1.31-3.28-3.53-4.602-5.343-7.48a14.318 14.318 0 01-.273-.446 3.698 3.698 0 01-.128-.24 2.127 2.127 0 01-.18-.48.03.03 0 00-.019-.01.041.041 0 00-.021 0l-.006.003-.008.004c-.448.214-3.105 4.438.495 8.054z"
  }), /*#__PURE__*/createElement("path", {
    d: "M18.237 9.615a2.428 2.428 0 00-.174-.143l-.072-.053a3.984 3.984 0 00-2.792-.681c4.165 2.092 3.048 9.295-2.725 9.023a5.133 5.133 0 01-1.506-.292 6.2 6.2 0 01-.34-.14c-.066-.03-.131-.06-.196-.093l.008.005c.805.552 4.78 1.9 8.938-1.5l.006-.016c.104-.243 1.48-3.68-1.147-6.11z"
  }), /*#__PURE__*/createElement("path", {
    d: "M7.706 13.429s.534-2 3.827-2c.356 0 1.375-.999 1.393-1.288a5.744 5.744 0 01-4.348-.172 4.352 4.352 0 00-4.258.172c.242.524.63.967 1.116 1.275a2.964 2.964 0 001.628.458c-.215 1.902.786 4.12 3.209 5.282.054.026.105.055.16.08-1.414-.734-2.581-2.122-2.727-3.807z"
  }), /*#__PURE__*/createElement("path", {
    d: "M23.62 8.051c-.503-1.216-1.524-2.529-2.323-2.944.57 1.11.965 2.3 1.173 3.53l.002.02c-1.31-3.279-3.53-4.6-5.343-7.48a14.318 14.318 0 01-.273-.445 3.698 3.698 0 01-.128-.24 2.127 2.127 0 01-.18-.48.03.03 0 00-.019-.01.041.041 0 00-.021 0l-.006.003-.008.004.004-.007c-2.909 1.71-3.896 4.877-3.987 6.461.136-.01.27-.02.407-.02a5.824 5.824 0 012.937.8 5.858 5.858 0 012.137 2.176 3.984 3.984 0 00-2.792-.681c4.166 2.092 3.048 9.295-2.724 9.023a5.132 5.132 0 01-1.507-.292 6.171 6.171 0 01-.536-.234l.008.006a5.897 5.897 0 01-.168-.085c.054.026.105.055.16.08-1.414-.734-2.581-2.122-2.727-3.807 0 0 .534-2 3.827-2 .356 0 1.375-.999 1.393-1.288-.005-.095-2.02-.9-2.806-1.678-.42-.416-.619-.616-.795-.766a3.46 3.46 0 00-.3-.228 5.416 5.416 0 01-.032-2.843A8.582 8.582 0 006.206 6.79H6.2c-.458-.584-.426-2.51-.4-2.913a2.067 2.067 0 00-.387.206c-.405.29-.783.616-1.131.974-.397.404-.759.84-1.083 1.304a9.844 9.844 0 00-1.554 3.525l-.015.076c-.022.103-.12.622-.134.734 0-.009 0 .008 0 0-.089.537-.146 1.078-.17 1.622v.06A11.661 11.661 0 004.38 20.24a11.544 11.544 0 0015.603 1.335 11.641 11.641 0 004.335-7.23c.02-.15.036-.299.053-.45a12.01 12.01 0 00-.751-5.844z"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "FirefoxBrowser_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    transform: "translate(.825)",
    d: "M0 0h25v24H0z"
  })))));
}

var _path$25;
function _extends$2e() {
  return _extends$2e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2e.apply(null, arguments);
}
function SvgFitbit(props) {
  return /*#__PURE__*/createElement("svg", _extends$2e({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$25 || (_path$25 = /*#__PURE__*/createElement("path", {
    d: "M13.297 1.79c0 .976-.81 1.79-1.784 1.79A1.803 1.803 0 019.73 1.79c0-.976.81-1.79 1.784-1.79.973 0 1.783.814 1.783 1.79zm-1.784 3.254c-1.053 0-1.864.814-1.864 1.871 0 1.058.81 1.871 1.865 1.871 1.054 0 1.864-.813 1.864-1.87 0-1.058-.81-1.872-1.864-1.872zm0 5.044c-1.053 0-1.945.895-1.945 1.953 0 1.057.892 1.952 1.946 1.952 1.054 0 1.946-.895 1.946-1.952 0-1.058-.892-1.953-1.947-1.953zm0 5.126c-1.053 0-1.864.813-1.864 1.87 0 1.058.81 1.872 1.865 1.872 1.054 0 1.864-.814 1.864-1.871 0-.977-.81-1.871-1.864-1.871zm0 5.206c-.973 0-1.783.814-1.783 1.79 0 .976.81 1.79 1.784 1.79.973 0 1.783-.814 1.783-1.79 0-.976-.81-1.79-1.784-1.79zM16.46 4.8c-1.135 0-2.108.976-2.108 2.115 0 1.14.973 2.116 2.108 2.116 1.136 0 2.109-.977 2.109-2.116 0-1.139-.973-2.115-2.109-2.115zm0 5.044c-1.216 0-2.189.976-2.189 2.197 0 1.22.973 2.196 2.19 2.196 1.216 0 2.189-.976 2.189-2.196 0-1.22-.973-2.197-2.19-2.197zm0 5.126c-1.135 0-2.108.976-2.108 2.115 0 1.139.973 2.115 2.108 2.115 1.136 0 2.109-.976 2.109-2.115 0-1.14-.973-2.116-2.109-2.116zm5.109-5.37a2.443 2.443 0 00-2.433 2.44c0 1.302 1.054 2.441 2.433 2.441 1.378 0 2.432-1.057 2.432-2.44-.081-1.383-1.135-2.441-2.432-2.441zM6.486 5.288a1.63 1.63 0 00-1.621 1.627c0 .895.73 1.627 1.621 1.627a1.63 1.63 0 001.622-1.627 1.63 1.63 0 00-1.622-1.627zm0 5.044c-.972 0-1.702.732-1.702 1.709 0 .976.73 1.708 1.702 1.708.973 0 1.703-.732 1.703-1.708 0-.977-.73-1.709-1.703-1.709zm0 5.126a1.63 1.63 0 00-1.621 1.627c0 .895.73 1.627 1.621 1.627a1.63 1.63 0 001.622-1.627 1.63 1.63 0 00-1.622-1.627zM1.46 10.576c-.81 0-1.459.651-1.459 1.465 0 .813.649 1.464 1.46 1.464.81 0 1.459-.65 1.459-1.464s-.649-1.465-1.46-1.465z",
    fill: "currentColor"
  })));
}

var _path$26, _path2$I;
function _extends$2f() {
  return _extends$2f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2f.apply(null, arguments);
}
function SvgFlagBannor(props) {
  return /*#__PURE__*/createElement("svg", _extends$2f({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$26 || (_path$26 = /*#__PURE__*/createElement("path", {
    d: "M2 23V1h9v6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$I || (_path2$I = /*#__PURE__*/createElement("path", {
    d: "M2 14h9v3h11l-5-6.5L22 4H11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$27;
function _extends$2g() {
  return _extends$2g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2g.apply(null, arguments);
}
function SvgFlowerIconRed(props) {
  return /*#__PURE__*/createElement("svg", _extends$2g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$27 || (_path$27 = /*#__PURE__*/createElement("path", {
    d: "M20.869 12.533A6.325 6.325 0 0019.59 12c.444-.13.873-.31 1.278-.533a4.002 4.002 0 00-4-6.934 6.524 6.524 0 00-1.1.834c.104-.449.16-.907.167-1.367a4 4 0 00-8 0c.007.46.063.918.166 1.367a6.522 6.522 0 00-1.1-.834 4.002 4.002 0 00-4 6.934c.405.224.834.402 1.278.533-.444.13-.873.31-1.278.533a4.002 4.002 0 004 6.934 6.522 6.522 0 001.1-.834c-.103.449-.16.907-.166 1.367a4 4 0 108 0 6.511 6.511 0 00-.167-1.367c.336.316.705.596 1.1.834a4.002 4.002 0 004-6.934zM9.713 12a2.222 2.222 0 112.223 2.222A2.234 2.234 0 019.713 12zm8.045-5.922a2.222 2.222 0 012.222 3.844c-.756.434-2.233.778-4.2.99a4.023 4.023 0 00-.978-1.7c1.167-1.6 2.2-2.7 2.956-3.134zm-5.822-4.3A2.233 2.233 0 0114.158 4c0 .867-.433 2.322-1.245 4.122a3.978 3.978 0 00-1.955 0C10.147 6.322 9.713 4.867 9.713 4a2.233 2.233 0 012.223-2.222zM3.08 6.888a2.222 2.222 0 013.033-.81C6.87 6.51 7.903 7.61 9.07 9.21a4.023 4.023 0 00-.978 1.7c-1.967-.211-3.444-.555-4.2-.989A2.222 2.222 0 013.08 6.89zm3.033 11.034a2.222 2.222 0 01-2.222-3.844c.756-.434 2.233-.778 4.2-.99.18.64.517 1.224.978 1.7-1.167 1.6-2.2 2.7-2.956 3.134zm5.823 4.3A2.234 2.234 0 019.713 20c0-.867.434-2.322 1.245-4.122a3.978 3.978 0 001.955 0c.812 1.8 1.245 3.255 1.245 4.122a2.233 2.233 0 01-2.222 2.222zm8.855-5.11a2.222 2.222 0 01-3.033.81c-.756-.433-1.79-1.533-2.956-3.133a4.022 4.022 0 00.978-1.7c1.967.211 3.444.555 4.2.989a2.222 2.222 0 01.811 3.033z",
    fill: "#F25858"
  })));
}

var _path$28;
function _extends$2h() {
  return _extends$2h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2h.apply(null, arguments);
}
function SvgFolder(props) {
  return /*#__PURE__*/createElement("svg", _extends$2h({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$28 || (_path$28 = /*#__PURE__*/createElement("path", {
    d: "M1 7a3 3 0 013-3h4.39a3 3 0 011.953.722l1.814 1.556A3 3 0 0014.11 7H20a3 3 0 013 3v8a3 3 0 01-3 3H4a3 3 0 01-3-3V7z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$29, _path2$J;
function _extends$2i() {
  return _extends$2i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2i.apply(null, arguments);
}
function SvgFontColor(props) {
  return /*#__PURE__*/createElement("svg", _extends$2i({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$29 || (_path$29 = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M4 19h16v3H4zM5.158 13.33a1.5 1.5 0 102.684 1.34l-2.684-1.34zM12 3l1.342-.67a1.5 1.5 0 00-2.684 0L12 3zm4.158 11.67a1.5 1.5 0 102.684-1.34l-2.684 1.34zm-8.316 0l5.5-11-2.684-1.34-5.5 11 2.684 1.34zm2.816-11l5.5 11 2.684-1.34-5.5-11-2.684 1.34z"
  })), _path2$J || (_path2$J = /*#__PURE__*/createElement("path", {
    d: "M8 11h8",
    stroke: "currentColor",
    strokeWidth: 3
  })));
}

var _path$2a;
function _extends$2j() {
  return _extends$2j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2j.apply(null, arguments);
}
function SvgFontHeading(props) {
  return /*#__PURE__*/createElement("svg", _extends$2j({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2a || (_path$2a = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8 4h13v3H8zM13 7h3v13h-3zM5 13h2v6H5zM3 11h6v2H3z"
  })));
}

var _path$2b, _path2$K;
function _extends$2k() {
  return _extends$2k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2k.apply(null, arguments);
}
function SvgFontUnderline(props) {
  return /*#__PURE__*/createElement("svg", _extends$2k({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2b || (_path$2b = /*#__PURE__*/createElement("path", {
    d: "M8 5v7.5s.5 3.5 4 3.5 4-3.5 4-3.5V5",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2$K || (_path2$K = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M4 20h16v3H4z"
  })));
}

var _path$2c;
function _extends$2l() {
  return _extends$2l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2l.apply(null, arguments);
}
function SvgForward(props) {
  return /*#__PURE__*/createElement("svg", _extends$2l({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2c || (_path$2c = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.203 7.572a.5.5 0 01.78-.414l6.064 4.093a.5.5 0 010 .829l-6.065 4.092a.5.5 0 01-.78-.414V7.572zM15.1 5.5c-1.66-1.12-3.898.07-3.898 2.072v2.242a2.565 2.565 0 00-.284-.221L4.855 5.5C3.195 4.38.957 5.57.957 7.572v8.186c0 2.003 2.238 3.193 3.898 2.072l6.064-4.093c.102-.068.196-.142.284-.22v2.241c0 2.003 2.238 3.193 3.898 2.072l6.065-4.093a2.5 2.5 0 000-4.144L15.1 5.5zM2.957 7.572a.5.5 0 01.78-.414L9.8 11.25a.5.5 0 010 .829l-6.065 4.092a.5.5 0 01-.78-.414V7.572z",
    fill: "currentColor"
  })));
}

var _path$2d, _path2$L;
function _extends$2m() {
  return _extends$2m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2m.apply(null, arguments);
}
function SvgForwardArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$2m({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2d || (_path$2d = /*#__PURE__*/createElement("path", {
    d: "M14.283 5L21 12l-6.717 7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$L || (_path2$L = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M19.733 12.032H4"
  })));
}

var _path$2e, _path2$M;
function _extends$2n() {
  return _extends$2n = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2n.apply(null, arguments);
}
function SvgForwardRedo(props) {
  return /*#__PURE__*/createElement("svg", _extends$2n({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2e || (_path$2e = /*#__PURE__*/createElement("path", {
    d: "M14.55 14.453l7.701.054V7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$M || (_path2$M = /*#__PURE__*/createElement("path", {
    d: "M22.252 14.508l-3.464-3.65c-4.792-5.05-13.208-3.396-15.733 3.09v0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2f, _path2$N, _path3$a, _path4$4, _path5$2, _path6$1, _path7, _path8;
function _extends$2o() {
  return _extends$2o = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2o.apply(null, arguments);
}
function SvgFullScreenExpandResize(props) {
  return /*#__PURE__*/createElement("svg", _extends$2o({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2f || (_path$2f = /*#__PURE__*/createElement("path", {
    d: "M15.214 3.649h5.274v5.29",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$N || (_path2$N = /*#__PURE__*/createElement("path", {
    d: "M19.512 4.512L14.5 9.524",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3$a || (_path3$a = /*#__PURE__*/createElement("path", {
    d: "M20.37 14.714v5.275h-5.291",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/createElement("path", {
    d: "M19.507 19.012L14.5 14.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5$2 || (_path5$2 = /*#__PURE__*/createElement("path", {
    d: "M8.912 20.012H3.637V14.72",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6$1 || (_path6$1 = /*#__PURE__*/createElement("path", {
    d: "M4.616 18.91L9.5 14.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/createElement("path", {
    d: "M3.629 8.915V3.641H8.92",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/createElement("path", {
    d: "M4.73 4.62L9.61 9.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$2g, _path2$O, _path3$b, _path4$5;
function _extends$2p() {
  return _extends$2p = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2p.apply(null, arguments);
}
function SvgFullScreenResizeExpand(props) {
  return /*#__PURE__*/createElement("svg", _extends$2p({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2g || (_path$2g = /*#__PURE__*/createElement("path", {
    d: "M14.087 3.646h6.275v6.29",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$O || (_path2$O = /*#__PURE__*/createElement("path", {
    d: "M20 4l-6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3$b || (_path3$b = /*#__PURE__*/createElement("path", {
    d: "M9.912 20.354H3.637v-6.29",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4$5 || (_path4$5 = /*#__PURE__*/createElement("path", {
    d: "M10 14.007l-6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$2h, _path2$P;
function _extends$2q() {
  return _extends$2q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2q.apply(null, arguments);
}
function SvgGamesIconRed(props) {
  return /*#__PURE__*/createElement("svg", _extends$2q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2h || (_path$2h = /*#__PURE__*/createElement("path", {
    d: "M6.326 4C2.776 4 1 6.403 1 8.006v9.613c0 1.603 2.663 4.006 6.214.801 3.55-3.204 6.021-3.204 9.572 0 3.55 3.205 6.214.802 6.214-.8V8.005C23 6.403 21.032 4 17.48 4H6.327z",
    stroke: "#F25858",
    strokeWidth: 2
  })), _path2$P || (_path2$P = /*#__PURE__*/createElement("path", {
    d: "M16.333 14.014c.643 0 1.164-.529 1.164-1.18 0-.653-.521-1.181-1.164-1.181-.642 0-1.163.528-1.163 1.18 0 .652.52 1.18 1.163 1.18zM18.66 11.653c.643 0 1.164-.529 1.164-1.18 0-.653-.52-1.181-1.163-1.181s-1.164.528-1.164 1.18c0 .652.521 1.18 1.164 1.18zM16.333 9.292c.643 0 1.164-.529 1.164-1.18 0-.653-.521-1.181-1.164-1.181-.642 0-1.163.528-1.163 1.18 0 .652.52 1.18 1.163 1.18zM14.006 11.653c.643 0 1.164-.529 1.164-1.18 0-.653-.521-1.181-1.164-1.181-.643 0-1.164.528-1.164 1.18 0 .652.521 1.18 1.164 1.18zM7.024 12.833c1.285 0 2.327-1.057 2.327-2.36 0-1.305-1.042-2.362-2.327-2.362-1.286 0-2.328 1.057-2.328 2.361 0 1.304 1.042 2.361 2.328 2.361z",
    fill: "#F25858"
  })));
}

var _circle$m, _path$2i;
function _extends$2r() {
  return _extends$2r = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2r.apply(null, arguments);
}
function SvgGeoLocate(props) {
  return /*#__PURE__*/createElement("svg", _extends$2r({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$m || (_circle$m = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$2i || (_path$2i = /*#__PURE__*/createElement("path", {
    d: "M12 1v5M12 18v5M1 12h5M18 12h5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2j, _rect$f, _path2$Q, _path3$c;
function _extends$2s() {
  return _extends$2s = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2s.apply(null, arguments);
}
function SvgGift(props) {
  return /*#__PURE__*/createElement("svg", _extends$2s({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2j || (_path$2j = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M4 12h16v10H4z"
  })), _rect$f || (_rect$f = /*#__PURE__*/createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 6,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$Q || (_path2$Q = /*#__PURE__*/createElement("path", {
    d: "M12 22.5v-16M12 6h3.5a2 2 0 100-4c-.466 0-.836-.016-1.5.5-1.09.847-2 3.5-2 3.5z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$c || (_path3$c = /*#__PURE__*/createElement("path", {
    d: "M12.5 6H9a2 2 0 110-4c.466 0 .836-.016 1.5.5 1.09.847 2 3.5 2 3.5z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$2k, _rect$g, _path2$R, _path3$d;
function _extends$2t() {
  return _extends$2t = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2t.apply(null, arguments);
}
function SvgGiftLite(props) {
  return /*#__PURE__*/createElement("svg", _extends$2t({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2k || (_path$2k = /*#__PURE__*/createElement("path", {
    stroke: "#04080F",
    strokeWidth: 3,
    d: "M13.333 40h53.333v33.333H13.333z"
  })), _rect$g || (_rect$g = /*#__PURE__*/createElement("rect", {
    x: 6.667,
    y: 20,
    width: 66.667,
    height: 20,
    rx: 1,
    stroke: "#04080F",
    strokeWidth: 3
  })), _path2$R || (_path2$R = /*#__PURE__*/createElement("path", {
    d: "M40 75V21.667M40 20h11.667a6.667 6.667 0 100-13.333c-1.552 0-2.787-.055-5 1.667C43.035 11.158 40 20 40 20z",
    stroke: "#04080F",
    strokeWidth: 3
  })), _path3$d || (_path3$d = /*#__PURE__*/createElement("path", {
    d: "M41.667 20H30a6.667 6.667 0 110-13.333c1.552 0 2.787-.055 5 1.667C38.632 11.158 41.667 20 41.667 20z",
    stroke: "#04080F",
    strokeWidth: 3
  })));
}

var _path$2l, _path2$S;
function _extends$2u() {
  return _extends$2u = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2u.apply(null, arguments);
}
function SvgGoingDownAlt(props) {
  return /*#__PURE__*/createElement("svg", _extends$2u({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2l || (_path$2l = /*#__PURE__*/createElement("path", {
    d: "M13.433 17.642h9V8.278",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$S || (_path2$S = /*#__PURE__*/createElement("path", {
    d: "M22.25 17.46l-8.925-8.994-4.5 4.782-7.783-7.782",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$6, _defs$5;
function _extends$2v() {
  return _extends$2v = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2v.apply(null, arguments);
}
function SvgGoogle(props) {
  return /*#__PURE__*/createElement("svg", _extends$2v({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Google_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.843 6.548a6.52 6.52 0 00-4.603-1.8c-3.13 0-5.79 2.113-6.737 4.957a7.188 7.188 0 000 4.594h.004c.952 2.84 3.607 4.952 6.737 4.952 1.616 0 3.004-.413 4.079-1.143v-.003a5.554 5.554 0 002.399-3.647H12.24v-4.62h11.319c.14.802.207 1.622.207 2.438 0 3.65-1.304 6.735-3.574 8.825l.002.002C18.206 22.937 15.476 24 12.24 24a12.002 12.002 0 01-10.724-6.61 12.01 12.01 0 010-10.776A11.998 11.998 0 0112.24 0a11.533 11.533 0 018.03 3.122l-3.427 3.426z",
    fill: "currentColor"
  }))), _defs$5 || (_defs$5 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Google_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var _path$2m;
function _extends$2w() {
  return _extends$2w = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2w.apply(null, arguments);
}
function SvgGoogleMaps(props) {
  return /*#__PURE__*/createElement("svg", _extends$2w({
    width: ".7em",
    height: "1em",
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2m || (_path$2m = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.951 2.99C3.186 1.519 5.35 0 8.34 0c1.445 0 2.545.383 2.545.383l-.01.01.025-.01c2.059.665 3.824 2.058 4.888 4.117l.005-.002s.94 1.607.94 3.917c0 2.472-.95 4.24-.95 4.24-.684 1.42-2.102 3.165-2.621 3.804-.073.09-.128.157-.16.2-.988 1.234-2.003 2.52-2.806 3.966-.406.755-.667 1.544-1 2.584-.161.481-.37.791-.828.791-.42 0-.618-.185-.828-.791l-.02-.06c-.347-1.065-.546-1.676-1.02-2.573a23.365 23.365 0 00-1.89-2.793c-.314-.422-.666-.859-1.031-1.312-1.003-1.244-2.103-2.609-2.764-4.113 0 0-.815-1.62-.815-3.954C0 6.2.86 4.275 1.954 3.014l-.003-.024zm3.801 3.52l.155-.184-.012-.01h.001c.042-.052.937-1.136 2.47-1.136 1.656 0 3.188 1.37 3.188 3.188 0 .804-.322 1.45-.538 1.794l-.007.008-.086.112-.111.136-.165.198c-.332.328-1.115.95-2.28.95a3.182 3.182 0 01-3.2-3.187c0-.875.373-1.554.585-1.87z",
    fill: "currentColor"
  })));
}

var _path$2n;
function _extends$2x() {
  return _extends$2x = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2x.apply(null, arguments);
}
function SvgGooglePlaystore(props) {
  return /*#__PURE__*/createElement("svg", _extends$2x({
    width: ".95em",
    height: "1em",
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2n || (_path$2n = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.444 8.464l-3.897 3.786 3.574 3.472 4.18-2.373c.998-.568 1.234-1.409.71-2.103a1.638 1.638 0 00-.709-.591l-.001-.001-3.857-2.19zm-1.232 7.769l-3.383-3.286-11.262 10.94a1.567 1.567 0 001.52-.197l13.125-7.457zM.882 23.158l11.23-10.908L.766 1.228a1.872 1.872 0 00-.03.456v20.502a1.91 1.91 0 000 .173c-.01.276.041.548.147.799zm.36-22.86L12.83 11.553l3.71-3.603L3.086.313a1.512 1.512 0 00-.97-.312H2.09a1.199 1.199 0 00-.847.297z",
    fill: "currentColor"
  })));
}

var _path$2o;
function _extends$2y() {
  return _extends$2y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2y.apply(null, arguments);
}
function SvgGovermentLawBalance(props) {
  return /*#__PURE__*/createElement("svg", _extends$2y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2o || (_path$2o = /*#__PURE__*/createElement("path", {
    d: "M3 6l2 1 7-2 7 2 2-1M12 3v18M9 21h6M8 16.1L5 8l-3 8.1s1 .9 3 .9 3-.9 3-.9zM22 16.1L19 8l-3 8.1s1 .9 3 .9 3-.9 3-.9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _rect$h, _rect2$2, _rect3$1, _rect4$1;
function _extends$2z() {
  return _extends$2z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2z.apply(null, arguments);
}
function SvgGridFeedCards(props) {
  return /*#__PURE__*/createElement("svg", _extends$2z({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$h || (_rect$h = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2$2 || (_rect2$2 = /*#__PURE__*/createElement("rect", {
    x: 15,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect3$1 || (_rect3$1 = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 15,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect4$1 || (_rect4$1 = /*#__PURE__*/createElement("rect", {
    x: 15,
    y: 15,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$i, _rect2$3, _rect3$2, _rect4$2, _rect5$1, _rect6$1, _rect7, _rect8, _rect9;
function _extends$2A() {
  return _extends$2A = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2A.apply(null, arguments);
}
function SvgGridMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$2A({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$i || (_rect$i = /*#__PURE__*/createElement("rect", {
    x: 2.998,
    y: 2,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2$3 || (_rect2$3 = /*#__PURE__*/createElement("rect", {
    x: 10.998,
    y: 2,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect3$2 || (_rect3$2 = /*#__PURE__*/createElement("rect", {
    x: 18.998,
    y: 2,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect4$2 || (_rect4$2 = /*#__PURE__*/createElement("rect", {
    x: 2.998,
    y: 10,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect5$1 || (_rect5$1 = /*#__PURE__*/createElement("rect", {
    x: 10.998,
    y: 10,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect6$1 || (_rect6$1 = /*#__PURE__*/createElement("rect", {
    x: 18.998,
    y: 10,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/createElement("rect", {
    x: 2.998,
    y: 18,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/createElement("rect", {
    x: 10.998,
    y: 18,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/createElement("rect", {
    x: 18.998,
    y: 18,
    width: 4,
    height: 4,
    rx: 0.25,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$2p;
function _extends$2B() {
  return _extends$2B = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2B.apply(null, arguments);
}
function SvgGrubhub(props) {
  return /*#__PURE__*/createElement("svg", _extends$2B({
    width: ".75em",
    height: "1em",
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2p || (_path$2p = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.046.154a3.76 3.76 0 011.472-.13 3.192 3.192 0 011.914.89c.67.644.986 1.595.94 2.513-.003.282.005.564-.003.847-.01.124-.138.185-.243.218-.706.252-1.41.514-2.116.762-.102.052-.201-.011-.289-.06-.05-.186-.032-.378-.034-.568-.002-.408.025-.836-.152-1.215-.11-.25-.326-.463-.596-.524-.417-.068-.829.11-1.152.361-.41.31-.634.801-.745 1.29a5.123 5.123 0 00-.104 1.077v4.764c.005.68-.039 1.371.13 2.037.084.292.218.609.501.76.283.15.62.08.897-.043.451-.199.767-.618.945-1.065.165-.4.242-.833.266-1.264.007-.41.001-.818.004-1.226-.346.124-.692.247-1.037.374-.106.042-.24.011-.304-.09-.029-.083-.026-.173-.028-.26.003-.634-.003-1.269.003-1.904a.314.314 0 01.22-.32L8.059 6.1c.147-.055.329.059.312.222.004 1.153 0 2.305.003 3.46-.011.569.023 1.14-.039 1.709-.114 1.221-.594 2.43-1.455 3.32a4.769 4.769 0 01-2.675 1.388l-.023.017c-.282.017-.566.059-.85.036-.785-.037-1.54-.4-2.095-.951-.722-.711-1.061-1.733-1.075-2.731V5.368C.19 4.03.671 2.695 1.555 1.687A5.093 5.093 0 014.045.154zm5.946 6.199c-.014-.176.16-.322.33-.252.735.269 1.472.533 2.207.8.132.043.258.156.248.305 0 1.956.003 3.912 0 5.87.75.28 1.508.542 2.258.82-.001-1.9.002-3.803 0-5.705a.27.27 0 01.138-.263.395.395 0 01.255.023c.709.259 1.42.513 2.13.774.136.043.273.157.266.314.002 4.894 0 9.787 0 14.68.007.097-.023.213-.12.256-.097.051-.209.014-.305-.02-.706-.259-1.413-.515-2.12-.772-.115-.045-.229-.143-.242-.272-.008-2.042.008-4.085-.007-6.127-.75-.267-1.502-.54-2.251-.812v5.95c.01.097-.041.2-.135.236a.488.488 0 01-.249-.014c-.723-.266-1.45-.523-2.175-.79a.348.348 0 01-.229-.35c.002-4.884-.001-9.768.001-14.651z",
    fill: "currentColor"
  })));
}

var _path$2q, _rect$j, _rect2$4, _rect3$3, _rect4$3;
function _extends$2C() {
  return _extends$2C = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2C.apply(null, arguments);
}
function SvgGymWeight(props) {
  return /*#__PURE__*/createElement("svg", _extends$2C({
    width: ".727em",
    height: "1em",
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2q || (_path$2q = /*#__PURE__*/createElement("path", {
    d: "M1 16.07h1m21 0h-1m-13 0h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect$j || (_rect$j = /*#__PURE__*/createElement("rect", {
    x: 5,
    y: 8.035,
    width: 4,
    height: 16.07,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2$4 || (_rect2$4 = /*#__PURE__*/createElement("rect", {
    x: 2,
    y: 10.714,
    width: 3,
    height: 10.714,
    rx: 1.5,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect3$3 || (_rect3$3 = /*#__PURE__*/createElement("rect", {
    x: 15,
    y: 8.035,
    width: 4,
    height: 16.07,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect4$3 || (_rect4$3 = /*#__PURE__*/createElement("rect", {
    x: 19,
    y: 10.714,
    width: 3,
    height: 10.714,
    rx: 1.5,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$2r, _path2$T, _circle$n, _path3$e;
function _extends$2D() {
  return _extends$2D = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2D.apply(null, arguments);
}
function SvgHairDryer(props) {
  return /*#__PURE__*/createElement("svg", _extends$2D({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2r || (_path$2r = /*#__PURE__*/createElement("path", {
    d: "M3 22.5h3a4 4 0 004-4v0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$T || (_path2$T = /*#__PURE__*/createElement("path", {
    d: "M2 7C2 3.361 5.304.617 8.881 1.284L21.173 3.58c.48.09.827.508.827.995v4.852c0 .487-.348.905-.827.995L8.881 12.716C5.304 13.383 2 10.639 2 7v0z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle$n || (_circle$n = /*#__PURE__*/createElement("circle", {
    cx: 8,
    cy: 7,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$e || (_path3$e = /*#__PURE__*/createElement("path", {
    d: "M6.5 13l1.76 4.842a1 1 0 00.94.658h2.413a1 1 0 00.948-1.316L11 12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2s;
function _extends$2E() {
  return _extends$2E = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2E.apply(null, arguments);
}
function SvgHamburgerMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$2E({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2s || (_path$2s = /*#__PURE__*/createElement("path", {
    d: "M1.996 5h22M1.996 12h22M1.996 19h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$7, _defs$6;
function _extends$2F() {
  return _extends$2F = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2F.apply(null, arguments);
}
function SvgHangers(props) {
  return /*#__PURE__*/createElement("svg", _extends$2F({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$7 || (_g$7 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Hangers_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    d: "M2.201 21c-.98 0-1.375-1.264-.569-1.822l9.23-6.39a2 2 0 012.276 0l9.23 6.39c.806.558.411 1.822-.57 1.822H2.202z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/createElement("path", {
    d: "M11 12a1 1 0 102 0h-2zM8 6.25a1 1 0 002 0H8zM10 6c0-.43.22-.939.637-1.357C11.053 4.225 11.56 4 12 4V2c-1.085 0-2.078.525-2.781 1.232C8.517 3.94 8 4.93 8 6h2zm2-2c.552 0 1.054.182 1.405.496.334.298.595.77.595 1.504h2c0-1.266-.476-2.294-1.262-2.996C13.971 2.318 12.973 2 12 2v2zm2 2c0 .363-.206.793-.642 1.264-.423.456-.956.834-1.352 1.08l1.058 1.698c.467-.29 1.166-.778 1.76-1.419C15.404 7.997 16 7.1 16 6h-2zm-3 4.118V12h2v-1.882h-2zM8 6v.25h2V6H8zm4.006 2.345c-.58.361-1.006 1.01-1.006 1.773h2v-.005a.075.075 0 01.008-.016.166.166 0 01.056-.055l-1.058-1.697z",
    fill: "currentColor"
  }))), _defs$6 || (_defs$6 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Hangers_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var _path$2t;
function _extends$2G() {
  return _extends$2G = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2G.apply(null, arguments);
}
function SvgHashtag(props) {
  return /*#__PURE__*/createElement("svg", _extends$2G({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2t || (_path$2t = /*#__PURE__*/createElement("path", {
    d: "M5 9h16M3 15h16M18 4l-6 16M12 4L6 20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2u;
function _extends$2H() {
  return _extends$2H = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2H.apply(null, arguments);
}
function SvgHeart(props) {
  return /*#__PURE__*/createElement("svg", _extends$2H({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2u || (_path$2u = /*#__PURE__*/createElement("path", {
    d: "M2.772 3.772a6.05 6.05 0 000 8.557l9.165 9.165.063-.063.063.063 9.165-9.165a6.05 6.05 0 10-8.557-8.557l-.317.318a.5.5 0 01-.707 0l-.318-.318a6.05 6.05 0 00-8.557 0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2v, _path2$U;
function _extends$2I() {
  return _extends$2I = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2I.apply(null, arguments);
}
function SvgHeat(props) {
  return /*#__PURE__*/createElement("svg", _extends$2I({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2v || (_path$2v = /*#__PURE__*/createElement("path", {
    d: "M1 3a2 2 0 012-2h18a2 2 0 012 2v4.528a2 2 0 01-.211.894l-1.236 2.472A2 2 0 0119.763 12H4.237a2 2 0 01-1.789-1.106L1.211 8.422A2 2 0 011 7.528V3z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$U || (_path2$U = /*#__PURE__*/createElement("path", {
    d: "M18 4.5h1M5 12v-2a2 2 0 012-2h10a2 2 0 012 2v2M19 17v1.764a2 2 0 001.106 1.789v0a2 2 0 001.788 0l.135-.068c.595-.297.971-.905.971-1.57v0c0-.273-.064-.542-.185-.786L22.5 17.5M14 19v1.93a2 2 0 00.89 1.664l.61.406M9.5 18v2.93a2 2 0 01-.89 1.664l-.106.07a2 2 0 01-1.11.336H7M5 17v1.764a2 2 0 01-1.106 1.789v0a2 2 0 01-1.788 0l-.135-.068A1.756 1.756 0 011 18.915v0c0-.273.063-.542.185-.786L1.5 17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$o, _circle2$6, _path$2w;
function _extends$2J() {
  return _extends$2J = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2J.apply(null, arguments);
}
function SvgHelp(props) {
  return /*#__PURE__*/createElement("svg", _extends$2J({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$o || (_circle$o = /*#__PURE__*/createElement("circle", {
    cx: 17,
    cy: 17,
    r: 11,
    transform: "rotate(-45 17 17)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2$6 || (_circle2$6 = /*#__PURE__*/createElement("circle", {
    cx: 17,
    cy: 17,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$2w || (_path$2w = /*#__PURE__*/createElement("path", {
    d: "M9.222 9.222l3.889 3.889M20.535 20.536l3.89 3.889M20.535 13.464l4.243-4.242M9.222 24.778l4.242-4.243",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$2x, _path2$V, _path3$f;
function _extends$2K() {
  return _extends$2K = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2K.apply(null, arguments);
}
function SvgHide(props) {
  return /*#__PURE__*/createElement("svg", _extends$2K({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2x || (_path$2x = /*#__PURE__*/createElement("path", {
    d: "M5.68 3l16 16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$V || (_path2$V = /*#__PURE__*/createElement("path", {
    d: "M22.268 13.23a2.522 2.522 0 00-.243-1.93C20.31 8.316 17.85 6.1 15 5.116M19.628 17c-2.19 2.228-4.95 3.556-7.948 3.556-4.236 0-7.995-2.65-10.345-6.744a2.522 2.522 0 010-2.512C2.94 8.505 5.202 6.383 7.824 5.317",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$f || (_path3$f = /*#__PURE__*/createElement("path", {
    d: "M14.59 11.825a3 3 0 11-2.291-2.204",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$2y;
function _extends$2L() {
  return _extends$2L = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2L.apply(null, arguments);
}
function SvgHome(props) {
  return /*#__PURE__*/createElement("svg", _extends$2L({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2y || (_path$2y = /*#__PURE__*/createElement("path", {
    d: "M2 9.88a3 3 0 011.221-2.416L12 1l8.779 6.464A3 3 0 0122 9.88V20.5a2.5 2.5 0 01-2.5 2.5H16a1 1 0 01-1-1v-6a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v6a1 1 0 01-1 1H4.5A2.5 2.5 0 012 20.5V9.88z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2z;
function _extends$2M() {
  return _extends$2M = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2M.apply(null, arguments);
}
function SvgHomeMinimal(props) {
  return /*#__PURE__*/createElement("svg", _extends$2M({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2z || (_path$2z = /*#__PURE__*/createElement("path", {
    d: "M2 9.88a3 3 0 011.221-2.416L12 1l8.779 6.464A3 3 0 0122 9.88V20.5a2.5 2.5 0 01-2.5 2.5h-15A2.5 2.5 0 012 20.5V9.88z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2A;
function _extends$2N() {
  return _extends$2N = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2N.apply(null, arguments);
}
function SvgHomeRed(props) {
  return /*#__PURE__*/createElement("svg", _extends$2N({
    width: 22,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2A || (_path$2A = /*#__PURE__*/createElement("path", {
    d: "M1 9.88a3 3 0 011.221-2.416L11 1l8.779 6.464A3 3 0 0121 9.88V20.5a2.5 2.5 0 01-2.5 2.5H15a1 1 0 01-1-1v-6a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v6a1 1 0 01-1 1H3.5A2.5 2.5 0 011 20.5V9.88z",
    stroke: "#F25858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _rect$k, _path$2B, _path2$W;
function _extends$2O() {
  return _extends$2O = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2O.apply(null, arguments);
}
function SvgHotel(props) {
  return /*#__PURE__*/createElement("svg", _extends$2O({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$k || (_rect$k = /*#__PURE__*/createElement("rect", {
    x: 2,
    y: 1,
    width: ".909em",
    height: "1em",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$2B || (_path$2B = /*#__PURE__*/createElement("path", {
    d: "M16 18a4 4 0 00-8 0h8zM6 6h4v4H6zM14 6h4v4h-4zM10 18h4v5h-4v-5z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$W || (_path2$W = /*#__PURE__*/createElement("path", {
    d: "M1 1h22M1 23h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2C, _path2$X, _path3$g, _path4$6;
function _extends$2P() {
  return _extends$2P = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2P.apply(null, arguments);
}
function SvgImage(props) {
  return /*#__PURE__*/createElement("svg", _extends$2P({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2C || (_path$2C = /*#__PURE__*/createElement("path", {
    d: "M1 5a2 2 0 012-2h18a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2$X || (_path2$X = /*#__PURE__*/createElement("path", {
    d: "M5.5 21L16.222 9.384a2 2 0 012.736-.191L23 12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$g || (_path3$g = /*#__PURE__*/createElement("path", {
    d: "M1 10l7.75 7.75",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4$6 || (_path4$6 = /*#__PURE__*/createElement("path", {
    d: "M12.5 13c0-1-1.79-3-4-3s-4 2-4 3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2D;
function _extends$2Q() {
  return _extends$2Q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2Q.apply(null, arguments);
}
function SvgInbox(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Q({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2D || (_path$2D = /*#__PURE__*/createElement("path", {
    d: "M3 12V1h18v11M8 6h8M8 11h8M1 16h7v2h8v-2h7v7H1v-7z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$2E, _path2$Y;
function _extends$2R() {
  return _extends$2R = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2R.apply(null, arguments);
}
function SvgIndentLess(props) {
  return /*#__PURE__*/createElement("svg", _extends$2R({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2E || (_path$2E = /*#__PURE__*/createElement("path", {
    d: "M11 7h12M11 17h12M11 12h12M1 2h22M1 22h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$Y || (_path2$Y = /*#__PURE__*/createElement("path", {
    d: "M6 7.808c0-.621-.455-1.01-.818-.699l-4.91 4.192c-.363.31-.363 1.087 0 1.398l4.91 4.192c.363.31.818-.078.818-.699V7.808z",
    fill: "currentColor"
  })));
}

var _path$2F, _path2$Z;
function _extends$2S() {
  return _extends$2S = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2S.apply(null, arguments);
}
function SvgIndentMore(props) {
  return /*#__PURE__*/createElement("svg", _extends$2S({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2F || (_path$2F = /*#__PURE__*/createElement("path", {
    d: "M11 7h12M11 17h12M11 12h12M1 2h22M1 22h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$Z || (_path2$Z = /*#__PURE__*/createElement("path", {
    d: "M0 7.808c0-.621.455-1.01.818-.699l4.91 4.192c.363.31.363 1.087 0 1.398L.817 16.89C.455 17.2 0 16.813 0 16.192V7.808z",
    fill: "currentColor"
  })));
}

var _circle$p, _path$2G;
function _extends$2T() {
  return _extends$2T = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2T.apply(null, arguments);
}
function SvgInfo(props) {
  return /*#__PURE__*/createElement("svg", _extends$2T({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$p || (_circle$p = /*#__PURE__*/createElement("circle", {
    cx: 14,
    cy: 2.5,
    r: 2.5,
    fill: "currentColor"
  })), _path$2G || (_path$2G = /*#__PURE__*/createElement("path", {
    d: "M15.508 8H6l-1 2.5 5 .5-3.425 7.935s-.168 1.231 0 1.99c.188.848.396 1.359.992 1.989 1.1 1.162 2.384 1.19 3.97.994C14.257 23.575 17 19.5 17 19.5l-1.492-1.56s-1.986 1.99-2.978 1.99c-.993 0-.993-.995-.993-.995L15.507 8z",
    fill: "currentColor"
  })));
}

var _path$2H, _path2$_;
function _extends$2U() {
  return _extends$2U = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2U.apply(null, arguments);
}
function SvgInstagram(props) {
  return /*#__PURE__*/createElement("svg", _extends$2U({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2H || (_path$2H = /*#__PURE__*/createElement("path", {
    d: "M12 2.16c3.206 0 3.586.015 4.847.071 1.172.052 1.805.249 2.226.413a3.71 3.71 0 011.379.895c.421.422.68.82.895 1.378.164.422.36 1.06.412 2.227.057 1.265.07 1.645.07 4.847 0 3.206-.013 3.586-.07 4.846-.051 1.172-.248 1.805-.412 2.227-.216.558-.478.961-.895 1.378a3.69 3.69 0 01-1.379.895c-.421.165-1.059.361-2.226.413-1.266.056-1.645.07-4.847.07-3.206 0-3.586-.014-4.847-.07-1.172-.052-1.805-.248-2.226-.413a3.71 3.71 0 01-1.379-.895 3.691 3.691 0 01-.895-1.378c-.164-.422-.36-1.06-.412-2.227-.057-1.265-.07-1.645-.07-4.846 0-3.207.013-3.586.07-4.847.051-1.172.248-1.805.412-2.227.216-.558.478-.96.895-1.378.422-.422.82-.68 1.379-.895.421-.164 1.059-.361 2.226-.413 1.261-.056 1.64-.07 4.847-.07zM12 0C8.742 0 8.334.014 7.055.07 5.78.127 4.903.333 4.144.628a5.857 5.857 0 00-2.128 1.388A5.88 5.88 0 00.628 4.139C.333 4.903.127 5.775.07 7.05.014 8.334 0 8.742 0 12s.014 3.666.07 4.945c.057 1.275.263 2.152.558 2.911.31.792.717 1.463 1.388 2.128a5.866 5.866 0 002.123 1.383c.764.296 1.636.502 2.911.558 1.28.056 1.688.07 4.945.07 3.258 0 3.666-.014 4.946-.07 1.275-.056 2.151-.262 2.91-.558a5.866 5.866 0 002.124-1.383 5.866 5.866 0 001.383-2.123c.295-.764.501-1.636.558-2.911.056-1.28.07-1.688.07-4.945 0-3.258-.014-3.666-.07-4.946-.057-1.275-.263-2.151-.558-2.91a5.62 5.62 0 00-1.374-2.133A5.866 5.866 0 0019.861.633C19.097.338 18.225.13 16.95.075 15.666.015 15.258 0 12 0z",
    fill: "currentColor"
  })), _path2$_ || (_path2$_ = /*#__PURE__*/createElement("path", {
    d: "M12 5.836A6.166 6.166 0 005.836 12 6.166 6.166 0 0012 18.164 6.166 6.166 0 0018.164 12 6.166 6.166 0 0012 5.836zm0 10.162A3.999 3.999 0 1112.001 8 3.999 3.999 0 0112 15.998zM19.847 5.592a1.44 1.44 0 11-2.879 0 1.44 1.44 0 012.879 0z",
    fill: "currentColor"
  })));
}

var _path$2I, _path2$$;
function _extends$2V() {
  return _extends$2V = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2V.apply(null, arguments);
}
function SvgItalic(props) {
  return /*#__PURE__*/createElement("svg", _extends$2V({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2I || (_path$2I = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M9 5h10v3H9zM5 16h10v3H5z"
  })), _path2$$ || (_path2$$ = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8 17.25l5.299-11.364 2.719 1.268-5.3 11.364z"
  })));
}

var _path$2J, _path2$10, _path3$h;
function _extends$2W() {
  return _extends$2W = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2W.apply(null, arguments);
}
function SvgKey(props) {
  return /*#__PURE__*/createElement("svg", _extends$2W({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2J || (_path$2J = /*#__PURE__*/createElement("path", {
    d: "M9.5 11L3 17.5V21h4.5v-1.5h2V17h2.25v-3",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$10 || (_path2$10 = /*#__PURE__*/createElement("path", {
    d: "M9.45 11.05C9.229 10.424 9 9.701 9 9a6 6 0 116 6c-1.093 0-2.367-.39-3.25-.9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$h || (_path3$h = /*#__PURE__*/createElement("path", {
    d: "M15.5 7s.5 0 1 .5.5 1 .5 1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$8, _defs$7;
function _extends$2X() {
  return _extends$2X = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2X.apply(null, arguments);
}
function SvgKitchenFood(props) {
  return /*#__PURE__*/createElement("svg", _extends$2X({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#KitchenFood_svg__clip0)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/createElement("path", {
    d: "M11 0v15"
  }), /*#__PURE__*/createElement("ellipse", {
    cx: 11,
    cy: 19,
    rx: 3,
    ry: 4
  }), /*#__PURE__*/createElement("path", {
    d: "M23 5.286C23 8.599 21.433 13 19.5 13S16 8.6 16 5.286 17.567 1 19.5 1s3.5.972 3.5 4.286zM1 25V13m0 0V2s4 1.5 4 9v2H1zM19.5 1v23"
  }))), _defs$7 || (_defs$7 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "KitchenFood_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var _path$2K, _path2$11;
function _extends$2Y() {
  return _extends$2Y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2Y.apply(null, arguments);
}
function SvgLabBeaker(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2K || (_path$2K = /*#__PURE__*/createElement("path", {
    d: "M17.795 1H6.205l2.199 4.475v4.011c0 .73-.253 1.53-.703 2.045l-5.994 6.775C.197 20.038 1.266 23 3.402 23h17.195c2.136 0 3.207-2.962 1.696-4.694L16.3 11.53c-.45-.516-.702-1.315-.702-2.045V5.475L17.795 1z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$11 || (_path2$11 = /*#__PURE__*/createElement("path", {
    d: "M22 18s-2.361-2-5.194-2c-3.306 0-3.306 2-6.612 2C6.89 18 5 16 5 16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _rect$l, _path$2L;
function _extends$2Z() {
  return _extends$2Z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2Z.apply(null, arguments);
}
function SvgLayout(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Z({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$l || (_rect$l = /*#__PURE__*/createElement("rect", {
    x: 3,
    y: 2,
    width: 18,
    height: 20,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path$2L || (_path$2L = /*#__PURE__*/createElement("path", {
    d: "M3 8h18M9.5 8v14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2M, _path2$12;
function _extends$2_() {
  return _extends$2_ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2_.apply(null, arguments);
}
function SvgLink(props) {
  return /*#__PURE__*/createElement("svg", _extends$2_({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2M || (_path$2M = /*#__PURE__*/createElement("path", {
    d: "M11.5 7l3.317-3.374a4.484 4.484 0 016.368-.027v0a4.484 4.484 0 010 6.341l-4.005 4.005a4 4 0 01-5.549.104L10.5 13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$12 || (_path2$12 = /*#__PURE__*/createElement("path", {
    d: "M12.855 17.813l-3.317 3.373a4.484 4.484 0 01-6.368.027v0a4.484 4.484 0 010-6.34l4.005-4.006a4 4 0 015.549-.104l1.131 1.05",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2N;
function _extends$2$() {
  return _extends$2$ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2$.apply(null, arguments);
}
function SvgLinkedIn(props) {
  return /*#__PURE__*/createElement("svg", _extends$2$({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2N || (_path$2N = /*#__PURE__*/createElement("path", {
    d: "M22.223 0H1.772C.792 0 0 .773 0 1.73v20.536C0 23.222.792 24 1.772 24h20.451c.98 0 1.777-.778 1.777-1.73V1.73C24 .773 23.203 0 22.223 0zM7.12 20.452H3.558V8.995H7.12v11.457zM5.34 7.434a2.064 2.064 0 110-4.125 2.063 2.063 0 010 4.125zm15.112 13.018h-3.558v-5.57c0-1.326-.024-3.037-1.852-3.037-1.851 0-2.133 1.449-2.133 2.944v5.663H9.356V8.995h3.413v1.566h.047c.473-.9 1.636-1.852 3.365-1.852 3.605 0 4.27 2.372 4.27 5.457v6.286z",
    fill: "currentColor"
  })));
}

var _path$2O, _path2$13;
function _extends$30() {
  return _extends$30 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$30.apply(null, arguments);
}
function SvgLipsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$30({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2O || (_path$2O = /*#__PURE__*/createElement("path", {
    d: "M7.6 7c2.2 0 3.728 1.333 4.4 2 .672-.667 2.2-2 4.4-2 1.1 0 5.256 3.333 6.6 5-1.176 2-3.3 7-11 7s-9.824-5-11-7c1.344-1.667 5.5-5 6.6-5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2$13 || (_path2$13 = /*#__PURE__*/createElement("path", {
    d: "M2 12s6.017 1 10 1c3.983 0 10-1 10-1",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _circle$q, _path$2P;
function _extends$31() {
  return _extends$31 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$31.apply(null, arguments);
}
function SvgLoader(props) {
  return /*#__PURE__*/createElement("svg", _extends$31({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$q || (_circle$q = /*#__PURE__*/createElement("circle", {
    cx: 40,
    cy: 40,
    r: 32,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path$2P || (_path$2P = /*#__PURE__*/createElement("path", {
    d: "M62 40a22 22 0 11-26.122-21.61",
    stroke: "currentColor",
    strokeWidth: 4
  }, /*#__PURE__*/createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 40 40",
    to: "360 40 40",
    dur: "0.5s",
    repeatCount: "indefinite"
  }))));
}

var _path$2Q;
function _extends$32() {
  return _extends$32 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$32.apply(null, arguments);
}
function SvgLoading(props) {
  return /*#__PURE__*/createElement("svg", _extends$32({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2Q || (_path$2Q = /*#__PURE__*/createElement("path", {
    d: "M12 2a10 10 0 1010 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2R, _circle$r;
function _extends$33() {
  return _extends$33 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$33.apply(null, arguments);
}
function SvgLocation(props) {
  return /*#__PURE__*/createElement("svg", _extends$33({
    width: ".96em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2R || (_path$2R = /*#__PURE__*/createElement("path", {
    d: "M22 11c0 4.346-6.192 9.902-8.831 12.073a1.828 1.828 0 01-2.338 0C8.192 20.903 2 15.346 2 11 2 5.477 6.477 1 12 1s10 4.477 10 10z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle$r || (_circle$r = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 11,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$m, _path$2S;
function _extends$34() {
  return _extends$34 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$34.apply(null, arguments);
}
function SvgLock(props) {
  return /*#__PURE__*/createElement("svg", _extends$34({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$m || (_rect$m = /*#__PURE__*/createElement("rect", {
    x: 3,
    y: 10,
    width: 18,
    height: 12,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$2S || (_path$2S = /*#__PURE__*/createElement("path", {
    d: "M7 10V6a5 5 0 1110 0v4",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$n, _path$2T;
function _extends$35() {
  return _extends$35 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$35.apply(null, arguments);
}
function SvgLockUnlocked(props) {
  return /*#__PURE__*/createElement("svg", _extends$35({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$n || (_rect$n = /*#__PURE__*/createElement("rect", {
    x: 3,
    y: 11,
    width: 18,
    height: 12,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$2T || (_path$2T = /*#__PURE__*/createElement("path", {
    d: "M6 6a1 1 0 002 0H6zm6-5V0v1zM8 6A4 4 0 019.172 3.17L7.757 1.757A6 6 0 006 6h2zM9.172 3.17A4 4 0 0112 2V0a6 6 0 00-4.243 1.757l1.415 1.414zM12 2a4 4 0 012.828 1.171l1.415-1.414A6 6 0 0012 0v2zm2.828 1.171A4 4 0 0116 6h2a6 6 0 00-1.757-4.243l-1.415 1.414zM16 6v5h2V6h-2z",
    fill: "currentColor"
  })));
}

var _path$2U, _path2$14, _path3$i;
function _extends$36() {
  return _extends$36 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$36.apply(null, arguments);
}
function SvgLogInCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$36({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2U || (_path$2U = /*#__PURE__*/createElement("path", {
    d: "M5.343 19.07c3.905 3.906 10.237 3.906 14.142 0 3.905-3.904 3.905-10.236 0-14.141-3.905-3.906-10.237-3.906-14.142 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$14 || (_path2$14 = /*#__PURE__*/createElement("path", {
    d: "M11 9l2.667 3L11 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$i || (_path3$i = /*#__PURE__*/createElement("path", {
    d: "M13.5 12H1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$2V, _path2$15, _path3$j;
function _extends$37() {
  return _extends$37 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$37.apply(null, arguments);
}
function SvgLogInSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends$37({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2V || (_path$2V = /*#__PURE__*/createElement("path", {
    d: "M13 9l2.667 3L13 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$15 || (_path2$15 = /*#__PURE__*/createElement("path", {
    d: "M15.5 12H1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3$j || (_path3$j = /*#__PURE__*/createElement("path", {
    d: "M9 5V2h14v20H9v-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2W, _path2$16;
function _extends$38() {
  return _extends$38 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$38.apply(null, arguments);
}
function SvgLogOutCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$38({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2W || (_path$2W = /*#__PURE__*/createElement("path", {
    d: "M16.364 18.364a9 9 0 110-12.728M20 9l2.667 3L20 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$16 || (_path2$16 = /*#__PURE__*/createElement("path", {
    d: "M22.5 12H10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$2X, _path2$17, _path3$k;
function _extends$39() {
  return _extends$39 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$39.apply(null, arguments);
}
function SvgLogOutSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends$39({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2X || (_path$2X = /*#__PURE__*/createElement("path", {
    d: "M20 9l2.667 3L20 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$17 || (_path2$17 = /*#__PURE__*/createElement("path", {
    d: "M22.5 12H9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3$k || (_path3$k = /*#__PURE__*/createElement("path", {
    d: "M15 5V2H1v20h14v-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$2Y;
function _extends$3a() {
  return _extends$3a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3a.apply(null, arguments);
}
function SvgLyft(props) {
  return /*#__PURE__*/createElement("svg", _extends$3a({
    width: "1.333em",
    height: "1em",
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2Y || (_path$2Y = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .298h3.645v9.847c0 1.558.708 2.486 1.267 2.884-.592.53-2.404.995-3.754-.133C.362 12.232 0 11.14 0 10.112V.298zm22.777 8.18V7.443h1.111v-3.63h-1.22C22.199 1.633 20.272 0 17.966 0c-2.655 0-4.808 2.167-4.808 4.84v8.478c.757.107 1.658-.013 2.425-.654.796-.664 1.158-1.757 1.158-2.784v-.313h1.82v-3.63h-1.82V4.84h.004c0-.679.547-1.229 1.221-1.229.675 0 1.224.55 1.224 1.23v3.637c0 2.673 2.155 4.84 4.81 4.84V9.707c-.674 0-1.223-.55-1.223-1.23zM8.974 3.813V9.14c0 .303-.25.548-.557.548a.552.552 0 01-.557-.548V3.813H4.254v6.265c0 1.128.38 2.553 2.108 3.017 1.73.465 2.733-.497 2.733-.497-.091.634-.684 1.098-1.64 1.197-.722.076-1.646-.165-2.107-.364v3.32c1.175.348 2.417.46 3.633.223 2.206-.43 3.599-2.287 3.599-4.757V3.813H8.974z",
    fill: "currentColor"
  })));
}

var _path$2Z, _path2$18;
function _extends$3b() {
  return _extends$3b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3b.apply(null, arguments);
}
function SvgMail(props) {
  return /*#__PURE__*/createElement("svg", _extends$3b({
    width: "1.083em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2Z || (_path$2Z = /*#__PURE__*/createElement("path", {
    d: "M1 6a2 2 0 012-2h20a2 2 0 012 2v13a2 2 0 01-2 2H3a2 2 0 01-2-2V6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2$18 || (_path2$18 = /*#__PURE__*/createElement("path", {
    d: "M2.421 5.303C1.917 4.84 2.244 4 2.928 4h20.144c.684 0 1.01.84.507 1.303l-8.552 7.839a3 3 0 01-4.054 0L2.42 5.302z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var _path$2_, _path2$19;
function _extends$3c() {
  return _extends$3c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3c.apply(null, arguments);
}
function SvgMap(props) {
  return /*#__PURE__*/createElement("svg", _extends$3c({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2_ || (_path$2_ = /*#__PURE__*/createElement("path", {
    d: "M1 5l7-4 8 4 7-4v18l-7 4-8-4-7 4V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$19 || (_path2$19 = /*#__PURE__*/createElement("path", {
    d: "M16 5v17.5M8 1.5V19",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$2$, _path2$1a, _path3$l;
function _extends$3d() {
  return _extends$3d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3d.apply(null, arguments);
}
function SvgMastercard(props) {
  return /*#__PURE__*/createElement("svg", _extends$3d({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2$ || (_path$2$ = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.179 16.8a6.653 6.653 0 01-2.382-5.1c0-2.042.924-3.87 2.382-5.1A6.802 6.802 0 007.781 5C4.036 5 1 8 1 11.7s3.036 6.7 6.78 6.7a6.803 6.803 0 004.399-1.6z",
    fill: "currentColor"
  })), _path2$1a || (_path2$1a = /*#__PURE__*/createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.179 16.8a6.653 6.653 0 002.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.653 6.653 0 00-2.382 5.1c0 2.042.924 3.87 2.382 5.1z",
    fill: "currentColor"
  })), _path3$l || (_path3$l = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.179 16.8a6.653 6.653 0 002.382-5.1c0-2.042-.924-3.87-2.382-5.1A6.802 6.802 0 0116.577 5c3.745 0 6.78 3 6.78 6.7s-3.035 6.7-6.78 6.7a6.802 6.802 0 01-4.398-1.6z",
    fill: "currentColor",
    opacity: 0.2
  })));
}

var _path$30;
function _extends$3e() {
  return _extends$3e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3e.apply(null, arguments);
}
function SvgMasterComponent(props) {
  return /*#__PURE__*/createElement("svg", _extends$3e({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$30 || (_path$30 = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M8.364 18.264l3.536-3.536 3.535 3.536-3.535 3.535zM2 11.9l3.535-3.536 3.536 3.535-3.536 3.536zM14.728 11.899l3.535-3.535 3.536 3.535-3.536 3.536zM8.364 5.536L11.9 2l3.535 3.536L11.9 9.07z"
  })));
}

var _path$31, _circle$s, _path2$1b;
function _extends$3f() {
  return _extends$3f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3f.apply(null, arguments);
}
function SvgMedical(props) {
  return /*#__PURE__*/createElement("svg", _extends$3f({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$31 || (_path$31 = /*#__PURE__*/createElement("path", {
    d: "M12 22.5v.5m0-18v6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$s || (_circle$s = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 3,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1b || (_path2$1b = /*#__PURE__*/createElement("path", {
    d: "M8 7.197C6 5.5 5 4 5 1H1m15 6.197C18.5 5.5 19 4 19 1h4M2 7h1M21 7h1M8 11H6a2 2 0 00-2 2v0a2 2 0 002 2h10a2 2 0 012 2v0a2 2 0 01-2 2H8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$9, _defs$8;
function _extends$3g() {
  return _extends$3g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3g.apply(null, arguments);
}
function SvgMedium(props) {
  return /*#__PURE__*/createElement("svg", _extends$3g({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$9 || (_g$9 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Medium_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.846 6.887a.928.928 0 00-.303-.784l-2.24-2.7V3h6.958l5.378 11.795L17.367 3H24v.403L22.084 5.24a.561.561 0 00-.213.538v13.498a.56.56 0 00.213.537l1.871 1.837v.403h-9.412v-.403l1.939-1.882c.19-.19.19-.246.19-.537V8.321l-5.389 13.688h-.728L4.28 8.321v9.174c-.052.385.076.774.347 1.052l2.521 3.058v.404H0v-.404l2.521-3.058c.27-.279.39-.67.325-1.052V6.887z",
    fill: "currentColor"
  }))), _defs$8 || (_defs$8 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Medium_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var _path$32;
function _extends$3h() {
  return _extends$3h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3h.apply(null, arguments);
}
function SvgMenuLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$3h({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$32 || (_path$32 = /*#__PURE__*/createElement("path", {
    d: "M4 7h16M4 17h12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$33;
function _extends$3i() {
  return _extends$3i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3i.apply(null, arguments);
}
function SvgMenuRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$3i({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$33 || (_path$33 = /*#__PURE__*/createElement("path", {
    d: "M4 7h16M8 17h12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _rect$o, _path$34, _path2$1c;
function _extends$3j() {
  return _extends$3j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3j.apply(null, arguments);
}
function SvgMicrophone(props) {
  return /*#__PURE__*/createElement("svg", _extends$3j({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$o || (_rect$o = /*#__PURE__*/createElement("rect", {
    x: 8,
    y: 1,
    width: 8,
    height: 14,
    rx: 4,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$34 || (_path$34 = /*#__PURE__*/createElement("path", {
    d: "M4 9.5V11a8 8 0 008 8v0a8 8 0 008-8V9.5M12 19v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$1c || (_path2$1c = /*#__PURE__*/createElement("path", {
    d: "M16 24a1 1 0 100-2v2zm-8-2a1 1 0 100 2v-2zm8 0H8v2h8v-2z",
    fill: "currentColor"
  })));
}

var _circle$t, _circle2$7;
function _extends$3k() {
  return _extends$3k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3k.apply(null, arguments);
}
function SvgMore(props) {
  return /*#__PURE__*/createElement("svg", _extends$3k({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$t || (_circle$t = /*#__PURE__*/createElement("circle", {
    cx: 7,
    cy: 12,
    r: 2,
    transform: "rotate(-90 7 12)",
    fill: "currentColor"
  })), _circle2$7 || (_circle2$7 = /*#__PURE__*/createElement("circle", {
    cx: 17,
    cy: 12,
    r: 2,
    transform: "rotate(-90 17 12)",
    fill: "currentColor"
  })));
}

var _circle$u, _circle2$8;
function _extends$3l() {
  return _extends$3l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3l.apply(null, arguments);
}
function SvgMoreVert(props) {
  return /*#__PURE__*/createElement("svg", _extends$3l({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$u || (_circle$u = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 7,
    r: 2,
    fill: "currentColor"
  })), _circle2$8 || (_circle2$8 = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 17,
    r: 2,
    fill: "currentColor"
  })));
}

var _rect$p, _path$35;
function _extends$3m() {
  return _extends$3m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3m.apply(null, arguments);
}
function SvgMoviesIconRed(props) {
  return /*#__PURE__*/createElement("svg", _extends$3m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$p || (_rect$p = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 2,
    stroke: "#F25858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path$35 || (_path$35 = /*#__PURE__*/createElement("path", {
    d: "M1.2 12h21.6M1.2 6.545H6M1.2 17.455H6M18 6.545h4.8M18 17.455h4.8M17.4 1.09v21.82M6.6 1.09v21.82",
    stroke: "#F25858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$36, _path2$1d;
function _extends$3n() {
  return _extends$3n = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3n.apply(null, arguments);
}
function SvgMusicIconRed(props) {
  return /*#__PURE__*/createElement("svg", _extends$3n({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$36 || (_path$36 = /*#__PURE__*/createElement("path", {
    d: "M1 14.5A2.5 2.5 0 013.5 12H6v2.5A2.5 2.5 0 013.5 17v0A2.5 2.5 0 011 14.5v0zM8 20.5a2.5 2.5 0 012.5-2.5H13v2.5a2.5 2.5 0 01-2.5 2.5v0A2.5 2.5 0 018 20.5v0zM18 18.5a2.5 2.5 0 012.5-2.5H23v2.5a2.5 2.5 0 01-2.5 2.5v0a2.5 2.5 0 01-2.5-2.5v0zM13 13l10-3",
    stroke: "#F25858",
    strokeWidth: 2
  })), _path2$1d || (_path2$1d = /*#__PURE__*/createElement("path", {
    d: "M11 4V1L6 3v9M23 16V5L13 8v10",
    stroke: "#F25858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$37, _path2$1e;
function _extends$3o() {
  return _extends$3o = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3o.apply(null, arguments);
}
function SvgMusicNote(props) {
  return /*#__PURE__*/createElement("svg", _extends$3o({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$37 || (_path$37 = /*#__PURE__*/createElement("path", {
    d: "M1 14.5A2.5 2.5 0 013.5 12H6v2.5A2.5 2.5 0 013.5 17v0A2.5 2.5 0 011 14.5v0zM8 20.5a2.5 2.5 0 012.5-2.5H13v2.5a2.5 2.5 0 01-2.5 2.5v0A2.5 2.5 0 018 20.5v0zM18 18.5a2.5 2.5 0 012.5-2.5H23v2.5a2.5 2.5 0 01-2.5 2.5v0a2.5 2.5 0 01-2.5-2.5v0zM13 13l10-3",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1e || (_path2$1e = /*#__PURE__*/createElement("path", {
    d: "M11 4V1L6 3v9M23 16V5L13 8v10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$38;
function _extends$3p() {
  return _extends$3p = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3p.apply(null, arguments);
}
function SvgNetflix(props) {
  return /*#__PURE__*/createElement("svg", _extends$3p({
    width: "1.41em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$38 || (_path$38 = /*#__PURE__*/createElement("path", {
    d: "M15.282 0v12l-4.5-12h-4.5v24h4.5V12l4.5 12h4.5V0h-4.5z",
    fill: "currentColor"
  })));
}

var _path$39;
function _extends$3q() {
  return _extends$3q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3q.apply(null, arguments);
}
function SvgNike(props) {
  return /*#__PURE__*/createElement("svg", _extends$3q({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$39 || (_path$39 = /*#__PURE__*/createElement("path", {
    d: "M2.848 16.728c-.701-.029-1.275-.229-1.723-.6a3.52 3.52 0 01-.358-.373 2.359 2.359 0 01-.388-.727c-.253-.791-.123-1.83.374-2.97.425-.976 1.081-1.943 2.226-3.284.168-.197.67-.774.674-.774l-.061.11a7.182 7.182 0 00-.691 1.66c-.223.85-.196 1.579.079 2.144.19.39.514.727.88.913.639.327 1.575.354 2.718.08.08-.02 3.98-1.098 8.669-2.398s8.526-2.361 8.526-2.36c.002 0-10.893 4.857-16.55 7.376-.895.399-1.134.5-1.555.654-1.077.394-2.041.581-2.82.55z",
    fill: "currentColor"
  })));
}

var _path$3a;
function _extends$3r() {
  return _extends$3r = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3r.apply(null, arguments);
}
function SvgNotificationBell(props) {
  return /*#__PURE__*/createElement("svg", _extends$3r({
    width: "1.083em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3a || (_path$3a = /*#__PURE__*/createElement("path", {
    d: "M20.333 9.014c0-1.86-.772-3.644-2.147-4.96C16.81 2.74 14.945 2 13 2c-1.945 0-3.81.739-5.185 2.054-1.376 1.316-2.148 3.1-2.148 4.96 0 5.934-2.454 8.795-3.803 9.92-.203.168-.07.602.193.602h6.465c.117 0 .219.08.253.191C9 20.453 10 23 13 23c3.001 0 4-2.547 4.225-3.273a.267.267 0 01.253-.19h6.465c.264 0 .395-.435.193-.604-1.349-1.124-3.803-3.985-3.803-9.919z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3b, _path2$1f, _path3$m, _path4$7, _path5$3;
function _extends$3s() {
  return _extends$3s = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3s.apply(null, arguments);
}
function SvgOfficeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$3s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3b || (_path$3b = /*#__PURE__*/createElement("path", {
    d: "M1 4l11.58-2.482A2 2 0 0115 3.474V23H1V4z",
    stroke: "#F25858",
    strokeWidth: 2
  })), _path2$1f || (_path2$1f = /*#__PURE__*/createElement("path", {
    d: "M6 19h4v4H6v-4z",
    stroke: "#F25858",
    strokeWidth: 2
  })), _path3$m || (_path3$m = /*#__PURE__*/createElement("path", {
    d: "M19 14h4M19 10h4M19 18h4",
    stroke: "#F25858",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4$7 || (_path4$7 = /*#__PURE__*/createElement("path", {
    stroke: "#F25858",
    strokeWidth: 2,
    d: "M15 5h8v18h-8zM19 0v5"
  })), _path5$3 || (_path5$3 = /*#__PURE__*/createElement("path", {
    d: "M4 15h3M9 15h3M9 7h3M4 7h3M4 11h3M9 11h3",
    stroke: "#F25858",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var _path$3c, _path2$1g, _path3$n;
function _extends$3t() {
  return _extends$3t = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3t.apply(null, arguments);
}
function SvgPalmTree(props) {
  return /*#__PURE__*/createElement("svg", _extends$3t({
    width: ".96em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3c || (_path$3c = /*#__PURE__*/createElement("path", {
    d: "M9 24h14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1g || (_path2$1g = /*#__PURE__*/createElement("path", {
    d: "M18.53 16.475c.518 2.74.368 7.525.368 7.525h-4.776s.75-5.874.368-8.654c-.342-2.486-1.837-4.891-1.837-4.891S11.867 11.495 11.5 13c-.315 1.29-.5 5.5-.5 5.5s-1.953-1.273-2.688-4.283c-.734-3.01.188-4.514.188-4.514s-1.898.545-3 1.297c-1.102.752-3.5 3.217-3.5 3.217s.367-5.643 2.571-6.772C6.675 6.368 8.98 5.94 8.98 5.94S7.853 4.93 7 4.5c-1.253-.633-3.5-.818-3.5-.818S6.5 2 8.98 2.554c1.792.4 3.306 1.128 3.306 1.128S13.376 2.281 14.5 2c2-.5 4 1 4 1s-1.842.573-2.5 1.5c-.37.52-.775 1.44-.775 1.44s1.836.376 2.938 1.505S20.5 11 20.5 11s-1.5-1-2.813-1.297C16.837 9.509 15.5 9.5 15.5 9.5s2.47 4 3.03 6.975z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$n || (_path3$n = /*#__PURE__*/createElement("path", {
    d: "M15.947 11.394a1 1 0 10-.894-1.788l.894 1.788zm1.87 4.055a1 1 0 00-.633-1.898l.632 1.898zm.807 5.043a1 1 0 10-.248-1.984l.248 1.984zm-4.677-8.098l2-1-.894-1.788-2 1 .894 1.788zm.87 4.055l3-1-.633-1.898-3 1 .632 1.898zm-.193 4.543l4-.5-.248-1.984-4 .5.248 1.984z",
    fill: "currentColor"
  })));
}

var _path$3d, _path2$1h, _path3$o;
function _extends$3u() {
  return _extends$3u = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3u.apply(null, arguments);
}
function SvgPandafood(props) {
  return /*#__PURE__*/createElement("svg", _extends$3u({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3d || (_path$3d = /*#__PURE__*/createElement("path", {
    d: "M12.338 17.647c1.588 0 2.912-1.147 2.912-2.559H9.426c0 1.412 1.236 2.56 2.912 2.56z",
    fill: "currentColor"
  })), _path2$1h || (_path2$1h = /*#__PURE__*/createElement("path", {
    d: "M22.132 5.47c.706-.529 1.06-1.411 1.06-2.382C23.191 1.324 21.778 0 20.014 0c-1.148 0-2.118.53-2.648 1.412C15.78.618 14.015.265 12.25.265c-1.853 0-3.618.44-5.118 1.147C6.602.529 5.632 0 4.485 0 2.72 0 1.31 1.412 1.31 3.088c0 .97.44 1.765 1.059 2.383C1.044 7.41.338 9.618.338 12.088.338 18.618 5.632 24 12.25 24c6.53 0 11.912-5.294 11.912-11.912 0-2.47-.706-4.764-2.03-6.617zm-9.794 17.56c-6 0-10.941-4.942-10.941-10.942 0-2.294.706-4.412 1.853-6.176C4.309 4.324 5.809 3 7.573 2.206c1.412-.706 3.089-1.059 4.765-1.059 1.677 0 3.353.353 4.765 1.059 1.764.882 3.176 2.118 4.323 3.706a11.312 11.312 0 011.853 6.176c0 6-4.94 10.941-10.94 10.941z",
    fill: "currentColor"
  })), _path3$o || (_path3$o = /*#__PURE__*/createElement("path", {
    d: "M12.338 14.382c.177.088 2.03-.617 2.03-1.5 0-.53-1.5-.617-2.03-.617-.53 0-2.03.088-2.03.617-.088.883 1.854 1.588 2.03 1.5zM19.22 6.97c-1.058-.705-3.352-1.058-4.235.089 0 0-1.147 1.235 0 2.47 1.147 1.236 1.941 2.471 2.206 3.442.265 1.059.706 1.411 1.5 1.411s2.383-1.235 2.647-3.264c.177-2.03-1.059-3.53-2.117-4.147zm-2.382 2.56a.603.603 0 01-.617-.618c0-.353.264-.618.617-.618s.618.265.618.618a.603.603 0 01-.618.617zM9.603 7.059c-.882-1.147-3.177-.794-4.235-.088-1.06.706-2.295 2.117-2.118 4.147.176 2.03 1.765 3.264 2.647 3.264.794 0 1.235-.44 1.5-1.411.265-1.06 1.147-2.206 2.206-3.442 1.147-1.323 0-2.47 0-2.47zm-1.677 2.47a.603.603 0 01-.617-.617c0-.353.264-.618.617-.618s.618.265.618.618a.603.603 0 01-.618.617z",
    fill: "currentColor"
  })));
}

var _circle$v, _path$3e;
function _extends$3v() {
  return _extends$3v = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3v.apply(null, arguments);
}
function SvgParking(props) {
  return /*#__PURE__*/createElement("svg", _extends$3v({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$v || (_circle$v = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$3e || (_path$3e = /*#__PURE__*/createElement("path", {
    d: "M9 18v-4M12.37 7H9v7h3.37c2.005 0 3.63-1.567 3.63-3.5S14.375 7 12.37 7z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3f, _rect$q;
function _extends$3w() {
  return _extends$3w = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3w.apply(null, arguments);
}
function SvgPaste(props) {
  return /*#__PURE__*/createElement("svg", _extends$3w({
    width: ".727em",
    height: "1em",
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3f || (_path$3f = /*#__PURE__*/createElement("path", {
    d: "M6 4.018v0a3 3 0 00-3 3v20.784a3 3 0 003 3h12a3 3 0 003-3V7.018a3 3 0 00-3-3v0",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect$q || (_rect$q = /*#__PURE__*/createElement("rect", {
    x: 6,
    y: 1.339,
    width: 12,
    height: 5.357,
    rx: 2.678,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$r, _rect2$5;
function _extends$3x() {
  return _extends$3x = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3x.apply(null, arguments);
}
function SvgPause(props) {
  return /*#__PURE__*/createElement("svg", _extends$3x({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$r || (_rect$r = /*#__PURE__*/createElement("rect", {
    x: 15,
    y: 4,
    width: 6,
    height: 16,
    rx: 1.5,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2$5 || (_rect2$5 = /*#__PURE__*/createElement("rect", {
    x: 3,
    y: 4,
    width: 6,
    height: 16,
    rx: 1.5,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3g;
function _extends$3y() {
  return _extends$3y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3y.apply(null, arguments);
}
function SvgPayPal(props) {
  return /*#__PURE__*/createElement("svg", _extends$3y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3g || (_path$3g = /*#__PURE__*/createElement("path", {
    d: "M21.006 6.474c.315.109.608.237.878.384.317-2.1-.003-3.529-1.098-4.823C19.58.61 17.401 0 14.614 0H6.522c-.57 0-1.055.43-1.143 1.014l-3.37 22.152c-.067.439.26.834.685.834H7.69l1.223-8.037c.105-.56.576-.969 1.132-.969h2.374c4.663 0 8.314-1.963 9.38-7.644.032-.168.06-.332.085-.492a5.665 5.665 0 00-.878-.383z",
    fill: "currentColor"
  })));
}

var _path$3h, _path2$1i;
function _extends$3z() {
  return _extends$3z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3z.apply(null, arguments);
}
function SvgPetCat(props) {
  return /*#__PURE__*/createElement("svg", _extends$3z({
    width: ".963em",
    height: "1em",
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3h || (_path$3h = /*#__PURE__*/createElement("path", {
    d: "M4 3l5 4s2.812-.5 4-.5c1.188 0 4 .5 4 .5l5-4v14a8 8 0 01-8 8h-2a8 8 0 01-8-8V3z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1i || (_path2$1i = /*#__PURE__*/createElement("path", {
    d: "M1.061 15.305l6.894 1.216M10 12v.5M16 12v.5M2.061 20.695l5.909-1.042M24.94 15.305l-6.894 1.216M23.94 20.695l-5.91-1.042M13 20l.002-1.999L14.732 17 13 17.998 11.268 17l1.73 1.001L13 20z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3i, _circle$w, _path2$1j, _path3$p;
function _extends$3A() {
  return _extends$3A = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3A.apply(null, arguments);
}
function SvgPetDog(props) {
  return /*#__PURE__*/createElement("svg", _extends$3A({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3i || (_path$3i = /*#__PURE__*/createElement("path", {
    d: "M19 9v6.5a3.5 3.5 0 11-7 0 3.5 3.5 0 11-7 0V9a7 7 0 0114 0z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle$w || (_circle$w = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 14,
    r: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1j || (_path2$1j = /*#__PURE__*/createElement("path", {
    d: "M19 7v0a2.64 2.64 0 013.447 2.13l.308 2.158A1.5 1.5 0 0121.27 13H19V7zM5 7v0a2.64 2.64 0 00-3.447 2.13l-.308 2.158A1.5 1.5 0 002.73 13H5V7z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$p || (_path3$p = /*#__PURE__*/createElement("path", {
    d: "M10 9v.5M14 9v.5M10 19s0 2.5 2 2.5 2-2.5 2-2.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _rect$s, _path$3j;
function _extends$3B() {
  return _extends$3B = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3B.apply(null, arguments);
}
function SvgPhoneIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$3B({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$s || (_rect$s = /*#__PURE__*/createElement("rect", {
    x: 5,
    y: 1,
    width: 14,
    height: 22,
    rx: 3,
    stroke: "#F25858",
    strokeWidth: 2
  })), _path$3j || (_path$3j = /*#__PURE__*/createElement("path", {
    d: "M11 19h2",
    stroke: "#F25858",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$3k, _path2$1k;
function _extends$3C() {
  return _extends$3C = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3C.apply(null, arguments);
}
function SvgPineTree(props) {
  return /*#__PURE__*/createElement("svg", _extends$3C({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3k || (_path$3k = /*#__PURE__*/createElement("path", {
    d: "M15 4c0 .292-.042.574-.12.84A.125.125 0 0015 5v0a3 3 0 012.775 4.143c-.285.691-.2 1.706.282 2.277a4 4 0 01-5.198 5.959 1.645 1.645 0 00-1.718 0 4 4 0 01-5.198-5.959c.483-.571.567-1.586.282-2.277a3 3 0 012.859-4.141v0a.061.061 0 00.06-.08A3 3 0 1115 4z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1k || (_path2$1k = /*#__PURE__*/createElement("path", {
    d: "M9 23h6M12 17.5V23M14 9v1M10 12v1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3l;
function _extends$3D() {
  return _extends$3D = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3D.apply(null, arguments);
}
function SvgPinterest(props) {
  return /*#__PURE__*/createElement("svg", _extends$3D({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3l || (_path$3l = /*#__PURE__*/createElement("path", {
    d: "M12 0C5.372 0 0 5.372 0 12c0 5.086 3.164 9.427 7.627 11.175-.104-.952-.202-2.405.042-3.44.22-.938 1.406-5.963 1.406-5.963s-.36-.717-.36-1.781c0-1.67.965-2.916 2.17-2.916 1.021 0 1.518.769 1.518 1.692 0 1.031-.656 2.569-.994 3.994-.28 1.195.6 2.17 1.777 2.17 2.133 0 3.773-2.25 3.773-5.494 0-2.873-2.062-4.884-5.01-4.884-3.413 0-5.42 2.56-5.42 5.208 0 1.031.4 2.137.896 2.737a.359.359 0 01.084.343c-.089.38-.295 1.195-.332 1.359-.052.22-.174.267-.404.16-1.5-.7-2.437-2.888-2.437-4.65 0-3.788 2.752-7.262 7.926-7.262 4.163 0 7.397 2.968 7.397 6.933 0 4.135-2.606 7.463-6.225 7.463-1.214 0-2.357-.633-2.751-1.378 0 0-.6 2.292-.745 2.854-.272 1.04-1.004 2.349-1.491 3.146C9.572 23.812 10.763 24 12 24c6.628 0 12-5.372 12-12S18.628 0 12 0z",
    fill: "currentColor"
  })));
}

var _circle$x, _path$3m, _circle2$9;
function _extends$3E() {
  return _extends$3E = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3E.apply(null, arguments);
}
function SvgPlanet(props) {
  return /*#__PURE__*/createElement("svg", _extends$3E({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$x || (_circle$x = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 11.937,
    r: 8,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$3m || (_path$3m = /*#__PURE__*/createElement("path", {
    d: "M6.764 1.382c-1.022-.23-1.85-.13-2.385.353-1.866 1.68.516 7.367 5.32 12.703 4.804 5.335 10.211 8.298 12.077 6.618.716-.644.806-1.879.375-3.457",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2$9 || (_circle2$9 = /*#__PURE__*/createElement("circle", {
    cx: 13,
    cy: 9.937,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3n, _circle$y;
function _extends$3F() {
  return _extends$3F = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3F.apply(null, arguments);
}
function SvgPlanetEarth(props) {
  return /*#__PURE__*/createElement("svg", _extends$3F({
    width: ".96em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3n || (_path$3n = /*#__PURE__*/createElement("path", {
    d: "M12.77 2.027l.07-.998-1.356-.094.314 1.322.973-.23zm9.561 7.188l.265.964 1.048-.288-.374-1.02-.939.344zm-9.538-7.096l-.973.231.973-.23zm.338.63l-.73.684.73-.683zm.152.163l.73-.683-.73.683zm.216 1.056l.94.342-.94-.342zm-.037.103l-.94-.342.94.342zm.55 1.178l.341-.94-.342.94zm.599.963l.994.107-.994-.107zm-.077.715l.994.107-.994-.107zm.485 1.452l.73-.683-.73.683zm.339.362l.73-.684-.73.684zm1.852.594l.196.98-.196-.98zm1.701-.34l.196.98-.196-.98zm.69-.017l-.15.989.15-.99zm1.903.286l.149-.989-.149.989zM5.891 22.149l-.556.832.536.358.548-.34-.528-.85zm.83-18.802l.68-.731-.528-.493-.633.348.48.877zm.673.627l.681-.732-.681.732zm.4.518l-.882.473.881-.473zm.433.808l-.88.473.03.057.037.052.813-.582zm.808 1.128l-.813.582.813-.582zm.479 2.464l-.942.337.942-.337zm-.74 2.119l-.527-.85.527.85zm-.381.236l.527.85-.527-.85zm-.308.236l-.682-.732.682.732zm-1.04.967l-.68-.732.68.732zm-.891.83l.681.732-.681-.732zm-.569 1.983l-.966.259.966-.26zm.13.483l.966-.26-.966.26zm.569.945l-.682.732.682-.732zm.405.378l.682-.732-.682.732zm.52.79l-.941.336.941-.337zm.427 1.191l-.941.337.941-.337zm.046.128l.942-.337-.942.337zm-.828 2.374l.527.85-.527-.85zm5.344-7.732l-.673-.74.673.74zm.09-.082l.673.74-.673-.74zm-.33 2.477l.806-.592-.807.592zm.326 1.343l.988.155-.988-.155zm-.202 1.284l-.988-.155.988.155zm.039.397l-.939.344.939-.344zm1.034.467l.363.931-.363-.931zm1.113-.434l.363.932-.363-.932zm.926-.748l.835.55-.835-.55zm.61-.925l-.834-.55.835.55zm.215-.27l-.728-.686.728.686zm.819-.869l.727.686-.727-.686zm-.238-2.187l.563-.826-.022-.016-.023-.013-.518.855zm-.773-.469l-.518.856.518-.856zm-.593-.24l-.222.976.222-.975zm-1.084-.246l-.29.957.034.01.034.008.222-.975zM12.702 3.024c4.004.277 7.364 2.915 8.69 6.535l1.878-.689c-1.59-4.34-5.618-7.508-10.43-7.841l-.138 1.995zm-.904-.767l.022.093 1.946-.461-.022-.093-1.946.461zm.022.093c.096.406.296.78.581 1.083l1.46-1.367a.391.391 0 01-.095-.177l-1.946.461zm.581 1.083l.152.163 1.46-1.367-.152-.163-1.46 1.367zm.152.163a.03.03 0 01.007.03l1.879.684a2.03 2.03 0 00-.426-2.081l-1.46 1.367zm.007.03l-.038.103 1.88.684.037-.103-1.88-.684zm-.038.103a1.92 1.92 0 001.147 2.46l.684-1.88a.08.08 0 01.048.104l-1.879-.684zm1.147 2.46a.08.08 0 01-.053-.084l1.989.214a1.92 1.92 0 00-1.252-2.01l-.684 1.88zm-.053-.084l-.077.715 1.989.214.077-.715-1.989-.214zm-.077.715c-.088.82.186 1.64.75 2.243l1.46-1.367a.837.837 0 01-.221-.662l-1.989-.214zm.75 2.243l.339.361 1.46-1.367-.339-.361-1.46 1.367zm.339.361a3 3 0 002.778.891l-.392-1.96a1 1 0 01-.926-.298l-1.46 1.367zm2.778.891l1.701-.34-.392-1.961-1.701.34.392 1.961zm1.701-.34a1 1 0 01.345-.008l.297-1.978a3 3 0 00-1.034.025l.392 1.961zm.345-.008l1.904.286.297-1.978-1.904-.286-.297 1.978zm1.904.286a3 3 0 001.24-.074l-.53-1.929a1 1 0 01-.413.025l-.297 1.978zM6.447 21.318A9.99 9.99 0 012 13H0c0 4.163 2.12 7.83 5.335 9.98l1.112-1.662zM2 13c0-3.782 2.1-7.075 5.201-8.776L6.24 2.471A11.997 11.997 0 000 13h2zm6.075-9.758l-.673-.626L6.039 4.08l.674.626 1.362-1.464zm.599.777a3 3 0 00-.599-.777L6.713 4.706a1 1 0 01.2.26l1.761-.947zm.434.808l-.434-.808-1.762.946.434.808 1.762-.946zm.74 1.018L9.04 4.718 7.414 5.882l.808 1.128 1.626-1.165zm.561 1.747a3 3 0 00-.561-1.747L8.222 7.01a1 1 0 01.187.582h2zm0 .698v-.698h-2v.698h2zm.046.265a.786.786 0 01-.046-.265h-2c0 .32.055.638.163.939l1.883-.674zM9.301 11.86a2.785 2.785 0 001.154-3.305l-1.883.674a.785.785 0 01-.325.932l1.054 1.7zm-.381.237l.381-.237-1.054-1.7-.381.238 1.054 1.699zm-.154.118c.047-.044.099-.084.154-.118l-1.054-1.7c-.166.103-.32.221-.463.354l1.363 1.464zm-1.04.967l1.04-.967-1.363-1.464-1.039.967 1.363 1.464zm-.89.83l.89-.83-1.362-1.464-.891.83 1.362 1.464zm-.285.991a1 1 0 01.284-.991l-1.362-1.464a3 3 0 00-.854 2.974l1.932-.519zm.13.483l-.13-.483-1.932.519.13.483 1.932-.519zm.284.473a1 1 0 01-.284-.473l-1.932.52a3 3 0 00.853 1.417l1.363-1.464zm.406.378l-.406-.378-1.363 1.464.406.378 1.363-1.464zm.78 1.184a2.999 2.999 0 00-.78-1.184L6.008 17.8a1 1 0 01.26.395l1.883-.674zm.427 1.192L8.15 17.52l-1.883.674.427 1.192 1.883-.674zm.046.128l-.046-.128-1.883.674.046.129 1.883-.675zm-1.243 3.56a3 3 0 001.243-3.56l-1.883.675a1 1 0 01-.414 1.187l1.054 1.699zM6.42 23l.962-.597-1.054-1.7-.963.598L6.42 23zm6.452-8.439l.09-.082-1.345-1.48-.09.082 1.345 1.48zm-.107 1.063a.799.799 0 01.107-1.063l-1.346-1.48a2.799 2.799 0 00-.374 3.726l1.613-1.183zm.508 2.09a2.799 2.799 0 00-.508-2.09l-1.613 1.183a.799.799 0 01.145.596l1.976.31zm-.202 1.284l.202-1.284-1.976-.31-.202 1.284 1.976.31zm-.01-.102a.206.206 0 01.01.102l-1.976-.31c-.047.301-.017.61.088.896l1.878-.688zm-.268-.121a.205.205 0 01.268.12l-1.878.69c.346.943 1.4 1.418 2.336 1.053l-.726-1.863zm1.113-.434l-1.113.434.726 1.863 1.113-.433-.726-1.864zm.455-.367a.964.964 0 01-.455.367l.726 1.864a2.965 2.965 0 001.398-1.13l-1.67-1.1zm.61-.925l-.61.925 1.669 1.102.61-.925-1.669-1.102zm.321-.405a3 3 0 00-.32.405l1.668 1.102c.032-.048.068-.093.107-.135l-1.455-1.372zm.819-.869l-.819.869 1.455 1.372.82-.869-1.456-1.372zm-.073-.675a.446.446 0 01.073.675l1.455 1.372a2.447 2.447 0 00-.402-3.7L16.037 15.1zm-.728-.44l.773.469 1.036-1.71-.772-.469-1.037 1.71zm-.297-.12a1 1 0 01.297.12l1.037-1.71a3.002 3.002 0 00-.89-.36l-.444 1.95zm-1.084-.246l1.084.247.444-1.95-1.084-.247-.444 1.95zm-.967.185a.934.934 0 01.899-.203l.58-1.914a2.934 2.934 0 00-2.824.637l1.345 1.48z",
    fill: "currentColor"
  })), _circle$y || (_circle$y = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 13,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3o;
function _extends$3G() {
  return _extends$3G = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3G.apply(null, arguments);
}
function SvgPlay(props) {
  return /*#__PURE__*/createElement("svg", _extends$3G({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3o || (_path$3o = /*#__PURE__*/createElement("path", {
    d: "M5 5.655a1.5 1.5 0 012.274-1.284l10.528 6.344a1.5 1.5 0 010 2.57L7.274 19.629A1.5 1.5 0 015 18.345V5.655z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3p, _path2$1l;
function _extends$3H() {
  return _extends$3H = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3H.apply(null, arguments);
}
function SvgPlaylist(props) {
  return /*#__PURE__*/createElement("svg", _extends$3H({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3p || (_path$3p = /*#__PURE__*/createElement("path", {
    d: "M17 8h6M10 14.5h13M1 21.5h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1l || (_path2$1l = /*#__PURE__*/createElement("path", {
    d: "M0 2.97c0-.746.758-1.211 1.364-.839l8.181 5.03c.607.373.607 1.305 0 1.677l-8.181 5.03C.758 14.242 0 13.777 0 13.03V2.97z",
    fill: "currentColor"
  })));
}

var _path$3q;
function _extends$3I() {
  return _extends$3I = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3I.apply(null, arguments);
}
function SvgPlaystation(props) {
  return /*#__PURE__*/createElement("svg", _extends$3I({
    width: "1.316em",
    height: "1em",
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3q || (_path$3q = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.612 14.177c-.469.592-1.617 1.014-1.617 1.014L14.45 18.26v-2.264l6.288-2.24c.714-.256.823-.617.244-.807-.58-.19-1.628-.136-2.342.121l-4.19 1.476v-2.35l.242-.081s1.21-.428 2.913-.617c1.702-.188 3.787.026 5.423.646 1.845.583 2.052 1.442 1.584 2.033zm-9.348-3.854V4.535c0-.68-.126-1.306-.764-1.483-.488-.156-.791.297-.791.976v14.496l-3.91-1.241V0c1.663.308 4.084 1.038 5.386 1.477 3.31 1.136 4.433 2.551 4.433 5.738 0 3.107-1.918 4.284-4.354 3.108zM2.627 15.76c-1.893-.534-2.208-1.644-1.345-2.284.797-.591 2.153-1.036 2.153-1.036l5.605-1.993v2.272l-4.033 1.443c-.713.256-.822.618-.243.808.58.19 1.628.135 2.342-.12l1.934-.703v2.033c-.122.022-.259.044-.386.065a12.683 12.683 0 01-6.027-.485z",
    fill: "currentColor"
  })));
}

var _path$3r, _path2$1m, _circle$z, _path3$q;
function _extends$3J() {
  return _extends$3J = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3J.apply(null, arguments);
}
function SvgPodCast(props) {
  return /*#__PURE__*/createElement("svg", _extends$3J({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3r || (_path$3r = /*#__PURE__*/createElement("path", {
    d: "M6.665 15.5A6.243 6.243 0 015.5 11.864C5.5 8.349 8.41 5.5 12 5.5s6.5 2.85 6.5 6.364c0 1.352-.43 2.605-1.165 3.636",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1m || (_path2$1m = /*#__PURE__*/createElement("path", {
    d: "M18.983 20.5A10.978 10.978 0 0023 12c0-6.075-4.925-11-11-11S1 5.925 1 12c0 3.72 1.847 7.01 4.674 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$z || (_circle$z = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$q || (_path3$q = /*#__PURE__*/createElement("path", {
    d: "M9.326 19.283A2 2 0 0111.306 17h1.388a2 2 0 011.98 2.283l-.286 2A2 2 0 0112.408 23h-.816a2 2 0 01-1.98-1.717l-.286-2z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _circle$A, _path$3s;
function _extends$3K() {
  return _extends$3K = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3K.apply(null, arguments);
}
function SvgPoints(props) {
  return /*#__PURE__*/createElement("svg", _extends$3K({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$A || (_circle$A = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$3s || (_path$3s = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.087 5.06a7.058 7.058 0 011.826 0 1 1 0 01-.259 1.982 5.058 5.058 0 00-1.308 0 1 1 0 01-.259-1.983zm3.773 1.57a1 1 0 011.402-.183c.485.372.919.806 1.291 1.291a1 1 0 01-1.586 1.219 5.039 5.039 0 00-.924-.924 1 1 0 01-.183-1.403zm-5.72 0a1 1 0 01-.183 1.403 5.036 5.036 0 00-.924.924 1 1 0 11-1.586-1.219 7.036 7.036 0 011.291-1.291 1 1 0 011.402.183zm8.68 3.595a1 1 0 011.12.862 7.063 7.063 0 010 1.826 1 1 0 01-1.982-.259 5.053 5.053 0 000-1.308 1 1 0 01.862-1.121zm-11.64 0a1 1 0 01.862 1.12 5.058 5.058 0 000 1.31 1 1 0 01-1.983.258 7.058 7.058 0 010-1.826 1 1 0 011.121-.862zm11.19 4.635a1 1 0 01.183 1.402 7.036 7.036 0 01-1.291 1.291 1 1 0 01-1.219-1.586 5.04 5.04 0 00.925-.924 1 1 0 011.402-.183zm-10.74 0a1 1 0 011.403.183c.266.347.577.658.924.925a1 1 0 11-1.219 1.585 7.036 7.036 0 01-1.291-1.291 1 1 0 01.183-1.402zm3.595 2.96a1 1 0 011.12-.862 5.053 5.053 0 001.31 0 1 1 0 01.258 1.983 7.063 7.063 0 01-1.826 0 1 1 0 01-.862-1.121z",
    fill: "currentColor"
  })));
}

var _path$3t, _path2$1n, _path3$r, _path4$8;
function _extends$3L() {
  return _extends$3L = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3L.apply(null, arguments);
}
function SvgPool(props) {
  return /*#__PURE__*/createElement("svg", _extends$3L({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3t || (_path$3t = /*#__PURE__*/createElement("path", {
    d: "M1 21s1 2 3.75 2 3.75-2 3.75-2 1.5 2 3.5 2 3.5-2 3.5-2 1.5 2 3.75 2S23 21 23 21M1 15s1 2 3.75 2 3.75-2 3.75-2 1.5 2 3.5 2 3.5-2 3.5-2 1.5 2 3.75 2S23 15 23 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1n || (_path2$1n = /*#__PURE__*/createElement("path", {
    d: "M20 16.5V3a2 2 0 012-2h1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$r || (_path3$r = /*#__PURE__*/createElement("path", {
    d: "M12 10h8M12 5h8",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4$8 || (_path4$8 = /*#__PURE__*/createElement("path", {
    d: "M12 16.5V3a2 2 0 012-2h1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$a, _defs$9;
function _extends$3M() {
  return _extends$3M = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3M.apply(null, arguments);
}
function SvgPowerOnOff(props) {
  return /*#__PURE__*/createElement("svg", _extends$3M({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$a || (_g$a = /*#__PURE__*/createElement("g", {
    clipPath: "url(#PowerOnOff_svg__clip0)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.364 6.636a9 9 0 11-12.728 0M12 3v10"
  }))), _defs$9 || (_defs$9 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "PowerOnOff_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var _path$3u, _path2$1o;
function _extends$3N() {
  return _extends$3N = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3N.apply(null, arguments);
}
function SvgPrinter(props) {
  return /*#__PURE__*/createElement("svg", _extends$3N({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3u || (_path$3u = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 14h12v9H6zM6 1h12v5H6z"
  })), _path2$1o || (_path2$1o = /*#__PURE__*/createElement("path", {
    d: "M6 17H1V8a2 2 0 012-2h18a2 2 0 012 2v9h-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3v;
function _extends$3O() {
  return _extends$3O = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3O.apply(null, arguments);
}
function SvgProfile(props) {
  return /*#__PURE__*/createElement("svg", _extends$3O({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3v || (_path$3v = /*#__PURE__*/createElement("path", {
    d: "M18.95 17.38c-1.572-.813-4.165-1.88-6.95-1.88s-5.378 1.067-6.95 1.88c-1.016.525-1.627 1.555-1.762 2.69L3 22.5h18l-.288-2.43c-.135-1.135-.746-2.165-1.761-2.69zM12 11a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3w;
function _extends$3P() {
  return _extends$3P = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3P.apply(null, arguments);
}
function SvgPuzzleIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$3P({
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3w || (_path$3w = /*#__PURE__*/createElement("path", {
    d: "M2.5 22.059h-2a2 2 0 002 2v-2zm13.97-11.177v2h2v-2h-2zm11.177 0h-2v2h2v-2zm13.97 13.97h-2v2h2v-2zm0 11.177v-2h-2v2h2zM30.442 50h-2a2 2 0 002 2v-2zm-16.764 0v2a2 2 0 002-2h-2zM2.5 38.824v-2a2 2 0 00-2 2h2zm2-16.765V11.882h-4V22.06h4zm-1-9.177h12.97v-4H3.5v4zm14.97-2V4.5h-4v6.382h4zm0-6.382h7.177v-4h-7.176v4zm7.177 0v6.382h4V4.5h-4zm2 8.382h12.97v-4h-12.97v4zm11.97-1v12.97h4v-12.97h-4zm2 14.97H48v-4h-6.382v4zm6.383 0v7.177h4v-7.176h-4zm0 7.177h-6.382v4H48v-4zm-8.382 2V49h4V36.03h-4zm1 11.971H30.44v4h10.177v-4zm-26.942 0H3.5v4h10.177v-4zM4.5 49V38.824h-4V49h4zm9.177 1c2 0 2 0 2 .002v-.03l.01-.19c.013-.176.04-.44.093-.763.11-.655.324-1.497.733-2.316.405-.81.982-1.56 1.81-2.111.814-.544 1.99-.974 3.736-.974v-4c-2.446 0-4.413.617-5.956 1.645-1.53 1.02-2.525 2.366-3.168 3.651a12.298 12.298 0 00-1.1 3.447 12.295 12.295 0 00-.155 1.478 5.903 5.903 0 00-.003.105v.054c0 .001 0 .002 2 .002zm8.382-6.382c1.745 0 2.922.43 3.736.974.828.551 1.404 1.3 1.81 2.111.409.819.623 1.661.732 2.316a8.291 8.291 0 01.103.953l.001.036v-.002-.002-.002c0-.001 0-.002 2-.002s2-.001 2-.002v-.002-.005-.013-.034a7.277 7.277 0 00-.021-.447c-.02-.282-.06-.672-.137-1.136a12.298 12.298 0 00-1.1-3.447c-.643-1.285-1.639-2.63-3.169-3.65-1.543-1.03-3.51-1.646-5.955-1.646v4zM2.5 22.058c0 2-.001 2-.002 2h-.002-.004l.036.002a8.294 8.294 0 01.953.103c.655.109 1.497.323 2.316.732.81.406 1.56.982 2.112 1.81.543.814.973 1.99.973 3.736h4c0-2.445-.617-4.412-1.645-5.955-1.02-1.53-2.366-2.526-3.651-3.168a12.3 12.3 0 00-3.447-1.101 12.254 12.254 0 00-1.478-.155 7.227 7.227 0 00-.105-.003h-.052-.002c-.001 0-.002 0-.002 2zm6.382 8.383c0 1.746-.43 2.922-.973 3.737-.552.827-1.302 1.404-2.112 1.809-.819.41-1.661.624-2.316.733a8.287 8.287 0 01-.99.104c-.002 0-.002 0 0 0h.007c.001 0 .002 0 .002 2s.001 2 .002 2h.02l.034-.001.105-.003a12.295 12.295 0 001.478-.155c.916-.152 2.17-.462 3.447-1.1 1.285-.643 2.63-1.638 3.65-3.168 1.03-1.543 1.646-3.51 1.646-5.956h-4zM39.618 49a1 1 0 011-1v4a3 3 0 003-3h-4zM48 34.03v4a4 4 0 004-4h-4zM25.647 4.5h4a4 4 0 00-4-4v4zM48 26.853h4a4 4 0 00-4-4v4zM3.5 48a1 1 0 011 1h-4a3 3 0 003 3v-4zM18.47 4.5v-4a4 4 0 00-4 4h4zm22.148 8.382a1 1 0 01-1-1h4a3 3 0 00-3-3v4zm-36.118-1a1 1 0 01-1 1v-4a3 3 0 00-3 3h4z",
    fill: "currentColor"
  })));
}

var _path$3x;
function _extends$3Q() {
  return _extends$3Q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3Q.apply(null, arguments);
}
function SvgQrCode(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Q({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3x || (_path$3x = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M1 1h6v6H1zM1 17h6v6H1zM17 1h6v6h-6zM10 1h4M10 4h4M12 12h4M13 18h5M8 10h4M0 12h4M6 12h4M10 14h2M20 20h2M22 15h2M14 10h2M10 18h3M19 11h5M16 16h4M10 23h8M11 1v7M13 15v7M23 19v5M19 10v6"
  })));
}

var _circle$B, _path$3y;
function _extends$3R() {
  return _extends$3R = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3R.apply(null, arguments);
}
function SvgQuestion(props) {
  return /*#__PURE__*/createElement("svg", _extends$3R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$B || (_circle$B = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#77838F",
    strokeWidth: 2
  })), _path$3y || (_path$3y = /*#__PURE__*/createElement("path", {
    d: "M12 14v-.77c0-.994.763-1.813 1.613-2.326C14.434 10.41 15.22 9.53 15 8c-.429-3-4.5-1.5-4.5-1.5M12 17v.5",
    stroke: "#77838F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3z;
function _extends$3S() {
  return _extends$3S = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3S.apply(null, arguments);
}
function SvgQuoteLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$3S({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3z || (_path$3z = /*#__PURE__*/createElement("path", {
    d: "M10.323 14.753c0-1.205-.373-2.237-1.119-3.097a5.188 5.188 0 00-2.838-1.807c.114-.745.401-1.52.86-2.322.516-.86 1.06-1.548 1.634-2.065L7.14 4C2.38 7.154 0 10.738 0 14.753c0 1.49.487 2.752 1.462 3.785C2.495 19.512 3.728 20 5.162 20c1.433 0 2.637-.516 3.612-1.548 1.032-1.033 1.549-2.266 1.549-3.7zm13.677 0c0-1.205-.373-2.237-1.118-3.097a5.187 5.187 0 00-2.839-1.807 8.408 8.408 0 01.946-2.408c.516-.803 1.061-1.462 1.635-1.979L20.817 4C16 7.269 13.591 10.853 13.591 14.753c0 1.433.517 2.666 1.549 3.699C16.172 19.484 17.405 20 18.839 20c1.376 0 2.58-.516 3.613-1.548 1.032-1.033 1.548-2.266 1.548-3.7z",
    fill: "currentColor"
  })));
}

var _path$3A;
function _extends$3T() {
  return _extends$3T = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3T.apply(null, arguments);
}
function SvgQuoteRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$3T({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3A || (_path$3A = /*#__PURE__*/createElement("path", {
    d: "M10.323 9.333c0-1.433-.517-2.666-1.549-3.699C7.8 4.544 6.595 4 5.161 4c-1.433 0-2.666.545-3.699 1.634C.487 6.667 0 7.9 0 9.334c0 1.204.373 2.265 1.118 3.182a5.188 5.188 0 002.839 1.807c-.057.745-.344 1.52-.86 2.322-.459.803-.975 1.463-1.549 1.979L3.097 20c2.122-1.262 3.842-2.81 5.161-4.645 1.376-1.835 2.065-3.843 2.065-6.022zm13.677 0c0-1.433-.516-2.666-1.548-3.699C21.419 4.544 20.186 4 18.752 4c-1.433 0-2.666.545-3.698 1.634-.975 1.033-1.463 2.266-1.463 3.7 0 1.204.373 2.265 1.119 3.182a5.187 5.187 0 002.838 1.807c-.114.745-.43 1.52-.946 2.322-.459.803-.975 1.463-1.548 1.979L16.774 20c2.122-1.262 3.842-2.81 5.162-4.645C23.312 13.52 24 11.512 24 9.333z",
    fill: "currentColor"
  })));
}

var _path$3B;
function _extends$3U() {
  return _extends$3U = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3U.apply(null, arguments);
}
function SvgReadBook(props) {
  return /*#__PURE__*/createElement("svg", _extends$3U({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3B || (_path$3B = /*#__PURE__*/createElement("path", {
    d: "M1 5.2l-.625-.78A1 1 0 000 5.2h1zM12 21l-.625.78.625.5.625-.5L12 21zM1 21H0a1 1 0 001.625.78L1 21zM23 5.2h1a1 1 0 00-.375-.78L23 5.2zM23 21l-.625.78A1 1 0 0024 21h-1zM11 5.2V21h2V5.2h-2zM2 21V5.2H0V21h2zM1 5.2c.625.78.625.781.624.781a.265.265 0 01.02-.015l.078-.06a12.281 12.281 0 011.468-.924C4.163 4.462 5.366 4 6.5 4V2c-1.617 0-3.164.638-4.252 1.218A14.28 14.28 0 00.525 4.304a7.606 7.606 0 00-.148.114H.375L1 5.2zM6.5 4c1.133 0 2.336.462 3.31.982a12.266 12.266 0 011.468.925l.078.059.017.013.003.003L12 5.2c.625-.78.624-.781.624-.781l-.001-.001-.003-.003-.01-.007a5.114 5.114 0 00-.135-.104 14.275 14.275 0 00-1.723-1.087C9.664 2.638 8.117 2 6.5 2v2zM12 21c.625-.78.624-.781.624-.781l-.001-.002c-.001 0-.002 0-.003-.002l-.01-.007-.03-.023a11.88 11.88 0 00-.488-.353 14.28 14.28 0 00-1.34-.814C9.664 18.438 8.117 17.8 6.5 17.8v2c1.133 0 2.336.462 3.31.982a12.26 12.26 0 011.468.925l.078.059.017.013.003.003L12 21zm-5.5-3.2c-1.617 0-3.164.638-4.252 1.218a14.285 14.285 0 00-1.723 1.086l-.106.08-.03.024-.009.007a.048.048 0 01-.004.003L1 21c.625.78.625.781.624.781l.003-.002.017-.013.078-.06a12.275 12.275 0 011.468-.924c.974-.52 2.177-.982 3.31-.982v-2zM22 5.2V21h2V5.2h-2zm-10 0c.625.78.624.781.624.781l.003-.002.017-.013.078-.06a12.27 12.27 0 011.467-.924C15.164 4.462 16.366 4 17.5 4V2c-1.617 0-3.164.638-4.252 1.218a14.275 14.275 0 00-1.723 1.086 7.891 7.891 0 00-.136.104l-.009.007a.104.104 0 00-.003.003h-.001L12 5.2zM17.5 4c1.134 0 2.336.462 3.31.982a12.27 12.27 0 011.468.925l.078.059.017.013.003.003L23 5.2c.625-.78.625-.781.624-.781l-.001-.001-.003-.003-.01-.007a5.114 5.114 0 00-.135-.104 14.275 14.275 0 00-1.723-1.087C20.664 2.638 19.116 2 17.5 2v2zM23 21c.625-.78.625-.781.624-.781l-.001-.002c-.001 0-.002 0-.003-.002l-.01-.007-.03-.023a11.88 11.88 0 00-.488-.353 14.28 14.28 0 00-1.34-.814c-1.088-.58-2.636-1.218-4.252-1.218v2c1.134 0 2.336.462 3.31.982a12.264 12.264 0 011.468.925l.078.059.017.013.003.003L23 21zm-5.5-3.2c-1.617 0-3.164.638-4.252 1.218a14.28 14.28 0 00-1.723 1.086l-.106.08-.03.024-.009.007a.078.078 0 01-.004.003L12 21c.625.78.624.781.624.781l.003-.002.017-.013a7.077 7.077 0 01.394-.285c.277-.19.675-.445 1.151-.699.975-.52 2.177-.982 3.311-.982v-2z",
    fill: "currentColor"
  })));
}

var _path$3C, _path2$1p;
function _extends$3V() {
  return _extends$3V = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3V.apply(null, arguments);
}
function SvgRefresh(props) {
  return /*#__PURE__*/createElement("svg", _extends$3V({
    width: "1.083em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3C || (_path$3C = /*#__PURE__*/createElement("path", {
    d: "M4.237 9.52a9 9 0 0117.108-.598M21.18 15.499a9 9 0 01-16.449.305",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1p || (_path2$1p = /*#__PURE__*/createElement("path", {
    d: "M6.714 14.935l-2.567.38-1.236 2.282M19.133 9.73l2.567-.38 1.236-2.283",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3D, _path2$1q;
function _extends$3W() {
  return _extends$3W = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3W.apply(null, arguments);
}
function SvgRoomServiceHelp(props) {
  return /*#__PURE__*/createElement("svg", _extends$3W({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3D || (_path$3D = /*#__PURE__*/createElement("path", {
    d: "M10 3h4M12 3v4M3 16v4M21 16v4M1 16h22M1 20h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1q || (_path2$1q = /*#__PURE__*/createElement("path", {
    d: "M21 16a9 9 0 00-18 0h18z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3E;
function _extends$3X() {
  return _extends$3X = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3X.apply(null, arguments);
}
function SvgRoomUpgrade(props) {
  return /*#__PURE__*/createElement("svg", _extends$3X({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3E || (_path$3E = /*#__PURE__*/createElement("path", {
    d: "M12.5 1a6 6 0 016 6v14a2 2 0 01-2 2h-8a2 2 0 01-2-2v-7a2 2 0 012-2H11c2 0 3.5-2 3.5-4s-1-3-2.5-3c-.881 0-1.417.518-1.811 1.25-.5.927-1.487 1.522-2.5 1.233v0c-.962-.275-1.593-1.237-1.318-2.199C7.035 2.954 8.465 1 12.5 1z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3F;
function _extends$3Y() {
  return _extends$3Y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3Y.apply(null, arguments);
}
function SvgSaveFavoriteBookmark(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3F || (_path$3F = /*#__PURE__*/createElement("path", {
    d: "M13.14 16.586l6.075 4.218a.5.5 0 00.785-.41V7a4 4 0 00-4-4H8a4 4 0 00-4 4v13.393a.5.5 0 00.785.41l6.074-4.217a2 2 0 012.282 0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3G;
function _extends$3Z() {
  return _extends$3Z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3Z.apply(null, arguments);
}
function SvgSaveFavoriteImportant(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Z({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3G || (_path$3G = /*#__PURE__*/createElement("path", {
    d: "M3 4h12l6 8-6 8H3l6-8-6-8z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3H, _path2$1r;
function _extends$3_() {
  return _extends$3_ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3_.apply(null, arguments);
}
function SvgScroll(props) {
  return /*#__PURE__*/createElement("svg", _extends$3_({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3H || (_path$3H = /*#__PURE__*/createElement("path", {
    d: "M16 22c2 0 2-2 2-2V4s0-2 2-2 2 2 2 2v3h-4m-2 15c-2 0-2-2-2-2v-3H2v3s0 2 2 2h12z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1r || (_path2$1r = /*#__PURE__*/createElement("path", {
    d: "M5 17V4s0-2 2-2h13M9 8h5M9 12h5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3I;
function _extends$3$() {
  return _extends$3$ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3$.apply(null, arguments);
}
function SvgSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$3$({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3I || (_path$3I = /*#__PURE__*/createElement("path", {
    d: "M11 20a9 9 0 100-18 9 9 0 000 18zM21 21l-3-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3J;
function _extends$40() {
  return _extends$40 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$40.apply(null, arguments);
}
function SvgSend(props) {
  return /*#__PURE__*/createElement("svg", _extends$40({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3J || (_path$3J = /*#__PURE__*/createElement("path", {
    d: "M2.227 12.827c-.828-.318-.862-1.477-.055-1.844l18.735-8.516c.841-.382 1.706.483 1.324 1.325l-8.516 18.735c-.367.807-1.525.772-1.844-.055L9.352 15.92a1 1 0 00-.574-.574l-6.551-2.52z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _rect$t, _path$3K, _path2$1s;
function _extends$41() {
  return _extends$41 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$41.apply(null, arguments);
}
function SvgServer(props) {
  return /*#__PURE__*/createElement("svg", _extends$41({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$t || (_rect$t = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 3,
    width: 22,
    height: 20,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$3K || (_path$3K = /*#__PURE__*/createElement("path", {
    d: "M1 13h22",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1s || (_path2$1s = /*#__PURE__*/createElement("path", {
    d: "M7 8h1M7 18h1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$C, _path$3L;
function _extends$42() {
  return _extends$42 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$42.apply(null, arguments);
}
function SvgSettings(props) {
  return /*#__PURE__*/createElement("svg", _extends$42({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$C || (_circle$C = /*#__PURE__*/createElement("circle", {
    cx: 13,
    cy: 13,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$3L || (_path$3L = /*#__PURE__*/createElement("path", {
    d: "M11.284 2.863c.777-1.296 2.655-1.296 3.432 0l.705 1.178a2 2 0 002.202.912l1.332-.334c1.465-.367 2.793.96 2.426 2.426l-.334 1.332a2 2 0 00.912 2.202l1.178.705c1.296.777 1.296 2.655 0 3.432l-1.178.705a2 2 0 00-.912 2.202l.334 1.332c.367 1.465-.96 2.793-2.426 2.426l-1.332-.334a2 2 0 00-2.202.912l-.705 1.178c-.777 1.296-2.655 1.296-3.432 0l-.705-1.178a2 2 0 00-2.202-.912l-1.332.334c-1.465.367-2.793-.96-2.426-2.426l.334-1.332a2 2 0 00-.912-2.202l-1.178-.705c-1.296-.777-1.296-2.655 0-3.432l1.178-.705a2 2 0 00.912-2.202l-.334-1.332c-.367-1.465.96-2.793 2.426-2.426l1.332.334a2 2 0 002.202-.912l.705-1.178z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3M;
function _extends$43() {
  return _extends$43 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$43.apply(null, arguments);
}
function SvgShare(props) {
  return /*#__PURE__*/createElement("svg", _extends$43({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3M || (_path$3M = /*#__PURE__*/createElement("path", {
    d: "M15.57 5.988A3.81 3.81 0 0023 4.808a3.808 3.808 0 10-7.43 1.18zm0 0L8.13 9.714m0 0a3.808 3.808 0 10-.104 3.9m.103-3.9a3.84 3.84 0 01-.104 3.9m0 0l7.86 3.69m0 0A3.808 3.808 0 1022.5 21.08a3.808 3.808 0 00-6.614-3.777z",
    stroke: "#000",
    strokeWidth: 2
  })));
}

var _path$3N;
function _extends$44() {
  return _extends$44 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$44.apply(null, arguments);
}
function SvgShareBack(props) {
  return /*#__PURE__*/createElement("svg", _extends$44({
    width: ".727em",
    height: "1em",
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3N || (_path$3N = /*#__PURE__*/createElement("path", {
    d: "M9.826 9.194V5L2 12.13l7.826 7.13v-4.194s2.174-.42 6.087 1.258S22 20 22 20s-.87-4.85-4.783-7.87c-3.913-3.02-7.39-2.936-7.39-2.936z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3O;
function _extends$45() {
  return _extends$45 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$45.apply(null, arguments);
}
function SvgShareBack1(props) {
  return /*#__PURE__*/createElement("svg", _extends$45({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3O || (_path$3O = /*#__PURE__*/createElement("path", {
    d: "M9.609 8.753V4L1 12.08l8.609 8.081v-4.753s2.391-.475 6.695 1.426C20.61 18.735 23 21 23 21s-.956-5.497-5.26-8.92c-4.305-3.422-8.131-3.327-8.131-3.327z",
    fill: "currentColor"
  })));
}

var _path$3P;
function _extends$46() {
  return _extends$46 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$46.apply(null, arguments);
}
function SvgShazam(props) {
  return /*#__PURE__*/createElement("svg", _extends$46({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3P || (_path$3P = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.393 24 0 18.643 0 12S5.393-.036 12 0c6.607 0 12 5.357 12 12 0 6.607-5.357 12-12 12zm3.143-4.25c.107-.072 2.143-2.036 3.285-3.286a5.361 5.361 0 001.43-4.071 5.76 5.76 0 00-2.037-4c-2-1.75-5.25-1.714-7.214.071a28.227 28.227 0 00-1.571 1.572A1.37 1.37 0 009.107 12a1.37 1.37 0 001.964-.071l.049-.05c.18-.187.816-.846 1.344-1.343 1.036-.929 2.679-.75 3.536-.036.643.536 1.036 1.286 1.071 2.072a2.854 2.854 0 01-.714 2.035c-.973 1.07-2.74 2.758-3.084 3.087l-.059.056a1.401 1.401 0 00-.036 1.964 1.41 1.41 0 001 .429c.358 0 .68-.143.965-.393zm-8.679-4.464c1 .857 2.286 1.285 3.572 1.285 1.321 0 2.643-.464 3.643-1.357.625-.563 1.333-1.318 1.523-1.52l.048-.051a1.37 1.37 0 00-.072-1.964 1.37 1.37 0 00-1.964.071 9.474 9.474 0 00-.048.05c-.18.187-.816.846-1.345 1.343-1.035.928-2.678.75-3.535.036-.643-.536-1.036-1.286-1.072-2.072a2.854 2.854 0 01.715-2.036c.972-1.07 2.74-2.757 3.084-3.086l.058-.056a1.401 1.401 0 00.036-1.965 1.401 1.401 0 00-1.964-.035C9.036 4 7 5.964 5.857 7.214c-1 1.143-1.536 2.572-1.428 4.072a5.76 5.76 0 002.035 4z",
    fill: "currentColor"
  })));
}

var _path$3Q, _path2$1t;
function _extends$47() {
  return _extends$47 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$47.apply(null, arguments);
}
function SvgSheildwithCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$47({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3Q || (_path$3Q = /*#__PURE__*/createElement("path", {
    d: "M3.002 4L12 1l8.998 3S21 7 21 13s-9 10-9 10-9-4-9-10 .002-9 .002-9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1t || (_path2$1t = /*#__PURE__*/createElement("path", {
    d: "M9 10.95l2.121 2.121 4.243-4.243",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$3R;
function _extends$48() {
  return _extends$48 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$48.apply(null, arguments);
}
function SvgShopify(props) {
  return /*#__PURE__*/createElement("svg", _extends$48({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3R || (_path$3R = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.06 24v-.01l-.042.01-13.68-2.559S3.096 7.845 3.166 7.367c.084-.632.098-.646.773-.857.054-.023.33-.108.764-.241.368-.113.848-.26 1.401-.434C6.568 3.866 8.06 0 11.152 0c.394 0 .872.225 1.237.703h.127c1.335 0 2.08 1.139 2.516 2.39.436-.14.703-.225.717-.225a.849.849 0 01.337-.019v-.023c.057 0 .127.028.184.084.154.127 1.434 1.406 1.434 1.406s1.841.14 1.926.14a.38.38 0 01.239.212c.014.126 2.615 17.73 2.615 17.73L15.06 24zm-.787-20.71c-.337.098-.745.225-1.153.366v-.254c0-.759-.098-1.377-.281-1.87.703.085 1.139.858 1.434 1.758zm-2.292-1.603c.183.478.31 1.153.31 2.081v.14c-.304.096-.615.192-.931.29-.475.145-.962.296-1.46.456.464-1.772 1.35-2.643 2.081-2.967zm-.9-.872c.141 0 .282.057.394.141-.998.464-2.053 1.631-2.488 3.993-.306.098-.606.19-.9.28-.341.103-.674.205-.998.31C7.595 3.74 8.86.816 11.08.816zm.535 10.46l.9-2.713s-.619-.365-1.828-.351c-3.248 0-4.85 2.165-4.85 4.4 0 1.503.835 2.183 1.567 2.777.57.463 1.075.875 1.075 1.582 0 .394-.28.928-.97.928-1.04 0-2.277-1.069-2.277-1.069L4.6 18.91s1.181 1.462 3.543 1.462c1.954 0 3.402-1.476 3.402-3.767 0-1.762-1.184-2.633-2.12-3.32-.61-.448-1.113-.818-1.113-1.306 0-.225.07-1.139 1.518-1.139.97 0 1.786.436 1.786.436z",
    fill: "currentColor"
  })));
}

var _path$3S, _path2$1u;
function _extends$49() {
  return _extends$49 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$49.apply(null, arguments);
}
function SvgShreaded(props) {
  return /*#__PURE__*/createElement("svg", _extends$49({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3S || (_path$3S = /*#__PURE__*/createElement("path", {
    d: "M19 20v-6H5v6M15.5 19v-5M12 20v-6M8.5 22v-8M5 1h14v5H5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1u || (_path2$1u = /*#__PURE__*/createElement("path", {
    d: "M23 17V9a3 3 0 00-3-3H4a3 3 0 00-3 3v8M19 10h-2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$b, _defs$a;
function _extends$4a() {
  return _extends$4a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4a.apply(null, arguments);
}
function SvgSlack(props) {
  return /*#__PURE__*/createElement("svg", _extends$4a({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$b || (_g$b = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Slack_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M4.997 15.187a2.544 2.544 0 01-2.538 2.538 2.544 2.544 0 01-2.538-2.538A2.544 2.544 0 012.46 12.65h2.538v2.538zM6.275 15.187a2.544 2.544 0 012.538-2.538 2.544 2.544 0 012.538 2.538v6.354a2.544 2.544 0 01-2.538 2.538 2.544 2.544 0 01-2.538-2.538v-6.354zM8.813 4.997a2.544 2.544 0 01-2.538-2.538A2.544 2.544 0 018.813-.079a2.544 2.544 0 012.538 2.538v2.538H8.813zM8.813 6.275a2.544 2.544 0 012.538 2.538 2.544 2.544 0 01-2.538 2.538H2.46A2.544 2.544 0 01-.079 8.813 2.544 2.544 0 012.46 6.275h6.354zM19.003 8.813a2.544 2.544 0 012.538-2.538 2.544 2.544 0 012.538 2.538 2.544 2.544 0 01-2.538 2.538h-2.538V8.813zM17.725 8.813a2.544 2.544 0 01-2.538 2.538 2.544 2.544 0 01-2.538-2.538V2.46a2.544 2.544 0 012.538-2.538 2.544 2.544 0 012.538 2.538v6.354zM15.187 19.003a2.544 2.544 0 012.538 2.538 2.544 2.544 0 01-2.538 2.538 2.544 2.544 0 01-2.538-2.538v-2.538h2.538zM15.187 17.725a2.544 2.544 0 01-2.538-2.538 2.544 2.544 0 012.538-2.538h6.354a2.544 2.544 0 012.538 2.538 2.544 2.544 0 01-2.538 2.538h-6.354z"
  }))), _defs$a || (_defs$a = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Slack_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var _path$3T, _rect$u, _rect2$6, _path2$1v;
function _extends$4b() {
  return _extends$4b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4b.apply(null, arguments);
}
function SvgSleepingBed(props) {
  return /*#__PURE__*/createElement("svg", _extends$4b({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3T || (_path$3T = /*#__PURE__*/createElement("path", {
    d: "M2 6a2 2 0 012-2h16a2 2 0 012 2v7H2V6zM1 15a2 2 0 012-2h18a2 2 0 012 2v3H1v-3z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect$u || (_rect$u = /*#__PURE__*/createElement("rect", {
    x: 5.5,
    y: 9,
    width: 5,
    height: 4,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2$6 || (_rect2$6 = /*#__PURE__*/createElement("rect", {
    x: 13.5,
    y: 9,
    width: 5,
    height: 4,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1v || (_path2$1v = /*#__PURE__*/createElement("path", {
    d: "M22 18v2M2 18v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3U;
function _extends$4c() {
  return _extends$4c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4c.apply(null, arguments);
}
function SvgSnap(props) {
  return /*#__PURE__*/createElement("svg", _extends$4c({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3U || (_path$3U = /*#__PURE__*/createElement("path", {
    d: "M23.97 18.18c-.104-.352-.605-.6-.605-.6l-.124-.066a9.65 9.65 0 01-2.197-1.462c-.5-.451-.93-.947-1.273-1.473a5.599 5.599 0 01-.703-1.47c-.047-.19-.04-.266 0-.365.033-.083.13-.162.175-.2.281-.202.735-.501 1.014-.683.241-.16.448-.296.57-.382.391-.279.66-.562.817-.868.204-.395.23-.83.07-1.258-.214-.577-.745-.921-1.42-.921-.15 0-.304.018-.458.05a7.067 7.067 0 00-1.059.347.032.032 0 01-.045-.033c.033-.772.07-1.81-.015-2.793-.075-.891-.256-1.643-.55-2.298-.297-.658-.683-1.144-.984-1.496A6.072 6.072 0 0015.629.94C14.556.316 13.337 0 12.002 0 10.669 0 9.45.316 8.377.939a6.13 6.13 0 00-1.557 1.27c-.301.352-.687.838-.984 1.496-.296.655-.475 1.404-.55 2.298-.085.989-.05 1.943-.015 2.793 0 .026-.022.043-.047.033a7.071 7.071 0 00-1.059-.347 2.174 2.174 0 00-.458-.05c-.673 0-1.203.344-1.42.921-.16.428-.135.863.07 1.258.159.306.426.59.817.868.12.086.328.222.57.382.272.18.712.47.996.67.035.026.155.117.192.213.04.101.048.177-.005.38a5.617 5.617 0 01-.697 1.455 7.463 7.463 0 01-1.273 1.473A9.65 9.65 0 01.76 17.514c-.04.02-.087.043-.137.073 0 0-.498.259-.593.593-.14.493.232.956.608 1.204.618.405 1.37.623 1.806.742.122.033.231.063.331.093.062.02.22.081.287.17.084.111.094.248.124.402.047.26.155.582.47.805.35.243.79.26 1.351.283.585.023 1.313.051 2.147.332.386.129.738.35 1.141.602.847.529 1.9 1.187 3.7 1.187 1.8 0 2.861-.66 3.713-1.192.404-.25.75-.468 1.129-.595.834-.28 1.561-.308 2.147-.331.56-.023 1.001-.038 1.35-.284.339-.237.436-.592.48-.857.026-.132.04-.25.115-.347.065-.084.21-.142.277-.165.102-.032.216-.063.343-.098.436-.12.984-.258 1.65-.64.802-.464.856-1.03.772-1.311z",
    fill: "currentColor"
  })));
}

var _path$3V;
function _extends$4d() {
  return _extends$4d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4d.apply(null, arguments);
}
function SvgSoundMuted(props) {
  return /*#__PURE__*/createElement("svg", _extends$4d({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3V || (_path$3V = /*#__PURE__*/createElement("path", {
    d: "M1 9h4l5-4v14l-5-4H1V9zM15 9l6.364 6.364M15 15.364L21.364 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3W, _path2$1w;
function _extends$4e() {
  return _extends$4e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4e.apply(null, arguments);
}
function SvgSoundPlaying(props) {
  return /*#__PURE__*/createElement("svg", _extends$4e({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3W || (_path$3W = /*#__PURE__*/createElement("path", {
    d: "M1 9.167h4l5-4v14l-5-4H1v-6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1w || (_path2$1w = /*#__PURE__*/createElement("path", {
    d: "M19.702 4a11 11 0 010 15.556M15.435 7.803a6 6 0 010 8.485",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$3X, _path2$1x;
function _extends$4f() {
  return _extends$4f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4f.apply(null, arguments);
}
function SvgSpaceship(props) {
  return /*#__PURE__*/createElement("svg", _extends$4f({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3X || (_path$3X = /*#__PURE__*/createElement("path", {
    d: "M8 8.25C8.91 5.99 12 2 12 2s3.09 3.99 4 6.25c1.473 3.656-1 9.75-1 9.75H9s-2.473-6.094-1-9.75z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1x || (_path2$1x = /*#__PURE__*/createElement("path", {
    d: "M15 18h5l-3.5-6M9 18H4l3.5-6M10.021 19.786c.262-.847.658-1.786.658-1.786h2.633s.344.96.658 1.786C14.285 20.61 12 22.5 12 22.5s-2.24-1.868-1.979-2.714zM8 8s1.5 1 4 1 4-1 4-1",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$3Y;
function _extends$4g() {
  return _extends$4g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4g.apply(null, arguments);
}
function SvgSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends$4g({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3Y || (_path$3Y = /*#__PURE__*/createElement("path", {
    d: "M20 0H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h16c2.2 0 4.001-1.8 4.001-4V4c0-2.2-1.801-4-4-4zm-.363 18.365c0 .7-.573 1.27-1.273 1.27H5.636c-.7 0-1.273-.571-1.273-1.27V5.637c0-.7.573-1.273 1.273-1.273h12.728c.7 0 1.273.573 1.273 1.272v12.729zm-4.363-3.82a.729.729 0 01-.726.728H9.457a.728.728 0 01-.727-.727V9.454c0-.4.327-.727.727-.727h5.09c.4 0 .727.327.727.727v5.09z",
    fill: "currentColor"
  })));
}

var _path$3Z, _path2$1y;
function _extends$4h() {
  return _extends$4h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4h.apply(null, arguments);
}
function SvgStack(props) {
  return /*#__PURE__*/createElement("svg", _extends$4h({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3Z || (_path$3Z = /*#__PURE__*/createElement("path", {
    d: "M1.414 17.09a1 1 0 00-.828 1.82l.828-1.82zm22 1.82a1 1 0 00-.828-1.82l.828 1.82zM12 23l-.414.91a1 1 0 00.828 0L12 23zM.586 18.91l11 5 .828-1.82-11-5-.828 1.82zm11.828 5l11-5-.828-1.82-11 5 .828 1.82zM1.414 10.59a1 1 0 00-.828 1.82l.828-1.82zm22 1.82a1 1 0 00-.828-1.82l.828 1.82zM12 16.5l-.414.91a1 1 0 00.828 0L12 16.5zM.586 12.41l11 5 .828-1.82-11-5-.828 1.82zm11.828 5l11-5-.828-1.82-11 5 .828 1.82z",
    fill: "currentColor"
  })), _path2$1y || (_path2$1y = /*#__PURE__*/createElement("path", {
    d: "M12 1l11 4-11 5L1 5l11-4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3_;
function _extends$4i() {
  return _extends$4i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4i.apply(null, arguments);
}
function SvgStar(props) {
  return /*#__PURE__*/createElement("svg", _extends$4i({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3_ || (_path$3_ = /*#__PURE__*/createElement("path", {
    d: "M11.308 2.658a.75.75 0 011.384 0l2.202 5.274a.75.75 0 00.591.454l5.803.785a.75.75 0 01.373 1.325l-4.48 3.656a.75.75 0 00-.257.75l1.433 6.19c.155.67-.599 1.178-1.162.783l-4.764-3.344a.75.75 0 00-.862 0l-4.764 3.344c-.563.395-1.317-.113-1.162-.783l1.432-6.19a.75.75 0 00-.256-.75l-4.48-3.656a.75.75 0 01.373-1.325l5.803-.785a.75.75 0 00.591-.454l2.202-5.274z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 3.329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$3$;
function _extends$4j() {
  return _extends$4j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4j.apply(null, arguments);
}
function SvgStarbucks(props) {
  return /*#__PURE__*/createElement("svg", _extends$4j({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3$ || (_path$3$ = /*#__PURE__*/createElement("path", {
    d: "M14.02 5.224a7.135 7.135 0 00-2.41 0c-.06.01-.08-.051-.04-.082l1.245-.957s1.205.927 1.246.957c.04.03.02.092-.04.082zm-2.086 5.987s-.06.02-.08.081c.253.194.425.642.951.642.527 0 .699-.448.952-.642-.02-.06-.08-.081-.08-.081s-.335.081-.872.081c-.537 0-.87-.081-.87-.081zm.871-.744c-.142 0-.182-.05-.273-.05-.091 0-.284.081-.324.142 0 .03.02.061.04.092.213.03.314.153.557.153.243 0 .345-.123.557-.153.03-.03.04-.061.04-.092-.04-.071-.222-.142-.323-.142-.091-.01-.122.05-.274.05zm12.01 2.281c-.02.286-.04.58-.07.856-1.358.224-1.844-.988-3.241-.937.08.295.152.6.202.906 1.155 0 1.61 1.08 2.897.917-.071.325-.152.651-.243.977-1.013.102-1.367-.906-2.542-.886.01.173.01.336.01.51 0 .091 0 .193-.01.285 1.002-.01 1.326.916 2.278.875-.121.326-.253.642-.395.957-.688-.04-.921-.916-1.954-.845-.03.224-.07.448-.122.672.902-.06 1.094.774 1.742.835-.162.306-.344.6-.526.886-.385-.204-.72-.825-1.438-.866.07-.234.141-.468.192-.702-.648 0-1.377-.255-1.995-.815.203-1.15-1.57-2.311-1.57-3.156 0-.906.456-1.416.456-2.648 0-.916-.445-1.904-1.104-2.576a2.612 2.612 0 00-.415-.336c.608.764 1.084 1.66 1.084 2.709 0 1.16-.537 1.771-.537 2.84 0 1.07 1.56 1.996 1.56 3.096 0 .438-.142.855-.588 1.69.699.703 1.61 1.08 2.198 1.08.192 0 .293-.061.364-.204.061-.132.112-.265.162-.397.628.02.922.6 1.266.835-.192.255-.395.509-.607.753-.233-.264-.547-.702-1.013-.824-.081.163-.172.315-.264.478.396.112.669.51.882.774-.223.234-.466.458-.71.682-.151-.234-.394-.54-.657-.713l-.304.398c.233.152.425.438.557.662-.284.234-.578.448-.881.651-.152-1.232-1.813-2.067-1.367-3.492-.152.254-.324.57-.324.947 0 1.028 1.093 1.853 1.174 2.871-.223.132-.456.265-.699.387-.04-1.13-1.195-2.362-1.195-3.279 0-1.028 1.347-2.067 1.347-3.289s-1.55-2.067-1.55-3.136c0-1.07.66-1.68.66-3.055 0-1.008-.477-2.016-1.206-2.667a2.003 2.003 0 00-.415-.286c.689.835 1.094 1.589 1.094 2.74 0 1.293-.76 2.005-.76 3.268s1.52 1.965 1.52 3.136-1.419 2.17-1.419 3.38c0 1.1 1.246 2.2 1.266 3.504a8.24 8.24 0 01-.83.325c.162-1.313-1.246-2.678-1.246-3.757 0-1.17 1.469-2.19 1.469-3.452s-1.489-1.853-1.489-3.156c0-1.304.921-2.027.921-3.462 0-1.12-.546-2.128-1.357-2.75-.02-.01-.03-.03-.05-.04-.071-.061-.142.01-.081.081.567.713.87 1.436.87 2.505 0 1.314-1.052 2.383-1.052 3.655 0 1.508 1.417 1.935 1.417 3.167 0 1.232-1.519 2.22-1.519 3.534 0 1.211 1.438 2.566 1.185 3.96-.283.072-.577.143-.87.194.273-1.741-1.135-3.004-1.135-4.144 0-1.232 1.57-2.342 1.57-3.544 0-1.14-1.124-1.507-1.276-2.678-.02-.163-.152-.275-.324-.244-.233.04-.527.193-.983.193-.465 0-.749-.152-.982-.193-.172-.03-.304.091-.324.244-.152 1.171-1.276 1.538-1.276 2.678 0 1.212 1.57 2.312 1.57 3.544 0 1.14-1.408 2.393-1.134 4.144-.294-.05-.588-.122-.871-.194-.243-1.405 1.184-2.749 1.184-3.96 0-1.314-1.518-2.302-1.518-3.534 0-1.232 1.417-1.66 1.417-3.167 0-1.272-1.053-2.341-1.053-3.655 0-1.07.304-1.792.871-2.505.05-.071-.01-.132-.081-.081-.02.01-.03.03-.05.04a3.514 3.514 0 00-1.358 2.75c0 1.435.922 2.158.922 3.462 0 1.303-1.489 1.894-1.489 3.156 0 1.263 1.469 2.281 1.469 3.452 0 1.08-1.408 2.434-1.246 3.757a11.695 11.695 0 01-.83-.325c.02-1.304 1.266-2.404 1.266-3.503 0-1.212-1.418-2.2-1.418-3.38 0-1.182 1.519-1.874 1.519-3.137s-.76-1.975-.76-3.268c0-1.151.405-1.905 1.094-2.74a2.314 2.314 0 00-.415.286c-.73.651-1.205 1.67-1.205 2.667 0 1.375.658 1.986.658 3.055 0 1.07-1.55 1.914-1.55 3.136 0 1.222 1.347 2.25 1.347 3.29 0 .926-1.154 2.158-1.195 3.278-.232-.122-.465-.244-.698-.387.09-1.028 1.185-1.843 1.185-2.871 0-.377-.173-.693-.325-.947.446 1.425-1.215 2.27-1.367 3.492a10.953 10.953 0 01-.88-.652c.131-.224.334-.509.556-.661-.1-.133-.212-.255-.303-.398-.274.163-.507.469-.659.713a11.231 11.231 0 01-.709-.682c.213-.265.487-.672.881-.774a7.214 7.214 0 01-.263-.478c-.466.122-.78.56-1.012.824a10.961 10.961 0 01-.608-.753c.354-.234.638-.805 1.276-.835.05.132.111.265.162.397.07.153.172.204.364.204.588 0 1.5-.387 2.198-1.08-.456-.835-.587-1.252-.587-1.69 0-1.1 1.56-2.026 1.56-3.095 0-1.07-.538-1.68-.538-2.841 0-1.05.466-1.945 1.084-2.709a2.15 2.15 0 00-.415.336c-.669.672-1.104 1.67-1.104 2.576 0 1.232.456 1.731.456 2.648 0 .845-1.773 2.006-1.57 3.156a2.983 2.983 0 01-2.005.815c.06.234.121.468.192.703-.729.04-1.063.661-1.438.865a9.708 9.708 0 01-.526-.886c.648-.071.84-.906 1.742-.835a7.8 7.8 0 01-.122-.672c-1.043-.071-1.276.815-1.954.845a15.802 15.802 0 01-.395-.957c.952.04 1.276-.886 2.268-.876v-.285c0-.173.01-.336.01-.509-1.175-.03-1.529.988-2.542.886a13.765 13.765 0 01-.243-.977c1.276.162 1.742-.927 2.897-.917.05-.305.121-.61.202-.906-1.397-.061-1.883 1.16-3.24.937-.04-.285-.061-.57-.081-.856 1.58.174 2.177-1.13 3.615-.967.131-.346.293-.682.476-1.008-1.803-.316-2.42 1.202-4.102.967C.967 5.224 6.284 0 12.805 0c6.532 0 11.838 5.224 12.02 11.75-1.68.235-2.298-1.283-4.1-.967.181.326.333.662.475 1.008 1.438-.173 2.025 1.14 3.615.957zM7.641 7.678c-.881-.367-1.955-.275-2.876.315-.142-.855-.608-1.619-1.266-2.077-.091-.061-.182 0-.182.102.141 1.812-.912 3.38-2.208 4.765 1.337.408 2.47-1.324 4.192-.723a9.487 9.487 0 012.34-2.382zm5.164-1.09c-1.114 0-2.056.631-2.298 1.456-.02.061.01.102.08.071.203-.091.426-.132.679-.132.456 0 .86.173 1.094.458.1.346.111.856-.01 1.14-.183-.04-.254-.183-.436-.183s-.324.133-.638.133-.344-.153-.547-.153c-.243 0-.283.244-.283.53 0 1.252 1.144 2.973 2.36 2.973 1.214 0 2.359-1.721 2.359-2.973 0-.286-.061-.52-.304-.55a.75.75 0 01-.527.173c-.314 0-.395-.133-.577-.133-.223 0-.202.469-.466.5-.172-.418-.182-.968-.04-1.447.233-.295.638-.458 1.093-.458.244 0 .476.04.679.133.07.03.101-.01.08-.072-.242-.835-1.184-1.466-2.298-1.466zm1.783 1.792c-.274 0-.578.082-.78.306-.02.06-.02.152.01.203.486-.163.911-.173 1.124.061.111-.101.142-.193.142-.295 0-.163-.172-.275-.496-.275zm-3.91.57c.233-.234.73-.224 1.236-.04.02-.255-.435-.54-.891-.54-.334 0-.496.112-.496.275.01.112.04.204.152.305zm7.697-4.236c-.881.062-1.65.367-2.268.876a8.705 8.705 0 011.022-2.036c-1.124.122-2.056.53-2.744 1.242l-.537-1.415 1.185-1.06-1.59-.111-.638-1.487-.638 1.487-1.59.112 1.185 1.059-.537 1.415c-.688-.703-1.62-1.12-2.744-1.242A8.91 8.91 0 019.504 5.59c-.618-.509-1.387-.814-2.268-.876.526.683.992 1.416 1.346 2.2.04.092.122.122.213.071a8.953 8.953 0 014.01-.947c1.438 0 2.795.336 4.01.947.091.051.172.02.213-.071.344-.784.82-1.517 1.347-2.2zm1.924 5.346c1.732-.6 2.866 1.12 4.202.723-1.296-1.385-2.349-2.953-2.207-4.765.01-.102-.091-.163-.172-.102-.659.458-1.124 1.222-1.266 2.077-.912-.59-1.985-.672-2.876-.315a9.242 9.242 0 012.319 2.382z",
    fill: "currentColor"
  })));
}

var _path$40, _path2$1z;
function _extends$4k() {
  return _extends$4k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4k.apply(null, arguments);
}
function SvgTag(props) {
  return /*#__PURE__*/createElement("svg", _extends$4k({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$40 || (_path$40 = /*#__PURE__*/createElement("path", {
    d: "M11.223 1.274a3 3 0 012.241.876l8.699 8.7a3 3 0 010 4.242l-7.071 7.071a3 3 0 01-4.243 0L2.15 13.464a3 3 0 01-.876-2.241l.346-8.644a1 1 0 01.959-.959l8.644-.346z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1z || (_path2$1z = /*#__PURE__*/createElement("path", {
    d: "M8 8l1 1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$41, _path2$1A, _path3$s;
function _extends$4l() {
  return _extends$4l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4l.apply(null, arguments);
}
function SvgTarget(props) {
  return /*#__PURE__*/createElement("svg", _extends$4l({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$41 || (_path$41 = /*#__PURE__*/createElement("path", {
    d: "M12.354 12.854l-2.122-2.122M19.425 19.925L18.01 18.51",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1A || (_path2$1A = /*#__PURE__*/createElement("path", {
    d: "M21.9 16.743l-4.95.707-.707 4.95L12 18.157l.707-4.95 4.95-.707 4.242 4.243z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$s || (_path3$s = /*#__PURE__*/createElement("path", {
    d: "M14.888 8.905a5 5 0 10-6.483 6.483M18.763 7.858A9 9 0 107.358 19.263",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$42;
function _extends$4m() {
  return _extends$4m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4m.apply(null, arguments);
}
function SvgTelegram(props) {
  return /*#__PURE__*/createElement("svg", _extends$4m({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$42 || (_path$42 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.825 12c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12s5.373-12 12-12c6.628 0 12 5.373 12 12zM13.901 8.566l-8.081 3.33c-1.422.555-.59 1.075-.59 1.075s1.214.416 2.254.728c1.04.313 1.596-.034 1.596-.034l4.89-3.295c1.734-1.18 1.318-.208.902.208a132.55 132.55 0 01-3.642 3.468c-.555.486-.277.902-.035 1.11.706.597 2.368 1.683 3.123 2.177.21.137.35.228.38.25.174.14 1.145.764 1.734.625.59-.139.66-.936.66-.936l.866-5.445c.077-.51.155-1.01.226-1.477.187-1.212.339-2.196.364-2.547.104-1.179-1.144-.693-1.144-.693S14.698 8.22 13.9 8.566z",
    fill: "currentColor"
  })));
}

var _g$c, _defs$b;
function _extends$4n() {
  return _extends$4n = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4n.apply(null, arguments);
}
function SvgTesla(props) {
  return /*#__PURE__*/createElement("svg", _extends$4n({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$c || (_g$c = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Tesla_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M12.284 24l3.068-17.506c2.924 0 3.846.325 3.98 1.653 0 0 1.96-.742 2.95-2.25C18.422 4.083 14.542 4 14.542 4L12.28 6.798h.005L10.021 4s-3.88.082-7.739 1.897c.988 1.507 2.95 2.25 2.95 2.25.135-1.329 1.056-1.654 3.96-1.656L12.284 24z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.282 1.95c3.416-.035 7.325.71 11.328 3.05.535-1.292.672-1.863.672-1.863C19.907.815 15.81.02 12.282 0c-3.528.02-7.626.815-12 3.137 0 0 .195.703.672 1.863 4.001-2.34 7.912-3.085 11.328-3.05z"
  }))), _defs$b || (_defs$b = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Tesla_svg__clip0"
  }, /*#__PURE__*/createElement("rect", {
    width: "2em",
    height: "2em",
    fill: "#fff",
    transform: "translate(.282)"
  })))));
}

var _circle$D, _circle2$a, _circle3$1, _path$43, _path2$1B;
function _extends$4o() {
  return _extends$4o = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4o.apply(null, arguments);
}
function SvgThreePeople(props) {
  return /*#__PURE__*/createElement("svg", _extends$4o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle$D || (_circle$D = /*#__PURE__*/createElement("circle", {
    cx: 20,
    cy: 11.667,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2$a || (_circle2$a = /*#__PURE__*/createElement("circle", {
    cx: 6.667,
    cy: 16.667,
    r: 3.333,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle3$1 || (_circle3$1 = /*#__PURE__*/createElement("circle", {
    cx: 33.333,
    cy: 16.667,
    stroke: "currentColor",
    strokeWidth: 2,
    r: 3.333
  })), _path$43 || (_path$43 = /*#__PURE__*/createElement("path", {
    d: "M11.666 27.667a6 6 0 016-6h4.667a6 6 0 016 6v5.666H11.667v-5.666z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1B || (_path2$1B = /*#__PURE__*/createElement("path", {
    d: "M7.5 25v-1 1zm4.227 1.815l.99.141.068-.479-.334-.35-.724.688zm-.06 6.518v1h1v-1h-1zm-10 0h-1v1h1v-1zm0-2.5h-1 1zM7.5 25v1c1.378 0 2.62.577 3.502 1.505l.725-.69.724-.689A6.815 6.815 0 007.5 24v1zm4.227 1.815l-.99-.14c-.047.325-.07.657-.07.992h2c0-.243.017-.48.05-.711l-.99-.14zm-.06.852h-1v5.666h2v-5.666h-1zm0 5.666v-1h-10v2h10v-1zm-10 0h1v-2.5h-2v2.5h1zm0-2.5h1A4.833 4.833 0 017.5 26v-2a6.833 6.833 0 00-6.833 6.833h1zM32.5 25v-1 1zm-4.227 1.815l-.99.141-.068-.479.334-.35.724.688zm.06 6.518v1h-1v-1h1zm10 0h1v1h-1v-1zm0-2.5h1-1zM32.5 25v1c-1.378 0-2.62.577-3.502 1.505l-.725-.69-.724-.689A6.815 6.815 0 0132.5 24v1zm-4.227 1.815l.99-.14c.047.325.07.657.07.992h-2c0-.243-.017-.48-.05-.711l.99-.14zm.06.852h1v5.666h-2v-5.666h1zm0 5.666v-1h10v2h-10v-1zm10 0h-1v-2.5h2v2.5h-1zm0-2.5h-1A4.833 4.833 0 0032.5 26v-2a6.833 6.833 0 016.833 6.833h-1z",
    fill: "currentColor"
  })));
}

var _path$44;
function _extends$4p() {
  return _extends$4p = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4p.apply(null, arguments);
}
function SvgThumbsUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$4p({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$44 || (_path$44 = /*#__PURE__*/createElement("path", {
    d: "M1 14a3 3 0 013-3h1.177a2 2 0 001.84-1.218l3.366-7.919A1.418 1.418 0 0111.688 1v0a2.835 2.835 0 012.816 3.165l-.37 3.16A1.5 1.5 0 0015.624 9h4.399a3 3 0 012.884 3.824l-2.285 8A3 3 0 0117.737 23H4a3 3 0 01-3-3v-6zM6 10v13",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$45;
function _extends$4q() {
  return _extends$4q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4q.apply(null, arguments);
}
function SvgThumbsUp1(props) {
  return /*#__PURE__*/createElement("svg", _extends$4q({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$45 || (_path$45 = /*#__PURE__*/createElement("path", {
    d: "M1 10a3 3 0 003 3h1.177a2 2 0 011.84 1.218l3.366 7.919c.223.523.736.863 1.305.863v0a2.835 2.835 0 002.816-3.165l-.37-3.16A1.5 1.5 0 0115.624 15h4.399a3 3 0 002.884-3.824l-2.285-8A3 3 0 0017.737 1H4a3 3 0 00-3 3v6zM6 1v13",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$46, _path2$1C;
function _extends$4r() {
  return _extends$4r = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4r.apply(null, arguments);
}
function SvgTicket(props) {
  return /*#__PURE__*/createElement("svg", _extends$4r({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$46 || (_path$46 = /*#__PURE__*/createElement("path", {
    d: "M1 9.17H0v.708l.667.236L1 9.17zm0 5.66l-.333-.944-.667.236v.707h1zm22 0h1v-.708l-.667-.236-.333.943zm0-5.66l.333.944.667-.236V9.17h-1zM2 6a1 1 0 011-1V3a3 3 0 00-3 3h2zm0 3.17V6H0v3.17h2zM4 12a4.001 4.001 0 00-2.667-3.772l-.666 1.886A2.001 2.001 0 012 12h2zm-2.667 3.772A4.001 4.001 0 004 12H2c0 .87-.555 1.611-1.333 1.886l.666 1.886zM2 18v-3.17H0V18h2zm1 1a1 1 0 01-1-1H0a3 3 0 003 3v-2zm18 0H3v2h18v-2zm1-1a1 1 0 01-1 1v2a3 3 0 003-3h-2zm0-3.17V18h2v-3.17h-2zM20 12a4.001 4.001 0 002.667 3.772l.666-1.886A2.001 2.001 0 0122 12h-2zm2.667-3.772A4.001 4.001 0 0020 12h2c0-.87.555-1.611 1.333-1.886l-.666-1.886zM22 6v3.17h2V6h-2zm-1-1a1 1 0 011 1h2a3 3 0 00-3-3v2zM3 5h18V3H3v2z",
    fill: "currentColor"
  })), _path2$1C || (_path2$1C = /*#__PURE__*/createElement("path", {
    d: "M15 4v2M15 11v2M15 18v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$47;
function _extends$4s() {
  return _extends$4s = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4s.apply(null, arguments);
}
function SvgTiktok(props) {
  return /*#__PURE__*/createElement("svg", _extends$4s({
    width: ".862em",
    height: "1em",
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$47 || (_path$47 = /*#__PURE__*/createElement("path", {
    d: "M24.278 11.347a7.49 7.49 0 01-.69.035 7.486 7.486 0 01-6.264-3.386v11.53a8.521 8.521 0 11-8.521-8.522c.178 0 .352.016.527.027v4.2c-.175-.022-.347-.054-.527-.054a4.349 4.349 0 000 8.698c2.402 0 4.524-1.893 4.524-4.295L13.369 0h4.017a7.482 7.482 0 006.896 6.68v4.667",
    fill: "currentColor"
  })));
}

var _circle$E, _path$48;
function _extends$4t() {
  return _extends$4t = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4t.apply(null, arguments);
}
function SvgTime(props) {
  return /*#__PURE__*/createElement("svg", _extends$4t({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$E || (_circle$E = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$48 || (_path$48 = /*#__PURE__*/createElement("path", {
    d: "M12 7v6l2.5 2.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$49;
function _extends$4u() {
  return _extends$4u = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4u.apply(null, arguments);
}
function SvgTinder(props) {
  return /*#__PURE__*/createElement("svg", _extends$4u({
    width: ".962em",
    height: "1em",
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$49 || (_path$49 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.698 9.69a.066.066 0 01-.073-.02c-.813-1.075-1.017-2.922-1.066-3.631-.01-.137-.164-.214-.288-.145C2.763 7.3.435 10.63.435 13.845.435 19.367 4.275 24 10.886 24c6.195 0 10.452-4.775 10.452-10.154 0-7.04-5.037-11.716-9.523-13.83a.161.161 0 00-.228.167c.577 3.793-.22 7.919-4.889 9.507z",
    fill: "currentColor"
  })));
}

var _g$d, _defs$c;
function _extends$4v() {
  return _extends$4v = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4v.apply(null, arguments);
}
function SvgToolsIconRed(props) {
  return /*#__PURE__*/createElement("svg", _extends$4v({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$d || (_g$d = /*#__PURE__*/createElement("g", {
    clipPath: "url(#ToolsIconRed_svg__clip0_2464_269)",
    fill: "#F25858"
  }, /*#__PURE__*/createElement("path", {
    d: "M6.502 18.66L10 15.162 8.838 14 5.34 17.498l-.651-.652a.821.821 0 00-1.162 0L.241 20.133a.822.822 0 000 1.162l2.464 2.464a.821.821 0 001.162 0l3.287-3.286a.822.822 0 000-1.162l-.652-.651zm-3.216 3.357l-1.303-1.303 2.125-2.125 1.303 1.303-2.125 2.125z"
  }), /*#__PURE__*/createElement("path", {
    d: "M18.91 23.09A4.915 4.915 0 0114 18.183c0-.428.058-.854.172-1.266L7.085 9.828a4.89 4.89 0 01-5.83-6.524l.457-1.163 2.71 2.71a.837.837 0 001.156 0 .817.817 0 000-1.157L2.868.983 4.034.527a4.89 4.89 0 016.522 5.83l7.088 7.087a4.89 4.89 0 015.829 6.524l-.456 1.163-2.71-2.71a.837.837 0 00-1.156 0 .817.817 0 00-.001 1.157l2.71 2.711-1.163.457a4.876 4.876 0 01-1.787.345zM7.504 7.936l8.56 8.559-.196.499a3.253 3.253 0 002.835 4.455l-.712-.712a2.456 2.456 0 010-3.471 2.513 2.513 0 013.471 0l.712.712a3.252 3.252 0 00-4.456-2.836l-.498.196-8.558-8.558.196-.5a3.252 3.252 0 00-2.836-4.454l.712.712a2.455 2.455 0 010 3.471 2.513 2.513 0 01-3.472 0l-.712-.713a3.252 3.252 0 004.455 2.836l.5-.196z"
  }), /*#__PURE__*/createElement("path", {
    d: "M23.235.676A2.827 2.827 0 0021.383 0c-.69 0-1.354.242-1.853.676L13 6.626l1.235 1.124 6.53-5.95a.943.943 0 01.617-.224c.23 0 .451.08.617.225.164.15.255.351.255.562 0 .21-.091.413-.255.562l-6.53 5.95L16.703 10l6.53-5.95c.491-.447.767-1.054.767-1.686 0-.633-.275-1.24-.765-1.688z"
  }))), _defs$c || (_defs$c = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "ToolsIconRed_svg__clip0_2464_269"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var _path$4a;
function _extends$4w() {
  return _extends$4w = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4w.apply(null, arguments);
}
function SvgTowels(props) {
  return /*#__PURE__*/createElement("svg", _extends$4w({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4a || (_path$4a = /*#__PURE__*/createElement("path", {
    d: "M5.5 8.5l2.9-3.728A2 2 0 019.977 4h8.11c1.632 0 2.577 1.848 1.622 3.171l-3.611 5a2 2 0 01-1.622.829H4a2 2 0 00-2 2v0a2 2 0 002 2h8a2 2 0 012 2v0a2 2 0 01-2 2H2M18.5 9.5h1.337c1.582 0 2.538 1.75 1.682 3.082L19 16.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _rect$v, _path$4b, _circle$F, _path2$1D;
function _extends$4x() {
  return _extends$4x = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4x.apply(null, arguments);
}
function SvgTrainRail(props) {
  return /*#__PURE__*/createElement("svg", _extends$4x({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$v || (_rect$v = /*#__PURE__*/createElement("rect", {
    x: 3,
    y: 1,
    width: 18,
    height: 18,
    rx: 4,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$4b || (_path$4b = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M3 5h18v6H3z"
  })), _circle$F || (_circle$F = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 15,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1D || (_path2$1D = /*#__PURE__*/createElement("path", {
    d: "M8.4 19h7.2l2.4 4H6l2.4-4z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4c, _path2$1E, _path3$t;
function _extends$4y() {
  return _extends$4y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4y.apply(null, arguments);
}
function SvgTrophy(props) {
  return /*#__PURE__*/createElement("svg", _extends$4y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4c || (_path$4c = /*#__PURE__*/createElement("path", {
    d: "M18 2H6s-.776 5.722 0 9.25c.92 4.18 4 5.75 4 5.75v5h4v-5s3.08-1.57 4-5.75C18.776 7.722 18 2 18 2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1E || (_path2$1E = /*#__PURE__*/createElement("path", {
    d: "M18.5 6h3.347V4H18.5v2zm3.347 0l-.197 1.376 1.98.283.197-1.376L21.847 6zm-.197 1.376a4.845 4.845 0 01-4.26 4.13l.22 1.988a6.845 6.845 0 006.02-5.835l-1.98-.283zM21.847 6l1.98.283A2 2 0 0021.847 4v2zM5.5 6H2.153V4H5.5v2zM2.153 6l.197 1.376-1.98.283-.197-1.376L2.153 6zm.197 1.376a4.844 4.844 0 004.26 4.13l-.22 1.988A6.844 6.844 0 01.37 7.659l1.98-.283zM2.153 6l-1.98.283A2 2 0 012.153 4v2z",
    fill: "currentColor"
  })), _path3$t || (_path3$t = /*#__PURE__*/createElement("path", {
    d: "M6 22h12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4d, _path2$1F, _path3$u, _path4$9, _circle$G, _path5$4;
function _extends$4z() {
  return _extends$4z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4z.apply(null, arguments);
}
function SvgTrophyPersonal(props) {
  return /*#__PURE__*/createElement("svg", _extends$4z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path$4d || (_path$4d = /*#__PURE__*/createElement("path", {
    d: "M15 36.667v-8.334s-5.135-2.618-6.667-9.583c-1.293-5.88 0-17.083 0-17.083h20s.704 3.83.834 7.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1F || (_path2$1F = /*#__PURE__*/createElement("path", {
    d: "M30 6.667h3.78a1 1 0 01.98 1.196l-.593 2.97",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3$u || (_path3$u = /*#__PURE__*/createElement("path", {
    d: "M8.485 6.667h-5.69a1 1 0 00-.992 1.12l.816 6.702a6 6 0 005.18 5.224L10 20",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4$9 || (_path4$9 = /*#__PURE__*/createElement("path", {
    d: "M10 36.667h8.333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$G || (_circle$G = /*#__PURE__*/createElement("circle", {
    cx: 29.167,
    cy: 17.5,
    stroke: "currentColor",
    strokeWidth: 2,
    r: 4.167
  })), _path5$4 || (_path5$4 = /*#__PURE__*/createElement("path", {
    d: "M21.666 31.667c1.667-4.167 5.285-5 7.5-5a9.167 9.167 0 019.167 9.166v.834h-15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$4e, _path2$1G, _path3$v, _path4$a;
function _extends$4A() {
  return _extends$4A = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4A.apply(null, arguments);
}
function SvgTropicalDrinks(props) {
  return /*#__PURE__*/createElement("svg", _extends$4A({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4e || (_path$4e = /*#__PURE__*/createElement("path", {
    d: "M15.311 5.5H6.69s-3.234 13 4.311 13 4.311-13 4.311-13z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1G || (_path2$1G = /*#__PURE__*/createElement("path", {
    d: "M7 11h8M3 2.5l3.97-1.19a1 1 0 011.263.74L9 5.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$v || (_path3$v = /*#__PURE__*/createElement("path", {
    d: "M18.635 3.564a4 4 0 01-.493 5.636L13 3.07a4 4 0 015.635.493zm0 0l-3.064 2.571",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4$a || (_path4$a = /*#__PURE__*/createElement("path", {
    d: "M11 18.5v4M7 22.5h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4f, _circle$H, _circle2$b;
function _extends$4B() {
  return _extends$4B = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4B.apply(null, arguments);
}
function SvgTruck(props) {
  return /*#__PURE__*/createElement("svg", _extends$4B({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4f || (_path$4f = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1 3h14v13H1zM15 8h4l4 4v4h-8V8z"
  })), _circle$H || (_circle$H = /*#__PURE__*/createElement("circle", {
    cx: 5.5,
    cy: 18.5,
    r: 2.5,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2$b || (_circle2$b = /*#__PURE__*/createElement("circle", {
    cx: 17.5,
    cy: 18.5,
    r: 2.5,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$e, _defs$d;
function _extends$4C() {
  return _extends$4C = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4C.apply(null, arguments);
}
function SvgTwitter(props) {
  return /*#__PURE__*/createElement("svg", _extends$4C({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$e || (_g$e = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Twitter_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    d: "M7.55 21.75c9.055 0 14.008-7.503 14.008-14.008 0-.21-.004-.426-.014-.637A9.999 9.999 0 0024 4.555c-.898.4-1.85.66-2.826.774a4.95 4.95 0 002.165-2.723 9.897 9.897 0 01-3.126 1.195 4.93 4.93 0 00-8.394 4.49A13.985 13.985 0 011.673 3.15a4.93 4.93 0 001.523 6.57 4.93 4.93 0 01-2.23-.614v.061a4.922 4.922 0 003.95 4.828 4.894 4.894 0 01-2.221.085A4.934 4.934 0 007.292 17.5 9.875 9.875 0 010 19.54a13.969 13.969 0 007.55 2.211z",
    fill: "currentColor"
  }))), _defs$d || (_defs$d = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Twitter_svg__clip0"
  }, /*#__PURE__*/createElement("rect", {
    width: "1em",
    height: "1em",
    fill: "#fff"
  })))));
}

var _circle$I, _circle2$c, _path$4g, _path2$1H;
function _extends$4D() {
  return _extends$4D = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4D.apply(null, arguments);
}
function SvgTwoPeople(props) {
  return /*#__PURE__*/createElement("svg", _extends$4D({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$I || (_circle$I = /*#__PURE__*/createElement("circle", {
    cx: 7,
    cy: 6,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2$c || (_circle2$c = /*#__PURE__*/createElement("circle", {
    cx: 16.5,
    cy: 8.5,
    r: 2.5,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$4g || (_path$4g = /*#__PURE__*/createElement("path", {
    d: "M1 18a6 6 0 016-6v0a6 6 0 016 6v2H1v-2z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1H || (_path2$1H = /*#__PURE__*/createElement("path", {
    d: "M12.537 15.686l-.922.386-.254-.606.456-.474.72.694zM13 20v1h-1v-1h1zm.357 0v-1 1zM22 20h1v1h-1v-1zm-10-2a4.98 4.98 0 00-.385-1.928l1.845-.772c.348.832.54 1.745.54 2.7h-2zm0 2v-2h2v2h-2zm1-1h.357v2H13v-2zm.357 0H22v2h-8.643v-2zM21 20v-.5h2v.5h-2zm0-.5a4.5 4.5 0 00-4.5-4.5v-2a6.5 6.5 0 016.5 6.5h-2zM16.5 15a4.484 4.484 0 00-3.242 1.38l-1.44-1.388A6.484 6.484 0 0116.5 13v2z",
    fill: "currentColor"
  })));
}

var _path$4h;
function _extends$4E() {
  return _extends$4E = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4E.apply(null, arguments);
}
function SvgType(props) {
  return /*#__PURE__*/createElement("svg", _extends$4E({
    width: "1.083em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4h || (_path$4h = /*#__PURE__*/createElement("path", {
    d: "M9.404 13.606H4.4L3.572 16H.926L5.444 3.418h2.934L12.896 16h-2.664l-.828-2.394zM8.72 11.59L6.902 6.334 5.084 11.59H8.72zM19.19 5.866c.745 0 1.399.15 1.963.45.564.288 1.008.666 1.332 1.134V6.028h2.538v10.044c0 .924-.186 1.746-.558 2.466a4.075 4.075 0 01-1.674 1.728c-.744.432-1.644.648-2.7.648-1.416 0-2.58-.33-3.492-.99-.9-.66-1.41-1.56-1.53-2.7h2.502c.132.456.414.816.846 1.08.444.276.978.414 1.602.414.732 0 1.326-.222 1.782-.666.456-.432.684-1.092.684-1.98v-1.548c-.324.468-.774.858-1.35 1.17-.564.312-1.212.468-1.944.468-.84 0-1.608-.216-2.304-.648-.696-.432-1.248-1.038-1.656-1.818-.396-.792-.594-1.698-.594-2.718 0-1.008.198-1.902.594-2.682.408-.78.954-1.38 1.638-1.8.696-.42 1.47-.63 2.322-.63zm3.295 5.148c0-.612-.12-1.134-.36-1.566a2.463 2.463 0 00-.972-1.008 2.548 2.548 0 00-1.314-.36c-.468 0-.9.114-1.296.342-.396.228-.72.564-.972 1.008-.24.432-.36.948-.36 1.548 0 .6.12 1.128.36 1.584.252.444.576.786.972 1.026.408.24.84.36 1.296.36a2.65 2.65 0 001.314-.342c.408-.24.732-.576.972-1.008.24-.444.36-.972.36-1.584z",
    fill: "currentColor"
  })));
}

var _g$f, _defs$e;
function _extends$4F() {
  return _extends$4F = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4F.apply(null, arguments);
}
function SvgUber(props) {
  return /*#__PURE__*/createElement("svg", _extends$4F({
    width: "2.777em",
    height: "1em",
    viewBox: "0 0 25 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$f || (_g$f = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Uber_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M3.463 7.035c1.132 0 2.008-.867 2.008-2.15V-.108h1.225v8.09H5.482v-.75c-.548.566-1.307.89-2.16.89-1.75 0-3.093-1.26-3.093-3.167V-.107h1.226v4.992c0 1.306.863 2.15 2.008 2.15M7.607-.107h1.18V2.84a2.945 2.945 0 012.112-.879c1.751 0 3.129 1.376 3.129 3.086 0 1.7-1.378 3.075-3.129 3.075a2.997 2.997 0 01-2.125-.879v.74H7.605l.002-8.09zm3.21 7.2c1.121 0 2.044-.913 2.044-2.046a2.04 2.04 0 00-2.043-2.045 2.043 2.043 0 00-2.055 2.045c0 1.133.91 2.046 2.055 2.046zM17.554 1.973c1.716 0 2.977 1.306 2.977 3.063v.381h-4.844a1.99 1.99 0 001.972 1.676c.69 0 1.273-.278 1.716-.867l.853.624c-.596.786-1.483 1.26-2.569 1.26-1.786 0-3.164-1.318-3.164-3.074a3.046 3.046 0 013.06-3.063h-.001zm-1.845 2.52h3.631c-.198-.902-.934-1.503-1.81-1.503-.875 0-1.61.6-1.82 1.502zM23.695 3.128c-.771 0-1.331.59-1.331 1.503v3.352h-1.18V2.088h1.169v.729c.291-.474.77-.775 1.424-.775h.408V3.13h-.49z"
  }))), _defs$e || (_defs$e = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Uber_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    transform: "translate(.282)",
    d: "M0 0h24v8.077H0z"
  })))));
}

var _path$4i, _path2$1I, _path3$w;
function _extends$4G() {
  return _extends$4G = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4G.apply(null, arguments);
}
function SvgUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$4G({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4i || (_path$4i = /*#__PURE__*/createElement("path", {
    d: "M2.5 12C2 10.5 2 9 2 7.956 2 4.478 5.114 1 8.956 1a6.954 6.954 0 016.026 3.478h.93C18.795 4.478 21.5 6.5 21.5 9c0 1 0 2-.5 3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1I || (_path2$1I = /*#__PURE__*/createElement("path", {
    d: "M15.583 14.668L11.5 10.75l-4.084 3.918",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$w || (_path3$w = /*#__PURE__*/createElement("path", {
    d: "M11.5 11.78v11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$4j, _path2$1J, _path3$x;
function _extends$4H() {
  return _extends$4H = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4H.apply(null, arguments);
}
function SvgUsbThumbDrive(props) {
  return /*#__PURE__*/createElement("svg", _extends$4H({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4j || (_path$4j = /*#__PURE__*/createElement("path", {
    d: "M5 6h14v13a4 4 0 01-4 4H9a4 4 0 01-4-4V6z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1J || (_path2$1J = /*#__PURE__*/createElement("path", {
    d: "M12 9.5v10M15.5 10.5v1.944L12 15.5M8.5 12v3.056L12 17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$x || (_path3$x = /*#__PURE__*/createElement("path", {
    d: "M8 1.5a.5.5 0 01.5-.5h7a.5.5 0 01.5.5V6H8V1.5z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4k;
function _extends$4I() {
  return _extends$4I = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4I.apply(null, arguments);
}
function SvgVenmo(props) {
  return /*#__PURE__*/createElement("svg", _extends$4I({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4k || (_path$4k = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0a4 4 0 00-4 4v16a4 4 0 004 4h16a4 4 0 004-4V4a4 4 0 00-4-4H4zm14 8.4c0-.938-.192-1.68-.619-2.4l-3.688.764c.235.502.385 1.112.385 2.007 0 1.636-1.131 4.036-2.047 5.563l-.981-8.073L7 6.655 8.855 18h4.625C15.505 15.273 18 11.39 18 8.4z",
    fill: "currentColor"
  })));
}

var _path$4l, _path2$1K;
function _extends$4J() {
  return _extends$4J = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4J.apply(null, arguments);
}
function SvgVerifiedBadge(props) {
  return /*#__PURE__*/createElement("svg", _extends$4J({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4l || (_path$4l = /*#__PURE__*/createElement("path", {
    d: "M9.701 2.793a2.977 2.977 0 014.598 0v0c.63.766 1.6 1.167 2.586 1.071v0a2.977 2.977 0 013.25 3.251v0a2.977 2.977 0 001.072 2.586v0a2.977 2.977 0 010 4.598v0a2.977 2.977 0 00-1.071 2.586v0a2.977 2.977 0 01-3.251 3.25v0a2.977 2.977 0 00-2.586 1.072v0a2.977 2.977 0 01-4.598 0v0a2.977 2.977 0 00-2.586-1.071v0a2.977 2.977 0 01-3.25-3.251v0a2.977 2.977 0 00-1.072-2.586v0a2.977 2.977 0 010-4.598v0a2.977 2.977 0 001.071-2.586v0a2.977 2.977 0 013.251-3.25v0a2.977 2.977 0 002.586-1.072v0z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1K || (_path2$1K = /*#__PURE__*/createElement("path", {
    d: "M9 11.95l2.121 2.121 4.243-4.243",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _rect$w, _path$4m;
function _extends$4K() {
  return _extends$4K = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4K.apply(null, arguments);
}
function SvgVideo(props) {
  return /*#__PURE__*/createElement("svg", _extends$4K({
    width: ".909em",
    height: "1em",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$w || (_rect$w = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 20,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path$4m || (_path$4m = /*#__PURE__*/createElement("path", {
    d: "M1 11h18M1 6h4M1 16h4M15 6h4M15 16h4M14.5 1v20M5.5 1v20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4n, _path2$1L;
function _extends$4L() {
  return _extends$4L = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4L.apply(null, arguments);
}
function SvgVideo1(props) {
  return /*#__PURE__*/createElement("svg", _extends$4L({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4n || (_path$4n = /*#__PURE__*/createElement("path", {
    d: "M4.867 6h9.266C15.164 6 16 6.768 16 7.714V10.2L21 7v10l-5-3.2v2.486c0 .947-.836 1.714-1.867 1.714H4.867C3.836 18 3 17.233 3 16.286V7.714C3 6.768 3.836 6 4.867 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1L || (_path2$1L = /*#__PURE__*/createElement("path", {
    d: "M8 6v12",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4o, _circle$J;
function _extends$4M() {
  return _extends$4M = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4M.apply(null, arguments);
}
function SvgView(props) {
  return /*#__PURE__*/createElement("svg", _extends$4M({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4o || (_path$4o = /*#__PURE__*/createElement("path", {
    d: "M1.335 13.256a2.522 2.522 0 010-2.512C3.685 6.651 7.444 4 11.68 4c4.236 0 7.995 2.65 10.345 6.744a2.522 2.522 0 010 2.512C19.675 17.349 15.915 20 11.68 20c-4.236 0-7.995-2.65-10.345-6.744z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle$J || (_circle$J = /*#__PURE__*/createElement("circle", {
    cx: 11.68,
    cy: 12,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4p;
function _extends$4N() {
  return _extends$4N = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4N.apply(null, arguments);
}
function SvgVisa(props) {
  return /*#__PURE__*/createElement("svg", _extends$4N({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4p || (_path$4p = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95 15.758H3.89L2.347 9.692c-.073-.279-.229-.525-.458-.642A6.573 6.573 0 000 8.408v-.233h3.318c.458 0 .801.35.859.758l.801 4.376 2.059-5.134h2.002L5.95 15.758zm4.234 0H8.24l1.602-7.583h1.945l-1.602 7.583zm4.119-5.482c.057-.409.4-.642.801-.642a3.534 3.534 0 011.888.35l.344-1.633A4.801 4.801 0 0015.562 8C13.674 8 12.3 9.05 12.3 10.508c0 1.11.973 1.692 1.66 2.042.743.35 1.03.584.972.933 0 .525-.572.759-1.143.759a4.789 4.789 0 01-2.003-.467l-.343 1.633c.687.292 1.43.409 2.117.409 2.117.057 3.432-.992 3.432-2.567 0-1.983-2.69-2.1-2.69-2.974zm9.497 5.482l-1.545-7.583h-1.659a.862.862 0 00-.801.583l-2.86 7h2.002l.4-1.108h2.46l.23 1.108H23.8zm-2.917-5.54l.571 2.857h-1.602l1.03-2.858z",
    fill: "currentColor"
  })));
}

var _rect$x, _circle$K, _path$4q, _path2$1M;
function _extends$4O() {
  return _extends$4O = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4O.apply(null, arguments);
}
function SvgWasher(props) {
  return /*#__PURE__*/createElement("svg", _extends$4O({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$x || (_rect$x = /*#__PURE__*/createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle$K || (_circle$K = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 13,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$4q || (_path$4q = /*#__PURE__*/createElement("path", {
    d: "M4.5 4.5h1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1M || (_path2$1M = /*#__PURE__*/createElement("path", {
    d: "M6 13s3.5 3 6 0 6 0 6 0",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4r;
function _extends$4P() {
  return _extends$4P = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4P.apply(null, arguments);
}
function SvgWeatherCloud(props) {
  return /*#__PURE__*/createElement("svg", _extends$4P({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4r || (_path$4r = /*#__PURE__*/createElement("path", {
    d: "M15.93 8l-.866.5a1 1 0 00.866.5V8zM9 5a6.997 6.997 0 016.064 3.5l1.731-1A8.997 8.997 0 009 3v2zm-7 7a7 7 0 017-7V3a9 9 0 00-9 9h2zm7 7a7 7 0 01-7-7H0a9 9 0 009 9v-2zm8 0H9v2h8v-2zm5-5a5 5 0 01-5 5v2a7 7 0 007-7h-2zm-5-5a5 5 0 015 5h2a7 7 0 00-7-7v2zm-1.07 0H17V7h-1.07v2z",
    fill: "currentColor"
  })));
}

var _path$4s, _circle$L;
function _extends$4Q() {
  return _extends$4Q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4Q.apply(null, arguments);
}
function SvgWeatherHurricane(props) {
  return /*#__PURE__*/createElement("svg", _extends$4Q({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4s || (_path$4s = /*#__PURE__*/createElement("path", {
    d: "M11.2 4.143C8.607 5.84 7.467 7.334 7.032 8.037a6.196 6.196 0 00.104 8.047l.421.69c.29.476.458 1.02.381 1.569-.083.6-.28 1.39-.738 1.907C6.09 21.501 4 23 4 23s6.21-1.447 8.8-3.143c2.593-1.697 3.733-3.191 4.168-3.894a6.195 6.195 0 00-.104-8.047l-.421-.69c-.29-.476-.458-1.02-.381-1.569.083-.6.28-1.39.738-1.907C17.91 2.499 20 1 20 1s-6.21 1.447-8.8 3.143z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$L || (_circle$L = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4t;
function _extends$4R() {
  return _extends$4R = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4R.apply(null, arguments);
}
function SvgWeatherLightning(props) {
  return /*#__PURE__*/createElement("svg", _extends$4R({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4t || (_path$4t = /*#__PURE__*/createElement("path", {
    d: "M4 15l-.868-.496A1 1 0 004 16v-1zm8-14h1a1 1 0 00-1.868-.496L12 1zm0 14h1a1 1 0 00-1-1v1zm0 8h-1a1 1 0 001.868.496L12 23zm8-14l.868.496A1 1 0 0020 8v1zm-8 0h-1a1 1 0 001 1V9zm-7.132 6.496l8-14-1.736-.992-8 14 1.736.992zM12 14H4v2h8v-2zm1 9v-8h-2v8h2zm6.132-14.496l-8 14 1.736.992 8-14-1.736-.992zM12 10h8V8h-8v2zm-1-9v8h2V1h-2z",
    fill: "currentColor"
  })));
}

var _path$4u;
function _extends$4S() {
  return _extends$4S = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4S.apply(null, arguments);
}
function SvgWeatherMoon(props) {
  return /*#__PURE__*/createElement("svg", _extends$4S({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4u || (_path$4u = /*#__PURE__*/createElement("path", {
    d: "M18.731 17.619c-5.836 0-10.567-4.819-10.567-10.763 0-1.747.409-3.397 1.134-4.856C5.062 3.402 2 7.456 2 12.238 2 18.182 6.731 23 12.567 23c4.12 0 7.69-2.402 9.433-5.906-1.03.34-2.128.525-3.269.525z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4v, _path2$1N, _path3$y;
function _extends$4T() {
  return _extends$4T = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4T.apply(null, arguments);
}
function SvgWeatherPartlyCloudy(props) {
  return /*#__PURE__*/createElement("svg", _extends$4T({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4v || (_path$4v = /*#__PURE__*/createElement("path", {
    d: "M5.595 22.73l.343-.94a1.003 1.003 0 00-.068-.022l-.275.961zm7.62-8.73l-.845.534a1 1 0 00.845.466v-1zM5.87 21.768C3.575 21.112 2 19.183 2 17H0c0 3.199 2.29 5.825 5.32 6.69l.55-1.922zM2 17c0-2.681 2.4-5 5.545-5v-2C3.462 10 0 13.054 0 17h2zm5.545-5c2.093 0 3.883 1.041 4.825 2.534l1.69-1.068C12.74 11.372 10.299 10 7.546 10v2zm5.67 3H14.5v-2h-1.285v2zm1.285 0a3.5 3.5 0 013.5 3.5h2a5.5 5.5 0 00-5.5-5.5v2zm3.5 3.5a3.5 3.5 0 01-3.5 3.5v2a5.5 5.5 0 005.5-5.5h-2zM14.5 22H7.545v2H14.5v-2zm-6.955 0h-.409v2h.41v-2zm-.409 0c-.423 0-.826-.075-1.198-.21l-.685 1.879A5.491 5.491 0 007.136 24v-2z",
    fill: "currentColor"
  })), _path2$1N || (_path2$1N = /*#__PURE__*/createElement("path", {
    d: "M6.083 11a6.002 6.002 0 1111.176 3.89",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3$y || (_path3$y = /*#__PURE__*/createElement("path", {
    d: "M12 1v1M19.778 4.222l-.707.707M4.222 4.222l.707.707M23 12h-1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4w, _path2$1O;
function _extends$4U() {
  return _extends$4U = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4U.apply(null, arguments);
}
function SvgWeatherRain(props) {
  return /*#__PURE__*/createElement("svg", _extends$4U({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4w || (_path$4w = /*#__PURE__*/createElement("path", {
    d: "M9.595 12.73l.343-.94a1.003 1.003 0 00-.068-.022l-.275.961zM17.215 4l-.845.534a1 1 0 00.845.466V4zM9.87 11.768C7.575 11.112 6 9.183 6 7H4c0 3.199 2.29 5.825 5.32 6.69l.55-1.922zM6 7c0-2.681 2.4-5 5.546-5V0C7.462 0 4 3.054 4 7h2zm5.546-5c2.092 0 3.882 1.041 4.824 2.534l1.69-1.068C16.74 1.372 14.299 0 11.547 0v2zm5.67 3H18.5V3h-1.285v2zM18.5 5A3.5 3.5 0 0122 8.5h2A5.5 5.5 0 0018.5 3v2zM22 8.5a3.5 3.5 0 01-3.5 3.5v2A5.5 5.5 0 0024 8.5h-2zM18.5 12h-6.954v2H18.5v-2zm-6.954 0h-.41v2h.41v-2zm-.41 0c-.422 0-.826-.075-1.198-.21l-.685 1.879a5.491 5.491 0 001.883.331v-2z",
    fill: "currentColor"
  })), _path2$1O || (_path2$1O = /*#__PURE__*/createElement("path", {
    d: "M15.012 13.478l-1.721 2.457M20.009 13.315l-2.294 3.276M10.014 13.64l-3.441 4.916M10.996 19.212l-.573.82M6.017 11.804l-1.721 2.458",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4x;
function _extends$4V() {
  return _extends$4V = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4V.apply(null, arguments);
}
function SvgWeatherSnow(props) {
  return /*#__PURE__*/createElement("svg", _extends$4V({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4x || (_path$4x = /*#__PURE__*/createElement("path", {
    d: "M12 1v22M2.474 6.5l19.052 11M2.473 17.5l19.053-11M9 3l3 2.5L15 3M9 21l3-2.5 3 2.5M2.706 10.098L6.37 8.75l-.665-3.848M18.294 19.098l-.665-3.848 3.665-1.348M5.706 19.098l.665-3.848-3.665-1.348M21.294 10.098L17.63 8.75l.665-3.848",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4y, _path2$1P;
function _extends$4W() {
  return _extends$4W = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4W.apply(null, arguments);
}
function SvgWeatherSnow1(props) {
  return /*#__PURE__*/createElement("svg", _extends$4W({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4y || (_path$4y = /*#__PURE__*/createElement("path", {
    d: "M9.595 12.73l.343-.94a1.003 1.003 0 00-.068-.022l-.275.961zM17.215 4l-.845.534a1 1 0 00.845.466V4zM9.87 11.768C7.575 11.112 6 9.183 6 7H4c0 3.199 2.29 5.825 5.32 6.69l.55-1.922zM6 7c0-2.681 2.4-5 5.546-5V0C7.462 0 4 3.054 4 7h2zm5.546-5c2.092 0 3.882 1.041 4.824 2.534l1.69-1.068C16.74 1.372 14.299 0 11.547 0v2zm5.67 3H18.5V3h-1.285v2zM18.5 5A3.5 3.5 0 0122 8.5h2A5.5 5.5 0 0018.5 3v2zM22 8.5a3.5 3.5 0 01-3.5 3.5v2A5.5 5.5 0 0024 8.5h-2zM18.5 12h-6.954v2H18.5v-2zm-6.954 0h-.41v2h.41v-2zm-.41 0c-.422 0-.826-.075-1.198-.21l-.685 1.879a5.491 5.491 0 001.883.331v-2z",
    fill: "currentColor"
  })), _path2$1P || (_path2$1P = /*#__PURE__*/createElement("path", {
    d: "M15.6 18v4M14 19.174l3.263 1.884M14 21.058l3.263-1.884M4.583 16.8V23M2 18.04l5.167 3.72M2 21.76l5.167-3.72",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4z, _path2$1Q;
function _extends$4X() {
  return _extends$4X = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4X.apply(null, arguments);
}
function SvgWeatherStars(props) {
  return /*#__PURE__*/createElement("svg", _extends$4X({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4z || (_path$4z = /*#__PURE__*/createElement("path", {
    d: "M14.516 3.894c.128-.501.84-.501.968 0l.671 2.624a6 6 0 004.327 4.327l2.624.67c.501.129.501.841 0 .97l-2.624.67a6 6 0 00-4.327 4.327l-.67 2.624c-.129.501-.841.501-.97 0l-.67-2.624a6 6 0 00-4.327-4.327l-2.624-.67c-.501-.129-.501-.841 0-.97l2.624-.67a6 6 0 004.327-4.327l.67-2.624z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1Q || (_path2$1Q = /*#__PURE__*/createElement("path", {
    d: "M3 1v4M5 3H1M4 19v4M6 21H2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$M, _path$4A;
function _extends$4Y() {
  return _extends$4Y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4Y.apply(null, arguments);
}
function SvgWeatherSun(props) {
  return /*#__PURE__*/createElement("svg", _extends$4Y({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$M || (_circle$M = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$4A || (_path$4A = /*#__PURE__*/createElement("path", {
    d: "M12 1v1m0 21v-1M4.222 19.778l.707-.707M19.778 4.222l-.707.707M4.222 4.222l.707.707m14.849 14.849l-.707-.707M1 12h1m21 0h-1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _circle$N, _path$4B, _path2$1R, _path3$z;
function _extends$4Z() {
  return _extends$4Z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4Z.apply(null, arguments);
}
function SvgWeatherTemperature(props) {
  return /*#__PURE__*/createElement("svg", _extends$4Z({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$N || (_circle$N = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 17,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$4B || (_path$4B = /*#__PURE__*/createElement("path", {
    d: "M12 13v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$1R || (_path2$1R = /*#__PURE__*/createElement("path", {
    d: "M13 5.5h3M13 9h3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$z || (_path3$z = /*#__PURE__*/createElement("path", {
    d: "M8 12.528l.667.745.333-.298v-.447H8zm8 0h-1v.447l.333.298.667-.745zM9 5a3 3 0 013-3V0a5 5 0 00-5 5h2zm0 7.528V5H7v7.528h2zM7 17c0-1.48.642-2.81 1.667-3.727l-1.334-1.49A6.985 6.985 0 005 17h2zm5 5a5 5 0 01-5-5H5a7 7 0 007 7v-2zm5-5a5 5 0 01-5 5v2a7 7 0 007-7h-2zm-1.667-3.727A4.985 4.985 0 0117 17h2a6.985 6.985 0 00-2.333-5.217l-1.334 1.49zM15 5v7.528h2V5h-2zm-3-3a3 3 0 013 3h2a5 5 0 00-5-5v2z",
    fill: "currentColor"
  })));
}

var _path$4C, _path2$1S;
function _extends$4_() {
  return _extends$4_ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4_.apply(null, arguments);
}
function SvgWeatherThunderstorms(props) {
  return /*#__PURE__*/createElement("svg", _extends$4_({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4C || (_path$4C = /*#__PURE__*/createElement("path", {
    d: "M1.5 14l4-4.5S5.009 8.448 5.009 7c0-3.314 2.93-6 6.545-6 2.423 0 4.538 1.207 5.67 3h1.285a4.5 4.5 0 014.5 4.5c0 1.564-1.009 3.5-2.009 4.748-1 1.248-7 8.252-7 8.252M16.867 11.294l-.642.766M3.09 19.915l-.643.766",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1S || (_path2$1S = /*#__PURE__*/createElement("path", {
    d: "M12.803 8.723L6.661 15.85l4.993.273L6 22.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _ellipse$1, _path$4D, _path2$1T;
function _extends$4$() {
  return _extends$4$ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4$.apply(null, arguments);
}
function SvgWeatherTornado(props) {
  return /*#__PURE__*/createElement("svg", _extends$4$({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse$1 || (_ellipse$1 = /*#__PURE__*/createElement("ellipse", {
    cx: 12,
    cy: 7,
    rx: 11,
    ry: 6,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path$4D || (_path$4D = /*#__PURE__*/createElement("path", {
    d: "M6 12.277c-.637.6-1 1.29-1 2.023 0 2.32 3.627 4.2 8.1 4.2 3.106 0 5.804-.906 7.163-2.237",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1T || (_path2$1T = /*#__PURE__*/createElement("path", {
    d: "M5 16c-1.036.688-2 2.027-2 2.976C3 21.2 6.395 23 10.583 23c1.23 0 2.39-.155 3.417-.43",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4E, _path2$1U;
function _extends$50() {
  return _extends$50 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$50.apply(null, arguments);
}
function SvgWeatherUmbrella(props) {
  return /*#__PURE__*/createElement("svg", _extends$50({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4E || (_path$4E = /*#__PURE__*/createElement("path", {
    d: "M21 10a9 9 0 00-18 0h18z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2$1U || (_path2$1U = /*#__PURE__*/createElement("path", {
    d: "M12 10v10.5s0 2.5 3 2.5 3-2.5 3-2.5V19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$4F;
function _extends$51() {
  return _extends$51 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$51.apply(null, arguments);
}
function SvgWeatherWaterDrop(props) {
  return /*#__PURE__*/createElement("svg", _extends$51({
    width: ".96em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4F || (_path$4F = /*#__PURE__*/createElement("path", {
    d: "M20 16a8 8 0 11-16 0c0-4.418 8-13.5 8-13.5s8 9.082 8 13.5z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4G;
function _extends$52() {
  return _extends$52 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$52.apply(null, arguments);
}
function SvgWeatherWind(props) {
  return /*#__PURE__*/createElement("svg", _extends$52({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4G || (_path$4G = /*#__PURE__*/createElement("path", {
    d: "M23 12H4.5C2.5 12 1 10.5 1 8.5s1.5-3 3.5-3 3 1 3.5 2.5M23 16.5H8.5C6.5 16.5 5 18 5 20s1.5 3 3.5 3 3-1 3.5-2.5M23 7.5h-8.5C12.5 7.5 11 6 11 4s1.5-3 3.5-3 3 1 3.5 2.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _g$g, _defs$f;
function _extends$53() {
  return _extends$53 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$53.apply(null, arguments);
}
function SvgWhatsapp(props) {
  return /*#__PURE__*/createElement("svg", _extends$53({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$g || (_g$g = /*#__PURE__*/createElement("g", {
    clipPath: "url(#Whatsapp_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    d: "M.339 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.442 5.335 5.777 0 12.332 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.339 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z",
    fill: "currentColor"
  }))), _defs$f || (_defs$f = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "Whatsapp_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    transform: "translate(.282)",
    d: "M0 0h25v24H0z"
  })))));
}

var _path$4H;
function _extends$54() {
  return _extends$54 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$54.apply(null, arguments);
}
function SvgWifi(props) {
  return /*#__PURE__*/createElement("svg", _extends$54({
    width: "1.037em",
    height: "1em",
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4H || (_path$4H = /*#__PURE__*/createElement("path", {
    d: "M1.125 10.772a18 18 0 0125.456 0M5.102 14.75a12.374 12.374 0 0117.5 0M9.08 18.727a6.75 6.75 0 019.546 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var _path$4I, _circle$O, _circle2$d;
function _extends$55() {
  return _extends$55 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$55.apply(null, arguments);
}
function SvgWorldGlobe(props) {
  return /*#__PURE__*/createElement("svg", _extends$55({
    width: "1.041em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4I || (_path$4I = /*#__PURE__*/createElement("path", {
    d: "M3 15l-.894-.447A2 2 0 011 12.763v-.877a2 2 0 011.298-1.873l2.048-.768c.424-.159.78-.46 1.103-.775C6.2 7.736 7.985 6.5 11.5 6.5c3.1 0 4.856 1.154 5.741 2.03.539.533 1.24.964 1.99 1.069 1.371.191 3.44.753 3.769 2.401.211 1.056.244 1.755.211 2.21-.037.53-.509.79-1.04.79H21m-5 0H8",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle$O || (_circle$O = /*#__PURE__*/createElement("circle", {
    cx: 5.5,
    cy: 15.5,
    r: 2.5,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2$d || (_circle2$d = /*#__PURE__*/createElement("circle", {
    cx: 18.5,
    cy: 15.5,
    r: 2.5,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _circle$P, _path$4J;
function _extends$56() {
  return _extends$56 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$56.apply(null, arguments);
}
function SvgWorldNet(props) {
  return /*#__PURE__*/createElement("svg", _extends$56({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$P || (_circle$P = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$4J || (_path$4J = /*#__PURE__*/createElement("path", {
    d: "M1 12h22M12 1S8 3.2 8 12s4 11 4 11M12 1s4 2.2 4 11-4 11-4 11",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var _path$4K;
function _extends$57() {
  return _extends$57 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$57.apply(null, arguments);
}
function SvgYouTube(props) {
  return /*#__PURE__*/createElement("svg", _extends$57({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4K || (_path$4K = /*#__PURE__*/createElement("path", {
    d: "M23.76 7.2s-.233-1.655-.955-2.381c-.914-.957-1.936-.961-2.405-1.018-3.356-.243-8.395-.243-8.395-.243h-.01s-5.039 0-8.395.243c-.469.057-1.49.061-2.405 1.018-.722.726-.951 2.38-.951 2.38S0 9.146 0 11.087v1.819c0 1.94.24 3.885.24 3.885s.233 1.655.95 2.382c.915.956 2.115.923 2.65 1.026 1.92.183 8.16.24 8.16.24s5.044-.01 8.4-.25c.469-.055 1.49-.06 2.405-1.016.722-.727.956-2.382.956-2.382S24 14.85 24 12.905v-1.82c0-1.94-.24-3.885-.24-3.885zM9.52 15.112V8.367l6.483 3.384-6.483 3.361z",
    fill: "currentColor"
  })));
}

var _templateObject$6, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$2, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9;
var Label = styled.label(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: block;\n    width: 100%;\n\n    .warning {\n        display: none;\n    }\n\n    textarea,\n    select {\n        resize: none;\n        height: 100%;\n        width: 100%;\n    }\n\n    input:disabled,\n    select:disabled {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    input,\n    select,\n    textarea {\n        position: relative;\n        z-index: 3;\n        display: block;\n        border: 2px solid transparent;\n        height: 100%;\n        width: 100%;\n\n        padding: ", ";\n        padding-left: ", ";\n\n        font: ", ";\n        outline: none;\n        background-color: transparent;\n        transition: ", ";\n\n        &:disabled {\n            padding-right: 24px;\n        }\n\n        &:focus:not(:disabled),\n        &:active:not(:disabled) {\n            border-color: ", ";\n        }\n\n        &:focus ~ div,\n        &:active ~ div {\n            background-color: transparent;\n        }\n\n        ", "\n        &:disabled {\n            cursor: auto;\n        }\n    }\n\n    input {\n        &:-webkit-autofill,\n        &:-webkit-autofill:hover,\n        &:-webkit-autofill:focus {\n            -webkit-text-fill-color: inherit;\n            -webkit-box-shadow: inherit;\n            transition: background-color 5000s ease-in-out 0s;\n        }\n    }\n"])), function (_ref) {
  var large = _ref.large,
    withoutClearButton = _ref.withoutClearButton;
  if (withoutClearButton) {
    return large ? '26px 24px 14px 24px' : '22px 24px 10px 24px';
  }
  return large ? '26px 64px 14px 24px' : '22px 64px 10px 24px';
}, function (_ref2) {
  var withIcon = _ref2.withIcon;
  return withIcon ? '60px' : '24px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.descriptor1;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transition["default"];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primaryText;
}, function (_ref6) {
  var withoutBorderColorsOnValidate = _ref6.withoutBorderColorsOnValidate;
  return withoutBorderColorsOnValidate ? '' : css(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n                      // valid state\n                      &:valid:not(:focus)[data-highlight-validate-touch='true']:not([data-invalid='1']) {\n                          border-color: ", ";\n\n                          & ~ span {\n                              color: ", ";\n                          }\n                      }\n\n                      // invalid\n                      &[data-invalid='1']:not(:focus),\n                      &[data-highlight-validate-touch='true']:invalid:not(:focus),\n                      &:invalid:not(:focus):not(:placeholder-shown) {\n                          border-color: ", ";\n\n                          & ~ .warning {\n                              display: block;\n                          }\n\n                          & ~ span {\n                              color: ", ";\n                          }\n                      }\n                  "])), function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.success;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.success;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.error;
  }, function (_ref0) {
    var theme = _ref0.theme;
    return theme.colors.error;
  });
});
var Placeholder = styled.span(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    z-index: 3;\n\n    border: 2px solid transparent;\n\n    padding: ", ";\n    padding-left: ", ";\n\n    font: ", ";\n    transition: ", ";\n\n    pointer-events: none;\n    touch-action: none;\n\n    &.active {\n        top: -8px;\n        font: ", ";\n        color: ", ";\n    }\n"])), function (_ref1) {
  var large = _ref1.large;
  return large ? '18px 24px' : '14px 24px';
}, function (_ref10) {
  var withIcon = _ref10.withIcon;
  return withIcon ? '60px' : '24px';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fonts.descriptor1;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.transition["default"];
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fonts.descriptor2;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.secondaryText;
});
var ClearInputIcon = styled(function (props) {
  return /*#__PURE__*/React__default.createElement(SvgCloseX, props);
})(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    font-size: 24px;\n    right: 22px;\n    top: ", ";\n    z-index: 4;\n    animation: ", " 0.2s ease-in-out;\n\n    cursor: pointer;\n"])), function (_ref15) {
  var large = _ref15.large;
  return large ? '20px' : '15px';
}, SlideFromRight);
var WarningIcon = styled(function (props) {
  return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertInfo, props);
})(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    font-size: 24px;\n    right: 22px;\n    top: ", ";\n    z-index: 4;\n    animation: ", " 0.2s ease-in-out;\n"])), function (_ref16) {
  var large = _ref16.large;
  return large ? '20px' : '15px';
}, SlideFromRight);
var ArrowChevronDownSelectIconWrap = styled(function (props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowChevronDown, props);
})(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    font-size: 24px;\n    right: 22px;\n    top: ", ";\n    z-index: 2;\n    animation: ", " 0.2s ease-in-out;\n\n    cursor: pointer;\n"])), function (_ref17) {
  var large = _ref17.large;
  return large ? '20px' : '16px';
}, SlideFromRight);
var InputIcon = styled.span(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    font-size: 24px;\n    left: 22px;\n    line-height: ", ";\n    height: ", ";\n    z-index: 2;\n"])), function (_ref18) {
  var large = _ref18.large;
  return large ? '61px' : '53px';
}, function (_ref19) {
  var large = _ref19.large;
  return large ? '61px' : '53px';
});
var InputWrap = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n    display: block;\n    height: auto;\n    position: relative;\n    color: ", ";\n    opacity: ", ";\n\n    * {\n        box-sizing: border-box;\n    }\n\n    select,\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        margin: 0;\n        box-shadow: none;\n        white-space: normal;\n        appearance: none;\n    }\n\n    select::-ms-expand {\n        display: none;\n    }\n"])), function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.secondaryText;
}, function (_ref21) {
  var disabled = _ref21.disabled,
    nonOpacityOnDisabled = _ref21.nonOpacityOnDisabled;
  return nonOpacityOnDisabled ? 1 : disabled ? 0.5 : 1;
});
var Background = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    z-index: 1;\n    background-color: ", ";\n    transition: ", ";\n"])), function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.background;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.transition["default"];
});

var _excluded$3 = ["type", "value", "onChange", "onBlur", "onKeyDown", "placeholder", "children", "large", "invalid", "showWarningIcon", "withoutClearButton", "onClearButtonCallback", "nonOpacityOnDisabled", "highlightValidateOnFirstTouch", "withoutBorderColorsOnValidate", "formatter", "parser", "trim"];
var formatInputValueByType = function formatInputValueByType(value, type) {
  if (type === 'tel') {
    return phoneMask(value);
  }
  return value;
};
var KliBaseField = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown,
    placeholder = _ref.placeholder,
    children = _ref.children,
    large = _ref.large,
    invalid = _ref.invalid,
    _ref$showWarningIcon = _ref.showWarningIcon,
    showWarningIcon = _ref$showWarningIcon === void 0 ? false : _ref$showWarningIcon,
    _ref$withoutClearButt = _ref.withoutClearButton,
    withoutClearButton = _ref$withoutClearButt === void 0 ? false : _ref$withoutClearButt,
    _ref$onClearButtonCal = _ref.onClearButtonCallback,
    onClearButtonCallback = _ref$onClearButtonCal === void 0 ? function () {
      return null;
    } : _ref$onClearButtonCal,
    _ref$nonOpacityOnDisa = _ref.nonOpacityOnDisabled,
    nonOpacityOnDisabled = _ref$nonOpacityOnDisa === void 0 ? false : _ref$nonOpacityOnDisa,
    _ref$withoutBorderCol = _ref.withoutBorderColorsOnValidate,
    withoutBorderColorsOnValidate = _ref$withoutBorderCol === void 0 ? false : _ref$withoutBorderCol,
    _ref$formatter = _ref.formatter,
    formatter = _ref$formatter === void 0 ? null : _ref$formatter,
    _ref$parser = _ref.parser,
    parser = _ref$parser === void 0 ? null : _ref$parser,
    _ref$trim = _ref.trim,
    trim = _ref$trim === void 0 ? true : _ref$trim,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var formatValue = useCallback(function (value) {
    var parsedVal = typeof parser === 'function' ? parser(value) : value;
    return typeof formatter === 'function' ? formatter(parsedVal) : formatInputValueByType(value, type);
  }, [type, formatter, parser]);
  var trimValue = function trimValue(val) {
    return typeof val === 'string' && trim ? val.trim() : val;
  };
  var theme = useContext(KliThemeContext);
  var _useState = useState(false),
    touched = _useState[0],
    setTouched = _useState[1];
  var _useState2 = useState(formatValue(value)),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  useEffect(function () {
    setInputValue(formatValue(value));
  }, [value, setInputValue]);
  var withIcon = !!children;
  var onInputChange = useCallback(function (e) {
    var value = e.target.value;
    var formattedValue = formatValue(value);
    setInputValue(formattedValue);
    if (typeof onChange === 'function') {
      e.target.value = typeof parser === 'function' ? parser(formattedValue) : formattedValue;
      onChange(e);
    }
  }, [setInputValue, onChange]);
  var onInputBlur = useCallback(function (e) {
    setTouched(false);
    var formattedValue = formatValue(trimValue(e.target.value));
    setInputValue(formattedValue);
    if (typeof onBlur === 'function') {
      e.target.value = typeof parser === 'function' ? parser(trimValue(e.target.value)) : formatValue(trimValue(e.target.value));
      onBlur(e);
    }
  }, [onBlur]);
  var onInputKeyDown = useCallback(function (e) {
    if (typeof onKeyDown === 'function') {
      e.target.value = typeof parser === 'function' ? parser(e.target.value) : formatValue(e.target.value);
      onKeyDown(e);
    }
  }, [onKeyDown]);
  var placeholderClass = touched || inputValue && inputValue.length !== 0 ? 'active' : '';
  return /*#__PURE__*/React__default.createElement(InputWrap, {
    disabled: rest.disabled,
    theme: theme,
    nonOpacityOnDisabled: nonOpacityOnDisabled
  }, /*#__PURE__*/React__default.createElement(Label, {
    withIcon: withIcon,
    withoutBorderColorsOnValidate: withoutBorderColorsOnValidate,
    withoutClearButton: withoutClearButton,
    theme: theme,
    large: large ? 1 : 0
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    value: inputValue,
    placeholder: " ",
    type: type,
    onFocus: function onFocus() {
      return setTouched(true);
    },
    onReset: function onReset() {
      return setTouched(false);
    },
    "data-highlight-validate-touch": touched,
    onChange: onInputChange,
    onBlur: onInputBlur,
    onKeyDown: onInputKeyDown,
    "data-invalid": invalid ? 1 : 0,
    ref: ref
  }, rest)), /*#__PURE__*/React__default.createElement(Placeholder, {
    className: placeholderClass,
    large: large ? 1 : 0,
    withIcon: withIcon,
    theme: theme
  }, placeholder), withIcon && /*#__PURE__*/React__default.createElement(InputIcon, {
    large: large ? 1 : 0
  }, children), !withoutClearButton && inputValue && !rest.disabled && !rest.readOnly && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(ClearInputIcon, {
    large: large ? 1 : 0,
    onClick: function onClick() {
      onClearButtonCallback();
      setInputValue('');
    }
  })), withoutClearButton && showWarningIcon && /*#__PURE__*/React__default.createElement("span", {
    className: "warning"
  }, /*#__PURE__*/React__default.createElement(WarningIcon, {
    large: large ? 1 : 0
  })), /*#__PURE__*/React__default.createElement(Background, {
    theme: theme
  })));
});

var _excluded$4 = ["currency", "locales", "minimumFractionDigits"];
var KliCurrencyField = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? 'USD' : _ref$currency,
    _ref$locales = _ref.locales,
    locales = _ref$locales === void 0 ? 'en-us' : _ref$locales,
    _ref$minimumFractionD = _ref.minimumFractionDigits,
    minimumFractionDigits = _ref$minimumFractionD === void 0 ? 0 : _ref$minimumFractionD,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var formatter = function formatter(value) {
    return new Intl.NumberFormat(locales, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: minimumFractionDigits
    }).format(value);
  };
  var parser = function parser(value) {
    return String(value).replace(/[^0-9.]/g, '');
  };
  return /*#__PURE__*/React__default.createElement(KliBaseField, _extends({
    ref: ref
  }, props, {
    type: "text",
    formatter: formatter,
    parser: parser,
    withoutClearButton: true
  }));
});
KliCurrencyField.displayName = 'KliField.Currency';

var KliField = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React__default.createElement(KliBaseField, _extends({
    ref: ref
  }, props));
});
KliField.displayName = 'KliField';

KliField.Currency = KliCurrencyField;

var _excluded$5 = ["value", "onChange", "placeholder", "large", "invalid", "nonOpacityOnDisabled", "withoutClearButton", "highlightValidateOnFirstTouch"];
var KliTextarea = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    large = _ref.large,
    invalid = _ref.invalid,
    nonOpacityOnDisabled = _ref.nonOpacityOnDisabled,
    withoutClearButton = _ref.withoutClearButton,
    _ref$highlightValidat = _ref.highlightValidateOnFirstTouch,
    highlightValidateOnFirstTouch = _ref$highlightValidat === void 0 ? true : _ref$highlightValidat,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var _useState = useState(value),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var _useState2 = useState(false),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var theme = useContext(KliThemeContext);
  useEffect(function () {
    setInputValue(value);
  }, [value, setInputValue]);
  var onInputChange = useCallback(function (e) {
    setInputValue(e.target.value);
    if (typeof onChange !== 'undefined') {
      onChange(e);
    }
  }, [setInputValue]);
  return /*#__PURE__*/React__default.createElement(InputWrap, {
    disabled: rest.disabled,
    theme: theme,
    nonOpacityOnDisabled: nonOpacityOnDisabled
  }, /*#__PURE__*/React__default.createElement(Label, {
    theme: theme,
    large: large ? 1 : 0,
    withoutClearButton: withoutClearButton
  }, /*#__PURE__*/React__default.createElement("textarea", _extends({
    value: inputValue,
    placeholder: " ",
    onFocus: function onFocus() {
      return setTouched(true);
    },
    onReset: function onReset() {
      return setTouched(false);
    },
    "data-highlight-validate-touch": highlightValidateOnFirstTouch && touched,
    onChange: onInputChange,
    "data-invalid": invalid ? 1 : 0,
    ref: ref
  }, rest)), /*#__PURE__*/React__default.createElement(Placeholder, {
    large: large ? 1 : 0,
    theme: theme
  }, placeholder), inputValue && !rest.disabled && !withoutClearButton && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(ClearInputIcon, {
    large: large ? 1 : 0,
    onClick: function onClick() {
      return setInputValue('');
    }
  })), /*#__PURE__*/React__default.createElement(Background, {
    theme: theme
  })));
});
KliTextarea.displayName = 'KliTextarea';

var _templateObject$7, _templateObject2$5;
var Label$1 = styled.label(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    height: ", ";\n    width: ", ";\n    border-radius: 40px;\n    box-sizing: content-box;\n\n    input {\n        opacity: 0;\n        position: fixed;\n        z-index: 0;\n        height: 0;\n        width: 0;\n\n        &:focus:not(:disabled) ~ span {\n            box-shadow: 0 0 0 6px ", ";\n        }\n\n        &:checked:hover:not(:disabled) ~ span {\n            background-color: ", ";\n        }\n\n        &:hover:not(:disabled) ~ span {\n            border-color: ", ";\n        }\n\n        &:checked ~ span {\n            border-color: ", ";\n            background-color: ", ";\n\n            &::before {\n                left: ", ";\n                background-color: ", ";\n            }\n        }\n\n        &:not(:disabled) ~ * {\n            cursor: pointer;\n        }\n\n        &:disabled ~ * {\n            cursor: not-allowed;\n            opacity: 0.5;\n        }\n    }\n"])), function (_ref) {
  var large = _ref.large;
  return large ? '32px' : '20px';
}, function (_ref2) {
  var large = _ref2.large;
  return large ? '64px' : '40px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.lines;
}, function (_ref4) {
  var theme = _ref4.theme,
    selectedColor = _ref4.selectedColor;
  return theme.colors[selectedColor] || selectedColor || theme.colors.primary;
}, function (_ref5) {
  var theme = _ref5.theme,
    selectedColor = _ref5.selectedColor;
  return theme.colors[selectedColor] || selectedColor || theme.colors.primary;
}, function (_ref6) {
  var theme = _ref6.theme,
    selectedColor = _ref6.selectedColor;
  return theme.colors[selectedColor] || selectedColor || theme.colors.primaryText;
}, function (_ref7) {
  var theme = _ref7.theme,
    selectedColor = _ref7.selectedColor;
  return theme.colors[selectedColor] || selectedColor || theme.colors.primaryText;
}, function (_ref8) {
  var large = _ref8.large;
  return large ? '30px' : '16px';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.canvas;
});
var Background$1 = styled.span(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n    display: block;\n    height: ", ";\n    width: ", ";\n    border-radius: inherit;\n    position: relative;\n    border: 2px solid ", ";\n    background-color: ", ";\n    transition: ", ";\n    box-sizing: content-box;\n\n    &::before {\n        content: '';\n        display: block;\n        position: absolute;\n        top: -2px;\n        left: -2px;\n        border-radius: 50%;\n        height: ", ";\n        width: ", ";\n        border: inherit;\n        background-color: ", ";\n        transition: left 0.2s ease-in-out;\n        box-sizing: content-box;\n    }\n"])), function (_ref0) {
  var large = _ref0.large;
  return large ? '28px' : '18px';
}, function (_ref1) {
  var large = _ref1.large;
  return large ? '60px' : '36px';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primaryText;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.background;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.transition["default"];
}, function (_ref13) {
  var large = _ref13.large;
  return large ? '28px' : '18px';
}, function (_ref14) {
  var large = _ref14.large;
  return large ? '28px' : '18px';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.background;
});

var _excluded$6 = ["value", "checked", "onChange", "selectedColor", "large"];
var KliToggle = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var value = _ref.value,
    checked = _ref.checked,
    onChange = _ref.onChange,
    selectedColor = _ref.selectedColor,
    large = _ref.large,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var themeContext = useContext(KliThemeContext);
  var _useState = useState(checked),
    selected = _useState[0],
    toggle = _useState[1];
  var _onChange = useCallback(function (e) {
    toggle(e.target.checked);
    if (typeof onChange !== 'undefined') {
      onChange(e);
    }
  }, [toggle]);
  return /*#__PURE__*/React__default.createElement(Label$1, {
    large: large ? 1 : 0,
    theme: themeContext,
    selectedColor: selectedColor
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    checked: selected,
    onChange: _onChange,
    value: value,
    type: "checkbox"
  }, rest, {
    ref: ref
  })), /*#__PURE__*/React__default.createElement(Background$1, {
    large: large ? 1 : 0,
    theme: themeContext,
    selectedColor: selectedColor
  }));
});
KliToggle.displayName = 'KliToggle';

var _templateObject$8, _templateObject2$6;
var StyledAntdButton = styled(Button$1)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return css(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n        &.ant-btn {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border-radius: 2px;\n\n            width: auto;\n            height: auto;\n            padding: 14px 20px;\n\n            & > span:not(:only-child):first-child.kli-icon,\n            & > svg:not(:only-child):first-child {\n                margin-right: 10px;\n            }\n\n            & > span:not(:only-child):last-child.kli-icon,\n            & > svg:not(:only-child):last-child {\n                margin-left: 10px;\n            }\n\n            & span:not(.kli-icon):not(.kli-text),\n            & span:not(.kli-icon):not(.kli-text):focus {\n                color: ", ";\n                font: ", ";\n            }\n\n            & span,\n            & p,\n            & div,\n            & svg,\n            & span.kli-icon {\n                transition-duration: 0s;\n            }\n\n            & > svg {\n                width: 24px;\n                height: 24px;\n            }\n        }\n\n        // ----- TYPE STYLES ----- //\n        // type = 'default'\n        &.ant-btn-default {\n            border-width: 2px;\n\n            &:active,\n            &:focus {\n                color: ", ";\n                border-color: ", ";\n            }\n\n            @media (hover: hover) {\n                &:hover {\n                    color: ", ";\n                    border-color: ", ";\n                }\n            }\n        }\n\n        // type = 'primary'\n        &.ant-btn-background-ghost.ant-btn-primary:not(.ant-btn-dangerous),\n        &.ant-btn-primary:not(.ant-btn-disabled) {\n            &,\n            &:focus,\n            &:hover {\n                background-color: ", ";\n                border: 2px solid ", ";\n                color: ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n                border: 2px solid ", ";\n                color: ", ";\n            }\n\n            @media (hover: hover) {\n                &:hover {\n                    background-color: ", ";\n                    border: 2px solid ", ";\n                    color: ", ";\n                }\n            }\n\n            &:disabled,\n            &:hover:disabled {\n                color: ", ";\n                background-color: ", ";\n                border: 2px solid ", ";\n                opacity: 0.5;\n            }\n\n            & > span:not(.kli-icon):not(.kli-text) {\n                color: inherit;\n            }\n\n            // ghost = true\n            &.ant-btn-background-ghost {\n                &,\n                &:focus,\n                &:hover {\n                    background-color: transparent;\n                    color: ", ";\n                }\n\n                &:active {\n                    background-color: ", ";\n                    border: 2px solid ", ";\n                    color: ", ";\n                }\n\n                @media (hover: hover) {\n                    &:hover {\n                        background-color: ", ";\n                        border: 2px solid ", ";\n                        color: ", ";\n                    }\n                }\n\n                &:disabled,\n                &:hover:disabled {\n                    background-color: transparent;\n                    color: ", ";\n                }\n\n                & span:not(.kli-icon):not(.kli-text) {\n                    color: inherit;\n                }\n            }\n        }\n\n        // type = 'primary-inverted'\n        &.ant-btn-primary-inverted {\n            &,\n            &:focus,\n            &:hover {\n                color: ", ";\n                background-color: ", ";\n                border: 2px solid ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n                border: 2px solid ", ";\n                color: ", ";\n            }\n\n            @media (hover: hover) {\n                &:not(:disabled):hover {\n                    background-color: ", ";\n                    border: 2px solid ", ";\n                    color: ", ";\n                }\n            }\n\n            &:disabled,\n            &:hover:disabled {\n                background-color: ", ";\n                border: 2px solid ", ";\n                color: ", ";\n                opacity: 0.5;\n            }\n\n            & > span:not(.kli-icon):not(.kli-text) {\n                color: inherit;\n            }\n\n            // ghost = true\n            &.ant-btn-background-ghost {\n                &,\n                &:active,\n                &:hover,\n                &:hover:disabled,\n                &:focus {\n                    background-color: transparent;\n                }\n            }\n        }\n\n        // type = 'secondary'\n        &.ant-btn-secondary {\n            &,\n            &:focus,\n            &:hover {\n                background-color: ", ";\n                border: 2px solid ", ";\n                color: ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n                border: 2px solid ", ";\n                color: ", ";\n            }\n\n            @media (hover: hover) {\n                &:hover {\n                    background-color: ", ";\n                    border: 2px solid ", ";\n                    color: ", ";\n                }\n            }\n\n            &:disabled,\n            &:hover:disabled {\n                background-color: ", ";\n                border: 2px solid ", ";\n                color: ", ";\n                opacity: 0.5;\n            }\n\n            & > span:not(.kli-icon):not(.kli-text) {\n                color: inherit;\n            }\n        }\n\n        // type = 'text'\n        &.ant-btn-text {\n            &,\n            &:focus,\n            &:hover {\n                background-color: transparent;\n                border: 2px solid transparent;\n            }\n\n            &:active {\n                background-color: transparent;\n                border: 2px solid transparent;\n                color: ", ";\n            }\n\n            @media (hover: hover) {\n                &:hover {\n                    background-color: transparent;\n                    border: 2px solid transparent;\n                    color: ", ";\n                }\n            }\n\n            &:disabled,\n            &:hover:disabled {\n                background-color: transparent;\n                border: 2px solid transparent;\n                color: ", ";\n                opacity: 0.5;\n            }\n\n            & > span:not(.kli-icon):not(.kli-text) {\n                color: inherit;\n            }\n        }\n\n        // type = 'unstyled'\n        &.ant-btn-unstyled {\n            &,\n            &:active,\n            &:focus,\n            &:hover {\n                background-color: transparent;\n                border: 2px solid transparent;\n                color: ", ";\n                box-shadow: none;\n\n                &:after {\n                    display: none;\n                }\n            }\n\n            &:disabled,\n            &:hover:disabled {\n                background-color: transparent;\n                border: 2px solid transparent;\n                color: ", ";\n                box-shadow: none;\n                opacity: 0.5;\n            }\n\n            & > span:not(.kli-icon):not(.kli-text) {\n                color: inherit;\n            }\n        }\n\n        // type = 'dashed'\n        &.ant-btn-dashed {\n            &,\n            &:focus,\n            &:hover {\n                background-color: ", ";\n                color: ", ";\n                border-color: ", ";\n                border-width: 2px;\n            }\n\n            &:active {\n                color: ", ";\n                border-color: ", ";\n            }\n\n            @media (hover: hover) {\n                &:hover {\n                    color: ", ";\n                    border-color: ", ";\n                }\n            }\n\n            &:disabled,\n            &:hover:disabled {\n                background-color: ", ";\n                color: ", ";\n                border-color: ", ";\n                opacity: 0.5;\n            }\n\n            &.ant-btn-background-ghost {\n                background-color: transparent;\n\n                &:disabled,\n                &:hover:disabled {\n                    background-color: transparent;\n                }\n            }\n\n            & > span:not(.kli-icon):not(.kli-text) {\n                color: inherit;\n            }\n        }\n        // ----- TYPE STYLES END ----- //\n\n        // ----- SIZE STYLES ----- //\n        // size = 'large'\n        &.ant-btn-lg {\n            & {\n                padding: 18px 24px;\n            }\n\n            &,\n            &:active,\n            &:focus {\n                font: ", ";\n            }\n\n            & > span:not(.kli-icon):not(.kli-text) {\n                font: inherit;\n            }\n        }\n\n        // size = 'medium'\n        &.ant-btn-md {\n            & {\n                padding: 14px 20px;\n            }\n\n            &,\n            &:active,\n            &:focus {\n                font: ", ";\n            }\n\n            span:not(.kli-icon):not(.kli-text) {\n                font: inherit;\n            }\n\n            & > svg {\n                width: 20px;\n                height: 20px;\n            }\n        }\n\n        // size = 'small'\n        &.ant-btn-sm {\n            & {\n                padding: 10px 16px;\n            }\n\n            &,\n            &:active,\n            &:focus {\n                font: ", ";\n            }\n\n            span:not(.kli-icon):not(.kli-text) {\n                font: inherit;\n            }\n\n            & > svg {\n                width: 16px;\n                height: 16px;\n            }\n        }\n        // ----- SIZE STYLES END ----- //\n\n        // ----- SHAPE STYLES ----- //\n        &.ant-btn-circle {\n            width: 40px;\n            height: 40px;\n            padding: 0;\n        }\n        // ----- SHAPE STYLES END ----- //\n\n        &.ant-btn-block {\n            width: 100%;\n        }\n    "])), $theme.colors.primaryText, $theme.fonts.badgeMedium, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.canvas, $theme.colors.background, $theme.colors.background, $theme.colors.primaryText, $theme.colors.lines, $theme.colors.lines, $theme.colors.primaryText, $theme.colors.lines, $theme.colors.lines, $theme.colors.primaryText, $theme.colors.background, $theme.colors.background, $theme.colors.primaryText, $theme.colors.primary, $theme.colors.primary, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.secondaryText, $theme.colors.secondaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.secondaryText, $theme.colors.secondaryText, $theme.fonts.badgeLarge, $theme.fonts.badgeMedium, $theme.fonts.badgeSmall);
});

var _excluded$7 = ["children", "danger"];
var Button = function Button(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAntdButton, _extends({
    $theme: themeContext
  }, props), children);
};

var _excluded$8 = ["onClose", "children", "cantClose"];
var Chip = function Chip(_ref) {
  var onClose = _ref.onClose,
    children = _ref.children,
    cantClose = _ref.cantClose,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return /*#__PURE__*/React__default.createElement(Button, _extends({
    size: "small"
  }, rest), /*#__PURE__*/React__default.createElement("span", null, children), !cantClose && /*#__PURE__*/React__default.createElement(SvgCloseX, {
    onClick: onClose || null
  }));
};

var _templateObject$9, _templateObject2$7, _templateObject3$4, _templateObject4$4, _templateObject5$3;
var KliCardContentDirections = Object.freeze({
  column: 'column',
  row: 'row'
});
var CardWrap = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n    white-space: break-spaces;\n    box-sizing: border-box;\n    display: flex;\n    padding: 20px;\n    flex-direction: ", ";\n    background: ", ";\n    transition: ", ";\n    position: relative;\n    align-items: center;\n\n    &:hover {\n        box-shadow: ", ";\n    }\n\n    & > div {\n        width: ", ";\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n"])), function (_ref) {
  var direction = _ref.direction;
  return KliCardContentDirections[direction];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.canvas;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition["default"];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.primary;
}, function (_ref5) {
  var direction = _ref5.direction;
  return direction === KliCardContentDirections.column ? '100%' : '50%';
});
var ImageWrap = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    position: relative;\n    display: flex;\n    padding: 10px 20px 10px 0;\n\n    img {\n        display: block;\n        max-width: 100%;\n        max-height: 100%;\n        margin: auto;\n        padding: 0;\n        outline: none;\n    }\n"])));
var ContentWrap = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n\n    ", "\n"])), function (_ref6) {
  var withButton = _ref6.withButton;
  return withButton ? css(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n                  padding-bottom: 90px;\n              "]))) : '';
});
var ButtonWrap = styled.div(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    width: ", ";\n    padding: ", ";\n    position: absolute;\n    bottom: 10px;\n    left: ", ";\n\n    & > button {\n        width: 100%;\n    }\n"])), function (_ref7) {
  var direction = _ref7.direction;
  return direction === KliCardContentDirections.column ? '100%' : '50%';
}, function (_ref8) {
  var direction = _ref8.direction;
  return direction === KliCardContentDirections.column ? '10px 20px' : '10px 20px 10px 0';
}, function (_ref9) {
  var direction = _ref9.direction;
  return direction === KliCardContentDirections.column ? '0' : '50%';
});

var _excluded$9 = ["children", "img", "button", "direction"];
var KliCard = function KliCard(_ref) {
  var children = _ref.children,
    img = _ref.img,
    button = _ref.button,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? KliCardContentDirections.column : _ref$direction,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(CardWrap, _extends({
    theme: themeContext,
    direction: direction
  }, rest), !!img && /*#__PURE__*/React__default.createElement(ImageWrap, null, img), /*#__PURE__*/React__default.createElement(ContentWrap, {
    direction: direction,
    withButton: !!button
  }, children, !!button && /*#__PURE__*/React__default.createElement(ButtonWrap, {
    direction: direction
  }, button)));
};

var _templateObject$a, _templateObject2$8;
var sharedTypographyStyles = css(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    color: ", ";\n    text-align: ", ";\n\n    ", ";\n"])), function (_ref) {
  var $color = _ref.$color,
    $theme = _ref.$theme;
  return $theme.colors[$color] || $color || 'inherit';
}, function (_ref2) {
  var $align = _ref2.$align;
  return $align || 'left';
}, function (_ref3) {
  var $marginBottom = _ref3.$marginBottom;
  return $marginBottom && css(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n            margin-bottom: ", ";\n        "])), $marginBottom);
});

var _templateObject$b;
var StyledText = styled(Typography$1.Text)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n    ", ";\n    font: ", ";\n"])), sharedTypographyStyles, function (_ref) {
  var _ref$$type = _ref.$type,
    $type = _ref$$type === void 0 ? 'body2' : _ref$$type,
    $theme = _ref.$theme;
  return $theme.fonts[$type];
});

var _excluded$a = ["children", "type", "color", "align", "as", "marginBottom"];
var Text = function Text(_ref) {
  var children = _ref.children,
    type = _ref.type,
    color = _ref.color,
    align = _ref.align,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'p' : _ref$as,
    marginBottom = _ref.marginBottom,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledText, _extends({
    $type: type,
    $color: color,
    $align: align,
    $theme: theme,
    as: as,
    $marginBottom: marginBottom
  }, props), children);
};

var getFontByThemeAndLevel = function getFontByThemeAndLevel(theme, level) {
  switch (level) {
    default:
      return theme.fonts.headline1;
    case 2:
      return theme.fonts.headline2;
    case 3:
      return theme.fonts.headline3;
  }
};

var _templateObject$c;
var StyledTitle = styled(Typography$1.Title)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n    && {\n        ", ";\n        font: ", ";\n    }\n"])), sharedTypographyStyles, function (_ref) {
  var $theme = _ref.$theme,
    level = _ref.level;
  return getFontByThemeAndLevel($theme, level);
});

var _excluded$b = ["children", "color", "align", "marginBottom"];
var Title = function Title(_ref) {
  var children = _ref.children,
    color = _ref.color,
    align = _ref.align,
    marginBottom = _ref.marginBottom,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledTitle, _extends({
    $theme: theme,
    $color: color,
    $align: align,
    $marginBottom: marginBottom
  }, props), children);
};

var Typography = function Typography(props) {
  return /*#__PURE__*/createElement(Typography$1, props);
};
Typography.Title = Title;
Typography.Text = Text;

var _templateObject$d, _templateObject2$9, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$3;
var CouponImgWrap = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n    margin-right: 16px;\n"])));
var CouponDetails = styled.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"])));
var CouponTitle = styled(Typography.Title)(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));
var CouponDescription = styled(Typography.Text)(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n    margin: 6px 0;\n\n    ", ";\n"])), function (_ref) {
  var $showFullDescription = _ref.$showFullDescription;
  return $showFullDescription ? css(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose([""]))) : css(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n                  display: -webkit-box;\n                  -webkit-line-clamp: 2;\n                  -webkit-box-orient: vertical;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n              "])));
});

var KliActiveCouponContent = function KliActiveCouponContent(_ref) {
  var img = _ref.img,
    title = _ref.title,
    description = _ref.description,
    showFullDescription = _ref.showFullDescription,
    _ref$additionalDetail = _ref.additionalDetailsContent,
    additionalDetailsContent = _ref$additionalDetail === void 0 ? null : _ref$additionalDetail,
    additionalDetailsContentOnTop = _ref.additionalDetailsContentOnTop,
    themeContext = _ref.themeContext;
  return /*#__PURE__*/React__default.createElement(Fragment, null, img ? /*#__PURE__*/React__default.createElement(CouponImgWrap, null, img) : null, /*#__PURE__*/React__default.createElement(CouponDetails, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CouponTitle, {
    "data-e2e": "coupons_coupon-title_value",
    level: 3,
    color: themeContext.colors.primaryText
  }, title), additionalDetailsContentOnTop ? additionalDetailsContent : null, /*#__PURE__*/React__default.createElement(CouponDescription, {
    $showFullDescription: showFullDescription,
    type: "body2",
    "data-e2e": "coupons_coupon-description_value"
  }, description)), !additionalDetailsContentOnTop ? additionalDetailsContent : null));
};

var _templateObject$e, _templateObject2$a;
var CouponDetails$1 = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n    width: 100%;\n"])));
var CouponTitle$1 = styled(Typography.Title)(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n    margin-bottom: 16px;\n"])));

var KliDeletedCouponContent = function KliDeletedCouponContent(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CouponDetails$1, null, /*#__PURE__*/React__default.createElement(CouponTitle$1, {
    level: 3,
    color: "primaryText",
    "data-e2e": "coupons_coupon-title_value"
  }, title)));
};

var _templateObject$f, _templateObject2$b, _templateObject3$6, _templateObject4$6, _templateObject5$5, _templateObject6$4;
var CouponImgWrap$1 = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n    margin-right: 16px;\n"])));
var CouponDetails$2 = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose([""])));
var CouponTitle$2 = styled(Typography.Title)(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));
var CouponDescription$1 = styled(Typography.Text)(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteralLoose(["\n    margin: 6px 0;\n\n    ", ";\n"])), function (_ref) {
  var $showFullDescription = _ref.$showFullDescription;
  return $showFullDescription ? css(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteralLoose([""]))) : css(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n                  display: -webkit-box;\n                  -webkit-line-clamp: 2;\n                  -webkit-box-orient: vertical;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n              "])));
});

var KliExpiredCouponContent = function KliExpiredCouponContent(_ref) {
  var img = _ref.img,
    title = _ref.title,
    description = _ref.description,
    showFullDescription = _ref.showFullDescription,
    _ref$additionalDetail = _ref.additionalDetailsContent,
    additionalDetailsContent = _ref$additionalDetail === void 0 ? null : _ref$additionalDetail;
  return /*#__PURE__*/React__default.createElement(Fragment, null, img ? /*#__PURE__*/React__default.createElement(CouponImgWrap$1, null, img) : null, /*#__PURE__*/React__default.createElement(CouponDetails$2, null, /*#__PURE__*/React__default.createElement(CouponTitle$2, {
    level: 3,
    "data-e2e": "coupons_coupon-title_value"
  }, title), /*#__PURE__*/React__default.createElement(CouponDescription$1, {
    $showFullDescription: showFullDescription,
    type: "body2",
    "data-e2e": "coupons_coupon-description_value"
  }, description), additionalDetailsContent));
};

var _templateObject$g, _templateObject2$c, _templateObject3$7, _templateObject4$7, _templateObject5$6, _templateObject6$5, _templateObject7$2, _templateObject8$2;
var CouponWrap = styled.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: ", ";\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    border-width: 2px;\n    border-color: ", ";\n    border-style: dashed;\n    cursor: ", ";\n\n    ", ";\n\n    ", ";\n"])), function (_ref) {
  var $align = _ref.$align;
  return $align === 'center' ? 'column' : 'row';
}, function (_ref2) {
  var $primary = _ref2.$primary,
    $theme = _ref2.$theme;
  return $primary ? $theme.colors.primary : $theme.colors.primaryText;
}, function (_ref3) {
  var $pointer = _ref3.$pointer;
  return $pointer ? 'pointer' : 'default';
}, function (_ref4) {
  var $status = _ref4.$status,
    $theme = _ref4.$theme;
  return $status === 'deleted' ? css(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n                  border: none;\n                  background-color: ", ";\n                  cursor: auto;\n              "])), $theme.colors.background) : '';
}, function (_ref5) {
  var $status = _ref5.$status;
  return $status === 'expired' || $status === 'redeemed' ? css(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n                  cursor: default;\n                  opacity: 0.5;\n              "]))) : '';
});
var CouponContent = styled.div(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteralLoose(["\n    padding: 24px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-grow: 1;\n    max-width: 100%;\n    overflow: hidden;\n"])));
var CouponButtonsWrap = styled.div(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n"])));
var StyledText$1 = styled(Typography.Text)(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteralLoose(["\n    padding: 12px 0;\n"])));
var CouponExpiredTextWrap = styled.div(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n"])));
var BottomContentWrap = styled.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n    padding: 0 24px 20px;\n"])));

var _excluded$c = ["primary", "status", "img", "title", "description", "showFullDescription", "additionalDetailsContent", "additionalDetailsContentOnTop", "bottomContent", "onClick", "onUseRewardClick", "onUndoDeletingClick", "onDeleteClick", "align"];
var KliCoupon = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$primary = _ref.primary,
    primary = _ref$primary === void 0 ? false : _ref$primary,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'available' : _ref$status,
    img = _ref.img,
    title = _ref.title,
    description = _ref.description,
    _ref$showFullDescript = _ref.showFullDescription,
    showFullDescription = _ref$showFullDescript === void 0 ? false : _ref$showFullDescript,
    _ref$additionalDetail = _ref.additionalDetailsContent,
    additionalDetailsContent = _ref$additionalDetail === void 0 ? null : _ref$additionalDetail,
    _ref$additionalDetail2 = _ref.additionalDetailsContentOnTop,
    additionalDetailsContentOnTop = _ref$additionalDetail2 === void 0 ? false : _ref$additionalDetail2,
    _ref$bottomContent = _ref.bottomContent,
    bottomContent = _ref$bottomContent === void 0 ? undefined : _ref$bottomContent,
    onClick = _ref.onClick,
    onUseRewardClick = _ref.onUseRewardClick,
    onUndoDeletingClick = _ref.onUndoDeletingClick,
    onDeleteClick = _ref.onDeleteClick,
    align = _ref.align,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  var themeContext = useContext(KliThemeContext);
  var inActiveStatus = status === 'available';
  var inAllocatedStatus = status === 'allocated';
  var inDeletedStatus = status === 'deleted';
  var inExpiredStatus = status === 'expired';
  var inRedeemedStatus = status === 'redeemed';
  var isActive = typeof onClick === 'function' && (inActiveStatus || inAllocatedStatus);
  var renderBottomContent = function renderBottomContent() {
    if (bottomContent) {
      return /*#__PURE__*/React__default.createElement(BottomContentWrap, null, bottomContent);
    }
    if (bottomContent === null) {
      return null;
    }
    if (inActiveStatus || inAllocatedStatus) {
      return /*#__PURE__*/React__default.createElement(BottomContentWrap, null, /*#__PURE__*/React__default.createElement(CouponButtonsWrap, null, typeof onUseRewardClick === 'function' ? /*#__PURE__*/React__default.createElement(Button, {
        type: "unstyled",
        style: {
          paddingLeft: 0
        },
        onClick: function onClick(event) {
          event.stopPropagation();
          return onUseRewardClick();
        }
      }, /*#__PURE__*/React__default.createElement(Typography.Text, {
        type: "badgeSmall",
        "data-e2e": "coupons_use-reward_btn"
      }, "Use reward"), /*#__PURE__*/React__default.createElement(KliIcon, {
        size: "16px"
      }, /*#__PURE__*/React__default.createElement(SvgArrowChevronForward, null))) : null, typeof onDeleteClick === 'function' ? /*#__PURE__*/React__default.createElement(Button, {
        type: "unstyled",
        style: {
          paddingRight: 0
        },
        onClick: function onClick(event) {
          event.stopPropagation();
          return onDeleteClick();
        }
      }, /*#__PURE__*/React__default.createElement(KliIcon, {
        size: "16px"
      }, /*#__PURE__*/React__default.createElement(SvgDelete, null)), /*#__PURE__*/React__default.createElement(Typography.Text, {
        type: "badgeSmall",
        "data-e2e": "coupons_unclip_btn"
      }, "Unclip")) : null));
    }
    if (inDeletedStatus) {
      return /*#__PURE__*/React__default.createElement(BottomContentWrap, null, /*#__PURE__*/React__default.createElement(CouponButtonsWrap, null, /*#__PURE__*/React__default.createElement(StyledText$1, {
        type: "badgeSmall",
        color: "secondaryText",
        "data-e2e": "coupons_reward-unclipped_text"
      }, "Reward unclipped"), typeof onUndoDeletingClick === 'function' ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Button, {
        "data-e2e": "coupons_undo_btn",
        color: "primaryText",
        type: "unstyled",
        onClick: function onClick(event) {
          event.stopPropagation();
          return onUndoDeletingClick();
        }
      }, /*#__PURE__*/React__default.createElement(KliIcon, null, /*#__PURE__*/React__default.createElement(SvgArrowReply, null)), /*#__PURE__*/React__default.createElement(Typography.Text, {
        type: "badgeSmall"
      }, "Undo"))) : null));
    }
    if (inExpiredStatus) {
      return /*#__PURE__*/React__default.createElement(BottomContentWrap, null, /*#__PURE__*/React__default.createElement(CouponExpiredTextWrap, null, /*#__PURE__*/React__default.createElement(KliIcon, {
        size: "16px",
        style: {
          marginRight: '8px'
        }
      }, /*#__PURE__*/React__default.createElement(SvgTime, null)), /*#__PURE__*/React__default.createElement(Typography.Text, {
        type: "badgeSmall",
        "data-e2e": "coupons_reward-expired_status"
      }, "REWARD EXPIRED")));
    }
    if (inRedeemedStatus) {
      return /*#__PURE__*/React__default.createElement(BottomContentWrap, null, /*#__PURE__*/React__default.createElement(CouponExpiredTextWrap, null, /*#__PURE__*/React__default.createElement(KliIcon, {
        size: "16px",
        style: {
          marginRight: '8px'
        }
      }, /*#__PURE__*/React__default.createElement(SvgEmojiHappySmile, null)), /*#__PURE__*/React__default.createElement(Typography.Text, {
        type: "badgeSmall",
        "data-e2e": "coupons_reward-applied_status"
      }, "REWARD APPLIED")));
    }
  };
  return /*#__PURE__*/React__default.createElement(CouponWrap, _extends({
    $align: align,
    $theme: themeContext,
    $status: status,
    $primary: primary,
    $pointer: isActive,
    onClick: isActive ? onClick : null,
    ref: ref
  }, rest), /*#__PURE__*/React__default.createElement(CouponContent, null, (inActiveStatus || inAllocatedStatus) && /*#__PURE__*/React__default.createElement(KliActiveCouponContent, {
    primary: primary,
    img: img,
    title: title,
    description: description,
    showFullDescription: showFullDescription,
    additionalDetailsContent: additionalDetailsContent,
    additionalDetailsContentOnTop: additionalDetailsContentOnTop,
    themeContext: themeContext
  }), inDeletedStatus && /*#__PURE__*/React__default.createElement(KliDeletedCouponContent, {
    title: title
  }), inExpiredStatus && /*#__PURE__*/React__default.createElement(KliExpiredCouponContent, {
    img: img,
    title: title,
    description: description,
    showFullDescription: showFullDescription,
    additionalDetailsContent: additionalDetailsContent,
    additionalDetailsContentOnTop: additionalDetailsContentOnTop,
    themeContext: themeContext
  }), inRedeemedStatus && /*#__PURE__*/React__default.createElement(KliExpiredCouponContent, {
    img: img,
    title: title,
    description: description,
    showFullDescription: showFullDescription,
    additionalDetailsContent: additionalDetailsContent,
    additionalDetailsContentOnTop: additionalDetailsContentOnTop,
    themeContext: themeContext
  })), renderBottomContent());
});

var _templateObject$h;
var StyledAvatar = styled(Avatar$1)(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    cursor: pointer;\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return $theme.colors.canvas;
});

var Avatar = function Avatar(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAvatar, _extends({
    $theme: theme,
    size: 40,
    icon: /*#__PURE__*/React__default.createElement(SvgAvatarNew, null)
  }, props));
};

var _templateObject$i, _templateObject2$d, _templateObject3$8, _templateObject4$8, _templateObject5$7, _templateObject6$6;
var Wrap = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    display: flex;\n    border: ", ";\n    align-items: center;\n    justify-content: space-between;\n    padding: 25px;\n    box-sizing: border-box;\n    flex-wrap: wrap-reverse;\n    background-color: ", ";\n    color: ", ";\n\n    button {\n        white-space: nowrap;\n    }\n\n    .button-wrap {\n        display: flex;\n        width: ", ";\n        justify-content: ", ";\n        align-items: center;\n        padding-bottom: 20px;\n    }\n"])), function (_ref) {
  var theme = _ref.theme,
    withoutBorders = _ref.withoutBorders;
  return "2px solid " + (withoutBorders ? 'transparent' : theme.colors.primaryText);
}, function (_ref2) {
  var theme = _ref2.theme,
    backgroundColor = _ref2.backgroundColor;
  return theme.colors[backgroundColor] || backgroundColor || 'transparent';
}, function (_ref3) {
  var theme = _ref3.theme,
    color = _ref3.color;
  return theme.colors[color] || color || 'inherit';
}, function (_ref4) {
  var simple = _ref4.simple;
  return simple ? 'auto' : '100%';
}, function (_ref5) {
  var withBackIcon = _ref5.withBackIcon;
  return withBackIcon ? 'space-between' : 'flex-end';
});
var AvatarWrap = styled.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n\n    .avatar {\n        margin-right: 24px;\n    }\n"])));
var BackIconWrap = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n    margin-right: 10px;\n"])));
var TitlesWrap = styled.div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: ", ";\n    text-align: ", ";\n\n    ", "\n"])), function (_ref6) {
  var titleOnTop = _ref6.titleOnTop;
  return titleOnTop ? 'column-reverse' : 'column';
}, function (_ref7) {
  var textAlign = _ref7.textAlign;
  return textAlign || 'inherit';
}, function (_ref8) {
  var titleOnTop = _ref8.titleOnTop;
  return titleOnTop ? css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n                  h1 {\n                      margin-bottom: 14px;\n                  }\n              "]))) : css(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteralLoose(["\n                  p {\n                      margin-bottom: 8px;\n                  }\n              "])));
});

var _excluded$d = ["avatar", "title", "titleComponent", "subTitle", "editText", "simple", "icon", "backIcon", "withoutBorders", "titleOnTop", "textAlign", "backgroundColor", "color", "onBack", "onEdit"];
var KliHero = function KliHero(_ref) {
  var avatar = _ref.avatar,
    title = _ref.title,
    titleComponent = _ref.titleComponent,
    subTitle = _ref.subTitle,
    editText = _ref.editText,
    _ref$simple = _ref.simple,
    simple = _ref$simple === void 0 ? true : _ref$simple,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/React__default.createElement(SvgEdit, null) : _ref$icon,
    _ref$backIcon = _ref.backIcon,
    backIcon = _ref$backIcon === void 0 ? /*#__PURE__*/React__default.createElement(SvgBackArrow, null) : _ref$backIcon,
    _ref$withoutBorders = _ref.withoutBorders,
    withoutBorders = _ref$withoutBorders === void 0 ? false : _ref$withoutBorders,
    _ref$titleOnTop = _ref.titleOnTop,
    titleOnTop = _ref$titleOnTop === void 0 ? false : _ref$titleOnTop,
    textAlign = _ref.textAlign,
    backgroundColor = _ref.backgroundColor,
    color = _ref.color,
    onBack = _ref.onBack,
    onEdit = _ref.onEdit,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var themeContext = useContext(KliThemeContext);
  var Title = titleComponent || Typography.Title;
  return /*#__PURE__*/React__default.createElement(Wrap, _extends({
    theme: themeContext,
    withoutBorders: withoutBorders,
    withBackIcon: !!onBack,
    simple: simple,
    backgroundColor: backgroundColor,
    color: color
  }, rest), /*#__PURE__*/React__default.createElement(AvatarWrap, null, !!onBack && simple && /*#__PURE__*/React__default.createElement(BackIconWrap, {
    theme: simple
  }, /*#__PURE__*/React__default.createElement(Button, {
    style: {
      padding: 0
    },
    type: "unstyled",
    onClick: onBack,
    "data-e2e": "common_back_btn"
  }, /*#__PURE__*/React__default.createElement(KliIcon, {
    color: color,
    size: "24px"
  }, backIcon))), avatar && /*#__PURE__*/React__default.createElement(Avatar, {
    className: "avatar",
    src: avatar
  }), (subTitle || title) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TitlesWrap, {
    titleOnTop: titleOnTop,
    textAlign: textAlign
  }, subTitle && /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "systemBody2",
    align: textAlign,
    "data-e2e": "common_page_subtitle"
  }, subTitle), title && /*#__PURE__*/React__default.createElement(Title, {
    align: textAlign,
    "data-e2e": "common_page_title"
  }, title)))), (!!onBack || !!onEdit) && /*#__PURE__*/React__default.createElement("div", {
    className: "button-wrap"
  }, !!onBack && !simple && /*#__PURE__*/React__default.createElement(BackIconWrap, {
    theme: simple
  }, /*#__PURE__*/React__default.createElement(Button, {
    style: {
      padding: 0
    },
    type: "unstyled",
    onClick: onBack,
    "data-e2e": "common_back_btn"
  }, /*#__PURE__*/React__default.createElement(KliIcon, {
    color: color,
    size: "24px"
  }, backIcon))), !!onEdit && /*#__PURE__*/React__default.createElement(Button, {
    type: "unstyled",
    style: {
      padding: '14px 0'
    },
    onClick: onEdit
  }, !!icon && /*#__PURE__*/React__default.createElement(KliIcon, {
    color: color
  }, icon), editText && /*#__PURE__*/React__default.createElement(Typography.Text, {
    color: color,
    type: "badgeSmall",
    as: "span"
  }, editText))));
};

var _templateObject$j, _templateObject2$e, _templateObject3$9, _templateObject4$9;
var InfinityScrollGalleryWrap = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n    height: ", ";\n    width: 100%;\n    margin: 0 auto;\n    position: relative;\n    transform: translate3d(0, 0, 0);\n    display: flex;\n\n    overflow: hidden;\n\n    ", "\n"])), function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var stopOnHover = _ref2.stopOnHover;
  return stopOnHover ? css(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteralLoose(["\n                  &:hover > div {\n                      animation-play-state: paused;\n                  }\n              "]))) : '';
});
var InfinityScrollGalleryMove = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    transform: translate3d(0, 0, 0);\n    display: flex;\n    will-change: transform;\n    animation: ", " ", "s linear infinite;\n"])), moveSlideshow, function (_ref3) {
  var speed = _ref3.speed;
  return speed;
});
var InfinityScrollGalleryMoveItem = styled.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    width: auto;\n"])));

var _excluded$e = ["children", "speed", "height", "stopOnHover"];
var KliInfinityScrollGallery = function KliInfinityScrollGallery(_ref) {
  var children = _ref.children,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 10 : _ref$speed,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$stopOnHover = _ref.stopOnHover,
    stopOnHover = _ref$stopOnHover === void 0 ? false : _ref$stopOnHover,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  return /*#__PURE__*/React__default.createElement(InfinityScrollGalleryWrap, _extends({}, rest, {
    height: height,
    stopOnHover: stopOnHover
  }), /*#__PURE__*/React__default.createElement(InfinityScrollGalleryMove, {
    speed: speed
  }, children.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(InfinityScrollGalleryMoveItem, {
      key: item.id || item.key || item.title || Math.random() + index
    }, /*#__PURE__*/cloneElement(item));
  })), /*#__PURE__*/React__default.createElement(InfinityScrollGalleryMove, {
    speed: speed
  }, children.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(InfinityScrollGalleryMoveItem, {
      key: item.id || item.key || item.title || Math.random() + index
    }, /*#__PURE__*/cloneElement(item));
  })));
};

var KliHintersType = Object.freeze({
  general: 'general',
  success: 'success',
  error: 'error',
  alert: 'alert'
});

var _templateObject$k, _templateObject2$f, _templateObject3$a;
var KliNotificationWrapper = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 25px;\n    margin: 0 0 10px;\n    color: ", ";\n    background: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryText;
}, function (_ref2) {
  var theme = _ref2.theme,
    type = _ref2.type;
  return "rgba(" + theme.RGB[type] + ", 0.1)";
});
var IconWrap$1 = styled.span(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 24px;\n    height: 26px;\n\n    margin-left: ", ";\n    margin-right: ", ";\n\n    color: ", ";\n"])), function (props) {
  return props.right ? '15px' : 0;
}, function (props) {
  return props.left ? '15px' : 0;
}, function (props) {
  if (props.type === KliHintersType.general) {
    return props.theme.colors.primaryText;
  }
  if (props.type === KliHintersType.general) {
    return props.theme.colors.primaryText;
  }
  if (props.type === KliHintersType.error) {
    return props.theme.colors.error;
  }
  if (props.type === KliHintersType.success) {
    return props.theme.colors.success;
  }
  if (props.type === KliHintersType.alert) {
    return props.theme.colors.alert;
  }
});
var NotificationContent = styled.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-grow: 2;\n    justify-content: ", ";\n    align-items: ", ";\n"])), function (_ref3) {
  var justify = _ref3.justify;
  return justify;
}, function (_ref4) {
  var align = _ref4.align;
  return align;
});

var _excluded$f = ["type", "canClose", "withoutIcon", "icon", "align", "justify", "onClose", "id", "children"];
var defaultIcon = function defaultIcon(type) {
  if (type === KliHintersType.general) {
    return /*#__PURE__*/React__default.createElement(SvgCircleActionsPlaceholder, null);
  }
  if (type === KliHintersType.success) {
    return /*#__PURE__*/React__default.createElement(SvgCircleActionsSuccess, null);
  }
  if (type === KliHintersType.error) {
    return /*#__PURE__*/React__default.createElement(SvgCircleActionsClose, null);
  }
  if (type === KliHintersType.alert) {
    return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertInfo, null);
  }
};
var KliNotification = function KliNotification(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? KliHintersType.general : _ref$type,
    _ref$canClose = _ref.canClose,
    canClose = _ref$canClose === void 0 ? false : _ref$canClose,
    _ref$withoutIcon = _ref.withoutIcon,
    withoutIcon = _ref$withoutIcon === void 0 ? false : _ref$withoutIcon,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? defaultIcon(type) : _ref$icon,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? 'flex-start' : _ref$justify,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(KliNotificationWrapper, _extends({
    theme: themeContext,
    type: type
  }, rest), !withoutIcon && /*#__PURE__*/React__default.createElement(IconWrap$1, {
    left: true,
    type: type,
    theme: themeContext
  }, icon), /*#__PURE__*/React__default.createElement(NotificationContent, {
    align: align,
    justify: justify
  }, children), canClose && /*#__PURE__*/React__default.createElement(IconWrap$1, {
    right: true,
    type: type,
    theme: themeContext
  }, /*#__PURE__*/React__default.createElement(SvgCloseX, {
    onClick: onClose
  })));
};

var _templateObject$l;
var NotificationsProviderWrap = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 9;\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n"])));

var _excluded$g = ["notifications"],
  _excluded2 = ["message", "id"];
var KliNotificationsProvider = function KliNotificationsProvider(_ref) {
  var _ref$notifications = _ref.notifications,
    notifications = _ref$notifications === void 0 ? [] : _ref$notifications,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  var _renderNotifications = notifications.map(function (_ref2) {
    var message = _ref2.message,
      _ref2$id = _ref2.id,
      id = _ref2$id === void 0 ? new Date().getTime().toString() : _ref2$id,
      notification = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return /*#__PURE__*/React__default.createElement(KliNotification, _extends({
      key: id,
      id: id
    }, notification), message);
  });
  return /*#__PURE__*/React__default.createElement(NotificationsProviderWrap, rest, _renderNotifications);
};

var _templateObject$m;
var Wrap$1 = styled.span(_templateObject$m || (_templateObject$m = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    vertical-align: inherit;\n"])));

var KliOutsideClick = /*#__PURE__*/function (_Component) {
  function KliOutsideClick() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.isTouch = false;
    _this.getContainer = function (ref) {
      _this.container = ref;
    };
    _this.handle = function (e) {
      if (e.type === 'touchend') _this.isTouch = true;
      if (e.type === 'click' && _this.isTouch) return;
      var handleClickOutside = _this.props.handleClickOutside;
      var el = _this.container;
      if (el && !el.contains(e.target)) {
        return handleClickOutside && handleClickOutside(e);
      }
    };
    return _this;
  }
  _inheritsLoose(KliOutsideClick, _Component);
  var _proto = KliOutsideClick.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React__default.createElement(Wrap$1, {
      ref: this.getContainer
    }, this.props.children);
  };
  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('touchend', this.handle, true);
    document.addEventListener('click', this.handle, true);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('touchend', this.handle, true);
    document.removeEventListener('click', this.handle, true);
  };
  return KliOutsideClick;
}(Component);

var storageCheckValue = "1";
var storageCheckKey = "_klpixel_storage_check";
var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {}
  LocalStorage.get = function get(key) {
    try {
      return localStorage.getItem(key) || undefined;
    } catch (e) {
      return undefined;
    }
  };
  LocalStorage.set = function set(key, value) {
    try {
      localStorage.setItem(key, value);
      return LocalStorage.get(key) === value;
    } catch (e) {
      return false;
    }
  };
  LocalStorage.remove = function remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      return false;
    }
  };
  LocalStorage.isSupport = function isSupport() {
    LocalStorage.set(storageCheckKey, storageCheckValue);
    return LocalStorage.get(storageCheckKey) === storageCheckValue;
  };
  return LocalStorage;
}();

var getCartTokenHeaders = function getCartTokenHeaders() {
  var cartToken = LocalStorage.get('x-klickly-cart-token');
  var headers = {};
  if (cartToken) {
    headers['x-klickly-cart-token'] = cartToken;
  }
  return headers;
};

var cartTokenHttpClient = axios.create({
  withCredentials: true
});
cartTokenHttpClient.interceptors.request.use(function (config) {
  var cartTokenHeaders = getCartTokenHeaders();
  config.headers = _extends({}, config.headers, cartTokenHeaders);
  return config;
});
cartTokenHttpClient.interceptors.response.use(function (response) {
  return response.data;
});

var device = {
  Android: function Android() {
    return !!navigator.userAgent.match(/Android/i);
  },
  iOSMobile: function iOSMobile() {
    return !!navigator.userAgent.match(/iPhone|iPod/i);
  },
  iOS: function iOS() {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  isMobile: function isMobile() {
    return device.Android() || device.iOSMobile();
  },
  isSafari: function isSafari() {
    return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1;
  },
  isChrome: function isChrome() {
    return !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  }
};

var dynamicFontSize = function dynamicFontSize(bannerRef, setFontSize, fontSize, bannerText, mobile, setBannerSizePending) {
  if (!bannerText) {
    setBannerSizePending(false);
    return;
  }
  var height = bannerRef.current.offsetHeight;
  var bannerWidthWithIndent = bannerRef.current.offsetWidth - 48;
  var width = mobile ? bannerWidthWithIndent : bannerWidthWithIndent / 2;
  var createBannerText = document.createElement('h1');
  createBannerText.style.fontSize = fontSize + 'px';
  createBannerText.style.visibility = 'hidden';
  createBannerText.style.opacity = '0';
  createBannerText.style.position = 'absolute';
  createBannerText.style.display = 'block';
  createBannerText.style.lineHeight = '112%';
  createBannerText.style.fontFamily = 'IBM Plex serif';
  createBannerText.style.wordBreak = 'break-word';
  createBannerText.style.width = width + 'px';
  createBannerText.innerHTML = bannerText;
  document.querySelector('#root').appendChild(createBannerText);
  if (createBannerText.offsetHeight > height) {
    setFontSize(function (prevFontSize) {
      return prevFontSize - 2;
    });
  }
  if (height > createBannerText.offsetHeight) {
    setTimeout(function () {
      setBannerSizePending(false);
    }, 100);
  }
  document.querySelector('#root').removeChild(createBannerText);
};

var formatPoints = function formatPoints(points, params) {
  if (params === void 0) {
    params = {
      thousand: false,
      million: false,
      billion: false
    };
  }
  var _params = params,
    thousand = _params.thousand,
    billion = _params.billion,
    million = _params.million;
  var formatter = new Intl.NumberFormat('en-US');
  var thousands = points / 1000;
  var millions = points / 1000000;
  var billions = points / 1000000000;
  if (isNaN(Number(points))) return null;
  if (Array.isArray(points)) return null;
  if (thousand && millions < 1) {
    return thousands >= 1 ? formatter.format(Math.floor(thousands)) + "k" : formatter.format(points);
  }
  if (million && billions < 1) {
    return millions >= 1 ? formatter.format(Math.floor(millions)) + "M" : formatter.format(points);
  }
  if (billion) {
    return billions >= 1 ? formatter.format(Math.floor(billions)) + "B" : formatter.format(points);
  }
  return formatter.format(points);
};

var COVERED_KEYS = ['shipping', 'taxes'];
var getCoveredAmounts = function getCoveredAmounts(discountsAllocation) {
  return (discountsAllocation || []).reduce(function (acc, discount) {
    if (COVERED_KEYS.includes(discount === null || discount === void 0 ? void 0 : discount.appliedTo)) {
      acc[discount.appliedTo] += discount.amount || 0;
    }
    return acc;
  }, {
    shipping: 0,
    taxes: 0
  });
};

var GRID_POINTS = Object.freeze({
  xs: 480,
  sm: 668,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
});
var GRID_CONTAINER_WIDTHS = Object.freeze({
  xs: 648,
  sm: 748,
  md: 856,
  lg: 992,
  xl: 1400,
  xxl: 1600
});
var GRID_DEVICES_MIN = Object.freeze({
  xs: "min-width: " + (GRID_POINTS.xs + 1) + "px",
  sm: "min-width: " + (GRID_POINTS.sm + 1) + "px",
  md: "min-width: " + (GRID_POINTS.md + 1) + "px",
  lg: "min-width: " + (GRID_POINTS.lg + 1) + "px",
  xl: "min-width: " + (GRID_POINTS.xl + 1) + "px",
  xxl: "min-width: " + (GRID_POINTS.xxl + 1) + "px"
});
var GRID_DEVICES_MAX = Object.freeze({
  xs: "max-width: " + GRID_POINTS.xs + "px",
  sm: "max-width: " + GRID_POINTS.sm + "px",
  md: "max-width: " + GRID_POINTS.md + "px",
  lg: "max-width: " + GRID_POINTS.lg + "px",
  xl: "max-width: " + GRID_POINTS.xl + "px",
  xxl: "max-width: " + GRID_POINTS.xxl + "px"
});
var GRID_CUSTOM_POINTS = Object.freeze({
  small: 648,
  medium: 768,
  large: 980,
  biggest: 1280
});
var GRID_DEVICES_CUSTOM_MIN = Object.freeze({
  small: "min-width: " + (GRID_CUSTOM_POINTS.small + 1) + "px",
  medium: "min-width: " + (GRID_CUSTOM_POINTS.medium + 1) + "px",
  large: "min-width: " + (GRID_CUSTOM_POINTS.large + 1) + "px",
  biggest: "min-width: " + (GRID_CUSTOM_POINTS.biggest + 1) + "px"
});
var GRID_DEVICES_CUSTOM_MAX = Object.freeze({
  small: "max-width: " + GRID_CUSTOM_POINTS.small + "px",
  medium: "max-width: " + GRID_CUSTOM_POINTS.medium + "px",
  large: "max-width: " + GRID_CUSTOM_POINTS.large + "px",
  biggest: "max-width: " + GRID_CUSTOM_POINTS.biggest + "px"
});

var INDENTS = {
  XXXS: '4px',
  XXS: '8px',
  XS: '12px',
  S: '16px',
  SM: '20px',
  M: '24px',
  L: '32px',
  XL: '40px',
  XXL: '64px'
};
var TOP_INDENTS = {
  XXXS: {
    marginTop: INDENTS.XXXS
  },
  XXS: {
    marginTop: INDENTS.XXS
  },
  XS: {
    marginTop: INDENTS.XS
  },
  S: {
    marginTop: INDENTS.S
  },
  SM: {
    marginTop: INDENTS.SM
  },
  M: {
    marginTop: INDENTS.M
  },
  L: {
    marginTop: INDENTS.L
  },
  XL: {
    marginTop: INDENTS.XL
  },
  XXL: {
    marginTop: INDENTS.XXL
  }
};
var RIGHT_INDENTS = {
  XXXS: {
    marginRight: INDENTS.XXXS
  },
  XXS: {
    marginRight: INDENTS.XXS
  },
  XS: {
    marginRight: INDENTS.XS
  },
  S: {
    marginRight: INDENTS.S
  },
  SM: {
    marginRight: INDENTS.SM
  },
  M: {
    marginRight: INDENTS.M
  },
  L: {
    marginRight: INDENTS.L
  },
  XL: {
    marginRight: INDENTS.XL
  },
  XXL: {
    marginRight: INDENTS.XXL
  }
};
var BOTTOM_INDENTS = {
  XXXS: {
    marginBottom: INDENTS.XXXS
  },
  XXS: {
    marginBottom: INDENTS.XXS
  },
  XS: {
    marginBottom: INDENTS.XS
  },
  S: {
    marginBottom: INDENTS.S
  },
  SM: {
    marginBottom: INDENTS.SM
  },
  M: {
    marginBottom: INDENTS.M
  },
  L: {
    marginBottom: INDENTS.L
  },
  XL: {
    marginBottom: INDENTS.XL
  },
  XXL: {
    marginBottom: INDENTS.XXL
  }
};
var LEFT_INDENTS = {
  XXXS: {
    marginLeft: INDENTS.XXXS
  },
  XXS: {
    marginLeft: INDENTS.XXS
  },
  XS: {
    marginLeft: INDENTS.XS
  },
  S: {
    marginLeft: INDENTS.S
  },
  SM: {
    marginLeft: INDENTS.SM
  },
  M: {
    marginLeft: INDENTS.M
  },
  L: {
    marginLeft: INDENTS.L
  },
  XL: {
    marginLeft: INDENTS.XL
  },
  XXL: {
    marginLeft: INDENTS.XXL
  }
};

var DEFAULT_SORT_KEY = 'relevance';
var PROMOTIONS_SORTS_STATE = [{
  key: DEFAULT_SORT_KEY,
  type: 'Relevance',
  checked: true,
  "default": true
}, {
  key: 'price_asc',
  name: 'Low to High',
  type: 'Price',
  checked: false
}, {
  key: 'price_desc',
  name: 'High to Low',
  type: 'Price',
  checked: false
}, {
  key: 'gmv',
  type: 'Best sellers',
  checked: false
}, {
  key: 'engagementScore',
  type: 'Most popular',
  checked: false
}];
var PROMOTIONS_PRICE_STATE = {
  gte: 0,
  lte: 10000
};
var MARKETPLACE = {
  DEFAULT_SORT_KEY: DEFAULT_SORT_KEY,
  PROMOTIONS_SORTS_STATE: PROMOTIONS_SORTS_STATE,
  PROMOTIONS_PRICE_STATE: PROMOTIONS_PRICE_STATE
};

var STORE_PATTERNS = Object.freeze({
  shopify: '_325x$1'
});

var getPriceRange = function getPriceRange(payload) {
  if (!payload) return MARKETPLACE.PROMOTIONS_PRICE_STATE;
  var _MARKETPLACE$PROMOTIO = MARKETPLACE.PROMOTIONS_PRICE_STATE,
    lte = _MARKETPLACE$PROMOTIO.lte,
    gte = _MARKETPLACE$PROMOTIO.gte;
  return {
    lte: payload.lte && !Number.isNaN(Number(payload.lte)) ? Number(payload.lte) : lte,
    gte: payload.gte && !Number.isNaN(Number(payload.gte)) ? Number(payload.gte) : gte
  };
};

var getFilterParamsFromUrl = function getFilterParamsFromUrl(params) {
  var searchParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true
  });
  var optionalParams = {};
  if (searchParams.suggest) optionalParams.suggest = searchParams.suggest;
  return _extends({
    search: searchParams.q || '',
    price: getPriceRange(searchParams.price),
    selectedBrands: searchParams.brands || [],
    strategy: searchParams.strategy || '',
    strategyId: searchParams.strategyId || '',
    gt: searchParams.gt || '',
    sort: searchParams.sort ? MARKETPLACE.PROMOTIONS_SORTS_STATE.map(function (sortItem) {
      return _extends({}, sortItem, {
        checked: sortItem.key === searchParams.sort
      });
    }) : [].concat(MARKETPLACE.PROMOTIONS_SORTS_STATE)
  }, optionalParams);
};

var getPriceQueryParams = function getPriceQueryParams(_ref) {
  var gte = _ref.gte,
    lte = _ref.lte;
  if (!gte && lte === MARKETPLACE.PROMOTIONS_PRICE_STATE.lte) return null;
  if (!gte) return {
    lte: lte
  };
  return {
    gte: gte,
    lte: lte
  };
};

var getUrlParamsFromFilter = function getUrlParamsFromFilter(_ref, params) {
  var categories = _ref.categories,
    brands = _ref.brands,
    price = _ref.price,
    sort = _ref.sort,
    search = _ref.search,
    strategy = _ref.strategy,
    strategyId = _ref.strategyId,
    gt = _ref.gt;
  if (params === void 0) {
    params = {};
  }
  var urlParams = getFilterParamsFromUrl();
  var optionalParams = {};
  var priceRange = getPriceQueryParams(price);
  var sorting = sort.find(function (sortOption) {
    return sortOption.checked;
  }).key;
  if (priceRange) optionalParams.price = priceRange;
  if (search) optionalParams.q = search;
  if (sorting !== MARKETPLACE.DEFAULT_SORT_KEY) optionalParams.sort = sorting;
  if (strategy) optionalParams.strategyName = strategy;
  if (strategyId) optionalParams.strategyId = strategyId;
  if (gt) optionalParams.gt = gt;
  return _extends({
    categories: categories.filter(function (_ref2) {
      var checked = _ref2.checked;
      return checked;
    }).map(function (_ref3) {
      var key = _ref3.key;
      return key;
    }),
    brands: brands !== null && brands !== void 0 && brands.length ? brands.filter(function (_ref4) {
      var checked = _ref4.checked;
      return checked;
    }).map(function (_ref5) {
      var key = _ref5.key;
      return key;
    }) : urlParams.selectedBrands
  }, optionalParams, params);
};

function msToTime(duration) {
  var days = Math.floor(duration / (1000 * 60 * 60 * 24));
  var hours = Math.floor(duration % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  var minutes = Math.floor(duration % (1000 * 60 * 60) / (1000 * 60));
  var seconds = Math.floor(duration % (1000 * 60) / 1000);
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;
  if (days > 0) {
    return days + "D:" + hours + "H:" + minutes + "M";
  }
  return hours + "H:" + minutes + "M:" + seconds + "S";
}

notification$1.config({
  placement: 'bottomRight',
  closeIcon: /*#__PURE__*/React__default.createElement(KliIcon, null, /*#__PURE__*/React__default.createElement(SvgCloseX, null))
});
var notification = notification$1;

var createRootElement = function createRootElement(id) {
  if (id === void 0) {
    id = 'root-portal';
  }
  var rootContainer = document.createElement('div');
  rootContainer.setAttribute('id', id);
  return rootContainer;
};
var addRootElement = function addRootElement(rootElem, rootElementId) {
  var rootParent = document.getElementById(rootElementId);
  rootParent.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
};
var usePortal = function usePortal(id, rootElementId) {
  if (rootElementId === void 0) {
    rootElementId = 'root';
  }
  var rootElemRef = useRef(null);
  useEffect(function setupElement() {
    var existingParent = document.querySelector("#" + id);
    var parentElem = existingParent || createRootElement(id);
    if (!existingParent) {
      addRootElement(parentElem, rootElementId);
    }
    parentElem.appendChild(rootElemRef.current);
    return function removeElement() {
      rootElemRef.current.remove();
      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, [id]);
  function getRootElem() {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
    }
    return rootElemRef.current;
  }
  return getRootElem();
};
var Portal = function Portal(_ref) {
  var id = _ref.id,
    children = _ref.children,
    _ref$rootElementId = _ref.rootElementId,
    rootElementId = _ref$rootElementId === void 0 ? 'root' : _ref$rootElementId;
  var target = usePortal(id, rootElementId);
  return /*#__PURE__*/ReactDOM.createPortal(children, target);
};

var _path$4L, _path2$1V, _path3$A, _path4$b, _path5$5;
function _extends$58() {
  return _extends$58 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$58.apply(null, arguments);
}
function SvgImagePlaceholder(props) {
  return /*#__PURE__*/createElement("svg", _extends$58({
    width: 149,
    height: 149,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4L || (_path$4L = /*#__PURE__*/createElement("path", {
    fill: "#F4F4F4",
    d: "M0 0h149v149H0z"
  })), _path2$1V || (_path2$1V = /*#__PURE__*/createElement("path", {
    d: "M64 68a2 2 0 012-2h18a2 2 0 012 2v14a2 2 0 01-2 2H66a2 2 0 01-2-2V68z",
    stroke: "#A4ADB4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3$A || (_path3$A = /*#__PURE__*/createElement("path", {
    d: "M68.5 84l10.722-11.616a2 2 0 012.736-.191L86 75.5",
    stroke: "#A4ADB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4$b || (_path4$b = /*#__PURE__*/createElement("path", {
    d: "M64 73l7.75 7.75",
    stroke: "#A4ADB4",
    strokeWidth: 2
  })), _path5$5 || (_path5$5 = /*#__PURE__*/createElement("path", {
    d: "M75.5 76c0-1-1.79-3-4-3s-4 2-4 3",
    stroke: "#A4ADB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var prepareImageUrl = function prepareImageUrl(_src, pattern, image) {
  if (!_src) return image || SvgImagePlaceholder;
  var src = typeof _src === 'object' ? _src.src : _src;
  return src.replace(/(\.jpg(?=[^.jpg]*$)|\.png(?=[^.png]*$)|\.gif(?=[^.gif]*$)|\.jpeg(?=[^.jpeg]*$))*$/, pattern);
};

var getWidth = function getWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};
var getHeight = function getHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};
function useWindowResize(resizeHandler) {
  var _useState = useState({
      width: getWidth(),
      height: getHeight()
    }),
    size = _useState[0],
    setSize = _useState[1];
  useEffect(function () {
    var timeoutId = null;
    var resizeListener = function resizeListener() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        return setSize({
          width: getWidth(),
          height: getHeight()
        });
      }, 150);
      if (typeof resizeHandler !== 'undefined') {
        resizeHandler();
      }
    };
    window.addEventListener('resize', resizeListener);
    return function () {
      window.removeEventListener('resize', resizeListener);
    };
  }, resizeHandler ? [resizeHandler] : []);
  return size;
}

var roundToLocaleString$1 = function roundToLocaleString(value, maxDigits) {
  if (maxDigits === void 0) {
    maxDigits = 2;
  }
  var toLocaleStringOptions = {
    minimumFractionDigits: maxDigits,
    maximumFractionDigits: maxDigits
  };
  return Number(value).toLocaleString('en-US', toLocaleStringOptions).replace(/,$/, '.');
};

var Cookie = /*#__PURE__*/function () {
  function Cookie() {}
  Cookie.get = function get(name) {
    var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };
  Cookie.set = function set(name, value, options) {
    if (options === void 0) {
      options = {};
    }
    options = _extends({
      path: '/',
      secure: true,
      sameSite: 'none'
    }, options);
    if (!options.expires) {
      var date = new Date();
      date.setDate(date.getDate() + 365);
      options.expires = date.toUTCString();
    } else if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }
    var updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    for (var k in options) {
      updatedCookie += '; ' + k;
      var _value = options[k];
      if (_value !== true) {
        updatedCookie += '=' + _value;
      }
    }
    document.cookie = updatedCookie;
  };
  Cookie.remove = function remove(name) {
    Cookie.set(name, '', {
      expires: new Date(0)
    });
  };
  return Cookie;
}();

var SessionStorage = /*#__PURE__*/function () {
  function SessionStorage() {}
  SessionStorage.get = function get(key) {
    try {
      return sessionStorage.getItem(key) || undefined;
    } catch (e) {
      return undefined;
    }
  };
  SessionStorage.set = function set(key, value) {
    try {
      sessionStorage.setItem(key, value);
      return SessionStorage.get(key) === value;
    } catch (e) {
      return false;
    }
  };
  SessionStorage.remove = function remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      return false;
    }
  };
  return SessionStorage;
}();

var storages = [Cookie, LocalStorage, SessionStorage];
var BrowserStorage = /*#__PURE__*/function () {
  function BrowserStorage() {}
  BrowserStorage.get = function get(key) {
    var value;
    for (var i = 0; i < storages.length; i++) {
      value = storages[i].get(key);
      if (value) {
        break;
      }
    }
    return value;
  };
  BrowserStorage.set = function set(key, value) {
    for (var i = 0; i < storages.length; i++) {
      storages[i].set(key, value);
    }
  };
  BrowserStorage.remove = function remove(key) {
    for (var i = 0; i < storages.length; i++) {
      storages[i].remove(key);
    }
  };
  return BrowserStorage;
}();
BrowserStorage.Cookie = Cookie;
BrowserStorage.LocalStorage = LocalStorage;
BrowserStorage.SessionStorage = SessionStorage;

function useForceUpdate() {
  var _useState = useState(0),
    setValue = _useState[1];
  return useCallback(function () {
    return setValue(function (value) {
      return value + 1;
    });
  }, []);
}

var useSimpleInterface = function useSimpleInterface(SIMPLE_GRID_POINT) {
  if (SIMPLE_GRID_POINT === void 0) {
    SIMPLE_GRID_POINT = 668;
  }
  var size = useWindowResize();
  var mobile = device.isMobile();
  var _useState = useState(mobile),
    simple = _useState[0],
    setSimple = _useState[1];
  useEffect(function () {
    if (!mobile) {
      setSimple(size.width <= SIMPLE_GRID_POINT);
    }
  }, [SIMPLE_GRID_POINT, mobile, size, setSimple]);
  return simple;
};

var PortalPositions = Object.freeze({
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
});

var _templateObject$n, _templateObject2$g, _templateObject3$b, _templateObject4$a, _templateObject5$8, _templateObject6$7;
var PortalTriggerWrap = styled.span(_templateObject$n || (_templateObject$n = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    vertical-align: inherit;\n"])));
var PortalContentPosition = styled.span(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    z-index: 9999;\n    max-width: 325px;\n    padding: 20px;\n    left: ", ";\n    top: ", ";\n    transform: ", ";\n    animation: ", ";\n"])), function (_ref) {
  var coords = _ref.coords,
    position = _ref.position,
    offsetLeft = _ref.offsetLeft;
  if (position === PortalPositions.TOP) {
    return coords.left + offsetLeft + 'px';
  }
  if (position === PortalPositions.RIGHT) {
    return coords.left + offsetLeft + coords.width + 'px';
  }
  if (position === PortalPositions.BOTTOM) {
    return coords.left + offsetLeft + 'px';
  }
  if (position === PortalPositions.LEFT) {
    return coords.left + offsetLeft - coords.width / 2 + 'px';
  }
}, function (_ref2) {
  var coords = _ref2.coords,
    position = _ref2.position,
    offsetTop = _ref2.offsetTop;
  if (position === PortalPositions.TOP) {
    return coords.top + offsetTop - 5 + 'px';
  }
  if (position === PortalPositions.RIGHT) {
    return coords.top + offsetTop - 5 + 'px';
  }
  if (position === PortalPositions.BOTTOM) {
    return coords.top + offsetTop + 5 + 'px';
  }
  if (position === PortalPositions.LEFT) {
    return coords.top + offsetTop - 5 + 'px';
  }
}, function (_ref3) {
  var position = _ref3.position;
  if (position === PortalPositions.TOP) {
    return 'translate3d(-50%, -100%, 0)';
  }
  if (position === PortalPositions.RIGHT) {
    return 'translate3d(0, -50%, 0)';
  }
  if (position === PortalPositions.BOTTOM) {
    return 'translate3d(-50%, 0, 0)';
  }
  if (position === PortalPositions.LEFT) {
    return 'translate3d(-100%, -50%, 0)';
  }
}, function (_ref4) {
  var position = _ref4.position;
  if (position === PortalPositions.TOP) {
    return css(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteralLoose(["\n                ", " 0.2s ease-in-out\n            "])), PortalTopAnimation);
  }
  if (position === PortalPositions.RIGHT) {
    return css(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteralLoose(["\n                ", " 0.2s ease-in-out\n            "])), PortalRightAnimation);
  }
  if (position === PortalPositions.BOTTOM) {
    return css(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteralLoose(["\n                ", " 0.2s ease-in-out\n            "])), PortalBottomAnimation);
  }
  if (position === PortalPositions.LEFT) {
    return css(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteralLoose(["\n                ", " 0.2s ease-in-out\n            "])), PortalLeftAnimation);
  }
});

var _excluded$h = ["isOpen", "triggerOnHover", "content", "children", "offsetLeft", "offsetTop", "position", "handleOutsideClick", "rootElementId"];
var KliPortalContent = function KliPortalContent(_ref) {
  var isOpen = _ref.isOpen,
    _ref$triggerOnHover = _ref.triggerOnHover,
    triggerOnHover = _ref$triggerOnHover === void 0 ? true : _ref$triggerOnHover,
    content = _ref.content,
    children = _ref.children,
    _ref$offsetLeft = _ref.offsetLeft,
    offsetLeft = _ref$offsetLeft === void 0 ? 0 : _ref$offsetLeft,
    _ref$offsetTop = _ref.offsetTop,
    offsetTop = _ref$offsetTop === void 0 ? 0 : _ref$offsetTop,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? PortalPositions.TOP : _ref$position,
    _ref$handleOutsideCli = _ref.handleOutsideClick,
    handleOutsideClick = _ref$handleOutsideCli === void 0 ? false : _ref$handleOutsideCli,
    _ref$rootElementId = _ref.rootElementId,
    rootElementId = _ref$rootElementId === void 0 ? 'root' : _ref$rootElementId,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  var _useState = useState(false),
    opened = _useState[0],
    setOpened = _useState[1];
  var _useState2 = useState(),
    coords = _useState2[0],
    setCoords = _useState2[1];
  var contentRef = useRef();
  var calculatePosition = function calculatePosition() {
    if (!contentRef.current) {
      return null;
    }
    var _contentRef$current$g = contentRef.current.getBoundingClientRect(),
      top = _contentRef$current$g.top,
      right = _contentRef$current$g.right,
      bottom = _contentRef$current$g.bottom,
      left = _contentRef$current$g.left,
      width = _contentRef$current$g.width,
      height = _contentRef$current$g.height;
    return {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      width: width,
      height: height
    };
  };
  var open = useCallback(function () {
    setOpened(true);
  }, [setOpened]);
  var close = useCallback(function () {
    setOpened(false);
  }, [setOpened]);
  useEffect(function () {
    var timer = setTimeout(function () {
      setCoords(calculatePosition());
      if (isOpen) {
        open();
      }
      clearTimeout(timer);
    });
    return function () {
      return clearTimeout(timer);
    };
  }, [isOpen, setCoords, open, calculatePosition]);
  return /*#__PURE__*/React__default.createElement(KliOutsideClick, {
    handleClickOutside: handleOutsideClick ? close : null
  }, /*#__PURE__*/React__default.createElement(PortalTriggerWrap, {
    onMouseEnter: triggerOnHover && !opened ? open : null,
    onMouseLeave: triggerOnHover && opened ? close : null,
    onClick: opened ? close : open,
    ref: contentRef
  }, children, opened && /*#__PURE__*/React__default.createElement(Portal, {
    id: "___kli-portal",
    rootElementId: rootElementId
  }, /*#__PURE__*/React__default.createElement(PortalContentPosition, _extends({
    coords: coords,
    offsetLeft: offsetLeft,
    offsetTop: offsetTop,
    position: position
  }, rest), content))));
};

var _templateObject$o;
var KliStepperOrient = Object.freeze({
  Horizontal: 'row',
  Vertical: 'column-reverse'
});
var StepperWrapper = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: ", ";\n    justify-content: space-between;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n"])), function (_ref) {
  var orient = _ref.orient;
  return orient;
}, function (orient) {
  return orient === KliStepperOrient.Vertical ? 'auto' : '120px';
}, function (_ref2) {
  var orient = _ref2.orient;
  return orient === KliStepperOrient.Vertical ? '120px' : 'auto';
});

var KliStepper = function KliStepper(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    _ref$orient = _ref.orient,
    orient = _ref$orient === void 0 ? KliStepperOrient.Horizontal : _ref$orient,
    onChange = _ref.onChange;
  if (typeof value !== 'number') {
    throw new Error('Value should be a number');
  }
  var _useState = useState(value),
    step = _useState[0],
    setStep = _useState[1];
  var onStepChange = useCallback(function (value) {
    var newValue = step + value;
    setStep(newValue);
    if (typeof onChange !== 'undefined') {
      onChange(newValue);
    }
  }, [step, setStep, onChange]);
  return /*#__PURE__*/React__default.createElement(StepperWrapper, {
    orient: orient
  }, /*#__PURE__*/React__default.createElement(KliCircleButton, {
    secondary: true,
    onClick: function onClick() {
      return onStepChange(-1);
    }
  }, /*#__PURE__*/React__default.createElement(SvgActionsMinus, null)), /*#__PURE__*/React__default.createElement("span", null, step), /*#__PURE__*/React__default.createElement(KliCircleButton, {
    secondaty: true,
    onClick: function onClick() {
      return onStepChange(1);
    }
  }, /*#__PURE__*/React__default.createElement(SvgActionsPlus, null)));
};

var _templateObject$p, _templateObject2$h;
var KliTimerMessageWrap = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px 25px;\n    color: ", ";\n    background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.canvas;
}, function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color;
  return theme.colors[color];
});
var TimerMessageWrap = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: ", ";\n    justify-content: ", ";\n    flex-direction: ", ";\n    color: inherit;\n    background: inherit;\n    width: 100%;\n"])), function (_ref3) {
  var simple = _ref3.simple;
  return simple ? 'flex-start' : 'space-between';
}, function (_ref4) {
  var simple = _ref4.simple;
  return simple ? 'space-between' : 'flex-start';
}, function (_ref5) {
  var simple = _ref5.simple,
    reverseOnSimple = _ref5.reverseOnSimple;
  return simple ? 'row' : reverseOnSimple ? 'column-reverse' : 'column';
});

var _excluded$i = ["date", "available", "simple", "leftMessage", "availableMessage", "notAvailableMessage", "selectDateMessage", "onTimeSelect", "onGiftClick"];
var LeftTimer = function LeftTimer(_ref) {
  var message = _ref.message,
    simple = _ref.simple,
    icon = _ref.icon,
    time = _ref.time;
  return /*#__PURE__*/React__default.createElement(TimerMessageWrap, {
    simple: simple
  }, /*#__PURE__*/React__default.createElement(Typography.Text, null, message), "\xA0", /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: simple ? 'body2' : 'badgeLarge',
    as: "span",
    color: "canvas"
  }, icon), "\xA0", /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: simple ? 'body2' : 'badgeLarge',
    as: "span",
    color: "canvas"
  }, msToTime(time))));
};
var TimeSelector = function TimeSelector(_ref2) {
  var message = _ref2.message,
    simple = _ref2.simple,
    icon = _ref2.icon;
  return /*#__PURE__*/React__default.createElement(TimerMessageWrap, {
    simple: simple,
    reverseOnSimple: true
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "span"
  }, message), "\xA0", /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: simple ? 'body2' : 'badgeLarge',
    as: "span"
  }, icon));
};
var KliTimerMessage = function KliTimerMessage(_ref3) {
  var date = _ref3.date,
    _ref3$available = _ref3.available,
    available = _ref3$available === void 0 ? true : _ref3$available,
    _ref3$simple = _ref3.simple,
    simple = _ref3$simple === void 0 ? true : _ref3$simple,
    _ref3$leftMessage = _ref3.leftMessage,
    leftMessage = _ref3$leftMessage === void 0 ? 'Gifting Suite open for' : _ref3$leftMessage,
    _ref3$notAvailableMes = _ref3.notAvailableMessage,
    notAvailableMessage = _ref3$notAvailableMes === void 0 ? 'Next Gifting Suite opens in' : _ref3$notAvailableMes,
    _ref3$onTimeSelect = _ref3.onTimeSelect,
    onTimeSelect = _ref3$onTimeSelect === void 0 ? function () {} : _ref3$onTimeSelect,
    _ref3$onGiftClick = _ref3.onGiftClick,
    onGiftClick = _ref3$onGiftClick === void 0 ? function () {} : _ref3$onGiftClick,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded$i);
  var timer;
  var getTimeLeft = function getTimeLeft(date) {
    return new Date(date) - Date.now();
  };
  var clear = function clear(timer) {
    if (timer) {
      clearInterval(timer);
    }
  };
  var getColor = function getColor(date, timeLeft, available) {
    if (typeof date === 'undefined') {
      return 'secondaryText';
    }
    if (timeLeft <= 0) {
      return 'primary';
    }
    return available ? 'primaryText' : 'secondaryText';
  };
  var themeContext = useContext(KliThemeContext);
  var _useState = useState(getTimeLeft(date)),
    timeLeft = _useState[0],
    setTimeLeft = _useState[1];
  var _useState2 = useState(getColor(date, timeLeft, available)),
    color = _useState2[0],
    setColor = _useState2[1];
  useEffect(function () {
    clear(timer);
    if (date && timeLeft > 0) {
      timer = setInterval(function () {
        setTimeLeft(getTimeLeft(date));
        setColor(getColor(date, timeLeft, available));
      }, 1000);
    }
    return function () {
      return clear(timer);
    };
  }, [date, timeLeft, setColor, setTimeLeft, available]);
  return /*#__PURE__*/React__default.createElement(KliTimerMessageWrap, _extends({
    theme: themeContext,
    color: color
  }, rest), function () {
    if (typeof date === 'undefined') {
      return /*#__PURE__*/React__default.createElement(TimeSelector, {
        message: "Select suitable date for the next Gifting Suite",
        simple: simple,
        icon: /*#__PURE__*/React__default.createElement(KliIcon, {
          onClick: onTimeSelect
        }, /*#__PURE__*/React__default.createElement(SvgCalandar, null))
      });
    }
    if (timeLeft > 0) {
      return /*#__PURE__*/React__default.createElement(LeftTimer, {
        message: available ? leftMessage : notAvailableMessage,
        simple: simple,
        time: timeLeft,
        icon: /*#__PURE__*/React__default.createElement(KliIcon, {
          onClick: onTimeSelect,
          style: {
            cursor: 'pointer'
          }
        }, /*#__PURE__*/React__default.createElement(SvgTime, null))
      });
    }
    if (timeLeft <= 0) {
      return /*#__PURE__*/React__default.createElement(TimeSelector, {
        message: "New Gifting Suite is ready to launch",
        simple: simple,
        icon: /*#__PURE__*/React__default.createElement(KliIcon, {
          onClick: onGiftClick,
          style: {
            cursor: 'pointer'
          }
        }, /*#__PURE__*/React__default.createElement(SvgGift, null))
      });
    }
  }());
};

var _templateObject$q, _templateObject2$i;
var StyledForm = createGlobalStyle(_templateObject$q || (_templateObject$q = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return css(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteralLoose(["\n        .ant-form-item-explain-error {\n            margin-top: -4px;\n            font: ", ";\n            color: ", ";\n        }\n\n        .ant-form-item-has-error {\n            *,\n            .label.label-float {\n                color: ", ";\n            }\n\n            .ant-select-dropdown * {\n                color: ", ";\n            }\n\n            &:has(.ant-select-status-error) {\n                .label {\n                    color: ", ";\n\n                    &.label-float {\n                        color: ", ";\n                    }\n                }\n\n                .ant-select-selection-item > span {\n                    color: ", ";\n                }\n            }\n\n            &:has(.ant-input:focus) .label.label-float {\n                color: ", ";\n            }\n\n            .ant-input-suffix {\n                .ant-input-clear-icon * {\n                    color: ", ";\n                }\n            }\n\n            .ant-form-item-control-input-content {\n                .ant-input-affix-wrapper {\n                    border-color: ", ";\n                }\n            }\n\n            .ant-form-item-feedback-icon.ant-form-item-feedback-icon-error {\n                display: none;\n            }\n\n            .ant-input-suffix > :not(:last-child) {\n                margin-right: 0;\n            }\n\n            .ant-form-item-control-input-content {\n                .ant-input-affix-wrapper.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n                    border-color: ", ";\n                }\n            }\n        }\n    "])), $theme.fonts.descriptor2, $theme.colors.error, $theme.colors.error, $theme.colors.secondaryText, $theme.colors.error, $theme.colors.secondaryText, $theme.colors.primaryText, $theme.colors.secondaryText, $theme.colors.error, $theme.colors.error, $theme.colors.error);
});

var _templateObject$r, _templateObject2$j, _templateObject3$c, _templateObject4$b, _templateObject5$9;
var StyledNotification = createGlobalStyle(_templateObject$r || (_templateObject$r = _taggedTemplateLiteralLoose(["\n    .ant-notification {\n        margin-right: 48px;\n\n        ", ";\n\n        .ant-notification-notice {\n            padding: 0 44px 0 0;\n            border: 1px solid ", ";\n            width: 414px;\n            border-radius: unset;\n            box-shadow: none;\n\n            ", ";\n        }\n    }\n\n    .ant-notification-notice-content {\n        padding: 24px 16px;\n        border-right: 1px solid ", ";\n\n        ", ";\n    }\n\n    .ant-notification-notice-close {\n        top: 50%;\n        right: 10px;\n        transform: translateY(-50%);\n\n        .kli-icon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 24px;\n            height: 24px;\n        }\n\n        ", ";\n    }\n\n    .ant-notification-notice-close-x {\n        width: 100%;\n    }\n\n    .ant-notification-notice-message {\n        margin-bottom: 0;\n    }\n"])), function (_ref) {
  var $simple = _ref.$simple;
  return $simple && css(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteralLoose(["\n                width: 100%;\n                margin: 0;\n\n                > div {\n                    width: 100%;\n                }\n            "])));
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.colors.disabledState;
}, function (_ref3) {
  var $simple = _ref3.$simple;
  return $simple && css(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteralLoose(["\n                    width: 100%;\n                    max-width: 100%;\n                    margin: 0;\n                    padding: 0 32px 0 0;\n                    border-left: none;\n                    border-right: none;\n                "])));
}, function (_ref4) {
  var $theme = _ref4.$theme;
  return $theme.colors.background;
}, function (_ref5) {
  var $simple = _ref5.$simple;
  return $simple && css(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteralLoose(["\n                padding: 16px 8px;\n            "])));
}, function (_ref6) {
  var $simple = _ref6.$simple;
  return $simple && css(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteralLoose(["\n                right: 4px;\n            "])));
});

var StyledUI = function StyledUI() {
  var simple = useSimpleInterface();
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledNotification, {
    $theme: themeContext,
    $simple: simple
  }), /*#__PURE__*/React__default.createElement(StyledForm, {
    $theme: themeContext
  }));
};

var _templateObject$s, _templateObject2$k, _templateObject3$d, _templateObject4$c;
var StyledAlert = styled(Alert$1)(_templateObject$s || (_templateObject$s = _taggedTemplateLiteralLoose(["\n    align-items: center;\n    color: ", ";\n    background-color: ", ";\n    border: 2px solid ", ";\n    border-radius: unset;\n    cursor: pointer;\n\n    ", ";\n\n    ", ";\n\n    .ant-alert-description {\n        font: ", ";\n    }\n\n    &.ant-alert-with-description {\n        padding: 15px 20px;\n    }\n\n    &.ant-alert-info .ant-alert-icon {\n        color: ", ";\n    }\n\n    svg {\n        width: 22px;\n        height: 22px;\n        vertical-align: middle;\n    }\n\n    .ant-alert-action {\n        margin-left: 6px;\n    }\n\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return $theme.colors.primaryText;
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.colors.canvas;
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.colors.primaryText;
}, function (_ref4) {
  var $centered = _ref4.$centered;
  return $centered && css(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteralLoose(["\n            justify-content: center;\n            .ant-alert-content {\n                flex: initial;\n            }\n        "])));
}, function (_ref5) {
  var $marginBottom = _ref5.$marginBottom;
  return $marginBottom && css(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteralLoose(["\n            margin-bottom: ", ";\n        "])), $marginBottom);
}, function (_ref6) {
  var $theme = _ref6.$theme;
  return $theme.fonts.badgeMedium;
}, function (_ref7) {
  var $theme = _ref7.$theme;
  return $theme.colors.primaryText;
}, function (_ref8) {
  var $isFixedOnMobile = _ref8.$isFixedOnMobile,
    $theme = _ref8.$theme;
  return $isFixedOnMobile && css(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteralLoose(["\n            @media (", ") {\n                position: fixed;\n                bottom: 0;\n                left: 0;\n                margin: 0;\n                z-index: 10;\n                border-top: 1px solid ", ";\n                border-bottom: 1px solid ", ";\n                border-left: 0;\n                border-right: 0;\n                width: 100%;\n            }\n\n            &:after {\n                content: '';\n                position: absolute;\n                top: 0;\n                right: 32px;\n                height: 100%;\n                background: ", ";\n                width: 1px;\n            }\n\n            svg {\n                @media (", ") {\n                    width: 16px;\n                    height: 16px;\n                }\n            }\n\n            .ant-alert-description {\n                @media (", ") {\n                    font: ", ";\n                    margin-right: 10px;\n                }\n            }\n\n            &.ant-alert-with-description {\n                @media (", ") {\n                    padding: 8px;\n                }\n            }\n        "])), GRID_DEVICES_MAX.sm, $theme.colors.disabledState, $theme.colors.disabledState, $theme.colors.background, GRID_DEVICES_MAX.sm, GRID_DEVICES_MAX.sm, function (_ref9) {
    var $theme = _ref9.$theme;
    return $theme.fonts.descriptor2;
  }, GRID_DEVICES_MAX.sm);
});

var _excluded$j = ["centered", "isFixedOnMobile", "afterIcon", "marginBottom"];
var Alert = function Alert(_ref) {
  var centered = _ref.centered,
    isFixedOnMobile = _ref.isFixedOnMobile,
    afterIcon = _ref.afterIcon,
    marginBottom = _ref.marginBottom,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$j);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAlert, _extends({
    $centered: centered,
    $isFixedOnMobile: isFixedOnMobile,
    $theme: theme,
    action: afterIcon && /*#__PURE__*/React__default.createElement(Space, {
      direction: "vertical",
      align: "center"
    }, afterIcon),
    $marginBottom: marginBottom
  }, props));
};

var _templateObject$t, _templateObject2$l;
var StyledButton = styled(Button)(_templateObject$t || (_templateObject$t = _taggedTemplateLiteralLoose(["\n    &.ant-btn-circle {\n        border-radius: 50%;\n\n        ", "\n\n        > svg {\n            width: 16px;\n            height: 16px;\n            margin: 0;\n\n            &:not(:only-child):last-child {\n                margin: 0;\n            }\n        }\n\n        &:last-child {\n            margin-left: ", ";\n        }\n\n        &.slick-disabled,\n        &.slick-disabled.ant-btn-background-ghost.ant-btn-primary:not(.ant-btn-dangerous):hover,\n        &.slick-disabled.ant-btn-primary:hover {\n            color: ", ";\n            border-color: ", ";\n            background: transparent;\n            cursor: not-allowed;\n        }\n\n        &[ant-click-animating-without-extra-node='true']::after {\n            display: none;\n        }\n    }\n"])), function (_ref) {
  var ghost = _ref.ghost,
    $theme = _ref.$theme;
  return ghost && css(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteralLoose(["\n                color: ", ";\n\n                &:hover,\n                &:focus {\n                    color: ", ";\n                }\n            "])), $theme.colors.primaryText, $theme.colors.primaryText);
}, function (_ref2) {
  var $withoutMargin = _ref2.$withoutMargin;
  return $withoutMargin ? 0 : '20px';
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.colors.disabledState;
}, function (_ref4) {
  var $theme = _ref4.$theme;
  return $theme.colors.disabledState;
});

var _excluded$k = ["carouselRef", "nativeControls", "type", "ghost", "currentSlide", "slideCount"];
var ControlButton = function ControlButton(_ref) {
  var carouselRef = _ref.carouselRef,
    nativeControls = _ref.nativeControls,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'prev' : _ref$type,
    ghost = _ref.ghost,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$k);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledButton, _extends({
    $theme: theme,
    $withoutMargin: nativeControls,
    type: ghost ? null : 'primary',
    ghost: ghost,
    shape: "circle",
    onClick: function onClick() {
      return !nativeControls && carouselRef.current && (type === 'prev' ? carouselRef.current.prev() : carouselRef.current.next());
    }
  }, props, {
    "data-e2e": type === 'prev' ? 'common_prev-arrow_btn' : 'common_forward-arrow_btn'
  }), type === 'prev' ? /*#__PURE__*/React__default.createElement(SvgArrowChevronBack, null) : /*#__PURE__*/React__default.createElement(SvgArrowChevronForward, null));
};

var _templateObject$u;
var StyledWrapper = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    justify-content: ", ";\n    align-items: center;\n"])), function (_ref) {
  var $bottomControls = _ref.$bottomControls;
  return ($bottomControls === null || $bottomControls === void 0 ? void 0 : $bottomControls.justify) || 'flex-start';
});

var BottomControls = function BottomControls(_ref) {
  var bottomControls = _ref.bottomControls,
    carouselRef = _ref.carouselRef,
    prevDisabled = _ref.prevDisabled,
    nextDisabled = _ref.nextDisabled;
  var theme = useContext(KliThemeContext);
  if (!bottomControls || bottomControls !== null && bottomControls !== void 0 && bottomControls.off) return null;
  return /*#__PURE__*/React__default.createElement(StyledWrapper, {
    $theme: theme,
    $bottomControls: bottomControls
  }, /*#__PURE__*/React__default.createElement(ControlButton, {
    carouselRef: carouselRef,
    disabled: prevDisabled
  }, /*#__PURE__*/React__default.createElement(SvgArrowChevronBack, null)), /*#__PURE__*/React__default.createElement(ControlButton, {
    carouselRef: carouselRef,
    disabled: nextDisabled,
    type: "next"
  }, /*#__PURE__*/React__default.createElement(SvgArrowChevronForward, null)));
};

var _templateObject$v;
var sharedCarouselStyles = css(_templateObject$v || (_templateObject$v = _taggedTemplateLiteralLoose(["\n    && {\n        .slick-prev,\n        .slick-prev:hover,\n        .slick-prev:focus {\n            left: -38px;\n            margin-top: 0;\n            font-size: inherit;\n            z-index: 2;\n        }\n\n        .slick-next,\n        .slick-next:hover,\n        .slick-next:focus {\n            right: -38px;\n            margin-top: 0;\n            font-size: inherit;\n            z-index: 2;\n        }\n    }\n\n    .slick-track {\n        display: flex;\n    }\n    .slick-track .slick-slide {\n        display: flex;\n        height: auto;\n        align-items: center;\n        justify-content: center;\n    }\n"])));

var _templateObject$w, _templateObject2$m, _templateObject3$e;
var StyledWrapper$1 = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteralLoose([""])));
var StyledCarousel = styled(Carousel$1)(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteralLoose(["\n    margin-bottom: 20px;\n\n    ", ";\n\n    .slick-dots {\n        margin: 0;\n    }\n\n    .slick-dots-bottom {\n        bottom: ", "; // 12px - default Antd value, could be changed if needed\n\n        ", ";\n    }\n"])), sharedCarouselStyles, function (_ref) {
  var dots = _ref.dots;
  return (dots === null || dots === void 0 ? void 0 : dots.bottom) || '12px';
}, function (_ref2) {
  var $bottomControls = _ref2.$bottomControls;
  return $bottomControls && ($bottomControls === null || $bottomControls === void 0 ? void 0 : $bottomControls.justify) === 'space-between' && css(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteralLoose(["\n                bottom: -35px;\n                left: 50px;\n                width: calc(100% - 100px);\n            "])));
});

var _excluded$l = ["children", "bottomControls", "sideControls", "infinite", "afterChange", "initialSlide", "carouselRef"];
var BaseCarousel = function BaseCarousel(_ref) {
  var children = _ref.children,
    bottomControls = _ref.bottomControls,
    infinite = _ref.infinite,
    _ref$afterChange = _ref.afterChange,
    _afterChange = _ref$afterChange === void 0 ? function () {
      return null;
    } : _ref$afterChange,
    initialSlide = _ref.initialSlide,
    _ref$carouselRef = _ref.carouselRef,
    outerRef = _ref$carouselRef === void 0 ? null : _ref$carouselRef,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$l);
  var _useState = useState(!infinite && !initialSlide),
    prevDisabled = _useState[0],
    setPrevDisabled = _useState[1];
  var _useState2 = useState(!infinite && initialSlide === (children === null || children === void 0 ? void 0 : children.length) - 1),
    nextDisabled = _useState2[0],
    setNextDisabled = _useState2[1];
  var ref = useRef(null);
  var carouselRef = outerRef || ref;
  return /*#__PURE__*/React__default.createElement(StyledWrapper$1, null, /*#__PURE__*/React__default.createElement(StyledCarousel, _extends({
    "data-e2e": "common_products_carousel",
    ref: carouselRef,
    infinite: infinite,
    afterChange: function afterChange(index) {
      if (!infinite) {
        setPrevDisabled(index === 0);
        setNextDisabled(index + 1 === (children === null || children === void 0 ? void 0 : children.length));
      }
      return _afterChange(index);
    },
    $bottomControls: bottomControls,
    prevArrow: /*#__PURE__*/React__default.createElement(ControlButton, {
      ghost: true,
      nativeControls: true
    }),
    nextArrow: /*#__PURE__*/React__default.createElement(ControlButton, {
      ghost: true,
      nativeControls: true,
      type: "next"
    }),
    initialSlide: initialSlide
  }, props), children), /*#__PURE__*/React__default.createElement(BottomControls, {
    bottomControls: bottomControls,
    carouselRef: carouselRef,
    prevDisabled: prevDisabled,
    nextDisabled: nextDisabled
  }));
};

var _templateObject$x, _templateObject2$n, _templateObject3$f;
var StyledWrapper$2 = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), sharedCarouselStyles);
var StyledPreview = styled(Carousel$1)(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteralLoose(["\n    && {\n        .slick-slide {\n            padding: 0 4px;\n            height: 60px;\n        }\n    }\n"])));
var StyledCarousel$1 = styled(Carousel$1)(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteralLoose(["\n    margin-bottom: 16px;\n\n    .slick-slide {\n        padding: 0 4px;\n    }\n"])));

var _excluded$m = ["children", "previews", "activeSlide", "carouselRef"];
var CarouselWithPreview = function CarouselWithPreview(_ref) {
  var children = _ref.children,
    previews = _ref.previews,
    _ref$carouselRef = _ref.carouselRef,
    carouselRef = _ref$carouselRef === void 0 ? null : _ref$carouselRef,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  var ref = useRef(null);
  var sliderRef = carouselRef || ref;
  var previewRef = useRef(null);
  return /*#__PURE__*/React__default.createElement(StyledWrapper$2, null, /*#__PURE__*/React__default.createElement(StyledCarousel$1, _extends({
    ref: sliderRef,
    asNavFor: previewRef === null || previewRef === void 0 ? void 0 : previewRef.current,
    infinite: false,
    dots: false,
    arrows: true,
    prevArrow: /*#__PURE__*/React__default.createElement(ControlButton, {
      ghost: true,
      nativeControls: true
    }),
    nextArrow: /*#__PURE__*/React__default.createElement(ControlButton, {
      ghost: true,
      nativeControls: true,
      type: "next"
    })
  }, props), children), (children === null || children === void 0 ? void 0 : children.length) > 1 && (previews === null || previews === void 0 ? void 0 : previews.length) > 1 && /*#__PURE__*/React__default.createElement(StyledPreview, {
    ref: previewRef,
    asNavFor: sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current,
    infinite: false,
    dots: false,
    arrows: true,
    prevArrow: /*#__PURE__*/React__default.createElement(ControlButton, {
      ghost: true,
      nativeControls: true
    }),
    nextArrow: /*#__PURE__*/React__default.createElement(ControlButton, {
      ghost: true,
      nativeControls: true,
      type: "next"
    }),
    slidesToShow: previews !== null && previews !== void 0 && previews.length && (previews === null || previews === void 0 ? void 0 : previews.length) > 5 ? 5 : previews === null || previews === void 0 ? void 0 : previews.length,
    swipeToSlide: true,
    focusOnSelect: true
  }, previews));
};

var Carousel = BaseCarousel;
Carousel.WithPreview = CarouselWithPreview;

var _templateObject$y, _templateObject2$o, _templateObject3$g;
var StyledAntdCheckbox = styled(Checkbox$1)(_templateObject$y || (_templateObject$y = _taggedTemplateLiteralLoose(["\n    && {\n        ", ";\n    }\n"])), function (_ref) {
  var $theme = _ref.$theme,
    $size = _ref.$size,
    $type = _ref.$type,
    $checkedColor = _ref.$checkedColor;
  return css(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteralLoose(["\n            &.ant-checkbox-wrapper {\n                display: flex;\n                align-items: center;\n\n                & .ant-checkbox-checked:after,\n                &:hover .ant-checkbox-inner {\n                    border-color: ", ";\n                }\n\n                & .ant-checkbox,\n                & .ant-checkbox-inner,\n                & .ant-checkbox-input {\n                    border-width: 2px;\n                }\n\n                &,\n                &:focus,\n                &:active {\n                    & .ant-checkbox,\n                    & .ant-checkbox-inner,\n                    & .ant-checkbox-input {\n                        border-color: ", ";\n                    }\n                }\n            }\n\n            & .ant-checkbox {\n                top: 0;\n\n                & + span:not(.kli-text) {\n                    color: ", ";\n                    font: ", ";\n                }\n            }\n\n            // size\n            & .ant-checkbox,\n            & .ant-checkbox-inner {\n                width: ", ";\n                height: ", ";\n            }\n\n            & .ant-checkbox-inner {\n                &:after {\n                    width: ", ";\n                    height: ", ";\n                    left: 29.5%;\n                }\n            }\n\n            & .ant-checkbox-checked .ant-checkbox-inner {\n                background-color: ", ";\n                border-color: ", ";\n            }\n\n            // type = 'rounded'\n            ", "\n        "])), $theme.colors[$checkedColor] ? $theme.colors[$checkedColor] : $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.fonts.body2, function () {
    return $size;
  }, function () {
    return $size;
  }, function () {
    return "calc(" + $size + " / 4.3)";
  }, function () {
    return "calc(" + $size + " / 2.3)";
  }, $theme.colors[$checkedColor] ? $theme.colors[$checkedColor] : $theme.colors.primaryText, $theme.colors[$checkedColor] ? $theme.colors[$checkedColor] : $theme.colors.primaryText, function () {
    return $type === 'rounded' ? css(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteralLoose(["\n                          & .ant-checkbox,\n                          & .ant-checkbox-inner,\n                          & .ant-checkbox-checked:after {\n                              border-radius: 50%;\n                          }\n                      "]))) : '';
  });
});

var _excluded$n = ["children", "size", "type", "checkedColor"];
var Checkbox = function Checkbox(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '28px' : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    checkedColor = _ref.checkedColor,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAntdCheckbox, _extends({
    $theme: themeContext,
    $size: size,
    $type: type,
    $checkedColor: checkedColor
  }, props), children);
};

var _templateObject$z, _templateObject2$p, _templateObject3$h, _templateObject4$d;
var StyledAntdCollapse = styled(Collapse$1)(_templateObject$z || (_templateObject$z = _taggedTemplateLiteralLoose(["\n    ", "\n"])), function (_ref) {
  var $iconSize = _ref.$iconSize;
  return css(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteralLoose(["\n        &.ant-collapse,\n        &.ant-collapse-borderless {\n            border-radius: 0;\n            background-color: transparent;\n        }\n\n        &.ant-collapse > .ant-collapse-item > .ant-collapse-header {\n            align-items: center;\n        }\n\n        &.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n            font-size: ", ";\n        }\n\n        &.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n            display: inline-flex;\n        }\n\n        ", "\n    "])), $iconSize, function (_ref2) {
    var $withoutPadding = _ref2.$withoutPadding;
    return $withoutPadding ? css(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteralLoose(["\n                      &.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header,\n                      &.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header,\n                      & .ant-collapse-content > .ant-collapse-content-box {\n                          padding: 0;\n                      }\n\n                      &.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n                          right: 0;\n                      }\n                  "]))) : '';
  });
});
var StyledAntdPanel = styled(Collapse$1.Panel)(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteralLoose([""])));

var _excluded$o = ["children", "iconSize", "withoutPadding"],
  _excluded2$1 = ["children"];
var Collapse = function Collapse(_ref) {
  var children = _ref.children,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? '14px' : _ref$iconSize,
    _ref$withoutPadding = _ref.withoutPadding,
    withoutPadding = _ref$withoutPadding === void 0 ? false : _ref$withoutPadding,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAntdCollapse, _extends({
    $theme: themeContext,
    $iconSize: iconSize,
    $withoutPadding: withoutPadding
  }, props), children);
};
var Panel = function Panel(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAntdPanel, _extends({
    $theme: themeContext
  }, props), children);
};

var _templateObject$A, _templateObject2$q;
var StyledDivider = styled(Divider$1)(_templateObject$A || (_templateObject$A = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme,
    $height = _ref.$height,
    $color = _ref.$color,
    _ref$$margin = _ref.$margin,
    $margin = _ref$$margin === void 0 ? '24px 0' : _ref$$margin;
  return css(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteralLoose(["\n        border-top-width: ", "px;\n        border-color: ", ";\n\n        &.ant-divider-horizontal {\n            margin: ", ";\n        }\n    "])), $height || 1, $color || $theme.colors.lines, typeof $margin === 'number' ? $margin + "px" : $margin);
});

var Divider = function Divider(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 1 : _ref$height,
    color = _ref.color,
    margin = _ref.margin;
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledDivider, {
    $theme: theme,
    $height: height,
    $color: color,
    $margin: margin
  });
};

var _templateObject$B, _templateObject2$r, _templateObject3$i, _templateObject4$e, _templateObject5$a, _templateObject6$8;
var iconStyles = css(_templateObject$B || (_templateObject$B = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n    line-height: ", ";\n    height: ", ";\n"])), function (_ref) {
  var $size = _ref.$size;
  return $size || 'inherit';
}, function (_ref2) {
  var $size = _ref2.$size;
  return $size || 'inherit';
}, function (_ref3) {
  var $size = _ref3.$size;
  return $size || 'fit-content';
});
var StyledIcon = styled(Icon$1)(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteralLoose(["\n    position: relative;\n    color: ", ";\n    ", ";\n\n    ", ";\n    ", ";\n\n    &&&&&&&&&& {\n        ", ";\n    }\n\n    ", ";\n\n    > * {\n        position: relative;\n        z-index: 2;\n    }\n"])), function (_ref4) {
  var $theme = _ref4.$theme,
    $color = _ref4.$color;
  return $theme.colors[$color] || $color || 'inherit';
}, iconStyles, function (_ref5) {
  var $marginRight = _ref5.$marginRight;
  return $marginRight && css(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteralLoose(["\n            margin-right: ", ";\n        "])), $marginRight);
}, function (_ref6) {
  var $marginLeft = _ref6.$marginLeft;
  return $marginLeft && css(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteralLoose(["\n            margin-left: ", ";\n        "])), $marginLeft);
}, function (_ref7) {
  var $stylePriority = _ref7.$stylePriority;
  return $stylePriority && css(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteralLoose(["\n                ", ";\n            "])), iconStyles);
}, function (_ref8) {
  var $roundedSize = _ref8.$roundedSize;
  return $roundedSize && css(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteralLoose(["\n            cursor: pointer;\n\n            &::after {\n                height: ", ";\n                width: ", ";\n                top: 50%;\n                left: 50%;\n                transform: translate3d(-50%, -50%, 0);\n\n                content: '';\n                position: absolute;\n                border-radius: 50%;\n                z-index: 1;\n                background-color: ", ";\n                opacity: ", ";\n                transition: ", ";\n            }\n\n            &:hover:after {\n                background-color: ", ";\n            }\n        "])), function (_ref9) {
    var $roundedSize = _ref9.$roundedSize;
    return $roundedSize;
  }, function (_ref0) {
    var $roundedSize = _ref0.$roundedSize;
    return $roundedSize;
  }, function (_ref1) {
    var $roundedColor = _ref1.$roundedColor,
      $theme = _ref1.$theme;
    return $roundedColor ? $theme.colors[$roundedColor] || $roundedColor : 'transparent';
  }, function (_ref10) {
    var $roundedOpacity = _ref10.$roundedOpacity;
    return $roundedOpacity;
  }, function (_ref11) {
    var $theme = _ref11.$theme;
    return $theme.transition["default"];
  }, function (_ref12) {
    var $theme = _ref12.$theme,
      $hoverRoundedColor = _ref12.$hoverRoundedColor;
    return $theme.colors[$hoverRoundedColor] || $hoverRoundedColor || $theme.colors.lines;
  });
});

var _excluded$p = ["color", "size", "stylePriority", "roundedColor", "roundedSize", "roundedOpacity", "hoverRoundedColor", "marginLeft", "marginRight"];
var BaseIcon = function BaseIcon(_ref) {
  var color = _ref.color,
    size = _ref.size,
    stylePriority = _ref.stylePriority,
    roundedColor = _ref.roundedColor,
    roundedSize = _ref.roundedSize,
    _ref$roundedOpacity = _ref.roundedOpacity,
    roundedOpacity = _ref$roundedOpacity === void 0 ? 0.7 : _ref$roundedOpacity,
    hoverRoundedColor = _ref.hoverRoundedColor,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$p);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledIcon, _extends({
    $roundedColor: roundedColor,
    $roundedSize: roundedSize,
    $roundedOpacity: roundedOpacity,
    $theme: theme,
    $color: color,
    $size: size,
    $stylePriority: stylePriority,
    $hoverRoundedColor: hoverRoundedColor,
    $marginLeft: marginLeft,
    $marginRight: marginRight
  }, props));
};

var _templateObject$C;
var StyledLoader = styled.div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteralLoose(["\n    position: ", ";\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: ", ";\n    z-index: ", ";\n"])), function (_ref) {
  var $position = _ref.$position;
  return $position || 'absolute';
}, function (_ref2) {
  var $theme = _ref2.$theme,
    $overlayColor = _ref2.$overlayColor;
  return $theme.colors[$overlayColor] || $overlayColor || 'transparent';
}, function (_ref3) {
  var $zIndex = _ref3.$zIndex;
  return $zIndex;
});

var _excluded$q = ["overlayColor", "position", "color", "size", "zIndex"];
var Loader = function Loader(_ref) {
  var overlayColor = _ref.overlayColor,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'absolute' : _ref$position,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '80px' : _ref$size,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 5 : _ref$zIndex,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledLoader, {
    $theme: theme,
    $position: position,
    $overlayColor: overlayColor,
    $zIndex: zIndex
  }, /*#__PURE__*/React__default.createElement(BaseIcon, _extends({
    color: color,
    size: size,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgLoader, null);
    }
  }, props)));
};

var Icon = BaseIcon;
Icon.Loader = Loader;

var Image = function Image(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React__default.createElement(Image$1, _extends({
    alt: "picture",
    preview: false
  }, props));
};

var _templateObject$D;
var StyledClearIcon = styled(SvgCloseX)(_templateObject$D || (_templateObject$D = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    font-size: 24px;\n    right: 0;\n    top: ", ";\n    z-index: 4;\n    color: ", ";\n    animation: ", " 0.2s ease-in-out;\n    cursor: pointer;\n"])), function (_ref) {
  var $size = _ref.$size;
  return $size === 'large' ? '20px' : '15px';
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.colors.secondaryText;
}, SlideFromRight);

var ClearIcon = function ClearIcon(_ref) {
  var size = _ref.size;
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledClearIcon, {
    $theme: theme,
    $size: size
  });
};

var getColor = function getColor(_ref) {
  var $theme = _ref.$theme,
    status = _ref.status,
    _ref$isBorder = _ref.isBorder,
    isBorder = _ref$isBorder === void 0 ? false : _ref$isBorder;
  switch (status) {
    case 'error':
      return $theme.colors.error;
    case 'success':
      return $theme.colors.success;
    default:
      return isBorder ? 'transparent' : $theme.colors.secondaryText;
  }
};

var _templateObject$E;
var StyledLabel = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteralLoose(["\n    position: relative;\n    margin-bottom: 12px;\n\n    .label {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        z-index: 3;\n        border: 2px solid transparent;\n        padding: ", ";\n        padding-left: ", ";\n        font: ", ";\n        color: ", ";\n        transition: ", ";\n        pointer-events: none;\n        touch-action: none;\n    }\n\n    .label-float {\n        top: -8px;\n        font: ", ";\n        color: ", ";\n    }\n\n    &:has([aria-invalid='true']) {\n        label {\n            color: ", ";\n\n            &.label-float {\n                color: ", ";\n            }\n        }\n    }\n"])), function (_ref) {
  var $size = _ref.$size;
  return $size === 'large' ? '18px 24px' : '14px 24px';
}, function (_ref2) {
  var $prefix = _ref2.$prefix;
  return $prefix ? '60px' : '24px';
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.fonts.descriptor1;
}, function (_ref4) {
  var $theme = _ref4.$theme,
    $status = _ref4.$status;
  return getColor({
    $theme: $theme,
    status: $status
  });
}, function (_ref5) {
  var $theme = _ref5.$theme;
  return $theme.transition["default"];
}, function (_ref6) {
  var $theme = _ref6.$theme;
  return $theme.fonts.descriptor2;
}, function (_ref7) {
  var $theme = _ref7.$theme;
  return $theme.colors.secondaryText;
}, function (_ref8) {
  var $theme = _ref8.$theme;
  return getColor({
    $theme: $theme,
    status: 'error'
  });
}, function (_ref9) {
  var $theme = _ref9.$theme;
  return getColor({
    $theme: $theme
  });
});

var Label$2 = function Label(_ref) {
  var children = _ref.children,
    label = _ref.label,
    value = _ref.value,
    theme = _ref.theme,
    size = _ref.size,
    prefix = _ref.prefix,
    status = _ref.status;
  var _useState = useState(false),
    focus = _useState[0],
    setFocus = _useState[1];
  var labelClass = focus || value && value.length !== 0 ? 'label label-float' : 'label';
  return /*#__PURE__*/React__default.createElement(StyledLabel, {
    $status: status,
    $prefix: prefix,
    onBlur: function onBlur() {
      return setFocus(false);
    },
    onFocus: function onFocus() {
      return setFocus(true);
    },
    $theme: theme,
    $size: size
  }, children, /*#__PURE__*/React__default.createElement("label", {
    className: labelClass
  }, label));
};

var _templateObject$F, _templateObject2$s, _templateObject3$j, _templateObject4$f, _templateObject5$b;
var sharedInputStyles = css(_templateObject$F || (_templateObject$F = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme,
    status = _ref.status,
    $noValidationBorders = _ref.$noValidationBorders;
  var borderColor = getColor({
    $theme: $theme,
    status: $noValidationBorders ? null : status,
    isBorder: true
  });
  var borderColorError = $noValidationBorders ? 'transparent' : $theme.colors.error;
  var color = getColor({
    $theme: $theme,
    status: status
  });
  return css(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteralLoose(["\n            border: 2px solid ", ";\n            border-radius: unset;\n            padding: 22px 24px 10px 24px;\n            font: ", ";\n            outline: none;\n            transition: ", ";\n            color: ", ";\n\n            &[aria-invalid='true'] + .ant-input-suffix {\n                color: ", ";\n            }\n            &[aria-invalid='true'],\n            &[aria-invalid='true']:hover {\n                border-color: ", ";\n            }\n\n            &:hover {\n                border-color: ", ";\n                border-right-width: 2px;\n            }\n\n            .ant-input-focused,\n            &.ant-input:focus {\n                background-color: ", ";\n                border-color: ", ";\n                box-shadow: none;\n                border-right-width: 2px;\n            }\n\n            &.ant-input {\n                background-color: ", ";\n\n                &::-webkit-outer-spin-button,\n                &::-webkit-inner-spin-button {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    margin: 0;\n                    box-shadow: none;\n                    white-space: normal;\n                    appearance: none;\n                }\n            }\n\n            &.ant-input-lg {\n                padding: 26px 24px 14px 24px;\n            }\n\n            &.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused,\n            &.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus {\n                border-color: ", ";\n                box-shadow: none;\n                border-right-width: 2px;\n            }\n\n            &.ant-input-affix-wrapper {\n                position: relative;\n                padding: 22px 64px 10px 24px;\n                background-color: ", ";\n                border: 2px solid ", ";\n                border-radius: unset;\n\n                ", ";\n\n                .ant-input {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    height: 100%;\n                    padding: 22px 64px 10px 24px;\n                    font: ", ";\n                    color: ", ";\n                    background-color: ", ";\n\n                    &:-webkit-autofill,\n                    &:-webkit-autofill:hover,\n                    &:-webkit-autofill:focus,\n                    &:-webkit-autofill:active {\n                        -webkit-text-fill-color: inherit;\n                        -webkit-box-shadow: ", " !important;\n                        transition: background-color 5000s ease-in-out 0s !important;\n                    }\n\n                    ", ";\n                }\n\n                &.ant-input-affix-wrapper-lg {\n                    padding: 26px 64px 14px 24px;\n\n                    ", ";\n                }\n\n                .ant-input-prefix {\n                    position: absolute;\n                    top: 0;\n                    width: 24px;\n                    height: 100%;\n                    color: ", ";\n                    font-size: 24px;\n                    left: 18px;\n                    margin-right: 0;\n                }\n\n                .ant-input-suffix {\n                    position: absolute;\n                    top: 0;\n                    width: 24px;\n                    height: 100%;\n                    color: ", ";\n                    font-size: 24px;\n                    right: 18px;\n                    margin-left: 0;\n                }\n\n                &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n                    border-color: ", ";\n                    border-right-width: 2px;\n                }\n\n                [aria-invalid='true'] + .ant-input-suffix {\n                    color: ", ";\n                }\n            }\n\n            &.ant-input-affix-wrapper,\n            &.ant-input-affix-wrapper-status-error {\n                &.ant-input-affix-wrapper-focused,\n                &.ant-input-affix-wrapper-focused:hover {\n                    && {\n                        border-color: ", ";\n                        background-color: ", ";\n                        border-width: 2px;\n                        box-shadow: none;\n\n                        .ant-input {\n                            background-color: ", ";\n                        }\n\n                        .ant-input-clear-icon *,\n                        .ant-input-prefix * {\n                            color: ", ";\n                        }\n\n                        .ant-input-suffix {\n                            display: none;\n                        }\n                    }\n                }\n            }\n\n            &.ant-input-affix-wrapper-status-error,\n            &:has([aria-invalid='true']) {\n                && {\n                    border-color: ", ";\n                    background-color: ", ";\n\n                    &:not(.ant-input-affix-wrapper-disabled):hover {\n                        border-right-width: 2px;\n                        background-color: ", ";\n                        border-color: ", ";\n                    }\n                }\n\n                &.ant-input-affix-wrapper-focused,\n                &.ant-input-affix-wrapper-focused:hover {\n                    .ant-input-prefix,\n                    .ant-input-suffix {\n                        color: ", ";\n\n                        .ant-input-clear-icon * {\n                            color: ", ";\n                        }\n                    }\n                }\n            }\n\n            &.ant-input[disabled],\n            &.ant-input-affix-wrapper-disabled {\n                border-color: transparent;\n                opacity: ", ";\n            }\n\n            .ant-input-clear-icon * {\n                color: ", ";\n            }\n\n            &.ant-input:-webkit-autofill,\n            &.ant-input:-webkit-autofill:hover,\n            &.ant-input:-webkit-autofill:focus,\n            &.ant-input:-webkit-autofill:active {\n                -webkit-text-fill-color: inherit;\n                -webkit-box-shadow: ", " !important;\n                transition: background-color 5000s ease-in-out 0s !important;\n            }\n        "])), borderColor, function (_ref2) {
    var $theme = _ref2.$theme;
    return $theme.fonts.descriptor1;
  }, function (_ref3) {
    var $theme = _ref3.$theme;
    return $theme.transition["default"];
  }, function (_ref4) {
    var $theme = _ref4.$theme;
    return $theme.colors.secondaryText;
  }, getColor({
    $theme: $theme,
    status: 'error'
  }), borderColorError, borderColor, function (_ref5) {
    var $theme = _ref5.$theme;
    return $theme.colors.canvas;
  }, function (_ref6) {
    var $theme = _ref6.$theme;
    return $theme.colors.primaryText;
  }, function (_ref7) {
    var $theme = _ref7.$theme;
    return $theme.colors.background;
  }, function (_ref8) {
    var $theme = _ref8.$theme;
    return $theme.colors.primaryText;
  }, function (_ref9) {
    var $theme = _ref9.$theme;
    return $theme.colors.background;
  }, borderColor, function (_ref0) {
    var prefix = _ref0.prefix;
    return prefix && css(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteralLoose(["\n                        padding-left: 60px;\n                    "])));
  }, function (_ref1) {
    var $theme = _ref1.$theme;
    return $theme.fonts.descriptor1;
  }, function (_ref10) {
    var $theme = _ref10.$theme;
    return $theme.colors.secondaryText;
  }, function (_ref11) {
    var $theme = _ref11.$theme;
    return $theme.colors.background;
  }, function (_ref12) {
    var $theme = _ref12.$theme;
    return "0 0 0px 1000px " + $theme.colors.background + " inset;";
  }, function (_ref13) {
    var prefix = _ref13.prefix;
    return prefix && css(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteralLoose(["\n                            padding-left: 60px;\n                        "])));
  }, function (_ref14) {
    var prefix = _ref14.prefix;
    return prefix && css(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteralLoose(["\n                            padding-left: 60px;\n                        "])));
  }, color, color, borderColor, getColor({
    $theme: $theme,
    status: 'error'
  }), function (_ref15) {
    var $theme = _ref15.$theme;
    return $theme.colors.primaryText;
  }, function (_ref16) {
    var $theme = _ref16.$theme;
    return $theme.colors.canvas;
  }, function (_ref17) {
    var $theme = _ref17.$theme;
    return $theme.colors.canvas;
  }, function (_ref18) {
    var $theme = _ref18.$theme;
    return $theme.colors.secondaryText;
  }, borderColorError, function (_ref19) {
    var $theme = _ref19.$theme;
    return $theme.colors.background;
  }, function (_ref20) {
    var $theme = _ref20.$theme;
    return $theme.colors.background;
  }, borderColorError, function (_ref21) {
    var $theme = _ref21.$theme;
    return $theme.colors.secondaryText;
  }, function (_ref22) {
    var $theme = _ref22.$theme;
    return $theme.colors.secondaryText;
  }, function (_ref23) {
    var $nonOpacityOnDisabled = _ref23.$nonOpacityOnDisabled;
    return $nonOpacityOnDisabled ? 1 : 0.5;
  }, color, function (_ref24) {
    var $theme = _ref24.$theme;
    return "0 0 0px 1000px " + $theme.colors.background + " inset;";
  });
});

var _templateObject$G;
var StyledInput = styled(Input$4)(_templateObject$G || (_templateObject$G = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), sharedInputStyles);

var formatInputValueByType$1 = function formatInputValueByType(value, type) {
  if (type === 'tel') {
    return phoneMask(value);
  }
  return value;
};

var _excluded$r = ["type", "value", "onChange", "onBlur", "allowClear", "size", "label", "prefix", "suffix", "showWarningIcon", "status", "nonOpacityOnDisabled", "withoutBorderColorsOnValidate", "formatter", "parser", "trim", "component"];
var BaseInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _props$ariaDescribed;
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$value = _ref.value,
    inputValue = _ref$value === void 0 ? '' : _ref$value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return null;
    } : _ref$onChange,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {
      return null;
    } : _ref$onBlur,
    _ref$allowClear = _ref.allowClear,
    allowClear = _ref$allowClear === void 0 ? false : _ref$allowClear,
    size = _ref.size,
    label = _ref.label,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? /*#__PURE__*/React__default.createElement("span", null) : _ref$prefix,
    _ref$suffix = _ref.suffix,
    suffix = _ref$suffix === void 0 ? /*#__PURE__*/React__default.createElement("span", null) : _ref$suffix,
    showWarningIcon = _ref.showWarningIcon,
    inputStatus = _ref.status,
    _ref$nonOpacityOnDisa = _ref.nonOpacityOnDisabled,
    nonOpacityOnDisabled = _ref$nonOpacityOnDisa === void 0 ? false : _ref$nonOpacityOnDisa,
    _ref$withoutBorderCol = _ref.withoutBorderColorsOnValidate,
    withoutBorderColorsOnValidate = _ref$withoutBorderCol === void 0 ? false : _ref$withoutBorderCol,
    _ref$formatter = _ref.formatter,
    formatter = _ref$formatter === void 0 ? null : _ref$formatter,
    _ref$parser = _ref.parser,
    parser = _ref$parser === void 0 ? null : _ref$parser,
    _ref$trim = _ref.trim,
    trim = _ref$trim === void 0 ? true : _ref$trim,
    _ref$component = _ref.component,
    Component = _ref$component === void 0 ? StyledInput : _ref$component,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$r);
  var _useState = useState(''),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(inputStatus),
    status = _useState2[0],
    setStatus = _useState2[1];
  var theme = useContext(KliThemeContext);
  var formatValue = useCallback(function (value) {
    var parsedVal = typeof parser === 'function' ? parser(value) : value;
    return typeof formatter === 'function' ? formatter(parsedVal) : formatInputValueByType$1(value, type);
  }, [type, formatter, parser]);
  var trimValue = function trimValue(val) {
    return typeof val === 'string' && trim ? val.trim() : val;
  };
  var handleOnChange = function handleOnChange(e) {
    setValue(formatValue(e.target.value));
    e.target.value = formatValue(e.target.value);
    return onChange(e);
  };
  var handleOnBlur = function handleOnBlur(e) {
    if (!inputStatus && !withoutBorderColorsOnValidate) setStatus('success');
    var event = _extends({}, e);
    if (trim) event.target.value = trimValue(event.target.value);
    return onBlur(event);
  };
  useEffect(function () {
    if (inputStatus !== status) setStatus(inputStatus || 'success');
  }, [inputStatus]);
  useEffect(function () {
    if (inputValue !== value) setValue(inputValue);
  }, [inputValue]);
  var showAlertSuffix = showWarningIcon && (props['aria-invalid'] || ((_props$ariaDescribed = props['aria-describedby']) === null || _props$ariaDescribed === void 0 ? void 0 : _props$ariaDescribed.includes('help')));
  return /*#__PURE__*/React__default.createElement(Label$2, {
    label: label,
    value: value,
    theme: theme,
    size: size,
    prefix: prefix,
    status: status
  }, /*#__PURE__*/React__default.createElement(Component, _extends({
    ref: ref,
    type: type,
    value: value,
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    $theme: theme,
    size: size,
    allowClear: allowClear && !showWarningIcon && {
      clearIcon: /*#__PURE__*/React__default.createElement(ClearIcon, {
        size: size
      })
    },
    prefix: prefix,
    suffix: showAlertSuffix ? /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertInfo, null) : suffix,
    status: status,
    $nonOpacityOnDisabled: nonOpacityOnDisabled,
    $noValidationBorders: withoutBorderColorsOnValidate
  }, props)));
});

var _templateObject$H, _templateObject2$t;
var StyledInputNumber = styled(InputNumber$1)(_templateObject$H || (_templateObject$H = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme,
    status = _ref.status,
    $noValidationBorders = _ref.$noValidationBorders;
  var borderColor = getColor({
    $theme: $theme,
    status: $noValidationBorders ? null : status,
    isBorder: true
  });
  return css(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteralLoose(["\n            width: 100%;\n            border: 2px solid ", ";\n            border-radius: unset;\n            padding: 22px 24px 10px 24px;\n            font: ", ";\n            outline: none;\n            transition: ", ";\n            color: ", ";\n\n            &.ant-input-number {\n                background-color: ", ";\n            }\n\n            &.ant-input-number-focused,\n            &.ant-input-number:focus {\n                && {\n                    background-color: ", ";\n                    border-color: ", ";\n                    box-shadow: none;\n                    border-right-width: 2px;\n                }\n            }\n\n            &.ant-input-number:hover {\n                border-color: ", ";\n                border-right-width: 2px;\n            }\n\n            .ant-input-number-handler-wrap {\n                display: none;\n            }\n        "])), borderColor, function (_ref2) {
    var $theme = _ref2.$theme;
    return $theme.fonts.descriptor1;
  }, function (_ref3) {
    var $theme = _ref3.$theme;
    return $theme.transition["default"];
  }, function (_ref4) {
    var $theme = _ref4.$theme;
    return $theme.colors.secondaryText;
  }, function (_ref5) {
    var $theme = _ref5.$theme;
    return $theme.colors.background;
  }, function (_ref6) {
    var $theme = _ref6.$theme;
    return $theme.colors.canvas;
  }, function (_ref7) {
    var $theme = _ref7.$theme;
    return $theme.colors.primaryText;
  }, borderColor);
});

var _excluded$s = ["size", "label", "withoutBorderColorsOnValidate", "trim"];
var InputNumber = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var size = _ref.size,
    label = _ref.label,
    _ref$withoutBorderCol = _ref.withoutBorderColorsOnValidate,
    withoutBorderColorsOnValidate = _ref$withoutBorderCol === void 0 ? false : _ref$withoutBorderCol,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$s);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(Label$2, {
    label: label,
    value: true,
    theme: theme,
    size: size
  }, /*#__PURE__*/React__default.createElement(StyledInputNumber, _extends({
    ref: ref,
    $theme: theme,
    size: size,
    $noValidationBorders: withoutBorderColorsOnValidate
  }, props)));
});

var _excluded$t = ["currency", "locales", "minimumFractionDigits"];
var InputCurrency = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? 'USD' : _ref$currency,
    _ref$locales = _ref.locales,
    locales = _ref$locales === void 0 ? 'en-us' : _ref$locales,
    _ref$minimumFractionD = _ref.minimumFractionDigits,
    minimumFractionDigits = _ref$minimumFractionD === void 0 ? 0 : _ref$minimumFractionD,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$t);
  var formatter = function formatter(value) {
    return new Intl.NumberFormat(locales, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: minimumFractionDigits
    }).format(value);
  };
  var parser = function parser(value) {
    return String(value).replace(/[^0-9.]/g, '');
  };
  return /*#__PURE__*/React__default.createElement(InputNumber, _extends({
    ref: ref
  }, props, {
    type: "text",
    formatter: formatter,
    parser: parser
  }));
});

var _templateObject$I, _templateObject2$u;
var StyledWrapper$3 = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteralLoose(["\n    position: relative;\n\n    &:before {\n        content: '';\n        position: absolute;\n        top: 2px;\n        left: 2px;\n        width: calc(100% - 4px);\n        height: ", ";\n        z-index: 1;\n        background: ", ";\n        transition: all 0.2s ease-in;\n    }\n\n    &:has(textarea:focus):before,\n    &:has(.ant-input-status-error):before {\n        background: ", ";\n    }\n\n    .ant-input-affix-wrapper {\n        border: none;\n        border-radius: unset;\n\n        &:hover {\n            border: none;\n        }\n    }\n\n    && {\n        textarea {\n            padding-top: calc(", " - 2px);\n        }\n    }\n"])), function (_ref) {
  var _ref$$labelHeight = _ref.$labelHeight,
    $labelHeight = _ref$$labelHeight === void 0 ? '24px' : _ref$$labelHeight;
  return $labelHeight;
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.colors.background;
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.colors.canvas;
}, function (_ref4) {
  var _ref4$$labelHeight = _ref4.$labelHeight,
    $labelHeight = _ref4$$labelHeight === void 0 ? '24px' : _ref4$$labelHeight;
  return $labelHeight;
});
var StyledTextArea = styled(Input$4.TextArea)(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteralLoose(["\n    && {\n        ", ";\n        resize: none;\n        border-radius: unset;\n    }\n"])), sharedInputStyles);

var _excluded$u = ["labelHeight"];
var TextArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var labelHeight = _ref.labelHeight,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$u);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledWrapper$3, {
    $theme: theme,
    $labelHeight: labelHeight
  }, /*#__PURE__*/React__default.createElement(BaseInput, _extends({}, props, {
    ref: ref,
    component: StyledTextArea
  })));
});

var Input = BaseInput;
Input.Currency = InputCurrency;
Input.Number = InputNumber;
Input.TextArea = TextArea;

var _templateObject$J, _templateObject2$v;
var StyledMenu = styled(Menu$1)(_templateObject$J || (_templateObject$J = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return css(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteralLoose(["\n        border-right: none;\n\n        &.ant-menu-vertical .ant-menu-item {\n            margin: 0 0 24px 0;\n        }\n\n        &.ant-menu-vertical .ant-menu-item:not(:last-child) {\n            margin-bottom: 24px;\n        }\n\n        .ant-menu-submenu {\n            margin-bottom: 0;\n            margin-top: -1px;\n            padding: 0;\n        }\n\n        .ant-menu-item {\n            position: relative;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            padding: 0 20px;\n            color: ", ";\n            font: ", ";\n\n            &:before {\n                position: absolute;\n                left: 0;\n                width: 4px;\n                height: 100%;\n                content: '';\n                background: transparent;\n                transition: background 0.3s ease-in-out;\n            }\n\n            a:not(.active) {\n                color: ", ";\n            }\n\n            .ant-menu-item-icon {\n                width: 24px;\n                height: 24px;\n            }\n\n            &.ant-menu-item-active,\n            &:has(.active) {\n                color: ", ";\n\n                &:before {\n                    background: ", ";\n                }\n            }\n\n            &.ant-menu-item-selected,\n            &:active {\n                background: ", ";\n            }\n\n            &:hover,\n            a:hover,\n            &.ant-menu-item-selected a {\n                color: ", ";\n            }\n        }\n    "])), $theme.colors.secondaryText, $theme.fonts.body2, $theme.colors.secondaryText, $theme.colors.primaryText, $theme.colors.primary, $theme.colors.canvas, $theme.colors.primaryText);
});

var BaseMenu = function BaseMenu(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledMenu, _extends({
    $theme: theme
  }, props));
};

var _templateObject$K, _templateObject2$w;
var StyledDropdown = styled.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteralLoose(["\n    box-shadow: 0 20px 40px rgb(0 0 0 / 9%);\n    background: ", ";\n\n    ", ";\n\n    > ul {\n        padding: 8px;\n        border-radius: 4px;\n        box-shadow: none;\n    }\n\n    .ant-dropdown-menu-item {\n        padding: 0;\n    }\n\n    [data-non-menu-item='true'] {\n        cursor: unset;\n\n        &:hover {\n            background: transparent;\n        }\n    }\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return $theme.colors.canvas;
}, function (_ref2) {
  var $menuMaxHeight = _ref2.$menuMaxHeight;
  return $menuMaxHeight ? css(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteralLoose(["\n                  max-height: ", ";\n                  overflow-x: auto;\n              "])), $menuMaxHeight) : '';
});

var _excluded$v = ["items", "children", "menuMaxHeight"];
var DropdownMenu = function DropdownMenu(_ref) {
  var items = _ref.items,
    children = _ref.children,
    menuMaxHeight = _ref.menuMaxHeight,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$v);
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(Dropdown, _extends({
    menu: {
      items: items
    },
    trigger: ['click'],
    placement: "bottomRight",
    dropdownRender: function dropdownRender(menus) {
      return /*#__PURE__*/React__default.createElement(StyledDropdown, {
        $theme: theme,
        $menuMaxHeight: menuMaxHeight
      }, menus);
    }
  }, props), children);
};

var Menu = BaseMenu;
Menu.Dropdown = DropdownMenu;

var _templateObject$L, _templateObject2$x, _templateObject3$k, _templateObject4$g;
var StyledAntdModal = styled(Modal$1)(_templateObject$L || (_templateObject$L = _taggedTemplateLiteralLoose(["\n    ", "\n"])), function (_ref) {
  return css(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteralLoose(["\n        &.ant-modal {\n            .ant-modal-content {\n                padding: 0;\n            }\n\n            ", "\n\n            ", "\n        }\n    "])), function (_ref2) {
    var $padding = _ref2.$padding;
    return $padding ? css(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteralLoose(["\n                          .ant-modal-body {\n                              padding: ", ";\n                          }\n                      "])), $padding) : '';
  }, function (_ref3) {
    var $fullscreen = _ref3.$fullscreen,
      $defaultFooter = _ref3.$defaultFooter;
    return $fullscreen ? css(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteralLoose(["\n                          &,\n                          & .ant-modal-content {\n                              max-width: 100%;\n                              width: 100%;\n                              height: 100%;\n                              top: 0;\n                              padding-bottom: 0;\n                              margin: 0;\n                          }\n\n                          & .ant-modal-body {\n                              height: ", ";\n                          }\n                      "])), function () {
      return $defaultFooter ? 'calc(100% - 53px)' : '100%';
    }) : '';
  });
});

var _excluded$w = ["children", "width", "centered", "padding", "defaultFooter", "fullscreen", "maskClosable", "onClose"],
  _excluded2$2 = ["children"];
var ModalContext = /*#__PURE__*/React__default.createContext(null);
var Modal = function Modal(_ref) {
  var children = _ref.children,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '630px' : _ref$width,
    _ref$centered = _ref.centered,
    centered = _ref$centered === void 0 ? true : _ref$centered,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? '0' : _ref$padding,
    _ref$defaultFooter = _ref.defaultFooter,
    defaultFooter = _ref$defaultFooter === void 0 ? false : _ref$defaultFooter,
    _ref$fullscreen = _ref.fullscreen,
    fullscreen = _ref$fullscreen === void 0 ? false : _ref$fullscreen,
    _ref$maskClosable = _ref.maskClosable,
    maskClosable = _ref$maskClosable === void 0 ? true : _ref$maskClosable,
    onClose = _ref.onClose,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$w);
  var customProps = {
    $padding: padding,
    $defaultFooter: defaultFooter,
    $fullscreen: fullscreen,
    width: fullscreen ? null : width,
    onCancel: onClose,
    maskClosable: maskClosable,
    centered: centered
  };
  customProps = defaultFooter ? _extends({}, customProps) : _extends({}, customProps, {
    footer: null
  });
  return /*#__PURE__*/React__default.createElement(StyledAntdModal, _extends({}, props, customProps), children);
};
var ModalProvider = function ModalProvider(_ref2) {
  var children = _ref2.children,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);
  var _useState = useState(),
    modal = _useState[0],
    _setModal = _useState[1];
  var _useState2 = useState({}),
    settings = _useState2[0],
    setSettings = _useState2[1];
  var hideModal = useCallback(function () {
    _setModal();
  }, [_setModal]);
  var setModal = useCallback(function (modal, settings) {
    if (settings === void 0) {
      settings = {};
    }
    _setModal(modal);
    if (typeof settings !== 'undefined') {
      setSettings(_extends({}, settings));
    }
  }, [_setModal, setSettings]);
  var setParams = useCallback(function (params) {
    if (typeof params !== 'undefined') {
      setSettings(_extends({}, params));
    }
  }, [setSettings]);
  return /*#__PURE__*/React__default.createElement(ModalContext.Provider, _extends({
    value: {
      hideModal: hideModal,
      setModal: setModal,
      setParams: setParams
    }
  }, rest), children, modal && /*#__PURE__*/React__default.createElement(Modal, _extends({
    open: Boolean(modal),
    onClose: hideModal
  }, settings), modal));
};
var useModal = function useModal() {
  var context = React__default.useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

var _templateObject$M, _templateObject2$y, _templateObject3$l, _templateObject4$h, _templateObject5$c, _templateObject6$9, _templateObject7$3;
var StyledWrap = createGlobalStyle(_templateObject$M || (_templateObject$M = _taggedTemplateLiteralLoose(["\n    ", ";\n\n    ", ";\n\n    ", ";\n\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return css(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteralLoose(["\n        .ant-popover .ant-popover-content > .ant-popover-inner > .ant-popover-title {\n            color: ", ";\n            margin: 0;\n            border: none;\n            font: ", ";\n            padding: 24px 32px 12px;\n        }\n\n        .ant-popover .ant-popover-content > .ant-popover-inner {\n            padding: 0;\n        }\n\n        .ant-popover-inner-content {\n            ", "\n        }\n    "])), $theme.colors.canvas, function () {
    return $theme.fonts.badgeLarge;
  }, function (_ref2) {
    var title = _ref2.title;
    return title ? css(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteralLoose(["\n                          padding: 0 32px 24px;\n                      "]))) : css(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteralLoose(["\n                          padding: 24px 32px;\n                      "])));
  });
}, function (_ref3) {
  var maxWidth = _ref3.maxWidth;
  return maxWidth ? css(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteralLoose(["\n                  .ant-popover {\n                      max-width: ", ";\n                  }\n              "])), maxWidth) : '';
}, function (_ref4) {
  var $theme = _ref4.$theme,
    type = _ref4.type;
  return type === 'primary' ? css(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteralLoose(["\n                  .ant-popover-title,\n                  .ant-popover-inner-content {\n                      background-color: ", ";\n\n                      span {\n                          color: ", ";\n                      }\n                  }\n\n                  .ant-popover .ant-popover-arrow {\n                      &:before {\n                          background: ", ";\n                      }\n                  }\n\n                  .ant-popover-arrow-content {\n                      --antd-arrow-background-color: ", ";\n                  }\n\n                  .ant-popover-title {\n                      color: ", ";\n                  }\n              "])), $theme.colors.primary, $theme.colors.canvas, $theme.colors.primary, $theme.colors.primary, $theme.colors.canvas) : '';
}, function (_ref5) {
  var $theme = _ref5.$theme,
    type = _ref5.type;
  return type === 'primary-black' ? css(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n                  .ant-popover-title,\n                  .ant-popover-inner-content {\n                      background-color: ", ";\n                      color: ", ";\n\n                      span {\n                          color: ", ";\n                      }\n                  }\n\n                  .ant-popover .ant-popover-arrow {\n                      &:before {\n                          background: ", ";\n                      }\n                  }\n\n                  .ant-popover-arrow-content {\n                      --antd-arrow-background-color: ", ";\n                  }\n              "])), $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.primaryText) : '';
});

var _excluded$x = ["children"];
var BasePopover = function BasePopover(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$x);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledWrap, _extends({
    $theme: themeContext
  }, props)), /*#__PURE__*/React__default.createElement(Popover$1, props, children));
};

var _templateObject$N, _templateObject2$z, _templateObject3$m, _templateObject4$i;
var StyledPopover = createGlobalStyle(_templateObject$N || (_templateObject$N = _taggedTemplateLiteralLoose(["\n    .popover-points {\n        .ant-popover-inner {\n            padding: 0;\n            .ant-popover-inner-content {\n                padding: 8px 16px;\n            }\n        }\n    }\n"])));
var StyledContent = styled(Typography.Text)(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteralLoose(["\n    && {\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n        white-space: nowrap;\n\n        ", ";\n\n        > span {\n            margin-left: 4px;\n            font-weight: 500;\n        }\n    }\n"])), function (_ref) {
  var $textLineHeight = _ref.$textLineHeight;
  return $textLineHeight && css(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteralLoose(["\n                line-height: ", ";\n            "])), $textLineHeight);
});
var StyledIcon$1 = styled(Icon)(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteralLoose(["\n    margin-left: 12px;\n"])));

var _excluded$y = ["children", "points", "showUsdOnly", "showCloseIconOnMobile", "textType", "textLineHeight"];
var PopoverPoints = function PopoverPoints(_ref) {
  var children = _ref.children,
    points = _ref.points,
    showUsdOnly = _ref.showUsdOnly,
    _ref$showCloseIconOnM = _ref.showCloseIconOnMobile,
    showCloseIconOnMobile = _ref$showCloseIconOnM === void 0 ? true : _ref$showCloseIconOnM,
    _ref$textType = _ref.textType,
    textType = _ref$textType === void 0 ? 'body2' : _ref$textType,
    textLineHeight = _ref.textLineHeight,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$y);
  var simple = useSimpleInterface(GRID_POINTS.md);
  var _useState = useState(false),
    clicked = _useState[0],
    setClicked = _useState[1];
  var _useState2 = useState(false),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  var handleHoverChange = function handleHoverChange(open) {
    setHovered(open);
    setClicked(false);
  };
  var handleClickChange = function handleClickChange(open) {
    setHovered(false);
    setClicked(open);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledPopover, null), /*#__PURE__*/React__default.createElement(BasePopover, _extends({
    open: simple ? clicked : hovered,
    onOpenChange: simple ? handleClickChange : handleHoverChange,
    overlayClassName: "popover-points",
    trigger: simple ? 'click' : 'hover',
    getPopupContainer: function getPopupContainer(node) {
      return node;
    },
    type: "primary",
    content: /*#__PURE__*/React__default.createElement(StyledContent, {
      type: textType,
      color: "canvas",
      $textLineHeight: textLineHeight
    }, !showUsdOnly && points + " points = ", /*#__PURE__*/React__default.createElement("span", null, points / 100 % 1 ? roundToLocaleString$1(points / 100) : points / 100, " USD"), simple && showCloseIconOnMobile && /*#__PURE__*/React__default.createElement(StyledIcon$1, {
      size: "12px",
      onClick: function onClick() {
        return handleClickChange(false);
      },
      component: function component() {
        return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
      }
    }))
  }, props), children));
};

var Popover = BasePopover;
Popover.Points = PopoverPoints;

var _templateObject$O, _templateObject2$A, _templateObject3$n, _templateObject4$j, _templateObject5$d, _templateObject6$a, _templateObject7$4, _templateObject8$3;
var getDefaultRadioStyles = function getDefaultRadioStyles(_ref) {
  var $theme = _ref.$theme,
    $size = _ref.$size,
    $checkedColor = _ref.$checkedColor;
  return css(_templateObject$O || (_templateObject$O = _taggedTemplateLiteralLoose(["\n    &.ant-radio-wrapper {\n        display: flex;\n        align-items: center;\n\n        & .ant-radio-checked:after,\n        &:not(.ant-radio-wrapper-disabled):hover .ant-radio-inner {\n            border-color: ", ";\n        }\n\n        & .ant-radio,\n        & .ant-radio-inner,\n        & .ant-radio-input {\n            border-width: 2px;\n        }\n\n        &,\n        &:focus,\n        &:not(.ant-radio-wrapper-disabled),\n        &:not(.ant-radio-wrapper-checked):active {\n            & .ant-radio,\n            & .ant-radio-inner,\n            & .ant-radio-input {\n                border-color: ", ";\n            }\n        }\n\n        & .ant-radio-checked {\n            border-color: ", ";\n\n            & .ant-radio-inner {\n                background-color: ", ";\n                border-color: ", ";\n            }\n        }\n    }\n\n    &.ant-radio-wrapper-disabled {\n        opacity: 0.6;\n    }\n\n    &.ant-radio-wrapper-checked,\n    & .ant-radio-checked {\n        &:focus {\n            border-color: transparent;\n            color: transparent;\n        }\n    }\n\n    & .ant-radio {\n        top: 0;\n\n        & + span:not(.kli-text) {\n            color: ", ";\n            font: ", ";\n        }\n    }\n\n    // size\n    & .ant-radio,\n    & .ant-radio-inner {\n        width: ", ";\n        height: ", ";\n    }\n\n    & .ant-radio-inner {\n        &:after {\n            width: ", ";\n            height: ", ";\n            background-color: ", ";\n            transform: translate(-50%, -50%) scale(0.5);\n            margin: 0;\n        }\n    }\n\n    & .ant-radio,\n    & .ant-radio-input,\n    & .ant-radio-inner {\n        outline: none;\n        box-shadow: none;\n    }\n"])), $theme.colors[$checkedColor] ? $theme.colors[$checkedColor] : $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors[$checkedColor] ? $theme.colors[$checkedColor] : $theme.colors.primaryText, $theme.colors[$checkedColor] ? $theme.colors[$checkedColor] : $theme.colors.primaryText, $theme.colors[$checkedColor] ? $theme.colors[$checkedColor] : $theme.colors.primaryText, $theme.colors.primaryText, $theme.fonts.body2, function () {
    return $size;
  }, function () {
    return $size;
  }, function () {
    return $size;
  }, function () {
    return $size;
  }, $theme.colors.canvas);
};
var getButtonRadioStyles = function getButtonRadioStyles(_ref2) {
  var $theme = _ref2.$theme;
  return css(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteralLoose(["\n    &.ant-radio-button-wrapper {\n        &,\n        &:focus {\n            width: fit-content;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border: 2px solid ", ";\n            color: ", ";\n            background-color: transparent;\n        }\n\n        & .ant-radio-button {\n            font: ", ";\n        }\n\n        &:before {\n            background-color: ", ";\n        }\n\n        &-checked,\n        &:not(.ant-radio-button-wrapper-disabled):hover,\n        &:not(.ant-radio-button-wrapper-disabled):active {\n            color: ", ";\n            border: 2px solid ", ";\n            opacity: 1;\n            outline: none;\n        }\n\n        &-checked {\n            &:not(.ant-radio-button-wrapper-disabled):before {\n                background-color: ", ";\n            }\n\n            &:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {\n                border-right-color: ", ";\n            }\n        }\n    }\n\n    &.ant-radio-button-wrapper-disabled {\n        opacity: 0.6;\n    }\n"])), $theme.colors.secondaryText, $theme.colors.primaryText, $theme.fonts.body2, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText);
};
var getSolidButtonRadioStyles = function getSolidButtonRadioStyles(_ref3) {
  var $theme = _ref3.$theme;
  return css(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteralLoose(["\n    &.ant-radio-button-wrapper {\n        &,\n        &:focus {\n            width: fit-content;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border: 2px solid ", ";\n            color: ", ";\n            background-color: transparent;\n        }\n\n        & .ant-radio-button {\n            font: ", ";\n        }\n\n        &:before {\n            background-color: ", ";\n        }\n\n        &-checked,\n        &:not(.ant-radio-button-wrapper-disabled):hover,\n        &:not(.ant-radio-button-wrapper-disabled):active {\n            color: ", ";\n            border: 2px solid ", ";\n            background-color: ", ";\n            opacity: 1;\n            outline: none;\n        }\n\n        &-checked {\n            &:not(.ant-radio-button-wrapper-disabled):before {\n                background-color: ", ";\n            }\n\n            &:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {\n                border-right-color: ", ";\n            }\n        }\n    }\n\n    &.ant-radio-button-wrapper-disabled {\n        opacity: 0.6;\n    }\n"])), $theme.colors.primaryText, $theme.colors.primaryText, $theme.fonts.body2, $theme.colors.primaryText, $theme.colors.canvas, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primaryText);
};
var StyledAntdRadio = styled(Radio$1)(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref4) {
  var $theme = _ref4.$theme,
    $size = _ref4.$size,
    $checkedColor = _ref4.$checkedColor;
  return getDefaultRadioStyles({
    $theme: $theme,
    $size: $size,
    $checkedColor: $checkedColor
  });
});
var StyledAntdRadioButton = styled(Radio$1.Button)(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref5) {
  var $theme = _ref5.$theme,
    $checkedColor = _ref5.$checkedColor;
  return getButtonRadioStyles({
    $theme: $theme,
    $checkedColor: $checkedColor
  });
});
var StyledAntdRadioGroup = styled(Radio$1.Group)(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteralLoose(["\n    & {\n        ", "\n    }\n\n    & .ant-radio-wrapper {\n        ", ";\n    }\n\n    &:not(.ant-radio-group-solid) .ant-radio-button-wrapper {\n        ", ";\n    }\n\n    &.ant-radio-group-solid .ant-radio-button-wrapper {\n        ", ";\n    }\n"])), function (_ref6) {
  var $direction = _ref6.$direction;
  return $direction === 'horizontal' ? css(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n                      display: inline-flex;\n                  "]))) : css(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["\n                      display: inline-block;\n\n                      & .ant-radio-wrapper,\n                      & .ant-radio-button-wrapper {\n                          margin-bottom: 14px;\n                      }\n                  "])));
}, function (_ref7) {
  var $theme = _ref7.$theme,
    $size = _ref7.$size,
    $checkedColor = _ref7.$checkedColor;
  return getDefaultRadioStyles({
    $theme: $theme,
    $size: $size,
    $checkedColor: $checkedColor
  });
}, function (_ref8) {
  var $theme = _ref8.$theme;
  return getButtonRadioStyles({
    $theme: $theme
  });
}, function (_ref9) {
  var $theme = _ref9.$theme;
  return getSolidButtonRadioStyles({
    $theme: $theme
  });
});

var _excluded$z = ["children", "direction", "size", "checkedColor", "buttonSize"],
  _excluded2$3 = ["children", "size", "checkedColor"],
  _excluded3 = ["children", "checkedColor"];
var RadioGroup = function RadioGroup(_ref) {
  var children = _ref.children,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '28px' : _ref$size,
    checkedColor = _ref.checkedColor,
    _ref$buttonSize = _ref.buttonSize,
    buttonSize = _ref$buttonSize === void 0 ? 'middle' : _ref$buttonSize,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$z);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAntdRadioGroup, _extends({
    "data-e2e": "common_radio-btn",
    $direction: direction,
    $size: size,
    size: buttonSize,
    $checkedColor: checkedColor,
    $theme: themeContext
  }, props), children);
};
var Radio = function Radio(_ref2) {
  var children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? '28px' : _ref2$size,
    checkedColor = _ref2.checkedColor,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2$3);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAntdRadio, _extends({
    "data-e2e": "common_radio-btn",
    $theme: themeContext,
    $size: size,
    $checkedColor: checkedColor
  }, props), children);
};
var RadioButton = function RadioButton(_ref3) {
  var children = _ref3.children,
    checkedColor = _ref3.checkedColor,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAntdRadioButton, _extends({
    "data-e2e": "common_radio-btn",
    $theme: themeContext,
    $checkedColor: checkedColor
  }, props), children);
};

var _templateObject$P;
var StyledLabel$1 = styled.div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteralLoose(["\n    position: relative;\n    margin-bottom: 12px;\n\n    .label {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        z-index: 3;\n        border: 2px solid transparent;\n        padding: ", ";\n        font: ", ";\n        color: ", ";\n        transition: ", ";\n        pointer-events: none;\n        touch-action: none;\n    }\n\n    .label-float {\n        top: -8px;\n        font: ", ";\n        color: ", ";\n    }\n"])), function (_ref) {
  var $size = _ref.$size;
  return $size === 'large' ? '18px 24px' : '14px 24px';
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.fonts.descriptor1;
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.colors.secondaryText;
}, function (_ref4) {
  var $theme = _ref4.$theme;
  return $theme.transition["default"];
}, function (_ref5) {
  var $theme = _ref5.$theme;
  return $theme.fonts.descriptor2;
}, function (_ref6) {
  var $theme = _ref6.$theme;
  return $theme.colors.secondaryText;
});

var Label$3 = function Label(_ref) {
  var children = _ref.children,
    label = _ref.label,
    value = _ref.value,
    theme = _ref.theme,
    size = _ref.size;
  var _useState = useState(false),
    focus = _useState[0],
    setFocus = _useState[1];
  var labelClass = focus || value && value.length !== 0 ? 'label label-float' : 'label';
  return /*#__PURE__*/React__default.createElement(StyledLabel$1, {
    onBlur: function onBlur() {
      return setFocus(false);
    },
    onFocus: function onFocus() {
      return setFocus(true);
    },
    $theme: theme,
    $size: size
  }, children, /*#__PURE__*/React__default.createElement("label", {
    className: labelClass
  }, label));
};

var _templateObject$Q, _templateObject2$B, _templateObject3$o, _templateObject4$k, _templateObject5$e;
var StyledSelect = styled(Select$1)(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteralLoose(["\n    width: 100%;\n\n    ", ";\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return css(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteralLoose(["\n            &&&& {\n                &:hover {\n                    .ant-select-selector {\n                        border-color: transparent;\n                        border-right-width: 2px;\n                    }\n                }\n                .ant-select-selector {\n                    border: 2px solid transparent;\n                    border-radius: unset;\n                    padding: ", ";\n                    font: ", ";\n                    outline: none;\n                    transition: ", ";\n                    color: ", ";\n                    background: ", ";\n\n                    &:hover {\n                        border-color: transparent;\n                        border-right-width: 2px;\n                    }\n\n                    ", ";\n\n                    .ant-select-selection-item .anticon {\n                        display: none;\n                    }\n                }\n\n                &.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customized-input)\n                    .ant-select-selector {\n                    box-shadow: none;\n                    border-color: transparent;\n\n                    ", ";\n                }\n\n                &.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector,\n                &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n                    height: auto;\n\n                    &:after {\n                        line-height: 24px;\n                    }\n                }\n\n                &.ant-select-single.ant-select-lg:not(.ant-select-customize-input)\n                    .ant-select-selector\n                    .ant-select-selection-item,\n                .ant-select-single.ant-select-lg:not(.ant-select-customize-input)\n                    .ant-select-selector\n                    .ant-select-selection-placeholder,\n                .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector:after,\n                &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item,\n                .ant-select-single.ant-select-lg:not(.ant-select-customize-input)\n                    .ant-select-selector\n                    .ant-select-selection-placeholder,\n                .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector:after {\n                    line-height: 24px;\n                }\n\n                .ant-select-arrow {\n                    right: 22px;\n                    color: ", ";\n                }\n\n                &.ant-select-single .ant-select-selector .ant-select-selection-item:after,\n                .ant-select-single .ant-select-selector .ant-select-selection-placeholder:after,\n                .ant-select-single .ant-select-selector:after {\n                    content: none;\n                }\n\n                .ant-select-selection-item {\n                    color: ", ";\n                }\n\n                &.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused\n                    .ant-select-selector,\n                .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open\n                    .ant-select-selector {\n                    border-right-width: 2px;\n                }\n            }\n        "])), function (_ref2) {
    var size = _ref2.size;
    return size === 'large' ? '26px 64px 14px 24px' : '20px 64px 10px 24px';
  }, $theme.fonts.descriptor1, $theme.transition["default"], $theme.colors.secondaryText, $theme.colors.background, function (_ref3) {
    var $error = _ref3.$error;
    return $error && css(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteralLoose(["\n                            border: 2px solid ", ";\n\n                            &:hover {\n                                border: 2px solid ", ";\n                            }\n                        "])), $theme.colors.error, $theme.colors.error);
  }, function (_ref4) {
    var $error = _ref4.$error;
    return $error && css(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteralLoose(["\n                            border: 2px solid ", ";\n\n                            &:hover {\n                                border: 2px solid ", ";\n                            }\n                        "])), $theme.colors.error, $theme.colors.error);
  }, $theme.colors.secondaryText, $theme.colors.primaryText);
});
var StyledOption = createGlobalStyle(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteralLoose(["\n    .ant-select-item, .ant-select-item-empty {\n        padding: 10px;\n        color: ", ";\n\n        .anticon {\n            visibility: hidden;\n        }\n    }\n\n    .ant-select-item-option-content {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n        background: transparent;\n        color: ", ";\n        font-weight: normal;\n\n        .anticon {\n            visibility: visible;\n        }\n    }\n\n    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n        background: transparent;\n    }\n"])), function (_ref5) {
  var $theme = _ref5.$theme;
  return $theme.colors.secondaryText;
}, function (_ref6) {
  var $theme = _ref6.$theme;
  return $theme.colors.secondaryText;
});

var _excluded$A = ["value", "onChange", "options", "allowClear", "size", "label", "error", "native"];
var Select = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$value = _ref.value,
    inputValue = _ref$value === void 0 ? '' : _ref$value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return null;
    } : _ref$onChange,
    options = _ref.options,
    size = _ref.size,
    label = _ref.label,
    _ref$error = _ref.error,
    selectError = _ref$error === void 0 ? false : _ref$error,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$A);
  var _useState = useState(''),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(false),
    error = _useState2[0],
    setError = _useState2[1];
  var theme = useContext(KliThemeContext);
  var handleOnChange = function handleOnChange(v) {
    setValue(typeof v === 'object' ? v.target.value : v);
    setError(false);
    return onChange(typeof v === 'object' ? v.target.value : v);
  };
  useEffect(function () {
    if (!value && selectError) setError(selectError);
  }, [selectError, value]);
  useEffect(function () {
    if (inputValue !== value) setValue(inputValue);
  }, [inputValue]);
  return /*#__PURE__*/React__default.createElement(Label$3, {
    label: label,
    value: value,
    theme: theme,
    size: size
  }, /*#__PURE__*/React__default.createElement(StyledOption, {
    $theme: theme
  }), /*#__PURE__*/React__default.createElement(StyledSelect, _extends({
    ref: ref,
    value: value,
    onChange: handleOnChange,
    $theme: theme,
    size: size,
    getPopupContainer: function getPopupContainer(node) {
      return node;
    },
    suffixIcon: /*#__PURE__*/React__default.createElement(Icon, {
      style: {
        pointerEvents: 'none'
      },
      size: "24px",
      component: function component() {
        return /*#__PURE__*/React__default.createElement(SvgArrowChevronDown, null);
      }
    }),
    $error: error
  }, props), options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement(StyledSelect.Option, {
      key: option.value,
      value: option.value,
      disabled: option.disabled,
      "data-e2e": "cancel-reason-option " + index
    }, /*#__PURE__*/React__default.createElement("span", null, option.label), /*#__PURE__*/React__default.createElement(Icon, {
      className: "checked",
      component: function component() {
        return /*#__PURE__*/React__default.createElement(SvgCheck, null);
      }
    }));
  })));
});

var _templateObject$R, _templateObject2$C, _templateObject3$p, _templateObject4$l, _templateObject5$f, _templateObject6$b, _templateObject7$5;
var Lablel = styled.label(_templateObject$R || (_templateObject$R = _taggedTemplateLiteralLoose(["\n    input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n    }\n\n    input:checked ~ .checkmark {\n        border-color: ", ";\n        background: ", ";\n        color: ", ";\n\n        .fake-icon-round {\n            background-color: ", ";\n            border-color: ", ";\n        }\n\n        .fake-icon {\n            opacity: 1;\n        }\n    }\n\n    .fake-icon {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        margin: auto;\n    }\n"])), function (_ref) {
  var fillSelected = _ref.fillSelected,
    theme = _ref.theme;
  return fillSelected ? 'transparent' : theme.colors.primary;
}, function (_ref2) {
  var fillSelected = _ref2.fillSelected,
    theme = _ref2.theme;
  return fillSelected ? theme.colors.primaryBackground : 'inherit';
}, function (_ref3) {
  var fillSelected = _ref3.fillSelected,
    theme = _ref3.theme;
  return fillSelected ? theme.colors.primary : 'inherit';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
var KliSelectedSquareWrap = styled.div(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  padding: ", ";\n  transition: ", ";\n  background: ", ";\n  cursor: pointer;\n  border: 2px solid transparent;\n  align-items: center;\n}\n"])), function (_ref6) {
  var withContent = _ref6.withContent;
  return withContent ? '15px 60px 15px 15px' : '15px';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.transition["default"];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.canvas;
});
var CheckboxWrap = styled.div(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    height: 24px;\n    margin: auto;\n    right: 15px;\n    top: ", ";\n    bottom: ", ";\n"])), function (_ref9) {
  var selectorOnTop = _ref9.selectorOnTop;
  return selectorOnTop ? '15px' : 0;
}, function (_ref0) {
  var selectorOnTop = _ref0.selectorOnTop;
  return selectorOnTop ? 'auto' : 0;
});
var ImageWrap$1 = styled.div(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteralLoose(["\n    width: ", ";\n    padding: ", ";\n\n    img {\n        max-height: 100%;\n        max-width: 100%;\n    }\n"])), function (_ref1) {
  var withContent = _ref1.withContent;
  return withContent ? '' : '100%';
}, function (_ref10) {
  var withContent = _ref10.withContent;
  return withContent ? '0' : '10px';
});
var ContentWrap$1 = styled.div(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteralLoose(["\n    padding: 0 15px 0 15px;\n    width: ", ";\n"])), function (_ref11) {
  var withImg = _ref11.withImg;
  return withImg ? '75%' : '100%';
});
var Checkmark = styled.span(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteralLoose(["\n    display: block;\n    height: ", ";\n    width: ", ";\n    border-radius: 50%;\n    border: 2px solid ", ";\n    background-color: ", ";\n    transition: ", ";\n"])), function (_ref12) {
  var size = _ref12.size;
  return size ? size + 'px' : '28px';
}, function (_ref13) {
  var size = _ref13.size;
  return size ? size + 'px' : '28px';
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.primaryText;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.background;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.transition["default"];
});
var CheckmarkIcon = styled(function (props) {
  return /*#__PURE__*/React__default.createElement(SvgCheck, props);
})(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    opacity: 0;\n    color: ", ";\n    transition: ", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.canvas;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.transition["default"];
});

var _excluded$B = ["children", "selectorOnTop", "img", "fillSelected"];
var SelectableItem = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$selectorOnTop = _ref.selectorOnTop,
    selectorOnTop = _ref$selectorOnTop === void 0 ? false : _ref$selectorOnTop,
    img = _ref.img,
    _ref$fillSelected = _ref.fillSelected,
    fillSelected = _ref$fillSelected === void 0 ? false : _ref$fillSelected,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$B);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(Lablel, {
    theme: themeContext,
    fillSelected: fillSelected
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    type: "checkbox"
  }, rest, {
    ref: ref
  })), /*#__PURE__*/React__default.createElement(KliSelectedSquareWrap, {
    theme: themeContext,
    withContent: !!children,
    className: "checkmark"
  }, !!img && /*#__PURE__*/React__default.createElement(ImageWrap$1, {
    withContent: !!children
  }, img), !!children && /*#__PURE__*/React__default.createElement(ContentWrap$1, {
    withImg: !!img
  }, children), /*#__PURE__*/React__default.createElement(CheckboxWrap, {
    selectorOnTop: selectorOnTop
  }, /*#__PURE__*/React__default.createElement(Checkmark, {
    size: 22,
    theme: themeContext,
    className: "fake-icon-round"
  }), /*#__PURE__*/React__default.createElement(CheckmarkIcon, {
    theme: themeContext,
    className: "fake-icon"
  }))));
});

var _templateObject$S, _templateObject2$D;
var StyledAntdSlider = styled(Slider$1)(_templateObject$S || (_templateObject$S = _taggedTemplateLiteralLoose(["\n    && {\n        ", "\n    }\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return css(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteralLoose(["\n            & .ant-slider-track,\n            &:hover .ant-slider-track {\n                background-color: ", ";\n            }\n\n            & .ant-slider-handle {\n                width: 25px;\n                height: 25px;\n                top: 50%;\n                transform: translate(-50%, -50%) !important;\n                margin: 0;\n                background-color: #fff;\n                border: 2px solid #91d5ff;\n                border-radius: 50%;\n                box-shadow: none;\n                cursor: pointer;\n                position: absolute;\n                transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n\n                &:after {\n                    display: none;\n                }\n            }\n\n            & .ant-slider-handle,\n            &:hover .ant-slider-handle,\n            &:hover .ant-slider-handle:not(.ant-tooltip-open) {\n                border-color: ", ";\n            }\n\n            .ant-slider-handle:active {\n                border-color: ", ";\n                box-shadow: 0 0 0 5px rgb(242, 88, 88, 0.12);\n            }\n\n            .ant-slider-handle:focus {\n                box-shadow: 0 0 0 5px rgb(242, 88, 88, 0.12);\n            }\n        "])), $theme.colors.primaryText, $theme.colors.primaryText, $theme.colors.primary);
});

var _excluded$C = ["children"];
var Slider = function Slider(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$C);
  var isIos = device.iOS();
  var isSafari = device.isSafari();
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyleProvider, {
    hashPriority: isSafari && !isIos ? 'high' : 'low'
  }, /*#__PURE__*/React__default.createElement(StyledAntdSlider, _extends({
    $theme: themeContext
  }, props), children));
};

var _templateObject$T, _templateObject2$E;
var StyledAntdSwitch = styled(Switch$1)(_templateObject$T || (_templateObject$T = _taggedTemplateLiteralLoose(["\n    ", "\n"])), function (_ref) {
  var $theme = _ref.$theme,
    $checkedColor = _ref.$checkedColor;
  return css(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteralLoose(["\n        &.ant-switch:focus {\n            outline: none;\n            box-shadow: none;\n        }\n\n        &.ant-switch-checked {\n            background-color: ", ";\n        }\n    "])), $theme.colors[$checkedColor] ? $theme.colors[$checkedColor] : $theme.colors.primaryText);
});

var _excluded$D = ["children", "checkedColor"];
var Switch = function Switch(_ref) {
  var children = _ref.children,
    checkedColor = _ref.checkedColor,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$D);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledAntdSwitch, _extends({
    $theme: themeContext,
    $checkedColor: checkedColor
  }, props), children);
};

var _templateObject$U, _templateObject2$F;
var StyledTabs = styled(Tabs$2)(_templateObject$U || (_templateObject$U = _taggedTemplateLiteralLoose(["\n    ", "\n"])), function (_ref) {
  var $theme = _ref.$theme,
    $titleFont = _ref.$titleFont;
  return css(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteralLoose(["\n        & {\n            & .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n                color: ", ";\n            }\n\n            & .ant-tabs-tab-with-remove,\n            & .ant-tabs-tab-btn {\n                font: ", ";\n\n                &:hover {\n                    color: ", ";\n                }\n            }\n\n            & .ant-tabs-nav-add:hover .anticon {\n                color: ", ";\n            }\n\n            & .ant-tabs-ink-bar {\n                background-color: ", ";\n            }\n        }\n    "])), $theme.colors.primary, $theme.fonts[$titleFont] ? $theme.fonts[$titleFont] : $theme.fonts.badgeMedium, $theme.colors.primary, $theme.colors.primary, $theme.colors.primary);
});

var _excluded$E = ["titleFont"];
var Tabs = function Tabs(_ref) {
  var titleFont = _ref.titleFont,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$E);
  var themeContext = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(StyledTabs, _extends({
    $theme: themeContext,
    $titleFont: titleFont
  }, props));
};

var _templateObject$V;
var StyledIconWrapper = styled.div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 50%;\n    right: 21px;\n    height: 24px;\n    transform: translateY(-50%);\n    cursor: pointer;\n"])));

var TOOLTIP_TEXT = 'Card Verification Value 3-digit number on the back of your credit card';

var CvcQuestion = function CvcQuestion() {
  return /*#__PURE__*/React__default.createElement(StyledIconWrapper, null, /*#__PURE__*/React__default.createElement(Popover, {
    content: /*#__PURE__*/React__default.createElement("span", null, TOOLTIP_TEXT),
    placement: "left",
    type: "primary-black",
    maxWidth: "300px"
  }, /*#__PURE__*/React__default.createElement(SvgQuestion, null)));
};

var _Object$freeze, _StripePaymentTokenIn;
var StripePaymentTokenFields = Object.freeze({
  cardNumber: 'cardNumber',
  cardCvc: 'cardCvc',
  cardExpiry: 'cardExpiry'
});
var CardsIconByBrand = Object.freeze({
  visa: /*#__PURE__*/React__default.createElement(SvgVisa, null),
  mastercard: /*#__PURE__*/React__default.createElement(SvgMastercard, null),
  discover: /*#__PURE__*/React__default.createElement(SvgDiscover, null),
  amex: /*#__PURE__*/React__default.createElement(SvgAmex, null)
});
var StripePaymentTokenFieldsPlaceholders = Object.freeze((_Object$freeze = {}, _Object$freeze[StripePaymentTokenFields.cardNumber] = 'Card Number', _Object$freeze[StripePaymentTokenFields.cardCvc] = 'CVC', _Object$freeze[StripePaymentTokenFields.cardExpiry] = 'MM / YY', _Object$freeze));
var StripePaymentTokenInitialState = (_StripePaymentTokenIn = {}, _StripePaymentTokenIn[StripePaymentTokenFields.cardNumber] = {
  complete: false,
  error: null
}, _StripePaymentTokenIn[StripePaymentTokenFields.cardCvc] = {
  complete: false,
  error: null
}, _StripePaymentTokenIn[StripePaymentTokenFields.cardExpiry] = {
  complete: false,
  error: null
}, _StripePaymentTokenIn);
var StripePaymentTokenContext = /*#__PURE__*/createContext(StripePaymentTokenInitialState);

var _templateObject$W;
var StyledIcon$2 = styled(Icon)(_templateObject$W || (_templateObject$W = _taggedTemplateLiteralLoose(["\n    && {\n        position: absolute;\n        left: 25px;\n        top: 50%;\n        transform: translateY(-50%);\n        line-height: 1;\n        margin: auto;\n        z-index: 2;\n    }\n\n    && ~ .StripeElement {\n        padding-left: 65px !important;\n    }\n    && ~ span {\n        left: 40px;\n    }\n"])));

var _excluded$F = ["brand"];
var StripeCardIcon = function StripeCardIcon(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? '' : _ref$brand,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$F);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, CardsIconByBrand[brand.toLowerCase()] ? /*#__PURE__*/React__default.createElement(StyledIcon$2, _extends({
    size: "28px"
  }, rest, {
    component: function component() {
      return CardsIconByBrand[brand.toLowerCase()];
    }
  })) : /*#__PURE__*/React__default.createElement(StyledIcon$2, _extends({
    size: "22px",
    color: "secondaryText"
  }, rest, {
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCard, null);
    }
  })));
};

var StripeOptions = function StripeOptions(_ref) {
  var _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? 'Source Code Pro, monospace' : _ref$fontFamily,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'inherit' : _ref$fontSize,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#424770' : _ref$color,
    _ref$placeholderColor = _ref.placeholderColor,
    placeholderColor = _ref$placeholderColor === void 0 ? 'transparent' : _ref$placeholderColor,
    _ref$errorColor = _ref.errorColor,
    errorColor = _ref$errorColor === void 0 ? '#424770' : _ref$errorColor;
  return {
    style: {
      base: {
        fontSize: fontSize,
        color: color,
        letterSpacing: '0',
        fontFamily: fontFamily,
        '::placeholder': {
          color: placeholderColor
        }
      },
      invalid: {
        color: errorColor
      }
    }
  };
};

var _templateObject$X, _templateObject2$G;
var StyledField = styled.label(_templateObject$X || (_templateObject$X = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: block;\n    width: 100%;\n    min-width: 108px;\n    height: ", ";\n\n    & > * {\n        box-sizing: border-box;\n    }\n\n    && .StripeElement {\n        width: 100%;\n        border: 2px solid transparent;\n        transition: ", ";\n        padding: ", ";\n        height: ", ";\n        position: relative;\n        transition: ", ";\n        background-color: ", ";\n\n        & + span {\n            color: ", ";\n        }\n\n        &:not(.StripeElement--empty) {\n            & + span {\n                font: ", ";\n                top: -8px;\n            }\n        }\n    }\n\n    && .StripeElement--complete {\n        border-color: ", ";\n        border: 2px solid ", ";\n\n        & + span {\n            color: ", ";\n        }\n    }\n\n    && .StripeElement--empty {\n        background-color: ", ";\n    }\n\n    && .StripeElement--focus {\n        border: 2px solid ", ";\n        background-color: transparent;\n\n        & + span {\n            font: ", ";\n            top: -8px;\n        }\n    }\n\n    && .StripeElement--invalid {\n        border-color: ", ";\n        border: 2px solid ", ";\n\n        & + span {\n            color: ", ";\n        }\n    }\n\n    && .StripeElement--webkit-autofill {\n        color: transparent;\n    }\n"])), function (_ref) {
  var large = _ref.large;
  return large ? '64px' : '55px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition["default"];
}, function (_ref3) {
  var large = _ref3.large;
  return large ? '26px 24px 14px 24px' : '22px 24px 10px 24px';
}, function (_ref4) {
  var large = _ref4.large;
  return large ? '64px' : '55px';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.transition["default"];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.background;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.secondaryText;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fonts.descriptor2;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.success;
}, function (_ref0) {
  var theme = _ref0.theme;
  return theme.colors.success;
}, function (_ref1) {
  var theme = _ref1.theme;
  return theme.colors.success;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.background;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primaryText;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fonts.descriptor2;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.error;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.error;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.error;
});
var Placeholder$1 = styled.span(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    z-index: 3;\n\n    border: 2px solid transparent;\n\n    padding: ", ";\n    padding-left: ", ";\n\n    font: ", ";\n    transition: ", ";\n\n    pointer-events: none;\n    touch-action: none;\n"])), function (_ref16) {
  var large = _ref16.large;
  return large ? '18px 24px' : '14px 24px';
}, function (_ref17) {
  var withIcon = _ref17.withIcon;
  return withIcon ? '60px' : '24px';
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fonts.descriptor1;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.transition["default"];
});

var StripeInput = function StripeInput(_ref) {
  var _stripePaymentState$n, _stripePaymentState$n2;
  var name = _ref.name,
    children = _ref.children,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options,
    large = _ref.large,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? StripePaymentTokenFieldsPlaceholders[name] : _ref$placeholder;
  var _useState = useState(),
    brand = _useState[0],
    setBrand = _useState[1];
  var stripeOptions = _extends({}, StripeOptions({
    fontSize: '16px',
    fontFamily: 'IBM Plex Sans'
  }), options);
  var _useContext = useContext(StripePaymentTokenContext),
    stripePaymentState = _useContext.stripePaymentState,
    setStripePaymentState = _useContext.setStripePaymentState;
  var themeContext = useContext(KliThemeContext);
  var _onChange = useCallback(function (elementState) {
    var _extends2;
    return setStripePaymentState(_extends({}, stripePaymentState, (_extends2 = {}, _extends2[name] = elementState, _extends2)));
  }, [stripePaymentState, setStripePaymentState]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledField, {
    large: large ? 1 : 0,
    theme: themeContext
  }, name === StripePaymentTokenFields.cardNumber && /*#__PURE__*/React__default.createElement(StripeCardIcon, {
    brand: brand
  }), /*#__PURE__*/React__default.cloneElement(children, {
    onChange: function onChange(e) {
      setBrand(e.brand);
      _onChange(e);
    },
    options: stripeOptions
  }), /*#__PURE__*/React__default.createElement(Placeholder$1, {
    theme: themeContext,
    large: large ? 1 : 0
  }, placeholder)), ((_stripePaymentState$n = stripePaymentState[name]) === null || _stripePaymentState$n === void 0 ? void 0 : _stripePaymentState$n.error) && /*#__PURE__*/React__default.createElement(Typography.Text, {
    style: {
      paddingTop: '8px'
    },
    type: "descriptor2",
    color: "error"
  }, (_stripePaymentState$n2 = stripePaymentState[name]) === null || _stripePaymentState$n2 === void 0 ? void 0 : _stripePaymentState$n2.error.message));
};

var _excluded$G = ["options"];
var StripeCardInput = function StripeCardInput(_ref) {
  var options = _ref.options,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$G);
  return /*#__PURE__*/React__default.createElement(StripeInput, _extends({
    name: StripePaymentTokenFields.cardNumber,
    options: options
  }, rest), /*#__PURE__*/React__default.createElement(CardNumberElement, null));
};

var _templateObject$Y;
var StyledWrapper$4 = styled.div(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteralLoose(["\n    position: relative;\n"])));

var _excluded$H = ["options", "rootElementId"];
var StripeCVCInput = function StripeCVCInput(_ref) {
  var options = _ref.options,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$H);
  return /*#__PURE__*/React__default.createElement(StyledWrapper$4, null, /*#__PURE__*/React__default.createElement(StripeInput, _extends({
    name: StripePaymentTokenFields.cardCvc,
    options: options
  }, rest), /*#__PURE__*/React__default.createElement(CardCvcElement, null)), /*#__PURE__*/React__default.createElement(CvcQuestion, null));
};

var _excluded$I = ["options"];
var StripeExpDateInput = function StripeExpDateInput(_ref) {
  var options = _ref.options,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$I);
  return /*#__PURE__*/React__default.createElement(StripeInput, _extends({
    name: StripePaymentTokenFields.cardExpiry,
    options: options
  }, rest), /*#__PURE__*/React__default.createElement(CardExpiryElement, null));
};

var _excluded$J = ["children", "onToken", "onChange", "onTokenError", "onPending"];
var StripePaymentTokenProvider = function StripePaymentTokenProvider(_ref) {
  var children = _ref.children,
    _ref$onToken = _ref.onToken,
    onToken = _ref$onToken === void 0 ? function () {
      return null;
    } : _ref$onToken,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return null;
    } : _ref$onChange,
    _ref$onTokenError = _ref.onTokenError,
    onTokenError = _ref$onTokenError === void 0 ? function () {
      return null;
    } : _ref$onTokenError,
    _ref$onPending = _ref.onPending,
    onPending = _ref$onPending === void 0 ? function () {
      return null;
    } : _ref$onPending,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$J);
  var stripe = useStripe();
  var elements = useElements();
  var _useState = useState(StripePaymentTokenInitialState),
    stripePaymentState = _useState[0],
    setStripePaymentState = _useState[1];
  var _useState2 = useState(),
    pending = _useState2[0],
    setPending = _useState2[1];
  useEffect(function () {
    if (Object.values(stripePaymentState).some(function (element) {
      return !element.complete;
    })) {
      return onChange();
    }
    var cardElement = elements.getElement(CardNumberElement);
    if (!cardElement) {
      return;
    }
    var createPaymentToken = function createPaymentToken() {
      try {
        setPending(true);
        return Promise.resolve(stripe.createToken(cardElement)).then(function (_ref2) {
          var error = _ref2.error,
            token = _ref2.token;
          setPending(false);
          if (error) {
            return onTokenError(error);
          }
          if (token) {
            onToken(token);
          }
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    createPaymentToken();
  }, [stripePaymentState, stripe, elements, setPending, onToken, onTokenError]);
  useEffect(function () {
    onPending(pending);
  }, [pending, onPending]);
  return /*#__PURE__*/React__default.createElement(StripePaymentTokenContext.Provider, _extends({
    value: {
      stripePaymentState: stripePaymentState,
      setStripePaymentState: setStripePaymentState
    }
  }, rest), children);
};

var _excluded$K = ["children", "token"];
var StripeProvider = function StripeProvider(_ref) {
  var children = _ref.children,
    token = _ref.token,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$K);
  var themeContext = useContext(KliThemeContext);
  if (!window.____kliStripeInit) {
    loadStripe.setLoadParameters({
      advancedFraudSignals: false
    });
    window.____kliStripeInit = loadStripe(token);
  }
  var stripePromise = window.____kliStripeInit;
  var options = {
    fonts: [{
      cssSrc: themeContext.fontsSrc.sans
    }]
  };
  return /*#__PURE__*/React__default.createElement(Elements, _extends({
    stripe: stripePromise,
    options: options
  }, rest), children);
};

var ErrorsStore = types.model('ErrorsStore', {
  list: types.optional(types.array(types.model({
    key: types.string,
    value: types.string
  })), [])
}).views(function (self) {
  return {
    getError: function getError(key) {
      if (!(self.list && self.list.length)) {
        return null;
      }
      var error = self.list.find(function (error) {
        return error.key === key;
      });
      return error ? error.value : null;
    }
  };
}).actions(function (self) {
  return {
    addHttpError: function addHttpError(key, err) {
      if (err && err.response && err.response.data) {
        self.addError(key, err.response.data.message);
        return true;
      }
      if (err && err.message) {
        self.addError(key, err.message);
      }
    },
    addError: function addError(key, value) {
      if (self.getError(key)) {
        self.updateError(key, value);
      }
      self.list.push({
        key: key,
        value: value
      });
    },
    updateError: function updateError(key, value) {
      var index = self.list.findIndex(function (error) {
        return error.key === key;
      });
      if (index !== -1) {
        self.list[index].value = value;
      }
    },
    deleteError: function deleteError(key) {
      var index = self.list.findIndex(function (error) {
        return error.key === key;
      });
      if (index !== -1) {
        self.list.splice(index, 1);
      }
    }
  };
});

var getYouPayPrice = function getYouPayPrice(variant) {
  var _variant$priceDetails, _variant$priceDetails2;
  if (variant !== null && variant !== void 0 && (_variant$priceDetails = variant.priceDetails) !== null && _variant$priceDetails !== void 0 && _variant$priceDetails.youPayPrice || (variant === null || variant === void 0 ? void 0 : (_variant$priceDetails2 = variant.priceDetails) === null || _variant$priceDetails2 === void 0 ? void 0 : _variant$priceDetails2.youPayPrice) === 0) {
    var _variant$priceDetails3;
    return variant === null || variant === void 0 ? void 0 : (_variant$priceDetails3 = variant.priceDetails) === null || _variant$priceDetails3 === void 0 ? void 0 : _variant$priceDetails3.youPayPrice;
  }
  return variant === null || variant === void 0 ? void 0 : variant.price;
};

var getVariantByPrice = function getVariantByPrice(variants) {
  var variant = variants[0];
  variants.forEach(function (_variant) {
    var price = getYouPayPrice(variant);
    var _price = getYouPayPrice(_variant);
    variant = price < _price ? variant : _variant;
  });
  return variant;
};

var arrayIncludes = function arrayIncludes(sourceArray, searchArray) {
  if (!Array.isArray(sourceArray) || !Array.isArray(searchArray) || !sourceArray.length || !searchArray.length) return false;
  var _loop = function _loop() {
      var search = _step.value;
      var searchKeys = Object.keys(search);
      var exists = sourceArray.find(function (source) {
        for (var _i = 0, _searchKeys = searchKeys; _i < _searchKeys.length; _i++) {
          var searchKey = _searchKeys[_i];
          if (!source[searchKey] || source[searchKey] !== search[searchKey]) {
            return false;
          }
        }
        return true;
      });
      if (!exists) {
        return {
          v: false
        };
      }
    },
    _ret;
  for (var _iterator = _createForOfIteratorHelperLoose(searchArray), _step; !(_step = _iterator()).done;) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  return true;
};

var getTimeLeft = function getTimeLeft(date) {
  if (!date) {
    return null;
  }
  return new Date(date) - Date.now();
};

var formatTime = function formatTime(value) {
  if (typeof value !== 'number') return null;
  return value < 10 ? "0" + value : "" + value;
};

var msToDisplayFormat = function msToDisplayFormat(timeLeftInMilliseconds) {
  if (!timeLeftInMilliseconds || typeof timeLeftInMilliseconds !== 'number') {
    return null;
  }
  var timeLeftInSeconds = timeLeftInMilliseconds / 1000;
  if (timeLeftInSeconds <= 0) {
    return {
      days: formatTime(0),
      hours: formatTime(0),
      minutes: formatTime(0),
      seconds: formatTime(0)
    };
  }
  var d = Math.floor(timeLeftInSeconds / (3600 * 24));
  var h = Math.floor(timeLeftInSeconds % (3600 * 24) / 3600);
  var m = Math.floor(timeLeftInSeconds % 3600 / 60);
  var s = Math.floor(timeLeftInSeconds % 3600 % 60);
  return {
    days: formatTime(d),
    hours: formatTime(h),
    minutes: formatTime(m),
    seconds: formatTime(s)
  };
};

var getVariantImage = function getVariantImage(images, selectedVariant) {
  var variantImageId = selectedVariant ? selectedVariant.image : null;
  if (!images || !images.length || !variantImageId) {
    return {};
  }
  var index = images.findIndex(function (img) {
    return img.externalId === variantImageId;
  }) || 0;
  var image = images.find(function (img) {
    return img.externalId === variantImageId;
  }) || {};
  var imageSrc = image.src || '';
  return {
    index: index,
    image: image,
    imageSrc: imageSrc
  };
};

var round = function round(value, factor) {
  if (factor === void 0) {
    factor = 100;
  }
  return Math.round(value * factor) / factor;
};

var OptionsStore = types.model('OptionsStore', {
  list: types.array(types.model({
    name: types.string,
    position: types.number,
    selected: types.maybeNull(types.string),
    values: types.array(types.model({
      value: types.string,
      disabled: types["boolean"]
    }))
  })),
  notSelectedErrorVisible: false
}).views(function (self) {
  return {
    get product() {
      return getParent(self);
    },
    get allOptionsSelected() {
      return self.amountOptionsSelected === self.list.length;
    },
    get selectedOptions() {
      return self.list.reduce(function (acc, option) {
        if (option.selected) {
          acc.push({
            position: option.position,
            value: option.selected
          });
        }
        return acc;
      }, []);
    },
    get amountOptionsSelected() {
      return self.list.reduce(function (res, option) {
        var value = option.selected !== null ? 1 : 0;
        return res + value;
      }, 0);
    }
  };
}).actions(function (self) {
  return {
    selectOption: function selectOption(key, value) {
      self.list[key].selected = value;
      self.checkOptionsForDisabling();
      self.product.variants.checkStrictQty();
    },
    setOptions: function setOptions(options) {
      var _product$variants;
      var product = getSnapshot(self.product);
      var variants = product === null || product === void 0 ? void 0 : (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants.list;
      var hasDefaultVariant = variants === null || variants === void 0 ? void 0 : variants.find(function (item) {
        return item === null || item === void 0 ? void 0 : item.isDefault;
      });
      var variantOptions = [];
      if (hasDefaultVariant) {
        variantOptions.push.apply(variantOptions, hasDefaultVariant.options);
      }
      if (!hasDefaultVariant) {
        var _product$variants2;
        var cheapestVariant = getVariantByPrice(product === null || product === void 0 ? void 0 : (_product$variants2 = product.variants) === null || _product$variants2 === void 0 ? void 0 : _product$variants2.list);
        variantOptions.push.apply(variantOptions, cheapestVariant.options);
      }
      self.list = options.map(function (option) {
        var isSingleOption = option.values.length === 1;
        var variantOption = variantOptions.find(function (opt) {
          return opt.position === option.position;
        });
        var selectedValue = variantOption ? variantOption.value : isSingleOption ? option.values[0] : null;
        return {
          name: option.name,
          position: option.position,
          selected: selectedValue,
          values: option.values.map(function (value) {
            return {
              value: value,
              disabled: false
            };
          })
        };
      });
    },
    checkOptionsForDisabling: function checkOptionsForDisabling() {
      var variants = self.product.variants.list;
      __enableAllOptions(self.list);
      var otherSelectedOptions = self.list.reduce(function (acc, otherOption) {
        if (otherOption.selected) {
          acc.push({
            value: otherOption.selected,
            position: otherOption.position
          });
        }
        return acc;
      }, []);
      var _loop = function _loop() {
        var option = _step.value;
        option.values.forEach(function (value) {
          var possibleOption = {
            position: option.position,
            value: value.value
          };
          var possibleVariant = otherSelectedOptions.filter(function (element) {
            return element.position !== possibleOption.position;
          });
          possibleVariant.push(possibleOption);
          var anyVariantExists = variants.some(function (variant) {
            return arrayIncludes(variant.options, possibleVariant);
          });
          value.disabled = !anyVariantExists;
        });
      };
      for (var _iterator = _createForOfIteratorHelperLoose(self.list), _step; !(_step = _iterator()).done;) {
        _loop();
      }
    },
    toggleOptionsError: function toggleOptionsError(value) {
      self.notSelectedErrorVisible = value;
    }
  };
});
function __enableAllOptions(options) {
  options.forEach(function (option) {
    option.values.forEach(function (value) {
      value.disabled = false;
    });
  });
}

var VariantModel = types.model({
  externalId: types.number,
  isDefault: types.optional(types["boolean"], false),
  options: types.array(types.model({
    position: types.number,
    value: types.string
  })),
  title: types.string,
  image: types.maybeNull(types.number),
  quantity: types.number,
  strictQuantity: types.maybeNull(types.number),
  price: types.number,
  originalPrice: types.maybeNull(types.number),
  inCart: types.optional(types["boolean"], false),
  cashbackPrice: types.maybeNull(types.number),
  cashbackType: types.maybeNull(types.string),
  cashbackDetails: types.maybeNull(types.array(types.model({
    name: types.string,
    value: types.number
  }))),
  pointsDetails: types.maybeNull(types.model({
    maxPoints: types.number,
    isWelcome: types["boolean"],
    list: types.array(types.model({
      type: types.string,
      value: types.number
    }))
  })),
  priceDiscount: types.maybeNull(types.model({
    type: types.string,
    value: types.number
  })),
  rewards: types.maybe(types.maybeNull(types.array(types.model({
    _id: types.maybe(types.maybeNull(types.string)),
    title: types.maybe(types.maybeNull(types.string)),
    description: types.maybe(types.maybeNull(types.string)),
    image: types.maybe(types.maybeNull(types.string)),
    expireAt: types.maybe(types.maybeNull(types.string)),
    appliedTo: types.maybe(types.maybeNull(types.string)),
    amount: types.maybe(types.maybeNull(types.number)),
    rewardType: types.maybe(types.maybeNull(types.string)),
    isReferralSession: types.maybe(types["boolean"]),
    value: types.maybe(types.maybeNull(types.number))
  })))),
  priceDetails: types.maybe(types.maybeNull(types.model({
    originalPrice: types.maybeNull(types.number),
    rewardsPrice: types.maybeNull(types.number),
    rewardsPercent: types.maybeNull(types.number),
    youPayPrice: types.maybeNull(types.number)
  })))
});
var VariantsStore = types.model('VariantsStore', {
  list: types.array(VariantModel),
  loading: false,
  qty: 1
}).views(function (self) {
  return {
    get product() {
      return getParent(self);
    },
    get variantPrice() {
      var _self$currentVariantD;
      return (_self$currentVariantD = self.currentVariantData) === null || _self$currentVariantD === void 0 ? void 0 : _self$currentVariantD.price;
    },
    get originalPrice() {
      var _self$currentVariantD2, _self$currentVariantD3, _self$currentVariantD4, _self$currentVariantD5, _self$currentVariantD8;
      if ((_self$currentVariantD2 = self.currentVariantData) !== null && _self$currentVariantD2 !== void 0 && (_self$currentVariantD3 = _self$currentVariantD2.priceDetails) !== null && _self$currentVariantD3 !== void 0 && _self$currentVariantD3.originalPrice || ((_self$currentVariantD4 = self.currentVariantData) === null || _self$currentVariantD4 === void 0 ? void 0 : (_self$currentVariantD5 = _self$currentVariantD4.priceDetails) === null || _self$currentVariantD5 === void 0 ? void 0 : _self$currentVariantD5.originalPrice) === 0) {
        var _self$currentVariantD6, _self$currentVariantD7;
        return (_self$currentVariantD6 = self.currentVariantData) === null || _self$currentVariantD6 === void 0 ? void 0 : (_self$currentVariantD7 = _self$currentVariantD6.priceDetails) === null || _self$currentVariantD7 === void 0 ? void 0 : _self$currentVariantD7.originalPrice;
      }
      return (_self$currentVariantD8 = self.currentVariantData) === null || _self$currentVariantD8 === void 0 ? void 0 : _self$currentVariantD8.originalPrice;
    },
    get youPayPrice() {
      var _self$currentVariantD9, _self$currentVariantD0, _self$currentVariantD1, _self$currentVariantD10, _self$currentVariantD13;
      if ((_self$currentVariantD9 = self.currentVariantData) !== null && _self$currentVariantD9 !== void 0 && (_self$currentVariantD0 = _self$currentVariantD9.priceDetails) !== null && _self$currentVariantD0 !== void 0 && _self$currentVariantD0.youPayPrice || ((_self$currentVariantD1 = self.currentVariantData) === null || _self$currentVariantD1 === void 0 ? void 0 : (_self$currentVariantD10 = _self$currentVariantD1.priceDetails) === null || _self$currentVariantD10 === void 0 ? void 0 : _self$currentVariantD10.youPayPrice) === 0) {
        var _self$currentVariantD11, _self$currentVariantD12;
        return (_self$currentVariantD11 = self.currentVariantData) === null || _self$currentVariantD11 === void 0 ? void 0 : (_self$currentVariantD12 = _self$currentVariantD11.priceDetails) === null || _self$currentVariantD12 === void 0 ? void 0 : _self$currentVariantD12.youPayPrice;
      }
      return (_self$currentVariantD13 = self.currentVariantData) === null || _self$currentVariantD13 === void 0 ? void 0 : _self$currentVariantD13.price;
    },
    get getPriceDiscount() {
      var _self$currentVariantD14;
      return (_self$currentVariantD14 = self.currentVariantData) === null || _self$currentVariantD14 === void 0 ? void 0 : _self$currentVariantD14.priceDiscount;
    },
    get currentVariantData() {
      var currentVariant = self.currentVariant;
      var data = [].concat(getSnapshot(self.list));
      return data.find(function (variant) {
        return variant.externalId === currentVariant.externalId;
      });
    },
    get selectedVariant() {
      if (self.product.options.allOptionsSelected) {
        var selectedOptions = self.product.options.selectedOptions;
        var index = self.list.findIndex(function (variant) {
          return arrayIncludes(variant.options, selectedOptions);
        });
        return self.list[index];
      }
      return null;
    },
    get currentVariant() {
      if (self.selectedVariant) {
        return self.selectedVariant;
      }
      return self.list[0];
    },
    get minQty() {
      if (self.currentVariant.strictQuantity) {
        return self.currentVariant.strictQuantity;
      }
      return 1;
    },
    get maxQty() {
      if (self.currentVariant.strictQuantity) {
        return self.currentVariant.strictQuantity;
      }
      var variantQuantity = 0;
      if (self.selectedVariant) {
        variantQuantity = self.selectedVariant.quantity;
      } else {
        variantQuantity = Math.max.apply(Math, self.list.map(function (_ref) {
          var quantity = _ref.quantity;
          return quantity;
        }));
      }
      return Math.max(variantQuantity, 1);
    }
  };
}).actions(function (self) {
  return {
    onUpdateRewards: flow(/*#__PURE__*/_regenerator().m(function onUpdateRewards() {
      var _self$product, _self$product2, _self$product2$referr;
      var response, _response, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(typeof self.product.root.callbacks.calculatePromotionRewards === 'string')) {
              _context.n = 6;
              break;
            }
            self.loading = true;
            _context.p = 1;
            _context.n = 2;
            return self.product.root.callbacks.onCalculatePromotionRewards({
              qty: self.qty
            });
          case 2:
            response = _context.v;
            if (!(!response || !Array.isArray(response.variants))) {
              _context.n = 3;
              break;
            }
            return _context.a(2, null);
          case 3:
            response.variants.forEach(function (variantFromResponse) {
              var variant = self.list.find(function (v) {
                return v.externalId === variantFromResponse.externalId;
              });
              if (variant) {
                var _variantFromResponse$, _variantFromResponse$2, _variantFromResponse$3;
                variant.cashbackPrice = (_variantFromResponse$ = variantFromResponse.cashbackPrice) != null ? _variantFromResponse$ : null;
                variant.cashbackType = (_variantFromResponse$2 = variantFromResponse.cashbackType) != null ? _variantFromResponse$2 : null;
                variant.cashbackDetails = (_variantFromResponse$3 = variantFromResponse.cashbackDetails) != null ? _variantFromResponse$3 : null;
              }
            });
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error('Failed to load ', _t);
          case 5:
            _context.p = 5;
            self.loading = false;
            return _context.f(5);
          case 6:
            if (!(typeof self.product.root.callbacks.productQtyManage === 'string' && (_self$product = self.product) !== null && _self$product !== void 0 && _self$product.referralSession && !((_self$product2 = self.product) !== null && _self$product2 !== void 0 && (_self$product2$referr = _self$product2.referralSession) !== null && _self$product2$referr !== void 0 && _self$product2$referr.isExpired))) {
              _context.n = 12;
              break;
            }
            self.loading = true;
            _context.p = 7;
            _context.n = 8;
            return self.product.root.callbacks.onProductQtyManage({
              qty: self.qty
            });
          case 8:
            _response = _context.v;
            if (!(!_response || !Array.isArray(_response.variants))) {
              _context.n = 9;
              break;
            }
            return _context.a(2, null);
          case 9:
            _response.variants.forEach(function (variantFromResponse) {
              var variant = self.list.find(function (v) {
                return v.externalId === variantFromResponse.externalId;
              });
              if (variant) {
                var _variantFromResponse$4;
                variant.priceDiscount = (_variantFromResponse$4 = variantFromResponse.priceDiscount) != null ? _variantFromResponse$4 : null;
              }
            });
            _context.n = 11;
            break;
          case 10:
            _context.p = 10;
            _t2 = _context.v;
            console.error('Failed to load ', _t2);
          case 11:
            _context.p = 11;
            self.loading = false;
            return _context.f(11);
          case 12:
            return _context.a(2);
        }
      }, onUpdateRewards, null, [[7, 10, 11, 12], [1, 4, 5, 6]]);
    })),
    setQty: function setQty(value) {
      self.qty = value;
    },
    incrementQty: flow(/*#__PURE__*/_regenerator().m(function incrementQty() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            self.qty += 1;
            if (self.qty > self.maxQty) {
              self.qty = self.maxQty;
            }
            _context2.n = 1;
            return self.onUpdateRewards();
          case 1:
            return _context2.a(2);
        }
      }, incrementQty);
    })),
    decrementQty: flow(/*#__PURE__*/_regenerator().m(function decrementQty() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            self.qty -= 1;
            if (self.qty < 1) {
              self.qty = 1;
            }
            _context3.n = 1;
            return self.onUpdateRewards();
          case 1:
            return _context3.a(2);
        }
      }, decrementQty);
    })),
    setVariants: function setVariants(variants) {
      self.list = variants;
    },
    checkStrictQty: function checkStrictQty() {
      if (self.currentVariant.strictQuantity) {
        self.setQty(self.currentVariant.strictQuantity);
      }
    }
  };
});

var ProductStore = types.model('ProductStore', {
  isLoading: false,
  data: types.maybeNull(types.model({
    id: types.string,
    externalId: types.string,
    title: types.string,
    rating: types.maybeNull(types.number),
    campaignCommission: types.maybeNull(types.number),
    publisherCommission: types.maybeNull(types.model({
      customer: types.maybeNull(types.number)
    })),
    publisherEnableFlatCashback: types.maybeNull(types["boolean"]),
    hasReferralSession: types.maybeNull(types["boolean"]),
    publisherFlatCashbackPercentage: types.maybeNull(types.number),
    accountCommissions: types.maybeNull(types.model({
      limitNewColdCustomerCommission: types.maybeNull(types["boolean"]),
      coldCustomerCommission: types.maybeNull(types.number),
      newCustomerCommission: types.maybeNull(types.number),
      referralCommission: types.maybeNull(types.number)
    })),
    accountId: types.string,
    campaignId: types.string,
    campaignName: types.maybeNull(types.string),
    shopDomain: types.string,
    brandName: types.string,
    brandLink: types.string,
    description: types.string,
    images: types.array(types.model({
      src: types.string,
      externalId: types.number
    })),
    handle: types.string,
    priceDiscount: types.maybeNull(types.model({
      type: types.string,
      value: types.number
    })),
    metadata: types.maybeNull(types.array(types.frozen())),
    prices: types.array(types.model({
      name: types.string,
      enabled: types["boolean"],
      src: types.string
    })),
    pixels: types.array(types.model({
      name: types.string,
      src: types.string
    })),
    source: types.maybeNull(types.string)
  })),
  options: types.optional(OptionsStore, {}),
  variants: types.optional(VariantsStore, {}),
  referralSession: types.maybeNull(types.model({
    expiresAt: types.maybeNull(types.string),
    isExpired: types.maybeNull(types["boolean"]),
    rewardPercentage: types.maybeNull(types.number),
    referrer: types.maybeNull(types.model({
      firstName: types.maybeNull(types.string),
      lastName: types.maybeNull(types.string),
      email: types.maybeNull(types.string)
    }))
  }))
}).views(function (self) {
  return {
    get root() {
      return getParent(self);
    },
    getData: function getData(field, defaultValue) {
      if (defaultValue === void 0) {
        defaultValue = null;
      }
      return self.data[field] !== undefined ? self.data[field] : defaultValue;
    },
    get prices() {
      var _self$variants$curren = self.variants.currentVariant,
        price = _self$variants$curren.price,
        originalPrice = _self$variants$curren.originalPrice;
      var prices = {
        price: round(price * self.variants.qty),
        originalPrice: round(originalPrice * self.variants.qty),
        priceNoQty: price,
        originalPriceNoQty: originalPrice
      };
      if (!prices.originalPrice || prices.originalPrice < prices.price) {
        prices.originalPrice = prices.price;
        prices.originalPriceNoQty = prices.priceNoQty;
      }
      var _ref = self.data.priceDiscount || {},
        type = _ref.type,
        value = _ref.value;
      if (type && value !== null) {
        var discountPrice = prices.price;
        if (type === 'rate') {
          discountPrice = round(prices.price - value);
        }
        if (type === 'percent') {
          discountPrice = round(prices.price - prices.price * (value / 100));
        }
        if (type === 'set') {
          discountPrice = value;
        }
        if (discountPrice > prices.price) {
          discountPrice = prices.price;
        }
        if (discountPrice !== prices.price) {
          if (!prices.originalPrice || prices.originalPrice < prices.price) {
            prices.originalPrice = prices.price;
            prices.originalPriceNoQty = prices.priceNoQty;
          }
          prices.price = discountPrice;
        }
      }
      return prices;
    },
    get pointsValue() {
      var pointsDetails = self.variants.currentVariant.pointsDetails;
      if (pointsDetails) {
        if (self.variants.qty === 1) {
          return pointsDetails.maxPoints;
        }
        var qtyPoints = pointsDetails.list.map(function (l) {
          if (l.type === 'percent') {
            return self.variants.qty * l.value;
          }
          return l.value;
        });
        if (!qtyPoints.length) {
          return null;
        }
        return Math.max.apply(Math, qtyPoints);
      }
      return null;
    },
    get pointsIsWelcome() {
      var pointsDetails = self.variants.currentVariant.pointsDetails;
      return (pointsDetails === null || pointsDetails === void 0 ? void 0 : pointsDetails.isWelcome) || null;
    },
    get metadata() {
      var data = [];
      if (self.root.metadata) {
        data = data.concat(self.root.metadata);
      }
      if (self.data.metadata) {
        data = data.concat(self.data.metadata);
      }
      return data;
    },
    get requestPayload() {
      var _self$variants$select, _self$variants$select2;
      var rewardsPrice = (_self$variants$select = self.variants.selectedVariant) === null || _self$variants$select === void 0 ? void 0 : (_self$variants$select2 = _self$variants$select.priceDetails) === null || _self$variants$select2 === void 0 ? void 0 : _self$variants$select2.rewardsPrice;
      var metadataWithReward = [].concat(self.metadata);
      if (rewardsPrice != null) {
        metadataWithReward.push({
          name: 'displayedRewardAmount',
          value: rewardsPrice * self.variants.qty
        });
      }
      return {
        testMode: self.root.testMode,
        productId: self.data.id,
        variantId: self.variants.selectedVariant.externalId,
        qty: self.variants.qty,
        prices: self.prices,
        metadata: metadataWithReward,
        redirects: self.root.redirects
      };
    },
    get optionsList() {
      return self.options.list.filter(function (option) {
        return !(option.name === 'Title' && option.values.length === 1 && option.values[0].value === 'Default Title');
      });
    },
    get notSelectedOptionsErrorVisible() {
      return self.options.notSelectedErrorVisible;
    },
    get trackingData() {
      var _self$variants$select3;
      return {
        id: self.data.id,
        externalId: self.data.externalId,
        title: self.data.title,
        accountId: self.data.accountId,
        campaignId: self.data.campaignId,
        campaignName: self.data.campaignName,
        shopDomain: self.data.shopDomain,
        selectedVariantId: (_self$variants$select3 = self.variants.selectedVariant) === null || _self$variants$select3 === void 0 ? void 0 : _self$variants$select3.externalId,
        pixels: self.data.pixels,
        version: self.data.source
      };
    }
  };
}).actions(function (self) {
  return {
    markLoading: function markLoading(loading) {
      self.isLoading = loading;
    },
    loadProduct: flow(/*#__PURE__*/_regenerator().m(function loadProduct() {
      var data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            self.root.markLoading(true);
            _context.n = 1;
            return self.root.callbacks.onProductFetch();
          case 1:
            data = _context.v;
            if (!data.hasReferralSession) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return self.root.callbacks.onGetRefereeSession();
          case 2:
            self.referralSession = _context.v;
          case 3:
            self.data = data;
            self.variants.setVariants(data.variants);
            self.variants.checkStrictQty();
            self.options.setOptions(data.options);
            self.root.markLoading(false);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.log(_t);
            self.root.view.setRoute('unavailable');
          case 5:
            return _context.a(2);
        }
      }, loadProduct, null, [[0, 4]]);
    })),
    onGetRefereeSession: flow(/*#__PURE__*/_regenerator().m(function onGetRefereeSession() {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return self.root.callbacks.onGetRefereeSession();
          case 1:
            self.referralSession = _context2.v;
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            self.root.errors.addHttpError('httpProductError', _t2);
          case 3:
            return _context2.a(2);
        }
      }, onGetRefereeSession, null, [[0, 2]]);
    })),
    addToCart: flow(function addToCart(_ref2) {
      var onOptionsErrorCallback = _ref2.onOptionsErrorCallback,
        onAddToCartSuccessCallback = _ref2.onAddToCartSuccessCallback;
      return /*#__PURE__*/_regenerator().m(function _callee() {
        var _response$data, response, _response$data2, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!self.root.view.customizations.buttons.addToCartClickOutsideRedirectLink) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, window.open(self.root.view.customizations.buttons.addToCartClickOutsideRedirectLink, '_blank'));
            case 1:
              _context3.p = 1;
              self.markLoading(true);
              self.root.errors.deleteError('httpProductError');
              if (!self.options.allOptionsSelected) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return self.root.callbacks.onAddToCart(self.requestPayload, self.trackingData);
            case 2:
              response = _context3.v;
              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.token) {
                LocalStorage.set('x-klickly-cart-token', response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.token);
              }
              self.variants.selectedVariant.inCart = true;
              typeof onAddToCartSuccessCallback === 'function' && self.root.view.customizations.showAddedToCartModal ? onAddToCartSuccessCallback() : null;
              _context3.n = 4;
              break;
            case 3:
              self.options.toggleOptionsError(true);
              typeof onOptionsErrorCallback === 'function' ? onOptionsErrorCallback() : null;
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t3 = _context3.v;
              self.root.errors.addHttpError('httpProductError', _t3);
            case 6:
              self.markLoading(false);
            case 7:
              return _context3.a(2);
          }
        }, _callee, null, [[1, 5]]);
      })();
    }),
    buyNow: flow(function buyNow(_ref3) {
      var onOptionsErrorCallback = _ref3.onOptionsErrorCallback;
      return /*#__PURE__*/_regenerator().m(function _callee2() {
        var _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              self.markLoading(true);
              self.root.errors.deleteError('httpProductError');
              _context4.p = 1;
              if (!self.options.allOptionsSelected) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return self.root.callbacks.onBuyNow(self.requestPayload, getSnapshot(self.variants.selectedVariant), self.trackingData);
            case 2:
              _context4.n = 4;
              break;
            case 3:
              self.options.toggleOptionsError(true);
              typeof onOptionsErrorCallback === 'function' ? onOptionsErrorCallback() : null;
              self.markLoading(false);
            case 4:
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t4 = _context4.v;
              self.root.errors.addHttpError('httpProductError', _t4);
              self.markLoading(false);
            case 6:
              return _context4.a(2);
          }
        }, _callee2, null, [[1, 5]]);
      })();
    }),
    onCancel: flow(/*#__PURE__*/_regenerator().m(function onCancel() {
      var _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            self.markLoading(true);
            _context5.p = 1;
            _context5.n = 2;
            return self.root.callbacks.onCancel();
          case 2:
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            console.error('Failed to load ', _t5);
            self.markLoading(false);
          case 4:
            return _context5.a(2);
        }
      }, onCancel, null, [[1, 3]]);
    })),
    showConfirmAddToCartModal: function showConfirmAddToCartModal(_ref4) {
      var onOptionsErrorCallback = _ref4.onOptionsErrorCallback,
        onSuccess = _ref4.onSuccess;
      if (self.options.allOptionsSelected) {
        onSuccess();
      } else {
        self.options.toggleOptionsError(true);
        typeof onOptionsErrorCallback === 'function' ? onOptionsErrorCallback() : null;
      }
    }
  };
});

var reviewModel = types.model({
  _id: types.identifier,
  customerFullName: types.string,
  customer: types.maybe(types.string),
  createdAt: types.maybe(types.string),
  rating: types.number,
  title: types.maybe(types.string),
  content: types.maybe(types.string),
  images: types.maybe(types.array(types.model({
    position: types.number,
    src: types.string
  })))
});
var paginationMetaModel = types.model({
  currentPage: types.number,
  firstPage: types.number,
  hasNextPage: types["boolean"],
  hasPreviousPage: types["boolean"],
  lastPage: types.number,
  nextPage: types.number,
  previousPage: types.number,
  totalDocuments: types.number,
  totalPages: types.number
});
var ReviewsStore = types.model('ReviewsStore', {
  isLoading: false,
  isWriting: false,
  activeReviewId: types.maybeNull(types.string),
  meta: types.maybeNull(paginationMetaModel),
  data: types.maybeNull(types.array(reviewModel)),
  page: 1,
  totalPages: 1,
  errorMessage: types.maybeNull(types.string),
  limit: 3
}).views(function (self) {
  return {
    get root() {
      return getParent(self);
    },
    get loading() {
      return self.isLoading;
    },
    get writing() {
      return self.isWriting;
    },
    get reviews() {
      return self.data ? self.data : null;
    },
    getActiveReview: function getActiveReview() {
      return self.activeReviewId ? self.data.find(function (review) {
        return review._id === self.activeReviewId;
      }) : null;
    }
  };
}).actions(function (self) {
  return {
    markLoading: function markLoading(loading) {
      self.isLoading = loading;
    },
    markWriting: function markWriting(writing) {
      self.isWriting = writing;
    },
    loadReviews: flow(/*#__PURE__*/_regenerator().m(function loadReviews(isNextPage) {
      var _self$data;
      var response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            self.markLoading(true);
            if (self.data && ((_self$data = self.data) === null || _self$data === void 0 ? void 0 : _self$data.length) === 3) {
              self.data = null;
              self.limit = 10;
            }
            if (self.data && isNextPage && self.page !== self.totalPages) {
              self.page = self.page + 1;
            }
            _context.p = 1;
            _context.n = 2;
            return self.root.callbacks.onReviewsFetch("?page=" + self.page + "&limit=" + self.limit);
          case 2:
            response = _context.v;
            self.meta = response.meta;
            self.totalPages = response.meta.totalPages;
            self.data = (self.data || []).concat(response.data);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error("Failed to load ", _t);
          case 4:
            _context.p = 4;
            self.markLoading(false);
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, loadReviews, null, [[1, 3, 4, 5]]);
    })),
    writeReview: flow(/*#__PURE__*/_regenerator().m(function writeReview(fd, callback, submitChallenge) {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            self.errorMessage = null;
            _context2.p = 1;
            submitChallenge();
            fd.append('promotion', self.root.product.getData('id'));
            fd.append('account', self.root.product.getData('accountId'));
            fd.append('externalProductId', self.root.product.getData('externalId'));
            self.markWriting(true);
            _context2.n = 2;
            return self.root.callbacks.onReviewsWrite(fd);
          case 2:
            callback();
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            self.errorMessage = _t2.message;
          case 4:
            _context2.p = 4;
            self.markWriting(false);
            return _context2.f(4);
          case 5:
            return _context2.a(2);
        }
      }, writeReview, null, [[1, 3, 4, 5]]);
    })),
    showReview: function showReview(id) {
      self.activeReviewId = id;
      self.root.view.setRoute('review');
    },
    backToPDP: function backToPDP() {
      self.activeReviewId = null;
      self.root.view.setRoute('pdp');
    }
  };
});

var UpsellStore = types.model('UpsellStore', {
  upsellEndDate: types.optional(types.string, '')
}).views(function (self) {
  return {
    get root() {
      return getParent(self);
    },
    get endDate() {
      return self.upsellEndDate;
    }
  };
});

var ViewStore = types.model({
  route: types.string,
  type: types.optional(types.string, 'default'),
  customizations: types.optional(types.model({
    rootAppName: types.maybeNull(types.string),
    marketplaceLink: types.maybeNull(types.string),
    showAddedToCartModal: types.optional(types["boolean"], true),
    showAddToCartConfirmModal: types.optional(types["boolean"], false),
    buttons: types.optional(types.model({
      buyNowButtonLabel: types.optional(types.string, 'Buy now'),
      addToCartButtonLabel: types.optional(types.string, 'Add to cart'),
      cancelButtonLabel: types.optional(types.string, 'I’ll pass'),
      showBuyNowButton: types.optional(types["boolean"], true),
      showAddToCartButton: types.optional(types["boolean"], true),
      showBuyNowButtonGiftIcon: types.optional(types["boolean"], false),
      showBuyNowButtonBagIcon: types.optional(types["boolean"], false),
      showAddToCartButtonIcon: types.optional(types["boolean"], true),
      showAddToCartButtonGiftIcon: types.optional(types["boolean"], false),
      pdpButtonsDirection: types.optional(types.string, 'row'),
      continueShoppingButtonLabel: types.optional(types.string, 'Continue shopping'),
      addToCartClickOutsideRedirectLink: types.maybeNull(types.string)
    }), {}),
    prices: types.optional(types.model({
      originalPriceLabel: types.optional(types.string, 'Market price'),
      discountLabel: types.optional(types.string, 'You save'),
      dealPriceLabel: types.optional(types.string, 'You pay')
    }), {}),
    rewards: types.optional(types.model({
      showRewards: types.optional(types["boolean"], false),
      color: types.optional(types.string, 'primaryColor')
    }), {}),
    points: types.optional(types.model({
      showPoints: types.optional(types["boolean"], false),
      pointsLabel: types.optional(types.string, 'Members earn')
    }), {}),
    cashBack: types.optional(types.model({
      showCashBack: types.optional(types["boolean"], false),
      color: types.optional(types.string, 'primary')
    }), {}),
    reviews: types.optional(types.model({
      showReviews: types.optional(types["boolean"], false)
    }), {}),
    referral: types.optional(types.model({
      showBanner: types.optional(types["boolean"], false)
    }), {})
  }), {}),
  appWidth: types.maybeNull(types.number),
  isLoggedIn: types.maybe(types["boolean"])
}).views(function (self) {
  return {
    isSimple: function isSimple(size) {
      return size > self.appWidth;
    },
    isUpsell: function isUpsell() {
      return self.type === 'upsell';
    },
    withGSConfirmModal: function withGSConfirmModal() {
      return self.customizations.showAddToCartConfirmModal;
    }
  };
}).actions(function (self) {
  return {
    setRoute: function setRoute(route) {
      self.route = route;
    },
    setAppWidth: function setAppWidth(width) {
      self.appWidth = width;
    }
  };
});

var RootStore = types.model('RootStore', {
  isLoading: true,
  product: types.optional(ProductStore, {}),
  variants: types.optional(VariantsStore, {}),
  options: types.optional(OptionsStore, {}),
  reviews: types.optional(ReviewsStore, {}),
  upsell: types.optional(UpsellStore, {}),
  view: types.optional(ViewStore, {
    route: 'pdp'
  }),
  notifications: types.maybeNull(types.frozen()),
  errors: ErrorsStore
})["volatile"](function () {
  return {
    useOnProductReviewSubmit: types["function"],
    useProductReviewNotification: types["function"]
  };
}).views(function (self) {
  return {
    get testMode() {
      return getEnv(self).testMode;
    },
    get callbacks() {
      return getEnv(self).callbacks;
    },
    get metadata() {
      return getEnv(self).metadata;
    },
    get redirects() {
      return getEnv(self).redirects;
    }
  };
}).actions(function (self) {
  return {
    afterCreate: function afterCreate() {
      self.product.loadProduct();
    },
    markLoading: function markLoading(loading) {
      self.isLoading = loading;
    },
    setHooks: function setHooks(useOnProductReviewSubmit, useProductReviewNotification, notificationMessages) {
      self.notifications = notificationMessages;
      self.useOnProductReviewSubmit = useOnProductReviewSubmit;
      self.useProductReviewNotification = useProductReviewNotification;
    }
  };
});

var COLORS = {
  $white: '#FFFFFF',
  $border: '#D2D6DA',
  $background: '#F4F4F4',
  $bordered: '#DCDCDC',
  $shadow: '0px 8px 40px rgba(0, 0, 0, 0.16)',
  $tartRed: '#FFEBEB',
  $primary: '#F25858',
  $primaryLight: '#FFEBEB',
  $primaryText: '#04080F',
  $error: '#EF2E2E',
  $success: '#1CA355',
  $secondaryText: '#77838F',
  $info: '#33B6DF'
};

var GRID_POINTS$1 = Object.freeze({
  xxs: 370,
  xs: 480,
  sm: 680,
  md: 850,
  lg: 950,
  xl: 1100,
  xxl: 1600
});

var StyledIcon$3 = styled(Icon).withConfig({
  displayName: "StyledIcon",
  componentId: "sc-vuihnu-0"
})(["height:20px;"]);

var _templateObject$Z, _templateObject2$H, _templateObject3$q, _templateObject4$m;
var StyledImage = styled(Image).withConfig({
  displayName: "StyledImage",
  componentId: "sc-16ad26w-0"
})(["width:100%;object-fit:contain;", ";", ";", ";"], function (_ref) {
  var $preview = _ref.$preview;
  return !$preview ? css(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteralLoose(["\n                  max-height: 500px;\n              "]))) : css(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteralLoose(["\n                  max-height: 60px;\n              "])));
}, function (_ref2) {
  var $appWidth = _ref2.$appWidth;
  return $appWidth <= GRID_POINTS$1.sm ? css(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteralLoose(["\n                  max-height: 400px;\n              "]))) : '';
}, function (_ref3) {
  var $appWidth = _ref3.$appWidth;
  return $appWidth <= GRID_POINTS$1.xs ? css(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteralLoose(["\n                  max-height: 238px;\n              "]))) : '';
});

var _templateObject$_, _templateObject2$I;
var StyledImgWrapper = styled.div.withConfig({
  displayName: "StyledImgWrapper",
  componentId: "sc-1ncsk97-0"
})(["width:425px;padding-right:64px;padding-left:44px;", ";", ";"], function (_ref) {
  var $appWidth = _ref.$appWidth;
  return $appWidth <= GRID_POINTS$1.md ? css(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteralLoose(["\n                  width: 300px;\n                  padding-right: 64px;\n                  padding-left: 44px;\n              "]))) : '';
}, function (_ref2) {
  var $appWidth = _ref2.$appWidth;
  return $appWidth <= GRID_POINTS$1.sm ? css(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteralLoose(["\n                  width: 100%;\n                  padding: 0 38px;\n              "]))) : '';
});

var _templateObject$$;
var StyledSliderWrap = styled.div.withConfig({
  displayName: "StyledSliderWrap",
  componentId: "sc-6aqzs6-0"
})(["width:100%;position:relative;margin-bottom:20px;", ";"], function (_ref) {
  var $appWidth = _ref.$appWidth;
  return $appWidth <= GRID_POINTS$1.md ? css(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteralLoose(["\n                  padding-bottom: 30px;\n              "]))) : '';
});

var StyledViewGalleryButton = styled(Button).withConfig({
  displayName: "StyledViewGalleryButton",
  componentId: "sc-1k2tli0-0"
})(["&&{position:absolute;left:0;bottom:0;padding-left:0;}"]);

var _templateObject$10, _templateObject2$J;
var Styles = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-u5l7g8-0"
})(["position:relative;max-width:630px;max-height:600px;width:100%;background-color:", ";", ""], COLORS.$white, function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n                  max-height: 100%;\n                  height: 100%;\n              "]))) : '';
});
var HeaderStyles = styled.div.withConfig({
  displayName: "styles__HeaderStyles",
  componentId: "sc-u5l7g8-1"
})(["border-bottom:1px solid ", ";"], COLORS.$background);
var HeaderButtonStyles = styled.div.withConfig({
  displayName: "styles__HeaderButtonStyles",
  componentId: "sc-u5l7g8-2"
})(["display:flex;justify-content:space-between;align-items:center;padding:10px 0;"]);
var BodyStyles = styled.div.withConfig({
  displayName: "styles__BodyStyles",
  componentId: "sc-u5l7g8-3"
})(["padding:40px;overflow:hidden;background-color:", ";", ";"], COLORS.$white, function (_ref2) {
  var simple = _ref2.simple;
  return !simple ? css(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteralLoose(["\n                  min-width: 400px;\n              "]))) : '';
});
var GalleryImageWrap = styled.div.withConfig({
  displayName: "styles__GalleryImageWrap",
  componentId: "sc-u5l7g8-4"
})(["height:100%;display:flex;justify-content:center;align-items:center;margin-bottom:", ";> img{margin:0 auto;}"], function (_ref3) {
  var simple = _ref3.simple;
  return simple ? '50px' : '20px';
});
var GalleryImage = styled(Image).withConfig({
  displayName: "styles__GalleryImage",
  componentId: "sc-u5l7g8-5"
})(["max-width:100%;max-height:500px;object-fit:contain;"]);
var CloseModalIcon = styled(Icon).withConfig({
  displayName: "styles__CloseModalIcon",
  componentId: "sc-u5l7g8-6"
})(["&&{position:absolute;bottom:100%;left:50%;margin-bottom:24px;font-size:24px;transform:translate3d(-50%,0,0);}"]);

var Gallery = function Gallery(_ref) {
  var images = _ref.images,
    _ref$initialSlide = _ref.initialSlide,
    initialSlide = _ref$initialSlide === void 0 ? 0 : _ref$initialSlide,
    onClose = _ref.onClose,
    _ref$simple = _ref.simple,
    simple = _ref$simple === void 0 ? false : _ref$simple;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Styles, {
    simple: simple
  }, /*#__PURE__*/React__default.createElement(HeaderStyles, null, /*#__PURE__*/React__default.createElement(CloseModalIcon, {
    "data-e2e": "pdp_close-images-modal_btn",
    color: "canvas",
    onClick: onClose,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  }), simple ? /*#__PURE__*/React__default.createElement(HeaderButtonStyles, null, /*#__PURE__*/React__default.createElement(Button, {
    type: "unstyled",
    onClick: onClose,
    "data-e2e": "pdp_product-details_btn"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBackArrow, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "Product details")), /*#__PURE__*/React__default.createElement(Button, {
    type: "unstyled",
    onClick: onClose,
    "data-e2e": "pdp_close-product-details_btn"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  }))) : null), /*#__PURE__*/React__default.createElement(BodyStyles, {
    simple: simple,
    "data-e2e": "pdp_product-images_modal"
  }, /*#__PURE__*/React__default.createElement(Carousel, {
    initialSlide: initialSlide,
    bottomControls: {
      justify: 'space-between',
      off: images.length < 2
    }
  }, Boolean(images && images.length) && images.map(function (image, index) {
    return /*#__PURE__*/React__default.createElement(GalleryImageWrap, {
      simple: simple,
      key: index,
      id: index
    }, /*#__PURE__*/React__default.createElement(GalleryImage, {
      src: image.src,
      "data-e2e": "pdp_checked-product-image-" + index + "_image"
    }));
  })))));
};

var useGalleryModal = function useGalleryModal(simple) {
  if (simple === void 0) {
    simple = false;
  }
  var _useModal = useModal(),
    setModal = _useModal.setModal,
    hideModal = _useModal.hideModal;
  return useCallback(function (images, mainImageIndex) {
    setModal(/*#__PURE__*/React__default.createElement(Gallery, {
      images: images,
      initialSlide: mainImageIndex,
      onClose: hideModal,
      simple: simple
    }), {
      fullscreen: simple,
      closable: false
    });
  }, [setModal, hideModal, simple]);
};

var ProductImage = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var _useState = useState(0),
    mainImageIndex = _useState[0],
    setMainImageIndex = _useState[1];
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var appWidth = store.view.appWidth;
  var images = store.product.getData('images', []);
  var selectedVariant = store.product.variants.selectedVariant;
  var carouselRef = useRef(null);
  useEffect(function () {
    var _getVariantImage = getVariantImage(images, selectedVariant),
      index = _getVariantImage.index;
    setMainImageIndex(index || 0);
    if (carouselRef !== null && carouselRef !== void 0 && carouselRef.current) carouselRef.current.goTo(index || 0);
  }, [selectedVariant]);
  var openGallery = useGalleryModal(simple);
  var showDots = images && images.length && images.length < 10;
  return /*#__PURE__*/React__default.createElement(StyledImgWrapper, {
    $appWidth: appWidth
  }, !simple ? /*#__PURE__*/React__default.createElement(StyledSliderWrap, null, /*#__PURE__*/React__default.createElement(Carousel.WithPreview, {
    afterChange: function afterChange(index) {
      return setMainImageIndex(index);
    },
    carouselRef: carouselRef,
    previews: Boolean(images && images.length) && images.map(function (image, key) {
      return /*#__PURE__*/React__default.createElement(StyledImage, {
        $preview: true,
        $appWidth: appWidth,
        key: key,
        src: image.src,
        "data-e2e": "pdp_product-image-" + (key + 1) + "_value"
      });
    })
  }, Boolean(images && images.length) && images.map(function (image, key) {
    return /*#__PURE__*/React__default.createElement(StyledImage, {
      $appWidth: appWidth,
      key: key,
      src: image.src,
      "data-e2e": "pdp_product-main-image_value",
      onClick: function onClick() {
        return openGallery(images, key);
      }
    });
  }))) : /*#__PURE__*/React__default.createElement(StyledSliderWrap, {
    $appWidth: appWidth
  }, /*#__PURE__*/React__default.createElement(Carousel, {
    afterChange: function afterChange(index) {
      return setMainImageIndex(index);
    },
    dots: showDots ? {
      bottom: '-4px'
    } : false,
    arrows: true,
    carouselRef: carouselRef
  }, Boolean(images && images.length) && images.map(function (image, key) {
    return /*#__PURE__*/React__default.createElement(StyledImage, {
      $appWidth: appWidth,
      key: key,
      src: image.src,
      onClick: function onClick() {
        return openGallery(images, key);
      }
    });
  })), /*#__PURE__*/React__default.createElement(StyledViewGalleryButton, {
    type: "unstyled",
    onClick: function onClick() {
      return openGallery(images, mainImageIndex);
    },
    "data-e2e": "pdp_view-gallery_btn"
  }, /*#__PURE__*/React__default.createElement(StyledIcon$3, {
    size: "16px",
    marginRight: "6px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgImage, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "View gallery"))));
}));

var ErrorFieldStyles = styled.div.withConfig({
  displayName: "styles__ErrorFieldStyles",
  componentId: "sc-1g2of7b-0"
})(["display:flex;align-items:center;"]);
var ErrorFieldIcon = styled(Icon).withConfig({
  displayName: "styles__ErrorFieldIcon",
  componentId: "sc-1g2of7b-1"
})(["padding:0 16px 0 0;"]);

var ErrorField = function ErrorField(_ref) {
  var error = _ref.error,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertInfo, null) : _ref$icon,
    _ref$textType = _ref.textType,
    textType = _ref$textType === void 0 ? 'descriptor2' : _ref$textType;
  return /*#__PURE__*/React__default.createElement(ErrorFieldStyles, {
    style: BOTTOM_INDENTS.SM
  }, showIcon && /*#__PURE__*/React__default.createElement(ErrorFieldIcon, {
    color: "error",
    size: "130%",
    component: function component() {
      return icon;
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    color: "error",
    type: textType,
    "data-e2e": "pdp_error_message"
  }, error));
};

var getSelectedVariantTitle = function getSelectedVariantTitle(selectedVariant) {
  if (!selectedVariant || !selectedVariant.title || selectedVariant.title === 'Default Title') return '';
  return selectedVariant.title;
};

var _templateObject$11, _templateObject2$K;
var Styles$1 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-2riudz-0"
})(["background-color:", ";position:relative;"], COLORS.$white);
var WrapStyles = styled.div.withConfig({
  displayName: "styles__WrapStyles",
  componentId: "sc-2riudz-1"
})(["max-width:630px;width:100%;", ";"], function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? css(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n                  height: 100%;\n              "]))) : '';
});
var HeadStyles = styled.div.withConfig({
  displayName: "styles__HeadStyles",
  componentId: "sc-2riudz-2"
})(["position:relative;width:100%;height:92px;background-color:", ";display:flex;justify-content:center;align-items:center;"], COLORS.$tartRed);
var BodyStyles$1 = styled.div.withConfig({
  displayName: "styles__BodyStyles",
  componentId: "sc-2riudz-3"
})(["width:100%;background-color:", ";padding:40px;display:flex;align-items:center;"], COLORS.$white);
var ProductImage$1 = styled.div.withConfig({
  displayName: "styles__ProductImage",
  componentId: "sc-2riudz-4"
})(["margin-right:16px;"]);
var StyledImg = styled.img.withConfig({
  displayName: "styles__StyledImg",
  componentId: "sc-2riudz-5"
})(["&&{width:80px;height:80px;object-fit:contain;}"]);
var ProductBody = styled.div.withConfig({
  displayName: "styles__ProductBody",
  componentId: "sc-2riudz-6"
})([""]);
var BrandName = styled(Typography.Text).withConfig({
  displayName: "styles__BrandName",
  componentId: "sc-2riudz-7"
})([""]);
var SelectedVariant = styled(Typography.Text).withConfig({
  displayName: "styles__SelectedVariant",
  componentId: "sc-2riudz-8"
})([""]);
var FootStyles = styled.div.withConfig({
  displayName: "styles__FootStyles",
  componentId: "sc-2riudz-9"
})(["padding:0 40px 40px;"]);
var StyledButton$1 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-2riudz-10"
})(["&&{width:100%;&:first-child{margin-bottom:16px;}}"]);
var CloseModalIcon$1 = styled(Icon).withConfig({
  displayName: "styles__CloseModalIcon",
  componentId: "sc-2riudz-11"
})(["position:absolute;bottom:100%;margin-bottom:24px;font-size:24px;left:50%;transform:translate3d(-50%,0,0);", ";"], function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteralLoose(["\n                  bottom: 50%;\n                  left: 24px;\n                  margin-bottom: 0;\n                  transform: translate3d(0, 50%, 0);\n              "]))) : '';
});

var AddedToCard = inject('store')(observer(function (_ref) {
  var _data$images;
  var store = _ref.store,
    data = _ref.data,
    onModalClose = _ref.onModalClose;
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var variantTitle = getSelectedVariantTitle(data === null || data === void 0 ? void 0 : data.selectedVariant);
  var images = data.images,
    selectedVariant = data.selectedVariant;
  var _getVariantImage = getVariantImage(images, selectedVariant),
    variantImgSrc = _getVariantImage.imageSrc;
  var defaultImageSrc = data !== null && data !== void 0 && (_data$images = data.images) !== null && _data$images !== void 0 && _data$images.length ? data.images[0].src : '';
  var imageSrc = variantImgSrc || defaultImageSrc;
  return /*#__PURE__*/React__default.createElement(Styles$1, {
    $simple: simple
  }, !simple ? /*#__PURE__*/React__default.createElement(CloseModalIcon$1, {
    "data-e2e": "item-added-modal_close-modal_btn",
    color: "canvas",
    onClick: onModalClose,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  }) : null, /*#__PURE__*/React__default.createElement(WrapStyles, {
    "data-e2e": "item-added-modal_content",
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(HeadStyles, null, simple ? /*#__PURE__*/React__default.createElement(CloseModalIcon$1, {
    color: "primaryText",
    $simple: simple,
    onClick: onModalClose,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  }) : null, /*#__PURE__*/React__default.createElement(Typography.Title, {
    "data-e2e": "item-added-modal_title",
    color: "primary"
  }, "Item added")), /*#__PURE__*/React__default.createElement(BodyStyles$1, null, /*#__PURE__*/React__default.createElement(ProductImage$1, {
    "data-e2e": "item-added-modal_product_image"
  }, /*#__PURE__*/React__default.createElement(StyledImg, {
    src: imageSrc
  })), /*#__PURE__*/React__default.createElement(ProductBody, null, /*#__PURE__*/React__default.createElement(BrandName, {
    "data-e2e": "item-added-modal_brand-name_value",
    type: "body2",
    color: "secondaryText"
  }, data === null || data === void 0 ? void 0 : data.brandName), /*#__PURE__*/React__default.createElement(Typography.Title, {
    "data-e2e": "item-added-modal_product-title_value",
    level: 3,
    marginBottom: "4px"
  }, data === null || data === void 0 ? void 0 : data.title), /*#__PURE__*/React__default.createElement(SelectedVariant, {
    "data-e2e": "item-added-modal_variant-title_value",
    type: "descriptor2",
    color: "secondaryText"
  }, variantTitle))), /*#__PURE__*/React__default.createElement(FootStyles, null, /*#__PURE__*/React__default.createElement(StyledButton$1, {
    "data-e2e": "item-added-modal_go-to-cart_btn",
    type: "primary",
    onClick: data === null || data === void 0 ? void 0 : data.onGoToShoppingCart
  }, "Go to cart"), /*#__PURE__*/React__default.createElement(StyledButton$1, {
    "data-e2e": "item-added-modal_continue-shopping_btn",
    type: "text",
    onClick: onModalClose
  }, store.view.customizations.buttons.continueShoppingButtonLabel))));
}));

var _templateObject$12;
var Styles$2 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1pwbod7-0"
})(["width:630px;margin:70px 0;background-color:#ffffff;", ""], function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteralLoose(["\n                  width: 100%;\n                  height: 100%;\n                  margin: 0;\n              "]))) : '';
});

var AddedToCardModal = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    data = _ref.data,
    onModalClose = _ref.onModalClose;
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  return /*#__PURE__*/React__default.createElement(Styles$2, {
    simple: simple
  }, /*#__PURE__*/React__default.createElement(AddedToCard, {
    data: data,
    onModalClose: onModalClose
  }));
}));

var useAddedToCardModal = function useAddedToCardModal(simple, onAfterClose) {
  if (simple === void 0) {
    simple = false;
  }
  var _useModal = useModal(),
    setModal = _useModal.setModal,
    hideModal = _useModal.hideModal;
  var onModalClose = useCallback(function () {
    hideModal();
    if (typeof onAfterClose === 'function') onAfterClose();
  }, [hideModal]);
  return useCallback(function (_ref) {
    var data = _ref.data;
    setModal(/*#__PURE__*/React__default.createElement(AddedToCardModal, {
      data: data,
      onModalClose: onModalClose
    }), {
      fullscreen: simple,
      closable: false
    });
  }, [setModal, onModalClose, simple]);
};

var _templateObject$13;
var Styles$3 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-19u9shf-0"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;color:", ";background-color:", ";padding:12px 24px;"], COLORS.$white, COLORS.$primary);
var BodyStyles$2 = styled.div.withConfig({
  displayName: "styles__BodyStyles",
  componentId: "sc-19u9shf-1"
})(["display:flex;align-items:center;"]);
var Text$1 = styled(Typography.Text).withConfig({
  displayName: "styles__Text",
  componentId: "sc-19u9shf-2"
})(["line-height:0.8;"]);
var $animated = keyframes(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteralLoose(["\n    0% {\n        opacity: 0;\n    }\n    25% {\n        opacity: 1;\n    }\n    75% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
var Dots = styled.span.withConfig({
  displayName: "styles__Dots",
  componentId: "sc-19u9shf-3"
})(["display:inline-block;vertical-align:middle;animation:1s infinite ", ";line-height:1;&::before{content:':';}"], $animated);
var Value = styled.span.withConfig({
  displayName: "styles__Value",
  componentId: "sc-19u9shf-4"
})(["display:inline-block;vertical-align:middle;line-height:1;"]);

var AnimatedTime = function AnimatedTime(_ref) {
  var time = _ref.time;
  return time && time.days > 0 ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Value, null, time === null || time === void 0 ? void 0 : time.days, "D"), /*#__PURE__*/React__default.createElement(Dots, null), /*#__PURE__*/React__default.createElement(Value, null, time === null || time === void 0 ? void 0 : time.hours, "H"), /*#__PURE__*/React__default.createElement(Dots, null), /*#__PURE__*/React__default.createElement(Value, null, time === null || time === void 0 ? void 0 : time.minutes, "M")) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Value, null, time === null || time === void 0 ? void 0 : time.hours, "H"), /*#__PURE__*/React__default.createElement(Dots, null), /*#__PURE__*/React__default.createElement(Value, null, time === null || time === void 0 ? void 0 : time.minutes, "M"), /*#__PURE__*/React__default.createElement(Dots, null), /*#__PURE__*/React__default.createElement(Value, null, time === null || time === void 0 ? void 0 : time.seconds, "S"));
};

var Timer = observer(function (_ref) {
  var simple = _ref.simple,
    endDate = _ref.endDate,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 1000 : _ref$speed,
    isTimerPaused = _ref.isTimerPaused,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#ffffff' : _ref$color,
    onTimeLeft = _ref.onTimeLeft,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'body2' : _ref$type,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon;
  var _useState = useState(),
    timeLeft = _useState[0],
    setTimeLeft = _useState[1];
  var timer = useRef(null);
  useEffect(function () {
    setTimeLeft(getTimeLeft(endDate));
  }, [setTimeLeft, endDate]);
  useEffect(function () {
    timer.current = setTimeout(function () {
      var newTimeLeft = getTimeLeft(endDate);
      if (!timeLeft && isTimerPaused) {
        clearTimeout(timer.current);
        return;
      }
      if (timeLeft && newTimeLeft > 0) {
        setTimeLeft(newTimeLeft);
      }
      if (newTimeLeft <= 0 && onTimeLeft) {
        onTimeLeft();
      }
      clearTimeout(timer.current);
    }, speed);
    return function () {
      return clearTimeout(timer.current);
    };
  }, [speed, timeLeft, setTimeLeft, endDate, onTimeLeft, isTimerPaused]);
  var getDisplayTime = useCallback(function () {
    return msToDisplayFormat(timeLeft);
  }, [timeLeft]);
  return /*#__PURE__*/React__default.createElement(Styles$3, {
    style: simple ? BOTTOM_INDENTS.SM : {}
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: type,
    color: color,
    "data-e2e": "pdp_offer-ends_text"
  }, "This offer ends in"), /*#__PURE__*/React__default.createElement(BodyStyles$2, null, showIcon && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
    color: color,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgTime, null);
    }
  }), "\xA0\xA0"), /*#__PURE__*/React__default.createElement(Text$1, {
    color: color,
    type: type,
    "data-e2e": "pdp_offer-ends-time_value"
  }, /*#__PURE__*/React__default.createElement(AnimatedTime, {
    time: getDisplayTime()
  }))));
});

var _templateObject$14;
var StyledButtonsBody = styled.div.withConfig({
  displayName: "StyledButtonsBody",
  componentId: "sc-le5xln-0"
})(["display:flex;flex-direction:", ";max-width:550px;", ";"], function (_ref) {
  var $direction = _ref.$direction;
  return $direction || 'row';
}, function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n                  padding: 22px 24px;\n              "]))) : '';
});

var _templateObject$15, _templateObject2$L;
var StyledButtonsWrapper = styled.div(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? css(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteralLoose(["\n                  position: sticky;\n                  bottom: 0;\n                  z-index: 15;\n\n                  max-width: unset;\n                  background-color: ", ";\n                  border-top: 1px solid ", ";\n              "])), COLORS.$white, COLORS.$border) : '';
});

var _templateObject$16, _templateObject2$M, _templateObject3$r;
var StyledBuyNowButton = styled(Button)(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteralLoose(["\n    && {\n        width: 100%;\n\n        ", "\n\n        ", "\n\n        .anticon {\n            margin-right: 8px;\n        }\n    }\n"])), function (_ref) {
  var $singleButton = _ref.$singleButton;
  return $singleButton ? css(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteralLoose(["\n                      width: 100%;\n                      max-width: ", ";\n                  "])), function (_ref2) {
    var simple = _ref2.simple;
    return simple ? 'unset' : '415px';
  }) : '';
}, function (_ref3) {
  var $simple = _ref3.$simple;
  return $simple ? css(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteralLoose(["\n                      padding-left: 10px;\n                      padding-right: 10px;\n                  "]))) : '';
});

var _templateObject$17;
var StyledCancelButton = styled(Button).withConfig({
  displayName: "StyledCancelButton",
  componentId: "sc-fyjzai-0"
})(["&&{width:100%;", ";}"], function (_ref) {
  var $smallerButtonText = _ref.$smallerButtonText;
  return $smallerButtonText ? css(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteralLoose(["\n                      padding-left: 10px;\n                      padding-right: 10px;\n                  "]))) : '';
});

var _templateObject$18;
var StyledCartButton = styled(Button).withConfig({
  displayName: "StyledCartButton",
  componentId: "sc-11mgkmo-0"
})(["&&{width:100%;min-width:197px;", ";.anticon > svg{margin-right:8px;}}"], function (_ref) {
  var $smallerButtonText = _ref.$smallerButtonText;
  return $smallerButtonText ? css(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteralLoose(["\n                      padding-left: 10px;\n                      padding-right: 10px;\n                      min-width: unset;\n                  "]))) : '';
});

var CheckoutButtons = inject('store')(observer(function (_ref) {
  var _store$callbacks, _store$view$customiza;
  var store = _ref.store,
    scrollToOptionsCallback = _ref.scrollToOptionsCallback,
    customButtons = _ref.customButtons,
    _ref$hasBottomIndent = _ref.hasBottomIndent,
    hasBottomIndent = _ref$hasBottomIndent === void 0 ? false : _ref$hasBottomIndent;
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var smallerButtonText = store.view.isSimple(380);
  var openAddedToCardModal = useAddedToCardModal(simple, (_store$callbacks = store.callbacks) === null || _store$callbacks === void 0 ? void 0 : _store$callbacks.onAfterAddToCartModalClose);
  var title = store.product.getData('title');
  var brandName = store.product.getData('brandName');
  var images = store.product.getData('images');
  var onGoToShoppingCart = store.callbacks.onGoToShoppingCart;
  var selectedVariant = store.product.variants.selectedVariant;
  var customizations = (_store$view$customiza = store.view.customizations) === null || _store$view$customiza === void 0 ? void 0 : _store$view$customiza.buttons;
  var isUpsell = store.view.isUpsell();
  var upsellEndDate = store.upsell.endDate;
  var isUpsellTimeLeft = store.view.isUpsell() && getTimeLeft(store.upsell.endDate) <= 0;
  var addedToCartModalData = {
    title: title,
    brandName: brandName,
    images: images,
    selectedVariant: selectedVariant,
    onGoToShoppingCart: onGoToShoppingCart
  };
  var onCancel = function onCancel() {
    return store.product.onCancel();
  };
  var onBuyNow = function onBuyNow(e) {
    e.stopPropagation();
    e.preventDefault();
    store.product.buyNow({
      onOptionsErrorCallback: scrollToOptionsCallback
    });
  };
  var onAddToCart = function onAddToCart() {
    return store.product.addToCart({
      onOptionsErrorCallback: scrollToOptionsCallback,
      onAddToCartSuccessCallback: function onAddToCartSuccessCallback(promotion) {
        openAddedToCardModal({
          data: addedToCartModalData,
          promotion: promotion
        });
      }
    });
  };
  var showAddToCartConfirmModal = store.callbacks.showAddToCartConfirmModal({
    simple: simple,
    onConfirm: onAddToCart
  });
  var handleAddToCartClick = function handleAddToCartClick(e) {
    e.stopPropagation();
    e.preventDefault();
    if (!store.view.withGSConfirmModal()) {
      onAddToCart();
    } else {
      return store.product.showConfirmAddToCartModal({
        onOptionsErrorCallback: scrollToOptionsCallback,
        onSuccess: showAddToCartConfirmModal
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledButtonsWrapper, {
    style: hasBottomIndent ? BOTTOM_INDENTS.SM : {},
    $simple: simple
  }, isUpsell ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Timer, {
    simple: simple,
    endDate: upsellEndDate,
    onTimeLeft: onCancel
  })) : null, customButtons || /*#__PURE__*/React__default.createElement(StyledButtonsBody, {
    $simple: simple,
    $direction: customizations === null || customizations === void 0 ? void 0 : customizations.pdpButtonsDirection
  }, customizations !== null && customizations !== void 0 && customizations.showAddToCartButton && !isUpsell ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledCartButton, {
    "data-e2e": "pdp_add-to-cart_btn",
    type: "primary",
    size: "large",
    disabled: selectedVariant && selectedVariant.inCart,
    onClick: handleAddToCartClick,
    $simple: simple,
    $smallerButtonText: smallerButtonText
  }, selectedVariant && selectedVariant.inCart ? [customizations !== null && customizations !== void 0 && customizations.showAddToCartButtonIcon ? /*#__PURE__*/React__default.createElement(Icon, {
    stylePriority: true,
    key: "icon-key",
    size: smallerButtonText ? '18px' : '24px',
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBag, null);
    }
  }) : null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    key: "text-key",
    type: smallerButtonText ? 'badgeSmall' : 'badgeLarge'
  }, "In cart")] : [customizations !== null && customizations !== void 0 && customizations.showAddToCartButtonIcon ? /*#__PURE__*/React__default.createElement(Icon, {
    stylePriority: true,
    key: "icon-key",
    size: smallerButtonText ? '18px' : '24px',
    component: function component() {
      return customizations !== null && customizations !== void 0 && customizations.showAddToCartButtonGiftIcon ? /*#__PURE__*/React__default.createElement(SvgGift, null) : /*#__PURE__*/React__default.createElement(SvgBag, null);
    }
  }) : null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    key: "text-key",
    type: smallerButtonText ? 'badgeSmall' : 'badgeLarge'
  }, customizations === null || customizations === void 0 ? void 0 : customizations.addToCartButtonLabel)]), customizations !== null && customizations !== void 0 && customizations.showBuyNowButton ? /*#__PURE__*/React__default.createElement(Fragment, null, "\xA0\xA0\xA0") : null) : null, customizations !== null && customizations !== void 0 && customizations.showBuyNowButton ? /*#__PURE__*/React__default.createElement(StyledBuyNowButton, {
    "data-e2e": "pdp_buy-now_btn",
    type: "primary",
    size: "large",
    disabled: isUpsellTimeLeft,
    onClick: onBuyNow,
    $simple: simple,
    $singleButton: !(customizations !== null && customizations !== void 0 && customizations.showAddToCartButton)
  }, (customizations === null || customizations === void 0 ? void 0 : customizations.showBuyNowButtonGiftIcon) && /*#__PURE__*/React__default.createElement(Icon, {
    size: "24px",
    stylePriority: true,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgGift, null);
    }
  }), (customizations === null || customizations === void 0 ? void 0 : customizations.showBuyNowButtonBagIcon) && /*#__PURE__*/React__default.createElement(Icon, {
    size: "24px",
    stylePriority: true,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBag, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: smallerButtonText ? 'badgeSmall' : 'badgeLarge'
  }, customizations === null || customizations === void 0 ? void 0 : customizations.buyNowButtonLabel)) : null, isUpsell ? /*#__PURE__*/React__default.createElement(Fragment, null, "\xA0 \xA0 \xA0", /*#__PURE__*/React__default.createElement(StyledCancelButton, {
    type: "secondary",
    size: "large",
    onClick: onCancel,
    $simple: simple,
    $smallerButtonText: smallerButtonText,
    disabled: isUpsellTimeLeft
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: smallerButtonText ? 'badgeSmall' : 'badgeLarge'
  }, customizations === null || customizations === void 0 ? void 0 : customizations.cancelButtonLabel))) : null)));
}));

var ErrorFieldStyles$1 = styled.div.withConfig({
  displayName: "styles__ErrorFieldStyles",
  componentId: "sc-99jm4t-0"
})(["display:flex;align-items:center;background-color:", ";padding:12px 25px;margin-bottom:22px;"], COLORS.$tartRed);
var ErrorFieldIcon$1 = styled(Icon).withConfig({
  displayName: "styles__ErrorFieldIcon",
  componentId: "sc-99jm4t-1"
})(["padding:0 16px 0 0;"]);

var OptionError = observer(function (_ref) {
  var error = _ref.error,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertInfo, null) : _ref$icon,
    _ref$textType = _ref.textType,
    textType = _ref$textType === void 0 ? 'descriptor1' : _ref$textType;
  return /*#__PURE__*/React__default.createElement(ErrorFieldStyles$1, null, showIcon && /*#__PURE__*/React__default.createElement(ErrorFieldIcon$1, {
    color: "error",
    size: "24px",
    component: function component() {
      return icon;
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    color: "primaryText",
    type: textType,
    "data-e2e": "pdp_option-error_message"
  }, error));
});

var _templateObject$19;
var Styles$4 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1gq2w4a-0"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;"]);
var Title$1 = styled(Typography.Text).withConfig({
  displayName: "styles__Title",
  componentId: "sc-1gq2w4a-1"
})(["padding-right:20px;", ";"], function (_ref) {
  var $appWidth = _ref.$appWidth;
  return $appWidth <= GRID_POINTS$1.xs ? css(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteralLoose(["\n                  max-width: 40%;\n              "]))) : '';
});

var OptionsBlockRow = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    _ref$hasBottomIndent = _ref.hasBottomIndent,
    hasBottomIndent = _ref$hasBottomIndent === void 0 ? false : _ref$hasBottomIndent,
    title = _ref.title,
    children = _ref.children;
  var appWidth = store.view.appWidth;
  return /*#__PURE__*/React__default.createElement(Styles$4, {
    style: hasBottomIndent ? BOTTOM_INDENTS.SM : {}
  }, /*#__PURE__*/React__default.createElement(Title$1, {
    $appWidth: appWidth,
    type: "body2",
    color: "primaryText"
  }, title), children);
}));

var _templateObject$1a, _templateObject2$N, _templateObject3$s;
var ItemsWrap = styled.div.withConfig({
  displayName: "styles__ItemsWrap",
  componentId: "sc-1v9ne3j-0"
})(["width:fit-content;margin-left:auto;display:flex;flex-wrap:nowrap;"]);
var Label$4 = styled.label.withConfig({
  displayName: "styles__Label",
  componentId: "sc-1v9ne3j-1"
})(["color:", ";background-color:", ";transition:all 0.2s linear;display:inline-flex;justify-content:center;align-items:center;padding:12px 16px;white-space:nowrap;margin-left:16px;cursor:pointer;&:hover{", "}", ""], function (_ref) {
  var active = _ref.active;
  return active ? COLORS.$white : COLORS.$secondaryText;
}, function (_ref2) {
  var active = _ref2.active;
  return active ? COLORS.$primaryText : COLORS.$background;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return !disabled ? css(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteralLoose(["\n                      color: ", ";\n                      background-color: ", ";\n                  "])), COLORS.$white, COLORS.$primaryText) : '';
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? css(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteralLoose(["\n                  pointer-events: none;\n                  opacity: 0.5;\n              "]))) : '';
});
var Input$1 = styled.input.withConfig({
  displayName: "styles__Input",
  componentId: "sc-1v9ne3j-2"
})(["width:0 !important;height:0 !important;visibility:hidden;"]);
var WrapStyles$1 = styled.div.withConfig({
  displayName: "styles__WrapStyles",
  componentId: "sc-1v9ne3j-3"
})(["overflow:", ";width:100%;"], function (_ref5) {
  var simple = _ref5.simple;
  return simple ? 'visible' : 'hidden';
});
var ContentStyles = styled.div.withConfig({
  displayName: "styles__ContentStyles",
  componentId: "sc-1v9ne3j-4"
})(["width:fit-content;margin-left:auto;& select{color:", ";}"], COLORS.$primaryText);
var StyledSelect$1 = styled(Select).withConfig({
  displayName: "styles__StyledSelect",
  componentId: "sc-1v9ne3j-5"
})(["&&{min-width:200px;", ";}"], function (_ref6) {
  var $appWidth = _ref6.$appWidth;
  return $appWidth <= 330 ? css(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteralLoose(["\n                      max-width: 200px;\n                  "]))) : '';
});
var OptionsBlockWrap = styled.div.withConfig({
  displayName: "styles__OptionsBlockWrap",
  componentId: "sc-1v9ne3j-6"
})(["width:100%;"]);

var Option = observer(function (_ref) {
  var appWidth = _ref.appWidth,
    optionKey = _ref.optionKey,
    option = _ref.option,
    _ref$highlightError = _ref.highlightError,
    highlightError = _ref$highlightError === void 0 ? false : _ref$highlightError,
    onClick = _ref.onClick;
  var wrapperRef = useRef();
  var contentRef = useRef();
  if (!(option && option.values && option.values.length)) {
    return null;
  }
  var simple = useFitContent({
    wrapperRef: wrapperRef,
    contentRef: contentRef
  });
  return /*#__PURE__*/React__default.createElement(WrapStyles$1, {
    ref: wrapperRef,
    simple: simple
  }, /*#__PURE__*/React__default.createElement(ContentStyles, {
    ref: contentRef,
    style: {
      width: 'fit-content'
    }
  }, simple ? /*#__PURE__*/React__default.createElement(StyledSelect$1, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    $appWidth: appWidth,
    value: option.selected || '',
    label: "Select " + option.name,
    error: highlightError,
    onChange: function onChange(value) {
      return onClick(optionKey, value);
    },
    options: option.values.map(function (option) {
      return {
        label: option.value,
        value: option.value,
        disabled: option.disabled
      };
    })
  }) : /*#__PURE__*/React__default.createElement(ItemsWrap, null, option.values.map(function (value, valueKey) {
    return /*#__PURE__*/React__default.createElement(Label$4, {
      key: "option-" + valueKey,
      "data-e2e": "pdp_option-value-" + valueKey + "_label",
      active: value.value === option.selected,
      disabled: value.disabled
    }, /*#__PURE__*/React__default.createElement(Typography.Text, {
      type: "descriptor2"
    }, value.value), /*#__PURE__*/React__default.createElement(Input$1, {
      "data-e2e": "pdp_option-value-" + valueKey + "_input",
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      type: "checkbox",
      name: option.name,
      onChange: function onChange() {
        return onClick(optionKey, value.value);
      }
    }));
  }))));
});
var Options = inject('store')(observer(function (_ref2) {
  var store = _ref2.store;
  var options = store.product.optionsList;
  return /*#__PURE__*/React__default.createElement(Fragment, null, options && options.length ? options.map(function (option, key) {
    var highlightNotSelectedError = !option.selected && store.product.notSelectedOptionsErrorVisible;
    return /*#__PURE__*/React__default.createElement(OptionsBlockWrap, {
      key: "options-block-row-" + key
    }, /*#__PURE__*/React__default.createElement(OptionsBlockRow, {
      title: option.name
    }, /*#__PURE__*/React__default.createElement(Option, {
      appWidth: store.view.appWidth,
      optionKey: key,
      option: option,
      highlightError: highlightNotSelectedError,
      onClick: function onClick(key, value) {
        store.product.options.selectOption(key, value);
      }
    })), highlightNotSelectedError ? /*#__PURE__*/React__default.createElement(OptionError, {
      error: "Choose " + option.name + " option",
      icon: /*#__PURE__*/React__default.createElement(SvgCircleActionsClose, null),
      showIcon: true
    }) : null);
  }) : null);
}));

var Styles$5 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-19ispve-0"
})(["display:flex;align-items:center;"]);
var Input$2 = styled.input.withConfig({
  displayName: "styles__Input",
  componentId: "sc-19ispve-1"
})(["border:none;width:40px;text-align:center;pointer-events:none;cursor:auto;"]);
var StyledButton$2 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-19ispve-2"
})(["&&{&,&:active,&:hover{width:28px;height:28px;background-color:", " !important;border-radius:50%;padding:0;}&:disabled{background-color:", " !important;opacity:0.5;}}"], COLORS.$background, COLORS.$background);

var Qty = inject('store')(observer(function (_ref) {
  var _store$product, _store$product$referr;
  var store = _ref.store;
  var hasReferralSession = store.product.data.hasReferralSession;
  var sessionExpiresAt = (_store$product = store.product) === null || _store$product === void 0 ? void 0 : (_store$product$referr = _store$product.referralSession) === null || _store$product$referr === void 0 ? void 0 : _store$product$referr.isExpired;
  var referralSession = hasReferralSession && !sessionExpiresAt;
  return /*#__PURE__*/React__default.createElement(Styles$5, null, /*#__PURE__*/React__default.createElement(StyledButton$2, {
    "data-e2e": "pdp_qty-deduct_btn",
    type: "unstyled",
    disabled: store.product.variants.qty <= store.product.variants.minQty || referralSession,
    onClick: function onClick() {
      return store.product.variants.decrementQty();
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    style: {
      pointerEvents: 'none'
    },
    stylePriority: true,
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgActionsMinus, null);
    }
  })), /*#__PURE__*/React__default.createElement(Input$2, {
    "data-e2e": "pdp_product-qty_value",
    readOnly: true,
    value: store.product.variants.qty
  }), /*#__PURE__*/React__default.createElement(StyledButton$2, {
    "data-e2e": "pdp_qty-add_btn",
    type: "unstyled",
    disabled: store.product.variants.qty === store.product.variants.maxQty || referralSession,
    onClick: function onClick() {
      return store.product.variants.incrementQty();
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    style: {
      pointerEvents: 'none'
    },
    stylePriority: true,
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgActionsPlus, null);
    }
  })));
}));

var _templateObject$1b;
var Styles$6 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-b02mgm-0"
})(["", ";"], function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteralLoose(["\n                  padding: 0 24px;\n              "]))) : '';
});

var OptionsBlock = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    optionsRef = _ref.optionsRef;
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  return /*#__PURE__*/React__default.createElement(Styles$6, {
    "data-e2e": "pdp_quantity_block",
    style: BOTTOM_INDENTS.SM,
    simple: simple,
    ref: optionsRef
  }, /*#__PURE__*/React__default.createElement(OptionsBlockRow, {
    hasBottomIndent: true,
    title: "Quantity"
  }, /*#__PURE__*/React__default.createElement(Qty, null)), /*#__PURE__*/React__default.createElement(Options, null));
}));

var formatString = function formatString(string, regexp, replaceWith) {
  if (string === void 0) {
    string = '';
  }
  if (regexp === void 0) {
    regexp = /\s+/g;
  }
  if (replaceWith === void 0) {
    replaceWith = '-';
  }
  if (string) {
    return string.replace(/[_:]/g, ' ').replace(/\s*\(.*?\)\s*/g, '').replace(regexp, replaceWith).toLowerCase();
  }
  return 'no-data';
};

var _templateObject$1c, _templateObject2$O, _templateObject3$t, _templateObject4$n, _templateObject5$g;
var StyledWrapper$5 = styled.div(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n"])));
var StyledLoaderWrapper = styled.div(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteralLoose(["\n    position: relative;\n"])));
var StyledText$2 = styled(Typography.Text)(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteralLoose(["\n    && {\n        display: flex;\n        align-items: center;\n        position: relative;\n\n        ", ";\n\n        ", ";\n\n        .anticon {\n            margin-left: 6px;\n        }\n    }\n"])), function (_ref) {
  var $appWidth = _ref.$appWidth;
  return $appWidth <= 320 ? css(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteralLoose(["\n                      max-width: 50%;\n\n                      & > span {\n                          max-width: 75px;\n                      }\n                  "]))) : '';
}, function (_ref2) {
  var $loading = _ref2.$loading;
  return $loading ? css(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteralLoose(["\n                      filter: blur(2px);\n                  "]))) : '';
});

var CashBackInfo = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var variant = store.product.variants.currentVariantData;
  var color = store.view.customizations.cashBack.color;
  var loading = store.product.variants.loading;
  return /*#__PURE__*/React__default.createElement(StyledWrapper$5, null, /*#__PURE__*/React__default.createElement(StyledText$2, {
    type: "body2",
    color: color
  }, "Cash back"), /*#__PURE__*/React__default.createElement(StyledLoaderWrapper, null, loading ? /*#__PURE__*/React__default.createElement(Icon.Loader, {
    size: "30px"
  }) : null, /*#__PURE__*/React__default.createElement(StyledText$2, {
    $loading: loading,
    "data-e2e": "pdp_cashback_value",
    type: "body2",
    color: color
  }, "$", roundToLocaleString(variant.cashbackPrice))));
}));

var geEntityFromStoreByPath = function geEntityFromStoreByPath(obj, path, defValue) {
  if (!path) return undefined;
  var pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  var result = pathArray.reduce(function (prevObj, key) {
    return prevObj && prevObj[key];
  }, obj);
  return result === undefined ? defValue : result;
};

var MIN_DISCOUNT_PERCENTAGE_TO_SHOW = 3;
var getPrices = function getPrices(prices) {
  if (!prices) {
    return {};
  }
  var textPrices = {
    showOriginalPrice: true
  };
  var discount = 0;
  if (prices.originalPrice) {
    textPrices.originalPrice = "$" + roundToLocaleString(prices.originalPrice);
    var priceDiff = prices.originalPrice - prices.price;
    if (priceDiff > 0) {
      discount = priceDiff;
    }
  } else {
    prices.originalPrice = prices.price;
  }
  if (discount) {
    var percentage = Number(discount) / Number(prices.originalPrice) * 100;
    textPrices.discount = "-$" + roundToLocaleString(discount);
    textPrices.showDiscountPercentage = percentage > MIN_DISCOUNT_PERCENTAGE_TO_SHOW;
    textPrices.discountPercentage = textPrices.showDiscountPercentage ? "(" + roundToLocaleString(percentage, 0) + "% off)" : '';
  }
  var priceText = textPrices.discountPercentage ? "$" + roundToLocaleString(prices.price) + " " + textPrices.discountPercentage : "$" + roundToLocaleString(prices.price);
  textPrices.price = prices.price === 0 ? 'Free' : priceText;
  if (!prices.originalPrice || prices.originalPrice === prices.price) {
    textPrices.showOriginalPrice = false;
  }
  return textPrices;
};

var _templateObject$1d, _templateObject2$P, _templateObject3$u, _templateObject4$o;
var StyledPopover$1 = createGlobalStyle(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteralLoose(["\n    .popover-points {\n        .ant-popover-inner-content {\n            padding: 8px 16px;\n        }\n    }\n"])));
var StyledContent$1 = styled(Typography.Text)(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteralLoose(["\n    white-space: nowrap;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    > span {\n        font-weight: 500;\n    }\n"])));
var StyledKliIcon = styled(Icon)(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteralLoose(["\n    margin-left: 12px;\n"])));
var StyledValue = styled.span(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteralLoose(["\n    margin-left: 4px;\n"])));

var _excluded$L = ["children", "points", "showUsdOnly"];
var PopoverPoints$1 = function PopoverPoints(_ref) {
  var children = _ref.children,
    points = _ref.points,
    showUsdOnly = _ref.showUsdOnly,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$L);
  var simple = useSimpleInterface(GRID_POINTS$1.md);
  var _useState = useState(false),
    clicked = _useState[0],
    setClicked = _useState[1];
  var _useState2 = useState(false),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  var handleHoverChange = function handleHoverChange(open) {
    setHovered(open);
    setClicked(false);
  };
  var handleClickChange = function handleClickChange(open) {
    setHovered(false);
    setClicked(open);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledPopover$1, null), /*#__PURE__*/React__default.createElement(Popover, _extends({
    open: simple ? clicked : hovered,
    onOpenChange: simple ? handleClickChange : handleHoverChange,
    overlayClassName: "popover-points",
    trigger: simple ? 'click' : 'hover',
    getPopupContainer: function getPopupContainer(node) {
      return node;
    },
    type: "primary",
    content: /*#__PURE__*/React__default.createElement(StyledContent$1, {
      type: "body2",
      color: "canvas"
    }, !showUsdOnly && points + " points = ", /*#__PURE__*/React__default.createElement(StyledValue, null, points / 100 % 1 ? roundToLocaleString(points / 100) : points / 100, " USD"), simple && /*#__PURE__*/React__default.createElement(StyledKliIcon, {
      size: "12px",
      onClick: function onClick() {
        return handleClickChange(false);
      },
      component: function component() {
        return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
      }
    }))
  }, props), children));
};

var _templateObject$1e, _templateObject2$Q, _templateObject3$v, _templateObject4$p;
var StyledWrapper$6 = styled.div(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n"])));
var StyledIcon$4 = styled(Icon)(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteralLoose(["\n    margin-right: 4px;\n"])));
var StyledText$3 = styled(Typography.Text)(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteralLoose(["\n    && {\n        display: flex;\n        align-items: center;\n\n        ", ";\n\n        > span {\n            display: flex;\n            align-items: center;\n        }\n    }\n"])), function (_ref) {
  var $appWidth = _ref.$appWidth;
  return $appWidth <= 320 ? css(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteralLoose(["\n                      max-width: 55%;\n                  "]))) : '';
});

var EarnedPoints = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var simple = useSimpleInterface(GRID_POINTS$1.sm);
  var points = store.product.pointsValue;
  var isWelcome = store.product.pointsIsWelcome;
  var pointsLabel = geEntityFromStoreByPath(store.view.customizations, 'points.pointsLabel', 'Members earn');
  if (!points) return null;
  return /*#__PURE__*/React__default.createElement(StyledWrapper$6, {
    "data-e2e": "pdp_points-earn_block"
  }, /*#__PURE__*/React__default.createElement(StyledText$3, {
    $appWidth: store.view.appWidth,
    type: "body2",
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "span"
  }, pointsLabel, isWelcome ? ' as Welcome Gift' : ''), /*#__PURE__*/React__default.createElement(Icon, {
    "data-e2e": "pdp_points-earn-question_icon",
    size: "12px",
    color: "primary",
    style: {
      marginLeft: '6px'
    },
    onClick: function onClick() {
      return typeof store.callbacks.onPointsQuestionClick === 'function' && store.callbacks.onPointsQuestionClick(getSnapshot(store.product));
    },
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertQuestion, null);
    }
  })), /*#__PURE__*/React__default.createElement(StyledText$3, {
    "data-e2e": "pdp_points-earn_value",
    type: "body2",
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(PopoverPoints$1, {
    points: points,
    showUsdOnly: simple,
    placement: simple ? 'topRight' : 'bottomRight'
  }, /*#__PURE__*/React__default.createElement(StyledIcon$4, {
    size: "14px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgPoints, null);
    }
  }), " +", points)));
}));

var ReferralOfferTimer = inject('store')(observer(function (_ref) {
  var referralSession = _ref.referralSession,
    onExpired = _ref.onExpired;
  var _useState = useState('00:00'),
    timeDisplay = _useState[0],
    setTimeDisplay = _useState[1];
  var _useState2 = useState(false),
    hasExpired = _useState2[0],
    setHasExpired = _useState2[1];
  useEffect(function () {
    if (!(referralSession !== null && referralSession !== void 0 && referralSession.expiresAt)) {
      return;
    }
    var formatTimeLeft = function formatTimeLeft(expiresAt) {
      var now = new Date().getTime();
      var expiry = new Date(expiresAt).getTime();
      var diff = expiry - now;
      if (diff <= 0) {
        return '00:00';
      }
      var totalSeconds = Math.floor(diff / 1000);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      return String(minutes).padStart(2, '0') + ":" + String(seconds).padStart(2, '0');
    };
    var getTimeLeftMs = function getTimeLeftMs(expiresAt) {
      var now = new Date().getTime();
      var expiry = new Date(expiresAt).getTime();
      return expiry - now;
    };
    setTimeDisplay(formatTimeLeft(referralSession.expiresAt));
    var timer = setInterval(function () {
      var timeLeftMs = getTimeLeftMs(referralSession.expiresAt);
      var newTime = formatTimeLeft(referralSession.expiresAt);
      setTimeDisplay(newTime);
      if (timeLeftMs <= 0 && !hasExpired) {
        setHasExpired(true);
        clearInterval(timer);
        if (onExpired) {
          onExpired();
        }
      }
    }, 1000);
    return function () {
      return clearInterval(timer);
    };
  }, [referralSession === null || referralSession === void 0 ? void 0 : referralSession.expiresAt, hasExpired, onExpired]);
  if (!referralSession) {
    return null;
  }
  return timeDisplay;
}));

var _templateObject$1f, _templateObject2$R, _templateObject3$w, _templateObject4$q;
var StyledTitle$1 = styled(Typography.Title)(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteralLoose(["\n    && {\n        background: ", ";\n        padding: 24px;\n        color: ", ";\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n"])), COLORS.$primaryLight, COLORS.$primary);
var StyledBody = styled.div(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteralLoose(["\n    padding: 40px 40px 24px 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n"])));
var StyledWrapper$7 = styled.div(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteralLoose(["\n    position: relative;\n"])));
var CloseModalIcon$2 = styled(Icon)(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteralLoose(["\n    && {\n        position: absolute;\n        bottom: 100%;\n        left: 50%;\n        margin-bottom: 24px;\n        font-size: 24px;\n        transform: translate3d(-50%, 0, 0);\n    }\n"])));

var RewardExpired = function RewardExpired(_ref) {
  var onModalClose = _ref.onModalClose;
  return /*#__PURE__*/React__default.createElement(StyledWrapper$7, null, /*#__PURE__*/React__default.createElement(CloseModalIcon$2, {
    size: "22px",
    color: "canvas",
    onClick: onModalClose,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  }), /*#__PURE__*/React__default.createElement(StyledTitle$1, {
    level: 1
  }, "Reward expired"), /*#__PURE__*/React__default.createElement(StyledBody, null, /*#__PURE__*/React__default.createElement(Icon, {
    size: "80px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgTime, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeMedium"
  }, "Sorry, this offer has ended, but you ", /*#__PURE__*/React__default.createElement("br", null), " can keep browsing for other deals."), /*#__PURE__*/React__default.createElement(Button, {
    onClick: onModalClose,
    style: TOP_INDENTS.M,
    type: "primary",
    size: "large",
    block: true
  }, "Continue shopping")));
};

var _templateObject$1g, _templateObject2$S, _templateObject3$x;
var StyledWrapper$8 = styled.div(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n"])));
var StyledText$4 = styled(Typography.Text)(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteralLoose(["\n    && {\n        display: flex;\n        align-items: center;\n\n        ", ";\n\n        .anticon {\n            margin-left: 6px;\n        }\n    }\n"])), function (_ref) {
  var $appWidth = _ref.$appWidth;
  return $appWidth <= 320 ? css(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteralLoose(["\n                      max-width: 50%;\n\n                      & > span {\n                          max-width: 75px;\n                      }\n                  "]))) : '';
});

var RewardsApplied = inject('store')(observer(function (_ref) {
  var _variant$rewards, _variant$priceDetails, _variant$priceDetails2;
  var store = _ref.store;
  var variant = store.product.variants.currentVariantData;
  var color = store.view.customizations.rewards.color;
  var rootAppName = store.view.customizations.rootAppName;
  var filteredRewards = variant !== null && variant !== void 0 && (_variant$rewards = variant.rewards) !== null && _variant$rewards !== void 0 && _variant$rewards.length ? variant.rewards.filter(function (reward) {
    return reward.appliedTo !== 'taxes';
  }) : [];
  var rewardsLength = (filteredRewards.length || 0) + " Rewards applied";
  if (rootAppName === 'dp' && !(filteredRewards !== null && filteredRewards !== void 0 && filteredRewards.length)) return null;
  return /*#__PURE__*/React__default.createElement(StyledWrapper$8, {
    "data-e2e": "pdp_rewards-applied_block"
  }, /*#__PURE__*/React__default.createElement(StyledText$4, {
    $appWidth: store.view.appWidth,
    type: "body2",
    color: color
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "pdp_rewards-applied-count_value",
    as: "span"
  }, rewardsLength), /*#__PURE__*/React__default.createElement(Icon, {
    "data-e2e": "pdp_reward-question_icon",
    size: "12px",
    onClick: function onClick() {
      return typeof store.callbacks.onRewardQuestionClick === 'function' && store.callbacks.onRewardQuestionClick(variant);
    },
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertQuestion, null);
    }
  })), /*#__PURE__*/React__default.createElement(StyledText$4, {
    "data-e2e": "pdp_rewards-applied_value",
    type: "body2",
    color: color
  }, "\u2013$", roundToLocaleString((variant === null || variant === void 0 ? void 0 : (_variant$priceDetails = variant.priceDetails) === null || _variant$priceDetails === void 0 ? void 0 : _variant$priceDetails.rewardsPrice) * store.product.variants.qty), " (", (variant === null || variant === void 0 ? void 0 : (_variant$priceDetails2 = variant.priceDetails) === null || _variant$priceDetails2 === void 0 ? void 0 : _variant$priceDetails2.rewardsPercent) || 0, "% off)"));
}));

var _templateObject$1h, _templateObject2$T, _templateObject3$y, _templateObject4$r, _templateObject5$h;
var StyledWrapper$9 = styled.div(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n    position: relative;\n"])));
var StyledLoaderWrapper$1 = styled.div(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteralLoose(["\n    position: relative;\n"])));
var StyledText$5 = styled(Typography.Text)(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    position: relative;\n\n    ", ";\n\n    ", ";\n"])), function (_ref) {
  var $referralSession = _ref.$referralSession;
  return $referralSession ? css(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteralLoose(["\n                  color: ", ";\n              "])), COLORS.$primary) : '';
}, function (_ref2) {
  var $loading = _ref2.$loading;
  return $loading ? css(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteralLoose(["\n                  filter: blur(2px);\n              "]))) : '';
});

var TotalPrice = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    referralSession = _ref.referralSession;
  var price = store.product.variants.youPayPrice;
  var discount = store.product.variants.getPriceDiscount;
  var loading = store.product.variants.loading;
  return /*#__PURE__*/React__default.createElement(StyledWrapper$9, {
    "data-e2e": "pdp_you-pay_block"
  }, /*#__PURE__*/React__default.createElement(StyledText$5, {
    $referralSession: referralSession,
    type: "descriptor1"
  }, "You pay"), /*#__PURE__*/React__default.createElement(StyledLoaderWrapper$1, null, loading && discount ? /*#__PURE__*/React__default.createElement(Icon.Loader, {
    size: "30px"
  }) : null, /*#__PURE__*/React__default.createElement(StyledText$5, {
    $loading: loading,
    $referralSession: referralSession,
    "data-e2e": "pdp_you-pay_value",
    type: "descriptor1"
  }, "$", discount && discount !== null && discount !== void 0 && discount.value ? roundToLocaleString(Math.max(0, store.product.variants.variantPrice * store.product.variants.qty - discount.value)) : roundToLocaleString(Math.max(0, price * store.product.variants.qty)))));
}));

var _templateObject$1i;
var Styles$7 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-cb4s5k-0"
})(["width:100%;position:relative;background-color:", ";padding:20px 24px;"], COLORS.$background);
var PriceRowWrap = styled.div.withConfig({
  displayName: "styles__PriceRowWrap",
  componentId: "sc-cb4s5k-1"
})(["display:flex;justify-content:space-between;align-items:center;color:", ";position:relative;"], COLORS.$primaryText);
var StyledOfferTimer = styled(Typography.Text).withConfig({
  displayName: "styles__StyledOfferTimer",
  componentId: "sc-cb4s5k-2"
})(["display:flex;gap:8px;align-items:center;"]);
var StyledOffer = styled.div.withConfig({
  displayName: "styles__StyledOffer",
  componentId: "sc-cb4s5k-3"
})(["padding:10px 24px;background-color:", ";color:", ";display:flex;justify-content:space-between;position:relative;", ""], COLORS.$primary, COLORS.$white, function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? '' : css(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteralLoose(["\n                  &::after {\n                      content: '';\n                      position: absolute;\n                      top: -10px;\n                      right: 35px;\n                      width: 0;\n                      height: 0;\n                      border-left: 8px solid transparent;\n                      border-right: 8px solid transparent;\n                      border-bottom: 10px solid ", ";\n                  }\n              "])), COLORS.$primary);
});

var PriceRow = observer(function (_ref) {
  var title = _ref.title,
    price = _ref.price,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type;
  var textType = type === 'deal' ? 'badgeMedium' : 'body2';
  return /*#__PURE__*/React__default.createElement(PriceRowWrap, {
    style: BOTTOM_INDENTS.SM,
    type: type,
    "data-e2e": "pdp_" + formatString(title) + "_block"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: textType
  }, title), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "pdp_" + formatString(title) + "_value",
    type: textType
  }, price));
});
var Prices = inject('store')(observer(function (_ref2) {
  var _store$product, _store$product$referr, _store$product2, _store$view$customiza, _variant$priceDetails, _store$view$customiza2, _store$view$customiza3, _store$view$customiza4, _store$product3;
  var store = _ref2.store;
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var _useModal = useModal(),
    setModal = _useModal.setModal,
    hideModal = _useModal.hideModal;
  var originalPriceLabel = geEntityFromStoreByPath(store.view.customizations, 'prices.originalPriceLabel', 'Market price');
  var discountLabel = geEntityFromStoreByPath(store.view.customizations, 'prices.discountLabel', 'You save');
  var priceLabel = geEntityFromStoreByPath(store.view.customizations, 'prices.dealPriceLabel', 'You pay');
  var showPointsRow = geEntityFromStoreByPath(store.view.customizations, 'points.showPoints', false);
  var _getPrices = getPrices(store.product.prices),
    originalPrice = _getPrices.originalPrice,
    discount = _getPrices.discount,
    price = _getPrices.price,
    showOriginalPrice = _getPrices.showOriginalPrice;
  var variant = store.product.variants.currentVariantData;
  var hasReferralSession = store.product.data.hasReferralSession;
  var sessionExpiresAt = (_store$product = store.product) === null || _store$product === void 0 ? void 0 : (_store$product$referr = _store$product.referralSession) === null || _store$product$referr === void 0 ? void 0 : _store$product$referr.isExpired;
  var referralSession = hasReferralSession && !sessionExpiresAt;
  var handleExpired = function handleExpired() {
    try {
      return Promise.resolve(store.product.onGetRefereeSession()).then(function () {
        setModal(/*#__PURE__*/React__default.createElement(RewardExpired, {
          onModalClose: hideModal
        }), {
          closable: false
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, referralSession && simple ? /*#__PURE__*/React__default.createElement(StyledOffer, {
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeMedium"
  }, "Exclusive offer is available for"), /*#__PURE__*/React__default.createElement(StyledOfferTimer, {
    type: "badgeLarge"
  }, /*#__PURE__*/React__default.createElement(ReferralOfferTimer, {
    referralSession: (_store$product2 = store.product) === null || _store$product2 === void 0 ? void 0 : _store$product2.referralSession,
    onExpired: handleExpired
  }), ' ', /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgTime, null);
    }
  }))) : null, /*#__PURE__*/React__default.createElement(Styles$7, {
    style: referralSession ? null : BOTTOM_INDENTS.SM
  }, showOriginalPrice && originalPrice && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(PriceRow, {
    title: originalPriceLabel,
    price: !((_store$view$customiza = store.view.customizations.rewards) !== null && _store$view$customiza !== void 0 && _store$view$customiza.showRewards) ? originalPrice : "$" + roundToLocaleString((variant === null || variant === void 0 ? void 0 : (_variant$priceDetails = variant.priceDetails) === null || _variant$priceDetails === void 0 ? void 0 : _variant$priceDetails.originalPrice) * store.product.variants.qty)
  })), discount && !((_store$view$customiza2 = store.view.customizations.rewards) !== null && _store$view$customiza2 !== void 0 && _store$view$customiza2.showRewards) && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(PriceRow, {
    title: discountLabel,
    price: discount
  })), (_store$view$customiza3 = store.view.customizations.rewards) !== null && _store$view$customiza3 !== void 0 && _store$view$customiza3.showRewards ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(RewardsApplied, null), /*#__PURE__*/React__default.createElement(TotalPrice, {
    referralSession: referralSession
  }), ((_store$view$customiza4 = store.view.customizations.cashBack) === null || _store$view$customiza4 === void 0 ? void 0 : _store$view$customiza4.showCashBack) && /*#__PURE__*/React__default.createElement(CashBackInfo, null)) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(PriceRow, {
    type: "deal",
    title: priceLabel,
    price: price
  })), showPointsRow ? /*#__PURE__*/React__default.createElement(EarnedPoints, null) : null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    color: "secondaryText",
    type: "descriptor2",
    "data-e2e": "pdp_shipping-info_text"
  }, "Shipping and taxes are calculated at checkout")), referralSession && !simple ? /*#__PURE__*/React__default.createElement(StyledOffer, {
    style: BOTTOM_INDENTS.SM
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeMedium"
  }, "Exclusive offer is available for"), /*#__PURE__*/React__default.createElement(StyledOfferTimer, {
    type: "badgeLarge"
  }, /*#__PURE__*/React__default.createElement(ReferralOfferTimer, {
    referralSession: (_store$product3 = store.product) === null || _store$product3 === void 0 ? void 0 : _store$product3.referralSession,
    onExpired: handleExpired
  }), ' ', /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgTime, null);
    }
  }))) : null);
}));

var _templateObject$1j, _templateObject2$U, _templateObject3$z;
var ReviewsStarRatingWrap = styled.div(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteralLoose(["\n    margin-right: 16px;\n"])));
var StyledStars = styled.div(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    font-size: ", ";\n    font-family: Times, serif;\n    line-height: 1;\n\n    &::before {\n        content: '\u2605\u2605\u2605\u2605\u2605';\n        letter-spacing: 3px;\n        background: ", "\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n    }\n"])), function (_ref) {
  var $starSize = _ref.$starSize;
  return $starSize;
}, function (_ref2) {
  var $ratePercent = _ref2.$ratePercent;
  return $ratePercent ? css(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteralLoose(["linear-gradient(90deg, #fc0 ", ", #F4F4F4 ", ");"])), $ratePercent, $ratePercent) : '';
});

var ReviewsStarRating = observer(function (_ref) {
  var rate = _ref.rate,
    _ref$starSize = _ref.starSize,
    starSize = _ref$starSize === void 0 ? '24px' : _ref$starSize;
  var ratePercent = rate / 5 * 100 + "%";
  return /*#__PURE__*/React__default.createElement(ReviewsStarRatingWrap, null, /*#__PURE__*/React__default.createElement(StyledStars, {
    "data-e2e": "pdp_rate-star-" + rate + "_icon",
    $ratePercent: ratePercent,
    $starSize: starSize
  }));
});

var Styles$8 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1srkrmo-0"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:", ";"], function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? '16px' : '0';
});
var ReviewsRatingData = styled.div.withConfig({
  displayName: "styles__ReviewsRatingData",
  componentId: "sc-1srkrmo-1"
})(["display:flex;align-items:center;"]);
var StyledButton$3 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1srkrmo-2"
})(["&&{padding:0;margin-left:16px;}"]);
var LoaderWrap = styled.div.withConfig({
  displayName: "styles__LoaderWrap",
  componentId: "sc-1srkrmo-3"
})(["position:relative;"]);

var ReviewsRating = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var rating = store.product.getData('rating');
  return /*#__PURE__*/React__default.createElement(Styles$8, {
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(ReviewsStarRating, {
    rate: rating
  }));
}));

var Styles$9 = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-3wo63h-0"
})(["display:flex;flex-wrap:nowrap;align-items:center;"]);
var StarRatingItemWrap = styled.div.withConfig({
  displayName: "styles__StarRatingItemWrap",
  componentId: "sc-3wo63h-1"
})([""]);

var _excluded$M = ["value", "maxRate", "onChange"];
var StarRatingItems = function StarRatingItems(_ref) {
  var rate = _ref.rate,
    _ref$maxRate = _ref.maxRate,
    maxRate = _ref$maxRate === void 0 ? 5 : _ref$maxRate,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/React__default.createElement(SvgFilledStar, null) : _ref$icon,
    onItemClick = _ref.onItemClick;
  return Array.from(new Array(maxRate).keys()).map(function (index) {
    return /*#__PURE__*/React__default.createElement(StarRatingItemWrap, {
      key: index
    }, /*#__PURE__*/React__default.createElement(Icon, {
      "data-e2e": "write-review-modal_rating-" + (index + 1) + "_btn",
      size: "44px",
      roundedSize: "110%",
      color: rate >= index + 1 ? 'primary' : 'secondaryText',
      onClick: function onClick() {
        return onItemClick(index + 1);
      },
      component: function component() {
        return icon;
      }
    }), "\xA0 \xA0");
  });
};
var StarRating = function StarRating(_ref2) {
  var _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? 0 : _ref2$value,
    _ref2$maxRate = _ref2.maxRate,
    maxRate = _ref2$maxRate === void 0 ? 5 : _ref2$maxRate,
    onChange = _ref2.onChange,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$M);
  var _useState = useState(value),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var onRateSelect = function onRateSelect(_value) {
    setInputValue(_value);
    if (typeof onChange !== 'undefined') {
      onChange(_value);
    }
  };
  return /*#__PURE__*/React__default.createElement(Styles$9, rest, /*#__PURE__*/React__default.createElement(StarRatingItems, {
    maxRate: maxRate,
    rate: inputValue,
    onItemClick: onRateSelect
  }));
};

var _templateObject$1k, _templateObject2$V;
var StyledErrorField = styled.div(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    margin-bottom: 24px;\n"])));
var StyledIcon$5 = styled(Icon)(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteralLoose(["\n    margin: 0 16px 0 0;\n"])));

var ErrorField$1 = function ErrorField(_ref) {
  var error = _ref.error,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/React__default.createElement(SvgEmojiSadFrown, null) : _ref$icon,
    _ref$textType = _ref.textType,
    textType = _ref$textType === void 0 ? 'descriptor2' : _ref$textType;
  return /*#__PURE__*/React__default.createElement(StyledErrorField, null, showIcon && /*#__PURE__*/React__default.createElement(StyledIcon$5, {
    color: "error",
    size: "130%",
    component: function component() {
      return icon;
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    color: "error",
    type: textType
  }, error));
};

var StyledLabel$2 = styled.label.withConfig({
  displayName: "styled__StyledLabel",
  componentId: "sc-uds5gj-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;width:80px;height:80px;background-color:", ";cursor:pointer;"], COLORS.$background);
var StyledFormItem = styled(Form.Item).withConfig({
  displayName: "styled__StyledFormItem",
  componentId: "sc-uds5gj-1"
})(["position:relative;min-height:100px;"]);
var StyledUpload = styled(Upload).withConfig({
  displayName: "styled__StyledUpload",
  componentId: "sc-uds5gj-2"
})(["&.ant-upload-picture-card-wrapper{display:flex;overflow-x:auto;.ant-upload-list{display:flex;}.ant-upload.ant-upload-select-picture-card,.ant-upload-list-picture-card-container{width:80px;height:80px;}.ant-upload.ant-upload-select-picture-card{position:absolute;top:0;left:0;}}.ant-upload.ant-upload-select-picture-card,.ant-upload.ant-upload-select-picture-card:hover{border:none;}"]);

var ImageUpload = function ImageUpload() {
  var dummyRequest = function dummyRequest(_ref) {
    var onSuccess = _ref.onSuccess;
    setTimeout(function () {
      onSuccess('ok');
    }, 0);
  };
  var normFile = function normFile(e) {
    if (Array.isArray(e)) {
      return e;
    }
    return e === null || e === void 0 ? void 0 : e.fileList;
  };
  return /*#__PURE__*/React__default.createElement(StyledFormItem, {
    name: "images",
    valuePropName: "fileList",
    getValueFromEvent: normFile
  }, /*#__PURE__*/React__default.createElement(StyledUpload, {
    listType: "picture-card",
    multiple: true,
    showUploadList: {
      showPreviewIcon: false
    },
    accept: "image/*",
    customRequest: dummyRequest
  }, /*#__PURE__*/React__default.createElement(StyledLabel$2, {
    htmlFor: "pdp-upload-file"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    size: "24px",
    style: {
      marginBottom: '10px'
    },
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgImage, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "write-review-modal_add-image_btn",
    type: "descriptor2"
  }, "Add Image"))));
};

var StarRatingStyles = styled.div.withConfig({
  displayName: "styles__StarRatingStyles",
  componentId: "sc-oenccu-0"
})(["width:100%;"]);
var StyledButton$4 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-oenccu-1"
})(["margin-bottom:", ";"], function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? '130px' : '0';
});

var _excluded$N = ["images"];
var WriteReviewForm = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    onModalClose = _ref.onModalClose;
  var _store$reviews = store.reviews,
    writeReview = _store$reviews.writeReview,
    errorMessage = _store$reviews.errorMessage;
  var submitChallenge = store.useOnProductReviewSubmit();
  var onSubmit = function onSubmit(data) {
    return writeReview(data, onModalClose, submitChallenge);
  };
  var _Form$useForm = Form.useForm(),
    form = _Form$useForm[0];
  var simple = useSimpleInterface(GRID_POINTS$1.md);
  var submitted = function submitted(_ref2) {
    var images = _ref2.images,
      data = _objectWithoutPropertiesLoose(_ref2, _excluded$N);
    if (typeof onSubmit !== 'undefined') {
      var formData = new window.FormData();
      Object.keys(data).forEach(function (field) {
        formData.append(field, data[field]);
      });
      if (Array.isArray(images)) {
        images.forEach(function (image) {
          formData.append('images', image.originFileObj);
        });
      }
      if (typeof submitChallenge === 'function') {
        submitChallenge({
          rate: data.rating,
          review: data.content
        });
      }
      onSubmit(formData);
    }
  };
  return /*#__PURE__*/React__default.createElement(Form, {
    form: form,
    onFinish: submitted,
    validateTrigger: ['onBlur']
  }, /*#__PURE__*/React__default.createElement(Form.Item, {
    hidden: true,
    name: "rating",
    rules: [{
      required: true,
      message: /*#__PURE__*/React__default.createElement("span", {
        "data-e2e": "write-review-modal_rating_error"
      }, "Rate is required")
    }]
  }, /*#__PURE__*/React__default.createElement(Input, null)), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "write-review-modal_overall-rating_title",
    style: BOTTOM_INDENTS.SM,
    type: "body1"
  }, "Overall rating"), /*#__PURE__*/React__default.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: true
  }, function () {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StarRatingStyles, null, /*#__PURE__*/React__default.createElement(StarRating, {
      value: form.getFieldValue('rating'),
      onChange: function onChange(value) {
        form.setFields([{
          name: 'rating',
          touched: true,
          errors: [],
          value: value
        }]);
      }
    })), form.getFieldError('rating').length ? /*#__PURE__*/React__default.createElement(Typography.Text, {
      type: "description1",
      color: "error",
      style: BOTTOM_INDENTS.M
    }, form.getFieldError('rating')[0]) : null);
  }), /*#__PURE__*/React__default.createElement(Form.Item, {
    name: "content",
    rules: [{
      required: true,
      message: /*#__PURE__*/React__default.createElement("span", {
        "data-e2e": "write-review-modal_review-input_error"
      }, "This field is mandatory")
    }, {
      min: 50,
      message: /*#__PURE__*/React__default.createElement("span", {
        "data-e2e": "write-review-modal_review-input_error"
      }, "Should be at least 50 characters")
    }]
  }, /*#__PURE__*/React__default.createElement(Input.TextArea, {
    "data-e2e": "write-review-modal_review_input",
    autoSize: {
      minRows: 3
    },
    labelHeight: simple ? '48px' : '24px',
    label: "What did you like about this product? What did you use this product for?"
  })), /*#__PURE__*/React__default.createElement(ImageUpload, null), errorMessage ? /*#__PURE__*/React__default.createElement(ErrorField$1, {
    error: errorMessage
  }) : null, /*#__PURE__*/React__default.createElement(StyledButton$4, {
    "data-e2e": "write-review-modal_submit-review_btn",
    $simple: simple,
    htmlType: "submit",
    type: "primary",
    block: true
  }, "Submit a review"));
}));

var GRID_POINTS$2 = Object.freeze({
  xxxs: 300,
  xxs: 370,
  xs: 480,
  sm: 680,
  md: 850,
  lg: 950,
  xl: 1100,
  xxl: 1600
});
var GRID_DEVICES_MIN$1 = Object.freeze({
  xxs: "min-width: " + (GRID_POINTS$2.xxs + 1) + "px",
  xs: "min-width: " + (GRID_POINTS$2.xs + 1) + "px",
  sm: "min-width: " + (GRID_POINTS$2.sm + 1) + "px",
  md: "min-width: " + (GRID_POINTS$2.md + 1) + "px",
  lg: "min-width: " + (GRID_POINTS$2.lg + 1) + "px",
  xl: "min-width: " + (GRID_POINTS$2.xl + 1) + "px",
  xxl: "min-width: " + (GRID_POINTS$2.xxl + 1) + "px"
});
var GRID_DEVICES_MAX$1 = Object.freeze({
  xxxs: "max-width: " + GRID_POINTS$2.xxxs + "px",
  xxs: "max-width: " + GRID_POINTS$2.xxs + "px",
  xs: "max-width: " + GRID_POINTS$2.xs + "px",
  sm: "max-width: " + GRID_POINTS$2.sm + "px",
  md: "max-width: " + GRID_POINTS$2.md + "px",
  lg: "max-width: " + GRID_POINTS$2.lg + "px",
  xl: "max-width: " + GRID_POINTS$2.xl + "px",
  xxl: "max-width: " + GRID_POINTS$2.xxl + "px"
});

var debounce = function debounce(func, delay, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    leading = _ref.leading;
  var timerId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!timerId && leading) {
      func.apply(void 0, args);
    }
    clearTimeout(timerId);
    timerId = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};

var MIN_DISCOUNT_PERCENTAGE_TO_SHOW$1 = 3;
var isFree = function isFree(value) {
  return Math.round(value * 100) <= 0;
};
var getPrices$1 = function getPrices(prices, covered) {
  if (covered === void 0) {
    covered = {
      shipping: 0,
      taxes: 0
    };
  }
  var responsePrice = {
    subTotal: "$" + roundToLocaleString(prices.subTotal),
    originalSubTotal: "$" + roundToLocaleString(prices.originalSubTotal),
    originalDiscount: 0,
    discounts: Math.max((prices.discounts || 0) - covered.shipping - covered.taxes, 0),
    discountPercentage: '',
    showOriginalPrice: false
  };
  var isShipping = prices.shipping !== undefined && prices.shipping !== null;
  var isTaxes = prices.taxes !== undefined && prices.taxes !== null;
  if (prices.originalSubTotal && prices.originalSubTotal > prices.subTotal) {
    responsePrice.originalDiscount = prices.originalSubTotal - prices.subTotal;
    responsePrice.discounts += responsePrice.originalDiscount;
  }
  if (responsePrice.discounts) {
    var percentage = Number(responsePrice.discounts) / Number(prices.total + responsePrice.originalDiscount) * 100;
    var showDiscountPercentage = percentage > MIN_DISCOUNT_PERCENTAGE_TO_SHOW$1;
    responsePrice.discountPercentage = showDiscountPercentage ? "(" + roundToLocaleString(percentage, 0) + "% off)" : '';
    responsePrice.discounts = "-$" + roundToLocaleString(responsePrice.discounts);
  }
  if (isShipping) {
    var shipping = prices.shipping - covered.shipping;
    responsePrice.shipping = isFree(shipping) ? 'Free' : "$" + roundToLocaleString(shipping);
  }
  if (isTaxes) {
    var taxes = prices.taxes - covered.taxes;
    responsePrice.taxes = isFree(taxes) ? 'Free' : "$" + roundToLocaleString(taxes);
  }
  responsePrice.fullTotal = responsePrice.fullTotal === 0 ? 'Free' : "$" + roundToLocaleString(prices.fullTotal);
  return responsePrice;
};

var Styles$a = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-qgjtet-0"
})(["background-color:", ";position:relative;"], COLORS.$white);
var FormWrapper = styled.div.withConfig({
  displayName: "styles__FormWrapper",
  componentId: "sc-qgjtet-1"
})(["padding:", ";"], function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? '24px' : '40px';
});
var CloseModalIcon$3 = styled(Icon).withConfig({
  displayName: "styles__CloseModalIcon",
  componentId: "sc-qgjtet-2"
})(["position:absolute;bottom:100%;margin-bottom:24px;font-size:24px;left:50%;transform:translate3d(-50%,0,0);"]);
var StyledHeader = styled.div.withConfig({
  displayName: "styles__StyledHeader",
  componentId: "sc-qgjtet-3"
})(["padding:40px;background:", ";@media (", "){padding:24px;}"], COLORS.$tartRed, GRID_DEVICES_MAX$1.md);

var WriteReview = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    onModalClose = _ref.onModalClose,
    simple = _ref.simple;
  var writing = store.reviews.writing;
  return /*#__PURE__*/React__default.createElement(Styles$a, {
    "data-e2e": "write-review-modal_content"
  }, writing ? /*#__PURE__*/React__default.createElement(Icon.Loader, null) : null, /*#__PURE__*/React__default.createElement(CloseModalIcon$3, {
    "data-e2e": "write-review-modal_close_btn",
    color: "canvas",
    onClick: onModalClose,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  }), /*#__PURE__*/React__default.createElement(StyledHeader, null, simple ? /*#__PURE__*/React__default.createElement(Icon, {
    size: "24px",
    color: "primary",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBackArrow, null);
    },
    onClick: onModalClose,
    style: BOTTOM_INDENTS.S
  }) : null, /*#__PURE__*/React__default.createElement(Typography.Title, {
    "data-e2e": "write-review-modal_title",
    color: "primary",
    align: simple ? 'left' : 'center',
    style: BOTTOM_INDENTS.S
  }, "Write a review"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "write-review-modal_description",
    type: "body1",
    color: "primary",
    align: simple ? 'left' : 'center'
  }, "Tell us what you think of your products")), /*#__PURE__*/React__default.createElement(FormWrapper, {
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(WriteReviewForm, {
    onModalClose: onModalClose
  })));
}));

var _templateObject$1l, _templateObject2$W;
var Styles$b = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-17mdldc-0"
})(["width:630px;margin:70px 0;background-color:#ffffff;", ""], function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteralLoose(["\n                  width: 100%;\n                  height: 100%;\n                  margin: 0;\n              "]))) : '';
});
var StyledModal = createGlobalStyle(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteralLoose(["\n    .ant-modal-close {\n        display: none;\n    }\n"])));

var WriteReviewModal = observer(function (_ref) {
  var onModalClose = _ref.onModalClose,
    simple = _ref.simple,
    store = _ref.store;
  if (typeof store.useProductReviewNotification === 'function') {
    var _store$notifications;
    store.useProductReviewNotification((_store$notifications = store.notifications) === null || _store$notifications === void 0 ? void 0 : _store$notifications.PRODUCT_REVIEW[4]);
  }
  return /*#__PURE__*/React__default.createElement(Styles$b, {
    simple: simple
  }, /*#__PURE__*/React__default.createElement(StyledModal, null), /*#__PURE__*/React__default.createElement(WriteReview, {
    simple: simple,
    onModalClose: onModalClose
  }));
});

var useWriteReviewModal = function useWriteReviewModal(simple, store) {
  if (simple === void 0) {
    simple = false;
  }
  var _useModal = useModal(),
    setModal = _useModal.setModal,
    hideModal = _useModal.hideModal;
  return useCallback(function () {
    setModal(/*#__PURE__*/React__default.createElement(WriteReviewModal, {
      store: store,
      simple: simple,
      onModalClose: hideModal
    }), {
      fullscreen: simple
    });
  }, [setModal, hideModal, simple]);
};

var _templateObject$1m, _templateObject2$X, _templateObject3$A;
var ReviewStyles = styled.div.withConfig({
  displayName: "styles__ReviewStyles",
  componentId: "sc-1d3yu7n-0"
})(["width:100%;padding:", ";"], function (_ref) {
  var withPadding = _ref.withPadding;
  return withPadding ? '0 24px' : '0';
});
var ReviewHead = styled.div.withConfig({
  displayName: "styles__ReviewHead",
  componentId: "sc-1d3yu7n-1"
})(["width:100%;"]);
var ReviewHeadLine = styled.div.withConfig({
  displayName: "styles__ReviewHeadLine",
  componentId: "sc-1d3yu7n-2"
})(["width:100%;display:flex;flex-direction:", ";justify-content:", ";align-items:", ";"], function (_ref2) {
  var direction = _ref2.direction;
  return direction || 'row';
}, function (_ref3) {
  var justify = _ref3.justify;
  return justify || 'space-between';
}, function (_ref4) {
  var align = _ref4.align;
  return align || 'start';
});
var StyledButton$5 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1d3yu7n-3"
})(["&&{margin-left:10px;padding-right:0;.anticon{display:flex;align-items:center;margin-left:12px;}}"]);
var ReviewBody = styled.div.withConfig({
  displayName: "styles__ReviewBody",
  componentId: "sc-1d3yu7n-4"
})([""]);
var ReviewText = styled(Typography.Text).withConfig({
  displayName: "styles__ReviewText",
  componentId: "sc-1d3yu7n-5"
})(["", ""], function (_ref5) {
  var $fullReview = _ref5.$fullReview;
  return !$fullReview ? css(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteralLoose(["\n                  display: -webkit-box;\n                  -webkit-line-clamp: 4;\n                  -webkit-box-orient: vertical;\n                  text-overflow: ellipsis;\n                  overflow: hidden;\n              "]))) : '';
});
var ReviewImages = styled.div.withConfig({
  displayName: "styles__ReviewImages",
  componentId: "sc-1d3yu7n-6"
})(["max-width:100%;", " ", ""], function (_ref6) {
  var scrollImages = _ref6.scrollImages;
  return scrollImages ? css(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteralLoose(["\n                  display: flex;\n                  overflow-x: auto;\n              "]))) : '';
}, function (_ref7) {
  var $fullReview = _ref7.$fullReview;
  return $fullReview ? css(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteralLoose(["\n                  width: 100%;\n                  display: flex;\n                  flex-wrap: wrap;\n                  justify-content: center;\n              "]))) : '';
});
var StyledImage$1 = styled(Image).withConfig({
  displayName: "styles__StyledImage",
  componentId: "sc-1d3yu7n-7"
})(["max-height:", ";width:auto;object-fit:contain;margin-right:16px;margin-bottom:16px;display:inline-block;"], function (_ref8) {
  var $fullReview = _ref8.$fullReview;
  return $fullReview ? '200px' : '80px';
});

var Review = observer(function (_ref) {
  var review = _ref.review,
    showReview = _ref.showReview,
    _ref$withPadding = _ref.withPadding,
    withPadding = _ref$withPadding === void 0 ? false : _ref$withPadding,
    _ref$scrollImages = _ref.scrollImages,
    scrollImages = _ref$scrollImages === void 0 ? false : _ref$scrollImages,
    _ref$fullReview = _ref.fullReview,
    fullReview = _ref$fullReview === void 0 ? false : _ref$fullReview;
  var createdAt = new Date(review.createdAt).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return /*#__PURE__*/React__default.createElement(ReviewStyles, {
    withPadding: withPadding,
    "data-e2e": "pdp_review-" + review._id + "_card"
  }, /*#__PURE__*/React__default.createElement(ReviewHead, {
    style: BOTTOM_INDENTS.SM
  }, /*#__PURE__*/React__default.createElement(ReviewHeadLine, {
    style: BOTTOM_INDENTS.SM,
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body1",
    "data-e2e": "pdp_review-customer-name_value"
  }, review.customerFullName), !fullReview && /*#__PURE__*/React__default.createElement(StyledButton$5, {
    "data-e2e": "pdp_read-full-review_btn",
    size: "medium",
    type: "unstyled",
    onClick: function onClick() {
      return showReview(review);
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "Read full review"), /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgForwardArrow, null);
    }
  }))), /*#__PURE__*/React__default.createElement(ReviewHeadLine, {
    style: BOTTOM_INDENTS.SM
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "descriptor2",
    color: "secondaryText",
    "data-e2e": "pdp_review-date_value"
  }, (review === null || review === void 0 ? void 0 : review.customer) && /*#__PURE__*/React__default.createElement(Fragment, null, "Giftly member \u2022\xA0"), "Purchased ", createdAt)), /*#__PURE__*/React__default.createElement(ReviewHeadLine, null, /*#__PURE__*/React__default.createElement(ReviewsStarRating, {
    rate: review.rating
  }))), /*#__PURE__*/React__default.createElement(ReviewBody, null, /*#__PURE__*/React__default.createElement(ReviewText, {
    style: BOTTOM_INDENTS.SM,
    $fullReview: fullReview,
    type: "body2",
    color: "primaryText",
    "data-e2e": "pdp_review-content_value"
  }, review.content), /*#__PURE__*/React__default.createElement(ReviewImages, {
    $fullReview: fullReview,
    scrollImages: scrollImages
  }, review.images && review.images.length ? review.images.map(function (image, key) {
    return /*#__PURE__*/React__default.createElement(StyledImage$1, {
      key: key,
      src: image.src,
      $fullReview: fullReview,
      "data-e2e": "pdp_review_image"
    });
  }) : null)));
});

var _templateObject$1n;
var StyledNoReviewWrapper = styled.div(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])));

var NoReview = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var theme = useContext(KliThemeContext);
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var openWriteReviewModal = useWriteReviewModal(simple, store);
  return /*#__PURE__*/React__default.createElement(StyledNoReviewWrapper, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "pdp_no-review_placeholder",
    align: "center",
    type: "body2",
    color: theme.colors.secondaryText,
    style: BOTTOM_INDENTS.M
  }, "There are no reviews for this product ", /*#__PURE__*/React__default.createElement("br", null), store.view.isLoggedIn ? 'Your review may be the first.' : null), store.view.isLoggedIn ? /*#__PURE__*/React__default.createElement(Button, {
    type: "secondary",
    onClick: openWriteReviewModal,
    "data-e2e": "pdp_write-a-review_btn"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgComment1, null);
    },
    style: RIGHT_INDENTS.XS
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "Write a review")) : null);
}));

var CenteredButton = styled(Button).withConfig({
  displayName: "styles__CenteredButton",
  componentId: "sc-1t77yzh-0"
})(["&&{margin:0 auto;.anticon{display:flex;align-items:center;margin-left:8px;}}"]);
var StyledButton$6 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1t77yzh-1"
})(["&&{width:fit-content;padding-left:0;margin:", ";.anticon{display:flex;align-items:center;margin-left:12px;}}"], function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? '0 auto' : '0';
});
var StyledLoaderWrapper$2 = styled.div.withConfig({
  displayName: "styles__StyledLoaderWrapper",
  componentId: "sc-1t77yzh-2"
})(["position:relative;height:160px;> *{top:50%;left:50%;transform:translate(-50%,-50%);}"]);

var ReviewsContainer = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    _ref$withPadding = _ref.withPadding,
    withPadding = _ref$withPadding === void 0 ? false : _ref$withPadding,
    _ref$loadMoreEnabled = _ref.loadMoreEnabled,
    loadMoreEnabled = _ref$loadMoreEnabled === void 0 ? false : _ref$loadMoreEnabled,
    _ref$scrollReviewImag = _ref.scrollReviewImages,
    scrollReviewImages = _ref$scrollReviewImag === void 0 ? false : _ref$scrollReviewImag,
    simple = _ref.simple;
  var maxVisibleReviews = loadMoreEnabled ? 10e6 : 3;
  var _store$reviews = store.reviews,
    reviews = _store$reviews.reviews,
    loadReviews = _store$reviews.loadReviews,
    isLoading = _store$reviews.isLoading,
    page = _store$reviews.page,
    totalPages = _store$reviews.totalPages;
  var showLoadMoreButton = totalPages > page;
  var openWriteReviewModal = useWriteReviewModal(simple, store);
  useEffect(function () {
    if (!(reviews !== null && reviews !== void 0 && reviews.length)) loadReviews();
  }, []);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(StyledLoaderWrapper$2, null, /*#__PURE__*/React__default.createElement(Icon.Loader, null));
  }
  return reviews && reviews !== null && reviews !== void 0 && reviews.length ? /*#__PURE__*/React__default.createElement(Fragment, null, store.view.isLoggedIn ? /*#__PURE__*/React__default.createElement(Button, {
    type: "secondary",
    onClick: openWriteReviewModal,
    style: _extends({}, withPadding ? LEFT_INDENTS.M : {}, BOTTOM_INDENTS.M)
  }, /*#__PURE__*/React__default.createElement(Icon, {
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgComment1, null);
    },
    style: RIGHT_INDENTS.XS
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "pdp_write-a-review_btn",
    type: "badgeSmall"
  }, "Write a review")) : null, reviews.map(function (review, key) {
    if (key + 1 <= maxVisibleReviews) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: key,
        style: BOTTOM_INDENTS.XL
      }, /*#__PURE__*/React__default.createElement(Review, {
        review: review,
        showReview: function showReview() {
          return store.reviews.showReview(review._id);
        },
        withPadding: withPadding,
        scrollImages: scrollReviewImages
      }));
    }
    return null;
  }), showLoadMoreButton && !loadMoreEnabled ? /*#__PURE__*/React__default.createElement(StyledButton$6, {
    style: TOP_INDENTS.SM,
    $simple: simple,
    type: "unstyled",
    onClick: function onClick() {
      return store.view.setRoute('reviews');
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeMedium",
    "data-e2e": "pdp_read-all-reviews_btn"
  }, "Read all reviews"), /*#__PURE__*/React__default.createElement(Icon, {
    size: "24px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgForwardArrow, null);
    }
  })) : null, showLoadMoreButton && loadMoreEnabled ? /*#__PURE__*/React__default.createElement(CenteredButton, {
    style: TOP_INDENTS.SM,
    type: "unstyled",
    onClick: function onClick() {
      return loadReviews(true);
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall",
    "data-e2e": "pdp_load-more-reviews_btn"
  }, "Load more reviews"), /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgArrowChevronDown, null);
    }
  })) : null) : /*#__PURE__*/React__default.createElement(NoReview, null);
}));

var HtmlViewer = function HtmlViewer(_ref) {
  var html = _ref.html;
  if (!html) return null;
  var createMarkup = function createMarkup() {
    return {
      __html: html
    };
  };
  return /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: createMarkup()
  });
};

var StyledLink = styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "sc-1ie90q1-0"
})(["display:flex;padding:12px 0;.anticon{margin-left:10px;}"]);

var _templateObject$1o;
var StyledText$6 = styled(Typography.Text).withConfig({
  displayName: "StyledText",
  componentId: "sc-bjrjet-0"
})(["width:100%;padding-bottom:20px;", ""], function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteralLoose(["\n                  padding: 0 24px 20px;\n              "]))) : '';
});

var AMAZON_AFFILIATE = 'https://amzn.to/4h6NVov';
var getElemAttrs = function getElemAttrs(target) {
  if (target === void 0) {
    target = {};
  }
  var element = {
    tagName: target.tagName.toLowerCase()
  };
  element.className = 'amazon_test';
  element.src = target.src || undefined;
  element.href = target.href || undefined;
  return {
    element: element
  };
};
var Details = function Details(_ref) {
  var data = _ref.data,
    _ref$simple = _ref.simple,
    simple = _ref$simple === void 0 ? false : _ref$simple,
    brandLink = _ref.brandLink;
  return /*#__PURE__*/React__default.createElement(StyledText$6, {
    "data-e2e": "pdp_product-description_value",
    simple: simple,
    type: "descriptor1",
    color: "primaryText",
    as: "div"
  }, /*#__PURE__*/React__default.createElement(HtmlViewer, {
    html: data
  }), /*#__PURE__*/React__default.createElement(Row, {
    style: TOP_INDENTS.XL
  }, brandLink !== '' ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(StyledLink, {
    style: RIGHT_INDENTS.XL,
    "data-e2e": "pdp_view-in-store_link",
    href: brandLink,
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "div",
    type: "badgeSmall"
  }, "View in brand store"), /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgArrowGoingUp, null);
    }
  }))) : null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(StyledLink, {
    "data-e2e": "pdp_view-on-amazon_link",
    onClick: function onClick(e) {
      window.klpixel('event', 'click', getElemAttrs(e.currentTarget));
    },
    href: AMAZON_AFFILIATE,
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "div",
    type: "badgeSmall"
  }, "View on Amazon"), /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgArrowGoingUp, null);
    }
  })))));
};

var _templateObject$1p, _templateObject2$Y;
var TabHead = styled.div(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteralLoose(["\n    display: flex;\n    margin-bottom: 20px;\n"])));
var TabHeadItem = styled.button(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteralLoose(["\n    background-color: transparent;\n    border: none;\n    outline: none;\n    color: ", ";\n\n    width: 50%;\n    padding: 16px;\n    cursor: pointer;\n\n    border-bottom: ", ";\n"])), function (_ref) {
  var active = _ref.active;
  return active ? COLORS.$primaryText : COLORS.$secondaryText;
}, function (_ref2) {
  var active = _ref2.active;
  return active ? "4px solid " + COLORS.$primary : "1px solid " + COLORS.$bordered;
});

var Tabs$1 = inject('store')(observer(function (_ref) {
  var _store$view$customiza, _store$view$customiza2;
  var store = _ref.store;
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var details = store.product.getData('description');
  var reviews = store.reviews.reviews;
  var brandLink = store.product.getData('brandLink');
  var handleParameter = store.product.getData('handle');
  var _useState = useState('details'),
    currentTab = _useState[0],
    setCurrentTab = _useState[1];
  useEffect(function () {
    if (!details && reviews) {
      setCurrentTab('reviews');
    }
  }, [details, reviews]);
  if (typeof store.useProductReviewNotification === 'function') {
    var _store$notifications;
    store.useProductReviewNotification((_store$notifications = store.notifications) === null || _store$notifications === void 0 ? void 0 : _store$notifications.PRODUCT_REVIEW[3], currentTab);
  }
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TabHead, null, details ? /*#__PURE__*/React__default.createElement(TabHeadItem, {
    "data-e2e": "pdp_product-description_tab",
    simple: simple,
    active: currentTab === 'details',
    onClick: function onClick() {
      return setCurrentTab('details');
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeMedium",
    align: "center"
  }, "Product description")) : null, (_store$view$customiza = store.view.customizations) !== null && _store$view$customiza !== void 0 && (_store$view$customiza2 = _store$view$customiza.reviews) !== null && _store$view$customiza2 !== void 0 && _store$view$customiza2.showReviews ? /*#__PURE__*/React__default.createElement(TabHeadItem, {
    "data-e2e": "pdp_reviews_tab",
    active: currentTab === 'reviews',
    onClick: function onClick() {
      return setCurrentTab('reviews');
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeMedium",
    align: "center"
  }, "Reviews")) : null), /*#__PURE__*/React__default.createElement("div", {
    style: BOTTOM_INDENTS.XL
  }, details && currentTab === 'details' ? /*#__PURE__*/React__default.createElement(Details, {
    simple: simple,
    data: details,
    brandLink: brandLink
  }) : null, currentTab === 'reviews' ? /*#__PURE__*/React__default.createElement(ReviewsContainer, {
    simple: simple,
    withPadding: simple,
    scrollReviewImages: true
  }) : null));
}));

var _templateObject$1q, _templateObject2$Z, _templateObject3$B, _templateObject4$s, _templateObject5$i;
var StyledProductInfoWrapper = styled.div.withConfig({
  displayName: "styles__StyledProductInfoWrapper",
  componentId: "sc-1h5zpst-0"
})(["max-width:calc(100% - 433px);width:100%;position:relative;", ";", ";"], function (_ref) {
  var $appWidth = _ref.$appWidth;
  return $appWidth <= GRID_POINTS$1.md ? css(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteralLoose(["\n                  max-width: calc(100% - 320px);\n              "]))) : '';
}, function (_ref2) {
  var $appWidth = _ref2.$appWidth;
  return $appWidth <= GRID_POINTS$1.sm ? css(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n              "]))) : '';
});
var StyledInfo = styled.div.withConfig({
  displayName: "styles__StyledInfo",
  componentId: "sc-1h5zpst-1"
})(["", ";"], function (_ref3) {
  var simple = _ref3.simple;
  return simple ? css(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteralLoose(["\n                  padding: 0 24px;\n              "]))) : '';
});
var StyledBrandNameButton = styled(Button).withConfig({
  displayName: "styles__StyledBrandNameButton",
  componentId: "sc-1h5zpst-2"
})(["&&{padding:0 !important;cursor:", ";&&{&:focus{outline:none;}}}"], function (_ref4) {
  var $linkToBrand = _ref4.$linkToBrand;
  return $linkToBrand ? 'pointer' : 'auto';
});
var StyledBrandName = styled(Typography.Text).withConfig({
  displayName: "styles__StyledBrandName",
  componentId: "sc-1h5zpst-3"
})(["", ";"], function (_ref5) {
  var $appWidth = _ref5.$appWidth;
  return $appWidth <= GRID_POINTS$1.xxs ? css(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteralLoose(["\n                  font-size: 14px;\n              "]))) : '';
});
var StyledTitle$2 = styled(Typography.Title).withConfig({
  displayName: "styles__StyledTitle",
  componentId: "sc-1h5zpst-4"
})(["margin-bottom:6px;", ";"], function (_ref6) {
  var $appWidth = _ref6.$appWidth;
  return $appWidth <= GRID_POINTS$1.xxs ? css(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteralLoose(["\n                  font-size: 18px;\n              "]))) : '';
});

var ProductInfo = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    optionsRef = _ref.optionsRef,
    bottomExtraContent = _ref.bottomExtraContent,
    customButtons = _ref.customButtons;
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var appWidth = store.view.appWidth;
  var selectedVariant = store.product.variants.selectedVariant;
  var brandLink = store.product.getData('brandLink');
  var publisherEnableFlatCashback = store.product.getData('publisherEnableFlatCashback');
  var brandId = store.product.getData('accountId');
  var rating = store.product.getData('rating');
  var httpError = store.errors.getError('httpProductError');
  var scrollToOptions = function scrollToOptions() {
    if (optionsRef && optionsRef.current) {
      optionsRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  var quantity = store.product.variants.qty;
  var onVariantChange = store.callbacks.onVariantChange;
  useEffect(function () {
    if (typeof onVariantChange === 'function' && selectedVariant !== null && selectedVariant !== void 0 && selectedVariant.cashbackPrice) {
      onVariantChange(selectedVariant.cashbackPrice);
    }
  }, [selectedVariant, quantity, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.cashbackPrice]);
  var onBrandNameClick = function onBrandNameClick(e) {
    e.stopPropagation();
    if (!brandLink && publisherEnableFlatCashback !== null || !brandId) return null;
    store.callbacks.onBrandNameClick(store.product.trackingData, brandLink, brandId);
  };
  return /*#__PURE__*/React__default.createElement(StyledProductInfoWrapper, {
    "data-e2e": "pdp_product-info_block",
    $appWidth: appWidth
  }, /*#__PURE__*/React__default.createElement(StyledInfo, {
    style: BOTTOM_INDENTS.SM,
    simple: simple
  }, rating !== null && simple ? /*#__PURE__*/React__default.createElement(ReviewsRating, null) : null, /*#__PURE__*/React__default.createElement(StyledBrandNameButton, {
    "data-e2e": "pdp_brand-name_btn",
    type: "unstyled",
    $linkToBrand: true,
    onClick: onBrandNameClick
  }, /*#__PURE__*/React__default.createElement(StyledBrandName, {
    $appWidth: appWidth,
    color: "secondaryText",
    type: "body1"
  }, store.product.getData('brandName', ''))), /*#__PURE__*/React__default.createElement(StyledTitle$2, {
    "data-e2e": "pdp_product-title_value",
    level: 2,
    $appWidth: appWidth
  }, store.product.getData('title', '')), rating !== null && !simple ? /*#__PURE__*/React__default.createElement(ReviewsRating, null) : null), /*#__PURE__*/React__default.createElement(OptionsBlock, {
    optionsRef: optionsRef
  }), /*#__PURE__*/React__default.createElement(Prices, null), simple && bottomExtraContent ? bottomExtraContent : null, httpError ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ErrorField, {
    showIcon: true,
    icon: /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertInfo, null),
    error: httpError
  })) : null, !simple && /*#__PURE__*/React__default.createElement("div", {
    style: BOTTOM_INDENTS.SM
  }, /*#__PURE__*/React__default.createElement(CheckoutButtons, {
    scrollToOptionsCallback: scrollToOptions,
    customButtons: customButtons,
    hasBottomIndent: true
  })), /*#__PURE__*/React__default.createElement(Tabs$1, null));
}));

var _templateObject$1r;
var StyledPdpPage = styled.div.withConfig({
  displayName: "StyledPdpPage",
  componentId: "sc-7rpc0s-0"
})(["display:flex;position:relative;", ";"], function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteralLoose(["\n                  display: block;\n              "]))) : '';
});

var PDPPage = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    bottomExtraContent = _ref.bottomExtraContent,
    customButtons = _ref.customButtons;
  var optionsRef = useRef(null);
  if (store.isLoading) {
    return /*#__PURE__*/React__default.createElement(Icon.Loader, null);
  }
  var scrollToOptions = function scrollToOptions() {
    if (optionsRef && optionsRef.current) {
      optionsRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  return /*#__PURE__*/React__default.createElement(StyledPdpPage, {
    simple: simple
  }, store.product.isLoading && /*#__PURE__*/React__default.createElement(Icon.Loader, {
    zIndex: 10,
    overlayColor: "rgba(255,255,255, 0.8)"
  }), /*#__PURE__*/React__default.createElement(ProductImage, null), /*#__PURE__*/React__default.createElement(ProductInfo, {
    optionsRef: optionsRef,
    bottomExtraContent: bottomExtraContent,
    customButtons: customButtons
  }), simple && /*#__PURE__*/React__default.createElement(CheckoutButtons, {
    scrollToOptionsCallback: scrollToOptions,
    customButtons: customButtons
  }));
}));

var Styles$c = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1g3dr5i-0"
})(["width:100%;"]);
var HeadStyles$1 = styled.div.withConfig({
  displayName: "styles__HeadStyles",
  componentId: "sc-1g3dr5i-1"
})(["display:flex;padding:20px 0;border-bottom:1px solid ", ";margin-bottom:20px;"], COLORS.$background);
var BodyStyles$3 = styled.div.withConfig({
  displayName: "styles__BodyStyles",
  componentId: "sc-1g3dr5i-2"
})(["padding:0 24px;"]);
var StyledButton$7 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1g3dr5i-3"
})(["&&{padding:0;margin-right:16px;margin-left:20px;.anticon{display:flex;align-items:center;margin-right:12px;}}"]);

var ReviewPage = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var pageRef = useRef(null);
  var activeReview = store.reviews.getActiveReview();
  useEffect(function () {
    if (pageRef !== null && pageRef !== void 0 && pageRef.current) pageRef.current.scrollIntoView();
  }, []);
  return /*#__PURE__*/React__default.createElement(Styles$c, {
    ref: pageRef
  }, /*#__PURE__*/React__default.createElement(HeadStyles$1, null, /*#__PURE__*/React__default.createElement(StyledButton$7, {
    "data-e2e": "pdp_back_btn",
    type: "unstyled",
    onClick: store.reviews.backToPDP
  }, /*#__PURE__*/React__default.createElement(Icon, {
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBackArrow, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall",
    "data-e2e": "pdp_reviews_title"
  }, "Reviews"))), /*#__PURE__*/React__default.createElement(BodyStyles$3, null, /*#__PURE__*/React__default.createElement(Review, {
    fullReview: true,
    review: activeReview
  })));
}));

var Styles$d = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-oknbcz-0"
})(["padding:0 24px;"]);

var ReviewsPage = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var headRef = useRef(null);
  useEffect(function () {
    if (headRef) {
      headRef.current.scrollIntoView();
    }
  }, [headRef]);
  return /*#__PURE__*/React__default.createElement(Styles$d, {
    ref: headRef
  }, /*#__PURE__*/React__default.createElement(KliHero, {
    simple: false,
    title: "Reviews",
    subTitle: store.product.getData('title', ''),
    withoutBorders: true,
    style: _extends({
      padding: 0
    }, BOTTOM_INDENTS.M),
    onBack: store.reviews.backToPDP
  }), /*#__PURE__*/React__default.createElement(ReviewsContainer, {
    loadMoreEnabled: true,
    scrollReviewImages: true
  }));
}));

var WrapStyles$2 = styled.div.withConfig({
  displayName: "styles__WrapStyles",
  componentId: "sc-vw14pc-0"
})(["width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow-y:auto;margin-top:24px;padding:40px 0;.anticon{margin-bottom:64px;}"]);
var ContentStyles$1 = styled.div.withConfig({
  displayName: "styles__ContentStyles",
  componentId: "sc-vw14pc-1"
})(["max-width:455px;display:flex;flex-direction:column;align-items:center;"]);
var StyledButton$8 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-vw14pc-2"
})(["&&{padding-left:60px;padding-right:60px;}"]);
var StyledTitle$3 = styled(Typography.Title).withConfig({
  displayName: "styles__StyledTitle",
  componentId: "sc-vw14pc-3"
})(["margin:60px 0 24px 0;"]);
var StyledTypography = styled(Typography.Text).withConfig({
  displayName: "styles__StyledTypography",
  componentId: "sc-vw14pc-4"
})(["margin-bottom:48px;"]);

var UnavailablePage = inject('store')(function (_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(WrapStyles$2, null, /*#__PURE__*/React__default.createElement(ContentStyles$1, {
    "data-e2e": "common_item-is-not-available_block"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    size: "40px",
    color: "primary",
    roundedColor: "primaryBackground",
    roundedSize: "280%",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBag, null);
    }
  }), /*#__PURE__*/React__default.createElement(StyledTitle$3, {
    level: 2,
    align: "center",
    "data-e2e": "common_item-is-not-available-title_value"
  }, "This item is not available"), /*#__PURE__*/React__default.createElement(StyledTypography, {
    align: "center",
    type: "body1",
    "data-e2e": "common_item-is-not-available-description_value"
  }, "We\u2019re sorry for the inconvenience. Explore the Giftly Marketplace for other products and brands."), store.callbacks.onGoToMarketplaceClick ? /*#__PURE__*/React__default.createElement(StyledButton$8, {
    type: "primary",
    size: "large",
    onClick: store.callbacks.onGoToMarketplaceClick,
    "data-e2e": "common_go-to-marketplace_btn"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, "Go to Marketplace")) : null));
});

var _templateObject$1s, _templateObject2$_;
var StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-1yycsot-0"
})(["max-width:1200px;margin:0 auto;", ";", ";"], function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? css(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n              "]))) : '';
}, function (_ref2) {
  var $showReferralBanner = _ref2.$showReferralBanner;
  return $showReferralBanner ? css(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n                  flex-grow: 1;\n                  min-width: 0;\n                  gap: 60px;\n              "]))) : '';
});

var _templateObject$1t, _templateObject2$$;
var StyledWrapper$a = styled.div(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteralLoose(["\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n\n    ", ";\n"])), function (_ref) {
  var $showReferralBanner = _ref.$showReferralBanner;
  return $showReferralBanner ? css(_templateObject2$$ || (_templateObject2$$ = _taggedTemplateLiteralLoose(["\n                  display: flex;\n              "]))) : '';
});

var _templateObject$1u;
var StyledButton$9 = styled(Button).withConfig({
  displayName: "styled__StyledButton",
  componentId: "sc-1lp9gjj-0"
})(["&&&{background-color:transparent;justify-content:space-between;svg{width:22px;height:22px;path{transition:0.3s ease;}}&:focus{background-color:transparent;}&:hover,&:active{background-color:", ";svg path{stroke:", ";}}}"], COLORS.$primaryText, COLORS.$white);
var StyledLearnMore = styled(Button).withConfig({
  displayName: "styled__StyledLearnMore",
  componentId: "sc-1lp9gjj-1"
})(["&&&{justify-content:space-between;color:", ";padding:15px;svg{width:22px;height:22px;path{stroke:", ";}}}"], COLORS.$primary, COLORS.$primary);
var StyledBanner = styled.div.withConfig({
  displayName: "styled__StyledBanner",
  componentId: "sc-1lp9gjj-2"
})(["flex:0 0 265px;padding:20px;background-color:", ";border:2px solid ", ";height:fit-content;", ";"], COLORS.$primaryLight, COLORS.$primary, function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? css(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n              "]))) : '';
});

var debounce$1 = function debounce(func, delay, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    leading = _ref.leading;
  var timerId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!timerId && leading) {
      func.apply(void 0, args);
    }
    clearTimeout(timerId);
    timerId = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};

var AppContainer = inject('store')(observer(function (_ref) {
  var _store$view$customiza, _store$view$customiza2, _store$product, _store$view$customiza3, _store$view$customiza4;
  var store = _ref.store,
    extraContent = _ref.extraContent,
    bottomExtraContent = _ref.bottomExtraContent,
    customButtons = _ref.customButtons;
  var _useState = useState(null),
    node = _useState[0],
    setNode = _useState[1];
  var showReferralBanner = (_store$view$customiza = store.view.customizations) === null || _store$view$customiza === void 0 ? void 0 : (_store$view$customiza2 = _store$view$customiza.referral) === null || _store$view$customiza2 === void 0 ? void 0 : _store$view$customiza2.showBanner;
  var session = (_store$product = store.product) === null || _store$product === void 0 ? void 0 : _store$product.referralSession;
  useEffect(function () {
    if (!session || session.isExpired) {
      return;
    }
    store.callbacks.onOpenRefereeModal(session);
  }, [session === null || session === void 0 ? void 0 : session.isExpired]);
  var appRef = useCallback(function (node) {
    var timeout;
    if (node !== null) {
      setNode(node);
      store.view.setAppWidth(node.offsetWidth);
      timeout = setTimeout(function () {
        return store.view.setAppWidth(node.offsetWidth);
      }, 100);
    }
    clearTimeout(timeout);
    return null;
  }, []);
  useLayoutEffect(function () {
    if (node) {
      var onResize = debounce$1(function () {
        store.view.setAppWidth(node.offsetWidth);
      }, 500);
      window.addEventListener('resize', onResize);
      return function () {
        window.removeEventListener('resize', onResize);
      };
    }
  }, [node]);
  var simple = store.view.isSimple(GRID_POINTS$1.sm);
  var trackPdpUiEvents = function trackPdpUiEvents() {
    if (store.view.route !== 'pdp') return;
    store.callbacks.onPdpPageClick(store.product.trackingData);
  };
  return /*#__PURE__*/React__default.createElement(StyledWrapper$a, {
    $simple: simple,
    ref: appRef,
    $showReferralBanner: showReferralBanner
  }, showReferralBanner && !simple ? /*#__PURE__*/React__default.createElement(StyledBanner, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    style: BOTTOM_INDENTS.S,
    type: "badgeLarge",
    color: COLORS.$primary
  }, "Earn cash for sharing!"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    style: BOTTOM_INDENTS.S,
    type: "body2",
    color: COLORS.$primary
  }, "Know someone who would like this product? Share it now, and they'll receive a reward they can instantly apply to their order. And if they make a purchase, we'll send you a cash bonus as a thank you."), /*#__PURE__*/React__default.createElement(StyledButton$9, {
    onClick: store.callbacks.onShareProduct,
    block: true,
    type: "primary"
  }, /*#__PURE__*/React__default.createElement("span", null, "Share & Earn"), /*#__PURE__*/React__default.createElement(Icon, {
    size: "22px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgShare, null);
    }
  })), /*#__PURE__*/React__default.createElement(StyledLearnMore, {
    onClick: function onClick() {
      return store.callbacks.onClickInviteEarnLearnMore();
    },
    block: true,
    type: "unstyled"
  }, /*#__PURE__*/React__default.createElement("span", null, "Learn More"), /*#__PURE__*/React__default.createElement(Icon, {
    size: "22px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertInfo, null);
    }
  }))) : null, /*#__PURE__*/React__default.createElement(StyledContainer, _extends({
    $simple: simple
  }, store.view.route === 'pdp' && {
    'data-omit-event-block': true
  }, {
    onClick: trackPdpUiEvents,
    $showReferralBanner: showReferralBanner
  }), extraContent || null, store.view.route === 'pdp' && /*#__PURE__*/React__default.createElement(PDPPage, {
    bottomExtraContent: bottomExtraContent,
    customButtons: customButtons
  }), (_store$view$customiza3 = store.view.customizations) !== null && _store$view$customiza3 !== void 0 && (_store$view$customiza4 = _store$view$customiza3.reviews) !== null && _store$view$customiza4 !== void 0 && _store$view$customiza4.showReviews ? /*#__PURE__*/React__default.createElement(Fragment, null, store.view.route === 'reviews' && /*#__PURE__*/React__default.createElement(ReviewsPage, null), store.view.route === 'review' && /*#__PURE__*/React__default.createElement(ReviewPage, null), store.view.route === 'unavailable' && /*#__PURE__*/React__default.createElement(UnavailablePage, null)) : null, !simple && bottomExtraContent ? bottomExtraContent : null));
}));

var _templateObject$1v, _templateObject2$10, _templateObject3$C;
var isIos = device.iOS();
var isSafari = device.isSafari();
var StyledGlobal = createGlobalStyle(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteralLoose(["\n    * {\n        margin: 0;\n        padding: 0;\n\n        box-sizing: border-box;\n\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        text-rendering: optimizeLegibility;\n\n        -webkit-backface-visibility: hidden;\n    }\n\n    html,\n    body,\n    #root {\n        position: relative;\n        overflow: hidden;\n        min-width: 320px;\n        background: ", ";\n\n\n        ", "\n    }\n\n    html,\n    body {\n        overflow: hidden;\n    }\n\n    #root {\n        overflow-y: auto;\n    }\n\n    body {\n        margin: 0;\n        font-family: 'IBM Plex Sans', sans-serif;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        background-color: #fff;\n        color: ", ";\n    }\n\n    a {\n        text-decoration: none;\n        color: inherit;\n    }\n"])), COLORS.$white, function () {
  return isSafari && isIos ? css(_templateObject2$10 || (_templateObject2$10 = _taggedTemplateLiteralLoose(["\n                      height: 100vh;\n                      min-height: -webkit-fill-available;\n                  "]))) : css(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteralLoose(["\n                      height: 100%;\n                  "])));
}, COLORS.$primaryText);

var CheckoutPDP = function CheckoutPDP(_ref) {
  var customizations = _ref.customizations,
    _ref$metadata = _ref.metadata,
    metadata = _ref$metadata === void 0 ? [] : _ref$metadata,
    _ref$redirects = _ref.redirects,
    redirects = _ref$redirects === void 0 ? {} : _ref$redirects,
    callbacks = _ref.callbacks,
    upsellEndDate = _ref.upsellEndDate,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    extraContent = _ref.extraContent,
    bottomExtraContent = _ref.bottomExtraContent,
    customButtons = _ref.customButtons,
    _ref$testMode = _ref.testMode,
    testMode = _ref$testMode === void 0 ? false : _ref$testMode,
    _ref$isLoggedIn = _ref.isLoggedIn,
    isLoggedIn = _ref$isLoggedIn === void 0 ? false : _ref$isLoggedIn,
    _ref$inModal = _ref.inModal,
    inModal = _ref$inModal === void 0 ? true : _ref$inModal,
    useProductReviewNotification = _ref.useProductReviewNotification,
    useOnProductReviewSubmit = _ref.useOnProductReviewSubmit,
    notificationMessages = _ref.notificationMessages;
  var store = useMemo(function () {
    return RootStore.create({
      view: {
        route: 'pdp',
        type: type,
        customizations: customizations,
        isLoggedIn: isLoggedIn
      },
      upsell: {
        upsellEndDate: upsellEndDate
      },
      errors: {
        list: []
      }
    }, {
      testMode: testMode,
      callbacks: callbacks,
      metadata: metadata,
      redirects: redirects
    });
  }, [upsellEndDate]);
  useEffect(function () {
    store.setHooks(useOnProductReviewSubmit, useProductReviewNotification, notificationMessages);
  }, [store, useOnProductReviewSubmit, useProductReviewNotification, notificationMessages]);
  useEffect(function () {
    elementScrollIntoViewPolyfill();
  }, []);
  var pdpContent = /*#__PURE__*/React__default.createElement(AppContainer, {
    extraContent: extraContent,
    bottomExtraContent: bottomExtraContent,
    customButtons: customButtons
  });
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React__default.createElement(StyledGlobal, null), inModal ? /*#__PURE__*/React__default.createElement(ModalProvider, null, pdpContent) : pdpContent);
};

var isFunction = function isFunction(fn) {
  return typeof fn === 'function';
};
var CheckoutPDPHTTPWrapper = function CheckoutPDPHTTPWrapper(_ref) {
  var children = _ref.children,
    links = _ref.links,
    onBuyNowButtonClick = _ref.onBuyNowButtonClick,
    onBeforeBuyNowButtonClick = _ref.onBeforeBuyNowButtonClick,
    onInsteadBuyNowButtonClick = _ref.onInsteadBuyNowButtonClick,
    onCancelButtonClick = _ref.onCancelButtonClick,
    onGoToMarketplaceClick = _ref.onGoToMarketplaceClick,
    onVariantChange = _ref.onVariantChange,
    onGoToShoppingCartClick = _ref.onGoToShoppingCartClick,
    onBeforeAddToCartButtonClick = _ref.onBeforeAddToCartButtonClick,
    onAddToCartButtonClick = _ref.onAddToCartButtonClick,
    onAfterAddToCartModalClose = _ref.onAfterAddToCartModalClose,
    onRewardQuestionClick = _ref.onRewardQuestionClick,
    onPointsQuestionClick = _ref.onPointsQuestionClick,
    onOpenRefereeModal = _ref.onOpenRefereeModal,
    onShareProduct = _ref.onShareProduct,
    onProductFetchSuccess = _ref.onProductFetchSuccess,
    onGetRefereeSession = _ref.onGetRefereeSession,
    rewardUuid = _ref.rewardUuid,
    onClickThroughClick = _ref.onClickThroughClick,
    onClickInviteEarnLearnMore = _ref.onClickInviteEarnLearnMore,
    onAddToCartConfirmModal = _ref.onAddToCartConfirmModal,
    onBrandNameButtonClick = _ref.onBrandNameButtonClick;
  var calculatePromotionRewards = links.calculatePromotionRewards,
    productFetch = links.productFetch,
    cartItemsManage = links.cartItemsManage,
    buyNow = links.buyNow,
    reviewsFetch = links.reviewsFetch,
    reviewsWrite = links.reviewsWrite,
    productQtyManage = links.productQtyManage;
  var createAxiosWithTokenInterceptor = function createAxiosWithTokenInterceptor() {
    var instance = axios.create({
      withCredentials: true
    });
    instance.interceptors.request.use(function (config) {
      var cartToken = LocalStorage.get('x-klickly-cart-token');
      if (cartToken) {
        config.headers['x-klickly-cart-token'] = cartToken;
      }
      return config;
    });
    return instance;
  };
  var axiosInstance = useMemo(function () {
    return createAxiosWithTokenInterceptor();
  }, []);
  var onProductFetch = function onProductFetch() {
    try {
      return Promise.resolve(axiosInstance.get(productFetch, rewardUuid ? {
        params: {
          couponUUID: rewardUuid
        }
      } : {})).then(function (_ref2) {
        var data = _ref2.data;
        if (isFunction(onProductFetchSuccess)) {
          onProductFetchSuccess(data);
        }
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onReviewsFetch = function onReviewsFetch(params) {
    try {
      return Promise.resolve(axiosInstance.get("" + reviewsFetch + (params || ''))).then(function (_ref3) {
        var data = _ref3.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onCalculatePromotionRewards = function onCalculatePromotionRewards(params) {
    try {
      return Promise.resolve(axiosInstance.get(calculatePromotionRewards, {
        params: params
      })).then(function (_ref4) {
        var data = _ref4.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onProductQtyManage = function onProductQtyManage(params) {
    try {
      return Promise.resolve(axiosInstance.get(productQtyManage, {
        params: params
      })).then(function (_ref5) {
        var data = _ref5.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onReviewsWrite = function onReviewsWrite(data) {
    return axiosInstance.post(reviewsWrite, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };
  var onBuyNow = function onBuyNow(payload, selectedVariant, trackingData) {
    try {
      var _temp3 = function _temp3() {
        return isFunction(onInsteadBuyNowButtonClick) ? onInsteadBuyNowButtonClick(payload, selectedVariant, trackingData) : Promise.resolve(axiosInstance.post(buyNow, payload)).then(function (_ref6) {
          var data = _ref6.data;
          var _temp = function () {
            if (isFunction(onBuyNowButtonClick)) {
              return Promise.resolve(onBuyNowButtonClick(data.cartId, data.checkoutKey, payload, selectedVariant, trackingData)).then(function () {});
            }
          }();
          return _temp && _temp.then ? _temp.then(function () {
            return true;
          }) : true;
        });
      };
      var _temp2 = function () {
        if (isFunction(onBeforeBuyNowButtonClick)) {
          return Promise.resolve(onBeforeBuyNowButtonClick(payload, selectedVariant, trackingData)).then(function () {});
        }
      }();
      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onAddToCart = function onAddToCart(data, trackingData) {
    try {
      var _temp5 = function _temp5() {
        return Promise.resolve(axiosInstance.post(cartItemsManage, {
          action: 'itemAdd',
          data: data
        })).then(function (response) {
          if (isFunction(onAddToCartButtonClick)) {
            onAddToCartButtonClick(data, trackingData);
          }
          return response;
        });
      };
      var _temp4 = function () {
        if (isFunction(onBeforeAddToCartButtonClick)) {
          return Promise.resolve(onBeforeAddToCartButtonClick(data, trackingData)).then(function () {});
        }
      }();
      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp5) : _temp5(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onCancel = function onCancel() {
    if (isFunction(onCancelButtonClick)) {
      onCancelButtonClick();
    }
    return true;
  };
  var onGoToShoppingCart = function onGoToShoppingCart() {
    if (isFunction(onGoToShoppingCartClick)) {
      onGoToShoppingCartClick();
    }
    return true;
  };
  var onPdpPageClick = function onPdpPageClick(trackingData) {
    onClickThroughClick(trackingData);
  };
  var onBrandNameClick = function onBrandNameClick(trackingData, brandLink, brandId) {
    if (isFunction(onBrandNameButtonClick)) {
      return onBrandNameButtonClick(brandId);
    }
    if (isFunction(onClickThroughClick)) {
      onClickThroughClick(trackingData, brandLink);
    }
    window.open(brandLink, '_blank');
    return true;
  };
  var showAddToCartConfirmModal = function showAddToCartConfirmModal(_ref7) {
    var props = _extends({}, (_objectDestructuringEmpty(_ref7), _ref7));
    if (isFunction(onAddToCartConfirmModal)) {
      return onAddToCartConfirmModal(props);
    }
    return true;
  };
  return React__default.Children.map(children, function (child) {
    if (/*#__PURE__*/React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        callbacks: {
          onPdpPageClick: onPdpPageClick,
          onProductFetch: onProductFetch,
          onReviewsFetch: onReviewsFetch,
          onReviewsWrite: onReviewsWrite,
          onAddToCart: onAddToCart,
          onBuyNow: onBuyNow,
          onCancel: onCancel,
          onGoToMarketplaceClick: onGoToMarketplaceClick,
          onCalculatePromotionRewards: onCalculatePromotionRewards,
          onProductQtyManage: onProductQtyManage,
          calculatePromotionRewards: calculatePromotionRewards,
          onGoToShoppingCart: onGoToShoppingCart,
          productQtyManage: productQtyManage,
          onVariantChange: onVariantChange,
          onAfterAddToCartModalClose: onAfterAddToCartModalClose,
          onShareProduct: onShareProduct,
          onClickInviteEarnLearnMore: onClickInviteEarnLearnMore,
          onGetRefereeSession: onGetRefereeSession,
          onRewardQuestionClick: onRewardQuestionClick,
          onPointsQuestionClick: onPointsQuestionClick,
          onOpenRefereeModal: onOpenRefereeModal,
          onBrandNameClick: onBrandNameClick,
          showAddToCartConfirmModal: showAddToCartConfirmModal
        }
      });
    }
    return child;
  });
};

var _templateObject$1w, _templateObject2$11, _templateObject3$D, _templateObject4$t, _templateObject5$j;
var StyledBadge = styled(Typography.Text)(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteralLoose(["\n    && {\n        position: ", ";\n        z-index: 1;\n        bottom: 0;\n        left: 0;\n        display: flex;\n        align-items: center;\n        width: fit-content;\n        height: 24px;\n        margin-top: 8px;\n        padding: 0 4px;\n        white-space: nowrap;\n        overflow: hidden;\n        color: ", ";\n        background: ", ";\n\n        > span {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n        }\n    }\n"])), function (_ref) {
  var $isMobile = _ref.$isMobile;
  return $isMobile ? 'absolute' : 'static';
}, function (_ref2) {
  var $isWelcome = _ref2.$isWelcome,
    $theme = _ref2.$theme;
  return $isWelcome ? $theme.colors.canvas : $theme.colors.primary;
}, function (_ref3) {
  var $isWelcome = _ref3.$isWelcome,
    $theme = _ref3.$theme;
  return $isWelcome ? $theme.colors.primary : $theme.colors.tartRed;
});
var StyledIcon$6 = styled(Icon)(_templateObject2$11 || (_templateObject2$11 = _taggedTemplateLiteralLoose(["\n    margin-right: 4px;\n"])));
var StyledPointsCount = styled(Typography.Text)(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteralLoose(["\n    font-weight: 500;\n"])));
var StyledWelcomeText = styled(Typography.Text)(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteralLoose(["\n    font-size: 12px;\n    color: ", ";\n    font-weight: 500;\n\n    ", ";\n"])), function (_ref4) {
  var $theme = _ref4.$theme;
  return $theme.colors.primary;
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return $isMobile && css(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteralLoose(["\n            position: absolute;\n            bottom: 24px;\n            left: 0;\n            background: ", ";\n            padding: 0 5px;\n            text-align: left;\n        "])), function (_ref6) {
    var $theme = _ref6.$theme;
    return $theme.colors.canvas;
  });
});

var PointsBadge = function PointsBadge(_ref) {
  var pointsDetails = _ref.pointsDetails;
  var simple = useSimpleInterface(GRID_POINTS.sm);
  var theme = useContext(KliThemeContext);
  var maxPoints = pointsDetails.maxPoints,
    isWelcome = pointsDetails.isWelcome;
  if (!maxPoints) return null;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledBadge, {
    $theme: theme,
    $isWelcome: isWelcome,
    $isMobile: simple,
    color: "primary",
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/React__default.createElement(Popover.Points, {
    points: maxPoints,
    showUsdOnly: simple,
    placement: simple ? 'topRight' : 'bottom',
    getPopupContainer: function getPopupContainer(node) {
      return simple ? document.body : node;
    }
  }, /*#__PURE__*/React__default.createElement(StyledIcon$6, {
    size: "14px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgPoints, null);
    }
  }), /*#__PURE__*/React__default.createElement(StyledPointsCount, {
    type: "description1",
    as: "span",
    "data-e2e": "marketplace_product-points_value"
  }, "+", formatPoints(maxPoints, {
    million: true,
    billion: true
  })))), isWelcome ? /*#__PURE__*/React__default.createElement(StyledWelcomeText, {
    $theme: theme,
    $isMobile: simple,
    "data-e2e": "marketplace_welcome-gift_label"
  }, "Welcome Gift") : '');
};

var _excluded$O = ["images", "width", "height", "isStatic", "placeHolder"];
var PromotionImg = function PromotionImg(_ref) {
  var images = _ref.images,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '106px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '106px' : _ref$height,
    isStatic = _ref.isStatic,
    placeHolder = _ref.placeHolder,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$O);
  var findCurrent = images === null || images === void 0 ? void 0 : images.find(function (img) {
    return img.position === 1;
  });
  var style = {
    width: width,
    height: height,
    objectFit: 'contain'
  };
  if (findCurrent) {
    if (isStatic) return /*#__PURE__*/React__default.createElement(Image, _extends({
      "data-e2e": "marketplace_product_image",
      style: style,
      src: findCurrent.src
    }, rest));
    var preparedImage = prepareImageUrl(findCurrent.src, "&width=" + width.replace(/\D/g, ''), placeHolder);
    return /*#__PURE__*/React__default.createElement(Image, _extends({
      "data-e2e": "marketplace_product_image",
      style: style,
      src: preparedImage
    }, rest));
  }
  return /*#__PURE__*/React__default.createElement(Image, _extends({
    "data-e2e": "marketplace_product_image",
    style: style,
    src: placeHolder
  }, rest));
};

var getOriginalPrice = function getOriginalPrice(variant) {
  var _variant$priceDetails, _variant$priceDetails2;
  if (variant !== null && variant !== void 0 && (_variant$priceDetails = variant.priceDetails) !== null && _variant$priceDetails !== void 0 && _variant$priceDetails.originalPrice || (variant === null || variant === void 0 ? void 0 : (_variant$priceDetails2 = variant.priceDetails) === null || _variant$priceDetails2 === void 0 ? void 0 : _variant$priceDetails2.originalPrice) === 0) {
    var _variant$priceDetails3;
    return variant === null || variant === void 0 ? void 0 : (_variant$priceDetails3 = variant.priceDetails) === null || _variant$priceDetails3 === void 0 ? void 0 : _variant$priceDetails3.originalPrice;
  }
  return variant === null || variant === void 0 ? void 0 : variant.originalPrice;
};

var _templateObject$1x;
var OriginalPrice = styled(Typography.Text)(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteralLoose(["\n    text-decoration: line-through;\n"])));

var processOriginalPrice = function processOriginalPrice(originalPrice, price, customPrice) {
  var isDisplayOriginalPrice = originalPrice && Number(originalPrice) > 0 && Number(originalPrice) > Number(price);
  if (customPrice && Number(customPrice) > 0 && Number(customPrice) > Number(price)) {
    originalPrice = customPrice;
    isDisplayOriginalPrice = true;
  }
  return [originalPrice, isDisplayOriginalPrice];
};

var PromotionPrice = function PromotionPrice(_ref) {
  var _variant$priceDetails;
  var variant = _ref.variant;
  var _useState = useState(),
    originalPrice = _useState[0],
    setOriginalPrice = _useState[1];
  var _useState2 = useState(false),
    isDisplayOriginalPrice = _useState2[0],
    setIsDisplayOriginalPrice = _useState2[1];
  useEffect(function () {
    if (!variant) {
      return;
    }
    var _processOriginalPrice = processOriginalPrice(getOriginalPrice(variant), getYouPayPrice(variant), variant.customPrice),
      _originalPrice = _processOriginalPrice[0],
      _isDisplayOriginalPrice = _processOriginalPrice[1];
    setOriginalPrice(_originalPrice);
    setIsDisplayOriginalPrice(_isDisplayOriginalPrice);
  }, [variant, originalPrice, setOriginalPrice, isDisplayOriginalPrice, setIsDisplayOriginalPrice]);
  return /*#__PURE__*/React__default.createElement("div", null, isDisplayOriginalPrice ? /*#__PURE__*/React__default.createElement(OriginalPrice, {
    "data-e2e": "marketplace_product-original-price_value",
    type: "badgeSmall",
    color: "secondaryText"
  }, "$", roundToLocaleString$1(originalPrice)) : null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall",
    "data-e2e": "marketplace_product-sale-price_value",
    color: isDisplayOriginalPrice ? 'primary' : 'primaryText'
  }, (variant === null || variant === void 0 ? void 0 : (_variant$priceDetails = variant.priceDetails) === null || _variant$priceDetails === void 0 ? void 0 : _variant$priceDetails.youPayPrice) <= 0 || (variant === null || variant === void 0 ? void 0 : variant.price) <= 0 ? 'FREE' : '$' + roundToLocaleString$1(getYouPayPrice(variant))));
};

var _templateObject$1y;
var StyledReward = styled(Typography.Text)(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    background: ", ";\n    width: fit-content;\n    margin-top: 6px;\n    padding: 2px 8px;\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return $theme.colors.primary;
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.colors.tartRed;
});

var ReferralReward = function ReferralReward(_ref) {
  var variant = _ref.variant;
  var theme = useContext(KliThemeContext);
  var value = variant.rewards.find(function (reward) {
    return reward.type === 'referral';
  }).amount;
  var _processOriginalPrice = processOriginalPrice(getOriginalPrice(variant), getYouPayPrice(variant), variant.customPrice),
    originalPrice = _processOriginalPrice[0];
  return /*#__PURE__*/React__default.createElement(StyledReward, {
    type: "badgeSmall",
    $theme: theme
  }, "$", Math.min(value, Math.max(originalPrice, 0)), " reward");
};

var _templateObject$1z, _templateObject2$12, _templateObject3$E, _templateObject4$u;
var PromotionStyles = styled(KliCard)(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteralLoose(["\n    position: relative;\n    width: 100%;\n    cursor: pointer;\n\n    ", ";\n\n    @media (", ") {\n        &:hover {\n            box-shadow: none;\n        }\n\n        flex-direction: column;\n        padding: 0;\n\n        > div {\n            width: 100%;\n\n            &:first-child {\n                padding: 0;\n            }\n        }\n    }\n"])), function (_ref) {
  var $height = _ref.$height;
  return $height && css(_templateObject2$12 || (_templateObject2$12 = _taggedTemplateLiteralLoose(["\n            height: ", ";\n        "])), $height);
}, GRID_DEVICES_MAX.sm);
var StyledPromotionImgWrapper = styled.div(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    height: 150px;\n    margin-bottom: 16px;\n\n    img.ant-image-img {\n        display: block;\n        object-fit: contain;\n    }\n\n    > div {\n        position: relative;\n\n        > div {\n            display: inline-block;\n        }\n    }\n\n    @media (", ") {\n        width: 100%;\n        > div {\n            display: flex;\n            justify-content: center;\n            width: 100%;\n        }\n    }\n"])), GRID_DEVICES_MAX.md);
var StyledTitle$4 = styled(Typography.Title)(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteralLoose(["\n    @media (", ") {\n        word-break: break-word;\n    }\n"])), GRID_DEVICES_MAX.md);

var Promotion = observer(function (_ref) {
  var _product$variants, _variant$rewards;
  var promotion = _ref.promotion,
    onBuy = _ref.onBuy,
    _ref$withoutButton = _ref.withoutButton,
    withoutButton = _ref$withoutButton === void 0 ? false : _ref$withoutButton,
    _ref$hidePrice = _ref.hidePrice,
    hidePrice = _ref$hidePrice === void 0 ? false : _ref$hidePrice,
    height = _ref.height,
    _ref$showPoints = _ref.showPoints,
    showPoints = _ref$showPoints === void 0 ? true : _ref$showPoints,
    _ref$afterPointsConte = _ref.afterPointsContent,
    afterPointsContent = _ref$afterPointsConte === void 0 ? null : _ref$afterPointsConte,
    _ref$placeHolder = _ref.placeHolder,
    placeHolder = _ref$placeHolder === void 0 ? null : _ref$placeHolder;
  var product = getSnapshot(promotion);
  var _useState = useState(),
    variant = _useState[0],
    setVariant = _useState[1];
  var simple = useSimpleInterface(GRID_POINTS.sm);
  var firstVariant = product === null || product === void 0 ? void 0 : (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants[0];
  var pointsDetails = firstVariant ? firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.pointsDetails : {};
  var hasReferral = variant === null || variant === void 0 ? void 0 : (_variant$rewards = variant.rewards) === null || _variant$rewards === void 0 ? void 0 : _variant$rewards.some(function (r) {
    return r.type === 'referral';
  });
  useEffect(function () {
    setVariant(getVariantByPrice(product.variants));
  }, [product, setVariant]);
  return /*#__PURE__*/React__default.createElement(PromotionStyles, {
    $height: height,
    id: promotion.id,
    "data-e2e": "marketplace_product-" + promotion.id + "_card",
    direction: "row",
    img: /*#__PURE__*/React__default.createElement(StyledPromotionImgWrapper, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PromotionImg, {
      placeHolder: placeHolder,
      style: {
        maxHeight: '150px'
      },
      images: promotion === null || promotion === void 0 ? void 0 : promotion.images
    }), simple && !hidePrice && showPoints ? /*#__PURE__*/React__default.createElement(PointsBadge, {
      pointsDetails: pointsDetails
    }) : null, simple && afterPointsContent)),
    onClick: function onClick(e) {
      e.stopPropagation();
      onBuy(promotion);
    },
    button: simple || withoutButton ? null : /*#__PURE__*/React__default.createElement(Button, {
      "data-e2e": "marketplace_product-" + promotion.id + "-buy-now_btn",
      type: "primary",
      style: {
        width: '100%'
      }
    }, "Buy")
  }, /*#__PURE__*/React__default.createElement(StyledTitle$4, {
    level: 3,
    "data-e2e": "marketplace_product-title_value"
  }, promotion === null || promotion === void 0 ? void 0 : promotion.title), (promotion === null || promotion === void 0 ? void 0 : promotion.brandName) && /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    "data-e2e": "marketplace_product-brand-name_value"
  }, promotion === null || promotion === void 0 ? void 0 : promotion.brandName), !hidePrice ? /*#__PURE__*/React__default.createElement(PromotionPrice, {
    variant: variant
  }) : null, hasReferral ? /*#__PURE__*/React__default.createElement(ReferralReward, {
    variant: variant
  }) : null, !simple && !hidePrice && showPoints && !hasReferral ? /*#__PURE__*/React__default.createElement(PointsBadge, {
    pointsDetails: pointsDetails
  }) : null, !simple && afterPointsContent);
});
Promotion.Img = PromotionImg;

var axiosInstance = axios.create({
  withCredentials: true
});

var INITIAL_STORE = {
  get: function (url, params) {
    try {
      return Promise.resolve(axiosInstance.get(url, params && {
        params: params
      })).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
  post: function (url, body) {
    if (body === void 0) {
      body = {};
    }
    try {
      return Promise.resolve(axiosInstance.post(url, body)).then(function (_ref2) {
        var data = _ref2.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
  patch: function (url, body) {
    if (body === void 0) {
      body = {};
    }
    try {
      return Promise.resolve(axiosInstance.patch(url, body)).then(function (_ref3) {
        var data = _ref3.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
  put: function (url, body) {
    if (body === void 0) {
      body = {};
    }
    try {
      return Promise.resolve(axiosInstance.put(url, body)).then(function (_ref4) {
        var data = _ref4.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
  "delete": function (url, params) {
    try {
      return Promise.resolve(axiosInstance["delete"](url, params && {
        params: params
      })).then(function (_ref5) {
        var data = _ref5.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }
};

var SuggestionModel = types.model({
  freq: types.maybeNull(types.number),
  score: types.number,
  text: types.string
});

var models = {
  SuggestionModel: SuggestionModel
};

var RootStore$1 = types.model('SearchStore', {
  kcpAPI: types.maybeNull(types.frozen()),
  search: types.maybeNull(types.string),
  autoSuggestions: types.maybeNull(types.array(types.string)),
  suggestions: types.maybeNull(types.array(models.SuggestionModel))
})["volatile"](function () {
  return {
    onSearch: types["function"],
    onClear: types["function"],
    shouldClearOnBackArrowClick: types["function"],
    onBeforeSearch: types["function"]
  };
}).views(function (self) {
  return {
    get root() {
      return getParent(self);
    },
    get get() {
      return getEnv(self).get;
    }
  };
}).actions(function (self) {
  return {
    afterInit: function afterInit(props) {
      self.kcpAPI = props.kcpAPI;
      self.shouldClearOnBackArrowClick = props.shouldClearOnBackArrowClick;
      self.onBeforeSearch = props.onBeforeSearch;
      self.onSearch = props.onSearch;
      self.onClear = props.onClear;
    },
    setAutoSuggestions: function setAutoSuggestions(data) {
      self.autoSuggestions = data;
    },
    setSuggestions: function setSuggestions(data) {
      self.suggestions = data;
    },
    setSearch: function setSearch(data) {
      self.search = data;
    },
    onSearchChange: flow(function onSearchChange(data, queryParams, clear) {
      if (clear === void 0) {
        clear = false;
      }
      return /*#__PURE__*/_regenerator().m(function _callee() {
        var suggestions;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(self.search !== data && !clear)) {
                _context.n = 4;
                break;
              }
              self.search = data || self.search;
              if (!self.search) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return self.onSearch({
                queryParams: queryParams,
                isNewSearch: true,
                searchValue: self.search
              });
            case 1:
              suggestions = _context.v;
              return _context.a(2, suggestions ? self.suggestions = suggestions : null);
            case 2:
              self.search = '';
              return _context.a(2, self.onClear());
            case 3:
              _context.n = 5;
              break;
            case 4:
              self.search = '';
              if (!clear) {
                _context.n = 5;
                break;
              }
              return _context.a(2, self.onClear());
            case 5:
              return _context.a(2);
          }
        }, _callee);
      })();
    }),
    getAutoSuggestions: flow(/*#__PURE__*/_regenerator().m(function getAutoSuggestions(text) {
      var data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return self.get(self.kcpAPI.marketplace.search.autoSuggestions + "?q=" + text);
          case 1:
            data = _context2.v;
            self.autoSuggestions = data.autosuggestions;
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            self.autoSuggestions = [];
          case 3:
            return _context2.a(2);
        }
      }, getAutoSuggestions, null, [[0, 2]]);
    })),
    afterCreate: function afterCreate() {
      var _getFilterParamsFromU = getFilterParamsFromUrl(),
        search = _getFilterParamsFromU.search;
      self.search = search;
    }
  };
});
var store = RootStore$1.create({}, INITIAL_STORE);

var useBrowserButtonsEvents = function useBrowserButtonsEvents(_ref) {
  var _history;
  var _ref$handleBackArrowC = _ref.handleBackArrowClick,
    handleBackArrowClick = _ref$handleBackArrowC === void 0 ? function () {
      return null;
    } : _ref$handleBackArrowC,
    _ref$handleForwardArr = _ref.handleForwardArrowClick,
    handleForwardArrowClick = _ref$handleForwardArr === void 0 ? function () {
      return null;
    } : _ref$handleForwardArr,
    navigationType = _ref.navigationType,
    location = _ref.location;
  var _useState = useState([]),
    locationKeys = _useState[0],
    setLocationKeys = _useState[1];
  var deps = typeof ((_history = history) === null || _history === void 0 ? void 0 : _history.listen) === 'function' ? locationKeys : location;
  useEffect(function () {
    if (navigationType === 'PUSH') {
      setLocationKeys([location.key]);
    }
    if (navigationType === 'POP') {
      if (locationKeys[1] === location.key) {
        setLocationKeys(function (_ref2) {
          var keys = _arrayLikeToArray(_ref2).slice(1);
          return keys;
        });
        handleForwardArrowClick(location);
      } else {
        setLocationKeys(function (keys) {
          return [location.key].concat(keys);
        });
        handleBackArrowClick(location);
      }
    }
  }, [deps]);
};

var useDebounce = function useDebounce(func, delay) {
  if (delay === void 0) {
    delay = 150;
  }
  var debouncedResults = useMemo(function () {
    return debounce$3(func, delay);
  }, []);
  useEffect(function () {
    return function () {
      debouncedResults.cancel();
    };
  });
  return debouncedResults;
};

var useSearch = function useSearch(_ref) {
  var shouldClearOnBackArrowClick = _ref.shouldClearOnBackArrowClick,
    onBeforeSearch = _ref.onBeforeSearch,
    search = _ref.search,
    onSearchChange = _ref.onSearchChange,
    setSearch = _ref.setSearch,
    getAutoSuggestions = _ref.getAutoSuggestions,
    setAutoSuggestions = _ref.setAutoSuggestions,
    location = _ref.location,
    navigationType = _ref.navigationType;
  var _useState = useState(''),
    value = _useState[0],
    setValue = _useState[1];
  var _getFilterParamsFromU = getFilterParamsFromUrl(),
    searchParam = _getFilterParamsFromU.search;
  var debounce = useDebounce(function (newValue) {
    setValue(newValue);
    return newValue && newValue.length > 2 ? getAutoSuggestions(newValue) : setAutoSuggestions(null);
  }, 1);
  var handleClear = function handleClear() {
    setValue('');
    setSearch('');
    setAutoSuggestions(null);
    return onSearchChange('', null, true);
  };
  useEffect(function () {
    if (search) {
      var searchQueryValue = typeof search === 'string' ? search : search.q;
      if (searchQueryValue !== value) setValue(searchQueryValue);
    }
  }, [search]);
  useEffect(function () {
    if (!searchParam) {
      setSearch('');
      setValue('');
    }
  }, [searchParam]);
  useBrowserButtonsEvents({
    handleBackArrowClick: function handleBackArrowClick() {
      return shouldClearOnBackArrowClick ? handleClear() : null;
    },
    navigationType: navigationType,
    location: location
  });
  var onSubmit = function onSubmit(data) {
    onBeforeSearch();
    setAutoSuggestions(null);
    return onSearchChange((data === null || data === void 0 ? void 0 : data.search) || value);
  };
  return {
    value: value,
    setValue: setValue,
    debounce: debounce,
    handleClear: handleClear,
    onSubmit: onSubmit
  };
};

var _templateObject$1A;
var StyledSuggestionPart = styled.span(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteralLoose(["\n    && {\n        margin: 0;\n        white-space: pre;\n    }\n\n    > b {\n        font-weight: 700;\n    }\n"])));

var getHighlightedText = function getHighlightedText(text, searchText) {
  var startIndex = text.toLowerCase().indexOf(searchText.toLowerCase());
  if (startIndex < 0) return null;
  return text.substring(startIndex, startIndex + searchText.length);
};

var SuggestionContent = function SuggestionContent(_ref) {
  var suggestion = _ref.suggestion,
    searchValue = _ref.searchValue;
  if (!suggestion) return null;
  var highlightedText = getHighlightedText(suggestion, searchValue);
  var parts = suggestion.split(highlightedText);
  return /*#__PURE__*/React__default.createElement(Fragment, null, parts.map(function (part, index) {
    return /*#__PURE__*/React__default.createElement(StyledSuggestionPart, {
      key: nextId()
    }, /*#__PURE__*/React__default.createElement(Fragment, null, part, index !== parts.length - 1 && /*#__PURE__*/React__default.createElement("b", null, highlightedText)));
  }));
};

var $white = '#FFFFFF';
var $primary = '#F25858';
var $primaryText = '#04080F';

var _templateObject$1B;
var StyledWrapper$b = styled.div(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 24px;\n    left: 62px;\n    width: calc(100% - 205px);\n    height: calc(100% - 27px);\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    background: ", ";\n    z-index: 3;\n"])), $white);

var AutoSuggestionPlaceholder = function AutoSuggestionPlaceholder(_ref) {
  var suggestion = _ref.suggestion,
    searchValue = _ref.searchValue;
  return suggestion ? /*#__PURE__*/React__default.createElement(StyledWrapper$b, null, /*#__PURE__*/React__default.createElement(SuggestionContent, {
    suggestion: suggestion,
    searchValue: searchValue
  })) : null;
};

var useHandleClickOutside = function useHandleClickOutside(ref, setAutoSuggestions) {
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setAutoSuggestions(null);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
};

var _templateObject$1C, _templateObject2$13, _templateObject3$F;
var StyledWrapper$c = styled.div(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    bottom: -12px;\n    width: 100%;\n    height: 0;\n    z-index: 3;\n"])));
var StyledContent$2 = styled.div(_templateObject2$13 || (_templateObject2$13 = _taggedTemplateLiteralLoose(["\n    padding: 16px 24px 24px;\n    background: ", ";\n    box-shadow: 0 8px 48px rgba(0, 0, 0, 0.16), 0 4px 8px rgba(0, 0, 0, 0.12);\n"])), $white);
var StyledSuggestion = styled(Button)(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteralLoose(["\n    && {\n        display: block;\n        width: 100%;\n        padding: 0 0 16px 0;\n        font-weight: normal;\n        text-align: left;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        &:last-child {\n            padding: 0;\n        }\n\n        &:hover:not(:disabled) {\n            color: inherit;\n        }\n    }\n"])));

var AutoSuggestions = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    searchValue = _ref.searchValue,
    onSetSearchValue = _ref.onSetSearchValue,
    onSubmitSearch = _ref.onSubmitSearch;
  var ref = useRef(null);
  var autoSuggestions = store.autoSuggestions,
    setAutoSuggestions = store.setAutoSuggestions;
  var _useState = useState(null),
    highlightedSuggestion = _useState[0],
    setHighlightedSuggestion = _useState[1];
  var simple = useSimpleInterface(GRID_POINTS.sm);
  useHandleClickOutside(ref, setAutoSuggestions);
  useEffect(function () {
    if (!(autoSuggestions !== null && autoSuggestions !== void 0 && autoSuggestions.length) || !searchValue) setHighlightedSuggestion(null);
  }, [autoSuggestions]);
  if (!(autoSuggestions !== null && autoSuggestions !== void 0 && autoSuggestions.length)) return null;
  return /*#__PURE__*/React__default.createElement(Fragment, null, !simple && /*#__PURE__*/React__default.createElement(AutoSuggestionPlaceholder, {
    suggestion: highlightedSuggestion,
    searchValue: searchValue
  }), /*#__PURE__*/React__default.createElement(StyledWrapper$c, {
    ref: ref
  }, /*#__PURE__*/React__default.createElement(StyledContent$2, null, autoSuggestions.map(function (suggestion) {
    return /*#__PURE__*/React__default.createElement(StyledSuggestion, {
      onClick: function onClick() {
        onSetSearchValue(suggestion);
        setHighlightedSuggestion(null);
        return onSubmitSearch({
          search: suggestion
        });
      },
      onMouseEnter: function onMouseEnter() {
        return setHighlightedSuggestion(suggestion);
      },
      onMouseLeave: function onMouseLeave() {
        return setHighlightedSuggestion(null);
      },
      key: nextId(),
      type: "unstyled"
    }, /*#__PURE__*/React__default.createElement(SuggestionContent, {
      suggestion: suggestion,
      searchValue: searchValue
    }));
  }))));
}));

var _templateObject$1D, _templateObject2$14, _templateObject3$G;
var StyledButton$a = styled(Button)(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteralLoose(["\n    &&&,\n    &&&:focus {\n        height: 100%;\n        color: ", ";\n        background-color: ", ";\n    }\n    &&&:active {\n        background-color: ", ";\n        color: ", ";\n    }\n"])), $white, $primaryText, $white, $primaryText);
var StyledButtonsWrapper$1 = styled.div(_templateObject2$14 || (_templateObject2$14 = _taggedTemplateLiteralLoose(["\n    position: relative;\n"])));
var StyledClearButton = styled(Button)(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteralLoose(["\n    && {\n        position: absolute;\n        top: 2px;\n        right: 94px;\n        width: 53px;\n        height: 53px;\n        padding: 0;\n        color: rgb(119, 131, 143);\n        z-index: 3;\n\n        &:focus,\n        &:focus:not(:hover) {\n            outline: none;\n        }\n\n        &:hover:not(:disabled) {\n            color: inherit;\n        }\n    }\n"])));

var SearchButtons = function SearchButtons(_ref) {
  var inputValue = _ref.inputValue,
    value = _ref.value,
    inputRef = _ref.inputRef,
    onClear = _ref.onClear,
    onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React__default.createElement(StyledButtonsWrapper$1, null, (inputValue || value) && /*#__PURE__*/React__default.createElement(StyledClearButton, {
    "data-e2e": "search-clear_btn",
    type: "unstyled",
    onClick: function onClick() {
      inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.focus();
      inputRef.current.value = '';
      return onClear();
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    stylePriority: true,
    size: "24px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  })), /*#__PURE__*/React__default.createElement(StyledButton$a, {
    size: "small",
    type: "primary",
    onClick: function onClick() {
      return onSubmit({
        search: inputValue
      });
    },
    "data-e2e": "header_search_btn"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    color: "canvas",
    type: "badgeMedium"
  }, "Search")));
};

var _templateObject$1E, _templateObject2$15, _templateObject3$H, _templateObject4$v;
var Styles$e = styled.div(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    margin-left: auto;\n    width: 100%;\n    max-width: 440px;\n\n    ", ";\n\n    input {\n        padding-right: 56px;\n    }\n\n    div {\n        &:first-child {\n            flex-grow: 1;\n        }\n\n        label {\n            span {\n                &:nth-child(3) {\n                    z-index: 3;\n                }\n\n                &:nth-child(4) {\n                    svg {\n                        top: 16px;\n                        right: 15px;\n                    }\n                }\n            }\n        }\n    }\n"])), function (prop) {
  return prop.$type === 'dp' ? css(_templateObject2$15 || (_templateObject2$15 = _taggedTemplateLiteralLoose(["\n                  margin-right: auto;\n                  margin-left: initial;\n                  max-width: 691px;\n                  @media (", ") {\n                      max-width: 100%;\n                      margin-bottom: 24px;\n                  }\n              "])), GRID_DEVICES_MAX.md) : '';
});
var StyledInput$1 = styled(KliField)(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteralLoose(["\n    && {\n        border: 2px solid ", ";\n        border-right: none;\n        background-color: ", ";\n        border-radius: 0;\n        color: inherit;\n\n        &:focus:not(:active) {\n            outline: none;\n        }\n    }\n"])), $primaryText, $white);
var StyledIcon$7 = styled(Icon)(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteralLoose(["\n    &.anticon {\n        height: 61px;\n        line-height: 61px;\n    }\n"])));

var SearchInput = inject('store')(observer(function (_ref) {
  var _ref$current;
  var type = _ref.type,
    location = _ref.location,
    navigationType = _ref.navigationType,
    store = _ref.store;
  var ref = useRef(null);
  var inputValue = ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.value;
  var onBeforeSearch = store.onBeforeSearch,
    shouldClearOnBackArrowClick = store.shouldClearOnBackArrowClick,
    search = store.search,
    onSearchChange = store.onSearchChange,
    setSearch = store.setSearch,
    getAutoSuggestions = store.getAutoSuggestions,
    setAutoSuggestions = store.setAutoSuggestions;
  var _useSearch = useSearch({
      shouldClearOnBackArrowClick: shouldClearOnBackArrowClick,
      onBeforeSearch: onBeforeSearch,
      search: search,
      onSearchChange: onSearchChange,
      setSearch: setSearch,
      getAutoSuggestions: getAutoSuggestions,
      setAutoSuggestions: setAutoSuggestions,
      location: location,
      navigationType: navigationType
    }),
    value = _useSearch.value,
    setValue = _useSearch.setValue,
    debounce = _useSearch.debounce,
    handleClear = _useSearch.handleClear,
    onSubmit = _useSearch.onSubmit;
  return /*#__PURE__*/React__default.createElement(Styles$e, {
    $type: type
  }, /*#__PURE__*/React__default.createElement(StyledInput$1, {
    ref: ref,
    placeholder: "Search",
    value: value,
    withoutClearButton: true,
    withoutBorderColorsOnValidate: true,
    onChange: function onChange(_ref2) {
      var newValue = _ref2.target.value;
      return debounce(newValue);
    },
    onKeyPress: function onKeyPress(_ref3) {
      var key = _ref3.key;
      return key === 'Enter' && onSubmit({
        search: inputValue
      });
    },
    "data-e2e": "header_search_input"
  }, /*#__PURE__*/React__default.createElement(StyledIcon$7, {
    size: "24px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgSearch, null);
    }
  })), /*#__PURE__*/React__default.createElement(SearchButtons, {
    inputValue: inputValue,
    value: value,
    inputRef: ref,
    onClear: handleClear,
    onSubmit: onSubmit
  }), /*#__PURE__*/React__default.createElement(AutoSuggestions, {
    searchValue: inputValue,
    onSetSearchValue: setValue,
    onSubmitSearch: onSubmit
  }));
}));

var _templateObject$1F, _templateObject2$16, _templateObject3$I, _templateObject4$w;
var StyledWrapper$d = styled.div(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    padding: 12px 0 32px 0;\n"])));
var StyledSuggestionButton = styled(Button)(_templateObject2$16 || (_templateObject2$16 = _taggedTemplateLiteralLoose(["\n    && {\n        display: inline-flex;\n        padding: 0 4px;\n        font: inherit;\n        color: ", ";\n    }\n"])), $primary);
var StyledText$7 = styled(Typography.Text)(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteralLoose(["\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n"])));
var StyledTypoButton = styled(Button)(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteralLoose(["\n    && {\n        display: inline-flex;\n        padding: 0 4px;\n        font: inherit;\n        font-weight: 500;\n        color: ", ";\n\n        &:hover:not(:disabled) {\n            color: inherit;\n        }\n    }\n"])), $primary);

var Typos = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var search = store.search,
    onSearchChange = store.onSearchChange,
    _store$setSuggestions = store.setSuggestions,
    setSuggestions = _store$setSuggestions === void 0 ? function () {
      return null;
    } : _store$setSuggestions,
    suggestions = store.suggestions;
  var mostRelevantSuggestion = suggestions !== null && suggestions !== void 0 && suggestions.length ? suggestions[0] : null;
  return mostRelevantSuggestion && search && typeof search === 'string' ? /*#__PURE__*/React__default.createElement(StyledWrapper$d, null, /*#__PURE__*/React__default.createElement(StyledText$7, {
    type: "body1"
  }, /*#__PURE__*/React__default.createElement("span", null, "Showing results for"), /*#__PURE__*/React__default.createElement(StyledTypoButton, {
    type: "unstyled",
    onClick: function onClick() {
      return setSuggestions([]);
    }
  }, search)), /*#__PURE__*/React__default.createElement(StyledText$7, {
    type: "body2"
  }, /*#__PURE__*/React__default.createElement("span", null, "Search instead for"), /*#__PURE__*/React__default.createElement(StyledSuggestionButton, {
    type: "unstyled",
    onClick: function onClick() {
      return onSearchChange(mostRelevantSuggestion.text, {
        suggest: 0
      });
    }
  }, mostRelevantSuggestion.text))) : null;
}));

var TyposItem = function TyposItem() {
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React__default.createElement(Typos, null));
};

var Search = function Search(_ref) {
  var type = _ref.type,
    location = _ref.location,
    navigationType = _ref.navigationType,
    onBeforeSearchRoute = _ref.onBeforeSearchRoute;
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React__default.createElement(SearchInput, {
    type: type,
    location: location,
    navigationType: navigationType,
    onBeforeSearchRoute: onBeforeSearchRoute
  }));
};
Search.store = store;
Search.Typos = TyposItem;

var formatPoints$1 = function formatPoints(points, params) {
  if (params === void 0) {
    params = {
      thousand: false,
      million: false,
      billion: false
    };
  }
  var _params = params,
    thousand = _params.thousand,
    billion = _params.billion,
    million = _params.million;
  var formatter = new Intl.NumberFormat('en-US');
  var thousands = points / 1000;
  var millions = points / 1000000;
  var billions = points / 1000000000;
  if (thousand && millions < 1) {
    return thousands >= 1 ? formatter.format(Math.floor(thousands)) + "k" : formatter.format(points);
  }
  if (million && billions < 1) {
    return millions >= 1 ? formatter.format(Math.floor(millions)) + "M" : formatter.format(points);
  }
  if (billion) {
    return billions >= 1 ? formatter.format(Math.floor(billions)) + "B" : formatter.format(points);
  }
  return formatter.format(points);
};

var GRID_POINTS$3 = Object.freeze({
  xxs: 370,
  xs: 480,
  sm: 680,
  md: 890,
  lg: 950,
  xl: 1100,
  xxl: 1600
});
var GRID_DEVICES_MAX$2 = Object.freeze({
  xxs: "max-width: " + GRID_POINTS$3.xxs + "px",
  xs: "max-width: " + GRID_POINTS$3.xs + "px",
  sm: "max-width: " + GRID_POINTS$3.sm + "px",
  md: "max-width: " + GRID_POINTS$3.md + "px",
  lg: "max-width: " + GRID_POINTS$3.lg + "px",
  xl: "max-width: " + GRID_POINTS$3.xl + "px",
  xxl: "max-width: " + GRID_POINTS$3.xxl + "px"
});

var debounce$2 = function debounce(func, delay, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    leading = _ref.leading;
  var timerId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!timerId && leading) {
      func.apply(void 0, args);
    }
    clearTimeout(timerId);
    timerId = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};
var getMetaByName = function getMetaByName(metadata, searchName) {
  return metadata.find(function (_ref2) {
    var name = _ref2.name;
    return name === searchName;
  });
};

var MIN_DISCOUNT_PERCENTAGE_TO_SHOW$2 = 3;
var getPrices$2 = function getPrices(prices) {
  var responsePrice = {
    fullTotal: prices.fullTotal,
    originalDiscount: 0,
    subTotal: "$" + roundToLocaleString(prices.subTotal),
    discounts: prices.discounts,
    discountPercentage: '',
    showOriginalPrice: false
  };
  if (prices.originalSubTotal && prices.originalSubTotal > prices.fullTotal) {
    responsePrice.showOriginalPrice = true;
    responsePrice.originalSubTotal = "$" + roundToLocaleString(prices.originalSubTotal);
    responsePrice.originalDiscount = prices.originalSubTotal - prices.subTotal;
    responsePrice.discounts += responsePrice.originalDiscount;
  } else {
    responsePrice.originalSubTotal = "$" + roundToLocaleString(prices.subTotal);
  }
  if (responsePrice.discounts) {
    var percentage = Number(responsePrice.discounts) / Number(prices.total + responsePrice.originalDiscount) * 100;
    var showDiscountPercentage = percentage > MIN_DISCOUNT_PERCENTAGE_TO_SHOW$2;
    responsePrice.discountPercentage = showDiscountPercentage ? "(" + roundToLocaleString(percentage, 0) + "% off)" : '';
    responsePrice.discounts = "-$" + roundToLocaleString(responsePrice.discounts);
  }
  responsePrice.fullTotal = responsePrice.fullTotal === 0 ? 'Free' : "$" + roundToLocaleString(prices.fullTotal);
  return responsePrice;
};

var UPDATE_QTY_DEBOUNCE_TIME = 1000;
var ItemStore = types.model('ItemStore', {
  _id: types.identifier,
  productId: types.string,
  productTitle: types.string,
  variantId: types.number,
  variantTitle: types.string,
  sku: types.optional(types.string, ''),
  weight: types.number,
  qty: types.number,
  maxQty: types.number,
  image: types.string,
  taxable: types["boolean"],
  requiredShipping: types["boolean"],
  priceDetails: types.model({
    qty: types.number,
    originalSubTotal: types.number,
    subTotal: types.number,
    discounts: types.number,
    total: types.number,
    fullTotal: types.number
  }),
  removed: false,
  metadata: types.array(types.frozen())
}).views(function (self) {
  return {
    get bag() {
      return getParent(self, 2);
    },
    get pointsEarned() {
      if (!self.bag.pointsDetails.isWelcome && self.metadata && self.metadata.length) {
        var _ref = self.metadata.find(function (el) {
            return el && el.name === 'pointsEarned';
          }) || {},
          details = _ref.details;
        if (details && details.list) {
          var percent = details.list.find(function (el) {
            return el && el.type === 'percent';
          });
          return percent && percent.value ? Math.round(percent.value * self.qty) : 0;
        }
      }
      return 0;
    }
  };
}).actions(function (self) {
  return {
    incrementQty: function incrementQty() {
      self.qty += 1;
    },
    decrementQty: function decrementQty() {
      self.qty -= 1;
    },
    updateQty: debounce$2(function () {
      self.bag.cart.changeItemQty(self._id, self.qty);
    }, UPDATE_QTY_DEBOUNCE_TIME),
    softRemove: function softRemove() {
      self.removed = true;
      self.bag.cart.removeItem(self._id, self.bag._id);
    },
    undoRemove: function undoRemove() {
      self.removed = false;
      self.bag.cart.undoRemoveItem(self._id, self.bag._id);
    },
    hardRemove: flow(function hardRemove(callback) {
      if (callback === void 0) {
        callback = function callback() {
          return null;
        };
      }
      return /*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return self.bag.cart.removeItem(self._id, self.bag._id);
            case 1:
              callback();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      })();
    })
  };
});

var BagStore = types.model('BagStore', {
  _id: types.identifier,
  merchantId: types.string,
  merchantName: types.maybeNull(types.string),
  items: types.array(ItemStore),
  priceDetails: types.model({
    qty: types.number,
    originalSubTotal: types.number,
    subTotal: types.number,
    discounts: types.number,
    total: types.number,
    fullTotal: types.number
  }),
  pointsDetails: types.maybeNull(types.model({
    isWelcome: false,
    points: types.number
  })),
  cashbackDetails: types.maybeNull(types.model({
    value: types.maybeNull(types.number)
  }))
}).views(function (self) {
  return {
    get cart() {
      return getParent(self, 2);
    }
  };
}).actions(function (self) {
  return {};
});

var CartStore = types.model('CartStore', {
  isLoading: false,
  _id: types.maybeNull(types.string),
  bags: types.array(BagStore),
  priceDetails: types.maybeNull(types.model({
    qty: types.number,
    originalSubTotal: types.number,
    subTotal: types.number,
    discounts: types.number,
    total: types.number,
    fullTotal: types.number
  })),
  discounts: types.maybeNull(types.array(types.frozen())),
  errorMessage: types.maybeNull(types.string),
  failedProductsIds: types.maybeNull(types.array(types.string))
}).views(function (self) {
  return {
    get root() {
      return getParent(self);
    },
    get isEmpty() {
      return !(self.bags && self.bags.length);
    },
    get failedProductsData() {
      return self.bags.reduce(function (accumulator, bag) {
        bag.items.map(function (item) {
          return self.failedProductsIds.includes(item._id) ? accumulator.push(item) : null;
        });
        return accumulator;
      }, []);
    },
    get hasGsProductInCart() {
      return self.bags.some(function (bag) {
        return bag.items.reduce(function (accumulator, currentValue) {
          var expirationMetadata = getMetaByName(currentValue.metadata, 'expireAt');
          var referralSessionMetadata = getMetaByName(currentValue.metadata, 'referralSession');
          if (referralSessionMetadata) return false;
          var couponExpireAt = expirationMetadata === null || expirationMetadata === void 0 ? void 0 : expirationMetadata.value;
          var suiteCouponTimerEnd = couponExpireAt ? new Date(couponExpireAt) - Date.now() : 0;
          if (suiteCouponTimerEnd > 0) return suiteCouponTimerEnd;
          return accumulator;
        }, 0);
      });
    },
    get pointsEarned() {
      return self.bags.reduce(function (sum, bag) {
        var _bag$pointsDetails;
        var points = ((_bag$pointsDetails = bag.pointsDetails) === null || _bag$pointsDetails === void 0 ? void 0 : _bag$pointsDetails.points) || 0;
        return sum + points;
      }, 0);
    },
    get cashback() {
      return self.bags.reduce(function (sum, bag) {
        var _bag$cashbackDetails;
        var cashback = ((_bag$cashbackDetails = bag.cashbackDetails) === null || _bag$cashbackDetails === void 0 ? void 0 : _bag$cashbackDetails.value) || 0;
        return sum + cashback;
      }, 0);
    }
  };
}).actions(function (self) {
  return {
    markLoading: function markLoading(loading) {
      self.isLoading = loading;
    },
    setErrorMessage: function setErrorMessage(err) {
      if (err && err.response && err.response.data) {
        self.errorMessage = err.response.data.message;
        return true;
      }
      if (err && err.message) {
        self.errorMessage = err.message;
      }
    },
    loadCart: flow(/*#__PURE__*/_regenerator().m(function loadCart() {
      var _yield$self$root$call, data, referralRewardChanged, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            self.root.markLoading(true);
            _context.p = 1;
            _context.n = 2;
            return self.root.callbacks.onCartFetch();
          case 2:
            _yield$self$root$call = _context.v;
            data = _yield$self$root$call.data;
            referralRewardChanged = _yield$self$root$call.referralRewardChanged;
            self._id = data._id;
            self.bags = data.bags;
            self.priceDetails = data.priceDetails;
            self.discounts = data.discounts;
            self.root.callbacks.onCartCashbackChange(self.cashback);
            self.root.markLoading(false);
            if (referralRewardChanged && typeof self.root.callbacks.onRewardChanged === 'function') {
              self.root.callbacks.onRewardChanged();
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error("Failed to load ", _t);
          case 4:
            return _context.a(2);
        }
      }, loadCart, null, [[1, 3]]);
    })),
    submitCart: flow(/*#__PURE__*/_regenerator().m(function submitCart() {
      var data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            self.failedProductsIds = null;
            self.errorMessage = null;
            self.markLoading(true);
            _context2.p = 1;
            _context2.n = 2;
            return self.root.callbacks.onGetCheckoutKey(self._id, {
              priceDetails: self.priceDetails,
              metadata: self.root.metadata,
              redirects: self.root.redirects
            });
          case 2:
            data = _context2.v;
            if (!(data.error && data.type === 'shipping')) {
              _context2.n = 3;
              break;
            }
            self.failedProductsIds = data.data;
            self.markLoading(false);
            return _context2.a(2);
          case 3:
            if (data.key) {
              self.root.callbacks.onCartSubmit(self._id, data.key);
            } else if (data.updatedCart) {
              self.bags = data.updatedCart.bags;
              self.priceDetails = data.updatedCart.priceDetails;
              self.setErrorMessage({
                message: "Oops, prices have changed. Your cart total has changed since you added product(s) to cart (now $" + self.priceDetails.fullTotal + ")."
              });
              self.markLoading(false);
            }
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            self.setErrorMessage(_t2);
            self.markLoading(false);
          case 5:
            return _context2.a(2);
        }
      }, submitCart, null, [[1, 4]]);
    })),
    changeItemQty: flow(/*#__PURE__*/_regenerator().m(function changeItemQty(itemId, qty) {
      var _yield$self$root$call2, data, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            self.markLoading(true);
            _context3.p = 1;
            _context3.n = 2;
            return self.root.callbacks.onCartItemQtyChange({
              itemId: itemId,
              qty: qty
            });
          case 2:
            _yield$self$root$call2 = _context3.v;
            data = _yield$self$root$call2.data;
            self.bags = data.bags;
            self.priceDetails = data.priceDetails;
            self.root.callbacks.onCartCashbackChange(self.cashback);
            self.markLoading(false);
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            console.error("Failed to load ", _t3);
          case 4:
            return _context3.a(2);
        }
      }, changeItemQty, null, [[1, 3]]);
    })),
    updateBagPriceAndRewards: function updateBagPriceAndRewards(bagId, data) {
      var selfBagIndex = self.bags.findIndex(function (bag) {
        return bag._id === bagId;
      });
      var nonRemovedItems = self.bags[selfBagIndex].items.filter(function (item) {
        return !item.removed;
      });
      if (selfBagIndex !== -1 && data.bags[selfBagIndex] && nonRemovedItems.length) {
        self.bags[selfBagIndex].priceDetails = data.bags[selfBagIndex].priceDetails;
        self.bags[selfBagIndex].pointsDetails = data.bags[selfBagIndex].pointsDetails;
        self.bags[selfBagIndex].cashbackDetails = data.bags[selfBagIndex].cashbackDetails;
      }
      self.priceDetails = data.priceDetails;
      self.root.callbacks.onCartCashbackChange(self.cashback);
    },
    removeItem: flow(/*#__PURE__*/_regenerator().m(function removeItem(itemId, bagId) {
      var _yield$self$root$call3, data, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            self.markLoading(true);
            _context4.p = 1;
            _context4.n = 2;
            return self.root.callbacks.onCartItemRemove({
              itemId: itemId
            });
          case 2:
            _yield$self$root$call3 = _context4.v;
            data = _yield$self$root$call3.data;
            self.updateBagPriceAndRewards(bagId, data);
            self.markLoading(false);
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            console.error("Failed to load ", _t4);
          case 4:
            return _context4.a(2);
        }
      }, removeItem, null, [[1, 3]]);
    })),
    undoRemoveItem: flow(/*#__PURE__*/_regenerator().m(function undoRemoveItem(itemId, bagId) {
      var _yield$self$root$call4, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            self.markLoading(true);
            _context5.p = 1;
            _context5.n = 2;
            return self.root.callbacks.onCartItemUndoRemove({
              itemId: itemId
            });
          case 2:
            _yield$self$root$call4 = _context5.v;
            data = _yield$self$root$call4.data;
            self.updateBagPriceAndRewards(bagId, data);
            self.markLoading(false);
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            console.error("Failed to load ", _t5);
          case 4:
            return _context5.a(2);
        }
      }, undoRemoveItem, null, [[1, 3]]);
    })),
    buyNow: flow(/*#__PURE__*/_regenerator().m(function buyNow(item) {
      var metadata, payload, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            self.markLoading(true);
            _context6.p = 1;
            metadata = self.root.metadata;
            if (item.metadata && item.metadata.length) {
              item.metadata.forEach(function (data) {
                if (!metadata.some(function (rootData) {
                  return rootData.name === data.name;
                })) {
                  metadata.push(data);
                }
              });
            }
            payload = {
              productId: item.productId,
              variantId: item.variantId,
              qty: item.qty,
              prices: item.priceDetails,
              metadata: metadata,
              redirects: self.root.redirects
            };
            _context6.n = 2;
            return self.root.callbacks.onBuyNow(payload);
          case 2:
            _context6.n = 4;
            break;
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            console.error("Failed to load ", _t6);
            self.markLoading(false);
          case 4:
            return _context6.a(2);
        }
      }, buyNow, null, [[1, 3]]);
    }))
  };
});

var PointsStore = types.model('PointsStore', {
  pointsBalance: types.maybeNull(types.number),
  pointsApplied: types.maybeNull(types.number),
  availablePointsBalance: types.maybeNull(types.number),
  loading: false,
  errorMessage: types.maybeNull(types.string)
}).views(function (self) {
  return {
    get root() {
      return getParent(self);
    }
  };
}).actions(function (self) {
  var markLoading = function markLoading(loading) {
    self.loading = loading;
  };
  var setErrorMessage = function setErrorMessage(err) {
    if (err && err.response && err.response.data) {
      self.errorMessage = err.response.data.message;
      return true;
    }
    if (err && err.message) {
      self.errorMessage = err.message;
    }
  };
  var fetchPoints = flow(/*#__PURE__*/_regenerator().m(function fetchPoints() {
    var _yield$self$root$call, pointsApplied, pointsBalance, availablePointsBalance, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          markLoading(true);
          _context.p = 1;
          _context.n = 2;
          return self.root.callbacks.onPointsFetch();
        case 2:
          _yield$self$root$call = _context.v;
          pointsApplied = _yield$self$root$call.pointsApplied;
          pointsBalance = _yield$self$root$call.pointsBalance;
          availablePointsBalance = _yield$self$root$call.availablePointsBalance;
          self.pointsBalance = pointsBalance;
          self.pointsApplied = pointsApplied;
          self.availablePointsBalance = availablePointsBalance;
          markLoading(false);
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          setErrorMessage(_t);
        case 4:
          return _context.a(2);
      }
    }, fetchPoints, null, [[1, 3]]);
  }));
  var applyPoints = flow(/*#__PURE__*/_regenerator().m(function applyPoints(points) {
    var _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          markLoading(true);
          _context2.p = 1;
          _context2.n = 2;
          return self.root.callbacks.onPointsApply(points);
        case 2:
          _context2.n = 3;
          return fetchPoints();
        case 3:
          _context2.n = 4;
          return self.root.cart.loadCart();
        case 4:
          markLoading(false);
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t2 = _context2.v;
          setErrorMessage(_t2);
        case 6:
          return _context2.a(2);
      }
    }, applyPoints, null, [[1, 5]]);
  }));
  var removeAppliedPoints = flow(/*#__PURE__*/_regenerator().m(function removeAppliedPoints() {
    var _t3;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          markLoading(true);
          _context3.p = 1;
          _context3.n = 2;
          return self.root.callbacks.onPointsRemove();
        case 2:
          _context3.n = 3;
          return fetchPoints();
        case 3:
          _context3.n = 4;
          return self.root.cart.loadCart();
        case 4:
          markLoading(false);
          _context3.n = 6;
          break;
        case 5:
          _context3.p = 5;
          _t3 = _context3.v;
          setErrorMessage(_t3);
        case 6:
          return _context3.a(2);
      }
    }, removeAppliedPoints, null, [[1, 5]]);
  }));
  return {
    fetchPoints: fetchPoints,
    applyPoints: applyPoints,
    removeAppliedPoints: removeAppliedPoints
  };
});

var ViewStore$1 = types.model({
  appWidth: types.maybeNull(types.number),
  customizations: types.optional(types.model({
    rootAppName: types.maybeNull(types.string),
    showProductPoints: types.optional(types["boolean"], false),
    showApplyPointsBlock: types.optional(types["boolean"], false),
    showRewards: types.optional(types["boolean"], false)
  }), {})
}).views(function (self) {
  return {
    isSimple: function isSimple(size) {
      return size > self.appWidth;
    }
  };
}).actions(function (self) {
  return {
    setAppWidth: function setAppWidth(width) {
      self.appWidth = width;
    }
  };
});

var RootStore$2 = types.model('RootStore', {
  isLoading: true,
  cart: types.optional(CartStore, {}),
  view: types.optional(ViewStore$1, {}),
  points: types.optional(PointsStore, {})
}).views(function (self) {
  return {
    get callbacks() {
      return getEnv(self).callbacks;
    },
    get metadata() {
      return getEnv(self).metadata;
    },
    get redirects() {
      return getEnv(self).redirects;
    },
    get isLoggedIn() {
      return getEnv(self).isLoggedIn;
    }
  };
}).actions(function (self) {
  return {
    markLoading: function markLoading(loading) {
      self.isLoading = loading;
    },
    afterCreate: function afterCreate() {
      self.cart.loadCart();
    }
  };
});

var COLORS$1 = {
  $primaryBackground: '#FFEEEE',
  $infoBackground: '#E6F7FF',
  $tartRedBackground: '#FFEBEB',
  $tartRed: '#F25858'
};

var Styles$f = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1per7sc-0"
})(["width:100%;padding:24px;display:flex;flex-direction:column;background-color:", ";"], function (_ref) {
  var $type = _ref.$type;
  return $type === 'error' ? COLORS$1.$primaryBackground : COLORS$1.$infoBackground;
});
var StyledHead = styled.div.withConfig({
  displayName: "styles__StyledHead",
  componentId: "sc-1per7sc-1"
})(["display:flex;align-items:flex-start;margin-bottom:24px;"]);
var StyledIcon$8 = styled(Icon).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1per7sc-2"
})(["margin-right:17px;padding:0;"]);
var StyledItemsWrap = styled.div.withConfig({
  displayName: "styles__StyledItemsWrap",
  componentId: "sc-1per7sc-3"
})(["padding-left:40px;"]);
var StyledItemWrap = styled.div.withConfig({
  displayName: "styles__StyledItemWrap",
  componentId: "sc-1per7sc-4"
})(["&:not(:last-child){margin-bottom:24px;}"]);

var AlertItemsMessage = function AlertItemsMessage(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    message = _ref.message,
    type = _ref.type;
  return /*#__PURE__*/React__default.createElement(Styles$f, {
    $type: type,
    "data-e2e": "cart_shipping-error_block"
  }, /*#__PURE__*/React__default.createElement(StyledHead, null, type === 'error' && /*#__PURE__*/React__default.createElement(StyledIcon$8, {
    size: "22px",
    color: "error",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsClose, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeMedium",
    "data-e2e": "cart_shipping-error_description"
  }, message)), /*#__PURE__*/React__default.createElement(StyledItemsWrap, null, items.length ? items.map(function (item, key) {
    return /*#__PURE__*/React__default.createElement(StyledItemWrap, {
      key: key
    }, /*#__PURE__*/React__default.createElement(Typography.Title, {
      level: 3,
      style: {
        marginBottom: '8px'
      },
      "data-e2e": "cart_incorrect-product-title_value"
    }, item.productTitle), /*#__PURE__*/React__default.createElement(Typography.Text, {
      type: "body2",
      color: "secondaryText",
      "data-e2e": "cart_incorrect-variant-title_value"
    }, item.variantTitle.replace('Default Title', '')));
  }) : null));
};

var $white$1 = '#FFFFFF';
var $border = '#D2D6DA';
var $background = '#F4F4F4';
var $tartRed = '#FFEBEB';
var $primary$1 = '#F25858';
var $primaryText$1 = '#04080F';
var $error = '#EF2E2E';
var $secondaryText = '#77838F';

var _templateObject$1G, _templateObject2$17;
var Styles$g = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1ljx3m0-0"
})(["width:100%;", ";"], function (_ref) {
  var removed = _ref.removed;
  return removed ? css(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteralLoose(["\n                  background-color: ", ";\n                  padding: 20px 24px;\n              "])), $background) : '';
});
var CardBody = styled.div.withConfig({
  displayName: "styles__CardBody",
  componentId: "sc-1ljx3m0-1"
})(["display:flex;align-items:flex-start;justify-content:space-between;"]);
var CardBodyLeft = styled.div.withConfig({
  displayName: "styles__CardBodyLeft",
  componentId: "sc-1ljx3m0-2"
})(["display:flex;align-items:flex-start;padding-right:50px;"]);
var CardFoot = styled.div.withConfig({
  displayName: "styles__CardFoot",
  componentId: "sc-1ljx3m0-3"
})(["display:flex;align-items:center;justify-content:space-between;", ";"], function (_ref2) {
  var removed = _ref2.removed;
  return removed ? css(_templateObject2$17 || (_templateObject2$17 = _taggedTemplateLiteralLoose(["\n                  align-items: center;\n              "]))) : '';
});
var StyledImage$2 = styled(Image).withConfig({
  displayName: "styles__StyledImage",
  componentId: "sc-1ljx3m0-4"
})(["&&{width:76px;height:76px;object-fit:contain;margin-right:10px;}"]);
var ProductTitle = styled(Typography.Title).withConfig({
  displayName: "styles__ProductTitle",
  componentId: "sc-1ljx3m0-5"
})(["margin-bottom:5px;"]);
var Info = styled.div.withConfig({
  displayName: "styles__Info",
  componentId: "sc-1ljx3m0-6"
})([""]);
var Prices$1 = styled.div.withConfig({
  displayName: "styles__Prices",
  componentId: "sc-1ljx3m0-7"
})(["white-space:nowrap;text-align:right;"]);
var Buttons = styled.div.withConfig({
  displayName: "styles__Buttons",
  componentId: "sc-1ljx3m0-8"
})(["display:flex;align-items:center;"]);
var RemoveButton = styled(Button).withConfig({
  displayName: "styles__RemoveButton",
  componentId: "sc-1ljx3m0-9"
})(["&&{padding:0;color:", ";}"], $secondaryText);
var BuyNowButton = styled(Button).withConfig({
  displayName: "styles__BuyNowButton",
  componentId: "sc-1ljx3m0-10"
})(["&&{padding:0;margin-left:16px;.anticon{margin-right:8px;}}"]);
var StyledText$8 = styled(Typography.Text).withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-1ljx3m0-11"
})(["padding-right:16px;"]);
var StyledPriceLine = styled.div.withConfig({
  displayName: "styles__StyledPriceLine",
  componentId: "sc-1ljx3m0-12"
})(["display:flex;align-items:center;justify-content:flex-end;margin-bottom:5px;& > *:not(:last-child){margin-right:8px;}"]);

var REMOVED_LABEL = 'Item removed from shopping cart';
var ProductCardRemoved = function ProductCardRemoved(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React__default.createElement(Styles$g, {
    removed: true
  }, /*#__PURE__*/React__default.createElement(CardBody, {
    style: BOTTOM_INDENTS.XL
  }, /*#__PURE__*/React__default.createElement(Info, null, /*#__PURE__*/React__default.createElement(ProductTitle, {
    "data-e2e": "cart_product-removed_title",
    level: 3
  }, item.productTitle), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_variant-removed_title",
    type: "descriptor2",
    color: $secondaryText
  }, item.variantTitle.replace('Default Title', '')))), /*#__PURE__*/React__default.createElement(CardFoot, {
    removed: true
  }, /*#__PURE__*/React__default.createElement(StyledText$8, {
    "data-e2e": "cart_product-removed_text",
    type: "descriptor2",
    color: $secondaryText
  }, REMOVED_LABEL), /*#__PURE__*/React__default.createElement(Button, {
    "data-e2e": "cart_product-undo_btn",
    type: "unstyled",
    style: {
      padding: 0
    },
    onClick: function onClick() {
      return item.undoRemove();
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    marginRight: "6px",
    size: "16px",
    stylePriority: true,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgArrowReply, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "Undo"))));
};

var Styles$h = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1y44bz4-0"
})(["display:flex;align-items:center;"]);
var Input$3 = styled.input.withConfig({
  displayName: "styles__Input",
  componentId: "sc-1y44bz4-1"
})(["border:none;width:40px;text-align:center;pointer-events:none;cursor:auto;"]);
var StyledButton$b = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1y44bz4-2"
})(["&&{&,&:active,&:hover{width:28px;height:28px;background-color:", " !important;border-radius:50%;padding:0;}&:disabled{background-color:", " !important;opacity:0.5;}}"], $background, $background);

var Qty$1 = observer(function (_ref) {
  var isReferralProduct = _ref.isReferralProduct,
    isGSProduct = _ref.isGSProduct,
    value = _ref.value,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? 99999 : _ref$maxValue,
    decreaseValue = _ref.decreaseValue,
    increaseValue = _ref.increaseValue;
  return /*#__PURE__*/React__default.createElement(Styles$h, null, /*#__PURE__*/React__default.createElement(StyledButton$b, {
    "data-e2e": "cart_decrease-qty_btn",
    type: "unstyled",
    disabled: value <= 1 || isGSProduct || isReferralProduct,
    onClick: decreaseValue
  }, /*#__PURE__*/React__default.createElement(Icon, {
    stylePriority: true,
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgActionsMinus, null);
    }
  })), /*#__PURE__*/React__default.createElement(Input$3, {
    "data-e2e": "cart_product-qty_value",
    readOnly: true,
    value: value
  }), /*#__PURE__*/React__default.createElement(StyledButton$b, {
    "data-e2e": "cart_increase-qty_btn",
    type: "unstyled",
    disabled: value === maxValue || isReferralProduct,
    onClick: increaseValue
  }, /*#__PURE__*/React__default.createElement(Icon, {
    stylePriority: true,
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgActionsPlus, null);
    }
  })));
});

var StyledWrap$1 = styled.div.withConfig({
  displayName: "styles__StyledWrap",
  componentId: "sc-6fdp33-0"
})(["width:fit-content;margin:0 0 0 auto;display:flex;align-items:center;padding:4px;background-color:", ";"], $tartRed);
var StyledIcon$9 = styled(Icon).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-6fdp33-1"
})(["margin-right:4px;"]);

var Timer$1 = function Timer(_ref) {
  var endDate = _ref.endDate,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 1000 : _ref$speed,
    _ref$discountActive = _ref.discountActive,
    discountActive = _ref$discountActive === void 0 ? true : _ref$discountActive;
  var _useState = useState(0),
    timeLeft = _useState[0],
    setTimeLeft = _useState[1];
  var timer = useRef(null);
  var getTimeLeft = function getTimeLeft(date) {
    if (!date) {
      return date;
    }
    return new Date(date) - Date.now();
  };
  var msToDisplayFormat = function msToDisplayFormat(timeLeftInMilliseconds) {
    if (!timeLeftInMilliseconds) {
      return timeLeftInMilliseconds;
    }
    var timeLeftInSeconds = timeLeftInMilliseconds / 1000;
    if (timeLeftInSeconds <= 0) {
      return null;
    }
    var d = Math.floor(timeLeftInSeconds / (3600 * 24));
    var h = Math.floor(timeLeftInSeconds % (3600 * 24) / 3600);
    var m = Math.floor(timeLeftInSeconds % 3600 / 60);
    var s = Math.floor(timeLeftInSeconds % 3600 % 60);
    if (d >= 1) {
      return d + " day" + (d > 1 ? 's' : '');
    }
    if (h >= 1) {
      return h + " hour" + (h > 1 ? 's' : '');
    }
    if (m >= 1) {
      return m + " min";
    }
    if (s >= 1) {
      return s + " sec";
    }
  };
  useEffect(function () {
    setTimeLeft(getTimeLeft(endDate));
  }, [setTimeLeft, endDate]);
  useEffect(function () {
    timer.current = setTimeout(function () {
      var newTimeLeft = getTimeLeft(endDate);
      if (!timeLeft) {
        clearTimeout(timer.current);
        return;
      }
      setTimeLeft(newTimeLeft);
      clearTimeout(timer.current);
    }, speed);
    return function () {
      return clearTimeout(timer.current);
    };
  }, [speed, timeLeft, setTimeLeft, endDate]);
  var getDisplayTime = useCallback(function () {
    return msToDisplayFormat(timeLeft);
  }, [timeLeft]);
  return timeLeft ? discountActive && timeLeft > 0 ? /*#__PURE__*/React__default.createElement(StyledWrap$1, null, /*#__PURE__*/React__default.createElement(StyledIcon$9, {
    size: "12px",
    color: "primary",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgTime, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_timer_value",
    color: "primary",
    type: "descriptor2"
  }, getDisplayTime())) : /*#__PURE__*/React__default.createElement(StyledWrap$1, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_timer-expired_text",
    color: "primary",
    type: "descriptor2"
  }, "expired")) : null;
};

var ProductCard = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    item = _ref.item,
    onBuyNow = _ref.onBuyNow;
  var couponTimer = useRef(null);
  var _useState = useState(false),
    buttonsHidden = _useState[0],
    setButtonsHidden = _useState[1];
  var _getPrices = getPrices$2(_extends({}, item.priceDetails)),
    showOriginalPrice = _getPrices.showOriginalPrice,
    originalSubTotal = _getPrices.originalSubTotal,
    fullTotal = _getPrices.fullTotal,
    discountPercentage = _getPrices.discountPercentage;
  var discounts = store.cart.discounts;
  var expirationMetadata = getMetaByName(item.metadata, 'expireAt');
  var isGSProduct = getMetaByName(item.metadata, 'suiteId');
  var isReferralProduct = getMetaByName(item.metadata, 'referralSession');
  var couponExpireAt = expirationMetadata === null || expirationMetadata === void 0 ? void 0 : expirationMetadata.value;
  var itemDiscountActive = Array.isArray(discounts) && discounts.length ? discounts.some(function (discount) {
    return discount.levelId === item._id;
  }) : false;
  useEffect(function () {
    if (isReferralProduct) return;
    var suiteCouponTimerEnd = couponExpireAt ? new Date(couponExpireAt) - Date.now() : 0;
    if (suiteCouponTimerEnd && suiteCouponTimerEnd > 0 && itemDiscountActive) {
      setButtonsHidden(true);
      couponTimer.current = setTimeout(function () {
        return setButtonsHidden(false);
      }, suiteCouponTimerEnd);
    }
    return function () {
      return clearTimeout(couponTimer.current);
    };
  }, [couponExpireAt, itemDiscountActive]);
  return !item.removed ? /*#__PURE__*/React__default.createElement(Styles$g, null, /*#__PURE__*/React__default.createElement(CardBody, {
    style: BOTTOM_INDENTS.SM
  }, /*#__PURE__*/React__default.createElement(CardBodyLeft, null, /*#__PURE__*/React__default.createElement(StyledImage$2, {
    src: item.image,
    alt: item.productTitle,
    "data-e2e": "cart_product_image"
  }), /*#__PURE__*/React__default.createElement(Info, null, /*#__PURE__*/React__default.createElement(ProductTitle, {
    "data-e2e": "cart_product-title_value",
    level: 3
  }, item.productTitle), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_variant-title_value",
    type: "descriptor2",
    color: $secondaryText
  }, item.variantTitle.replace('Default Title', '')))), /*#__PURE__*/React__default.createElement(Prices$1, null, /*#__PURE__*/React__default.createElement(StyledPriceLine, null, showOriginalPrice ? /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_product-original-price_value",
    type: "descriptor2",
    color: $secondaryText,
    style: {
      textDecoration: 'line-through'
    },
    align: "right"
  }, originalSubTotal) : null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_product-total-price_value",
    type: "body2",
    color: $secondaryText,
    align: "right"
  }, fullTotal)), !expirationMetadata ? /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_product-discount-percentage_value",
    type: "body2",
    color: $secondaryText,
    align: "right"
  }, discountPercentage) : null, couponExpireAt && !isReferralProduct ? /*#__PURE__*/React__default.createElement(Timer$1, {
    endDate: couponExpireAt,
    discountActive: itemDiscountActive
  }) : null)), /*#__PURE__*/React__default.createElement(CardFoot, null, /*#__PURE__*/React__default.createElement(Qty$1, {
    "data-e2e": "cart_product-qty_value",
    isGSProduct: isGSProduct,
    isReferralProduct: isReferralProduct,
    value: item.qty,
    maxValue: item.maxQty,
    decreaseValue: function decreaseValue() {
      item.decrementQty();
      item.updateQty();
    },
    increaseValue: function increaseValue() {
      item.incrementQty();
      item.updateQty();
    }
  }), !buttonsHidden ? /*#__PURE__*/React__default.createElement(Buttons, null, /*#__PURE__*/React__default.createElement(RemoveButton, {
    "data-e2e": "cart_product-remove_btn",
    type: "unstyled",
    onClick: function onClick() {
      return item.softRemove();
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "Remove")), /*#__PURE__*/React__default.createElement(BuyNowButton, {
    "data-e2e": "cart_product-buy-now_btn",
    type: "unstyled",
    onClick: function onClick() {
      return onBuyNow(item);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    stylePriority: true,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBag, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "Buy now"))) : null, buttonsHidden && typeof store.callbacks.onCartCouponRemove === 'function' ? /*#__PURE__*/React__default.createElement(Buttons, null, /*#__PURE__*/React__default.createElement(RemoveButton, {
    "data-e2e": "cart_change-reward_btn",
    type: "unstyled",
    onClick: function onClick() {
      item.hardRemove(store.callbacks.onCartCouponRemove);
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "Change reward"))) : null)) : /*#__PURE__*/React__default.createElement(ProductCardRemoved, {
    item: item
  });
}));

var _templateObject$1H, _templateObject2$18, _templateObject3$J, _templateObject4$x;
var Styles$i = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1f5klvh-0"
})(["width:100%;padding:40px 0 15px;&:not(:last-child){border-bottom:1px solid ", ";}", ";"], $border, function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? css(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteralLoose(["\n                  padding: 24px 0 15px;\n              "]))) : '';
});
var CardHead = styled.div.withConfig({
  displayName: "styles__CardHead",
  componentId: "sc-1f5klvh-1"
})(["display:flex;align-items:center;justify-content:space-between;", ";"], function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject2$18 || (_templateObject2$18 = _taggedTemplateLiteralLoose(["\n                  padding: 0 24px;\n              "]))) : '';
});
var CardBody$1 = styled.div.withConfig({
  displayName: "styles__CardBody",
  componentId: "sc-1f5klvh-2"
})(["width:100%;", ";"], function (_ref3) {
  var $simple = _ref3.$simple;
  return $simple ? css(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteralLoose(["\n                  padding: 0 24px;\n              "]))) : '';
});
var StyledText$9 = styled.div.withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-1f5klvh-3"
})(["padding-right:16px;"]);
var StyledIcon$a = styled(Icon).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1f5klvh-4"
})(["margin-right:4px;"]);
var WelcomeGiftText = styled.div.withConfig({
  displayName: "styles__WelcomeGiftText",
  componentId: "sc-1f5klvh-5"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:8px;background:", ";color:", ";"], COLORS$1.$tartRedBackground, COLORS$1.$tartRed);
var WelcomeGiftPoints = styled.div.withConfig({
  displayName: "styles__WelcomeGiftPoints",
  componentId: "sc-1f5klvh-6"
})(["display:flex;align-items:center;"]);
var StyledBadge$1 = styled(Typography.Text).withConfig({
  displayName: "styles__StyledBadge",
  componentId: "sc-1f5klvh-7"
})(["&&{display:flex;align-items:center;width:fit-content;margin:-5px 0 0 auto;white-space:nowrap;overflow:hidden;", ";}"], function (_ref4) {
  var $simple = _ref4.$simple;
  return $simple ? css(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteralLoose(["\n                      padding: 0 24px;\n                  "]))) : '';
});
var StyledPointsCount$1 = styled(Typography.Text).withConfig({
  displayName: "styles__StyledPointsCount",
  componentId: "sc-1f5klvh-8"
})(["font-weight:500;"]);

var BrandCard = observer(function (_ref) {
  var bag = _ref.bag,
    orderNumber = _ref.orderNumber,
    simple = _ref.simple,
    showProductPoints = _ref.showProductPoints,
    onBuyNow = _ref.onBuyNow;
  var items = bag.items || [];
  var pointsDetails = bag.pointsDetails || {};
  return /*#__PURE__*/React__default.createElement(Styles$i, {
    $simple: simple,
    "data-e2e": "cart_order-" + orderNumber + "_card"
  }, /*#__PURE__*/React__default.createElement(CardHead, {
    style: BOTTOM_INDENTS.SM,
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(StyledText$9, {
    "data-e2e": "cart_order-number_value",
    type: "badgeLarge"
  }, "Order \u2116", orderNumber, "" + (bag.merchantName ? " - " + bag.merchantName : '')), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_order-total-price_value",
    type: "body1"
  }, "$" + roundToLocaleString(bag.priceDetails.fullTotal))), showProductPoints && pointsDetails.isWelcome ? /*#__PURE__*/React__default.createElement(WelcomeGiftText, {
    "data-e2e": "cart_welcome-gift_block"
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-e2e": "cart_welcome-gift-title_value"
  }, bag.merchantName, " Welcome Gift for your first order"), /*#__PURE__*/React__default.createElement(WelcomeGiftPoints, {
    "data-e2e": "cart_welcome-gift-points_value"
  }, /*#__PURE__*/React__default.createElement(StyledIcon$a, {
    size: "14px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgPoints, null);
    }
  }), " +", roundToLocaleString(pointsDetails.points, 0))) : null, showProductPoints && pointsDetails.points && !pointsDetails.isWelcome ? /*#__PURE__*/React__default.createElement(StyledBadge$1, {
    $simple: simple,
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(StyledIcon$a, {
    size: "14px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgPoints, null);
    }
  }), /*#__PURE__*/React__default.createElement(StyledPointsCount$1, {
    "data-e2e": "cart_points_value",
    type: "description1",
    as: "span"
  }, "+", formatPoints$1(pointsDetails.points, {
    million: true,
    billion: true
  }))) : null, /*#__PURE__*/React__default.createElement(CardBody$1, {
    style: TOP_INDENTS.SM,
    $simple: simple
  }, items.length && items.map(function (item, key) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      style: BOTTOM_INDENTS.XL,
      "data-e2e": "cart_product-" + item.productId + "_card"
    }, /*#__PURE__*/React__default.createElement(ProductCard, {
      points: pointsDetails.points,
      key: key,
      item: item,
      onBuyNow: onBuyNow
    }));
  })));
});

var Styles$j = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1d1mj07-0"
})(["width:100%;padding:12px 25px;display:flex;align-items:center;background-color:", ";"], COLORS$1.$primaryBackground);
var StyledIcon$b = styled(Icon).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1d1mj07-1"
})(["margin-right:17px;padding:0;"]);

var Error$1 = function Error(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React__default.createElement(Styles$j, null, /*#__PURE__*/React__default.createElement(StyledIcon$b, {
    size: "22px",
    color: "error",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsClose, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "descriptor1"
  }, message));
};

var _templateObject$1I, _templateObject2$19, _templateObject3$K, _templateObject4$y;
var WrapStyles$3 = styled.div.withConfig({
  displayName: "styles__WrapStyles",
  componentId: "sc-1ss00yc-0"
})(["width:100%;height:100%;overflow-y:auto;", ";"], function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? css(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteralLoose(["\n                  height: auto;\n                  overflow-y: visible;\n              "]))) : '';
});
var Styles$k = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1ss00yc-1"
})(["max-width:738px;width:100%;margin:0 auto;padding:20px 24px 40px;", ";"], function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject2$19 || (_templateObject2$19 = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n                  padding: 0;\n              "]))) : '';
});
var StyledHeadLine2 = styled(Typography.Title).withConfig({
  displayName: "styles__StyledHeadLine2",
  componentId: "sc-1ss00yc-2"
})(["", ";"], function (_ref3) {
  var $simple = _ref3.$simple;
  return $simple ? css(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteralLoose(["\n                  padding: 0 24px;\n              "]))) : '';
});
var BackButton = styled(Button).withConfig({
  displayName: "styles__BackButton",
  componentId: "sc-1ss00yc-3"
})(["&&{padding:0;", ";}"], function (_ref4) {
  var $simple = _ref4.$simple;
  return $simple ? css(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteralLoose(["\n                      padding: 24px 0 0 24px;\n                  "]))) : '';
});

var Details$1 = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    bottomExtraContent = _ref.bottomExtraContent;
  var simple = store.view.isSimple(GRID_POINTS$3.md);
  var showBackButton = Boolean(store.callbacks.onBackButtonClick);
  var showProductPoints = store.view.customizations.showProductPoints;
  return /*#__PURE__*/React__default.createElement(WrapStyles$3, {
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(Styles$k, {
    $simple: simple
  }, showBackButton ? /*#__PURE__*/React__default.createElement(BackButton, {
    "data-e2e": "cart_back_btn",
    $simple: simple,
    type: "unstyled",
    onClick: store.callbacks.onBackButtonClick
  }, /*#__PURE__*/React__default.createElement(Icon, {
    size: "24px",
    stylePriority: true,
    component: function component() {
      return simple ? /*#__PURE__*/React__default.createElement(SvgCloseX, null) : /*#__PURE__*/React__default.createElement(SvgBackArrow, null);
    }
  })) : null, /*#__PURE__*/React__default.createElement(StyledHeadLine2, {
    style: _extends({}, TOP_INDENTS.SM, BOTTOM_INDENTS.SM),
    "data-e2e": "cart_page_title",
    level: 2,
    $simple: simple,
    color: "primaryText"
  }, "Shopping cart"), store.cart.failedProductsIds ? /*#__PURE__*/React__default.createElement(AlertItemsMessage, {
    type: "error",
    message: "An item(s) you added can\u2019t be shipped to your address. Remove an item(s) to complete the order.",
    items: store.cart.failedProductsData
  }) : null, store.cart.errorMessage ? /*#__PURE__*/React__default.createElement(Error$1, {
    message: store.cart.errorMessage
  }) : null, store.cart.bags && store.cart.bags.length && store.cart.bags.map(function (bag, key) {
    return /*#__PURE__*/React__default.createElement(BrandCard, {
      key: key,
      orderNumber: key + 1,
      bag: bag,
      simple: simple,
      showProductPoints: showProductPoints,
      onBuyNow: store.cart.buyNow
    });
  })), !simple && bottomExtraContent ? bottomExtraContent : null);
}));

var _templateObject$1J, _templateObject2$1a, _templateObject3$L;
var Styles$l = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-o5o2vc-0"
})(["max-width:1063px;width:100%;margin:0 auto;padding:0 24px;display:flex;flex-direction:column;", ";"], function (_ref) {
  var simple = _ref.simple;
  return !simple ? css(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteralLoose(["\n                  height: 100%;\n              "]))) : '';
});
var BodyStyles$4 = styled.div.withConfig({
  displayName: "styles__BodyStyles",
  componentId: "sc-o5o2vc-1"
})(["display:flex;flex-direction:column;align-items:center;flex-grow:1;justify-content:center;padding-bottom:50px;"]);
var StyledIcon$c = styled(Icon).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-o5o2vc-2"
})(["width:120px;height:120px;border-radius:50%;background-color:", ";display:flex;justify-content:center;align-items:center;"], $background);
var StyledHeadLine2$1 = styled(Typography.Title).withConfig({
  displayName: "styles__StyledHeadLine2",
  componentId: "sc-o5o2vc-3"
})(["text-align:center;"]);
var StyledText$a = styled(Typography.Text).withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-o5o2vc-4"
})(["text-align:center;"]);
var StyledButton$c = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-o5o2vc-5"
})(["&&{", ";.anticon{margin-right:8px;}}"], function (_ref2) {
  var $simple = _ref2.$simple;
  return !$simple ? css(_templateObject2$1a || (_templateObject2$1a = _taggedTemplateLiteralLoose(["\n                      padding-left: 90px;\n                      padding-right: 90px;\n                  "]))) : css(_templateObject3$L || (_templateObject3$L = _taggedTemplateLiteralLoose(["\n                      width: 100%;\n                  "])));
});

var EmptyCart = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var simple = store.view.isSimple(GRID_POINTS$3.md);
  var continueShoppingUrl = store.redirects.continueShoppingUrl;
  var rootAppName = store.view.customizations.rootAppName;
  var marketplaceName = rootAppName === 'dp' ? '' : 'Giftly';
  return /*#__PURE__*/React__default.createElement(Styles$l, null, /*#__PURE__*/React__default.createElement(Typography.Title, {
    "data-e2e": "cart_page_title",
    style: BOTTOM_INDENTS.SM,
    level: 2,
    color: "primaryText"
  }, "Shopping cart"), /*#__PURE__*/React__default.createElement(BodyStyles$4, null, /*#__PURE__*/React__default.createElement(StyledIcon$c, {
    style: BOTTOM_INDENTS.SM,
    size: "40px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBag, null);
    }
  }), /*#__PURE__*/React__default.createElement(StyledHeadLine2$1, {
    "data-e2e": "cart_no-item_title",
    style: BOTTOM_INDENTS.SM,
    level: 2
  }, "No items in cart"), /*#__PURE__*/React__default.createElement(StyledText$a, {
    style: BOTTOM_INDENTS.XL
  }, "Discover new products and brands in the ", marketplaceName, " Marketplace"), /*#__PURE__*/React__default.createElement(StyledButton$c, {
    "data-e2e": "cart_shop-" + formatString(marketplaceName) + "_btn",
    type: "primary",
    size: "large",
    $simple: simple,
    onClick: function onClick() {
      return window.location.replace(continueShoppingUrl);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    size: "24px",
    stylePriority: true,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCart, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, "Shop ", marketplaceName))));
}));

var _templateObject$1K, _templateObject2$1b, _templateObject3$M;
var StyledWrapper$e = styled.div(_templateObject$1K || (_templateObject$1K = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n"])));
var StyledIcon$d = styled(Icon)(_templateObject2$1b || (_templateObject2$1b = _taggedTemplateLiteralLoose(["\n    margin-right: 4px;\n"])));
var StyledText$b = styled(Typography.Text)(_templateObject3$M || (_templateObject3$M = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n\n    > span {\n        margin-left: 6px;\n    }\n"])));

var Cashback = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(StyledWrapper$e, null, /*#__PURE__*/React__default.createElement(StyledText$b, {
    "data-e2e": "cart_cash-back_title",
    type: "body2",
    color: "primary"
  }, "Cash back"), /*#__PURE__*/React__default.createElement(StyledText$b, {
    "data-e2e": "cart_cash-back_value",
    type: "body2",
    color: "primary"
  }, "$", roundToLocaleString(store.cart.cashback, 2)));
}));

var _templateObject$1L, _templateObject2$1c, _templateObject3$N;
var StyledWrapper$f = styled.div(_templateObject$1L || (_templateObject$1L = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n"])));
var StyledIcon$e = styled(Icon)(_templateObject2$1c || (_templateObject2$1c = _taggedTemplateLiteralLoose(["\n    margin-right: 4px;\n"])));
var StyledText$c = styled(Typography.Text)(_templateObject3$N || (_templateObject3$N = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n\n    > span {\n        margin-left: 6px;\n    }\n"])));

var getProducts = function getProducts(bags) {
  return bags.reduce(function (result, bag) {
    return [].concat(result, bag.items.map(function (item) {
      var _item$metadata$find, _item$priceDetails, _item$priceDetails2;
      return {
        data: {
          images: [item === null || item === void 0 ? void 0 : item.image],
          brandName: bag === null || bag === void 0 ? void 0 : bag.merchantName,
          title: item === null || item === void 0 ? void 0 : item.productTitle
        },
        variants: {
          list: [{
            pointsDetails: (_item$metadata$find = item.metadata.find(function (metaItem) {
              return metaItem.name === 'pointsEarned';
            })) === null || _item$metadata$find === void 0 ? void 0 : _item$metadata$find.details,
            price: (item === null || item === void 0 ? void 0 : (_item$priceDetails = item.priceDetails) === null || _item$priceDetails === void 0 ? void 0 : _item$priceDetails.subTotal) / (item === null || item === void 0 ? void 0 : (_item$priceDetails2 = item.priceDetails) === null || _item$priceDetails2 === void 0 ? void 0 : _item$priceDetails2.qty) || 0
          }]
        }
      };
    }));
  }, []);
};

var EarnedPoints$1 = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var onPointsIconClick = store.callbacks.onPointsIconClick;
  var products = getProducts(getSnapshot(store.cart.bags));
  return /*#__PURE__*/React__default.createElement(StyledWrapper$f, null, /*#__PURE__*/React__default.createElement(StyledText$c, {
    "data-e2e": "cart_points-earned_title",
    type: "body2",
    color: "primary"
  }, store.isLoggedIn ? 'Points you’ll earn' : 'Members earn', /*#__PURE__*/React__default.createElement(Icon, {
    "data-e2e": "cart_points-earned_icon",
    size: "12px",
    onClick: function onClick() {
      return onPointsIconClick(products);
    },
    color: $primary$1,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertQuestion, null);
    }
  })), /*#__PURE__*/React__default.createElement(StyledText$c, {
    "data-e2e": "cart_points-earned_value",
    type: "body2",
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(StyledIcon$e, {
    size: "14px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgPoints, null);
    }
  }), " +", roundToLocaleString(store.cart.pointsEarned, 0)));
}));

var _templateObject$1M, _templateObject2$1d, _templateObject3$O, _templateObject4$z, _templateObject5$k, _templateObject6$c, _templateObject7$6, _templateObject8$4, _templateObject9$1;
var StyledPayWithPointsForm = styled.div(_templateObject$1M || (_templateObject$1M = _taggedTemplateLiteralLoose(["\n    margin-bottom: 16px;\n    padding: 10px 0 20px;\n    border-bottom: 1px solid ", ";\n    position: relative;\n    min-height: 119px;\n"])), $border);
var StyledText$d = styled(Typography.Text)(_templateObject2$1d || (_templateObject2$1d = _taggedTemplateLiteralLoose(["\n    margin-bottom: 8px;\n"])));
var StyledFormWrapper = styled.div(_templateObject3$O || (_templateObject3$O = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n"])));
var StyledFormTitle = styled.div(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n\n    p {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 230px;\n    }\n"])));
var StyledField$1 = styled(KliField)(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteralLoose(["\n    && {\n        width: 230px;\n        background: ", ";\n        margin-right: 16px;\n        padding: 16px 24px;\n        outline: none !important;\n        box-shadow: none !important;\n\n        ", "\n    }\n"])), $white$1, function (_ref) {
  var $invalid = _ref.$invalid;
  return $invalid ? css(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteralLoose(["\n                      border: 2px solid ", ";\n                  "])), $error) : '';
});
var StyledErrorText = styled(Typography.Text)(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteralLoose(["\n    margin-top: 12px;\n"])));
var AppliedPointsWrap = styled.div(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteralLoose([""])));
var StyledPointsButton = styled(Button)(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n    && {\n        padding: 0;\n        margin-bottom: 8px;\n\n        p {\n            margin-bottom: 0;\n            margin-right: 4px !important;\n        }\n    }\n"])));

var PayWithPointsForm = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var _useState = useState(''),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(''),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState('Points to use'),
    placeholder = _useState3[0],
    setPlaceholder = _useState3[1];
  var _store$points = store.points,
    pointsBalance = _store$points.pointsBalance,
    availablePointsBalance = _store$points.availablePointsBalance,
    pointsApplied = _store$points.pointsApplied,
    removeAppliedPoints = _store$points.removeAppliedPoints,
    loading = _store$points.loading,
    errorMessage = _store$points.errorMessage,
    fetchPoints = _store$points.fetchPoints,
    applyPoints = _store$points.applyPoints;
  var onValueChange = function onValueChange(val) {
    setValue(val);
    if (val && val < 1000) {
      setError('1,000 points minimum');
      return;
    } else {
      setError('');
    }
    if (val > availablePointsBalance) {
      setError("You have " + formatPoints$1(availablePointsBalance) + " pts available");
    } else {
      setError('');
    }
  };
  var onApplyPoints = function onApplyPoints() {
    applyPoints(value);
  };
  var checkPlaceholder = function checkPlaceholder() {
    if (value) setPlaceholder('');else setPlaceholder('Points to use');
  };
  useEffect(function () {
    if (pointsBalance === null && !loading && !errorMessage) {
      fetchPoints();
    }
  }, [pointsBalance, loading, errorMessage]);
  return /*#__PURE__*/React__default.createElement(StyledPayWithPointsForm, null, loading ? /*#__PURE__*/React__default.createElement(Icon.Loader, null) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledFormTitle, null, /*#__PURE__*/React__default.createElement(StyledText$d, {
    "data-e2e": "cart_available-points_text",
    type: "body2",
    color: "secondaryText"
  }, "Pay with points (", formatPoints$1(availablePointsBalance), " available)"), /*#__PURE__*/React__default.createElement(AppliedPointsWrap, null, pointsApplied ? /*#__PURE__*/React__default.createElement(StyledPointsButton, {
    type: "unstyled"
  }, /*#__PURE__*/React__default.createElement(StyledText$d, {
    "data-e2e": "cart_points-applied_text",
    type: "body2",
    color: "secondaryText"
  }, "\u2013" + formatPoints$1(pointsApplied) + " pts"), /*#__PURE__*/React__default.createElement(Icon, {
    stylePriority: true,
    size: "16px",
    color: "secondaryText",
    onClick: removeAppliedPoints,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  })) : null)), /*#__PURE__*/React__default.createElement(StyledFormWrapper, null, /*#__PURE__*/React__default.createElement(StyledField$1, {
    "data-e2e": "cart_use-points_input",
    $invalid: Boolean(error),
    type: "number",
    placeholder: placeholder,
    value: value,
    onFocus: function onFocus() {
      return setPlaceholder('');
    },
    onBlur: function onBlur() {
      return checkPlaceholder();
    },
    onChange: function onChange(_ref2) {
      var newValue = _ref2.target.value;
      return onValueChange(newValue);
    },
    onClearButtonCallback: function onClearButtonCallback() {
      onValueChange('');
      checkPlaceholder();
    },
    max: pointsBalance,
    withoutBorderColorsOnValidate: true
  }), /*#__PURE__*/React__default.createElement(Button, {
    "data-e2e": "cart_apply-points_btn",
    type: "primary",
    ghost: true,
    disabled: !value || error,
    onClick: onApplyPoints
  }, "Apply")), error ? /*#__PURE__*/React__default.createElement(StyledErrorText, {
    "data-e2e": "cart_points-apply_error",
    type: "badgeSmall",
    color: "error"
  }, error) : null));
}));

var useInterval = function useInterval(action, timeInterval, stopInterval) {
  if (action === void 0) {
    action = function action() {
      return null;
    };
  }
  if (timeInterval === void 0) {
    timeInterval = 1000;
  }
  useEffect(function () {
    var interval = setInterval(function () {
      action();
    }, timeInterval);
    if (stopInterval) clearInterval(interval);
    return function () {
      return clearInterval(interval);
    };
  }, [timeInterval, action]);
};

var useScrollable = function useScrollable(targetRef, handle, onBottom) {
  if (handle === void 0) {
    handle = null;
  }
  if (onBottom === void 0) {
    onBottom = null;
  }
  var onScroll = useCallback(function (e) {
    if (!e) {
      return;
    }
    if (handle) {
      handle(e);
    }
    if (Math.round(e.target.scrollHeight - e.target.scrollTop) === e.target.clientHeight && onBottom) {
      onBottom(e);
    }
  }, [handle, onBottom]);
  useEffect(function () {
    var current = targetRef.current;
    if (current) {
      current.addEventListener('scroll', onScroll);
    }
    return function () {
      if (current) {
        current.removeEventListener('scroll', onScroll);
      }
    };
  }, [targetRef, onScroll]);
};

var _templateObject$1N, _templateObject2$1e;
var StyledWrapper$g = styled.div(_templateObject$1N || (_templateObject$1N = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 4px 0 10px;\n"])));
var StyledText$e = styled(Typography.Text)(_templateObject2$1e || (_templateObject2$1e = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n\n    > span {\n        margin-left: 6px;\n    }\n"])));

var getAvailableRewards = function getAvailableRewards(rewards) {
  return rewards.filter(function (_ref) {
    var expireAt = _ref.expireAt;
    return !expireAt || new Date(expireAt).valueOf() > new Date().valueOf();
  });
};

var getDiscount = function getDiscount(bags) {
  var discountInUsd = bags.reduce(function (result, bag) {
    return result + bag.priceDetails.discounts + (bag.priceDetails.originalSubTotal - bag.priceDetails.subTotal);
  }, 0);
  var discountInPercents = Math.round(discountInUsd / (bags.reduce(function (result, bag) {
    return result + bag.priceDetails.originalSubTotal;
  }, 0) / 100));
  return {
    discountInUsd: discountInUsd,
    discountInPercents: discountInPercents
  };
};

var getRewardsData = function getRewardsData(bags) {
  return bags.reduce(function (result, bag) {
    var rewardDataArray = bag.items.map(function (item) {
      var _item$metadata$find;
      return _extends({}, ((_item$metadata$find = item.metadata.find(function (metaItem) {
        return metaItem.name === 'rewardsDetails';
      })) === null || _item$metadata$find === void 0 ? void 0 : _item$metadata$find.value) || {}, {
        qty: item.priceDetails.qty
      });
    });
    return {
      rewards: [].concat(result.rewards, rewardDataArray.reduce(function (res, rewardItem) {
        return [].concat(res, (rewardItem === null || rewardItem === void 0 ? void 0 : rewardItem.rewards) || []);
      }, [])),
      priceDetails: [].concat(result.priceDetails, rewardDataArray.map(function (rewardItem) {
        return _extends({}, rewardItem.priceDetails, {
          qty: rewardItem.qty
        });
      }))
    };
  }, {
    rewards: [],
    priceDetails: []
  });
};

var RewardsApplied$1 = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var onRewardIconClick = store.callbacks.onRewardIconClick;
  var rewardsData = getRewardsData(getSnapshot(store.cart.bags));
  var _getDiscount = getDiscount(getSnapshot(store.cart.bags)),
    discountInUsd = _getDiscount.discountInUsd,
    discountInPercents = _getDiscount.discountInPercents;
  var appliedRewards = getAvailableRewards(rewardsData.rewards);
  useInterval(function () {
    if (getAvailableRewards(appliedRewards).length !== appliedRewards.length) {
      window.location.reload();
    }
  });
  return appliedRewards.length ? /*#__PURE__*/React__default.createElement(StyledWrapper$g, null, /*#__PURE__*/React__default.createElement(StyledText$e, {
    "data-e2e": "cart_rewards-applied_title",
    type: "body2"
  }, appliedRewards.length, " Rewards applied", /*#__PURE__*/React__default.createElement(Icon, {
    "data-e2e": "cart_reward-question_icon",
    size: "12px",
    onClick: function onClick() {
      return onRewardIconClick(rewardsData);
    },
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertQuestion, null);
    }
  })), /*#__PURE__*/React__default.createElement(StyledText$e, {
    type: "body2",
    "data-e2e": "cart_rewards-applied_value"
  }, "\u2013$", roundToLocaleString(discountInUsd), " (", discountInPercents, "% off)")) : null;
}));

var _templateObject$1O, _templateObject2$1f;
var Styles$m = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1xyp4s4-0"
})(["min-width:385px;width:385px;background-color:", ";padding:24px;display:flex;flex-direction:column;", ";"], $background, function (_ref) {
  var $simple = _ref.$simple,
    $withExtraBottomContent = _ref.$withExtraBottomContent;
  return $simple ? css(_templateObject$1O || (_templateObject$1O = _taggedTemplateLiteralLoose(["\n                  min-width: unset;\n                  max-width: 100%;\n                  width: 100%;\n                  padding-bottom: ", ";\n              "])), $withExtraBottomContent ? '24px' : '130px') : '';
});
var DetailsBody = styled.div.withConfig({
  displayName: "styles__DetailsBody",
  componentId: "sc-1xyp4s4-1"
})(["color:", ";padding-bottom:10px;border-bottom:1px solid ", ";"], $secondaryText, $border);
var DetailsFoot = styled.div.withConfig({
  displayName: "styles__DetailsFoot",
  componentId: "sc-1xyp4s4-2"
})(["padding-top:10px;"]);
var PriceRow$1 = styled.div.withConfig({
  displayName: "styles__PriceRow",
  componentId: "sc-1xyp4s4-3"
})(["display:flex;align-items:center;justify-content:space-between;padding:5px 0;white-space:nowrap;"]);
var ButtonWrap$1 = styled.div.withConfig({
  displayName: "styles__ButtonWrap",
  componentId: "sc-1xyp4s4-4"
})(["width:100%;margin-top:auto;background-color:inherit;", ";.anticon{margin-right:8px;}"], function (_ref2) {
  var simple = _ref2.simple;
  return simple ? css(_templateObject2$1f || (_templateObject2$1f = _taggedTemplateLiteralLoose(["\n                  width: 100%;\n                  margin: 0;\n                  position: absolute;\n                  left: 0;\n                  bottom: 0;\n                  z-index: 5;\n\n                  background-color: ", ";\n                  padding: 24px;\n                  border-top: 1px solid ", ";\n              "])), $white$1, $border) : '';
});

var PricesDetails = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    withExtraBottomContent = _ref.withExtraBottomContent,
    buttonBadge = _ref.buttonBadge;
  var simple = store.view.isSimple(GRID_POINTS$3.md);
  var priceDetails = store.cart.priceDetails;
  var pointsEarned = store.cart.pointsEarned;
  var cashback = store.cart.cashback;
  var hasGsProductInCart = store.cart.hasGsProductInCart;
  var customizations = store.view.customizations;
  var showApplyPointsBlock = customizations.showApplyPointsBlock,
    showRewards = customizations.showRewards;
  var _getPrices = getPrices$2(_extends({}, priceDetails)),
    originalSubTotal = _getPrices.originalSubTotal,
    discounts = _getPrices.discounts,
    fullTotal = _getPrices.fullTotal,
    discountPercentage = _getPrices.discountPercentage;
  return /*#__PURE__*/React__default.createElement(Styles$m, {
    $simple: simple,
    $withExtraBottomContent: withExtraBottomContent
  }, /*#__PURE__*/React__default.createElement(DetailsBody, null, /*#__PURE__*/React__default.createElement(PriceRow$1, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_items-number_title",
    type: "body2"
  }, "Number of items"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_items-number_value",
    type: "body2"
  }, priceDetails.qty)), /*#__PURE__*/React__default.createElement(PriceRow$1, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_original-price_title",
    type: "body2"
  }, "Original price"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_original-price_value",
    type: "body2"
  }, originalSubTotal)), discounts && !showRewards ? /*#__PURE__*/React__default.createElement(PriceRow$1, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_you-save_title",
    type: "body2"
  }, "You save"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_you-save_value",
    type: "body2"
  }, discounts)) : null, showRewards && /*#__PURE__*/React__default.createElement(RewardsApplied$1, {
    discountInPercents: 75,
    discountInUsd: 12,
    rewardsCount: 3
  })), /*#__PURE__*/React__default.createElement(DetailsFoot, null, showApplyPointsBlock ? /*#__PURE__*/React__default.createElement(PayWithPointsForm, {
    priceDetails: priceDetails
  }) : null, /*#__PURE__*/React__default.createElement(PriceRow$1, {
    "data-e2e": "cart_estimated-total_title"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, "Estimated total"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_estimated-total_value",
    type: "badgeLarge"
  }, fullTotal, " ", discountPercentage)), pointsEarned ? /*#__PURE__*/React__default.createElement(EarnedPoints$1, null) : null, cashback ? /*#__PURE__*/React__default.createElement(Cashback, null) : null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "cart_shipping-info_text",
    type: "descriptor2",
    color: "secondaryText"
  }, "Shipping and taxes are calculated at checkout")), /*#__PURE__*/React__default.createElement(ButtonWrap$1, {
    simple: simple
  }, /*#__PURE__*/React__default.createElement(Button, {
    "data-e2e": hasGsProductInCart ? 'cart_claim-gift_btn' : 'cart_check-out_btn',
    type: "primary",
    ghost: true,
    block: true,
    size: "large",
    onClick: function onClick() {
      return store.cart.submitCart();
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    stylePriority: true,
    size: "24px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBag, null);
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, hasGsProductInCart ? 'Claim Gift' : 'Check out')), simple && buttonBadge ? buttonBadge : null));
}));

var _templateObject$1P;
var Styles$n = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1655bwl-0"
})(["display:flex;height:100%;overflow-y:auto;", ";"], function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject$1P || (_templateObject$1P = _taggedTemplateLiteralLoose(["\n                  flex-direction: column;\n              "]))) : '';
});

var ShoppingCart = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    bottomExtraContent = _ref.bottomExtraContent,
    buttonBadge = _ref.buttonBadge;
  var simple = store.view.isSimple(GRID_POINTS$3.md);
  if (store.isLoading) {
    return /*#__PURE__*/React__default.createElement(Icon.Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Styles$n, {
    simple: simple
  }, !store.cart.isEmpty ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Details$1, {
    bottomExtraContent: bottomExtraContent
  }), /*#__PURE__*/React__default.createElement(PricesDetails, {
    withExtraBottomContent: Boolean(bottomExtraContent),
    buttonBadge: buttonBadge
  }), simple && bottomExtraContent ? bottomExtraContent : null) : /*#__PURE__*/React__default.createElement(EmptyCart, null));
}));

var ContainerStyles = styled.div.withConfig({
  displayName: "styles__ContainerStyles",
  componentId: "sc-2bwld6-0"
})(["width:100%;height:100%;overflow-y:auto;position:relative;"]);

var _excluded$P = ["store"];
var AppContainer$1 = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$P);
  var _useState = useState(null),
    node = _useState[0],
    setNode = _useState[1];
  var appRef = useCallback(function (node) {
    if (node !== null) {
      setNode(node);
      store.view.setAppWidth(node.offsetWidth);
    }
  }, []);
  useLayoutEffect(function () {
    if (node) {
      var onResize = debounce$2(function () {
        store.view.setAppWidth(node.offsetWidth);
      }, 500);
      window.addEventListener('resize', onResize);
      return function () {
        window.removeEventListener('resize', onResize);
      };
    }
  }, [node]);
  return /*#__PURE__*/React__default.createElement(ContainerStyles, {
    ref: appRef
  }, store.cart.isLoading && /*#__PURE__*/React__default.createElement(Icon.Loader, {
    overlayColor: "rgba(255,255,255, 0.8)"
  }), /*#__PURE__*/React__default.createElement(ShoppingCart, props));
}));

function App(props) {
  return /*#__PURE__*/React__default.createElement(ModalProvider, null, /*#__PURE__*/React__default.createElement(AppContainer$1, props));
}

var _templateObject$1Q, _templateObject2$1g, _templateObject3$P;
var isIos$1 = device.iOS();
var isSafari$1 = device.isSafari();
var GlobalStyle = createGlobalStyle(_templateObject$1Q || (_templateObject$1Q = _taggedTemplateLiteralLoose(["\n    * {\n        margin: 0;\n        padding: 0;\n\n        box-sizing: border-box;\n\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        text-rendering: optimizeLegibility;\n\n        -webkit-backface-visibility: hidden;\n    }\n\n    html,\n    body,\n    #root {\n        position: relative;\n        overflow: hidden;\n        min-width: 320px;\n        background: ", ";\n\n\n        ", "\n    }\n\n    html,\n    body {\n        overflow: hidden;\n    }\n\n    #root {\n        overflow-y: auto;\n    }\n\n    body {\n        margin: 0;\n        font-family: 'IBM Plex Sans', sans-serif;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        background-color: #fff;\n        color: ", ";\n    }\n\n    a {\n        text-decoration: none;\n        color: inherit;\n    }\n"])), $white$1, function () {
  return isSafari$1 && isIos$1 ? css(_templateObject2$1g || (_templateObject2$1g = _taggedTemplateLiteralLoose(["\n                      height: 100vh;\n                      min-height: -webkit-fill-available;\n                  "]))) : css(_templateObject3$P || (_templateObject3$P = _taggedTemplateLiteralLoose(["\n                      height: 100%;\n                  "])));
}, $primaryText$1);

var CheckoutShoppingCart = function CheckoutShoppingCart(_ref) {
  var callbacks = _ref.callbacks,
    _ref$metadata = _ref.metadata,
    metadata = _ref$metadata === void 0 ? [] : _ref$metadata,
    _ref$redirects = _ref.redirects,
    redirects = _ref$redirects === void 0 ? {} : _ref$redirects,
    _ref$customizations = _ref.customizations,
    customizations = _ref$customizations === void 0 ? {} : _ref$customizations,
    _ref$isLoggedIn = _ref.isLoggedIn,
    isLoggedIn = _ref$isLoggedIn === void 0 ? false : _ref$isLoggedIn,
    bottomExtraContent = _ref.bottomExtraContent,
    buttonBadge = _ref.buttonBadge;
  var store = useMemo(function () {
    return RootStore$2.create({
      view: {
        customizations: customizations
      }
    }, {
      callbacks: callbacks,
      metadata: metadata,
      redirects: redirects,
      isLoggedIn: isLoggedIn
    });
  }, []);
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React__default.createElement(GlobalStyle, null), /*#__PURE__*/React__default.createElement(App, {
    bottomExtraContent: bottomExtraContent,
    buttonBadge: buttonBadge
  }));
};
var CheckoutShoppingCartHTTPWrapper = function CheckoutShoppingCartHTTPWrapper(_ref2) {
  var children = _ref2.children,
    links = _ref2.links,
    onCheckoutButtonClick = _ref2.onCheckoutButtonClick,
    onCashbackChange = _ref2.onCashbackChange,
    onBackButtonClick = _ref2.onBackButtonClick,
    _ref2$onRewardIconCli = _ref2.onRewardIconClick,
    onRewardIconClick = _ref2$onRewardIconCli === void 0 ? function () {
      return null;
    } : _ref2$onRewardIconCli,
    _ref2$onPointsIconCli = _ref2.onPointsIconClick,
    onPointsIconClick = _ref2$onPointsIconCli === void 0 ? function () {
      return null;
    } : _ref2$onPointsIconCli,
    _ref2$onRewardChanged = _ref2.onRewardChanged,
    onRewardChanged = _ref2$onRewardChanged === void 0 ? function () {
      return null;
    } : _ref2$onRewardChanged,
    onCartCouponRemove = _ref2.onCartCouponRemove;
  var cartFetch = links.cartFetch,
    cartItemsManage = links.cartItemsManage,
    buyNow = links.buyNow,
    pointsFetch = links.pointsFetch,
    pointsApply = links.pointsApply,
    pointsRemove = links.pointsRemove,
    cartToCheckout = links.cartToCheckout;
  var createAxiosWithTokenInterceptor = function createAxiosWithTokenInterceptor() {
    var instance = axios.create({
      withCredentials: true
    });
    instance.interceptors.request.use(function (config) {
      var cartToken = LocalStorage.get('x-klickly-cart-token');
      if (cartToken) {
        config.headers['x-klickly-cart-token'] = cartToken;
      }
      return config;
    });
    return instance;
  };
  var axiosInstance = useMemo(function () {
    return createAxiosWithTokenInterceptor();
  }, []);
  var onCartFetch = function onCartFetch() {
    try {
      return Promise.resolve(axiosInstance.get("" + cartFetch)).then(function (_ref3) {
        var data = _ref3.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onGetCheckoutKey = function onGetCheckoutKey(cartId, body) {
    try {
      return Promise.resolve(axiosInstance.post("" + cartToCheckout, body)).then(function (_ref4) {
        var data = _ref4.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onCartSubmit = function onCartSubmit(cartId, key) {
    if (typeof onCheckoutButtonClick === 'function') {
      return onCheckoutButtonClick({
        cartId: cartId,
        checkoutKey: key,
        isBuyNow: false
      });
    }
    return true;
  };
  var onCartCashbackChange = function onCartCashbackChange(cashback) {
    if (typeof onCashbackChange === 'function') {
      onCashbackChange(cashback);
    }
    return true;
  };
  var onCartItemQtyChange = function onCartItemQtyChange(payload) {
    try {
      return Promise.resolve(axiosInstance.post(cartItemsManage, {
        action: 'qtyChange',
        data: payload
      })).then(function (_ref5) {
        var data = _ref5.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onCartItemRemove = function onCartItemRemove(payload) {
    try {
      return Promise.resolve(axiosInstance.post(cartItemsManage, {
        action: 'itemDelete',
        data: payload
      })).then(function (_ref6) {
        var data = _ref6.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onCartItemUndoRemove = function onCartItemUndoRemove(payload) {
    try {
      return Promise.resolve(axiosInstance.post(cartItemsManage, {
        action: 'itemUndoDelete',
        data: payload
      })).then(function (_ref7) {
        var data = _ref7.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onBuyNow = function onBuyNow(payload) {
    try {
      return Promise.resolve(axiosInstance.post(buyNow, payload)).then(function (_ref8) {
        var data = _ref8.data;
        if (typeof onCheckoutButtonClick === 'function') {
          return onCheckoutButtonClick({
            cartId: data.cartId,
            checkoutKey: data.checkoutKey,
            isBuyNow: true
          });
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onPointsFetch = function onPointsFetch() {
    try {
      return Promise.resolve(axiosInstance.get(pointsFetch)).then(function (_ref9) {
        var data = _ref9.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onPointsApply = function onPointsApply(points) {
    try {
      return Promise.resolve(axiosInstance.post(pointsApply, {
        points: points
      })).then(function (_ref0) {
        var data = _ref0.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onPointsRemove = function onPointsRemove() {
    try {
      return Promise.resolve(axiosInstance.post(pointsRemove, {})).then(function (_ref1) {
        var data = _ref1.data;
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return React__default.Children.map(children, function (child) {
    if (/*#__PURE__*/React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        callbacks: {
          onCartFetch: onCartFetch,
          onCartItemQtyChange: onCartItemQtyChange,
          onCartItemRemove: onCartItemRemove,
          onCartItemUndoRemove: onCartItemUndoRemove,
          onCartSubmit: onCartSubmit,
          onGetCheckoutKey: onGetCheckoutKey,
          onCartCashbackChange: onCartCashbackChange,
          onBackButtonClick: onBackButtonClick,
          onBuyNow: onBuyNow,
          onPointsFetch: onPointsFetch,
          onPointsApply: onPointsApply,
          onPointsRemove: onPointsRemove,
          onRewardIconClick: onRewardIconClick,
          onPointsIconClick: onPointsIconClick,
          onRewardChanged: onRewardChanged,
          onCartCouponRemove: onCartCouponRemove
        }
      });
    }
    return child;
  });
};

var PSEUDO_ROOT_CATEGORIES_KEYS = {
  MAKEUP: 'Health & Beauty > Personal Care > Cosmetics > Makeup',
  SKIN_CARE: 'Health & Beauty > Personal Care > Cosmetics > Skin Care',
  HAIR_CARE: 'Health & Beauty > Personal Care > Hair Care',
  BATH_BODY: 'Health & Beauty > Personal Care > Cosmetics > Bath & Body',
  CLOTHING: 'Apparel & Accessories > Clothing',
  JEWELRY: 'Apparel & Accessories > Jewelry',
  FITNESS_NUTRITION: 'Health & Beauty > Health Care > Fitness & Nutrition'
};
var TAXONOMY_ROOT_CATEGORIES = [{
  title: 'Makeup',
  key: PSEUDO_ROOT_CATEGORIES_KEYS.MAKEUP,
  order: 1,
  icon: SvgLipsIcon
}, {
  title: 'Skin Care',
  key: PSEUDO_ROOT_CATEGORIES_KEYS.SKIN_CARE,
  order: 4,
  icon: SvgFeather
}, {
  title: 'Hair Care',
  key: PSEUDO_ROOT_CATEGORIES_KEYS.HAIR_CARE,
  order: 7,
  icon: SvgHairDryer
}, {
  title: 'Bath & Body',
  key: PSEUDO_ROOT_CATEGORIES_KEYS.BATH_BODY,
  order: 10,
  icon: SvgBathroomShowerTub
}, {
  title: 'Clothing',
  key: PSEUDO_ROOT_CATEGORIES_KEYS.CLOTHING,
  order: 13,
  icon: SvgHangers
}, {
  title: 'Jewelry',
  key: PSEUDO_ROOT_CATEGORIES_KEYS.JEWELRY,
  order: 16,
  icon: SvgDiamond
}, {
  title: 'Fitness & Nutrition',
  key: PSEUDO_ROOT_CATEGORIES_KEYS.FITNESS_NUTRITION,
  order: 2,
  icon: SvgBottleIcon
}, {
  title: 'Home & Garden',
  key: 'Home & Garden',
  order: 5,
  icon: SvgHome
}, {
  title: 'Arts & Entertainment',
  key: 'Arts & Entertainment',
  order: 8,
  icon: SvgImage
}, {
  title: 'Food & Beverages',
  key: 'Food, Beverages & Tobacco',
  order: 11,
  icon: SvgComponent5
}, {
  title: 'Toys & Games',
  key: 'Toys & Games',
  order: 14,
  icon: SvgGamesIconRed
}, {
  title: 'Sporting Goods',
  key: 'Sporting Goods',
  order: 17,
  icon: SvgGymWeight
}, {
  title: 'Media',
  key: 'Media',
  order: 3,
  icon: SvgVideo
}, {
  title: 'Electronics',
  key: 'Electronics',
  order: 6,
  icon: SvgDevicePhone
}, {
  title: 'Animals & Pet Supplies',
  key: 'Animals & Pet Supplies',
  order: 9,
  icon: SvgPetDog
}, {
  title: 'Baby & Toddler',
  key: 'Baby & Toddler',
  order: 12,
  icon: SvgBike
}];

var getCategoriesArrayFromString = function getCategoriesArrayFromString(categoriesString) {
  var pseudoRootCategory = Object.values(PSEUDO_ROOT_CATEGORIES_KEYS).find(function (key) {
    return categoriesString.startsWith(key);
  });
  return pseudoRootCategory ? [pseudoRootCategory].concat(categoriesString.split("" + pseudoRootCategory).join('').split(' > ')).filter(function (t) {
    return t;
  }) : categoriesString.split(' > ');
};

var _getTaxonomyByPath = function getTaxonomyByPath(categories, path) {
  if (!categories) return null;
  for (var _iterator = _createForOfIteratorHelperLoose(categories), _step; !(_step = _iterator()).done;) {
    var category = _step.value;
    if (category.path === path) {
      return category;
    }
    var foundInChildren = _getTaxonomyByPath(category.children, path);
    if (foundInChildren) return foundInChildren;
  }
  return null;
};

var _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
var _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";
function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}

var axiosInstance$1 = axios.create({
  withCredentials: true
});

var INITIAL_STORE$1 = {
  get: function (url, params) {
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(axiosInstance$1.get(url, params && {
          params: params
        })).then(function (_ref) {
          var data = _ref.data;
          return data;
        });
      }, function (error) {
        throw error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  post: function (url, body) {
    if (body === void 0) {
      body = {};
    }
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(axiosInstance$1.post(url, body)).then(function (_ref2) {
          var data = _ref2.data;
          return data;
        });
      }, function (error) {
        throw error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  patch: function (url, body) {
    if (body === void 0) {
      body = {};
    }
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(axiosInstance$1.patch(url, body)).then(function (_ref3) {
          var data = _ref3.data;
          return data;
        });
      }, function (error) {
        throw error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  put: function (url, body) {
    if (body === void 0) {
      body = {};
    }
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(axiosInstance$1.put(url, body)).then(function (_ref4) {
          var data = _ref4.data;
          return data;
        });
      }, function (error) {
        throw error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  "delete": function (url, params) {
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(axiosInstance$1["delete"](url, params && {
          params: params
        })).then(function (_ref5) {
          var data = _ref5.data;
          return data;
        });
      }, function (error) {
        throw error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }
};

var TaxonomyBestSellersModel = types.model('TaxonomyBestSellersModel', {
  id: types.string,
  externalId: types.maybeNull(types.string),
  accountId: types.maybeNull(types.string),
  campaignId: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  brandName: types.maybeNull(types.string),
  shopDomain: types.maybeNull(types.string),
  category: types.maybeNull(types.string),
  images: types.array(types.frozen()),
  options: types.array(types.frozen()),
  variants: types.array(types.frozen()),
  creativeSettings: types.frozen(),
  brandLink: types.maybeNull(types.string)
});

var TaxonomyCategoriesModel = types.model('TaxonomyCategoriesModel', {
  title: types.maybeNull(types.string),
  count: types.number,
  path: types.maybeNull(types.string),
  checked: false,
  children: types.array(types.late(function () {
    return TaxonomyCategoriesModel;
  }))
});

var models$1 = {
  TaxonomyCategoriesModel: TaxonomyCategoriesModel,
  TaxonomyBestSellersModel: TaxonomyBestSellersModel
};

var RootStore$3 = types.model('TaxonomyStore', {
  kcpAPI: types.maybeNull(types.frozen()),
  pending: false,
  brandId: types.maybeNull(types.string),
  strategy: types.maybeNull(types.model({
    strategyName: types.maybeNull(types.string),
    strategyId: types.maybeNull(types.string)
  })),
  error: types.maybeNull(types.string),
  categories: types.array(types.model({
    order: types.number,
    title: types.string,
    key: types.string,
    count: types.maybeNull(types.number),
    children: types.array(models$1.TaxonomyCategoriesModel),
    bestSellers: types.array(models$1.TaxonomyBestSellersModel)
  })),
  selectedCategories: types.array(types.string)
}).views(function (self) {
  return {
    get root() {
      return getParent(self);
    },
    get get() {
      return getEnv(self).get;
    },
    get post() {
      return getEnv(self).post;
    },
    get patch() {
      return getEnv(self).patch;
    },
    get put() {
      return getEnv(self).put;
    },
    get delete() {
      return getEnv(self)["delete"];
    },
    get selectedTaxonomyData() {
      var selectedTaxonomyKey = self.selectedCategories[0];
      if (!selectedTaxonomyKey) return null;
      return self.getRootCategoryByKey(selectedTaxonomyKey);
    },
    getRootCategoryByKey: function getRootCategoryByKey(key) {
      return self.categories.find(function (category) {
        return category.key === key;
      });
    },
    getCategoryChildTitles: function getCategoryChildTitles(category) {
      return category.children.reduce(function (result, child) {
        return [].concat(result, [child.title], self.getCategoryChildTitles(child));
      }, []);
    },
    getParentCategoryByChildTitle: function getParentCategoryByChildTitle(title, categories) {
      if (categories === void 0) {
        categories = self.categories;
      }
      return categories.reduce(function (result, category) {
        if (category.children.some(function (child) {
          return child.title === title;
        })) {
          return category;
        }
        return result || self.getParentCategoryByChildTitle(title, category.children);
      }, null);
    },
    getSelectedCategories: function getSelectedCategories(path, checked, categories) {
      if (categories === void 0) {
        categories = self.categories;
      }
      var categoriesTitles = getCategoriesArrayFromString(path);
      return categories.map(function (category) {
        if (category.title === categoriesTitles[0] || category.key === categoriesTitles[0]) {
          return _extends({}, category, {
            checked: checked,
            children: self.getSelectedCategories(categoriesTitles.slice(1).join(' > '), checked, category.children)
          });
        } else {
          return category;
        }
      });
    }
  };
}).actions(function (self) {
  return {
    setKcpAPI: function setKcpAPI(kcpAPI) {
      self.kcpAPI = kcpAPI;
    },
    setBrandId: function setBrandId(brandId) {
      self.brandId = brandId;
    },
    setStrategy: function setStrategy(strategy) {
      self.strategy = strategy;
    },
    getTaxonomyCategoryDetails: flow(/*#__PURE__*/_regenerator().m(function getTaxonomyCategoryInfo(title) {
      var _self$getRootCategory, _self$getRootCategory2, _self$strategy, _self$strategy2;
      var hasData, headers, params, data, _error$response, _error$response$data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            hasData = (_self$getRootCategory = self.getRootCategoryByKey(title)) === null || _self$getRootCategory === void 0 ? void 0 : (_self$getRootCategory2 = _self$getRootCategory.children) === null || _self$getRootCategory2 === void 0 ? void 0 : _self$getRootCategory2.length;
            if (!hasData) {
              _context.n = 1;
              break;
            }
            return _context.a(2, false);
          case 1:
            headers = getCartTokenHeaders();
            self.error = null;
            params = {
              title: title
            };
            if ((_self$strategy = self.strategy) !== null && _self$strategy !== void 0 && _self$strategy.strategyName) params.strategyName = self.strategy.strategyName;
            if ((_self$strategy2 = self.strategy) !== null && _self$strategy2 !== void 0 && _self$strategy2.strategyId) params.strategyId = self.strategy.strategyId;
            _context.p = 2;
            _context.n = 3;
            return self.get(self.kcpAPI.marketplace.taxonomy.getDetails, params, headers);
          case 3:
            data = _context.v;
            if (data && (data.children || data.bestSellers)) {
              self.categories = self.categories.map(function (category) {
                if (category.key === title) {
                  return _extends({}, category, {
                    children: data.children || [],
                    bestSellers: data.bestSellers || []
                  });
                }
                return category;
              });
            }
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            self.error = _t === null || _t === void 0 ? void 0 : (_error$response = _t.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message;
          case 5:
            _context.p = 5;
            self.pending = false;
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, getTaxonomyCategoryInfo, null, [[2, 4, 5, 6]]);
    })),
    getTaxonomyBrandCategoryDetails: flow(/*#__PURE__*/_regenerator().m(function getTaxonomyBrandCategoryDetails(title) {
      var _self$getRootCategory3, _self$getRootCategory4;
      var hasData, _data$googleTaxonomy, data, _error$response2, _error$response2$data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            hasData = (_self$getRootCategory3 = self.getRootCategoryByKey(title)) === null || _self$getRootCategory3 === void 0 ? void 0 : (_self$getRootCategory4 = _self$getRootCategory3.children) === null || _self$getRootCategory4 === void 0 ? void 0 : _self$getRootCategory4.length;
            if (!hasData) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, false);
          case 1:
            self.error = null;
            _context2.p = 2;
            _context2.n = 3;
            return self.get(self.kcpAPI.marketplace.brands.getBrandData(self.brandId), {
              title: title
            });
          case 3:
            data = _context2.v;
            if (data && ((_data$googleTaxonomy = data.googleTaxonomy) !== null && _data$googleTaxonomy !== void 0 && _data$googleTaxonomy.children || data.bestSellers)) {
              self.categories = self.categories.map(function (category) {
                if (category.key === title) {
                  var _data$googleTaxonomy2;
                  return _extends({}, category, {
                    children: ((_data$googleTaxonomy2 = data.googleTaxonomy) === null || _data$googleTaxonomy2 === void 0 ? void 0 : _data$googleTaxonomy2.children) || [],
                    bestSellers: data.bestSellers || []
                  });
                }
                return category;
              });
            }
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            self.error = _t2 === null || _t2 === void 0 ? void 0 : (_error$response2 = _t2.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message;
          case 5:
            _context2.p = 5;
            self.pending = false;
            return _context2.f(5);
          case 6:
            return _context2.a(2);
        }
      }, getTaxonomyBrandCategoryDetails, null, [[2, 4, 5, 6]]);
    })),
    selectCategory: flow(function selectCategory(path, checked, onAfterCategorySelect, parentCategory, isInitialFetch) {
      if (onAfterCategorySelect === void 0) {
        onAfterCategorySelect = function onAfterCategorySelect() {
          return null;
        };
      }
      if (isInitialFetch === void 0) {
        isInitialFetch = false;
      }
      return /*#__PURE__*/_regenerator().m(function _callee() {
        var categoryNames, newPath;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(checked && isInitialFetch)) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return self.getTaxonomyCategoryDetails(parentCategory);
            case 1:
              if (!path) self.selectedCategories = [];
              categoryNames = getCategoriesArrayFromString(path);
              if (checked) {
                self.selectedCategories = categoryNames;
              } else {
                self.selectedCategories = categoryNames.length === 1 ? [] : self.selectedCategories.filter(function (category) {
                  return ![parentCategory.title].concat(self.getCategoryChildTitles(parentCategory)).includes(category);
                });
              }
              newPath = self.selectedCategories.join(' > ');
              if (!(checked && !isInitialFetch && !self.brandId)) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return self.getTaxonomyCategoryDetails(newPath);
            case 2:
              if (!(checked && !isInitialFetch && self.brandId)) {
                _context3.n = 3;
                break;
              }
              _context3.n = 3;
              return self.getTaxonomyBrandCategoryDetails(newPath);
            case 3:
              onAfterCategorySelect(newPath);
            case 4:
              return _context3.a(2);
          }
        }, _callee);
      })();
    }),
    setSelectedCategories: function setSelectedCategories(categories) {
      self.selectedCategories = categories;
    },
    getBrandsCategoriesList: function getBrandsCategoriesList(brandData) {
      self.categories = TAXONOMY_ROOT_CATEGORIES.map(function (item) {
        var taxonomy = _getTaxonomyByPath(brandData.googleTaxonomy, item.key);
        if (taxonomy) {
          return _extends({}, item, {
            count: taxonomy.count
          });
        }
        return _extends({}, item);
      }).filter(function (tax) {
        return tax.count;
      });
      self.pending = false;
    },
    getCategoriesList: flow(/*#__PURE__*/_regenerator().m(function getCategoriesList() {
      var _self$strategy3, _self$strategy4;
      var url, params, data;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            url = self.kcpAPI.marketplace.taxonomy.list;
            params = {};
            if (self.publisherId) params.publisher = self.publisherId;
            if ((_self$strategy3 = self.strategy) !== null && _self$strategy3 !== void 0 && _self$strategy3.strategyName) params.strategyName = self.strategy.strategyName;
            if ((_self$strategy4 = self.strategy) !== null && _self$strategy4 !== void 0 && _self$strategy4.strategyId) params.strategyId = self.strategy.strategyId;
            _context4.n = 1;
            return self.get("" + url + (Object.keys(params).length > 0 ? "?" + qs.stringify(params) : ''));
          case 1:
            data = _context4.v;
            self.categories = TAXONOMY_ROOT_CATEGORIES.map(function (item) {
              var taxonomy = _getTaxonomyByPath(data, item.key);
              if (taxonomy) {
                return _extends({}, item, {
                  count: taxonomy.count
                });
              }
              return _extends({}, item);
            }).filter(function (tax) {
              return tax.count;
            });
            self.pending = false;
          case 2:
            return _context4.a(2);
        }
      }, getCategoriesList);
    })),
    afterCreate: function afterCreate() {
      self.pending = true;
      self.taxonomyLoader = true;
      var searchParams = getFilterParamsFromUrl();
      if (searchParams.gt) {
        var newCategories = getCategoriesArrayFromString(searchParams.gt);
        self.selectedCategories = newCategories;
        self.hasActiveSubCategories = (newCategories === null || newCategories === void 0 ? void 0 : newCategories.length) > 1;
      }
    }
  };
});
var store$1 = RootStore$3.create({}, INITIAL_STORE$1);

var _templateObject$1R, _templateObject2$1h;
var StyledBestSellersWrapper = styled.div(_templateObject$1R || (_templateObject$1R = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n\n    > * {\n        &:first-child {\n            width: 315px;\n            @media (", ") {\n                width: 240px;\n            }\n        }\n        &:last-child {\n            flex-grow: 1;\n            padding-left: 20px;\n            max-width: calc(100% - 315px);\n            @media (", ") {\n                max-width: calc(100% - 240px);\n            }\n        }\n    }\n"])), GRID_DEVICES_MAX.lg, GRID_DEVICES_MAX.lg);
var StyledBestSellerTitleWrapper = styled.div(_templateObject2$1h || (_templateObject2$1h = _taggedTemplateLiteralLoose(["\n    height: 100%;\n"])));

var BestSellers = inject('store')(observer(function (_ref) {
  var _selectedTaxonomyData, _selectedTaxonomyData2, _selectedTaxonomyData3;
  var store = _ref.store,
    onBuy = _ref.onBuy;
  var selectedTaxonomyData = store.selectedTaxonomyData;
  var theme = useContext(KliThemeContext);
  var simple = useSimpleInterface(GRID_POINTS.xl);
  var bestsellersCount = simple ? 2 : 3;
  return (selectedTaxonomyData === null || selectedTaxonomyData === void 0 ? void 0 : (_selectedTaxonomyData = selectedTaxonomyData.bestSellers) === null || _selectedTaxonomyData === void 0 ? void 0 : _selectedTaxonomyData.length) > 0 ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledBestSellersWrapper, null, /*#__PURE__*/React__default.createElement(StyledBestSellerTitleWrapper, null, /*#__PURE__*/React__default.createElement(Typography.Title, {
    align: simple ? 'center' : 'left',
    level: simple ? 2 : 1,
    color: theme.colors.secondaryText,
    style: simple && BOTTOM_INDENTS.XXS
  }, "Bestsellers")), /*#__PURE__*/React__default.createElement(Row, {
    gutter: 10,
    wrap: false
  }, selectedTaxonomyData === null || selectedTaxonomyData === void 0 ? void 0 : (_selectedTaxonomyData2 = selectedTaxonomyData.bestSellers) === null || _selectedTaxonomyData2 === void 0 ? void 0 : (_selectedTaxonomyData3 = _selectedTaxonomyData2.slice(0, bestsellersCount)) === null || _selectedTaxonomyData3 === void 0 ? void 0 : _selectedTaxonomyData3.map(function (product) {
    return /*#__PURE__*/React__default.createElement(Col, {
      key: product.id,
      span: simple ? 12 : 8,
      style: simple && BOTTOM_INDENTS.L
    }, /*#__PURE__*/React__default.createElement(Promotion, {
      onBuy: onBuy,
      withoutButton: true,
      showPoints: false,
      promotion: product
    }));
  }))), /*#__PURE__*/React__default.createElement(Divider, {
    height: "1px",
    color: theme.colors.lines
  })) : null;
}));

var _templateObject$1S, _templateObject2$1i, _templateObject3$Q, _templateObject4$A, _templateObject5$l;
var StyledContent$3 = styled.div(_templateObject$1S || (_templateObject$1S = _taggedTemplateLiteralLoose(["\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 0 20px;\n"])));
var StyledImageWrapper = styled.div(_templateObject2$1i || (_templateObject2$1i = _taggedTemplateLiteralLoose(["\n    position: relative;\n    width: 100%;\n    height: 273px;\n    margin-bottom: 16px;\n"])));
var StyledImage$3 = styled.img(_templateObject3$Q || (_templateObject3$Q = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n"])));
var StyledBestSellersWrapper$1 = styled.div(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n\n    > * {\n        &:first-child {\n            width: 315px;\n        }\n        &:last-child {\n            flex-grow: 1;\n            padding-left: 20px;\n        }\n    }\n"])));
var StyledBestSellerTitleWrapper$1 = styled.div(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteralLoose(["\n    height: 100%;\n"])));

var CategoryPageHeader = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    onBuy = _ref.onBuy;
  var selectedTaxonomyData = store.selectedTaxonomyData,
    pending = store.pending;
  var theme = useContext(KliThemeContext);
  var simple = useSimpleInterface(GRID_POINTS.md);
  var ref = useRef(null);
  useScrollable(ref, null, function () {
    return null;
  });
  if (!pending && !selectedTaxonomyData) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    style: BOTTOM_INDENTS.M,
    id: "shop-promotions-container"
  }, pending ? /*#__PURE__*/React__default.createElement(Icon.Loader, null) : /*#__PURE__*/React__default.createElement(Fragment, null, selectedTaxonomyData !== null && selectedTaxonomyData !== void 0 && selectedTaxonomyData.imgSrc ? /*#__PURE__*/React__default.createElement(StyledImageWrapper, null, /*#__PURE__*/React__default.createElement(StyledImage$3, {
    src: selectedTaxonomyData === null || selectedTaxonomyData === void 0 ? void 0 : selectedTaxonomyData.imgSrc,
    alt: selectedTaxonomyData === null || selectedTaxonomyData === void 0 ? void 0 : selectedTaxonomyData.title
  })) : /*#__PURE__*/React__default.createElement("div", {
    style: BOTTOM_INDENTS.S
  }), /*#__PURE__*/React__default.createElement(StyledContent$3, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: simple ? 'headline1' : 'em0',
    align: simple ? 'center' : 'left'
  }, selectedTaxonomyData === null || selectedTaxonomyData === void 0 ? void 0 : selectedTaxonomyData.title), /*#__PURE__*/React__default.createElement(Divider, {
    height: "1px",
    color: theme.colors.lines
  }), /*#__PURE__*/React__default.createElement(BestSellers, {
    onBuy: onBuy
  }))));
}));

var PageHeader = function PageHeader(_ref) {
  var onBuy = _ref.onBuy;
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: store$1
  }, /*#__PURE__*/React__default.createElement(CategoryPageHeader, {
    onBuy: onBuy
  }));
};

var _templateObject$1T, _templateObject2$1j, _templateObject3$R, _templateObject4$B, _templateObject5$m;
var StyledButton$d = styled(Button)(_templateObject$1T || (_templateObject$1T = _taggedTemplateLiteralLoose(["\n    && {\n        height: 24px;\n        width: 24px;\n        padding: 0;\n        margin-left: 12px;\n        border: 0;\n\n        &:disabled {\n            opacity: 0;\n            pointer-events: none;\n        }\n\n        &:focus,\n        &:active,\n        &:hover,\n        &:disabled {\n            border: 0;\n        }\n\n        .anticon {\n            width: 20px;\n            height: 20px;\n\n            > svg {\n                font-size: 20px;\n                color: ", ";\n            }\n        }\n    }\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return $theme.colors.disabledState;
});
var StyledCol = styled(Col)(_templateObject2$1j || (_templateObject2$1j = _taggedTemplateLiteralLoose(["\n    display: none;\n"])));
var StyledWrapper$h = styled(Row)(_templateObject3$R || (_templateObject3$R = _taggedTemplateLiteralLoose(["\n    .ant-col {\n        width: 100%;\n    }\n"])));
var StyledNum = styled.div(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteralLoose(["\n    padding: 6px 12px;\n    border-radius: 40px;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    color: ", ";\n    background: ", ";\n"])), function (_ref2) {
  var $checked = _ref2.$checked,
    $theme = _ref2.$theme;
  return $checked ? $theme.colors.tartRed : $theme.colors.secondaryText;
}, function (_ref3) {
  var $checked = _ref3.$checked,
    $theme = _ref3.$theme;
  return $checked ? $theme.colors.primary : $theme.colors.background;
});
var StyledRow = styled(Row)(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteralLoose(["\n    && {\n        padding-top: 8px;\n        padding-bottom: 8px;\n\n        * {\n            cursor: pointer;\n        }\n\n        label {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            justify-content: space-between;\n\n            @media (", ") {\n                height: 32px;\n            }\n        }\n\n        &:hover {\n            .ant-checkbox-checked {\n                &:after {\n                    border-color: ", "!important;\n                }\n                .ant-checkbox-inner {\n                    background-color: ", "!important;\n                }\n            }\n            .ant-checkbox-wrapper .ant-checkbox {\n                .ant-checkbox-input,\n                .ant-checkbox-inner {\n                    border-color: ", ";\n                }\n            }\n        }\n    }\n"])), GRID_DEVICES_MAX.md, function (_ref4) {
  var $theme = _ref4.$theme;
  return $theme.colors.primary;
}, function (_ref5) {
  var $theme = _ref5.$theme;
  return $theme.colors.primary;
}, function (_ref6) {
  var $theme = _ref6.$theme;
  return $theme.colors.primary;
});

var CategoryItem = function CategoryItem(_ref) {
  var count = _ref.count,
    value = _ref.value,
    title = _ref.title,
    checked = _ref.checked,
    _onChange = _ref.onChange,
    onClick = _ref.onClick,
    buttonVisible = _ref.buttonVisible,
    ItemIcon = _ref.icon;
  var simple = useSimpleInterface(GRID_POINTS.md);
  var theme = useContext(KliThemeContext);
  var checkbox = /*#__PURE__*/React__default.createElement(Checkbox, {
    checked: checked,
    type: "rounded",
    checkedColor: "primary",
    size: "20px",
    id: value,
    value: value,
    onChange: function onChange(_ref2) {
      var isChecked = _ref2.target.checked;
      return _onChange(value, isChecked);
    }
  });
  return /*#__PURE__*/React__default.createElement(StyledWrapper$h, {
    align: "middle",
    justify: "space-between",
    wrap: false
  }, ItemIcon ? /*#__PURE__*/React__default.createElement(Col, {
    span: 3
  }, /*#__PURE__*/React__default.createElement(Icon, {
    color: theme.colors.primary,
    size: "24px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(ItemIcon, null);
    }
  })) : null, /*#__PURE__*/React__default.createElement(Col, {
    flex: simple && 'auto'
  }, /*#__PURE__*/React__default.createElement(StyledRow, {
    $theme: theme,
    align: "middle",
    gutter: 12,
    wrap: false
  }, /*#__PURE__*/React__default.createElement(StyledCol, null, checkbox), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: value
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    "data-e2e": "marketplace_category-" + formatString(title) + "_title"
  }, title), /*#__PURE__*/React__default.createElement(StyledNum, {
    $checked: checked,
    $theme: theme,
    "data-e2e": "marketplace_category-" + formatString(title) + "-count_value"
  }, count))))), /*#__PURE__*/React__default.createElement(StyledButton$d, {
    disabled: !buttonVisible,
    $theme: theme,
    onClick: onClick,
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      component: function component() {
        return /*#__PURE__*/React__default.createElement(SvgArrowChevronForward, null);
      }
    }),
    type: "unstyled"
  }));
};

var _templateObject$1U;
var StyledButton$e = styled(Button)(_templateObject$1U || (_templateObject$1U = _taggedTemplateLiteralLoose(["\n    && {\n        height: 48px;\n        padding: 14px 20px 14px 0;\n\n        .anticon {\n            width: 20px;\n            height: 20px;\n\n            > svg {\n                font-size: 20px;\n                color: ", ";\n            }\n        }\n    }\n"])), function (_ref) {
  var $theme = _ref.$theme;
  return $theme.colors.disabledState;
});

var Title$2 = function Title(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Categories' : _ref$title,
    _ref$isRoot = _ref.isRoot,
    isRoot = _ref$isRoot === void 0 ? false : _ref$isRoot,
    onBackButtonClick = _ref.onBackButtonClick;
  var theme = useContext(KliThemeContext);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    align: "middle"
  }, !isRoot ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(StyledButton$e, {
    $theme: theme,
    onClick: onBackButtonClick,
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      component: function component() {
        return /*#__PURE__*/React__default.createElement(SvgArrowChevronBack, null);
      }
    }),
    type: "unstyled"
  })) : null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "marketplace_categories_title",
    type: "badgeMedium"
  }, title))), /*#__PURE__*/React__default.createElement(Divider, {
    height: "1px",
    color: theme.colors.lines
  }));
};

var _templateObject$1V, _templateObject2$1k, _templateObject3$S;
var StyledWrapper$i = styled.div(_templateObject$1V || (_templateObject$1V = _taggedTemplateLiteralLoose(["\n    position: relative;\n    ", "\n\n    min-height: ", "\n"])), function (_ref) {
  var $inMobileMenu = _ref.$inMobileMenu;
  return $inMobileMenu && css(_templateObject2$1k || (_templateObject2$1k = _taggedTemplateLiteralLoose(["\n            .ant-checkbox-wrapper {\n                display: none;\n            }\n\n            label {\n                display: flex;\n                align-items: center;\n                height: 64px;\n            }\n        "])));
}, function (_ref2) {
  var $pending = _ref2.$pending;
  return $pending ? '200px' : 'initial';
});
var StyledLoader$1 = styled.div(_templateObject3$S || (_templateObject3$S = _taggedTemplateLiteralLoose(["\n    min-height: 150px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background-color: transparent;\n"])));

var TaxonomyTree = inject('store')(observer(function (_ref) {
  var _selectedSubCategory$;
  var store = _ref.store,
    taxonomyType = _ref.taxonomyType,
    brandId = _ref.brandId,
    strategy = _ref.strategy,
    brandData = _ref.brandData,
    selectedSubCategory = _ref.selectedSubCategory,
    setSelectedSubCategory = _ref.setSelectedSubCategory,
    onAfterCategorySelect = _ref.onAfterCategorySelect,
    _ref$inMobileMenu = _ref.inMobileMenu,
    inMobileMenu = _ref$inMobileMenu === void 0 ? false : _ref$inMobileMenu,
    _ref$selectCategoryOn = _ref.selectCategoryOnArrowClick,
    selectCategoryOnArrowClick = _ref$selectCategoryOn === void 0 ? false : _ref$selectCategoryOn;
  var getTaxonomyCategoryDetails = store.getTaxonomyCategoryDetails,
    getRootCategoryByKey = store.getRootCategoryByKey,
    getParentCategoryByChildTitle = store.getParentCategoryByChildTitle,
    selectCategory = store.selectCategory,
    selectedCategories = store.selectedCategories,
    setSelectedCategories = store.setSelectedCategories,
    getBrandsCategoriesList = store.getBrandsCategoriesList,
    getTaxonomyBrandCategoryDetails = store.getTaxonomyBrandCategoryDetails,
    getCategoriesList = store.getCategoriesList,
    setBrandId = store.setBrandId,
    setStrategy = store.setStrategy,
    pending = store.pending;
  var searchParams = getFilterParamsFromUrl();
  useEffect(function () {
    (function () {
      try {
        var _temp3 = function _temp3() {
          var _temp = function () {
            if (taxonomyType === 'marketplace') {
              setStrategy(strategy);
              return Promise.resolve(getCategoriesList()).then(function () {});
            }
          }();
          if (_temp && _temp.then) return _temp.then(function () {});
        };
        var _temp2 = function () {
          if (taxonomyType === 'brand' && brandData) {
            return Promise.resolve(setBrandId(brandId)).then(function () {
              return Promise.resolve(getBrandsCategoriesList(brandData)).then(function () {});
            });
          }
        }();
        return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
      } catch (e) {
        Promise.reject(e);
      }
    })();
  }, [brandData]);
  useEffect(function () {
    (function () {
      try {
        var _temp4 = function () {
          if (searchParams.gt && !pending) {
            var categories = getCategoriesArrayFromString(searchParams.gt);
            var category = categories === null || categories === void 0 ? void 0 : categories[0];
            return Promise.resolve(selectCategory(searchParams.gt, true, function () {
              return null;
            }, category, true)).then(function () {
              setSelectedSubCategory(getParentCategoryByChildTitle(categories === null || categories === void 0 ? void 0 : categories[(categories === null || categories === void 0 ? void 0 : categories.length) - 1]));
            });
          }
        }();
        return _temp4 && _temp4.then ? _temp4.then(function () {}) : void 0;
      } catch (e) {
        Promise.reject(e);
      }
    })();
  }, []);
  useEffect(function () {
    if (!searchParams.gt) {
      setSelectedSubCategory(null);
      setSelectedCategories([]);
    }
  }, [searchParams.gt]);
  return /*#__PURE__*/React__default.createElement(StyledWrapper$i, {
    $pending: pending,
    $inMobileMenu: inMobileMenu,
    "data-e2e": "marketplace_categories_block"
  }, pending && /*#__PURE__*/React__default.createElement(StyledLoader$1, null, /*#__PURE__*/React__default.createElement(Icon.Loader, null)), inMobileMenu ? null : /*#__PURE__*/React__default.createElement(Title$2, {
    title: selectedSubCategory === null || selectedSubCategory === void 0 ? void 0 : selectedSubCategory.title,
    isRoot: !(selectedSubCategory !== null && selectedSubCategory !== void 0 && (_selectedSubCategory$ = selectedSubCategory.children) !== null && _selectedSubCategory$ !== void 0 && _selectedSubCategory$.length),
    onBackButtonClick: function onBackButtonClick() {
      return setSelectedSubCategory(getParentCategoryByChildTitle(selectedSubCategory === null || selectedSubCategory === void 0 ? void 0 : selectedSubCategory.title));
    }
  }), !(selectedSubCategory !== null && selectedSubCategory !== void 0 && selectedSubCategory.children) ? store.categories.slice().sort(function (a, b) {
    return a.title.localeCompare(b.title);
  }).map(function (_ref2) {
    var key = _ref2.key,
      title = _ref2.title,
      icon = _ref2.icon,
      count = _ref2.count;
    return /*#__PURE__*/React__default.createElement(CategoryItem, {
      count: count,
      title: title,
      key: key,
      value: key,
      icon: inMobileMenu ? icon : null,
      checked: selectedCategories.includes(key),
      onChange: function onChange(value, isChecked) {
        return selectCategory(value, isChecked, onAfterCategorySelect);
      },
      onClick: function onClick() {
        try {
          var _temp6 = function _temp6() {
            var category = getRootCategoryByKey(key);
            if (selectCategoryOnArrowClick) {
              selectCategory(key, true, onAfterCategorySelect);
            }
            if (category.children.length) setSelectedSubCategory(category);
          };
          var _temp5 = function () {
            if (brandId) {
              return Promise.resolve(getTaxonomyBrandCategoryDetails(key)).then(function () {});
            } else {
              return Promise.resolve(getTaxonomyCategoryDetails(key)).then(function () {});
            }
          }();
          return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(_temp6) : _temp6(_temp5));
        } catch (e) {
          return Promise.reject(e);
        }
      },
      buttonVisible: true
    });
  }) : [].concat(isStateTreeNode(selectedSubCategory === null || selectedSubCategory === void 0 ? void 0 : selectedSubCategory.children) ? getSnapshot(selectedSubCategory === null || selectedSubCategory === void 0 ? void 0 : selectedSubCategory.children) : (selectedSubCategory === null || selectedSubCategory === void 0 ? void 0 : selectedSubCategory.children) || []).sort(function (a, b) {
    return a.title.localeCompare(b.title);
  }).map(function (category) {
    var _category$children;
    return /*#__PURE__*/React__default.createElement(CategoryItem, {
      count: category.count,
      title: category.title,
      key: category.title,
      value: category.title,
      checked: selectedCategories.includes(category.title),
      onChange: function onChange(value, isChecked) {
        return selectCategory(category.path, isChecked, onAfterCategorySelect, category);
      },
      onClick: function onClick() {
        if (selectCategoryOnArrowClick) {
          selectCategory(category.path, true, onAfterCategorySelect, category);
        }
        return setSelectedSubCategory(category);
      },
      buttonVisible: category === null || category === void 0 ? void 0 : (_category$children = category.children) === null || _category$children === void 0 ? void 0 : _category$children.length
    });
  }));
}));

var Taxonomy = function Taxonomy(_ref) {
  var _ref$taxonomyType = _ref.taxonomyType,
    taxonomyType = _ref$taxonomyType === void 0 ? '' : _ref$taxonomyType,
    _ref$strategy = _ref.strategy,
    strategy = _ref$strategy === void 0 ? {} : _ref$strategy,
    _ref$brandId = _ref.brandId,
    brandId = _ref$brandId === void 0 ? '' : _ref$brandId,
    _ref$brandData = _ref.brandData,
    brandData = _ref$brandData === void 0 ? null : _ref$brandData,
    selectedSubCategory = _ref.selectedSubCategory,
    setSelectedSubCategory = _ref.setSelectedSubCategory,
    onAfterCategorySelect = _ref.onAfterCategorySelect,
    _ref$inMobileMenu = _ref.inMobileMenu,
    inMobileMenu = _ref$inMobileMenu === void 0 ? false : _ref$inMobileMenu,
    _ref$selectCategoryOn = _ref.selectCategoryOnArrowClick,
    selectCategoryOnArrowClick = _ref$selectCategoryOn === void 0 ? false : _ref$selectCategoryOn;
  var isIos = device.iOS();
  var isSafari = device.isSafari();
  return /*#__PURE__*/React__default.createElement(StyleProvider, {
    hashPriority: isSafari && !isIos ? 'high' : 'low'
  }, /*#__PURE__*/React__default.createElement(Provider, {
    store: store$1
  }, /*#__PURE__*/React__default.createElement(TaxonomyTree, {
    brandId: brandId,
    strategy: strategy,
    taxonomyType: taxonomyType,
    brandData: brandData,
    onAfterCategorySelect: onAfterCategorySelect,
    setSelectedSubCategory: setSelectedSubCategory,
    selectedSubCategory: selectedSubCategory,
    inMobileMenu: inMobileMenu,
    selectCategoryOnArrowClick: selectCategoryOnArrowClick
  })));
};
Taxonomy.TAXONOMY_ROOT_CATEGORIES = TAXONOMY_ROOT_CATEGORIES;
Taxonomy.PSEUDO_ROOT_CATEGORIES_KEYS = PSEUDO_ROOT_CATEGORIES_KEYS;
Taxonomy.getCategoriesArrayFromString = getCategoriesArrayFromString;
Taxonomy.store = store$1;
Taxonomy.CategoryPageHeader = PageHeader;

var ErrorFieldStyles$2 = styled.div.withConfig({
  displayName: "styles__ErrorFieldStyles",
  componentId: "sc-h3l7zk-0"
})(["display:flex;align-items:center;"]);
var ErrorFieldIcon$2 = styled(Icon).withConfig({
  displayName: "styles__ErrorFieldIcon",
  componentId: "sc-h3l7zk-1"
})(["padding:0 16px 0 0;"]);

var ErrorField$2 = function ErrorField(_ref) {
  var error = _ref.error,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/React__default.createElement(SvgEmojiSadFrown, null) : _ref$icon,
    _ref$textType = _ref.textType,
    textType = _ref$textType === void 0 ? 'descriptor2' : _ref$textType;
  return /*#__PURE__*/React__default.createElement(ErrorFieldStyles$2, {
    style: BOTTOM_INDENTS.SM
  }, showIcon && /*#__PURE__*/React__default.createElement(ErrorFieldIcon$2, {
    color: "error",
    size: "130%",
    component: function component() {
      return icon;
    }
  }), /*#__PURE__*/React__default.createElement(Typography.Text, {
    color: "error",
    type: textType
  }, error));
};

var $white$2 = '#FFFFFF';
var $border$1 = '#D2D6DA';
var $background$1 = '#F4F4F4';
var $primary$2 = '#F25858';
var $primaryText$2 = '#04080F';
var $secondaryText$1 = '#77838F';
var $info = '#33B6DF';
var $primaryBackground = '#FFEEEE';

var _templateObject$1W, _templateObject2$1l, _templateObject3$T, _templateObject4$C;
var StyledInfoRow = styled.div(_templateObject$1W || (_templateObject$1W = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n\n    ", ";\n"])), function (_ref) {
  var $justify = _ref.$justify;
  return $justify && css(_templateObject2$1l || (_templateObject2$1l = _taggedTemplateLiteralLoose(["\n            justify-content: ", ";\n        "])), $justify);
});
var StyledInfoWrapper = styled.div(_templateObject3$T || (_templateObject3$T = _taggedTemplateLiteralLoose(["\n    margin-top: 60px;\n"])));
var StyledIcon$f = styled(Icon)(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteralLoose(["\n    margin-left: 6px;\n"])));

var ProductInfo$1 = inject('globalProps')(observer(function (_ref) {
  var _item$metadata$find, _rewardsData$rewards, _rewardsData$priceDet, _rewardsData$priceDet2;
  var item = _ref.item,
    globalProps = _ref.globalProps;
  var rewardsData = (_item$metadata$find = item.metadata.find(function (item) {
    return item.name === 'rewardsDetails';
  })) === null || _item$metadata$find === void 0 ? void 0 : _item$metadata$find.value;
  var priceDetails = (item === null || item === void 0 ? void 0 : item.priceDetails) || {};
  var onRewardIconClick = globalProps !== null && globalProps !== void 0 && globalProps.onRewardIconClick ? globalProps === null || globalProps === void 0 ? void 0 : globalProps.onRewardIconClick : function () {
    return null;
  };
  return /*#__PURE__*/React__default.createElement(StyledInfoWrapper, null, /*#__PURE__*/React__default.createElement(StyledInfoRow, {
    "data-e2e": "NumberItems-block"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    color: $secondaryText$1
  }, "Number of items"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "NumberItems-val",
    type: "body2",
    color: $secondaryText$1
  }, priceDetails.qty)), /*#__PURE__*/React__default.createElement(StyledInfoRow, {
    "data-e2e": "originalPrice-block"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    color: $secondaryText$1
  }, "Original price"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "originalPrice-val",
    type: "body2",
    color: $secondaryText$1
  }, "$", roundToLocaleString(priceDetails.originalSubTotal))), /*#__PURE__*/React__default.createElement(StyledInfoRow, {
    "data-e2e": "rewardApplied-block"
  }, /*#__PURE__*/React__default.createElement(StyledInfoRow, {
    $justify: "flex-start"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    color: $secondaryText$1
  }, (rewardsData === null || rewardsData === void 0 ? void 0 : (_rewardsData$rewards = rewardsData.rewards) === null || _rewardsData$rewards === void 0 ? void 0 : _rewardsData$rewards.length) || 0, " Reward applied"), /*#__PURE__*/React__default.createElement(StyledIcon$f, {
    size: "12px",
    onClick: function onClick() {
      return onRewardIconClick(item);
    },
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertQuestion, null);
    }
  })), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "rewardApplied-val",
    type: "body2",
    color: $secondaryText$1
  }, "-$", roundToLocaleString(rewardsData === null || rewardsData === void 0 ? void 0 : (_rewardsData$priceDet = rewardsData.priceDetails) === null || _rewardsData$priceDet === void 0 ? void 0 : _rewardsData$priceDet.rewardsPrice), " (", rewardsData === null || rewardsData === void 0 ? void 0 : (_rewardsData$priceDet2 = rewardsData.priceDetails) === null || _rewardsData$priceDet2 === void 0 ? void 0 : _rewardsData$priceDet2.rewardsPercent, "% off)")));
}));

var _templateObject$1X, _templateObject2$1m, _templateObject3$U, _templateObject4$D, _templateObject5$n, _templateObject6$d, _templateObject7$7;
var Styles$o = styled.div(_templateObject$1X || (_templateObject$1X = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    padding: ", ";\n"])), function (_ref) {
  var simple = _ref.simple;
  return simple ? '' : '0 24px';
});
var CardBody$2 = styled.div(_templateObject2$1m || (_templateObject2$1m = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n"])));
var CardBodyLeft$1 = styled.div(_templateObject3$U || (_templateObject3$U = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: flex-start;\n    padding-right: 16px;\n"])));
var StyledImage$4 = styled(Image)(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteralLoose(["\n    && {\n        width: 76px;\n        height: 76px;\n        object-fit: contain;\n        margin-right: 10px;\n    }\n"])));
var ProductTitle$1 = styled(Typography.Title)(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteralLoose(["\n    margin-bottom: 5px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n"])));
var Info$1 = styled.div(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteralLoose([""])));
var Prices$2 = styled.div(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteralLoose(["\n    white-space: nowrap;\n    text-align: right;\n"])));

var ProductCard$1 = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    item = _ref.item;
  var priceDetails = item.priceDetails;
  var _getPrices = getPrices$1(_extends({}, priceDetails)),
    fullTotal = _getPrices.fullTotal,
    discountPercentage = _getPrices.discountPercentage;
  var simple = store.view.isSimple(GRID_POINTS$2.lg);
  var points = store.getItemPointsEarned(item);
  return /*#__PURE__*/React__default.createElement(Styles$o, {
    simple: simple
  }, /*#__PURE__*/React__default.createElement(CardBody$2, {
    "data-e2e": "orderCard-block"
  }, /*#__PURE__*/React__default.createElement(CardBodyLeft$1, null, /*#__PURE__*/React__default.createElement(StyledImage$4, {
    src: item.image,
    alt: item.productTitle
  }), /*#__PURE__*/React__default.createElement(Info$1, null, /*#__PURE__*/React__default.createElement(ProductTitle$1, {
    "data-e2e": "order-productTitle",
    level: 3
  }, item.productTitle), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "descriptor2",
    color: $secondaryText$1
  }, item.variantTitle.replace('Default Title', '')))), /*#__PURE__*/React__default.createElement(Prices$2, null, !store.env && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    color: $secondaryText$1,
    style: {
      marginBottom: '5px'
    }
  }, priceDetails.qty + " x " + fullTotal), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    align: "right",
    color: $secondaryText$1
  }, discountPercentage)), store.env === 'kcp' && /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "order-priceFullTotal",
    type: "body2",
    color: $secondaryText$1
  }, fullTotal), points && store.isLoggedIn ? /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "orderPoints-val",
    type: "body2",
    color: "primary",
    align: "right"
  }, "up to ", points, " pts") : null)), store.env === 'kcp' && /*#__PURE__*/React__default.createElement(ProductInfo$1, {
    item: item
  }));
}));

var _templateObject$1Y, _templateObject2$1n, _templateObject3$V, _templateObject4$E, _templateObject5$o, _templateObject6$e, _templateObject7$8, _templateObject8$5, _templateObject9$2, _templateObject0;
var Styles$p = styled.div(_templateObject$1Y || (_templateObject$1Y = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    padding: 40px 0 22px;\n    border-bottom: 1px solid ", ";\n\n    &:last-child {\n        margin-bottom: 20px;\n    }\n\n    ", ";\n"])), $border$1, function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? css(_templateObject2$1n || (_templateObject2$1n = _taggedTemplateLiteralLoose(["\n                  &:last-child {\n                      margin-bottom: 0;\n                      border-bottom: none;\n                  }\n              "]))) : '';
});
var CardHead$1 = styled.div(_templateObject3$V || (_templateObject3$V = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 24px;\n"])));
var CardBody$3 = styled.div(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteralLoose(["\n    width: 100%;\n\n    ", ";\n"])), function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteralLoose(["\n                  padding: 0 24px;\n              "]))) : '';
});
var StyledText$f = styled.div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteralLoose(["\n    padding-right: 16px;\n    font-weight: 500;\n"])));
var CardPrices = styled.div(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteralLoose(["\n    padding-bottom: 16px;\n    margin: 0 24px;\n    color: ", ";\n\n    border-bottom: 1px solid ", ";\n"])), $secondaryText$1, $border$1);
var CardPricesRow = styled.div(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"])));
var SubtotalPrice = styled.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    padding: 16px 24px 0;\n"])), $primaryText$2);
var StyledDivider$1 = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 1px;\n    margin: 16px 0;\n    background: ", ";\n"])), $border$1);

var BrandCard$1 = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    bag = _ref.bag,
    orderNumber = _ref.orderNumber,
    orderLength = _ref.orderLength;
  var _getPrices = getPrices$1(_extends({}, bag.priceDetails), getCoveredAmounts(bag.discountsAllocation)),
    shipping = _getPrices.shipping,
    taxes = _getPrices.taxes,
    discounts = _getPrices.discounts,
    fullTotal = _getPrices.fullTotal,
    originalSubTotal = _getPrices.originalSubTotal;
  var simple = store.view.isSimple(GRID_POINTS$2.lg);
  return bag.items && bag.items.length ? /*#__PURE__*/React__default.createElement(Styles$p, {
    "data-e2e": "orderCard-info",
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(CardHead$1, {
    style: BOTTOM_INDENTS.XL
  }, /*#__PURE__*/React__default.createElement(StyledText$f, {
    "data-e2e": "orderNum",
    type: "badgeMedium"
  }, "Order \u2116", orderNumber, "" + (bag.merchantName ? " - " + bag.merchantName : ''))), /*#__PURE__*/React__default.createElement(CardBody$3, {
    $simple: simple
  }, bag.items.map(function (item, key) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      style: BOTTOM_INDENTS.XL
    }, /*#__PURE__*/React__default.createElement(ProductCard$1, {
      key: key,
      item: item
    }));
  })), !store.env && /*#__PURE__*/React__default.createElement(CardPrices, null, /*#__PURE__*/React__default.createElement(CardPricesRow, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, "Brand price " + (bag.items.length > 1 ? "(" + bag.items.length + "x)" : '')), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, originalSubTotal)), /*#__PURE__*/React__default.createElement(CardPricesRow, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, "Shipping"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, shipping)), /*#__PURE__*/React__default.createElement(CardPricesRow, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, "Taxes"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, taxes)), discounts ? /*#__PURE__*/React__default.createElement(CardPricesRow, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, "You save"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, discounts)) : null), store.env === 'kcp' && /*#__PURE__*/React__default.createElement(CardPrices, null, /*#__PURE__*/React__default.createElement(StyledDivider$1, null), /*#__PURE__*/React__default.createElement(CardPricesRow, {
    "data-e2e": "shipping-block"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, "Shipping"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "shipping-val",
    type: "body2"
  }, shipping)), /*#__PURE__*/React__default.createElement(CardPricesRow, {
    "data-e2e": "taxes-block"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2"
  }, "Taxes"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "taxes-val",
    type: "body2"
  }, taxes))), /*#__PURE__*/React__default.createElement(SubtotalPrice, null, /*#__PURE__*/React__default.createElement(CardPricesRow, {
    "data-e2e": "fullTotalPrice-block"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, orderLength > 1 ? 'Subtotal' : 'Total'), /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "fullTotalPrice-val",
    type: "badgeLarge"
  }, fullTotal)))) : null;
}));

var OrdersData = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var orders = store.orders;
  return orders && orders.length ? orders.map(function (bag, key) {
    return /*#__PURE__*/React__default.createElement(BrandCard$1, {
      key: key,
      orderNumber: key + 1,
      orderLength: orders.length,
      bag: bag
    });
  }) : null;
}));

var Styles$q = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1py26h1-0"
})(["display:flex;align-items:flex-end;justify-content:space-between;padding:0 24px;"]);

var OrderSummary = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var price = "$" + roundToLocaleString(store.totalPrice);
  return /*#__PURE__*/React__default.createElement(Styles$q, {
    style: TOP_INDENTS.XL,
    "data-e2e": "orderSum-block"
  }, /*#__PURE__*/React__default.createElement(Typography.Title, {
    level: 2
  }, "Order summary"), /*#__PURE__*/React__default.createElement(Typography.Title, {
    "data-e2e": "orderSum-val",
    level: 2
  }, price));
}));

var ExpansionHeadStyles = styled.div.withConfig({
  displayName: "styles__ExpansionHeadStyles",
  componentId: "sc-mrojcg-0"
})(["width:100%;cursor:pointer;padding:24px;border-bottom:", ";"], function (_ref) {
  var $opened = _ref.$opened;
  return $opened ? "1px solid " + $border$1 : '1px solid transparent';
});
var ExpansionHeadRow = styled.div.withConfig({
  displayName: "styles__ExpansionHeadRow",
  componentId: "sc-mrojcg-1"
})(["display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;&:last-child{margin-bottom:0;}"]);
var OrderSummaryWrap = styled.div.withConfig({
  displayName: "styles__OrderSummaryWrap",
  componentId: "sc-mrojcg-2"
})(["display:flex;align-items:center;justify-content:center;"]);

var ExpansionHead = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    opened = _ref.opened,
    summaryPrice = _ref.summaryPrice,
    pointsEarned = _ref.pointsEarned;
  return /*#__PURE__*/React__default.createElement(ExpansionHeadStyles, {
    $opened: opened
  }, /*#__PURE__*/React__default.createElement(ExpansionHeadRow, null, /*#__PURE__*/React__default.createElement(OrderSummaryWrap, null, /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgBag, null);
    }
  }), "\xA0", /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeSmall"
  }, "Order summary"), "\xA0", /*#__PURE__*/React__default.createElement(Icon, {
    size: "16px",
    component: function component() {
      return opened ? /*#__PURE__*/React__default.createElement(SvgArrowChevronDown, null) : /*#__PURE__*/React__default.createElement(SvgArrowChevronForward, null);
    }
  })), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeMedium"
  }, summaryPrice)), pointsEarned && store.isLoggedIn ? /*#__PURE__*/React__default.createElement(ExpansionHeadRow, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    color: "primary"
  }, "Points earned"), /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "body2",
    color: "primary"
  }, "up to ", pointsEarned, " pts")) : null);
}));

var Styles$r = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-n96244-0"
})(["width:100%;"]);

var Topbar = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    children = _ref.children;
  var _useState = useState(false),
    opened = _useState[0],
    setOpened = _useState[1];
  var summaryPrice = "$" + roundToLocaleString(store.totalPrice);
  var pointsEarned = store.pointsEarned;
  return /*#__PURE__*/React__default.createElement(Styles$r, null, /*#__PURE__*/React__default.createElement(Collapse, {
    withoutPadding: true,
    bordered: false,
    onChange: function onChange(props) {
      return setOpened(props && props[0]);
    }
  }, /*#__PURE__*/React__default.createElement(Panel, {
    header: /*#__PURE__*/React__default.createElement(ExpansionHead, {
      opened: opened,
      summaryPrice: summaryPrice,
      pointsEarned: pointsEarned
    }),
    showArrow: false
  }, children)));
}));

var _templateObject$1Z;
var WrapStyles$4 = styled.div.withConfig({
  displayName: "styles__WrapStyles",
  componentId: "sc-1gd06e0-0"
})(["min-width:430px;width:430px;height:100%;overflow-y:auto;background-color:", ";", ";"], $background$1, function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject$1Z || (_templateObject$1Z = _taggedTemplateLiteralLoose(["\n                  min-width: unset;\n                  width: 100%;\n                  height: auto;\n                  overflow-y: visible;\n              "]))) : '';
});

var Sidebar = inject('store')(observer(function (_ref) {
  var store = _ref.store;
  var simple = store.view.isSimple(GRID_POINTS$2.lg);
  return /*#__PURE__*/React__default.createElement(WrapStyles$4, {
    simple: simple
  }, simple ? /*#__PURE__*/React__default.createElement(Topbar, null, /*#__PURE__*/React__default.createElement(OrdersData, null)) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(OrderSummary, null), /*#__PURE__*/React__default.createElement(OrdersData, null)));
}));

var _templateObject$1_, _templateObject2$1o, _templateObject3$W, _templateObject4$F;
var Wrapper = styled.div(_templateObject$1_ || (_templateObject$1_ = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: flex-start;\n    justify-content: space-between;\n\n    ", ";\n"])), function (_ref) {
  var simple = _ref.simple;
  return simple ? css(_templateObject2$1o || (_templateObject2$1o = _taggedTemplateLiteralLoose(["\n                  flex-direction: column;\n                  overflow-y: auto;\n                  justify-content: flex-start;\n              "]))) : '';
});
var ChildrenWrap = styled.div(_templateObject3$W || (_templateObject3$W = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n\n    ", ";\n"])), function (_ref2) {
  var simple = _ref2.simple;
  return simple ? css(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteralLoose(["\n                  height: auto;\n                  overflow-y: visible;\n              "]))) : '';
});

var LayoutWithSidebar = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    children = _ref.children;
  var simple = store.view.isSimple(GRID_POINTS$2.lg);
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    simple: simple
  }, /*#__PURE__*/React__default.createElement(Sidebar, null), /*#__PURE__*/React__default.createElement(ChildrenWrap, {
    simple: simple
  }, children));
}));

var FieldStyles = styled.div.withConfig({
  displayName: "styles__FieldStyles",
  componentId: "sc-10g6jri-0"
})(["width:100%;"]);
var FieldErrorStyles = styled(Typography.Text).withConfig({
  displayName: "styles__FieldErrorStyles",
  componentId: "sc-10g6jri-1"
})(["padding:8px 0 0;"]);

var _excluded$Q = ["error"];
var TextArea$1 = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var error = _ref.error,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$Q);
  return /*#__PURE__*/React__default.createElement(FieldStyles, null, /*#__PURE__*/React__default.createElement(KliTextarea, _extends({
    invalid: Boolean(error),
    withoutClearButton: true,
    ref: ref
  }, rest)), error && /*#__PURE__*/React__default.createElement(FieldErrorStyles, {
    type: "descriptor2",
    color: "error"
  }, error));
});

var _templateObject$1$;
var BodyStyles$5 = styled.div.withConfig({
  displayName: "styles__BodyStyles",
  componentId: "sc-3b77av-0"
})(["background-color:", ";padding:", ";display:flex;flex-direction:column;align-items:center;"], $white$2, function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? '40px 24px' : '50px 40px';
});
var ButtonsWrap = styled.div.withConfig({
  displayName: "styles__ButtonsWrap",
  componentId: "sc-3b77av-1"
})(["width:100%;display:flex;", ";"], function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject$1$ || (_templateObject$1$ = _taggedTemplateLiteralLoose(["\n                  flex-direction: column-reverse;\n              "]))) : '';
});
var StyledText$g = styled(Typography.Text).withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-3b77av-2"
})(["text-align:center;@media (", "){text-align:left;}"], GRID_DEVICES_MAX$1.md);

var CancelOrderConfirmation = function CancelOrderConfirmation(_ref) {
  var onModalClose = _ref.onModalClose,
    onConfirm = _ref.onConfirm,
    simple = _ref.simple;
  return /*#__PURE__*/React__default.createElement(BodyStyles$5, {
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(StyledText$g, {
    style: BOTTOM_INDENTS.XL,
    type: "body1"
  }, "Are you sure you want to cancel your order? This action cannot be undone."), /*#__PURE__*/React__default.createElement(ButtonsWrap, {
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(Button, {
    type: "unstyled",
    block: true,
    onClick: onModalClose,
    "data-e2e": "cancel-ord-modal-go-back-btn"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, "Go back")), "\xA0 \xA0", /*#__PURE__*/React__default.createElement(Button, {
    type: "primary",
    block: true,
    onClick: onConfirm,
    "data-e2e": "cancel-ord-modal-confirm-btn"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, "Confirm"))));
};

var selectorData = [{
  label: 'Not receiving any shipping information',
  value: 'Not receiving any shipping information'
}, {
  label: 'Accidentally added an upsell purchase',
  value: 'Accidentally added an upsell purchase'
}, {
  label: 'Didn’t notice the shipping fee',
  value: 'Didn’t notice the shipping fee'
}, {
  label: 'Ordered the incorrect item',
  value: 'Ordered the incorrect item'
}, {
  label: 'Other',
  value: 'Other'
}];

var _templateObject$20;
var Styles$s = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1i2dv1o-0"
})(["width:100%;background-color:", ";padding:", ";"], $white$2, function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? '40px 24px' : '52px 40px';
});
var ButtonsWrap$1 = styled.div.withConfig({
  displayName: "styles__ButtonsWrap",
  componentId: "sc-1i2dv1o-1"
})(["width:100%;display:flex;", ";"], function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject$20 || (_templateObject$20 = _taggedTemplateLiteralLoose(["\n                  flex-direction: column-reverse;\n              "]))) : '';
});

var CancelOrderForm = function CancelOrderForm(_ref) {
  var onSubmit = _ref.onSubmit,
    errorMessage = _ref.errorMessage,
    onClose = _ref.onClose,
    simple = _ref.simple;
  var _useState = useState(''),
    selectorValue = _useState[0],
    setSelectorValue = _useState[1];
  var _useState2 = useState(''),
    replyValue = _useState2[0],
    setReplyValue = _useState2[1];
  var _useState3 = useState(''),
    selectorError = _useState3[0],
    setSelectorError = _useState3[1];
  var _useState4 = useState(''),
    replyError = _useState4[0],
    setReplyError = _useState4[1];
  var onSelectorValueChange = function onSelectorValueChange(value) {
    setSelectorValue(value);
    setSelectorError('');
  };
  var onReplyValueChange = function onReplyValueChange(e) {
    setReplyValue(e.target.value);
    setReplyError('');
  };
  var handleSubmit = function handleSubmit() {
    if (!selectorValue) {
      return setSelectorError('This field is required');
    }
    var note = [selectorValue];
    if (selectorValue === 'Other' && (!replyValue || replyValue.length < 10)) {
      return setReplyError('This field is required min 3 words (10 characters)');
    }
    if (replyValue) {
      note.push(replyValue);
    }
    onSubmit(note.join(', '));
  };
  return /*#__PURE__*/React__default.createElement(Styles$s, {
    $simple: simple
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    style: BOTTOM_INDENTS.SM
  }, "Please set cancellation reason"), /*#__PURE__*/React__default.createElement(Select, {
    size: "large",
    label: "Select cancellation reason*",
    value: selectorValue,
    "data-e2e": "cancel-order-reason-select",
    error: selectorError,
    onChange: function onChange(value) {
      return onSelectorValueChange(value);
    },
    options: selectorData.map(function (reason) {
      return {
        label: reason.label,
        value: reason.value
      };
    })
  }), selectorError ? /*#__PURE__*/React__default.createElement(ErrorField$2, {
    error: selectorError
  }) : null, /*#__PURE__*/React__default.createElement(TextArea$1, {
    "data-e2e": "cancel-order-share-reply-text-input",
    style: TOP_INDENTS.SM,
    placeholder: "Share a reply (min 3 words)*",
    value: replyValue,
    onChange: function onChange(e) {
      return onReplyValueChange(e);
    },
    error: replyError
  }), errorMessage && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ErrorField$2, {
    error: errorMessage
  })), /*#__PURE__*/React__default.createElement(ButtonsWrap$1, {
    style: TOP_INDENTS.SM,
    $simple: simple
  }, /*#__PURE__*/React__default.createElement(Button, {
    type: "unstyled",
    block: true,
    onClick: onClose,
    "data-e2e": "cancel-ord-modal-go-back-btn-final"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, "Go back")), "\xA0 \xA0", /*#__PURE__*/React__default.createElement(Button, {
    type: "primary",
    block: true,
    onClick: handleSubmit,
    "data-e2e": "cancel-ord-modal-continue-btn-final"
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, "Confirm")))));
};

var _templateObject$21, _templateObject2$1p;
var WrapStyles$5 = styled.div.withConfig({
  displayName: "styles__WrapStyles",
  componentId: "sc-17xgtai-0"
})(["width:630px;background-color:", ";position:relative;", ";"], $white$2, function (_ref) {
  var $simple = _ref.$simple;
  return $simple ? css(_templateObject$21 || (_templateObject$21 = _taggedTemplateLiteralLoose(["\n                  width: 100%;\n                  height: 100%;\n              "]))) : '';
});
var ContentStyles$2 = styled.div.withConfig({
  displayName: "styles__ContentStyles",
  componentId: "sc-17xgtai-1"
})([""]);
var HeadStyles$2 = styled.div.withConfig({
  displayName: "styles__HeadStyles",
  componentId: "sc-17xgtai-2"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";color:", ";padding:24px;", ""], $primaryBackground, $primary$2, function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject2$1p || (_templateObject2$1p = _taggedTemplateLiteralLoose(["\n                  flex-direction: column;\n                  align-items: flex-start;\n              "]))) : '';
});
var CloseModalIcon$4 = styled(Icon).withConfig({
  displayName: "styles__CloseModalIcon",
  componentId: "sc-17xgtai-3"
})(["position:absolute;bottom:100%;margin-bottom:30px;font-size:24px;left:50%;transform:translate3d(-50%,0,0);"]);

var CancelOrderModal = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    onModalClose = _ref.onModalClose,
    simple = _ref.simple;
  var modalState = store.currentModalState;
  var pending = store.cancelOrderPending;
  var error = store.cancelOrderError;
  var onSubmit = function onSubmit(note) {
    store.cancelOrder(note, onModalClose);
  };
  return /*#__PURE__*/React__default.createElement(WrapStyles$5, {
    $simple: simple
  }, !simple ? /*#__PURE__*/React__default.createElement(CloseModalIcon$4, {
    color: "canvas",
    onClick: onModalClose,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  }) : null, /*#__PURE__*/React__default.createElement(ContentStyles$2, null, /*#__PURE__*/React__default.createElement(HeadStyles$2, {
    $simple: simple
  }, simple ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
    style: BOTTOM_INDENTS.SM,
    size: "24px",
    color: "primary",
    onClick: onModalClose,
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCloseX, null);
    }
  })) : null, /*#__PURE__*/React__default.createElement(Typography.Title, null, "Cancel order")), modalState === 'confirmation' ? /*#__PURE__*/React__default.createElement(CancelOrderConfirmation, {
    simple: simple,
    onModalClose: onModalClose,
    onConfirm: store.toConfirmationReasonModalState
  }) : null, modalState === 'cancellation-reason' ? /*#__PURE__*/React__default.createElement(CancelOrderForm, {
    onClose: onModalClose,
    onSubmit: onSubmit,
    errorMessage: error,
    simple: simple
  }) : null, pending && /*#__PURE__*/React__default.createElement(Icon.Loader, null)));
}));

var useCancelOrderModal = function useCancelOrderModal(simple, onCancel) {
  var _useModal = useModal(),
    setModal = _useModal.setModal,
    hideModal = _useModal.hideModal;
  var onModalClose = useCallback(function () {
    hideModal();
    if (onCancel !== undefined) {
      onCancel();
    }
  }, [hideModal, onCancel]);
  return useCallback(function () {
    setModal(/*#__PURE__*/React__default.createElement(CancelOrderModal, {
      simple: simple,
      onModalClose: onModalClose
    }), {
      closable: false,
      fullscreen: simple
    });
  }, [setModal, onModalClose, simple]);
};

var _path$4M, _circle$Q, _path2$1W;
function _extends$59() {
  return _extends$59 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$59.apply(null, arguments);
}
function SvgIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$59({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4M || (_path$4M = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.797 12.777a2 2 0 00-.425.89h53.256a2 2 0 00-.425-.89l-7.826-9.39a2 2 0 00-1.536-.72H15.159a2 2 0 00-1.537.72l-7.825 9.39zm-.464 45.556V15.667h53.334v42.666a3 3 0 01-3 3H8.333a3 3 0 01-3-3zm17-31.666a1 1 0 00-2 0c0 6.443 5.224 11.666 11.667 11.666s11.667-5.223 11.667-11.666a1 1 0 10-2 0A9.667 9.667 0 0132 36.332c-5.339 0-9.667-4.328-9.667-9.666z",
    fill: "#A4ADB4"
  })), _circle$Q || (_circle$Q = /*#__PURE__*/createElement("circle", {
    cx: 60,
    cy: 60,
    r: 18.333,
    fill: "#fff",
    stroke: "#F25858",
    strokeWidth: 3.333
  })), _path2$1W || (_path2$1W = /*#__PURE__*/createElement("path", {
    d: "M55 59.916l3.535 3.536 7.072-7.072",
    stroke: "#F25858",
    strokeWidth: 3.333,
    strokeLinecap: "round"
  })));
}

var _templateObject$22, _templateObject2$1q;
var Styles$t = styled.div.withConfig({
  displayName: "styles__Styles",
  componentId: "sc-1m5cwii-0"
})(["width:100%;max-width:630px;display:flex;flex-direction:column;align-items:center;background-color:", ";padding:90px 150px;", ";", ";"], $background$1, function (_ref) {
  var $appWidth = _ref.$appWidth;
  return $appWidth < 1050 ? css(_templateObject$22 || (_templateObject$22 = _taggedTemplateLiteralLoose(["\n                  padding: 90px;\n              "]))) : '';
}, function (_ref2) {
  var $simple = _ref2.$simple;
  return $simple ? css(_templateObject2$1q || (_templateObject2$1q = _taggedTemplateLiteralLoose(["\n                  width: 100%;\n                  background-color: ", ";\n                  padding: 40px 24px;\n              "])), $white$2) : '';
});
var StyledImg$1 = styled(SvgIcon).withConfig({
  displayName: "styles__StyledImg",
  componentId: "sc-1m5cwii-1"
})(["&&{width:80px;height:80px;object-fit:contain;}"]);
var InfoWrap = styled.div.withConfig({
  displayName: "styles__InfoWrap",
  componentId: "sc-1m5cwii-2"
})(["width:100%;display:flex;align-items:center;color:", ";.anticon{margin-left:8px;}"], $primaryText$2);
var CancelInfoWrap = styled.div.withConfig({
  displayName: "styles__CancelInfoWrap",
  componentId: "sc-1m5cwii-3"
})(["display:flex;align-items:center;color:", ";@media (", "){width:100%;padding:12px 24px;background:", ";}"], $primaryText$2, GRID_DEVICES_MAX$1.md, $background$1);
var CancelOrderButton = styled(Button).withConfig({
  displayName: "styles__CancelOrderButton",
  componentId: "sc-1m5cwii-4"
})(["&&{color:inherit;padding:0;display:inline-block;margin:0 5px;text-decoration:underline;text-decoration-color:", ";}"], function (_ref3) {
  var _ref3$$textDecoration = _ref3.$textDecorationColor,
    $textDecorationColor = _ref3$$textDecoration === void 0 ? $primaryText$2 : _ref3$$textDecoration;
  return $textDecorationColor;
});
var StyledConfirmationInfo = styled(Typography.Text).withConfig({
  displayName: "styles__StyledConfirmationInfo",
  componentId: "sc-1m5cwii-5"
})(["@media (", "){margin-bottom:36px;}"], GRID_DEVICES_MAX$1.xxxs);

var CancelMuiltiplyOrderLine = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    order = _ref.order,
    orderIndex = _ref.orderIndex,
    onCancelOrder = _ref.onCancelOrder;
  var simple = useSimpleInterface(GRID_DEVICES_MAX$1.md);
  return /*#__PURE__*/React__default.createElement("div", {
    key: order.klicklyOrderId
  }, order.isAvailableForCancel && order.klicklyStatus !== 'refunded' && !store.cancelOrderUnavailable ? /*#__PURE__*/React__default.createElement(InfoWrap, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "div",
    type: "descriptor2"
  }, "- Order #", orderIndex + 1, " (#", order.orderNumber, ") - Cancel", /*#__PURE__*/React__default.createElement(CancelOrderButton, {
    $textDecorationColor: $info,
    type: "unstyled",
    onClick: function onClick() {
      store.setOrderForRefund(order.klicklyOrderId);
      return onCancelOrder();
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "descriptor2",
    color: "info"
  }, "here")))) : null, order.klicklyStatus === 'refunded' ? /*#__PURE__*/React__default.createElement(InfoWrap, null, /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "div",
    type: simple ? 'descriptor1' : 'descriptor2'
  }, "- Order #", orderIndex + 1, " ($", order.orderNumber, ") - Your order", ' ', /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "span",
    type: simple ? 'descriptor1' : 'descriptor2',
    color: "primary"
  }, "has been cancelled"))) : null);
}));

var CancelSingleOrderLine = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    order = _ref.order,
    onCancelOrder = _ref.onCancelOrder;
  var simple = useSimpleInterface(GRID_DEVICES_MAX$1.md);
  return /*#__PURE__*/React__default.createElement(Fragment, null, order.isAvailableForCancel && order.klicklyStatus !== 'refunded' && !store.cancelOrderUnavailable ? /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "div",
    type: "descriptor2"
  }, "Error with your order? ", /*#__PURE__*/React__default.createElement("br", null), "Cancel in the next 5 mins by clicking", /*#__PURE__*/React__default.createElement(CancelOrderButton, {
    type: "unstyled",
    onClick: function onClick() {
      store.setOrderForRefund(order.klicklyOrderId);
      return onCancelOrder();
    }
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "descriptor2"
  }, "here"))) : null, order.klicklyStatus === 'refunded' ? /*#__PURE__*/React__default.createElement(Typography.Text, {
    "data-e2e": "order-cancelled-confirmation-text",
    as: "div",
    type: simple ? 'descriptor1' : 'descriptor2'
  }, "This order has been cancelled", simple && /*#__PURE__*/React__default.createElement("br", null), " and your credit card refunded") : null);
}));

var OrdersInfo = inject('store', 'globalProps')(observer(function (_ref) {
  var store = _ref.store,
    globalProps = _ref.globalProps,
    hideContinueShoppingButton = _ref.hideContinueShoppingButton;
  var continueShoppingText = globalProps.continueShoppingText;
  var customContent = globalProps.customContent;
  var orderNumbers = store.orderNumbers;
  var continueShoppingClick = function continueShoppingClick() {
    if (globalProps.continueShoppingClick !== undefined) {
      globalProps.continueShoppingClick();
    }
  };
  var prefix1 = '';
  var prefix2 = 'has';
  var isMultipleOrders = orderNumbers && orderNumbers.length > 1;
  if (isMultipleOrders) {
    prefix1 = 's';
    prefix2 = 'have';
  }
  var simpleModal = store.view.isSimple(GRID_POINTS$2.sm);
  var simple = store.view.isSimple(GRID_POINTS$2.lg);
  var appWidth = store.view.appWidth;
  var onCancelOrder = useCancelOrderModal(simpleModal, store.resetModalState);
  var getOrdersNumbers = function getOrdersNumbers(orderNumbers) {
    var string = '';
    orderNumbers && orderNumbers.length && orderNumbers.forEach(function (number, index) {
      if (index > 0 && index + 1 !== orderNumbers.length) {
        string = string + (", " + number);
        return;
      }
      if (index > 0 && index + 1 === orderNumbers.length) {
        string = string + (" and " + number);
        return;
      }
      string = string + ("" + number);
    });
    return string;
  };
  return /*#__PURE__*/React__default.createElement(Styles$t, {
    "data-e2e": "thank-you-block",
    $simple: simple,
    $appWidth: appWidth
  }, /*#__PURE__*/React__default.createElement(StyledImg$1, {
    style: BOTTOM_INDENTS.XL
  }), /*#__PURE__*/React__default.createElement(Typography.Title, {
    style: TOP_INDENTS.SM,
    "data-e2e": "klickly-order-number",
    level: 2,
    align: "center"
  }, "Your order" + prefix1 + " " + getOrdersNumbers(orderNumbers) + " " + prefix2 + " been received"), /*#__PURE__*/React__default.createElement(StyledConfirmationInfo, {
    align: "center",
    type: "descriptor1"
  }, "A confirmation will be sent to your email shortly"), customContent || (store.hasOrdersForRefund ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CancelInfoWrap, {
    style: TOP_INDENTS.XL,
    "data-e2e": "cancel-block"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    size: "22px",
    style: {
      marginRight: '16px'
    },
    color: "primary",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgCircleActionsAlertInfo, null);
    }
  }), store.orders && store.orders.length === 1 ? /*#__PURE__*/React__default.createElement(CancelSingleOrderLine, {
    order: store.orders[0],
    onCancelOrder: onCancelOrder
  }) : null, store.orders && store.orders.length > 1 ? /*#__PURE__*/React__default.createElement(Typography.Text, {
    as: "div",
    type: "descriptor2"
  }, "Error with your order? Cancel in the next 5 minutes", /*#__PURE__*/React__default.createElement("div", {
    style: TOP_INDENTS.SM
  }, store.orders.map(function (order, index) {
    return /*#__PURE__*/React__default.createElement(CancelMuiltiplyOrderLine, {
      key: order.klicklyOrderId,
      orderIndex: index,
      order: order,
      onCancelOrder: onCancelOrder
    });
  }))) : null)) : null), !hideContinueShoppingButton && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(InfoWrap, {
    style: TOP_INDENTS.XL
  }, /*#__PURE__*/React__default.createElement(Button, {
    "data-e2e": "continue-shopping-button",
    onClick: continueShoppingClick,
    type: "primary",
    size: "large",
    ghost: true,
    block: true
  }, /*#__PURE__*/React__default.createElement(Typography.Text, {
    type: "badgeLarge"
  }, continueShoppingText), /*#__PURE__*/React__default.createElement(Icon, {
    size: "24px",
    component: function component() {
      return /*#__PURE__*/React__default.createElement(SvgArrowGoingUp, null);
    }
  })))));
}));

var _templateObject$23, _templateObject2$1r, _templateObject3$X, _templateObject4$G;
var WrapStyles$6 = styled.div(_templateObject$23 || (_templateObject$23 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
var Styles$u = styled.div(_templateObject2$1r || (_templateObject2$1r = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 24px;\n\n    ", ";\n\n    ", ";\n"])), function (_ref) {
  var $env = _ref.$env;
  return $env === 'kcp' && css(_templateObject3$X || (_templateObject3$X = _taggedTemplateLiteralLoose(["\n            height: auto;\n            padding-top: 56px;\n        "])));
}, function (_ref2) {
  var simple = _ref2.simple;
  return simple ? css(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteralLoose(["\n                  max-width: 100%;\n                  padding: 24px 0;\n              "]))) : '';
});

var ThankYouPage = inject('store')(observer(function (_ref) {
  var store = _ref.store,
    bottomExtraContent = _ref.bottomExtraContent,
    hideContinueShoppingButton = _ref.hideContinueShoppingButton;
  var _useState = useState(null),
    node = _useState[0],
    setNode = _useState[1];
  var appRef = useCallback(function (node) {
    if (node !== null) {
      setNode(node);
      store.view.setAppWidth(node.offsetWidth);
    }
  }, []);
  useLayoutEffect(function () {
    if (node) {
      var onResize = debounce(function () {
        store.view.setAppWidth(node.offsetWidth);
      }, 500);
      window.addEventListener('resize', onResize);
      return function () {
        window.removeEventListener('resize', onResize);
      };
    }
  }, [node]);
  var simple = store.view.isSimple(GRID_POINTS$2.lg);
  var loading = store.isLoading;
  return /*#__PURE__*/React__default.createElement(WrapStyles$6, {
    ref: appRef,
    id: "cancel-order-modal"
  }, !loading ? /*#__PURE__*/React__default.createElement(LayoutWithSidebar, null, /*#__PURE__*/React__default.createElement(Styles$u, {
    simple: simple,
    className: "thank-you-page-main-content",
    $env: store.env
  }, /*#__PURE__*/React__default.createElement(OrdersInfo, {
    hideContinueShoppingButton: hideContinueShoppingButton
  }), bottomExtraContent || null)) : /*#__PURE__*/React__default.createElement(Icon.Loader, null));
}));

var HttpClient = /*#__PURE__*/function () {
  function HttpClient() {}
  var _proto = HttpClient.prototype;
  _proto.init = function init(links) {
    this.links = links;
    this.axiosInstance = axios.create({
      withCredentials: true
    });
  };
  _proto.__requestWrapper = function __requestWrapper(request) {
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(request).then(function (_ref) {
          var data = _ref.data;
          return data;
        });
      }, function (error) {
        throw error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  _proto.fetchOrdersData = function fetchOrdersData(code) {
    return this.__requestWrapper(this.axiosInstance.get(this.links.getOrderByCode + "?code=" + code));
  };
  _proto.fetchOrdersDataByOrderId = function fetchOrdersDataByOrderId(orderId) {
    return this.__requestWrapper(this.axiosInstance.get(this.links.getOrderById + "/" + orderId));
  };
  _proto.cancelOrder = function cancelOrder(orderId, note) {
    var cartToken = LocalStorage.get('x-klickly-cart-token');
    var headers = {};
    if (cartToken) {
      headers['x-klickly-cart-token'] = cartToken;
    }
    return this.__requestWrapper(this.axiosInstance.post(this.links.cancelOrder + "/" + orderId, {
      note: note
    }, {
      headers: headers
    }));
  };
  return HttpClient;
}();
var HttpClient$1 = new HttpClient();

var ViewStore$2 = types.model({
  appWidth: types.maybeNull(types.number)
}).views(function (self) {
  return {
    isSimple: function isSimple(size) {
      return size > self.appWidth;
    }
  };
}).actions(function (self) {
  return {
    setAppWidth: function setAppWidth(width) {
      self.appWidth = width;
    }
  };
});

var RootStore$4 = types.model('RootStore', {
  isLoading: true,
  cancelOrderPending: false,
  orderIdForRefund: types.maybeNull(types.string),
  data: types.maybeNull(types.model({
    account: types.string,
    cartId: types.string,
    paymentInfo: types.optional(types.model({
      cardType: types.maybeNull(types.string),
      expMonth: types.maybeNull(types.number),
      expYear: types.maybeNull(types.number),
      last4: types.maybeNull(types.string),
      type: types.maybeNull(types.string)
    }), {}),
    cart: types.model({
      account: types.maybeNull(types.string),
      bags: types.optional(types.array(types.model({
        klicklyOrderId: types.maybeNull(types.string),
        klicklyStatus: types.maybeNull(types.string),
        isAvailableForCancel: types.maybeNull(types["boolean"]),
        merchantId: types.maybeNull(types.string),
        merchantName: types.string,
        orderNumber: types.string,
        pixels: types.array(types.model({
          name: types.string,
          src: types.string,
          enabled: types.maybeNull(types["boolean"])
        })),
        items: types.array(types.model({
          productId: types.string,
          image: types.string,
          priceDetails: types.model({
            qty: types.number,
            originalPrice: types.number,
            originalSubTotal: types.number,
            price: types.number,
            subTotal: types.number,
            discounts: types.number,
            total: types.number,
            fullTotal: types.number
          }),
          productTitle: types.string,
          variantTitle: types.string,
          metadata: types.array(types.frozen())
        })),
        priceDetails: types.optional(types.model({
          qty: types.maybeNull(types.number),
          subTotal: types.maybeNull(types.number),
          originalSubTotal: types.maybeNull(types.number),
          discounts: types.maybeNull(types.number),
          shipping: types.maybeNull(types.number),
          taxes: types.maybeNull(types.number),
          total: types.maybeNull(types.number),
          fullTotal: types.maybeNull(types.number)
        }), {}),
        discountsAllocation: types.maybeNull(types.frozen()),
        shopDomain: types.maybeNull(types.string)
      })), []),
      priceDetails: types.optional(types.model({
        discounts: types.maybeNull(types.number),
        qty: types.maybeNull(types.number),
        shipping: types.maybeNull(types.number),
        taxes: types.maybeNull(types.number),
        originalSubTotal: types.maybeNull(types.number),
        subTotal: types.maybeNull(types.number),
        total: types.maybeNull(types.number),
        fullTotal: types.maybeNull(types.number)
      }), {}),
      customerInfo: types.model({
        email: types.string
      })
    })
  })),
  modalState: 'confirmation',
  cancelOrderError: types.maybeNull(types.string),
  view: types.optional(ViewStore$2, {}),
  cancelOrderUnavailable: types.optional(types["boolean"], false),
  env: types.maybe(types.string),
  isLoggedIn: types.maybe(types["boolean"])
}).views(function (self) {
  return {
    get propsData() {
      return getEnv(self).propsData;
    },
    get asyncHooks() {
      return getEnv(self).asyncHooks;
    },
    get isEmptyOrders() {
      return !self.orders.length;
    },
    get prices() {
      var _self$data, _self$data$cart;
      return (_self$data = self.data) === null || _self$data === void 0 ? void 0 : (_self$data$cart = _self$data.cart) === null || _self$data$cart === void 0 ? void 0 : _self$data$cart.priceDetails;
    },
    get totalPrice() {
      var _self$data2, _self$data2$cart, _self$data2$cart$pric;
      return (_self$data2 = self.data) === null || _self$data2 === void 0 ? void 0 : (_self$data2$cart = _self$data2.cart) === null || _self$data2$cart === void 0 ? void 0 : (_self$data2$cart$pric = _self$data2$cart.priceDetails) === null || _self$data2$cart$pric === void 0 ? void 0 : _self$data2$cart$pric.fullTotal;
    },
    get orders() {
      var _self$data3, _self$data3$cart;
      return ((_self$data3 = self.data) === null || _self$data3 === void 0 ? void 0 : (_self$data3$cart = _self$data3.cart) === null || _self$data3$cart === void 0 ? void 0 : _self$data3$cart.bags) || [];
    },
    get orderNumbers() {
      return self.orders.map(function (_ref) {
        var orderNumber = _ref.orderNumber;
        return orderNumber;
      });
    },
    get hasOrdersForRefund() {
      return Boolean(self.orders.filter(function (order) {
        return order.isAvailableForCancel && order.klicklyStatus !== 'refunded' && !self.cancelOrderUnavailable || order.klicklyStatus === 'refunded';
      }).length);
    },
    get currentModalState() {
      return self.modalState;
    },
    get pointsEarned() {
      return self.data.cart.bags.reduce(function (sum, bag) {
        var bagPoints = bag.items.reduce(function (sum, item) {
          var pointsEarnedMetadataField = item && item.metadata && item.metadata.length ? item.metadata.find(function (el) {
            return el && el.name === 'pointsEarned';
          }) : null;
          if (pointsEarnedMetadataField) {
            sum += pointsEarnedMetadataField.value;
          }
          return sum;
        }, 0);
        return sum + bagPoints;
      }, 0);
    }
  };
}).actions(function (self) {
  return {
    afterCreate: function afterCreate() {
      self.loadOrders();
    },
    markLoading: function markLoading(loading) {
      self.isLoading = loading;
    },
    calculateCashback: function calculateCashback(cart) {
      var _cart$bags;
      if (!(cart !== null && cart !== void 0 && (_cart$bags = cart.bags) !== null && _cart$bags !== void 0 && _cart$bags.length)) return 0;
      return cart.bags.reduce(function (sum, bag) {
        var _bag$cashbackDetails;
        var cashback = ((_bag$cashbackDetails = bag.cashbackDetails) === null || _bag$cashbackDetails === void 0 ? void 0 : _bag$cashbackDetails.value) || 0;
        return sum + cashback;
      }, 0);
    },
    setOrderForRefund: function setOrderForRefund(orderId) {
      self.orderIdForRefund = orderId;
    },
    setOrderHasBeenRefunded: function setOrderHasBeenRefunded(orderIdForRefund) {
      var order = self.orders.find(function (_ref2) {
        var klicklyOrderId = _ref2.klicklyOrderId;
        return klicklyOrderId === orderIdForRefund;
      });
      order.klicklyStatus = 'refunded';
      order.isAvailableForCancel = false;
      self.orderIdForRefund = null;
    },
    loadOrders: flow(/*#__PURE__*/_regenerator().m(function loadOrders() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            self.markLoading(true);
            if (!self.propsData.checkoutOrderCode) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return HttpClient$1.fetchOrdersData(self.propsData.checkoutOrderCode);
          case 1:
            self.data = _context.v;
          case 2:
            if (!self.propsData.checkoutOrderId) {
              _context.n = 4;
              break;
            }
            _context.n = 3;
            return HttpClient$1.fetchOrdersDataByOrderId(self.propsData.checkoutOrderId);
          case 3:
            self.data = _context.v;
          case 4:
            if (typeof self.asyncHooks.onFetchOrdersSuccess === 'function') {
              self.asyncHooks.onFetchOrdersSuccess(self.data);
            }
            self.markLoading(false);
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            console.error("Failed to load ", _t);
          case 6:
            return _context.a(2);
        }
      }, loadOrders, null, [[0, 5]]);
    })),
    resetModalState: function resetModalState() {
      self.modalState = 'confirmation';
      self.orderIdForRefund = null;
      self.cancelOrderError = null;
    },
    toConfirmationReasonModalState: function toConfirmationReasonModalState() {
      self.modalState = 'cancellation-reason';
    },
    cancelOrder: flow(/*#__PURE__*/_regenerator().m(function cancelOrder(note, onModalClose) {
      var orderIdForRefund, canceledCartData, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            self.cancelOrderPending = true;
            orderIdForRefund = self.orderIdForRefund;
            _context2.n = 1;
            return HttpClient$1.cancelOrder(orderIdForRefund, note);
          case 1:
            canceledCartData = _context2.v;
            self.setOrderHasBeenRefunded(orderIdForRefund);
            if (typeof onModalClose === 'function') {
              onModalClose();
            }
            if (typeof self.asyncHooks.onCancelOrderSuccess === 'function') {
              self.asyncHooks.onCancelOrderSuccess({
                orderIdForRefund: orderIdForRefund,
                note: note,
                cashback: self.calculateCashback(canceledCartData === null || canceledCartData === void 0 ? void 0 : canceledCartData.cart)
              });
            }
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            if (_t2 && _t2.message) {
              self.cancelOrderError = _t2.message;
            }
            if (_t2 && _t2.response && _t2.response.data) {
              self.cancelOrderError = _t2.response.data.message;
            }
          case 3:
            _context2.p = 3;
            self.cancelOrderPending = false;
            return _context2.f(3);
          case 4:
            return _context2.a(2);
        }
      }, cancelOrder, null, [[0, 2, 3, 4]]);
    })),
    getItemPointsEarned: function getItemPointsEarned(item) {
      var pointsEarnedMetadataField = item.metadata && item.metadata.length ? item.metadata.find(function (el) {
        return el && el.name === 'pointsEarned';
      }) : null;
      if (pointsEarnedMetadataField) {
        return pointsEarnedMetadataField.value;
      }
      return null;
    }
  };
});

var CheckoutThankYou = function CheckoutThankYou(_ref) {
  var links = _ref.links,
    data = _ref.data,
    _ref$continueShopping = _ref.continueShoppingText,
    continueShoppingText = _ref$continueShopping === void 0 ? 'Continue shopping' : _ref$continueShopping,
    continueShoppingClick = _ref.continueShoppingClick,
    _ref$loadFonts = _ref.loadFonts,
    loadFonts = _ref$loadFonts === void 0 ? true : _ref$loadFonts,
    _ref$asyncHooks = _ref.asyncHooks,
    asyncHooks = _ref$asyncHooks === void 0 ? {} : _ref$asyncHooks,
    cancelOrderUnavailable = _ref.cancelOrderUnavailable,
    customContent = _ref.customContent,
    bottomExtraContent = _ref.bottomExtraContent,
    _ref$onRewardIconClic = _ref.onRewardIconClick,
    onRewardIconClick = _ref$onRewardIconClic === void 0 ? function () {
      return null;
    } : _ref$onRewardIconClic,
    env = _ref.env,
    isLoggedIn = _ref.isLoggedIn,
    hideContinueShoppingButton = _ref.hideContinueShoppingButton;
  HttpClient$1.init(links);
  var store = useMemo(function () {
    return RootStore$4.create({
      cancelOrderUnavailable: cancelOrderUnavailable,
      env: env,
      isLoggedIn: isLoggedIn
    }, {
      propsData: data,
      asyncHooks: asyncHooks
    });
  }, []);
  var globalProps = useMemo(function () {
    return {
      continueShoppingText: continueShoppingText,
      continueShoppingClick: continueShoppingClick,
      customContent: customContent,
      onRewardIconClick: onRewardIconClick
    };
  }, []);
  useEffect(function () {
    if (loadFonts) {
      WebFont.load({
        google: {
          families: ['IBM Plex Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700', 'IBM Plex Serif:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700']
        }
      });
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: store,
    globalProps: globalProps
  }, /*#__PURE__*/React__default.createElement(ModalProvider, null, /*#__PURE__*/React__default.createElement(ThankYouPage, {
    bottomExtraContent: bottomExtraContent,
    hideContinueShoppingButton: hideContinueShoppingButton
  })));
};
var CheckoutOrdersSidebar = function CheckoutOrdersSidebar(_ref2) {
  var totalPrice = _ref2.totalPrice,
    _ref2$orders = _ref2.orders,
    orders = _ref2$orders === void 0 ? [] : _ref2$orders,
    _ref2$simple = _ref2.simple,
    simple = _ref2$simple === void 0 ? false : _ref2$simple,
    _ref2$loadFonts = _ref2.loadFonts,
    loadFonts = _ref2$loadFonts === void 0 ? true : _ref2$loadFonts;
  useEffect(function () {
    if (loadFonts) {
      WebFont.load({
        google: {
          families: ['IBM Plex Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700', 'IBM Plex Serif:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700']
        }
      });
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.StrictMode, null, /*#__PURE__*/React__default.createElement(Sidebar, {
    totalPrice: totalPrice,
    orders: orders,
    simple: simple
  }));
};

export { SvgActionsMinus as ActionsMinusIcon, SvgActionsPlus as ActionsPlusIcon, SvgAirbnb as AirbnbIcon, SvgAirlinePlane as AirlinePlaneIcon, Alert, SvgAlignCenter as AlignCenterIcon, SvgAlignJustify as AlignJustifyIcon, SvgAlignLeft as AlignLeftIcon, SvgAlignRight as AlignRightIcon, SvgAmazon as AmazonIcon, SvgAmex as AmexIcon, SvgAndroid as AndroidIcon, SvgApple as AppleIcon, SvgAppleMusic as AppleMusicIcon, SvgArrowCaretBack as ArrowCaretBackIcon, SvgArrowCaretDown as ArrowCaretDownIcon, SvgArrowCaretForward as ArrowCaretForwardIcon, SvgArrowCaretUp as ArrowCaretUpIcon, SvgArrowChevronBack as ArrowChevronBackIcon, SvgArrowChevronDown as ArrowChevronDownIcon, SvgArrowChevronForward as ArrowChevronForwardIcon, SvgArrowChevronUp as ArrowChevronUpIcon, SvgArrowDown as ArrowDownIcon, SvgArrowGoingDown as ArrowGoingDownIcon, SvgArrowGoingUpAlt as ArrowGoingUpAltIcon, SvgArrowGoingUp as ArrowGoingUpIcon, SvgArrowReply as ArrowReplyIcon, SvgArrowSelect as ArrowSelectIcon, SvgArrowUp as ArrowUpIcon, SvgAtSign as AtSignIcon, SvgAttach as AttachIcon, SvgAutoLayout as AutoLayoutIcon, SvgAutomotiveIconRed as AutomotiveIconRed, Avatar, SvgAvatar as AvatarIcon, SvgAvatarNew as AvatarIconNew, BOTTOM_INDENTS, SvgBackArrow as BackArrowIcon, SvgBackUndo as BackUndoIcon, SvgBackspace as BackspaceIcon, SvgBackward as BackwardIcon, SvgBagAndSuccess as BagAndSuccessIcon, SvgBag as BagIcon, SvgBathroomShowerTub as BathroomShowerTubIcon, SvgSleepingBed as BedIcon, SvgBike as BikeIcon, SvgBioFingerprint as BioFingerprintIcon, SvgBitcoin as BitcoinIcon, SvgBold as BoldIcon, SvgBottleIcon as BottleIcon, SvgBox as BoxIcon, SvgBriefcasePortfolio as BriefcasePortfolioIcon, BrowserStorage, SvgBuildingBusinessOffice as BuildingBusinessOfficeIcon, SvgBuildingGov as BuildingGovIcon, SvgBullets as BulletsIcon, SvgBulletsNumbered as BulletsNumberedIcon, SvgBullhorn as BullhornIcon, SvgBumble as BumbleIcon, SvgBush as BushIcon, Button, SvgCalandar as CalandarIcon, SvgCall as CallIcon, SvgCamera as CameraIcon, SvgCandle as CandleIcon, SvgCarFront as CarFrontIcon, SvgCarGarage as CarGarageIcon, SvgCardCollection as CardCollectionIcon, SvgCard as CardIcon, CardsIconByBrand, Carousel, SvgCart as CartIcon, SvgCashMoney as CashMoneyIcon, SvgCashapp as CashappIcon, SvgCast as CastIcon, SvgChartBar as ChartBarIcon, SvgChartPie as ChartPieIcon, SvgCheck as CheckIcon, Checkbox, CheckoutOrdersSidebar, CheckoutPDP, CheckoutPDPHTTPWrapper, CheckoutShoppingCart, CheckoutShoppingCartHTTPWrapper, CheckoutThankYou, Chip, SvgChip as ChipIcon, SvgChrome as ChromeIcon, SvgCircleActionsAlertInfo as CircleActionsAlertInfoIcon, SvgCircleActionsAlertQuestion as CircleActionsAlertQuestionIcon, SvgCircleActionsClose as CircleActionsCloseIcon, SvgCircleActionsPlaceholder as CircleActionsPlaceholderIcon, SvgCircleActionsSuccess as CircleActionsSuccessIcon, SvgCloseX as CloseXIcon, Collapse, SvgColorPalette as ColorPaletteIcon, SvgComment1 as Comment1Icon, SvgComment as CommentIcon, SvgCommentRound as CommentRoundIcon, SvgCommentWithLines as CommentWithLinesIcon, SvgCompass as CompassIcon, SvgComponent1 as Component1Icon, SvgComponent2 as Component2Icon, SvgComponent5 as Component5Icon, SvgComponent as ComponentIcon, SvgConfigure as ConfigureIcon, Cookie, SvgCopy as CopyIcon, SvgCursor as CursorIcon, SvgCursorPointer as CursorPointerIcon, SvgCut as CutIcon, SvgDatabase as DatabaseIcon, SvgDelete as DeleteIcon, SvgDeviceDesktop as DeviceDesktopIcon, SvgDeviceLaptop as DeviceLaptopIcon, SvgDeviceMouse as DeviceMouseIcon, SvgDevicePhone as DevicePhoneIcon, SvgDeviceTablet as DeviceTabletIcon, SvgDeviceWatch as DeviceWatchIcon, SvgDiamond as DiamondIcon, SvgDisabled as DisabledIcon, SvgDiscover as DiscoverIcon, Divider, SvgDollar as DollarIcon, SvgDoordash as DoordashIcon, SvgDownload as DownloadIcon, SvgDribbble as DribbbleIcon, SvgDryer as DryerIcon, SvgEdit as EditIcon, SvgEmojiHappySmile as EmojiHappySmileIcon, SvgEmojiSadFrown as EmojiSadFrownIcon, SvgExchangeTransfer as ExchangeTransferIcon, SvgExport as ExportIcon, SvgFacebook as FacebookIcon, SvgFastGage as FastGageIcon, SvgFeather as FeatherIcon, SvgFeedList as FeedListIcon, SvgFigma as FigmaIcon, SvgFile as FileIcon, SvgFileStructure as FileStructureIcon, SvgFilledAleritInfo as FilledAleritInfoIcon, SvgFilledAlertQuestion as FilledAlertQuestionIcon, SvgFilledBackspace as FilledBackspaceIcon, SvgFilledBag as FilledBagIcon, SvgFilledCart as FilledCartIcon, SvgFilledClose as FilledCloseIcon, SvgFilledEdit as FilledEditIcon, SvgFilledFolder as FilledFolderIcon, SvgFilledHeart as FilledHeartIcon, SvgFilledHome as FilledHomeIcon, SvgFilledLocation as FilledLocationIcon, SvgFilledProfile as FilledProfileIcon, SvgFilledSearch as FilledSearchIcon, SvgFilledSettings as FilledSettingsIcon, SvgFilledStar as FilledStarIcon, SvgFilledSuccess as FilledSuccessIcon, SvgFilledThumbsUp1 as FilledThumbsUp1Icon, SvgFilledThumbsUp as FilledThumbsUpIcon, SvgFilledTwoPeople as FilledTwoPeopleIcon, SvgFirefoxBrowser as FirefoxBrowserIcon, SvgFitbit as FitbitIcon, SvgFlagBannor as FlagBannorIcon, SvgFlowerIconRed as FlowerIconRed, SvgFolder as FolderIcon, SvgFontColor as FontColorIcon, SvgFontHeading as FontHeadingIcon, SvgFontUnderline as FontUnderlineIcon, SvgForwardArrow as ForwardArrowIcon, SvgForward as ForwardIcon, SvgForwardRedo as ForwardRedoIcon, FromToOpacity, SvgFullScreenExpandResize as FullScreenExpandResizeIcon, SvgFullScreenResizeExpand as FullScreenResizeExpandIcon, GRID_CONTAINER_WIDTHS, GRID_CUSTOM_POINTS, GRID_DEVICES_CUSTOM_MAX, GRID_DEVICES_CUSTOM_MIN, GRID_DEVICES_MAX, GRID_DEVICES_MIN, GRID_POINTS, SvgGamesIconRed as GamesIconRed, SvgGeoLocate as GeoLocateIcon, SvgGift as GiftIcon, SvgGiftLite as GiftLiteIcon, SvgGoingDownAlt as GoingDownAltIcon, SvgGoogle as GoogleIcon, SvgGoogleMaps as GoogleMapsIcon, SvgGooglePlaystore as GooglePlaystoreIcon, SvgGovermentLawBalance as GovermentLawBalanceIcon, SvgGridFeedCards as GridFeedCardsIcon, SvgGridMenu as GridMenuIcon, SvgGrubhub as GrubhubIcon, SvgGymWeight as GymWeightIcon, SvgHairDryer as HairDryerIcon, SvgHamburgerMenu as HamburgerMenuIcon, SvgHangers as HangersIcon, SvgHashtag as HashtagIcon, SvgHeart as HeartIcon, SvgHeat as HeatIcon, SvgHelp as HelpIcon, SvgHide as HideIcon, SvgHome as HomeIcon, SvgHomeRed as HomeIconRed, SvgHomeMinimal as HomeMinimalIcon, SvgHotel as HotelIcon, Icon, Image, SvgImage as ImageIcon, SvgInbox as InboxIcon, SvgIndentLess as IndentLessIcon, SvgIndentMore as IndentMoreIcon, SvgInfo as InfoIcon, Input, SvgInstagram as InstagramIcon, SvgItalic as ItalicIcon, SvgKey as KeyIcon, SvgKitchenFood as KitchenFoodIcon, KliButton, KliCard, KliCircleButton, KliCoupon, KliField, KliHero, KliHintersType, KliIcon, KliInfinityScrollGallery, KliNotification, KliNotificationsProvider, KliOutsideClick, KliPortalContent, KliStepper, KliStepperOrient, KliTextarea, KliThemeContext, KliThemeProvider, KliTimerMessage, KliToggle, LEFT_INDENTS, SvgLabBeaker as LabBeakerIcon, SvgLayout as LayoutIcon, LeftTimer, SvgLink as LinkIcon, SvgLinkedIn as LinkedInIcon, SvgLipsIcon as LipsIcon, SvgLoader as LoaderIcon, SvgLoading as LoadingIcon, LocalStorage, SvgLocation as LocationIcon, SvgLock as LockIcon, SvgLockUnlocked as LockUnlockedIcon, SvgLogInCircle as LogInCircleIcon, SvgLogInSquare as LogInSquareIcon, SvgLogOutCircle as LogOutCircleIcon, SvgLogOutSquare as LogOutSquareIcon, SvgLyft as LyftIcon, MARKETPLACE, SvgMail as MailIcon, SvgMap as MapIcon, SvgMasterComponent as MasterComponentIcon, SvgMastercard as MastercardIcon, SvgMedical as MedicalIcon, SvgMedium as MediumIcon, Menu, SvgMenuLeft as MenuLeftIcon, SvgMenuRight as MenuRightIcon, SvgMicrophone as MicrophoneIcon, Modal, ModalProvider, SvgMore as MoreIcon, SvgMoreVert as MoreVertIcon, SvgMoviesIconRed as MoviesIconRed, SvgMusicIconRed as MusicIconRed, SvgMusicNote as MusicNoteIcon, SvgNetflix as NetflixIcon, SvgNike as NikeIcon, SvgNotificationBell as NotificationBellIcon, SvgOfficeIcon as OfficeIconRed, SvgPalmTree as PalmTreeIcon, SvgPandafood as PandafoodIcon, Panel, SvgParking as ParkingIcon, SvgPaste as PasteIcon, SvgPause as PauseIcon, SvgPayPal as PayPalIcon, SvgPetCat as PetCatIcon, SvgPetDog as PetDogIcon, SvgPhoneIcon as PhoneIconRed, SvgPineTree as PineTreeIcon, SvgPinterest as PinterestIcon, SvgPlanetEarth as PlanetEarthIcon, SvgPlanet as PlanetIcon, SvgPlay as PlayIcon, SvgPlaylist as PlaylistIcon, SvgPlaystation as PlaystationIcon, SvgPodCast as PodCastIcon, SvgPoints as PointsIcon, SvgPool as PoolIcon, Popover, Portal, PortalBottomAnimation, PortalLeftAnimation, PortalPositions, PortalRightAnimation, PortalTopAnimation, SvgPowerOnOff as PowerOnOffIcon, SvgPrinter as PrinterIcon, SvgProfile as ProfileIcon, Promotion, SvgPuzzleIcon as PuzzleIcon, SvgQrCode as QRCodeIcon, SvgQuestion as QuestionIcon, SvgQuoteLeft as QuoteLeftIcon, SvgQuoteRight as QuoteRightIcon, RIGHT_INDENTS, Radio, RadioButton, RadioGroup, SvgReadBook as ReadBookIcon, SvgRefresh as RefreshIcon, SvgRoomServiceHelp as RoomServiceHelpIcon, SvgRoomUpgrade as RoomUpgradeIcon, STORE_PATTERNS, SvgSaveFavoriteBookmark as SaveFavoriteBookmarkIcon, SvgSaveFavoriteImportant as SaveFavoriteImportantIcon, SvgScroll as ScrollIcon, Search, SvgSearch as SearchIcon, Select, SelectableItem, SvgSend as SendIcon, SvgServer as ServerIcon, SessionStorage, SvgSettings as SettingsIcon, SvgShareBack1 as ShareBack1Icon, SvgShareBack as ShareBackIcon, SvgShare as ShareIcon, SvgShazam as ShazamIcon, SvgSheildwithCheck as SheildwithCheckIcon, SvgShopify as ShopifyIcon, SvgShreaded as ShreadedIcon, SvgSlack as SlackIcon, SlideFromBottom, SlideFromRight, Slider, SvgSnap as SnapIcon, SvgSoundMuted as SoundMutedIcon, SvgSoundPlaying as SoundPlayingIcon, SvgSpaceship as SpaceshipIcon, SvgSquare as SquareIcon, SvgStack as StackIcon, SvgStar as StarIcon, SvgStarbucks as StarbucksIcon, StripeCVCInput, StripeCardIcon, StripeCardInput, StripeExpDateInput, StripeInput, StripePaymentTokenContext, StripePaymentTokenFields, StripePaymentTokenFieldsPlaceholders, StripePaymentTokenInitialState, StripePaymentTokenProvider, StripeProvider, StyledUI, Switch, TOP_INDENTS, Tabs, SvgTag as TagIcon, SvgTarget as TargetIcon, Taxonomy, SvgTelegram as TelegramIcon, SvgTesla as TeslaIcon, SvgThreePeople as ThreePeopleIcon, SvgThumbsUp1 as ThumbsUp1Icon, SvgThumbsUp as ThumbsUpIcon, SvgTicket as TicketIcon, SvgTiktok as TiktokIcon, SvgTime as TimeIcon, TimeSelector, SvgTinder as TinderIcon, SvgToolsIconRed as ToolsIconRed, SvgTowels as TowelsIcon, SvgTrainRail as TrainRailIcon, SvgTrophy as TrophyIcon, SvgTrophyPersonal as TrophyPersonal, SvgTropicalDrinks as TropicalDrinksIcon, SvgTruck as TruckIcon, SvgTwitter as TwitterIcon, SvgTwoPeople as TwoPeopleIcon, SvgType as TypeIcon, Typography, SvgUsbThumbDrive as USBThumbDriveIcon, SvgUber as UberIcon, SvgUpload as UploadIcon, SvgVenmo as VenmoIcon, SvgVerifiedBadge as VerifiedBadgeIcon, SvgVideo1 as Video1Icon, SvgVideo as VideoIcon, SvgView as ViewIcon, SvgVisa as VisaIcon, SvgWasher as WasherIcon, SvgWeatherCloud as WeatherCloudIcon, SvgWeatherHurricane as WeatherHurricaneIcon, SvgWeatherLightning as WeatherLightningIcon, SvgWeatherMoon as WeatherMoonIcon, SvgWeatherPartlyCloudy as WeatherPartlyCloudyIcon, SvgWeatherRain as WeatherRainIcon, SvgWeatherSnow1 as WeatherSnow1Icon, SvgWeatherSnow as WeatherSnowIcon, SvgWeatherStars as WeatherStarsIcon, SvgWeatherSun as WeatherSunIcon, SvgWeatherTemperature as WeatherTemperatureIcon, SvgWeatherThunderstorms as WeatherThunderstormsIcon, SvgWeatherTornado as WeatherTornadoIcon, SvgWeatherUmbrella as WeatherUmbrellaIcon, SvgWeatherWaterDrop as WeatherWaterDropIcon, SvgWeatherWind as WeatherWindIcon, SvgWhatsapp as WhatsappIcon, SvgWifi as WifiIcon, SvgWorldGlobe as WorldGlobeIcon, SvgWorldNet as WorldNetIcon, SvgYouTube as YouTubeIcon, addRootElement, cartTokenHttpClient, createRootElement, defaultTheme, device, dynamicFontSize, formatPoints, getCoveredAmounts, getFilterParamsFromUrl, getPriceQueryParams, getPriceRange, getUrlParamsFromFilter, moveSlideshow, msToTime, notification, prepareImageUrl, roundToLocaleString$1 as roundToLocaleString, useForceUpdate, useInterval, useModal, usePortal, useScrollable, useSimpleInterface, useWindowResize };
//# sourceMappingURL=index.modern.js.map
